(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire130b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire130b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gKWsR", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c32e4b0ba829ddb2$export$ae55be85d98224ed; }, function (v) { return $c32e4b0ba829ddb2$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c32e4b0ba829ddb2$export$d39a5bbd09211389; }, function (v) { return $c32e4b0ba829ddb2$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c32e4b0ba829ddb2$export$882461b6382ed46c; }, function (v) { return $c32e4b0ba829ddb2$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c32e4b0ba829ddb2$export$466bfc07425424d5; }, function (v) { return $c32e4b0ba829ddb2$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c32e4b0ba829ddb2$export$cd75ccfd720a3cd4; }, function (v) { return $c32e4b0ba829ddb2$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c32e4b0ba829ddb2$export$fa8d919ba61d84db; }, function (v) { return $c32e4b0ba829ddb2$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c32e4b0ba829ddb2$export$757ceba2d55c277e; }, function (v) { return $c32e4b0ba829ddb2$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c32e4b0ba829ddb2$export$b3890eb0ae9dca99; }, function (v) { return $c32e4b0ba829ddb2$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c32e4b0ba829ddb2$export$502457920280e6be; }, function (v) { return $c32e4b0ba829ddb2$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c32e4b0ba829ddb2$export$c78a37762a8d58e1; }, function (v) { return $c32e4b0ba829ddb2$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c32e4b0ba829ddb2$export$dc54d992c10e8a18; }, function (v) { return $c32e4b0ba829ddb2$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c32e4b0ba829ddb2$export$83d89fbfd8236492; }, function (v) { return $c32e4b0ba829ddb2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $2bfPH = parcelRequire("2bfPH");
var $c32e4b0ba829ddb2$export$ae55be85d98224ed;
var $c32e4b0ba829ddb2$export$d39a5bbd09211389;
var $c32e4b0ba829ddb2$export$882461b6382ed46c;
var $c32e4b0ba829ddb2$export$466bfc07425424d5;
var $c32e4b0ba829ddb2$export$cd75ccfd720a3cd4;
var $c32e4b0ba829ddb2$export$fa8d919ba61d84db;
var $c32e4b0ba829ddb2$export$757ceba2d55c277e;
var $c32e4b0ba829ddb2$export$b3890eb0ae9dca99;
var $c32e4b0ba829ddb2$export$502457920280e6be;
var $c32e4b0ba829ddb2$export$c78a37762a8d58e1;
var $c32e4b0ba829ddb2$export$dc54d992c10e8a18;
var $c32e4b0ba829ddb2$export$83d89fbfd8236492;
"use strict";

var $eHaBZ = parcelRequire("eHaBZ");

var $5t8wa = parcelRequire("5t8wa");
function $c32e4b0ba829ddb2$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c32e4b0ba829ddb2$var$da = new Set, $c32e4b0ba829ddb2$var$ea = {};
function $c32e4b0ba829ddb2$var$fa(a, b) {
    $c32e4b0ba829ddb2$var$ha(a, b);
    $c32e4b0ba829ddb2$var$ha(a + "Capture", b);
}
function $c32e4b0ba829ddb2$var$ha(a, b) {
    $c32e4b0ba829ddb2$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c32e4b0ba829ddb2$var$da.add(b[a]);
}
var $c32e4b0ba829ddb2$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c32e4b0ba829ddb2$var$ja = Object.prototype.hasOwnProperty, $c32e4b0ba829ddb2$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c32e4b0ba829ddb2$var$la = {}, $c32e4b0ba829ddb2$var$ma = {};
function $c32e4b0ba829ddb2$var$oa(a) {
    if ($c32e4b0ba829ddb2$var$ja.call($c32e4b0ba829ddb2$var$ma, a)) return !0;
    if ($c32e4b0ba829ddb2$var$ja.call($c32e4b0ba829ddb2$var$la, a)) return !1;
    if ($c32e4b0ba829ddb2$var$ka.test(a)) return $c32e4b0ba829ddb2$var$ma[a] = !0;
    $c32e4b0ba829ddb2$var$la[a] = !0;
    return !1;
}
function $c32e4b0ba829ddb2$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $2bfPH._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c32e4b0ba829ddb2$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c32e4b0ba829ddb2$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c32e4b0ba829ddb2$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c32e4b0ba829ddb2$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c32e4b0ba829ddb2$var$z[b] = new $c32e4b0ba829ddb2$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c32e4b0ba829ddb2$var$ra = /[\-:]([a-z])/g;
function $c32e4b0ba829ddb2$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c32e4b0ba829ddb2$var$ra, $c32e4b0ba829ddb2$var$sa);
    $c32e4b0ba829ddb2$var$z[b] = new $c32e4b0ba829ddb2$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c32e4b0ba829ddb2$var$ra, $c32e4b0ba829ddb2$var$sa);
    $c32e4b0ba829ddb2$var$z[b] = new $c32e4b0ba829ddb2$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c32e4b0ba829ddb2$var$ra, $c32e4b0ba829ddb2$var$sa);
    $c32e4b0ba829ddb2$var$z[b] = new $c32e4b0ba829ddb2$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c32e4b0ba829ddb2$var$z.xlinkHref = new $c32e4b0ba829ddb2$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c32e4b0ba829ddb2$var$ta(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$z.hasOwnProperty(b) ? $c32e4b0ba829ddb2$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c32e4b0ba829ddb2$var$qa(b, c, e, d) && (c = null), d || null === e ? $c32e4b0ba829ddb2$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c32e4b0ba829ddb2$var$ua = $eHaBZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c32e4b0ba829ddb2$var$va = Symbol.for("react.element"), $c32e4b0ba829ddb2$var$wa = Symbol.for("react.portal"), $c32e4b0ba829ddb2$var$ya = Symbol.for("react.fragment"), $c32e4b0ba829ddb2$var$za = Symbol.for("react.strict_mode"), $c32e4b0ba829ddb2$var$Aa = Symbol.for("react.profiler"), $c32e4b0ba829ddb2$var$Ba = Symbol.for("react.provider"), $c32e4b0ba829ddb2$var$Ca = Symbol.for("react.context"), $c32e4b0ba829ddb2$var$Da = Symbol.for("react.forward_ref"), $c32e4b0ba829ddb2$var$Ea = Symbol.for("react.suspense"), $c32e4b0ba829ddb2$var$Fa = Symbol.for("react.suspense_list"), $c32e4b0ba829ddb2$var$Ga = Symbol.for("react.memo"), $c32e4b0ba829ddb2$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c32e4b0ba829ddb2$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c32e4b0ba829ddb2$var$Ja = Symbol.iterator;
function $c32e4b0ba829ddb2$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c32e4b0ba829ddb2$var$Ja && a[$c32e4b0ba829ddb2$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c32e4b0ba829ddb2$var$A = Object.assign, $c32e4b0ba829ddb2$var$La;
function $c32e4b0ba829ddb2$var$Ma(a) {
    if (void 0 === $c32e4b0ba829ddb2$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c32e4b0ba829ddb2$var$La = b && b[1] || "";
    }
    return "\n" + $c32e4b0ba829ddb2$var$La + a;
}
var $c32e4b0ba829ddb2$var$Na = !1;
function $c32e4b0ba829ddb2$var$Oa(a, b) {
    if (!a || $c32e4b0ba829ddb2$var$Na) return "";
    $c32e4b0ba829ddb2$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c32e4b0ba829ddb2$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c32e4b0ba829ddb2$var$Ma(a) : "";
}
function $c32e4b0ba829ddb2$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c32e4b0ba829ddb2$var$Ma(a.type);
        case 16:
            return $c32e4b0ba829ddb2$var$Ma("Lazy");
        case 13:
            return $c32e4b0ba829ddb2$var$Ma("Suspense");
        case 19:
            return $c32e4b0ba829ddb2$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c32e4b0ba829ddb2$var$Oa(a.type, !1), a;
        case 11:
            return a = $c32e4b0ba829ddb2$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c32e4b0ba829ddb2$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c32e4b0ba829ddb2$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c32e4b0ba829ddb2$var$ya:
            return "Fragment";
        case $c32e4b0ba829ddb2$var$wa:
            return "Portal";
        case $c32e4b0ba829ddb2$var$Aa:
            return "Profiler";
        case $c32e4b0ba829ddb2$var$za:
            return "StrictMode";
        case $c32e4b0ba829ddb2$var$Ea:
            return "Suspense";
        case $c32e4b0ba829ddb2$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c32e4b0ba829ddb2$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c32e4b0ba829ddb2$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c32e4b0ba829ddb2$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c32e4b0ba829ddb2$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c32e4b0ba829ddb2$var$Qa(a.type) || "Memo";
        case $c32e4b0ba829ddb2$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c32e4b0ba829ddb2$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c32e4b0ba829ddb2$var$Qa(b);
        case 8:
            return b === $c32e4b0ba829ddb2$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c32e4b0ba829ddb2$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c32e4b0ba829ddb2$var$Ua(a) {
    var b = $c32e4b0ba829ddb2$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c32e4b0ba829ddb2$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c32e4b0ba829ddb2$var$Ua(a));
}
function $c32e4b0ba829ddb2$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c32e4b0ba829ddb2$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c32e4b0ba829ddb2$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c32e4b0ba829ddb2$var$Ya(a, b) {
    var c = b.checked;
    return $c32e4b0ba829ddb2$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c32e4b0ba829ddb2$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c32e4b0ba829ddb2$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c32e4b0ba829ddb2$var$ab(a, b) {
    b = b.checked;
    null != b && $c32e4b0ba829ddb2$var$ta(a, "checked", b, !1);
}
function $c32e4b0ba829ddb2$var$bb(a, b) {
    $c32e4b0ba829ddb2$var$ab(a, b);
    var c = $c32e4b0ba829ddb2$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c32e4b0ba829ddb2$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c32e4b0ba829ddb2$var$cb(a, b.type, $c32e4b0ba829ddb2$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c32e4b0ba829ddb2$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c32e4b0ba829ddb2$var$cb(a, b, c) {
    if ("number" !== b || $c32e4b0ba829ddb2$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c32e4b0ba829ddb2$var$eb = Array.isArray;
function $c32e4b0ba829ddb2$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c32e4b0ba829ddb2$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c32e4b0ba829ddb2$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c32e4b0ba829ddb2$var$p(91));
    return $c32e4b0ba829ddb2$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c32e4b0ba829ddb2$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c32e4b0ba829ddb2$var$p(92));
            if ($c32e4b0ba829ddb2$var$eb(c)) {
                if (1 < c.length) throw Error($c32e4b0ba829ddb2$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c32e4b0ba829ddb2$var$Sa(c)
    };
}
function $c32e4b0ba829ddb2$var$ib(a, b) {
    var c = $c32e4b0ba829ddb2$var$Sa(b.value), d = $c32e4b0ba829ddb2$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c32e4b0ba829ddb2$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c32e4b0ba829ddb2$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c32e4b0ba829ddb2$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c32e4b0ba829ddb2$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c32e4b0ba829ddb2$var$mb, $c32e4b0ba829ddb2$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c32e4b0ba829ddb2$var$mb = $c32e4b0ba829ddb2$var$mb || document.createElement("div");
        $c32e4b0ba829ddb2$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c32e4b0ba829ddb2$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c32e4b0ba829ddb2$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c32e4b0ba829ddb2$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c32e4b0ba829ddb2$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c32e4b0ba829ddb2$var$pb).forEach(function(a) {
    $c32e4b0ba829ddb2$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c32e4b0ba829ddb2$var$pb[b] = $c32e4b0ba829ddb2$var$pb[a];
    });
});
function $c32e4b0ba829ddb2$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c32e4b0ba829ddb2$var$pb.hasOwnProperty(a) && $c32e4b0ba829ddb2$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c32e4b0ba829ddb2$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c32e4b0ba829ddb2$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c32e4b0ba829ddb2$var$tb = $c32e4b0ba829ddb2$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c32e4b0ba829ddb2$var$ub(a, b) {
    if (b) {
        if ($c32e4b0ba829ddb2$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c32e4b0ba829ddb2$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c32e4b0ba829ddb2$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c32e4b0ba829ddb2$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c32e4b0ba829ddb2$var$p(62));
    }
}
function $c32e4b0ba829ddb2$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c32e4b0ba829ddb2$var$wb = null;
function $c32e4b0ba829ddb2$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c32e4b0ba829ddb2$var$yb = null, $c32e4b0ba829ddb2$var$zb = null, $c32e4b0ba829ddb2$var$Ab = null;
function $c32e4b0ba829ddb2$var$Bb(a) {
    if (a = $c32e4b0ba829ddb2$var$Cb(a)) {
        if ("function" !== typeof $c32e4b0ba829ddb2$var$yb) throw Error($c32e4b0ba829ddb2$var$p(280));
        var b = a.stateNode;
        b && (b = $c32e4b0ba829ddb2$var$Db(b), $c32e4b0ba829ddb2$var$yb(a.stateNode, a.type, b));
    }
}
function $c32e4b0ba829ddb2$var$Eb(a) {
    $c32e4b0ba829ddb2$var$zb ? $c32e4b0ba829ddb2$var$Ab ? $c32e4b0ba829ddb2$var$Ab.push(a) : $c32e4b0ba829ddb2$var$Ab = [
        a
    ] : $c32e4b0ba829ddb2$var$zb = a;
}
function $c32e4b0ba829ddb2$var$Fb() {
    if ($c32e4b0ba829ddb2$var$zb) {
        var a = $c32e4b0ba829ddb2$var$zb, b = $c32e4b0ba829ddb2$var$Ab;
        $c32e4b0ba829ddb2$var$Ab = $c32e4b0ba829ddb2$var$zb = null;
        $c32e4b0ba829ddb2$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c32e4b0ba829ddb2$var$Bb(b[a]);
    }
}
function $c32e4b0ba829ddb2$var$Gb(a, b) {
    return a(b);
}
function $c32e4b0ba829ddb2$var$Hb() {}
var $c32e4b0ba829ddb2$var$Ib = !1;
function $c32e4b0ba829ddb2$var$Jb(a, b, c) {
    if ($c32e4b0ba829ddb2$var$Ib) return a(b, c);
    $c32e4b0ba829ddb2$var$Ib = !0;
    try {
        return $c32e4b0ba829ddb2$var$Gb(a, b, c);
    } finally{
        if ($c32e4b0ba829ddb2$var$Ib = !1, null !== $c32e4b0ba829ddb2$var$zb || null !== $c32e4b0ba829ddb2$var$Ab) $c32e4b0ba829ddb2$var$Hb(), $c32e4b0ba829ddb2$var$Fb();
    }
}
function $c32e4b0ba829ddb2$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c32e4b0ba829ddb2$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c32e4b0ba829ddb2$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $2bfPH._)(c)));
    return c;
}
var $c32e4b0ba829ddb2$var$Lb = !1;
if ($c32e4b0ba829ddb2$var$ia) try {
    var $c32e4b0ba829ddb2$var$Mb = {};
    Object.defineProperty($c32e4b0ba829ddb2$var$Mb, "passive", {
        get: function get() {
            $c32e4b0ba829ddb2$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c32e4b0ba829ddb2$var$Mb, $c32e4b0ba829ddb2$var$Mb);
    window.removeEventListener("test", $c32e4b0ba829ddb2$var$Mb, $c32e4b0ba829ddb2$var$Mb);
} catch (a) {
    $c32e4b0ba829ddb2$var$Lb = !1;
}
function $c32e4b0ba829ddb2$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c32e4b0ba829ddb2$var$Ob = !1, $c32e4b0ba829ddb2$var$Pb = null, $c32e4b0ba829ddb2$var$Qb = !1, $c32e4b0ba829ddb2$var$Rb = null, $c32e4b0ba829ddb2$var$Sb = {
    onError: function onError(a) {
        $c32e4b0ba829ddb2$var$Ob = !0;
        $c32e4b0ba829ddb2$var$Pb = a;
    }
};
function $c32e4b0ba829ddb2$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c32e4b0ba829ddb2$var$Ob = !1;
    $c32e4b0ba829ddb2$var$Pb = null;
    $c32e4b0ba829ddb2$var$Nb.apply($c32e4b0ba829ddb2$var$Sb, arguments);
}
function $c32e4b0ba829ddb2$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c32e4b0ba829ddb2$var$Tb.apply(this, arguments);
    if ($c32e4b0ba829ddb2$var$Ob) {
        if ($c32e4b0ba829ddb2$var$Ob) {
            var l = $c32e4b0ba829ddb2$var$Pb;
            $c32e4b0ba829ddb2$var$Ob = !1;
            $c32e4b0ba829ddb2$var$Pb = null;
        } else throw Error($c32e4b0ba829ddb2$var$p(198));
        $c32e4b0ba829ddb2$var$Qb || ($c32e4b0ba829ddb2$var$Qb = !0, $c32e4b0ba829ddb2$var$Rb = l);
    }
}
function $c32e4b0ba829ddb2$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c32e4b0ba829ddb2$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Xb(a) {
    if ($c32e4b0ba829ddb2$var$Vb(a) !== a) throw Error($c32e4b0ba829ddb2$var$p(188));
}
function $c32e4b0ba829ddb2$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c32e4b0ba829ddb2$var$Vb(a);
        if (null === b) throw Error($c32e4b0ba829ddb2$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c32e4b0ba829ddb2$var$Xb(e), a;
                if (f === d) return $c32e4b0ba829ddb2$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c32e4b0ba829ddb2$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c32e4b0ba829ddb2$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c32e4b0ba829ddb2$var$p(190));
    }
    if (3 !== c.tag) throw Error($c32e4b0ba829ddb2$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c32e4b0ba829ddb2$var$Zb(a) {
    a = $c32e4b0ba829ddb2$var$Yb(a);
    return null !== a ? $c32e4b0ba829ddb2$var$$b(a) : null;
}
function $c32e4b0ba829ddb2$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c32e4b0ba829ddb2$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c32e4b0ba829ddb2$var$ac = $5t8wa.unstable_scheduleCallback, $c32e4b0ba829ddb2$var$bc = $5t8wa.unstable_cancelCallback, $c32e4b0ba829ddb2$var$cc = $5t8wa.unstable_shouldYield, $c32e4b0ba829ddb2$var$dc = $5t8wa.unstable_requestPaint, $c32e4b0ba829ddb2$var$B = $5t8wa.unstable_now, $c32e4b0ba829ddb2$var$ec = $5t8wa.unstable_getCurrentPriorityLevel, $c32e4b0ba829ddb2$var$fc = $5t8wa.unstable_ImmediatePriority, $c32e4b0ba829ddb2$var$gc = $5t8wa.unstable_UserBlockingPriority, $c32e4b0ba829ddb2$var$hc = $5t8wa.unstable_NormalPriority, $c32e4b0ba829ddb2$var$ic = $5t8wa.unstable_LowPriority, $c32e4b0ba829ddb2$var$jc = $5t8wa.unstable_IdlePriority, $c32e4b0ba829ddb2$var$kc = null, $c32e4b0ba829ddb2$var$lc = null;
function $c32e4b0ba829ddb2$var$mc(a) {
    if ($c32e4b0ba829ddb2$var$lc && "function" === typeof $c32e4b0ba829ddb2$var$lc.onCommitFiberRoot) try {
        $c32e4b0ba829ddb2$var$lc.onCommitFiberRoot($c32e4b0ba829ddb2$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c32e4b0ba829ddb2$var$oc = Math.clz32 ? Math.clz32 : $c32e4b0ba829ddb2$var$nc, $c32e4b0ba829ddb2$var$pc = Math.log, $c32e4b0ba829ddb2$var$qc = Math.LN2;
function $c32e4b0ba829ddb2$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c32e4b0ba829ddb2$var$pc(a) / $c32e4b0ba829ddb2$var$qc | 0) | 0;
}
var $c32e4b0ba829ddb2$var$rc = 64, $c32e4b0ba829ddb2$var$sc = 4194304;
function $c32e4b0ba829ddb2$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c32e4b0ba829ddb2$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c32e4b0ba829ddb2$var$tc(h) : (f &= g, 0 !== f && (d = $c32e4b0ba829ddb2$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c32e4b0ba829ddb2$var$tc(g) : 0 !== f && (d = $c32e4b0ba829ddb2$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c32e4b0ba829ddb2$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c32e4b0ba829ddb2$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c32e4b0ba829ddb2$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c32e4b0ba829ddb2$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c32e4b0ba829ddb2$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c32e4b0ba829ddb2$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c32e4b0ba829ddb2$var$yc() {
    var a = $c32e4b0ba829ddb2$var$rc;
    $c32e4b0ba829ddb2$var$rc <<= 1;
    0 === ($c32e4b0ba829ddb2$var$rc & 4194240) && ($c32e4b0ba829ddb2$var$rc = 64);
    return a;
}
function $c32e4b0ba829ddb2$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c32e4b0ba829ddb2$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c32e4b0ba829ddb2$var$oc(b);
    a[b] = c;
}
function $c32e4b0ba829ddb2$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c32e4b0ba829ddb2$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c32e4b0ba829ddb2$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c32e4b0ba829ddb2$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c32e4b0ba829ddb2$var$C = 0;
function $c32e4b0ba829ddb2$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c32e4b0ba829ddb2$var$Ec, $c32e4b0ba829ddb2$var$Fc, $c32e4b0ba829ddb2$var$Gc, $c32e4b0ba829ddb2$var$Hc, $c32e4b0ba829ddb2$var$Ic, $c32e4b0ba829ddb2$var$Jc = !1, $c32e4b0ba829ddb2$var$Kc = [], $c32e4b0ba829ddb2$var$Lc = null, $c32e4b0ba829ddb2$var$Mc = null, $c32e4b0ba829ddb2$var$Nc = null, $c32e4b0ba829ddb2$var$Oc = new Map, $c32e4b0ba829ddb2$var$Pc = new Map, $c32e4b0ba829ddb2$var$Qc = [], $c32e4b0ba829ddb2$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c32e4b0ba829ddb2$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c32e4b0ba829ddb2$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c32e4b0ba829ddb2$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c32e4b0ba829ddb2$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c32e4b0ba829ddb2$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c32e4b0ba829ddb2$var$Pc.delete(b.pointerId);
    }
}
function $c32e4b0ba829ddb2$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c32e4b0ba829ddb2$var$Cb(b), null !== b && $c32e4b0ba829ddb2$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c32e4b0ba829ddb2$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c32e4b0ba829ddb2$var$Lc = $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c32e4b0ba829ddb2$var$Mc = $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c32e4b0ba829ddb2$var$Nc = $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c32e4b0ba829ddb2$var$Oc.set(f, $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c32e4b0ba829ddb2$var$Pc.set(f, $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c32e4b0ba829ddb2$var$Vc(a) {
    var b = $c32e4b0ba829ddb2$var$Wc(a.target);
    if (null !== b) {
        var c = $c32e4b0ba829ddb2$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c32e4b0ba829ddb2$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c32e4b0ba829ddb2$var$Ic(a.priority, function() {
                        $c32e4b0ba829ddb2$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c32e4b0ba829ddb2$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c32e4b0ba829ddb2$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c32e4b0ba829ddb2$var$wb = d;
            c.target.dispatchEvent(d);
            $c32e4b0ba829ddb2$var$wb = null;
        } else return b = $c32e4b0ba829ddb2$var$Cb(c), null !== b && $c32e4b0ba829ddb2$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c32e4b0ba829ddb2$var$Zc(a, b, c) {
    $c32e4b0ba829ddb2$var$Xc(a) && c.delete(b);
}
function $c32e4b0ba829ddb2$var$$c() {
    $c32e4b0ba829ddb2$var$Jc = !1;
    null !== $c32e4b0ba829ddb2$var$Lc && $c32e4b0ba829ddb2$var$Xc($c32e4b0ba829ddb2$var$Lc) && ($c32e4b0ba829ddb2$var$Lc = null);
    null !== $c32e4b0ba829ddb2$var$Mc && $c32e4b0ba829ddb2$var$Xc($c32e4b0ba829ddb2$var$Mc) && ($c32e4b0ba829ddb2$var$Mc = null);
    null !== $c32e4b0ba829ddb2$var$Nc && $c32e4b0ba829ddb2$var$Xc($c32e4b0ba829ddb2$var$Nc) && ($c32e4b0ba829ddb2$var$Nc = null);
    $c32e4b0ba829ddb2$var$Oc.forEach($c32e4b0ba829ddb2$var$Zc);
    $c32e4b0ba829ddb2$var$Pc.forEach($c32e4b0ba829ddb2$var$Zc);
}
function $c32e4b0ba829ddb2$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c32e4b0ba829ddb2$var$Jc || ($c32e4b0ba829ddb2$var$Jc = !0, $5t8wa.unstable_scheduleCallback($5t8wa.unstable_NormalPriority, $c32e4b0ba829ddb2$var$$c)));
}
function $c32e4b0ba829ddb2$var$bd(a) {
    function b(b) {
        return $c32e4b0ba829ddb2$var$ad(b, a);
    }
    if (0 < $c32e4b0ba829ddb2$var$Kc.length) {
        $c32e4b0ba829ddb2$var$ad($c32e4b0ba829ddb2$var$Kc[0], a);
        for(var c = 1; c < $c32e4b0ba829ddb2$var$Kc.length; c++){
            var d = $c32e4b0ba829ddb2$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c32e4b0ba829ddb2$var$Lc && $c32e4b0ba829ddb2$var$ad($c32e4b0ba829ddb2$var$Lc, a);
    null !== $c32e4b0ba829ddb2$var$Mc && $c32e4b0ba829ddb2$var$ad($c32e4b0ba829ddb2$var$Mc, a);
    null !== $c32e4b0ba829ddb2$var$Nc && $c32e4b0ba829ddb2$var$ad($c32e4b0ba829ddb2$var$Nc, a);
    $c32e4b0ba829ddb2$var$Oc.forEach(b);
    $c32e4b0ba829ddb2$var$Pc.forEach(b);
    for(c = 0; c < $c32e4b0ba829ddb2$var$Qc.length; c++)d = $c32e4b0ba829ddb2$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c32e4b0ba829ddb2$var$Qc.length && (c = $c32e4b0ba829ddb2$var$Qc[0], null === c.blockedOn);)$c32e4b0ba829ddb2$var$Vc(c), null === c.blockedOn && $c32e4b0ba829ddb2$var$Qc.shift();
}
var $c32e4b0ba829ddb2$var$cd = $c32e4b0ba829ddb2$var$ua.ReactCurrentBatchConfig, $c32e4b0ba829ddb2$var$dd = !0;
function $c32e4b0ba829ddb2$var$ed(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$C, f = $c32e4b0ba829ddb2$var$cd.transition;
    $c32e4b0ba829ddb2$var$cd.transition = null;
    try {
        $c32e4b0ba829ddb2$var$C = 1, $c32e4b0ba829ddb2$var$fd(a, b, c, d);
    } finally{
        $c32e4b0ba829ddb2$var$C = e, $c32e4b0ba829ddb2$var$cd.transition = f;
    }
}
function $c32e4b0ba829ddb2$var$gd(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$C, f = $c32e4b0ba829ddb2$var$cd.transition;
    $c32e4b0ba829ddb2$var$cd.transition = null;
    try {
        $c32e4b0ba829ddb2$var$C = 4, $c32e4b0ba829ddb2$var$fd(a, b, c, d);
    } finally{
        $c32e4b0ba829ddb2$var$C = e, $c32e4b0ba829ddb2$var$cd.transition = f;
    }
}
function $c32e4b0ba829ddb2$var$fd(a, b, c, d) {
    if ($c32e4b0ba829ddb2$var$dd) {
        var e = $c32e4b0ba829ddb2$var$Yc(a, b, c, d);
        if (null === e) $c32e4b0ba829ddb2$var$hd(a, b, d, $c32e4b0ba829ddb2$var$id, c), $c32e4b0ba829ddb2$var$Sc(a, d);
        else if ($c32e4b0ba829ddb2$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c32e4b0ba829ddb2$var$Sc(a, d), b & 4 && -1 < $c32e4b0ba829ddb2$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c32e4b0ba829ddb2$var$Cb(e);
                null !== f && $c32e4b0ba829ddb2$var$Ec(f);
                f = $c32e4b0ba829ddb2$var$Yc(a, b, c, d);
                null === f && $c32e4b0ba829ddb2$var$hd(a, b, d, $c32e4b0ba829ddb2$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c32e4b0ba829ddb2$var$hd(a, b, d, null, c);
    }
}
var $c32e4b0ba829ddb2$var$id = null;
function $c32e4b0ba829ddb2$var$Yc(a, b, c, d) {
    $c32e4b0ba829ddb2$var$id = null;
    a = $c32e4b0ba829ddb2$var$xb(d);
    a = $c32e4b0ba829ddb2$var$Wc(a);
    if (null !== a) {
        if (b = $c32e4b0ba829ddb2$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c32e4b0ba829ddb2$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c32e4b0ba829ddb2$var$id = a;
    return null;
}
function $c32e4b0ba829ddb2$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c32e4b0ba829ddb2$var$ec()){
                case $c32e4b0ba829ddb2$var$fc:
                    return 1;
                case $c32e4b0ba829ddb2$var$gc:
                    return 4;
                case $c32e4b0ba829ddb2$var$hc:
                case $c32e4b0ba829ddb2$var$ic:
                    return 16;
                case $c32e4b0ba829ddb2$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c32e4b0ba829ddb2$var$kd = null, $c32e4b0ba829ddb2$var$ld = null, $c32e4b0ba829ddb2$var$md = null;
function $c32e4b0ba829ddb2$var$nd() {
    if ($c32e4b0ba829ddb2$var$md) return $c32e4b0ba829ddb2$var$md;
    var a, b = $c32e4b0ba829ddb2$var$ld, c = b.length, d, e = "value" in $c32e4b0ba829ddb2$var$kd ? $c32e4b0ba829ddb2$var$kd.value : $c32e4b0ba829ddb2$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c32e4b0ba829ddb2$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c32e4b0ba829ddb2$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c32e4b0ba829ddb2$var$pd() {
    return !0;
}
function $c32e4b0ba829ddb2$var$qd() {
    return !1;
}
function $c32e4b0ba829ddb2$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c32e4b0ba829ddb2$var$pd : $c32e4b0ba829ddb2$var$qd;
        this.isPropagationStopped = $c32e4b0ba829ddb2$var$qd;
        return this;
    }
    $c32e4b0ba829ddb2$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $2bfPH._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $c32e4b0ba829ddb2$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $2bfPH._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $c32e4b0ba829ddb2$var$pd);
        },
        persist: function persist() {},
        isPersistent: $c32e4b0ba829ddb2$var$pd
    });
    return b;
}
var $c32e4b0ba829ddb2$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c32e4b0ba829ddb2$var$td = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$sd), $c32e4b0ba829ddb2$var$ud = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    view: 0,
    detail: 0
}), $c32e4b0ba829ddb2$var$vd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$ud), $c32e4b0ba829ddb2$var$wd, $c32e4b0ba829ddb2$var$xd, $c32e4b0ba829ddb2$var$yd, $c32e4b0ba829ddb2$var$Ad = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c32e4b0ba829ddb2$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c32e4b0ba829ddb2$var$yd && ($c32e4b0ba829ddb2$var$yd && "mousemove" === a.type ? ($c32e4b0ba829ddb2$var$wd = a.screenX - $c32e4b0ba829ddb2$var$yd.screenX, $c32e4b0ba829ddb2$var$xd = a.screenY - $c32e4b0ba829ddb2$var$yd.screenY) : $c32e4b0ba829ddb2$var$xd = $c32e4b0ba829ddb2$var$wd = 0, $c32e4b0ba829ddb2$var$yd = a);
        return $c32e4b0ba829ddb2$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $c32e4b0ba829ddb2$var$xd;
    }
}), $c32e4b0ba829ddb2$var$Bd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Ad), $c32e4b0ba829ddb2$var$Cd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$Ad, {
    dataTransfer: 0
}), $c32e4b0ba829ddb2$var$Dd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Cd), $c32e4b0ba829ddb2$var$Ed = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$ud, {
    relatedTarget: 0
}), $c32e4b0ba829ddb2$var$Fd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Ed), $c32e4b0ba829ddb2$var$Gd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c32e4b0ba829ddb2$var$Hd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Gd), $c32e4b0ba829ddb2$var$Id = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c32e4b0ba829ddb2$var$Jd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Id), $c32e4b0ba829ddb2$var$Kd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    data: 0
}), $c32e4b0ba829ddb2$var$Ld = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Kd), $c32e4b0ba829ddb2$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c32e4b0ba829ddb2$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c32e4b0ba829ddb2$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c32e4b0ba829ddb2$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c32e4b0ba829ddb2$var$Od[a]) ? !!b[a] : !1;
}
function $c32e4b0ba829ddb2$var$zd() {
    return $c32e4b0ba829ddb2$var$Pd;
}
var $c32e4b0ba829ddb2$var$Qd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $c32e4b0ba829ddb2$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c32e4b0ba829ddb2$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c32e4b0ba829ddb2$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c32e4b0ba829ddb2$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $c32e4b0ba829ddb2$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $c32e4b0ba829ddb2$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c32e4b0ba829ddb2$var$Rd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Qd), $c32e4b0ba829ddb2$var$Sd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c32e4b0ba829ddb2$var$Td = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Sd), $c32e4b0ba829ddb2$var$Ud = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c32e4b0ba829ddb2$var$zd
}), $c32e4b0ba829ddb2$var$Vd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Ud), $c32e4b0ba829ddb2$var$Wd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c32e4b0ba829ddb2$var$Xd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Wd), $c32e4b0ba829ddb2$var$Yd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c32e4b0ba829ddb2$var$Zd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Yd), $c32e4b0ba829ddb2$var$$d = [
    9,
    13,
    27,
    32
], $c32e4b0ba829ddb2$var$ae = $c32e4b0ba829ddb2$var$ia && "CompositionEvent" in window, $c32e4b0ba829ddb2$var$be = null;
$c32e4b0ba829ddb2$var$ia && "documentMode" in document && ($c32e4b0ba829ddb2$var$be = document.documentMode);
var $c32e4b0ba829ddb2$var$ce = $c32e4b0ba829ddb2$var$ia && "TextEvent" in window && !$c32e4b0ba829ddb2$var$be, $c32e4b0ba829ddb2$var$de = $c32e4b0ba829ddb2$var$ia && (!$c32e4b0ba829ddb2$var$ae || $c32e4b0ba829ddb2$var$be && 8 < $c32e4b0ba829ddb2$var$be && 11 >= $c32e4b0ba829ddb2$var$be), $c32e4b0ba829ddb2$var$ee = String.fromCharCode(32), $c32e4b0ba829ddb2$var$fe = !1;
function $c32e4b0ba829ddb2$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c32e4b0ba829ddb2$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c32e4b0ba829ddb2$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c32e4b0ba829ddb2$var$ie = !1;
function $c32e4b0ba829ddb2$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c32e4b0ba829ddb2$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c32e4b0ba829ddb2$var$fe = !0;
            return $c32e4b0ba829ddb2$var$ee;
        case "textInput":
            return a = b.data, a === $c32e4b0ba829ddb2$var$ee && $c32e4b0ba829ddb2$var$fe ? null : a;
        default:
            return null;
    }
}
function $c32e4b0ba829ddb2$var$ke(a, b) {
    if ($c32e4b0ba829ddb2$var$ie) return "compositionend" === a || !$c32e4b0ba829ddb2$var$ae && $c32e4b0ba829ddb2$var$ge(a, b) ? (a = $c32e4b0ba829ddb2$var$nd(), $c32e4b0ba829ddb2$var$md = $c32e4b0ba829ddb2$var$ld = $c32e4b0ba829ddb2$var$kd = null, $c32e4b0ba829ddb2$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c32e4b0ba829ddb2$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c32e4b0ba829ddb2$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c32e4b0ba829ddb2$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c32e4b0ba829ddb2$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c32e4b0ba829ddb2$var$ne(a, b, c, d) {
    $c32e4b0ba829ddb2$var$Eb(d);
    b = $c32e4b0ba829ddb2$var$oe(b, "onChange");
    0 < b.length && (c = new $c32e4b0ba829ddb2$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c32e4b0ba829ddb2$var$pe = null, $c32e4b0ba829ddb2$var$qe = null;
function $c32e4b0ba829ddb2$var$re(a) {
    $c32e4b0ba829ddb2$var$se(a, 0);
}
function $c32e4b0ba829ddb2$var$te(a) {
    var b = $c32e4b0ba829ddb2$var$ue(a);
    if ($c32e4b0ba829ddb2$var$Wa(b)) return a;
}
function $c32e4b0ba829ddb2$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c32e4b0ba829ddb2$var$we = !1;
if ($c32e4b0ba829ddb2$var$ia) {
    var $c32e4b0ba829ddb2$var$xe;
    if ($c32e4b0ba829ddb2$var$ia) {
        var $c32e4b0ba829ddb2$var$ye = "oninput" in document;
        if (!$c32e4b0ba829ddb2$var$ye) {
            var $c32e4b0ba829ddb2$var$ze = document.createElement("div");
            $c32e4b0ba829ddb2$var$ze.setAttribute("oninput", "return;");
            $c32e4b0ba829ddb2$var$ye = "function" === typeof $c32e4b0ba829ddb2$var$ze.oninput;
        }
        $c32e4b0ba829ddb2$var$xe = $c32e4b0ba829ddb2$var$ye;
    } else $c32e4b0ba829ddb2$var$xe = !1;
    $c32e4b0ba829ddb2$var$we = $c32e4b0ba829ddb2$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c32e4b0ba829ddb2$var$Ae() {
    $c32e4b0ba829ddb2$var$pe && ($c32e4b0ba829ddb2$var$pe.detachEvent("onpropertychange", $c32e4b0ba829ddb2$var$Be), $c32e4b0ba829ddb2$var$qe = $c32e4b0ba829ddb2$var$pe = null);
}
function $c32e4b0ba829ddb2$var$Be(a) {
    if ("value" === a.propertyName && $c32e4b0ba829ddb2$var$te($c32e4b0ba829ddb2$var$qe)) {
        var b = [];
        $c32e4b0ba829ddb2$var$ne(b, $c32e4b0ba829ddb2$var$qe, a, $c32e4b0ba829ddb2$var$xb(a));
        $c32e4b0ba829ddb2$var$Jb($c32e4b0ba829ddb2$var$re, b);
    }
}
function $c32e4b0ba829ddb2$var$Ce(a, b, c) {
    "focusin" === a ? ($c32e4b0ba829ddb2$var$Ae(), $c32e4b0ba829ddb2$var$pe = b, $c32e4b0ba829ddb2$var$qe = c, $c32e4b0ba829ddb2$var$pe.attachEvent("onpropertychange", $c32e4b0ba829ddb2$var$Be)) : "focusout" === a && $c32e4b0ba829ddb2$var$Ae();
}
function $c32e4b0ba829ddb2$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c32e4b0ba829ddb2$var$te($c32e4b0ba829ddb2$var$qe);
}
function $c32e4b0ba829ddb2$var$Ee(a, b) {
    if ("click" === a) return $c32e4b0ba829ddb2$var$te(b);
}
function $c32e4b0ba829ddb2$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c32e4b0ba829ddb2$var$te(b);
}
function $c32e4b0ba829ddb2$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c32e4b0ba829ddb2$var$He = "function" === typeof Object.is ? Object.is : $c32e4b0ba829ddb2$var$Ge;
function $c32e4b0ba829ddb2$var$Ie(a, b) {
    if ($c32e4b0ba829ddb2$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c32e4b0ba829ddb2$var$ja.call(b, e) || !$c32e4b0ba829ddb2$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c32e4b0ba829ddb2$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c32e4b0ba829ddb2$var$Ke(a, b) {
    var c = $c32e4b0ba829ddb2$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c32e4b0ba829ddb2$var$Je(c);
    }
}
function $c32e4b0ba829ddb2$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c32e4b0ba829ddb2$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c32e4b0ba829ddb2$var$Me() {
    for(var a = window, b = $c32e4b0ba829ddb2$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c32e4b0ba829ddb2$var$Xa(a.document);
    }
    return b;
}
function $c32e4b0ba829ddb2$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c32e4b0ba829ddb2$var$Oe(a) {
    var b = $c32e4b0ba829ddb2$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c32e4b0ba829ddb2$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c32e4b0ba829ddb2$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c32e4b0ba829ddb2$var$Ke(c, f);
                var g = $c32e4b0ba829ddb2$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c32e4b0ba829ddb2$var$Pe = $c32e4b0ba829ddb2$var$ia && "documentMode" in document && 11 >= document.documentMode, $c32e4b0ba829ddb2$var$Qe = null, $c32e4b0ba829ddb2$var$Re = null, $c32e4b0ba829ddb2$var$Se = null, $c32e4b0ba829ddb2$var$Te = !1;
function $c32e4b0ba829ddb2$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c32e4b0ba829ddb2$var$Te || null == $c32e4b0ba829ddb2$var$Qe || $c32e4b0ba829ddb2$var$Qe !== $c32e4b0ba829ddb2$var$Xa(d) || (d = $c32e4b0ba829ddb2$var$Qe, "selectionStart" in d && $c32e4b0ba829ddb2$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c32e4b0ba829ddb2$var$Se && $c32e4b0ba829ddb2$var$Ie($c32e4b0ba829ddb2$var$Se, d) || ($c32e4b0ba829ddb2$var$Se = d, d = $c32e4b0ba829ddb2$var$oe($c32e4b0ba829ddb2$var$Re, "onSelect"), 0 < d.length && (b = new $c32e4b0ba829ddb2$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c32e4b0ba829ddb2$var$Qe)));
}
function $c32e4b0ba829ddb2$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c32e4b0ba829ddb2$var$We = {
    animationend: $c32e4b0ba829ddb2$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c32e4b0ba829ddb2$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c32e4b0ba829ddb2$var$Ve("Animation", "AnimationStart"),
    transitionend: $c32e4b0ba829ddb2$var$Ve("Transition", "TransitionEnd")
}, $c32e4b0ba829ddb2$var$Xe = {}, $c32e4b0ba829ddb2$var$Ye = {};
$c32e4b0ba829ddb2$var$ia && ($c32e4b0ba829ddb2$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c32e4b0ba829ddb2$var$We.animationend.animation, delete $c32e4b0ba829ddb2$var$We.animationiteration.animation, delete $c32e4b0ba829ddb2$var$We.animationstart.animation), "TransitionEvent" in window || delete $c32e4b0ba829ddb2$var$We.transitionend.transition);
function $c32e4b0ba829ddb2$var$Ze(a) {
    if ($c32e4b0ba829ddb2$var$Xe[a]) return $c32e4b0ba829ddb2$var$Xe[a];
    if (!$c32e4b0ba829ddb2$var$We[a]) return a;
    var b = $c32e4b0ba829ddb2$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c32e4b0ba829ddb2$var$Ye) return $c32e4b0ba829ddb2$var$Xe[a] = b[c];
    return a;
}
var $c32e4b0ba829ddb2$var$$e = $c32e4b0ba829ddb2$var$Ze("animationend"), $c32e4b0ba829ddb2$var$af = $c32e4b0ba829ddb2$var$Ze("animationiteration"), $c32e4b0ba829ddb2$var$bf = $c32e4b0ba829ddb2$var$Ze("animationstart"), $c32e4b0ba829ddb2$var$cf = $c32e4b0ba829ddb2$var$Ze("transitionend"), $c32e4b0ba829ddb2$var$df = new Map, $c32e4b0ba829ddb2$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c32e4b0ba829ddb2$var$ff(a, b) {
    $c32e4b0ba829ddb2$var$df.set(a, b);
    $c32e4b0ba829ddb2$var$fa(b, [
        a
    ]);
}
for(var $c32e4b0ba829ddb2$var$gf = 0; $c32e4b0ba829ddb2$var$gf < $c32e4b0ba829ddb2$var$ef.length; $c32e4b0ba829ddb2$var$gf++){
    var $c32e4b0ba829ddb2$var$hf = $c32e4b0ba829ddb2$var$ef[$c32e4b0ba829ddb2$var$gf], $c32e4b0ba829ddb2$var$jf = $c32e4b0ba829ddb2$var$hf.toLowerCase(), $c32e4b0ba829ddb2$var$kf = $c32e4b0ba829ddb2$var$hf[0].toUpperCase() + $c32e4b0ba829ddb2$var$hf.slice(1);
    $c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$jf, "on" + $c32e4b0ba829ddb2$var$kf);
}
$c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$$e, "onAnimationEnd");
$c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$af, "onAnimationIteration");
$c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$bf, "onAnimationStart");
$c32e4b0ba829ddb2$var$ff("dblclick", "onDoubleClick");
$c32e4b0ba829ddb2$var$ff("focusin", "onFocus");
$c32e4b0ba829ddb2$var$ff("focusout", "onBlur");
$c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$cf, "onTransitionEnd");
$c32e4b0ba829ddb2$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c32e4b0ba829ddb2$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c32e4b0ba829ddb2$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c32e4b0ba829ddb2$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c32e4b0ba829ddb2$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c32e4b0ba829ddb2$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c32e4b0ba829ddb2$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c32e4b0ba829ddb2$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c32e4b0ba829ddb2$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c32e4b0ba829ddb2$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c32e4b0ba829ddb2$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c32e4b0ba829ddb2$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c32e4b0ba829ddb2$var$lf));
function $c32e4b0ba829ddb2$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c32e4b0ba829ddb2$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c32e4b0ba829ddb2$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c32e4b0ba829ddb2$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c32e4b0ba829ddb2$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c32e4b0ba829ddb2$var$Qb) throw a = $c32e4b0ba829ddb2$var$Rb, $c32e4b0ba829ddb2$var$Qb = !1, $c32e4b0ba829ddb2$var$Rb = null, a;
}
function $c32e4b0ba829ddb2$var$D(a, b) {
    var c = b[$c32e4b0ba829ddb2$var$of];
    void 0 === c && (c = b[$c32e4b0ba829ddb2$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c32e4b0ba829ddb2$var$pf(b, a, 2, !1), c.add(d));
}
function $c32e4b0ba829ddb2$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c32e4b0ba829ddb2$var$pf(c, a, d, b);
}
var $c32e4b0ba829ddb2$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c32e4b0ba829ddb2$var$sf(a) {
    if (!a[$c32e4b0ba829ddb2$var$rf]) {
        a[$c32e4b0ba829ddb2$var$rf] = !0;
        $c32e4b0ba829ddb2$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c32e4b0ba829ddb2$var$mf.has(b) || $c32e4b0ba829ddb2$var$qf(b, !1, a), $c32e4b0ba829ddb2$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c32e4b0ba829ddb2$var$rf] || (b[$c32e4b0ba829ddb2$var$rf] = !0, $c32e4b0ba829ddb2$var$qf("selectionchange", !1, b));
    }
}
function $c32e4b0ba829ddb2$var$pf(a, b, c, d) {
    switch($c32e4b0ba829ddb2$var$jd(b)){
        case 1:
            var e = $c32e4b0ba829ddb2$var$ed;
            break;
        case 4:
            e = $c32e4b0ba829ddb2$var$gd;
            break;
        default:
            e = $c32e4b0ba829ddb2$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c32e4b0ba829ddb2$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c32e4b0ba829ddb2$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c32e4b0ba829ddb2$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c32e4b0ba829ddb2$var$Jb(function() {
        var _$d = f, _$e = $c32e4b0ba829ddb2$var$xb(c), g = [];
        a: {
            var h = $c32e4b0ba829ddb2$var$df.get(a);
            if (void 0 !== h) {
                var k = $c32e4b0ba829ddb2$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c32e4b0ba829ddb2$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c32e4b0ba829ddb2$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c32e4b0ba829ddb2$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c32e4b0ba829ddb2$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c32e4b0ba829ddb2$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c32e4b0ba829ddb2$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c32e4b0ba829ddb2$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c32e4b0ba829ddb2$var$Vd;
                        break;
                    case $c32e4b0ba829ddb2$var$$e:
                    case $c32e4b0ba829ddb2$var$af:
                    case $c32e4b0ba829ddb2$var$bf:
                        k = $c32e4b0ba829ddb2$var$Hd;
                        break;
                    case $c32e4b0ba829ddb2$var$cf:
                        k = $c32e4b0ba829ddb2$var$Xd;
                        break;
                    case "scroll":
                        k = $c32e4b0ba829ddb2$var$vd;
                        break;
                    case "wheel":
                        k = $c32e4b0ba829ddb2$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c32e4b0ba829ddb2$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c32e4b0ba829ddb2$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c32e4b0ba829ddb2$var$Kb(w, x), null != F && t.push($c32e4b0ba829ddb2$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c32e4b0ba829ddb2$var$wb && (n = c.relatedTarget || c.fromElement) && ($c32e4b0ba829ddb2$var$Wc(n) || n[$c32e4b0ba829ddb2$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $c32e4b0ba829ddb2$var$Wc(n) : null, null !== n && (J = $c32e4b0ba829ddb2$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $c32e4b0ba829ddb2$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c32e4b0ba829ddb2$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c32e4b0ba829ddb2$var$ue(k);
                        u = null == n ? h : $c32e4b0ba829ddb2$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c32e4b0ba829ddb2$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c32e4b0ba829ddb2$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c32e4b0ba829ddb2$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c32e4b0ba829ddb2$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c32e4b0ba829ddb2$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c32e4b0ba829ddb2$var$vf(t);
                                x = $c32e4b0ba829ddb2$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c32e4b0ba829ddb2$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c32e4b0ba829ddb2$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $c32e4b0ba829ddb2$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c32e4b0ba829ddb2$var$ve;
                else if ($c32e4b0ba829ddb2$var$me(h)) {
                    if ($c32e4b0ba829ddb2$var$we) na = $c32e4b0ba829ddb2$var$Fe;
                    else {
                        na = $c32e4b0ba829ddb2$var$De;
                        var xa = $c32e4b0ba829ddb2$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c32e4b0ba829ddb2$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $c32e4b0ba829ddb2$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c32e4b0ba829ddb2$var$cb(h, "number", h.value);
            }
            xa = _$d ? $c32e4b0ba829ddb2$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($c32e4b0ba829ddb2$var$me(xa) || "true" === xa.contentEditable) $c32e4b0ba829ddb2$var$Qe = xa, $c32e4b0ba829ddb2$var$Re = _$d, $c32e4b0ba829ddb2$var$Se = null;
                    break;
                case "focusout":
                    $c32e4b0ba829ddb2$var$Se = $c32e4b0ba829ddb2$var$Re = $c32e4b0ba829ddb2$var$Qe = null;
                    break;
                case "mousedown":
                    $c32e4b0ba829ddb2$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c32e4b0ba829ddb2$var$Te = !1;
                    $c32e4b0ba829ddb2$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($c32e4b0ba829ddb2$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c32e4b0ba829ddb2$var$Ue(g, c, _$e);
            }
            var $a;
            if ($c32e4b0ba829ddb2$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c32e4b0ba829ddb2$var$ie ? $c32e4b0ba829ddb2$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c32e4b0ba829ddb2$var$de && "ko" !== c.locale && ($c32e4b0ba829ddb2$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c32e4b0ba829ddb2$var$ie && ($a = $c32e4b0ba829ddb2$var$nd()) : ($c32e4b0ba829ddb2$var$kd = _$e, $c32e4b0ba829ddb2$var$ld = "value" in $c32e4b0ba829ddb2$var$kd ? $c32e4b0ba829ddb2$var$kd.value : $c32e4b0ba829ddb2$var$kd.textContent, $c32e4b0ba829ddb2$var$ie = !0)), xa = $c32e4b0ba829ddb2$var$oe(_$d, ba), 0 < xa.length && (ba = new $c32e4b0ba829ddb2$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c32e4b0ba829ddb2$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c32e4b0ba829ddb2$var$ce ? $c32e4b0ba829ddb2$var$je(a, c) : $c32e4b0ba829ddb2$var$ke(a, c)) _$d = $c32e4b0ba829ddb2$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $c32e4b0ba829ddb2$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $c32e4b0ba829ddb2$var$se(g, b);
    });
}
function $c32e4b0ba829ddb2$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c32e4b0ba829ddb2$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c32e4b0ba829ddb2$var$Kb(a, c), null != f && d.unshift($c32e4b0ba829ddb2$var$tf(a, f, e)), f = $c32e4b0ba829ddb2$var$Kb(a, b), null != f && d.push($c32e4b0ba829ddb2$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c32e4b0ba829ddb2$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c32e4b0ba829ddb2$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c32e4b0ba829ddb2$var$Kb(c, f), null != k && g.unshift($c32e4b0ba829ddb2$var$tf(c, k, h))) : e || (k = $c32e4b0ba829ddb2$var$Kb(c, f), null != k && g.push($c32e4b0ba829ddb2$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c32e4b0ba829ddb2$var$xf = /\r\n?/g, $c32e4b0ba829ddb2$var$yf = /\u0000|\uFFFD/g;
function $c32e4b0ba829ddb2$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c32e4b0ba829ddb2$var$xf, "\n").replace($c32e4b0ba829ddb2$var$yf, "");
}
function $c32e4b0ba829ddb2$var$Af(a, b, c) {
    b = $c32e4b0ba829ddb2$var$zf(b);
    if ($c32e4b0ba829ddb2$var$zf(a) !== b && c) throw Error($c32e4b0ba829ddb2$var$p(425));
}
function $c32e4b0ba829ddb2$var$Bf() {}
var $c32e4b0ba829ddb2$var$Cf = null, $c32e4b0ba829ddb2$var$Df = null;
function $c32e4b0ba829ddb2$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c32e4b0ba829ddb2$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c32e4b0ba829ddb2$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c32e4b0ba829ddb2$var$Hf = "function" === typeof Promise ? Promise : void 0, $c32e4b0ba829ddb2$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c32e4b0ba829ddb2$var$Hf ? function Jf(a) {
    return $c32e4b0ba829ddb2$var$Hf.resolve(null).then(a).catch($c32e4b0ba829ddb2$var$If);
} : $c32e4b0ba829ddb2$var$Ff;
function $c32e4b0ba829ddb2$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c32e4b0ba829ddb2$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c32e4b0ba829ddb2$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c32e4b0ba829ddb2$var$bd(b);
}
function $c32e4b0ba829ddb2$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c32e4b0ba829ddb2$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c32e4b0ba829ddb2$var$Nf = Math.random().toString(36).slice(2), $c32e4b0ba829ddb2$var$Of = "__reactFiber$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$Pf = "__reactProps$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$uf = "__reactContainer$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$of = "__reactEvents$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$Qf = "__reactListeners$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$Rf = "__reactHandles$" + $c32e4b0ba829ddb2$var$Nf;
function $c32e4b0ba829ddb2$var$Wc(a) {
    var b = a[$c32e4b0ba829ddb2$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c32e4b0ba829ddb2$var$uf] || c[$c32e4b0ba829ddb2$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c32e4b0ba829ddb2$var$Mf(a); null !== a;){
                if (c = a[$c32e4b0ba829ddb2$var$Of]) return c;
                a = $c32e4b0ba829ddb2$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Cb(a) {
    a = a[$c32e4b0ba829ddb2$var$Of] || a[$c32e4b0ba829ddb2$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c32e4b0ba829ddb2$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c32e4b0ba829ddb2$var$p(33));
}
function $c32e4b0ba829ddb2$var$Db(a) {
    return a[$c32e4b0ba829ddb2$var$Pf] || null;
}
var $c32e4b0ba829ddb2$var$Sf = [], $c32e4b0ba829ddb2$var$Tf = -1;
function $c32e4b0ba829ddb2$var$Uf(a) {
    return {
        current: a
    };
}
function $c32e4b0ba829ddb2$var$E(a) {
    0 > $c32e4b0ba829ddb2$var$Tf || (a.current = $c32e4b0ba829ddb2$var$Sf[$c32e4b0ba829ddb2$var$Tf], $c32e4b0ba829ddb2$var$Sf[$c32e4b0ba829ddb2$var$Tf] = null, $c32e4b0ba829ddb2$var$Tf--);
}
function $c32e4b0ba829ddb2$var$G(a, b) {
    $c32e4b0ba829ddb2$var$Tf++;
    $c32e4b0ba829ddb2$var$Sf[$c32e4b0ba829ddb2$var$Tf] = a.current;
    a.current = b;
}
var $c32e4b0ba829ddb2$var$Vf = {}, $c32e4b0ba829ddb2$var$H = $c32e4b0ba829ddb2$var$Uf($c32e4b0ba829ddb2$var$Vf), $c32e4b0ba829ddb2$var$Wf = $c32e4b0ba829ddb2$var$Uf(!1), $c32e4b0ba829ddb2$var$Xf = $c32e4b0ba829ddb2$var$Vf;
function $c32e4b0ba829ddb2$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c32e4b0ba829ddb2$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c32e4b0ba829ddb2$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c32e4b0ba829ddb2$var$$f() {
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf);
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H);
}
function $c32e4b0ba829ddb2$var$ag(a, b, c) {
    if ($c32e4b0ba829ddb2$var$H.current !== $c32e4b0ba829ddb2$var$Vf) throw Error($c32e4b0ba829ddb2$var$p(168));
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$H, b);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Wf, c);
}
function $c32e4b0ba829ddb2$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c32e4b0ba829ddb2$var$p(108, $c32e4b0ba829ddb2$var$Ra(a) || "Unknown", e));
    return $c32e4b0ba829ddb2$var$A({}, c, d);
}
function $c32e4b0ba829ddb2$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c32e4b0ba829ddb2$var$Vf;
    $c32e4b0ba829ddb2$var$Xf = $c32e4b0ba829ddb2$var$H.current;
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$H, a);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Wf, $c32e4b0ba829ddb2$var$Wf.current);
    return !0;
}
function $c32e4b0ba829ddb2$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c32e4b0ba829ddb2$var$p(169));
    c ? (a = $c32e4b0ba829ddb2$var$bg(a, b, $c32e4b0ba829ddb2$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf), $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H), $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$H, a)) : $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Wf, c);
}
var $c32e4b0ba829ddb2$var$eg = null, $c32e4b0ba829ddb2$var$fg = !1, $c32e4b0ba829ddb2$var$gg = !1;
function $c32e4b0ba829ddb2$var$hg(a) {
    null === $c32e4b0ba829ddb2$var$eg ? $c32e4b0ba829ddb2$var$eg = [
        a
    ] : $c32e4b0ba829ddb2$var$eg.push(a);
}
function $c32e4b0ba829ddb2$var$ig(a) {
    $c32e4b0ba829ddb2$var$fg = !0;
    $c32e4b0ba829ddb2$var$hg(a);
}
function $c32e4b0ba829ddb2$var$jg() {
    if (!$c32e4b0ba829ddb2$var$gg && null !== $c32e4b0ba829ddb2$var$eg) {
        $c32e4b0ba829ddb2$var$gg = !0;
        var a = 0, b = $c32e4b0ba829ddb2$var$C;
        try {
            var c = $c32e4b0ba829ddb2$var$eg;
            for($c32e4b0ba829ddb2$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c32e4b0ba829ddb2$var$eg = null;
            $c32e4b0ba829ddb2$var$fg = !1;
        } catch (e) {
            throw null !== $c32e4b0ba829ddb2$var$eg && ($c32e4b0ba829ddb2$var$eg = $c32e4b0ba829ddb2$var$eg.slice(a + 1)), $c32e4b0ba829ddb2$var$ac($c32e4b0ba829ddb2$var$fc, $c32e4b0ba829ddb2$var$jg), e;
        } finally{
            $c32e4b0ba829ddb2$var$C = b, $c32e4b0ba829ddb2$var$gg = !1;
        }
    }
    return null;
}
var $c32e4b0ba829ddb2$var$kg = [], $c32e4b0ba829ddb2$var$lg = 0, $c32e4b0ba829ddb2$var$mg = null, $c32e4b0ba829ddb2$var$ng = 0, $c32e4b0ba829ddb2$var$og = [], $c32e4b0ba829ddb2$var$pg = 0, $c32e4b0ba829ddb2$var$qg = null, $c32e4b0ba829ddb2$var$rg = 1, $c32e4b0ba829ddb2$var$sg = "";
function $c32e4b0ba829ddb2$var$tg(a, b) {
    $c32e4b0ba829ddb2$var$kg[$c32e4b0ba829ddb2$var$lg++] = $c32e4b0ba829ddb2$var$ng;
    $c32e4b0ba829ddb2$var$kg[$c32e4b0ba829ddb2$var$lg++] = $c32e4b0ba829ddb2$var$mg;
    $c32e4b0ba829ddb2$var$mg = a;
    $c32e4b0ba829ddb2$var$ng = b;
}
function $c32e4b0ba829ddb2$var$ug(a, b, c) {
    $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$rg;
    $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$sg;
    $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$qg;
    $c32e4b0ba829ddb2$var$qg = a;
    var d = $c32e4b0ba829ddb2$var$rg;
    a = $c32e4b0ba829ddb2$var$sg;
    var e = 32 - $c32e4b0ba829ddb2$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c32e4b0ba829ddb2$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c32e4b0ba829ddb2$var$rg = 1 << 32 - $c32e4b0ba829ddb2$var$oc(b) + e | c << e | d;
        $c32e4b0ba829ddb2$var$sg = f + a;
    } else $c32e4b0ba829ddb2$var$rg = 1 << f | c << e | d, $c32e4b0ba829ddb2$var$sg = a;
}
function $c32e4b0ba829ddb2$var$vg(a) {
    null !== a.return && ($c32e4b0ba829ddb2$var$tg(a, 1), $c32e4b0ba829ddb2$var$ug(a, 1, 0));
}
function $c32e4b0ba829ddb2$var$wg(a) {
    for(; a === $c32e4b0ba829ddb2$var$mg;)$c32e4b0ba829ddb2$var$mg = $c32e4b0ba829ddb2$var$kg[--$c32e4b0ba829ddb2$var$lg], $c32e4b0ba829ddb2$var$kg[$c32e4b0ba829ddb2$var$lg] = null, $c32e4b0ba829ddb2$var$ng = $c32e4b0ba829ddb2$var$kg[--$c32e4b0ba829ddb2$var$lg], $c32e4b0ba829ddb2$var$kg[$c32e4b0ba829ddb2$var$lg] = null;
    for(; a === $c32e4b0ba829ddb2$var$qg;)$c32e4b0ba829ddb2$var$qg = $c32e4b0ba829ddb2$var$og[--$c32e4b0ba829ddb2$var$pg], $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg] = null, $c32e4b0ba829ddb2$var$sg = $c32e4b0ba829ddb2$var$og[--$c32e4b0ba829ddb2$var$pg], $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg] = null, $c32e4b0ba829ddb2$var$rg = $c32e4b0ba829ddb2$var$og[--$c32e4b0ba829ddb2$var$pg], $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg] = null;
}
var $c32e4b0ba829ddb2$var$xg = null, $c32e4b0ba829ddb2$var$yg = null, $c32e4b0ba829ddb2$var$I = !1, $c32e4b0ba829ddb2$var$zg = null;
function $c32e4b0ba829ddb2$var$Ag(a, b) {
    var c = $c32e4b0ba829ddb2$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c32e4b0ba829ddb2$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c32e4b0ba829ddb2$var$xg = a, $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c32e4b0ba829ddb2$var$xg = a, $c32e4b0ba829ddb2$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c32e4b0ba829ddb2$var$qg ? {
                id: $c32e4b0ba829ddb2$var$rg,
                overflow: $c32e4b0ba829ddb2$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c32e4b0ba829ddb2$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c32e4b0ba829ddb2$var$xg = a, $c32e4b0ba829ddb2$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c32e4b0ba829ddb2$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c32e4b0ba829ddb2$var$Eg(a) {
    if ($c32e4b0ba829ddb2$var$I) {
        var b = $c32e4b0ba829ddb2$var$yg;
        if (b) {
            var c = b;
            if (!$c32e4b0ba829ddb2$var$Cg(a, b)) {
                if ($c32e4b0ba829ddb2$var$Dg(a)) throw Error($c32e4b0ba829ddb2$var$p(418));
                b = $c32e4b0ba829ddb2$var$Lf(c.nextSibling);
                var d = $c32e4b0ba829ddb2$var$xg;
                b && $c32e4b0ba829ddb2$var$Cg(a, b) ? $c32e4b0ba829ddb2$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c32e4b0ba829ddb2$var$I = !1, $c32e4b0ba829ddb2$var$xg = a);
            }
        } else {
            if ($c32e4b0ba829ddb2$var$Dg(a)) throw Error($c32e4b0ba829ddb2$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c32e4b0ba829ddb2$var$I = !1;
            $c32e4b0ba829ddb2$var$xg = a;
        }
    }
}
function $c32e4b0ba829ddb2$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c32e4b0ba829ddb2$var$xg = a;
}
function $c32e4b0ba829ddb2$var$Gg(a) {
    if (a !== $c32e4b0ba829ddb2$var$xg) return !1;
    if (!$c32e4b0ba829ddb2$var$I) return $c32e4b0ba829ddb2$var$Fg(a), $c32e4b0ba829ddb2$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c32e4b0ba829ddb2$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c32e4b0ba829ddb2$var$yg)) {
        if ($c32e4b0ba829ddb2$var$Dg(a)) throw $c32e4b0ba829ddb2$var$Hg(), Error($c32e4b0ba829ddb2$var$p(418));
        for(; b;)$c32e4b0ba829ddb2$var$Ag(a, b), b = $c32e4b0ba829ddb2$var$Lf(b.nextSibling);
    }
    $c32e4b0ba829ddb2$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c32e4b0ba829ddb2$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c32e4b0ba829ddb2$var$yg = null;
        }
    } else $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$xg ? $c32e4b0ba829ddb2$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c32e4b0ba829ddb2$var$Hg() {
    for(var a = $c32e4b0ba829ddb2$var$yg; a;)a = $c32e4b0ba829ddb2$var$Lf(a.nextSibling);
}
function $c32e4b0ba829ddb2$var$Ig() {
    $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$xg = null;
    $c32e4b0ba829ddb2$var$I = !1;
}
function $c32e4b0ba829ddb2$var$Jg(a) {
    null === $c32e4b0ba829ddb2$var$zg ? $c32e4b0ba829ddb2$var$zg = [
        a
    ] : $c32e4b0ba829ddb2$var$zg.push(a);
}
var $c32e4b0ba829ddb2$var$Kg = $c32e4b0ba829ddb2$var$ua.ReactCurrentBatchConfig;
function $c32e4b0ba829ddb2$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c32e4b0ba829ddb2$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c32e4b0ba829ddb2$var$Mg = $c32e4b0ba829ddb2$var$Uf(null), $c32e4b0ba829ddb2$var$Ng = null, $c32e4b0ba829ddb2$var$Og = null, $c32e4b0ba829ddb2$var$Pg = null;
function $c32e4b0ba829ddb2$var$Qg() {
    $c32e4b0ba829ddb2$var$Pg = $c32e4b0ba829ddb2$var$Og = $c32e4b0ba829ddb2$var$Ng = null;
}
function $c32e4b0ba829ddb2$var$Rg(a) {
    var b = $c32e4b0ba829ddb2$var$Mg.current;
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Mg);
    a._currentValue = b;
}
function $c32e4b0ba829ddb2$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c32e4b0ba829ddb2$var$Tg(a, b) {
    $c32e4b0ba829ddb2$var$Ng = a;
    $c32e4b0ba829ddb2$var$Pg = $c32e4b0ba829ddb2$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c32e4b0ba829ddb2$var$Ug = !0), a.firstContext = null);
}
function $c32e4b0ba829ddb2$var$Vg(a) {
    var b = a._currentValue;
    if ($c32e4b0ba829ddb2$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c32e4b0ba829ddb2$var$Og) {
            if (null === $c32e4b0ba829ddb2$var$Ng) throw Error($c32e4b0ba829ddb2$var$p(308));
            $c32e4b0ba829ddb2$var$Og = a;
            $c32e4b0ba829ddb2$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c32e4b0ba829ddb2$var$Og = $c32e4b0ba829ddb2$var$Og.next = a;
    }
    return b;
}
var $c32e4b0ba829ddb2$var$Wg = null;
function $c32e4b0ba829ddb2$var$Xg(a) {
    null === $c32e4b0ba829ddb2$var$Wg ? $c32e4b0ba829ddb2$var$Wg = [
        a
    ] : $c32e4b0ba829ddb2$var$Wg.push(a);
}
function $c32e4b0ba829ddb2$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c32e4b0ba829ddb2$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c32e4b0ba829ddb2$var$Zg(a, d);
}
function $c32e4b0ba829ddb2$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c32e4b0ba829ddb2$var$$g = !1;
function $c32e4b0ba829ddb2$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c32e4b0ba829ddb2$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c32e4b0ba829ddb2$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c32e4b0ba829ddb2$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c32e4b0ba829ddb2$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c32e4b0ba829ddb2$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c32e4b0ba829ddb2$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c32e4b0ba829ddb2$var$Zg(a, c);
}
function $c32e4b0ba829ddb2$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c32e4b0ba829ddb2$var$Cc(a, c);
    }
}
function $c32e4b0ba829ddb2$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c32e4b0ba829ddb2$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c32e4b0ba829ddb2$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c32e4b0ba829ddb2$var$A({}, q, r);
                            break a;
                        case 2:
                            $c32e4b0ba829ddb2$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c32e4b0ba829ddb2$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c32e4b0ba829ddb2$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c32e4b0ba829ddb2$var$p(191, e));
            e.call(d);
        }
    }
}
var $c32e4b0ba829ddb2$var$jh = (new $eHaBZ.Component).refs;
function $c32e4b0ba829ddb2$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c32e4b0ba829ddb2$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c32e4b0ba829ddb2$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $c32e4b0ba829ddb2$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $c32e4b0ba829ddb2$var$L(), e = $c32e4b0ba829ddb2$var$lh(a), f = $c32e4b0ba829ddb2$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c32e4b0ba829ddb2$var$dh(a, f, e);
        null !== b && ($c32e4b0ba829ddb2$var$mh(b, a, e, d), $c32e4b0ba829ddb2$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $c32e4b0ba829ddb2$var$L(), e = $c32e4b0ba829ddb2$var$lh(a), f = $c32e4b0ba829ddb2$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c32e4b0ba829ddb2$var$dh(a, f, e);
        null !== b && ($c32e4b0ba829ddb2$var$mh(b, a, e, d), $c32e4b0ba829ddb2$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $c32e4b0ba829ddb2$var$L(), d = $c32e4b0ba829ddb2$var$lh(a), e = $c32e4b0ba829ddb2$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c32e4b0ba829ddb2$var$dh(a, e, d);
        null !== b && ($c32e4b0ba829ddb2$var$mh(b, a, d, c), $c32e4b0ba829ddb2$var$eh(b, a, d));
    }
};
function $c32e4b0ba829ddb2$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c32e4b0ba829ddb2$var$Ie(c, d) || !$c32e4b0ba829ddb2$var$Ie(e, f) : !0;
}
function $c32e4b0ba829ddb2$var$ph(a, b, c) {
    var d = !1, e = $c32e4b0ba829ddb2$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c32e4b0ba829ddb2$var$Vg(f) : (e = $c32e4b0ba829ddb2$var$Zf(b) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c32e4b0ba829ddb2$var$Yf(a, e) : $c32e4b0ba829ddb2$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c32e4b0ba829ddb2$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c32e4b0ba829ddb2$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c32e4b0ba829ddb2$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c32e4b0ba829ddb2$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c32e4b0ba829ddb2$var$jh;
    $c32e4b0ba829ddb2$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c32e4b0ba829ddb2$var$Vg(f) : (f = $c32e4b0ba829ddb2$var$Zf(b) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current, e.context = $c32e4b0ba829ddb2$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c32e4b0ba829ddb2$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c32e4b0ba829ddb2$var$nh.enqueueReplaceState(e, e.state, null), $c32e4b0ba829ddb2$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c32e4b0ba829ddb2$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c32e4b0ba829ddb2$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c32e4b0ba829ddb2$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $c32e4b0ba829ddb2$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c32e4b0ba829ddb2$var$p(284));
        if (!c._owner) throw Error($c32e4b0ba829ddb2$var$p(290, a));
    }
    return a;
}
function $c32e4b0ba829ddb2$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c32e4b0ba829ddb2$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c32e4b0ba829ddb2$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c32e4b0ba829ddb2$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c32e4b0ba829ddb2$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c32e4b0ba829ddb2$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c32e4b0ba829ddb2$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c32e4b0ba829ddb2$var$Ha && $c32e4b0ba829ddb2$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c32e4b0ba829ddb2$var$sh(a, b, c), d.return = a, d;
        d = $c32e4b0ba829ddb2$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c32e4b0ba829ddb2$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c32e4b0ba829ddb2$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c32e4b0ba829ddb2$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c32e4b0ba829ddb2$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c32e4b0ba829ddb2$var$va:
                    return c = $c32e4b0ba829ddb2$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c32e4b0ba829ddb2$var$sh(a, null, b), c.return = a, c;
                case $c32e4b0ba829ddb2$var$wa:
                    return b = $c32e4b0ba829ddb2$var$zh(b, a.mode, c), b.return = a, b;
                case $c32e4b0ba829ddb2$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c32e4b0ba829ddb2$var$eb(b) || $c32e4b0ba829ddb2$var$Ka(b)) return b = $c32e4b0ba829ddb2$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c32e4b0ba829ddb2$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c32e4b0ba829ddb2$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c32e4b0ba829ddb2$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c32e4b0ba829ddb2$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c32e4b0ba829ddb2$var$eb(c) || $c32e4b0ba829ddb2$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c32e4b0ba829ddb2$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c32e4b0ba829ddb2$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c32e4b0ba829ddb2$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c32e4b0ba829ddb2$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c32e4b0ba829ddb2$var$eb(d) || $c32e4b0ba829ddb2$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c32e4b0ba829ddb2$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c32e4b0ba829ddb2$var$Ka(h);
        if ("function" !== typeof l) throw Error($c32e4b0ba829ddb2$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c32e4b0ba829ddb2$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c32e4b0ba829ddb2$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c32e4b0ba829ddb2$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c32e4b0ba829ddb2$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c32e4b0ba829ddb2$var$Ha && $c32e4b0ba829ddb2$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c32e4b0ba829ddb2$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c32e4b0ba829ddb2$var$ya ? (d = $c32e4b0ba829ddb2$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c32e4b0ba829ddb2$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c32e4b0ba829ddb2$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c32e4b0ba829ddb2$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c32e4b0ba829ddb2$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c32e4b0ba829ddb2$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c32e4b0ba829ddb2$var$eb(f)) return n(a, d, f, h);
            if ($c32e4b0ba829ddb2$var$Ka(f)) return t(a, d, f, h);
            $c32e4b0ba829ddb2$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c32e4b0ba829ddb2$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c32e4b0ba829ddb2$var$Bh = $c32e4b0ba829ddb2$var$vh(!0), $c32e4b0ba829ddb2$var$Ch = $c32e4b0ba829ddb2$var$vh(!1), $c32e4b0ba829ddb2$var$Dh = {}, $c32e4b0ba829ddb2$var$Eh = $c32e4b0ba829ddb2$var$Uf($c32e4b0ba829ddb2$var$Dh), $c32e4b0ba829ddb2$var$Fh = $c32e4b0ba829ddb2$var$Uf($c32e4b0ba829ddb2$var$Dh), $c32e4b0ba829ddb2$var$Gh = $c32e4b0ba829ddb2$var$Uf($c32e4b0ba829ddb2$var$Dh);
function $c32e4b0ba829ddb2$var$Hh(a) {
    if (a === $c32e4b0ba829ddb2$var$Dh) throw Error($c32e4b0ba829ddb2$var$p(174));
    return a;
}
function $c32e4b0ba829ddb2$var$Ih(a, b) {
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Gh, b);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Fh, a);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Eh, $c32e4b0ba829ddb2$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c32e4b0ba829ddb2$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c32e4b0ba829ddb2$var$lb(b, a);
    }
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Eh);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Eh, b);
}
function $c32e4b0ba829ddb2$var$Jh() {
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Eh);
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Fh);
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Gh);
}
function $c32e4b0ba829ddb2$var$Kh(a) {
    $c32e4b0ba829ddb2$var$Hh($c32e4b0ba829ddb2$var$Gh.current);
    var b = $c32e4b0ba829ddb2$var$Hh($c32e4b0ba829ddb2$var$Eh.current);
    var c = $c32e4b0ba829ddb2$var$lb(b, a.type);
    b !== c && ($c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Fh, a), $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Eh, c));
}
function $c32e4b0ba829ddb2$var$Lh(a) {
    $c32e4b0ba829ddb2$var$Fh.current === a && ($c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Eh), $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Fh));
}
var $c32e4b0ba829ddb2$var$M = $c32e4b0ba829ddb2$var$Uf(0);
function $c32e4b0ba829ddb2$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c32e4b0ba829ddb2$var$Nh = [];
function $c32e4b0ba829ddb2$var$Oh() {
    for(var a = 0; a < $c32e4b0ba829ddb2$var$Nh.length; a++)$c32e4b0ba829ddb2$var$Nh[a]._workInProgressVersionPrimary = null;
    $c32e4b0ba829ddb2$var$Nh.length = 0;
}
var $c32e4b0ba829ddb2$var$Ph = $c32e4b0ba829ddb2$var$ua.ReactCurrentDispatcher, $c32e4b0ba829ddb2$var$Qh = $c32e4b0ba829ddb2$var$ua.ReactCurrentBatchConfig, $c32e4b0ba829ddb2$var$Rh = 0, $c32e4b0ba829ddb2$var$N = null, $c32e4b0ba829ddb2$var$O = null, $c32e4b0ba829ddb2$var$P = null, $c32e4b0ba829ddb2$var$Sh = !1, $c32e4b0ba829ddb2$var$Th = !1, $c32e4b0ba829ddb2$var$Uh = 0, $c32e4b0ba829ddb2$var$Vh = 0;
function $c32e4b0ba829ddb2$var$Q() {
    throw Error($c32e4b0ba829ddb2$var$p(321));
}
function $c32e4b0ba829ddb2$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c32e4b0ba829ddb2$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c32e4b0ba829ddb2$var$Xh(a, b, c, d, e, f) {
    $c32e4b0ba829ddb2$var$Rh = f;
    $c32e4b0ba829ddb2$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c32e4b0ba829ddb2$var$Ph.current = null === a || null === a.memoizedState ? $c32e4b0ba829ddb2$var$Yh : $c32e4b0ba829ddb2$var$Zh;
    a = c(d, e);
    if ($c32e4b0ba829ddb2$var$Th) {
        f = 0;
        do {
            $c32e4b0ba829ddb2$var$Th = !1;
            $c32e4b0ba829ddb2$var$Uh = 0;
            if (25 <= f) throw Error($c32e4b0ba829ddb2$var$p(301));
            f += 1;
            $c32e4b0ba829ddb2$var$P = $c32e4b0ba829ddb2$var$O = null;
            b.updateQueue = null;
            $c32e4b0ba829ddb2$var$Ph.current = $c32e4b0ba829ddb2$var$$h;
            a = c(d, e);
        }while ($c32e4b0ba829ddb2$var$Th);
    }
    $c32e4b0ba829ddb2$var$Ph.current = $c32e4b0ba829ddb2$var$ai;
    b = null !== $c32e4b0ba829ddb2$var$O && null !== $c32e4b0ba829ddb2$var$O.next;
    $c32e4b0ba829ddb2$var$Rh = 0;
    $c32e4b0ba829ddb2$var$P = $c32e4b0ba829ddb2$var$O = $c32e4b0ba829ddb2$var$N = null;
    $c32e4b0ba829ddb2$var$Sh = !1;
    if (b) throw Error($c32e4b0ba829ddb2$var$p(300));
    return a;
}
function $c32e4b0ba829ddb2$var$bi() {
    var a = 0 !== $c32e4b0ba829ddb2$var$Uh;
    $c32e4b0ba829ddb2$var$Uh = 0;
    return a;
}
function $c32e4b0ba829ddb2$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c32e4b0ba829ddb2$var$P ? $c32e4b0ba829ddb2$var$N.memoizedState = $c32e4b0ba829ddb2$var$P = a : $c32e4b0ba829ddb2$var$P = $c32e4b0ba829ddb2$var$P.next = a;
    return $c32e4b0ba829ddb2$var$P;
}
function $c32e4b0ba829ddb2$var$di() {
    if (null === $c32e4b0ba829ddb2$var$O) {
        var a = $c32e4b0ba829ddb2$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c32e4b0ba829ddb2$var$O.next;
    var b = null === $c32e4b0ba829ddb2$var$P ? $c32e4b0ba829ddb2$var$N.memoizedState : $c32e4b0ba829ddb2$var$P.next;
    if (null !== b) $c32e4b0ba829ddb2$var$P = b, $c32e4b0ba829ddb2$var$O = a;
    else {
        if (null === a) throw Error($c32e4b0ba829ddb2$var$p(310));
        $c32e4b0ba829ddb2$var$O = a;
        a = {
            memoizedState: $c32e4b0ba829ddb2$var$O.memoizedState,
            baseState: $c32e4b0ba829ddb2$var$O.baseState,
            baseQueue: $c32e4b0ba829ddb2$var$O.baseQueue,
            queue: $c32e4b0ba829ddb2$var$O.queue,
            next: null
        };
        null === $c32e4b0ba829ddb2$var$P ? $c32e4b0ba829ddb2$var$N.memoizedState = $c32e4b0ba829ddb2$var$P = a : $c32e4b0ba829ddb2$var$P = $c32e4b0ba829ddb2$var$P.next = a;
    }
    return $c32e4b0ba829ddb2$var$P;
}
function $c32e4b0ba829ddb2$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c32e4b0ba829ddb2$var$fi(a) {
    var b = $c32e4b0ba829ddb2$var$di(), c = b.queue;
    if (null === c) throw Error($c32e4b0ba829ddb2$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c32e4b0ba829ddb2$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c32e4b0ba829ddb2$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c32e4b0ba829ddb2$var$N.lanes |= m;
                $c32e4b0ba829ddb2$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c32e4b0ba829ddb2$var$He(d, b.memoizedState) || ($c32e4b0ba829ddb2$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c32e4b0ba829ddb2$var$N.lanes |= f, $c32e4b0ba829ddb2$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c32e4b0ba829ddb2$var$gi(a) {
    var b = $c32e4b0ba829ddb2$var$di(), c = b.queue;
    if (null === c) throw Error($c32e4b0ba829ddb2$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c32e4b0ba829ddb2$var$He(f, b.memoizedState) || ($c32e4b0ba829ddb2$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c32e4b0ba829ddb2$var$hi() {}
function $c32e4b0ba829ddb2$var$ii(a, b) {
    var c = $c32e4b0ba829ddb2$var$N, d = $c32e4b0ba829ddb2$var$di(), e = b(), f = !$c32e4b0ba829ddb2$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c32e4b0ba829ddb2$var$Ug = !0);
    d = d.queue;
    $c32e4b0ba829ddb2$var$ji($c32e4b0ba829ddb2$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c32e4b0ba829ddb2$var$P && $c32e4b0ba829ddb2$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c32e4b0ba829ddb2$var$li(9, $c32e4b0ba829ddb2$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c32e4b0ba829ddb2$var$R) throw Error($c32e4b0ba829ddb2$var$p(349));
        0 !== ($c32e4b0ba829ddb2$var$Rh & 30) || $c32e4b0ba829ddb2$var$ni(c, b, e);
    }
    return e;
}
function $c32e4b0ba829ddb2$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c32e4b0ba829ddb2$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c32e4b0ba829ddb2$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c32e4b0ba829ddb2$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c32e4b0ba829ddb2$var$oi(b) && $c32e4b0ba829ddb2$var$pi(a);
}
function $c32e4b0ba829ddb2$var$ki(a, b, c) {
    return c(function() {
        $c32e4b0ba829ddb2$var$oi(b) && $c32e4b0ba829ddb2$var$pi(a);
    });
}
function $c32e4b0ba829ddb2$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c32e4b0ba829ddb2$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c32e4b0ba829ddb2$var$pi(a) {
    var b = $c32e4b0ba829ddb2$var$Zg(a, 1);
    null !== b && $c32e4b0ba829ddb2$var$mh(b, a, 1, -1);
}
function $c32e4b0ba829ddb2$var$qi(a) {
    var b = $c32e4b0ba829ddb2$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c32e4b0ba829ddb2$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c32e4b0ba829ddb2$var$ri.bind(null, $c32e4b0ba829ddb2$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c32e4b0ba829ddb2$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c32e4b0ba829ddb2$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c32e4b0ba829ddb2$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c32e4b0ba829ddb2$var$si() {
    return $c32e4b0ba829ddb2$var$di().memoizedState;
}
function $c32e4b0ba829ddb2$var$ti(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$ci();
    $c32e4b0ba829ddb2$var$N.flags |= a;
    e.memoizedState = $c32e4b0ba829ddb2$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c32e4b0ba829ddb2$var$ui(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c32e4b0ba829ddb2$var$O) {
        var g = $c32e4b0ba829ddb2$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c32e4b0ba829ddb2$var$Wh(d, g.deps)) {
            e.memoizedState = $c32e4b0ba829ddb2$var$li(b, c, f, d);
            return;
        }
    }
    $c32e4b0ba829ddb2$var$N.flags |= a;
    e.memoizedState = $c32e4b0ba829ddb2$var$li(1 | b, c, f, d);
}
function $c32e4b0ba829ddb2$var$vi(a, b) {
    return $c32e4b0ba829ddb2$var$ti(8390656, 8, a, b);
}
function $c32e4b0ba829ddb2$var$ji(a, b) {
    return $c32e4b0ba829ddb2$var$ui(2048, 8, a, b);
}
function $c32e4b0ba829ddb2$var$wi(a, b) {
    return $c32e4b0ba829ddb2$var$ui(4, 2, a, b);
}
function $c32e4b0ba829ddb2$var$xi(a, b) {
    return $c32e4b0ba829ddb2$var$ui(4, 4, a, b);
}
function $c32e4b0ba829ddb2$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c32e4b0ba829ddb2$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c32e4b0ba829ddb2$var$ui(4, 4, $c32e4b0ba829ddb2$var$yi.bind(null, b, a), c);
}
function $c32e4b0ba829ddb2$var$Ai() {}
function $c32e4b0ba829ddb2$var$Bi(a, b) {
    var c = $c32e4b0ba829ddb2$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c32e4b0ba829ddb2$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c32e4b0ba829ddb2$var$Ci(a, b) {
    var c = $c32e4b0ba829ddb2$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c32e4b0ba829ddb2$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c32e4b0ba829ddb2$var$Di(a, b, c) {
    if (0 === ($c32e4b0ba829ddb2$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c32e4b0ba829ddb2$var$Ug = !0), a.memoizedState = c;
    $c32e4b0ba829ddb2$var$He(c, b) || (c = $c32e4b0ba829ddb2$var$yc(), $c32e4b0ba829ddb2$var$N.lanes |= c, $c32e4b0ba829ddb2$var$hh |= c, a.baseState = !0);
    return b;
}
function $c32e4b0ba829ddb2$var$Ei(a, b) {
    var c = $c32e4b0ba829ddb2$var$C;
    $c32e4b0ba829ddb2$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c32e4b0ba829ddb2$var$Qh.transition;
    $c32e4b0ba829ddb2$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c32e4b0ba829ddb2$var$C = c, $c32e4b0ba829ddb2$var$Qh.transition = d;
    }
}
function $c32e4b0ba829ddb2$var$Fi() {
    return $c32e4b0ba829ddb2$var$di().memoizedState;
}
function $c32e4b0ba829ddb2$var$Gi(a, b, c) {
    var d = $c32e4b0ba829ddb2$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c32e4b0ba829ddb2$var$Hi(a)) $c32e4b0ba829ddb2$var$Ii(b, c);
    else if (c = $c32e4b0ba829ddb2$var$Yg(a, b, c, d), null !== c) {
        var e = $c32e4b0ba829ddb2$var$L();
        $c32e4b0ba829ddb2$var$mh(c, a, d, e);
        $c32e4b0ba829ddb2$var$Ji(c, b, d);
    }
}
function $c32e4b0ba829ddb2$var$ri(a, b, c) {
    var d = $c32e4b0ba829ddb2$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c32e4b0ba829ddb2$var$Hi(a)) $c32e4b0ba829ddb2$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c32e4b0ba829ddb2$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c32e4b0ba829ddb2$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c32e4b0ba829ddb2$var$Yg(a, b, e, d);
        null !== c && (e = $c32e4b0ba829ddb2$var$L(), $c32e4b0ba829ddb2$var$mh(c, a, d, e), $c32e4b0ba829ddb2$var$Ji(c, b, d));
    }
}
function $c32e4b0ba829ddb2$var$Hi(a) {
    var b = a.alternate;
    return a === $c32e4b0ba829ddb2$var$N || null !== b && b === $c32e4b0ba829ddb2$var$N;
}
function $c32e4b0ba829ddb2$var$Ii(a, b) {
    $c32e4b0ba829ddb2$var$Th = $c32e4b0ba829ddb2$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c32e4b0ba829ddb2$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c32e4b0ba829ddb2$var$Cc(a, c);
    }
}
var $c32e4b0ba829ddb2$var$ai = {
    readContext: $c32e4b0ba829ddb2$var$Vg,
    useCallback: $c32e4b0ba829ddb2$var$Q,
    useContext: $c32e4b0ba829ddb2$var$Q,
    useEffect: $c32e4b0ba829ddb2$var$Q,
    useImperativeHandle: $c32e4b0ba829ddb2$var$Q,
    useInsertionEffect: $c32e4b0ba829ddb2$var$Q,
    useLayoutEffect: $c32e4b0ba829ddb2$var$Q,
    useMemo: $c32e4b0ba829ddb2$var$Q,
    useReducer: $c32e4b0ba829ddb2$var$Q,
    useRef: $c32e4b0ba829ddb2$var$Q,
    useState: $c32e4b0ba829ddb2$var$Q,
    useDebugValue: $c32e4b0ba829ddb2$var$Q,
    useDeferredValue: $c32e4b0ba829ddb2$var$Q,
    useTransition: $c32e4b0ba829ddb2$var$Q,
    useMutableSource: $c32e4b0ba829ddb2$var$Q,
    useSyncExternalStore: $c32e4b0ba829ddb2$var$Q,
    useId: $c32e4b0ba829ddb2$var$Q,
    unstable_isNewReconciler: !1
}, $c32e4b0ba829ddb2$var$Yh = {
    readContext: $c32e4b0ba829ddb2$var$Vg,
    useCallback: function useCallback(a, b) {
        $c32e4b0ba829ddb2$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c32e4b0ba829ddb2$var$Vg,
    useEffect: $c32e4b0ba829ddb2$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c32e4b0ba829ddb2$var$ti(4194308, 4, $c32e4b0ba829ddb2$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $c32e4b0ba829ddb2$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $c32e4b0ba829ddb2$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $c32e4b0ba829ddb2$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $c32e4b0ba829ddb2$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c32e4b0ba829ddb2$var$Gi.bind(null, $c32e4b0ba829ddb2$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $c32e4b0ba829ddb2$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c32e4b0ba829ddb2$var$qi,
    useDebugValue: $c32e4b0ba829ddb2$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $c32e4b0ba829ddb2$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $c32e4b0ba829ddb2$var$qi(!1), b = a[0];
        a = $c32e4b0ba829ddb2$var$Ei.bind(null, a[1]);
        $c32e4b0ba829ddb2$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $c32e4b0ba829ddb2$var$N, e = $c32e4b0ba829ddb2$var$ci();
        if ($c32e4b0ba829ddb2$var$I) {
            if (void 0 === c) throw Error($c32e4b0ba829ddb2$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c32e4b0ba829ddb2$var$R) throw Error($c32e4b0ba829ddb2$var$p(349));
            0 !== ($c32e4b0ba829ddb2$var$Rh & 30) || $c32e4b0ba829ddb2$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c32e4b0ba829ddb2$var$vi($c32e4b0ba829ddb2$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c32e4b0ba829ddb2$var$li(9, $c32e4b0ba829ddb2$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $c32e4b0ba829ddb2$var$ci(), b = $c32e4b0ba829ddb2$var$R.identifierPrefix;
        if ($c32e4b0ba829ddb2$var$I) {
            var c = $c32e4b0ba829ddb2$var$sg;
            var d = $c32e4b0ba829ddb2$var$rg;
            c = (d & ~(1 << 32 - $c32e4b0ba829ddb2$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c32e4b0ba829ddb2$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c32e4b0ba829ddb2$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c32e4b0ba829ddb2$var$Zh = {
    readContext: $c32e4b0ba829ddb2$var$Vg,
    useCallback: $c32e4b0ba829ddb2$var$Bi,
    useContext: $c32e4b0ba829ddb2$var$Vg,
    useEffect: $c32e4b0ba829ddb2$var$ji,
    useImperativeHandle: $c32e4b0ba829ddb2$var$zi,
    useInsertionEffect: $c32e4b0ba829ddb2$var$wi,
    useLayoutEffect: $c32e4b0ba829ddb2$var$xi,
    useMemo: $c32e4b0ba829ddb2$var$Ci,
    useReducer: $c32e4b0ba829ddb2$var$fi,
    useRef: $c32e4b0ba829ddb2$var$si,
    useState: function useState() {
        return $c32e4b0ba829ddb2$var$fi($c32e4b0ba829ddb2$var$ei);
    },
    useDebugValue: $c32e4b0ba829ddb2$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $c32e4b0ba829ddb2$var$di();
        return $c32e4b0ba829ddb2$var$Di(b, $c32e4b0ba829ddb2$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $c32e4b0ba829ddb2$var$fi($c32e4b0ba829ddb2$var$ei)[0], b = $c32e4b0ba829ddb2$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c32e4b0ba829ddb2$var$hi,
    useSyncExternalStore: $c32e4b0ba829ddb2$var$ii,
    useId: $c32e4b0ba829ddb2$var$Fi,
    unstable_isNewReconciler: !1
}, $c32e4b0ba829ddb2$var$$h = {
    readContext: $c32e4b0ba829ddb2$var$Vg,
    useCallback: $c32e4b0ba829ddb2$var$Bi,
    useContext: $c32e4b0ba829ddb2$var$Vg,
    useEffect: $c32e4b0ba829ddb2$var$ji,
    useImperativeHandle: $c32e4b0ba829ddb2$var$zi,
    useInsertionEffect: $c32e4b0ba829ddb2$var$wi,
    useLayoutEffect: $c32e4b0ba829ddb2$var$xi,
    useMemo: $c32e4b0ba829ddb2$var$Ci,
    useReducer: $c32e4b0ba829ddb2$var$gi,
    useRef: $c32e4b0ba829ddb2$var$si,
    useState: function useState() {
        return $c32e4b0ba829ddb2$var$gi($c32e4b0ba829ddb2$var$ei);
    },
    useDebugValue: $c32e4b0ba829ddb2$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $c32e4b0ba829ddb2$var$di();
        return null === $c32e4b0ba829ddb2$var$O ? b.memoizedState = a : $c32e4b0ba829ddb2$var$Di(b, $c32e4b0ba829ddb2$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $c32e4b0ba829ddb2$var$gi($c32e4b0ba829ddb2$var$ei)[0], b = $c32e4b0ba829ddb2$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c32e4b0ba829ddb2$var$hi,
    useSyncExternalStore: $c32e4b0ba829ddb2$var$ii,
    useId: $c32e4b0ba829ddb2$var$Fi,
    unstable_isNewReconciler: !1
};
function $c32e4b0ba829ddb2$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c32e4b0ba829ddb2$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c32e4b0ba829ddb2$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c32e4b0ba829ddb2$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c32e4b0ba829ddb2$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c32e4b0ba829ddb2$var$Oi(a, b, c) {
    c = $c32e4b0ba829ddb2$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c32e4b0ba829ddb2$var$Pi || ($c32e4b0ba829ddb2$var$Pi = !0, $c32e4b0ba829ddb2$var$Qi = d);
        $c32e4b0ba829ddb2$var$Mi(a, b);
    };
    return c;
}
function $c32e4b0ba829ddb2$var$Ri(a, b, c) {
    c = $c32e4b0ba829ddb2$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c32e4b0ba829ddb2$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c32e4b0ba829ddb2$var$Mi(a, b);
        "function" !== typeof d && (null === $c32e4b0ba829ddb2$var$Si ? $c32e4b0ba829ddb2$var$Si = new Set([
            this
        ]) : $c32e4b0ba829ddb2$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $c32e4b0ba829ddb2$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c32e4b0ba829ddb2$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c32e4b0ba829ddb2$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c32e4b0ba829ddb2$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c32e4b0ba829ddb2$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c32e4b0ba829ddb2$var$ch(-1, 1), b.tag = 2, $c32e4b0ba829ddb2$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c32e4b0ba829ddb2$var$Xi = $c32e4b0ba829ddb2$var$ua.ReactCurrentOwner, $c32e4b0ba829ddb2$var$Ug = !1;
function $c32e4b0ba829ddb2$var$Yi(a, b, c, d) {
    b.child = null === a ? $c32e4b0ba829ddb2$var$Ch(b, null, c, d) : $c32e4b0ba829ddb2$var$Bh(b, a.child, c, d);
}
function $c32e4b0ba829ddb2$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c32e4b0ba829ddb2$var$Tg(b, e);
    d = $c32e4b0ba829ddb2$var$Xh(a, b, c, d, f, e);
    c = $c32e4b0ba829ddb2$var$bi();
    if (null !== a && !$c32e4b0ba829ddb2$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c32e4b0ba829ddb2$var$$i(a, b, e);
    $c32e4b0ba829ddb2$var$I && c && $c32e4b0ba829ddb2$var$vg(b);
    b.flags |= 1;
    $c32e4b0ba829ddb2$var$Yi(a, b, d, e);
    return b.child;
}
function $c32e4b0ba829ddb2$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c32e4b0ba829ddb2$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c32e4b0ba829ddb2$var$cj(a, b, f, d, e);
        a = $c32e4b0ba829ddb2$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c32e4b0ba829ddb2$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c32e4b0ba829ddb2$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c32e4b0ba829ddb2$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c32e4b0ba829ddb2$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c32e4b0ba829ddb2$var$Ie(f, d) && a.ref === b.ref) {
            if ($c32e4b0ba829ddb2$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c32e4b0ba829ddb2$var$Ug = !0);
            else return b.lanes = a.lanes, $c32e4b0ba829ddb2$var$$i(a, b, e);
        }
    }
    return $c32e4b0ba829ddb2$var$dj(a, b, c, d, e);
}
function $c32e4b0ba829ddb2$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$fj, $c32e4b0ba829ddb2$var$gj), $c32e4b0ba829ddb2$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$fj, $c32e4b0ba829ddb2$var$gj), $c32e4b0ba829ddb2$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$fj, $c32e4b0ba829ddb2$var$gj);
            $c32e4b0ba829ddb2$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$fj, $c32e4b0ba829ddb2$var$gj), $c32e4b0ba829ddb2$var$gj |= d;
    $c32e4b0ba829ddb2$var$Yi(a, b, e, c);
    return b.child;
}
function $c32e4b0ba829ddb2$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c32e4b0ba829ddb2$var$dj(a, b, c, d, e) {
    var f = $c32e4b0ba829ddb2$var$Zf(c) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current;
    f = $c32e4b0ba829ddb2$var$Yf(b, f);
    $c32e4b0ba829ddb2$var$Tg(b, e);
    c = $c32e4b0ba829ddb2$var$Xh(a, b, c, d, f, e);
    d = $c32e4b0ba829ddb2$var$bi();
    if (null !== a && !$c32e4b0ba829ddb2$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c32e4b0ba829ddb2$var$$i(a, b, e);
    $c32e4b0ba829ddb2$var$I && d && $c32e4b0ba829ddb2$var$vg(b);
    b.flags |= 1;
    $c32e4b0ba829ddb2$var$Yi(a, b, c, e);
    return b.child;
}
function $c32e4b0ba829ddb2$var$ij(a, b, c, d, e) {
    if ($c32e4b0ba829ddb2$var$Zf(c)) {
        var f = !0;
        $c32e4b0ba829ddb2$var$cg(b);
    } else f = !1;
    $c32e4b0ba829ddb2$var$Tg(b, e);
    if (null === b.stateNode) $c32e4b0ba829ddb2$var$jj(a, b), $c32e4b0ba829ddb2$var$ph(b, c, d), $c32e4b0ba829ddb2$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c32e4b0ba829ddb2$var$Vg(l) : (l = $c32e4b0ba829ddb2$var$Zf(c) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current, l = $c32e4b0ba829ddb2$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c32e4b0ba829ddb2$var$qh(b, g, d, l);
        $c32e4b0ba829ddb2$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c32e4b0ba829ddb2$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c32e4b0ba829ddb2$var$Wf.current || $c32e4b0ba829ddb2$var$$g ? ("function" === typeof m && ($c32e4b0ba829ddb2$var$kh(b, c, m, d), k = b.memoizedState), (h = $c32e4b0ba829ddb2$var$$g || $c32e4b0ba829ddb2$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c32e4b0ba829ddb2$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c32e4b0ba829ddb2$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c32e4b0ba829ddb2$var$Vg(k) : (k = $c32e4b0ba829ddb2$var$Zf(c) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current, k = $c32e4b0ba829ddb2$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c32e4b0ba829ddb2$var$qh(b, g, d, k);
        $c32e4b0ba829ddb2$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c32e4b0ba829ddb2$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c32e4b0ba829ddb2$var$Wf.current || $c32e4b0ba829ddb2$var$$g ? ("function" === typeof y && ($c32e4b0ba829ddb2$var$kh(b, c, y, d), n = b.memoizedState), (l = $c32e4b0ba829ddb2$var$$g || $c32e4b0ba829ddb2$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c32e4b0ba829ddb2$var$kj(a, b, c, d, f, e);
}
function $c32e4b0ba829ddb2$var$kj(a, b, c, d, e, f) {
    $c32e4b0ba829ddb2$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c32e4b0ba829ddb2$var$dg(b, c, !1), $c32e4b0ba829ddb2$var$$i(a, b, f);
    d = b.stateNode;
    $c32e4b0ba829ddb2$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c32e4b0ba829ddb2$var$Bh(b, a.child, null, f), b.child = $c32e4b0ba829ddb2$var$Bh(b, null, h, f)) : $c32e4b0ba829ddb2$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c32e4b0ba829ddb2$var$dg(b, c, !0);
    return b.child;
}
function $c32e4b0ba829ddb2$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c32e4b0ba829ddb2$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c32e4b0ba829ddb2$var$ag(a, b.context, !1);
    $c32e4b0ba829ddb2$var$Ih(a, b.containerInfo);
}
function $c32e4b0ba829ddb2$var$mj(a, b, c, d, e) {
    $c32e4b0ba829ddb2$var$Ig();
    $c32e4b0ba829ddb2$var$Jg(e);
    b.flags |= 256;
    $c32e4b0ba829ddb2$var$Yi(a, b, c, d);
    return b.child;
}
var $c32e4b0ba829ddb2$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c32e4b0ba829ddb2$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c32e4b0ba829ddb2$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c32e4b0ba829ddb2$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$M, e & 1);
    if (null === a) {
        $c32e4b0ba829ddb2$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c32e4b0ba829ddb2$var$qj(g, d, 0, null), a = $c32e4b0ba829ddb2$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c32e4b0ba829ddb2$var$oj(c), b.memoizedState = $c32e4b0ba829ddb2$var$nj, a) : $c32e4b0ba829ddb2$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c32e4b0ba829ddb2$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c32e4b0ba829ddb2$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c32e4b0ba829ddb2$var$wh(h, f) : (f = $c32e4b0ba829ddb2$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c32e4b0ba829ddb2$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c32e4b0ba829ddb2$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c32e4b0ba829ddb2$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c32e4b0ba829ddb2$var$rj(a, b) {
    b = $c32e4b0ba829ddb2$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c32e4b0ba829ddb2$var$tj(a, b, c, d) {
    null !== d && $c32e4b0ba829ddb2$var$Jg(d);
    $c32e4b0ba829ddb2$var$Bh(b, a.child, null, c);
    a = $c32e4b0ba829ddb2$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c32e4b0ba829ddb2$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c32e4b0ba829ddb2$var$Li(Error($c32e4b0ba829ddb2$var$p(422))), $c32e4b0ba829ddb2$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c32e4b0ba829ddb2$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c32e4b0ba829ddb2$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c32e4b0ba829ddb2$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c32e4b0ba829ddb2$var$oj(g);
        b.memoizedState = $c32e4b0ba829ddb2$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c32e4b0ba829ddb2$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c32e4b0ba829ddb2$var$p(419));
        d = $c32e4b0ba829ddb2$var$Li(f, d, void 0);
        return $c32e4b0ba829ddb2$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c32e4b0ba829ddb2$var$Ug || h) {
        d = $c32e4b0ba829ddb2$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c32e4b0ba829ddb2$var$Zg(a, e), $c32e4b0ba829ddb2$var$mh(d, a, e, -1));
        }
        $c32e4b0ba829ddb2$var$uj();
        d = $c32e4b0ba829ddb2$var$Li(Error($c32e4b0ba829ddb2$var$p(421)));
        return $c32e4b0ba829ddb2$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c32e4b0ba829ddb2$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$Lf(e.nextSibling);
    $c32e4b0ba829ddb2$var$xg = b;
    $c32e4b0ba829ddb2$var$I = !0;
    $c32e4b0ba829ddb2$var$zg = null;
    null !== a && ($c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$rg, $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$sg, $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$qg, $c32e4b0ba829ddb2$var$rg = a.id, $c32e4b0ba829ddb2$var$sg = a.overflow, $c32e4b0ba829ddb2$var$qg = b);
    b = $c32e4b0ba829ddb2$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c32e4b0ba829ddb2$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c32e4b0ba829ddb2$var$Sg(a.return, b, c);
}
function $c32e4b0ba829ddb2$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c32e4b0ba829ddb2$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c32e4b0ba829ddb2$var$Yi(a, b, d.children, c);
    d = $c32e4b0ba829ddb2$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c32e4b0ba829ddb2$var$wj(a, c, b);
            else if (19 === a.tag) $c32e4b0ba829ddb2$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c32e4b0ba829ddb2$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c32e4b0ba829ddb2$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c32e4b0ba829ddb2$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c32e4b0ba829ddb2$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c32e4b0ba829ddb2$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c32e4b0ba829ddb2$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c32e4b0ba829ddb2$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c32e4b0ba829ddb2$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c32e4b0ba829ddb2$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c32e4b0ba829ddb2$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c32e4b0ba829ddb2$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c32e4b0ba829ddb2$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c32e4b0ba829ddb2$var$lj(b);
            $c32e4b0ba829ddb2$var$Ig();
            break;
        case 5:
            $c32e4b0ba829ddb2$var$Kh(b);
            break;
        case 1:
            $c32e4b0ba829ddb2$var$Zf(b.type) && $c32e4b0ba829ddb2$var$cg(b);
            break;
        case 4:
            $c32e4b0ba829ddb2$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$M, $c32e4b0ba829ddb2$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c32e4b0ba829ddb2$var$pj(a, b, c);
                $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$M, $c32e4b0ba829ddb2$var$M.current & 1);
                a = $c32e4b0ba829ddb2$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$M, $c32e4b0ba829ddb2$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c32e4b0ba829ddb2$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$M, $c32e4b0ba829ddb2$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c32e4b0ba829ddb2$var$ej(a, b, c);
    }
    return $c32e4b0ba829ddb2$var$$i(a, b, c);
}
var $c32e4b0ba829ddb2$var$Aj, $c32e4b0ba829ddb2$var$Bj, $c32e4b0ba829ddb2$var$Cj, $c32e4b0ba829ddb2$var$Dj;
$c32e4b0ba829ddb2$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c32e4b0ba829ddb2$var$Bj = function Bj() {};
$c32e4b0ba829ddb2$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c32e4b0ba829ddb2$var$Hh($c32e4b0ba829ddb2$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c32e4b0ba829ddb2$var$Ya(a, e);
                d = $c32e4b0ba829ddb2$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c32e4b0ba829ddb2$var$A({}, e, {
                    value: void 0
                });
                d = $c32e4b0ba829ddb2$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c32e4b0ba829ddb2$var$gb(a, e);
                d = $c32e4b0ba829ddb2$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c32e4b0ba829ddb2$var$Bf);
        }
        $c32e4b0ba829ddb2$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c32e4b0ba829ddb2$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c32e4b0ba829ddb2$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c32e4b0ba829ddb2$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c32e4b0ba829ddb2$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c32e4b0ba829ddb2$var$Ej(a, b) {
    if (!$c32e4b0ba829ddb2$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c32e4b0ba829ddb2$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c32e4b0ba829ddb2$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c32e4b0ba829ddb2$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c32e4b0ba829ddb2$var$S(b), null;
        case 1:
            return $c32e4b0ba829ddb2$var$Zf(b.type) && $c32e4b0ba829ddb2$var$$f(), $c32e4b0ba829ddb2$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c32e4b0ba829ddb2$var$Jh();
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf);
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H);
            $c32e4b0ba829ddb2$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c32e4b0ba829ddb2$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c32e4b0ba829ddb2$var$zg && ($c32e4b0ba829ddb2$var$Gj($c32e4b0ba829ddb2$var$zg), $c32e4b0ba829ddb2$var$zg = null));
            $c32e4b0ba829ddb2$var$Bj(a, b);
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 5:
            $c32e4b0ba829ddb2$var$Lh(b);
            var e = $c32e4b0ba829ddb2$var$Hh($c32e4b0ba829ddb2$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c32e4b0ba829ddb2$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c32e4b0ba829ddb2$var$p(166));
                    $c32e4b0ba829ddb2$var$S(b);
                    return null;
                }
                a = $c32e4b0ba829ddb2$var$Hh($c32e4b0ba829ddb2$var$Eh.current);
                if ($c32e4b0ba829ddb2$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c32e4b0ba829ddb2$var$Of] = b;
                    d[$c32e4b0ba829ddb2$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c32e4b0ba829ddb2$var$D("cancel", d);
                            $c32e4b0ba829ddb2$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c32e4b0ba829ddb2$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c32e4b0ba829ddb2$var$lf.length; e++)$c32e4b0ba829ddb2$var$D($c32e4b0ba829ddb2$var$lf[e], d);
                            break;
                        case "source":
                            $c32e4b0ba829ddb2$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c32e4b0ba829ddb2$var$D("error", d);
                            $c32e4b0ba829ddb2$var$D("load", d);
                            break;
                        case "details":
                            $c32e4b0ba829ddb2$var$D("toggle", d);
                            break;
                        case "input":
                            $c32e4b0ba829ddb2$var$Za(d, f);
                            $c32e4b0ba829ddb2$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c32e4b0ba829ddb2$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c32e4b0ba829ddb2$var$hb(d, f), $c32e4b0ba829ddb2$var$D("invalid", d);
                    }
                    $c32e4b0ba829ddb2$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c32e4b0ba829ddb2$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c32e4b0ba829ddb2$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c32e4b0ba829ddb2$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c32e4b0ba829ddb2$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c32e4b0ba829ddb2$var$Va(d);
                            $c32e4b0ba829ddb2$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c32e4b0ba829ddb2$var$Va(d);
                            $c32e4b0ba829ddb2$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c32e4b0ba829ddb2$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c32e4b0ba829ddb2$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c32e4b0ba829ddb2$var$Of] = b;
                    a[$c32e4b0ba829ddb2$var$Pf] = d;
                    $c32e4b0ba829ddb2$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c32e4b0ba829ddb2$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c32e4b0ba829ddb2$var$D("cancel", a);
                                $c32e4b0ba829ddb2$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c32e4b0ba829ddb2$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c32e4b0ba829ddb2$var$lf.length; e++)$c32e4b0ba829ddb2$var$D($c32e4b0ba829ddb2$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c32e4b0ba829ddb2$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c32e4b0ba829ddb2$var$D("error", a);
                                $c32e4b0ba829ddb2$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c32e4b0ba829ddb2$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c32e4b0ba829ddb2$var$Za(a, d);
                                e = $c32e4b0ba829ddb2$var$Ya(a, d);
                                $c32e4b0ba829ddb2$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c32e4b0ba829ddb2$var$A({}, d, {
                                    value: void 0
                                });
                                $c32e4b0ba829ddb2$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c32e4b0ba829ddb2$var$hb(a, d);
                                e = $c32e4b0ba829ddb2$var$gb(a, d);
                                $c32e4b0ba829ddb2$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c32e4b0ba829ddb2$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c32e4b0ba829ddb2$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c32e4b0ba829ddb2$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c32e4b0ba829ddb2$var$ob(a, k) : "number" === typeof k && $c32e4b0ba829ddb2$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c32e4b0ba829ddb2$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c32e4b0ba829ddb2$var$D("scroll", a) : null != k && $c32e4b0ba829ddb2$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c32e4b0ba829ddb2$var$Va(a);
                                $c32e4b0ba829ddb2$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c32e4b0ba829ddb2$var$Va(a);
                                $c32e4b0ba829ddb2$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c32e4b0ba829ddb2$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c32e4b0ba829ddb2$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c32e4b0ba829ddb2$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c32e4b0ba829ddb2$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c32e4b0ba829ddb2$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c32e4b0ba829ddb2$var$p(166));
                c = $c32e4b0ba829ddb2$var$Hh($c32e4b0ba829ddb2$var$Gh.current);
                $c32e4b0ba829ddb2$var$Hh($c32e4b0ba829ddb2$var$Eh.current);
                if ($c32e4b0ba829ddb2$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c32e4b0ba829ddb2$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c32e4b0ba829ddb2$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c32e4b0ba829ddb2$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c32e4b0ba829ddb2$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c32e4b0ba829ddb2$var$Of] = b, b.stateNode = d;
            }
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 13:
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c32e4b0ba829ddb2$var$I && null !== $c32e4b0ba829ddb2$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c32e4b0ba829ddb2$var$Hg(), $c32e4b0ba829ddb2$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c32e4b0ba829ddb2$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c32e4b0ba829ddb2$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c32e4b0ba829ddb2$var$p(317));
                        f[$c32e4b0ba829ddb2$var$Of] = b;
                    } else $c32e4b0ba829ddb2$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c32e4b0ba829ddb2$var$S(b);
                    f = !1;
                } else null !== $c32e4b0ba829ddb2$var$zg && ($c32e4b0ba829ddb2$var$Gj($c32e4b0ba829ddb2$var$zg), $c32e4b0ba829ddb2$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c32e4b0ba829ddb2$var$M.current & 1) ? 0 === $c32e4b0ba829ddb2$var$T && ($c32e4b0ba829ddb2$var$T = 3) : $c32e4b0ba829ddb2$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 4:
            return $c32e4b0ba829ddb2$var$Jh(), $c32e4b0ba829ddb2$var$Bj(a, b), null === a && $c32e4b0ba829ddb2$var$sf(b.stateNode.containerInfo), $c32e4b0ba829ddb2$var$S(b), null;
        case 10:
            return $c32e4b0ba829ddb2$var$Rg(b.type._context), $c32e4b0ba829ddb2$var$S(b), null;
        case 17:
            return $c32e4b0ba829ddb2$var$Zf(b.type) && $c32e4b0ba829ddb2$var$$f(), $c32e4b0ba829ddb2$var$S(b), null;
        case 19:
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$M);
            f = b.memoizedState;
            if (null === f) return $c32e4b0ba829ddb2$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c32e4b0ba829ddb2$var$Ej(f, !1);
                else {
                    if (0 !== $c32e4b0ba829ddb2$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c32e4b0ba829ddb2$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c32e4b0ba829ddb2$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$M, $c32e4b0ba829ddb2$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c32e4b0ba829ddb2$var$B() > $c32e4b0ba829ddb2$var$Hj && (b.flags |= 128, d = !0, $c32e4b0ba829ddb2$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c32e4b0ba829ddb2$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c32e4b0ba829ddb2$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c32e4b0ba829ddb2$var$I) return $c32e4b0ba829ddb2$var$S(b), null;
                    } else 2 * $c32e4b0ba829ddb2$var$B() - f.renderingStartTime > $c32e4b0ba829ddb2$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c32e4b0ba829ddb2$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c32e4b0ba829ddb2$var$B(), b.sibling = null, c = $c32e4b0ba829ddb2$var$M.current, $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$M, d ? c & 1 | 2 : c & 1), b;
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 22:
        case 23:
            return $c32e4b0ba829ddb2$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c32e4b0ba829ddb2$var$gj & 1073741824) && ($c32e4b0ba829ddb2$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c32e4b0ba829ddb2$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c32e4b0ba829ddb2$var$p(156, b.tag));
}
function $c32e4b0ba829ddb2$var$Jj(a, b) {
    $c32e4b0ba829ddb2$var$wg(b);
    switch(b.tag){
        case 1:
            return $c32e4b0ba829ddb2$var$Zf(b.type) && $c32e4b0ba829ddb2$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c32e4b0ba829ddb2$var$Jh(), $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf), $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H), $c32e4b0ba829ddb2$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c32e4b0ba829ddb2$var$Lh(b), null;
        case 13:
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c32e4b0ba829ddb2$var$p(340));
                $c32e4b0ba829ddb2$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$M), null;
        case 4:
            return $c32e4b0ba829ddb2$var$Jh(), null;
        case 10:
            return $c32e4b0ba829ddb2$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c32e4b0ba829ddb2$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c32e4b0ba829ddb2$var$Kj = !1, $c32e4b0ba829ddb2$var$U = !1, $c32e4b0ba829ddb2$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c32e4b0ba829ddb2$var$V = null;
function $c32e4b0ba829ddb2$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c32e4b0ba829ddb2$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c32e4b0ba829ddb2$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c32e4b0ba829ddb2$var$W(a, b, d);
    }
}
var $c32e4b0ba829ddb2$var$Oj = !1;
function $c32e4b0ba829ddb2$var$Pj(a, b) {
    $c32e4b0ba829ddb2$var$Cf = $c32e4b0ba829ddb2$var$dd;
    a = $c32e4b0ba829ddb2$var$Me();
    if ($c32e4b0ba829ddb2$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c32e4b0ba829ddb2$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c32e4b0ba829ddb2$var$dd = !1;
    for($c32e4b0ba829ddb2$var$V = b; null !== $c32e4b0ba829ddb2$var$V;)if (b = $c32e4b0ba829ddb2$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c32e4b0ba829ddb2$var$V = a;
    else for(; null !== $c32e4b0ba829ddb2$var$V;){
        b = $c32e4b0ba829ddb2$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c32e4b0ba829ddb2$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c32e4b0ba829ddb2$var$p(163));
            }
        } catch (F) {
            $c32e4b0ba829ddb2$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c32e4b0ba829ddb2$var$V = a;
            break;
        }
        $c32e4b0ba829ddb2$var$V = b.return;
    }
    n = $c32e4b0ba829ddb2$var$Oj;
    $c32e4b0ba829ddb2$var$Oj = !1;
    return n;
}
function $c32e4b0ba829ddb2$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c32e4b0ba829ddb2$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c32e4b0ba829ddb2$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c32e4b0ba829ddb2$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c32e4b0ba829ddb2$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c32e4b0ba829ddb2$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c32e4b0ba829ddb2$var$Of], delete b[$c32e4b0ba829ddb2$var$Pf], delete b[$c32e4b0ba829ddb2$var$of], delete b[$c32e4b0ba829ddb2$var$Qf], delete b[$c32e4b0ba829ddb2$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c32e4b0ba829ddb2$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c32e4b0ba829ddb2$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c32e4b0ba829ddb2$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c32e4b0ba829ddb2$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c32e4b0ba829ddb2$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c32e4b0ba829ddb2$var$Wj(a, b, c), a = a.sibling; null !== a;)$c32e4b0ba829ddb2$var$Wj(a, b, c), a = a.sibling;
}
function $c32e4b0ba829ddb2$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c32e4b0ba829ddb2$var$Xj(a, b, c), a = a.sibling; null !== a;)$c32e4b0ba829ddb2$var$Xj(a, b, c), a = a.sibling;
}
var $c32e4b0ba829ddb2$var$X = null, $c32e4b0ba829ddb2$var$Yj = !1;
function $c32e4b0ba829ddb2$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c32e4b0ba829ddb2$var$ak(a, b, c), c = c.sibling;
}
function $c32e4b0ba829ddb2$var$ak(a, b, c) {
    if ($c32e4b0ba829ddb2$var$lc && "function" === typeof $c32e4b0ba829ddb2$var$lc.onCommitFiberUnmount) try {
        $c32e4b0ba829ddb2$var$lc.onCommitFiberUnmount($c32e4b0ba829ddb2$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c32e4b0ba829ddb2$var$U || $c32e4b0ba829ddb2$var$Mj(c, b);
        case 6:
            var d = $c32e4b0ba829ddb2$var$X, e = $c32e4b0ba829ddb2$var$Yj;
            $c32e4b0ba829ddb2$var$X = null;
            $c32e4b0ba829ddb2$var$Zj(a, b, c);
            $c32e4b0ba829ddb2$var$X = d;
            $c32e4b0ba829ddb2$var$Yj = e;
            null !== $c32e4b0ba829ddb2$var$X && ($c32e4b0ba829ddb2$var$Yj ? (a = $c32e4b0ba829ddb2$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c32e4b0ba829ddb2$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c32e4b0ba829ddb2$var$X && ($c32e4b0ba829ddb2$var$Yj ? (a = $c32e4b0ba829ddb2$var$X, c = c.stateNode, 8 === a.nodeType ? $c32e4b0ba829ddb2$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c32e4b0ba829ddb2$var$Kf(a, c), $c32e4b0ba829ddb2$var$bd(a)) : $c32e4b0ba829ddb2$var$Kf($c32e4b0ba829ddb2$var$X, c.stateNode));
            break;
        case 4:
            d = $c32e4b0ba829ddb2$var$X;
            e = $c32e4b0ba829ddb2$var$Yj;
            $c32e4b0ba829ddb2$var$X = c.stateNode.containerInfo;
            $c32e4b0ba829ddb2$var$Yj = !0;
            $c32e4b0ba829ddb2$var$Zj(a, b, c);
            $c32e4b0ba829ddb2$var$X = d;
            $c32e4b0ba829ddb2$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c32e4b0ba829ddb2$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c32e4b0ba829ddb2$var$Nj(c, b, g) : 0 !== (f & 4) && $c32e4b0ba829ddb2$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c32e4b0ba829ddb2$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c32e4b0ba829ddb2$var$U && ($c32e4b0ba829ddb2$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c32e4b0ba829ddb2$var$W(c, b, h);
            }
            $c32e4b0ba829ddb2$var$Zj(a, b, c);
            break;
        case 21:
            $c32e4b0ba829ddb2$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c32e4b0ba829ddb2$var$U = (d = $c32e4b0ba829ddb2$var$U) || null !== c.memoizedState, $c32e4b0ba829ddb2$var$Zj(a, b, c), $c32e4b0ba829ddb2$var$U = d) : $c32e4b0ba829ddb2$var$Zj(a, b, c);
            break;
        default:
            $c32e4b0ba829ddb2$var$Zj(a, b, c);
    }
}
function $c32e4b0ba829ddb2$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c32e4b0ba829ddb2$var$Lj);
        b.forEach(function(b) {
            var d = $c32e4b0ba829ddb2$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c32e4b0ba829ddb2$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c32e4b0ba829ddb2$var$X = h.stateNode;
                        $c32e4b0ba829ddb2$var$Yj = !1;
                        break a;
                    case 3:
                        $c32e4b0ba829ddb2$var$X = h.stateNode.containerInfo;
                        $c32e4b0ba829ddb2$var$Yj = !0;
                        break a;
                    case 4:
                        $c32e4b0ba829ddb2$var$X = h.stateNode.containerInfo;
                        $c32e4b0ba829ddb2$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c32e4b0ba829ddb2$var$X) throw Error($c32e4b0ba829ddb2$var$p(160));
            $c32e4b0ba829ddb2$var$ak(f, g, e);
            $c32e4b0ba829ddb2$var$X = null;
            $c32e4b0ba829ddb2$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c32e4b0ba829ddb2$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c32e4b0ba829ddb2$var$ek(b, a), b = b.sibling;
}
function $c32e4b0ba829ddb2$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            if (d & 4) {
                try {
                    $c32e4b0ba829ddb2$var$Qj(3, a, a.return), $c32e4b0ba829ddb2$var$Rj(3, a);
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
                try {
                    $c32e4b0ba829ddb2$var$Qj(5, a, a.return);
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            d & 512 && null !== c && $c32e4b0ba829ddb2$var$Mj(c, c.return);
            break;
        case 5:
            $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            d & 512 && null !== c && $c32e4b0ba829ddb2$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c32e4b0ba829ddb2$var$ob(e, "");
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c32e4b0ba829ddb2$var$ab(e, f);
                    $c32e4b0ba829ddb2$var$vb(h, g);
                    var l = $c32e4b0ba829ddb2$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c32e4b0ba829ddb2$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c32e4b0ba829ddb2$var$nb(e, q) : "children" === m ? $c32e4b0ba829ddb2$var$ob(e, q) : $c32e4b0ba829ddb2$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c32e4b0ba829ddb2$var$bb(e, f);
                            break;
                        case "textarea":
                            $c32e4b0ba829ddb2$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c32e4b0ba829ddb2$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c32e4b0ba829ddb2$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c32e4b0ba829ddb2$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c32e4b0ba829ddb2$var$Pf] = f;
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c32e4b0ba829ddb2$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c32e4b0ba829ddb2$var$bd(b.containerInfo);
            } catch (t) {
                $c32e4b0ba829ddb2$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            break;
        case 13:
            $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c32e4b0ba829ddb2$var$gk = $c32e4b0ba829ddb2$var$B()));
            d & 4 && $c32e4b0ba829ddb2$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c32e4b0ba829ddb2$var$U = (l = $c32e4b0ba829ddb2$var$U) || m, $c32e4b0ba829ddb2$var$dk(b, a), $c32e4b0ba829ddb2$var$U = l) : $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c32e4b0ba829ddb2$var$V = a, m = a.child; null !== m;){
                    for(q = $c32e4b0ba829ddb2$var$V = m; null !== $c32e4b0ba829ddb2$var$V;){
                        r = $c32e4b0ba829ddb2$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c32e4b0ba829ddb2$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c32e4b0ba829ddb2$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c32e4b0ba829ddb2$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c32e4b0ba829ddb2$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c32e4b0ba829ddb2$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c32e4b0ba829ddb2$var$V = y) : $c32e4b0ba829ddb2$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c32e4b0ba829ddb2$var$rb("display", g));
                            } catch (t) {
                                $c32e4b0ba829ddb2$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c32e4b0ba829ddb2$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c32e4b0ba829ddb2$var$dk(b, a);
            $c32e4b0ba829ddb2$var$fk(a);
            d & 4 && $c32e4b0ba829ddb2$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c32e4b0ba829ddb2$var$dk(b, a), $c32e4b0ba829ddb2$var$fk(a);
    }
}
function $c32e4b0ba829ddb2$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c32e4b0ba829ddb2$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c32e4b0ba829ddb2$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c32e4b0ba829ddb2$var$ob(e, ""), d.flags &= -33);
                    var f = $c32e4b0ba829ddb2$var$Vj(a);
                    $c32e4b0ba829ddb2$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c32e4b0ba829ddb2$var$Vj(a);
                    $c32e4b0ba829ddb2$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c32e4b0ba829ddb2$var$p(161));
            }
        } catch (k) {
            $c32e4b0ba829ddb2$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c32e4b0ba829ddb2$var$ik(a, b, c) {
    $c32e4b0ba829ddb2$var$V = a;
    $c32e4b0ba829ddb2$var$jk(a, b, c);
}
function $c32e4b0ba829ddb2$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c32e4b0ba829ddb2$var$V;){
        var e = $c32e4b0ba829ddb2$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c32e4b0ba829ddb2$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c32e4b0ba829ddb2$var$U;
                h = $c32e4b0ba829ddb2$var$Kj;
                var l = $c32e4b0ba829ddb2$var$U;
                $c32e4b0ba829ddb2$var$Kj = g;
                if (($c32e4b0ba829ddb2$var$U = k) && !l) for($c32e4b0ba829ddb2$var$V = e; null !== $c32e4b0ba829ddb2$var$V;)g = $c32e4b0ba829ddb2$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c32e4b0ba829ddb2$var$kk(e) : null !== k ? (k.return = g, $c32e4b0ba829ddb2$var$V = k) : $c32e4b0ba829ddb2$var$kk(e);
                for(; null !== f;)$c32e4b0ba829ddb2$var$V = f, $c32e4b0ba829ddb2$var$jk(f, b, c), f = f.sibling;
                $c32e4b0ba829ddb2$var$V = e;
                $c32e4b0ba829ddb2$var$Kj = h;
                $c32e4b0ba829ddb2$var$U = l;
            }
            $c32e4b0ba829ddb2$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c32e4b0ba829ddb2$var$V = f) : $c32e4b0ba829ddb2$var$lk(a, b, c);
    }
}
function $c32e4b0ba829ddb2$var$lk(a) {
    for(; null !== $c32e4b0ba829ddb2$var$V;){
        var b = $c32e4b0ba829ddb2$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c32e4b0ba829ddb2$var$U || $c32e4b0ba829ddb2$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c32e4b0ba829ddb2$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c32e4b0ba829ddb2$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c32e4b0ba829ddb2$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c32e4b0ba829ddb2$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c32e4b0ba829ddb2$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c32e4b0ba829ddb2$var$p(163));
                }
                $c32e4b0ba829ddb2$var$U || b.flags & 512 && $c32e4b0ba829ddb2$var$Sj(b);
            } catch (r) {
                $c32e4b0ba829ddb2$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c32e4b0ba829ddb2$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c32e4b0ba829ddb2$var$V = c;
            break;
        }
        $c32e4b0ba829ddb2$var$V = b.return;
    }
}
function $c32e4b0ba829ddb2$var$hk(a) {
    for(; null !== $c32e4b0ba829ddb2$var$V;){
        var b = $c32e4b0ba829ddb2$var$V;
        if (b === a) {
            $c32e4b0ba829ddb2$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c32e4b0ba829ddb2$var$V = c;
            break;
        }
        $c32e4b0ba829ddb2$var$V = b.return;
    }
}
function $c32e4b0ba829ddb2$var$kk(a) {
    for(; null !== $c32e4b0ba829ddb2$var$V;){
        var b = $c32e4b0ba829ddb2$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c32e4b0ba829ddb2$var$Rj(4, b);
                    } catch (k) {
                        $c32e4b0ba829ddb2$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c32e4b0ba829ddb2$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c32e4b0ba829ddb2$var$Sj(b);
                    } catch (k) {
                        $c32e4b0ba829ddb2$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c32e4b0ba829ddb2$var$Sj(b);
                    } catch (k) {
                        $c32e4b0ba829ddb2$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c32e4b0ba829ddb2$var$W(b, b.return, k);
        }
        if (b === a) {
            $c32e4b0ba829ddb2$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c32e4b0ba829ddb2$var$V = h;
            break;
        }
        $c32e4b0ba829ddb2$var$V = b.return;
    }
}
var $c32e4b0ba829ddb2$var$mk = Math.ceil, $c32e4b0ba829ddb2$var$nk = $c32e4b0ba829ddb2$var$ua.ReactCurrentDispatcher, $c32e4b0ba829ddb2$var$ok = $c32e4b0ba829ddb2$var$ua.ReactCurrentOwner, $c32e4b0ba829ddb2$var$pk = $c32e4b0ba829ddb2$var$ua.ReactCurrentBatchConfig, $c32e4b0ba829ddb2$var$K = 0, $c32e4b0ba829ddb2$var$R = null, $c32e4b0ba829ddb2$var$Y = null, $c32e4b0ba829ddb2$var$Z = 0, $c32e4b0ba829ddb2$var$gj = 0, $c32e4b0ba829ddb2$var$fj = $c32e4b0ba829ddb2$var$Uf(0), $c32e4b0ba829ddb2$var$T = 0, $c32e4b0ba829ddb2$var$qk = null, $c32e4b0ba829ddb2$var$hh = 0, $c32e4b0ba829ddb2$var$rk = 0, $c32e4b0ba829ddb2$var$sk = 0, $c32e4b0ba829ddb2$var$tk = null, $c32e4b0ba829ddb2$var$uk = null, $c32e4b0ba829ddb2$var$gk = 0, $c32e4b0ba829ddb2$var$Hj = Infinity, $c32e4b0ba829ddb2$var$vk = null, $c32e4b0ba829ddb2$var$Pi = !1, $c32e4b0ba829ddb2$var$Qi = null, $c32e4b0ba829ddb2$var$Si = null, $c32e4b0ba829ddb2$var$wk = !1, $c32e4b0ba829ddb2$var$xk = null, $c32e4b0ba829ddb2$var$yk = 0, $c32e4b0ba829ddb2$var$zk = 0, $c32e4b0ba829ddb2$var$Ak = null, $c32e4b0ba829ddb2$var$Bk = -1, $c32e4b0ba829ddb2$var$Ck = 0;
function $c32e4b0ba829ddb2$var$L() {
    return 0 !== ($c32e4b0ba829ddb2$var$K & 6) ? $c32e4b0ba829ddb2$var$B() : -1 !== $c32e4b0ba829ddb2$var$Bk ? $c32e4b0ba829ddb2$var$Bk : $c32e4b0ba829ddb2$var$Bk = $c32e4b0ba829ddb2$var$B();
}
function $c32e4b0ba829ddb2$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c32e4b0ba829ddb2$var$K & 2) && 0 !== $c32e4b0ba829ddb2$var$Z) return $c32e4b0ba829ddb2$var$Z & -$c32e4b0ba829ddb2$var$Z;
    if (null !== $c32e4b0ba829ddb2$var$Kg.transition) return 0 === $c32e4b0ba829ddb2$var$Ck && ($c32e4b0ba829ddb2$var$Ck = $c32e4b0ba829ddb2$var$yc()), $c32e4b0ba829ddb2$var$Ck;
    a = $c32e4b0ba829ddb2$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c32e4b0ba829ddb2$var$jd(a.type);
    return a;
}
function $c32e4b0ba829ddb2$var$mh(a, b, c, d) {
    if (50 < $c32e4b0ba829ddb2$var$zk) throw $c32e4b0ba829ddb2$var$zk = 0, $c32e4b0ba829ddb2$var$Ak = null, Error($c32e4b0ba829ddb2$var$p(185));
    $c32e4b0ba829ddb2$var$Ac(a, c, d);
    if (0 === ($c32e4b0ba829ddb2$var$K & 2) || a !== $c32e4b0ba829ddb2$var$R) a === $c32e4b0ba829ddb2$var$R && (0 === ($c32e4b0ba829ddb2$var$K & 2) && ($c32e4b0ba829ddb2$var$rk |= c), 4 === $c32e4b0ba829ddb2$var$T && $c32e4b0ba829ddb2$var$Dk(a, $c32e4b0ba829ddb2$var$Z)), $c32e4b0ba829ddb2$var$Ek(a, d), 1 === c && 0 === $c32e4b0ba829ddb2$var$K && 0 === (b.mode & 1) && ($c32e4b0ba829ddb2$var$Hj = $c32e4b0ba829ddb2$var$B() + 500, $c32e4b0ba829ddb2$var$fg && $c32e4b0ba829ddb2$var$jg());
}
function $c32e4b0ba829ddb2$var$Ek(a, b) {
    var c = a.callbackNode;
    $c32e4b0ba829ddb2$var$wc(a, b);
    var d = $c32e4b0ba829ddb2$var$uc(a, a === $c32e4b0ba829ddb2$var$R ? $c32e4b0ba829ddb2$var$Z : 0);
    if (0 === d) null !== c && $c32e4b0ba829ddb2$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c32e4b0ba829ddb2$var$bc(c);
        if (1 === b) 0 === a.tag ? $c32e4b0ba829ddb2$var$ig($c32e4b0ba829ddb2$var$Fk.bind(null, a)) : $c32e4b0ba829ddb2$var$hg($c32e4b0ba829ddb2$var$Fk.bind(null, a)), $c32e4b0ba829ddb2$var$Jf(function() {
            0 === ($c32e4b0ba829ddb2$var$K & 6) && $c32e4b0ba829ddb2$var$jg();
        }), c = null;
        else {
            switch($c32e4b0ba829ddb2$var$Dc(d)){
                case 1:
                    c = $c32e4b0ba829ddb2$var$fc;
                    break;
                case 4:
                    c = $c32e4b0ba829ddb2$var$gc;
                    break;
                case 16:
                    c = $c32e4b0ba829ddb2$var$hc;
                    break;
                case 536870912:
                    c = $c32e4b0ba829ddb2$var$jc;
                    break;
                default:
                    c = $c32e4b0ba829ddb2$var$hc;
            }
            c = $c32e4b0ba829ddb2$var$Gk(c, $c32e4b0ba829ddb2$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c32e4b0ba829ddb2$var$Hk(a, b) {
    $c32e4b0ba829ddb2$var$Bk = -1;
    $c32e4b0ba829ddb2$var$Ck = 0;
    if (0 !== ($c32e4b0ba829ddb2$var$K & 6)) throw Error($c32e4b0ba829ddb2$var$p(327));
    var c = a.callbackNode;
    if ($c32e4b0ba829ddb2$var$Ik() && a.callbackNode !== c) return null;
    var d = $c32e4b0ba829ddb2$var$uc(a, a === $c32e4b0ba829ddb2$var$R ? $c32e4b0ba829ddb2$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c32e4b0ba829ddb2$var$Jk(a, d);
    else {
        b = d;
        var e = $c32e4b0ba829ddb2$var$K;
        $c32e4b0ba829ddb2$var$K |= 2;
        var f = $c32e4b0ba829ddb2$var$Kk();
        if ($c32e4b0ba829ddb2$var$R !== a || $c32e4b0ba829ddb2$var$Z !== b) $c32e4b0ba829ddb2$var$vk = null, $c32e4b0ba829ddb2$var$Hj = $c32e4b0ba829ddb2$var$B() + 500, $c32e4b0ba829ddb2$var$Lk(a, b);
        for(;;)try {
            $c32e4b0ba829ddb2$var$Mk();
            break;
        } catch (h) {
            $c32e4b0ba829ddb2$var$Nk(a, h);
        }
        $c32e4b0ba829ddb2$var$Qg();
        $c32e4b0ba829ddb2$var$nk.current = f;
        $c32e4b0ba829ddb2$var$K = e;
        null !== $c32e4b0ba829ddb2$var$Y ? b = 0 : ($c32e4b0ba829ddb2$var$R = null, $c32e4b0ba829ddb2$var$Z = 0, b = $c32e4b0ba829ddb2$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c32e4b0ba829ddb2$var$xc(a), 0 !== e && (d = e, b = $c32e4b0ba829ddb2$var$Ok(a, e)));
        if (1 === b) throw c = $c32e4b0ba829ddb2$var$qk, $c32e4b0ba829ddb2$var$Lk(a, 0), $c32e4b0ba829ddb2$var$Dk(a, d), $c32e4b0ba829ddb2$var$Ek(a, $c32e4b0ba829ddb2$var$B()), c;
        if (6 === b) $c32e4b0ba829ddb2$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c32e4b0ba829ddb2$var$Pk(e) && (b = $c32e4b0ba829ddb2$var$Jk(a, d), 2 === b && (f = $c32e4b0ba829ddb2$var$xc(a), 0 !== f && (d = f, b = $c32e4b0ba829ddb2$var$Ok(a, f))), 1 === b)) throw c = $c32e4b0ba829ddb2$var$qk, $c32e4b0ba829ddb2$var$Lk(a, 0), $c32e4b0ba829ddb2$var$Dk(a, d), $c32e4b0ba829ddb2$var$Ek(a, $c32e4b0ba829ddb2$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c32e4b0ba829ddb2$var$p(345));
                case 2:
                    $c32e4b0ba829ddb2$var$Qk(a, $c32e4b0ba829ddb2$var$uk, $c32e4b0ba829ddb2$var$vk);
                    break;
                case 3:
                    $c32e4b0ba829ddb2$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c32e4b0ba829ddb2$var$gk + 500 - $c32e4b0ba829ddb2$var$B(), 10 < b)) {
                        if (0 !== $c32e4b0ba829ddb2$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c32e4b0ba829ddb2$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c32e4b0ba829ddb2$var$Ff($c32e4b0ba829ddb2$var$Qk.bind(null, a, $c32e4b0ba829ddb2$var$uk, $c32e4b0ba829ddb2$var$vk), b);
                        break;
                    }
                    $c32e4b0ba829ddb2$var$Qk(a, $c32e4b0ba829ddb2$var$uk, $c32e4b0ba829ddb2$var$vk);
                    break;
                case 4:
                    $c32e4b0ba829ddb2$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c32e4b0ba829ddb2$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c32e4b0ba829ddb2$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c32e4b0ba829ddb2$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c32e4b0ba829ddb2$var$Ff($c32e4b0ba829ddb2$var$Qk.bind(null, a, $c32e4b0ba829ddb2$var$uk, $c32e4b0ba829ddb2$var$vk), d);
                        break;
                    }
                    $c32e4b0ba829ddb2$var$Qk(a, $c32e4b0ba829ddb2$var$uk, $c32e4b0ba829ddb2$var$vk);
                    break;
                case 5:
                    $c32e4b0ba829ddb2$var$Qk(a, $c32e4b0ba829ddb2$var$uk, $c32e4b0ba829ddb2$var$vk);
                    break;
                default:
                    throw Error($c32e4b0ba829ddb2$var$p(329));
            }
        }
    }
    $c32e4b0ba829ddb2$var$Ek(a, $c32e4b0ba829ddb2$var$B());
    return a.callbackNode === c ? $c32e4b0ba829ddb2$var$Hk.bind(null, a) : null;
}
function $c32e4b0ba829ddb2$var$Ok(a, b) {
    var c = $c32e4b0ba829ddb2$var$tk;
    a.current.memoizedState.isDehydrated && ($c32e4b0ba829ddb2$var$Lk(a, b).flags |= 256);
    a = $c32e4b0ba829ddb2$var$Jk(a, b);
    2 !== a && (b = $c32e4b0ba829ddb2$var$uk, $c32e4b0ba829ddb2$var$uk = c, null !== b && $c32e4b0ba829ddb2$var$Gj(b));
    return a;
}
function $c32e4b0ba829ddb2$var$Gj(a) {
    null === $c32e4b0ba829ddb2$var$uk ? $c32e4b0ba829ddb2$var$uk = a : $c32e4b0ba829ddb2$var$uk.push.apply($c32e4b0ba829ddb2$var$uk, a);
}
function $c32e4b0ba829ddb2$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c32e4b0ba829ddb2$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c32e4b0ba829ddb2$var$Dk(a, b) {
    b &= ~$c32e4b0ba829ddb2$var$sk;
    b &= ~$c32e4b0ba829ddb2$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c32e4b0ba829ddb2$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c32e4b0ba829ddb2$var$Fk(a) {
    if (0 !== ($c32e4b0ba829ddb2$var$K & 6)) throw Error($c32e4b0ba829ddb2$var$p(327));
    $c32e4b0ba829ddb2$var$Ik();
    var b = $c32e4b0ba829ddb2$var$uc(a, 0);
    if (0 === (b & 1)) return $c32e4b0ba829ddb2$var$Ek(a, $c32e4b0ba829ddb2$var$B()), null;
    var c = $c32e4b0ba829ddb2$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c32e4b0ba829ddb2$var$xc(a);
        0 !== d && (b = d, c = $c32e4b0ba829ddb2$var$Ok(a, d));
    }
    if (1 === c) throw c = $c32e4b0ba829ddb2$var$qk, $c32e4b0ba829ddb2$var$Lk(a, 0), $c32e4b0ba829ddb2$var$Dk(a, b), $c32e4b0ba829ddb2$var$Ek(a, $c32e4b0ba829ddb2$var$B()), c;
    if (6 === c) throw Error($c32e4b0ba829ddb2$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c32e4b0ba829ddb2$var$Qk(a, $c32e4b0ba829ddb2$var$uk, $c32e4b0ba829ddb2$var$vk);
    $c32e4b0ba829ddb2$var$Ek(a, $c32e4b0ba829ddb2$var$B());
    return null;
}
function $c32e4b0ba829ddb2$var$Rk(a, b) {
    var c = $c32e4b0ba829ddb2$var$K;
    $c32e4b0ba829ddb2$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c32e4b0ba829ddb2$var$K = c, 0 === $c32e4b0ba829ddb2$var$K && ($c32e4b0ba829ddb2$var$Hj = $c32e4b0ba829ddb2$var$B() + 500, $c32e4b0ba829ddb2$var$fg && $c32e4b0ba829ddb2$var$jg());
    }
}
function $c32e4b0ba829ddb2$var$Sk(a) {
    null !== $c32e4b0ba829ddb2$var$xk && 0 === $c32e4b0ba829ddb2$var$xk.tag && 0 === ($c32e4b0ba829ddb2$var$K & 6) && $c32e4b0ba829ddb2$var$Ik();
    var b = $c32e4b0ba829ddb2$var$K;
    $c32e4b0ba829ddb2$var$K |= 1;
    var c = $c32e4b0ba829ddb2$var$pk.transition, d = $c32e4b0ba829ddb2$var$C;
    try {
        if ($c32e4b0ba829ddb2$var$pk.transition = null, $c32e4b0ba829ddb2$var$C = 1, a) return a();
    } finally{
        $c32e4b0ba829ddb2$var$C = d, $c32e4b0ba829ddb2$var$pk.transition = c, $c32e4b0ba829ddb2$var$K = b, 0 === ($c32e4b0ba829ddb2$var$K & 6) && $c32e4b0ba829ddb2$var$jg();
    }
}
function $c32e4b0ba829ddb2$var$Ij() {
    $c32e4b0ba829ddb2$var$gj = $c32e4b0ba829ddb2$var$fj.current;
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$fj);
}
function $c32e4b0ba829ddb2$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c32e4b0ba829ddb2$var$Gf(c));
    if (null !== $c32e4b0ba829ddb2$var$Y) for(c = $c32e4b0ba829ddb2$var$Y.return; null !== c;){
        var d = c;
        $c32e4b0ba829ddb2$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c32e4b0ba829ddb2$var$$f();
                break;
            case 3:
                $c32e4b0ba829ddb2$var$Jh();
                $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf);
                $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H);
                $c32e4b0ba829ddb2$var$Oh();
                break;
            case 5:
                $c32e4b0ba829ddb2$var$Lh(d);
                break;
            case 4:
                $c32e4b0ba829ddb2$var$Jh();
                break;
            case 13:
                $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$M);
                break;
            case 19:
                $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$M);
                break;
            case 10:
                $c32e4b0ba829ddb2$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c32e4b0ba829ddb2$var$Ij();
        }
        c = c.return;
    }
    $c32e4b0ba829ddb2$var$R = a;
    $c32e4b0ba829ddb2$var$Y = a = $c32e4b0ba829ddb2$var$wh(a.current, null);
    $c32e4b0ba829ddb2$var$Z = $c32e4b0ba829ddb2$var$gj = b;
    $c32e4b0ba829ddb2$var$T = 0;
    $c32e4b0ba829ddb2$var$qk = null;
    $c32e4b0ba829ddb2$var$sk = $c32e4b0ba829ddb2$var$rk = $c32e4b0ba829ddb2$var$hh = 0;
    $c32e4b0ba829ddb2$var$uk = $c32e4b0ba829ddb2$var$tk = null;
    if (null !== $c32e4b0ba829ddb2$var$Wg) {
        for(b = 0; b < $c32e4b0ba829ddb2$var$Wg.length; b++)if (c = $c32e4b0ba829ddb2$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c32e4b0ba829ddb2$var$Wg = null;
    }
    return a;
}
function $c32e4b0ba829ddb2$var$Nk(a, b) {
    do {
        var c = $c32e4b0ba829ddb2$var$Y;
        try {
            $c32e4b0ba829ddb2$var$Qg();
            $c32e4b0ba829ddb2$var$Ph.current = $c32e4b0ba829ddb2$var$ai;
            if ($c32e4b0ba829ddb2$var$Sh) {
                for(var d = $c32e4b0ba829ddb2$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c32e4b0ba829ddb2$var$Sh = !1;
            }
            $c32e4b0ba829ddb2$var$Rh = 0;
            $c32e4b0ba829ddb2$var$P = $c32e4b0ba829ddb2$var$O = $c32e4b0ba829ddb2$var$N = null;
            $c32e4b0ba829ddb2$var$Th = !1;
            $c32e4b0ba829ddb2$var$Uh = 0;
            $c32e4b0ba829ddb2$var$ok.current = null;
            if (null === c || null === c.return) {
                $c32e4b0ba829ddb2$var$T = 1;
                $c32e4b0ba829ddb2$var$qk = b;
                $c32e4b0ba829ddb2$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c32e4b0ba829ddb2$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c32e4b0ba829ddb2$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c32e4b0ba829ddb2$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c32e4b0ba829ddb2$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c32e4b0ba829ddb2$var$Ti(f, l, b);
                            $c32e4b0ba829ddb2$var$uj();
                            break a;
                        }
                        k = Error($c32e4b0ba829ddb2$var$p(426));
                    }
                } else if ($c32e4b0ba829ddb2$var$I && h.mode & 1) {
                    var J = $c32e4b0ba829ddb2$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c32e4b0ba829ddb2$var$Wi(J, g, h, f, b);
                        $c32e4b0ba829ddb2$var$Jg($c32e4b0ba829ddb2$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c32e4b0ba829ddb2$var$Ki(k, h);
                4 !== $c32e4b0ba829ddb2$var$T && ($c32e4b0ba829ddb2$var$T = 2);
                null === $c32e4b0ba829ddb2$var$tk ? $c32e4b0ba829ddb2$var$tk = [
                    f
                ] : $c32e4b0ba829ddb2$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c32e4b0ba829ddb2$var$Oi(f, k, b);
                            $c32e4b0ba829ddb2$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c32e4b0ba829ddb2$var$Si || !$c32e4b0ba829ddb2$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c32e4b0ba829ddb2$var$Ri(f, h, b);
                                $c32e4b0ba829ddb2$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c32e4b0ba829ddb2$var$Tk(c);
        } catch (na) {
            b = na;
            $c32e4b0ba829ddb2$var$Y === c && null !== c && ($c32e4b0ba829ddb2$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c32e4b0ba829ddb2$var$Kk() {
    var a = $c32e4b0ba829ddb2$var$nk.current;
    $c32e4b0ba829ddb2$var$nk.current = $c32e4b0ba829ddb2$var$ai;
    return null === a ? $c32e4b0ba829ddb2$var$ai : a;
}
function $c32e4b0ba829ddb2$var$uj() {
    if (0 === $c32e4b0ba829ddb2$var$T || 3 === $c32e4b0ba829ddb2$var$T || 2 === $c32e4b0ba829ddb2$var$T) $c32e4b0ba829ddb2$var$T = 4;
    null === $c32e4b0ba829ddb2$var$R || 0 === ($c32e4b0ba829ddb2$var$hh & 268435455) && 0 === ($c32e4b0ba829ddb2$var$rk & 268435455) || $c32e4b0ba829ddb2$var$Dk($c32e4b0ba829ddb2$var$R, $c32e4b0ba829ddb2$var$Z);
}
function $c32e4b0ba829ddb2$var$Jk(a, b) {
    var c = $c32e4b0ba829ddb2$var$K;
    $c32e4b0ba829ddb2$var$K |= 2;
    var d = $c32e4b0ba829ddb2$var$Kk();
    if ($c32e4b0ba829ddb2$var$R !== a || $c32e4b0ba829ddb2$var$Z !== b) $c32e4b0ba829ddb2$var$vk = null, $c32e4b0ba829ddb2$var$Lk(a, b);
    for(;;)try {
        $c32e4b0ba829ddb2$var$Uk();
        break;
    } catch (e) {
        $c32e4b0ba829ddb2$var$Nk(a, e);
    }
    $c32e4b0ba829ddb2$var$Qg();
    $c32e4b0ba829ddb2$var$K = c;
    $c32e4b0ba829ddb2$var$nk.current = d;
    if (null !== $c32e4b0ba829ddb2$var$Y) throw Error($c32e4b0ba829ddb2$var$p(261));
    $c32e4b0ba829ddb2$var$R = null;
    $c32e4b0ba829ddb2$var$Z = 0;
    return $c32e4b0ba829ddb2$var$T;
}
function $c32e4b0ba829ddb2$var$Uk() {
    for(; null !== $c32e4b0ba829ddb2$var$Y;)$c32e4b0ba829ddb2$var$Vk($c32e4b0ba829ddb2$var$Y);
}
function $c32e4b0ba829ddb2$var$Mk() {
    for(; null !== $c32e4b0ba829ddb2$var$Y && !$c32e4b0ba829ddb2$var$cc();)$c32e4b0ba829ddb2$var$Vk($c32e4b0ba829ddb2$var$Y);
}
function $c32e4b0ba829ddb2$var$Vk(a) {
    var b = $c32e4b0ba829ddb2$var$Wk(a.alternate, a, $c32e4b0ba829ddb2$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c32e4b0ba829ddb2$var$Tk(a) : $c32e4b0ba829ddb2$var$Y = b;
    $c32e4b0ba829ddb2$var$ok.current = null;
}
function $c32e4b0ba829ddb2$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c32e4b0ba829ddb2$var$Fj(c, b, $c32e4b0ba829ddb2$var$gj), null !== c) {
                $c32e4b0ba829ddb2$var$Y = c;
                return;
            }
        } else {
            c = $c32e4b0ba829ddb2$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c32e4b0ba829ddb2$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c32e4b0ba829ddb2$var$T = 6;
                $c32e4b0ba829ddb2$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c32e4b0ba829ddb2$var$Y = b;
            return;
        }
        $c32e4b0ba829ddb2$var$Y = b = a;
    }while (null !== b);
    0 === $c32e4b0ba829ddb2$var$T && ($c32e4b0ba829ddb2$var$T = 5);
}
function $c32e4b0ba829ddb2$var$Qk(a, b, c) {
    var d = $c32e4b0ba829ddb2$var$C, e = $c32e4b0ba829ddb2$var$pk.transition;
    try {
        $c32e4b0ba829ddb2$var$pk.transition = null, $c32e4b0ba829ddb2$var$C = 1, $c32e4b0ba829ddb2$var$Xk(a, b, c, d);
    } finally{
        $c32e4b0ba829ddb2$var$pk.transition = e, $c32e4b0ba829ddb2$var$C = d;
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Xk(a, b, c, d) {
    do $c32e4b0ba829ddb2$var$Ik();
    while (null !== $c32e4b0ba829ddb2$var$xk);
    if (0 !== ($c32e4b0ba829ddb2$var$K & 6)) throw Error($c32e4b0ba829ddb2$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c32e4b0ba829ddb2$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c32e4b0ba829ddb2$var$Bc(a, f);
    a === $c32e4b0ba829ddb2$var$R && ($c32e4b0ba829ddb2$var$Y = $c32e4b0ba829ddb2$var$R = null, $c32e4b0ba829ddb2$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c32e4b0ba829ddb2$var$wk || ($c32e4b0ba829ddb2$var$wk = !0, $c32e4b0ba829ddb2$var$Gk($c32e4b0ba829ddb2$var$hc, function() {
        $c32e4b0ba829ddb2$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c32e4b0ba829ddb2$var$pk.transition;
        $c32e4b0ba829ddb2$var$pk.transition = null;
        var g = $c32e4b0ba829ddb2$var$C;
        $c32e4b0ba829ddb2$var$C = 1;
        var h = $c32e4b0ba829ddb2$var$K;
        $c32e4b0ba829ddb2$var$K |= 4;
        $c32e4b0ba829ddb2$var$ok.current = null;
        $c32e4b0ba829ddb2$var$Pj(a, c);
        $c32e4b0ba829ddb2$var$ek(c, a);
        $c32e4b0ba829ddb2$var$Oe($c32e4b0ba829ddb2$var$Df);
        $c32e4b0ba829ddb2$var$dd = !!$c32e4b0ba829ddb2$var$Cf;
        $c32e4b0ba829ddb2$var$Df = $c32e4b0ba829ddb2$var$Cf = null;
        a.current = c;
        $c32e4b0ba829ddb2$var$ik(c, a, e);
        $c32e4b0ba829ddb2$var$dc();
        $c32e4b0ba829ddb2$var$K = h;
        $c32e4b0ba829ddb2$var$C = g;
        $c32e4b0ba829ddb2$var$pk.transition = f;
    } else a.current = c;
    $c32e4b0ba829ddb2$var$wk && ($c32e4b0ba829ddb2$var$wk = !1, $c32e4b0ba829ddb2$var$xk = a, $c32e4b0ba829ddb2$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c32e4b0ba829ddb2$var$Si = null);
    $c32e4b0ba829ddb2$var$mc(c.stateNode, d);
    $c32e4b0ba829ddb2$var$Ek(a, $c32e4b0ba829ddb2$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c32e4b0ba829ddb2$var$Pi) throw $c32e4b0ba829ddb2$var$Pi = !1, a = $c32e4b0ba829ddb2$var$Qi, $c32e4b0ba829ddb2$var$Qi = null, a;
    0 !== ($c32e4b0ba829ddb2$var$yk & 1) && 0 !== a.tag && $c32e4b0ba829ddb2$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c32e4b0ba829ddb2$var$Ak ? $c32e4b0ba829ddb2$var$zk++ : ($c32e4b0ba829ddb2$var$zk = 0, $c32e4b0ba829ddb2$var$Ak = a) : $c32e4b0ba829ddb2$var$zk = 0;
    $c32e4b0ba829ddb2$var$jg();
    return null;
}
function $c32e4b0ba829ddb2$var$Ik() {
    if (null !== $c32e4b0ba829ddb2$var$xk) {
        var a = $c32e4b0ba829ddb2$var$Dc($c32e4b0ba829ddb2$var$yk), b = $c32e4b0ba829ddb2$var$pk.transition, c = $c32e4b0ba829ddb2$var$C;
        try {
            $c32e4b0ba829ddb2$var$pk.transition = null;
            $c32e4b0ba829ddb2$var$C = 16 > a ? 16 : a;
            if (null === $c32e4b0ba829ddb2$var$xk) var d = !1;
            else {
                a = $c32e4b0ba829ddb2$var$xk;
                $c32e4b0ba829ddb2$var$xk = null;
                $c32e4b0ba829ddb2$var$yk = 0;
                if (0 !== ($c32e4b0ba829ddb2$var$K & 6)) throw Error($c32e4b0ba829ddb2$var$p(331));
                var e = $c32e4b0ba829ddb2$var$K;
                $c32e4b0ba829ddb2$var$K |= 4;
                for($c32e4b0ba829ddb2$var$V = a.current; null !== $c32e4b0ba829ddb2$var$V;){
                    var f = $c32e4b0ba829ddb2$var$V, g = f.child;
                    if (0 !== ($c32e4b0ba829ddb2$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c32e4b0ba829ddb2$var$V = l; null !== $c32e4b0ba829ddb2$var$V;){
                                    var m = $c32e4b0ba829ddb2$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c32e4b0ba829ddb2$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c32e4b0ba829ddb2$var$V = q;
                                    else for(; null !== $c32e4b0ba829ddb2$var$V;){
                                        m = $c32e4b0ba829ddb2$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c32e4b0ba829ddb2$var$Tj(m);
                                        if (m === l) {
                                            $c32e4b0ba829ddb2$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c32e4b0ba829ddb2$var$V = r;
                                            break;
                                        }
                                        $c32e4b0ba829ddb2$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c32e4b0ba829ddb2$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c32e4b0ba829ddb2$var$V = g;
                    else b: for(; null !== $c32e4b0ba829ddb2$var$V;){
                        f = $c32e4b0ba829ddb2$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c32e4b0ba829ddb2$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c32e4b0ba829ddb2$var$V = x;
                            break b;
                        }
                        $c32e4b0ba829ddb2$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c32e4b0ba829ddb2$var$V = w; null !== $c32e4b0ba829ddb2$var$V;){
                    g = $c32e4b0ba829ddb2$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c32e4b0ba829ddb2$var$V = u;
                    else b: for(g = w; null !== $c32e4b0ba829ddb2$var$V;){
                        h = $c32e4b0ba829ddb2$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c32e4b0ba829ddb2$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c32e4b0ba829ddb2$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c32e4b0ba829ddb2$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c32e4b0ba829ddb2$var$V = F;
                            break b;
                        }
                        $c32e4b0ba829ddb2$var$V = h.return;
                    }
                }
                $c32e4b0ba829ddb2$var$K = e;
                $c32e4b0ba829ddb2$var$jg();
                if ($c32e4b0ba829ddb2$var$lc && "function" === typeof $c32e4b0ba829ddb2$var$lc.onPostCommitFiberRoot) try {
                    $c32e4b0ba829ddb2$var$lc.onPostCommitFiberRoot($c32e4b0ba829ddb2$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c32e4b0ba829ddb2$var$C = c, $c32e4b0ba829ddb2$var$pk.transition = b;
        }
    }
    return !1;
}
function $c32e4b0ba829ddb2$var$Yk(a, b, c) {
    b = $c32e4b0ba829ddb2$var$Ki(c, b);
    b = $c32e4b0ba829ddb2$var$Oi(a, b, 1);
    a = $c32e4b0ba829ddb2$var$dh(a, b, 1);
    b = $c32e4b0ba829ddb2$var$L();
    null !== a && ($c32e4b0ba829ddb2$var$Ac(a, 1, b), $c32e4b0ba829ddb2$var$Ek(a, b));
}
function $c32e4b0ba829ddb2$var$W(a, b, c) {
    if (3 === a.tag) $c32e4b0ba829ddb2$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c32e4b0ba829ddb2$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c32e4b0ba829ddb2$var$Si || !$c32e4b0ba829ddb2$var$Si.has(d))) {
                a = $c32e4b0ba829ddb2$var$Ki(c, a);
                a = $c32e4b0ba829ddb2$var$Ri(b, a, 1);
                b = $c32e4b0ba829ddb2$var$dh(b, a, 1);
                a = $c32e4b0ba829ddb2$var$L();
                null !== b && ($c32e4b0ba829ddb2$var$Ac(b, 1, a), $c32e4b0ba829ddb2$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c32e4b0ba829ddb2$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c32e4b0ba829ddb2$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c32e4b0ba829ddb2$var$R === a && ($c32e4b0ba829ddb2$var$Z & c) === c && (4 === $c32e4b0ba829ddb2$var$T || 3 === $c32e4b0ba829ddb2$var$T && ($c32e4b0ba829ddb2$var$Z & 130023424) === $c32e4b0ba829ddb2$var$Z && 500 > $c32e4b0ba829ddb2$var$B() - $c32e4b0ba829ddb2$var$gk ? $c32e4b0ba829ddb2$var$Lk(a, 0) : $c32e4b0ba829ddb2$var$sk |= c);
    $c32e4b0ba829ddb2$var$Ek(a, b);
}
function $c32e4b0ba829ddb2$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c32e4b0ba829ddb2$var$sc, $c32e4b0ba829ddb2$var$sc <<= 1, 0 === ($c32e4b0ba829ddb2$var$sc & 130023424) && ($c32e4b0ba829ddb2$var$sc = 4194304)));
    var c = $c32e4b0ba829ddb2$var$L();
    a = $c32e4b0ba829ddb2$var$Zg(a, b);
    null !== a && ($c32e4b0ba829ddb2$var$Ac(a, b, c), $c32e4b0ba829ddb2$var$Ek(a, c));
}
function $c32e4b0ba829ddb2$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c32e4b0ba829ddb2$var$Zk(a, c);
}
function $c32e4b0ba829ddb2$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c32e4b0ba829ddb2$var$p(314));
    }
    null !== d && d.delete(b);
    $c32e4b0ba829ddb2$var$Zk(a, c);
}
var $c32e4b0ba829ddb2$var$Wk;
$c32e4b0ba829ddb2$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c32e4b0ba829ddb2$var$Wf.current) $c32e4b0ba829ddb2$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c32e4b0ba829ddb2$var$Ug = !1, $c32e4b0ba829ddb2$var$zj(a, b, c);
            $c32e4b0ba829ddb2$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c32e4b0ba829ddb2$var$Ug = !1, $c32e4b0ba829ddb2$var$I && 0 !== (b.flags & 1048576) && $c32e4b0ba829ddb2$var$ug(b, $c32e4b0ba829ddb2$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c32e4b0ba829ddb2$var$jj(a, b);
            a = b.pendingProps;
            var e = $c32e4b0ba829ddb2$var$Yf(b, $c32e4b0ba829ddb2$var$H.current);
            $c32e4b0ba829ddb2$var$Tg(b, c);
            e = $c32e4b0ba829ddb2$var$Xh(null, b, d, a, e, c);
            var f = $c32e4b0ba829ddb2$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c32e4b0ba829ddb2$var$Zf(d) ? (f = !0, $c32e4b0ba829ddb2$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c32e4b0ba829ddb2$var$ah(b), e.updater = $c32e4b0ba829ddb2$var$nh, b.stateNode = e, e._reactInternals = b, $c32e4b0ba829ddb2$var$rh(b, d, a, c), b = $c32e4b0ba829ddb2$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c32e4b0ba829ddb2$var$I && f && $c32e4b0ba829ddb2$var$vg(b), $c32e4b0ba829ddb2$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c32e4b0ba829ddb2$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c32e4b0ba829ddb2$var$$k(d);
                a = $c32e4b0ba829ddb2$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c32e4b0ba829ddb2$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c32e4b0ba829ddb2$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c32e4b0ba829ddb2$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c32e4b0ba829ddb2$var$aj(null, b, d, $c32e4b0ba829ddb2$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c32e4b0ba829ddb2$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c32e4b0ba829ddb2$var$Lg(d, e), $c32e4b0ba829ddb2$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c32e4b0ba829ddb2$var$Lg(d, e), $c32e4b0ba829ddb2$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c32e4b0ba829ddb2$var$lj(b);
                if (null === a) throw Error($c32e4b0ba829ddb2$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c32e4b0ba829ddb2$var$bh(a, b);
                $c32e4b0ba829ddb2$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c32e4b0ba829ddb2$var$Ki(Error($c32e4b0ba829ddb2$var$p(423)), b);
                        b = $c32e4b0ba829ddb2$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c32e4b0ba829ddb2$var$Ki(Error($c32e4b0ba829ddb2$var$p(424)), b);
                        b = $c32e4b0ba829ddb2$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$Lf(b.stateNode.containerInfo.firstChild), $c32e4b0ba829ddb2$var$xg = b, $c32e4b0ba829ddb2$var$I = !0, $c32e4b0ba829ddb2$var$zg = null, c = $c32e4b0ba829ddb2$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c32e4b0ba829ddb2$var$Ig();
                    if (d === e) {
                        b = $c32e4b0ba829ddb2$var$$i(a, b, c);
                        break a;
                    }
                    $c32e4b0ba829ddb2$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c32e4b0ba829ddb2$var$Kh(b), null === a && $c32e4b0ba829ddb2$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c32e4b0ba829ddb2$var$Ef(d, e) ? g = null : null !== f && $c32e4b0ba829ddb2$var$Ef(d, f) && (b.flags |= 32), $c32e4b0ba829ddb2$var$hj(a, b), $c32e4b0ba829ddb2$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c32e4b0ba829ddb2$var$Eg(b), null;
        case 13:
            return $c32e4b0ba829ddb2$var$pj(a, b, c);
        case 4:
            return $c32e4b0ba829ddb2$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c32e4b0ba829ddb2$var$Bh(b, null, d, c) : $c32e4b0ba829ddb2$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c32e4b0ba829ddb2$var$Lg(d, e), $c32e4b0ba829ddb2$var$Zi(a, b, d, e, c);
        case 7:
            return $c32e4b0ba829ddb2$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c32e4b0ba829ddb2$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c32e4b0ba829ddb2$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c32e4b0ba829ddb2$var$He(f.value, g)) {
                        if (f.children === e.children && !$c32e4b0ba829ddb2$var$Wf.current) {
                            b = $c32e4b0ba829ddb2$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c32e4b0ba829ddb2$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c32e4b0ba829ddb2$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c32e4b0ba829ddb2$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c32e4b0ba829ddb2$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c32e4b0ba829ddb2$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c32e4b0ba829ddb2$var$Tg(b, c), e = $c32e4b0ba829ddb2$var$Vg(e), d = d(e), b.flags |= 1, $c32e4b0ba829ddb2$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c32e4b0ba829ddb2$var$Lg(d, b.pendingProps), e = $c32e4b0ba829ddb2$var$Lg(d.type, e), $c32e4b0ba829ddb2$var$aj(a, b, d, e, c);
        case 15:
            return $c32e4b0ba829ddb2$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c32e4b0ba829ddb2$var$Lg(d, e), $c32e4b0ba829ddb2$var$jj(a, b), b.tag = 1, $c32e4b0ba829ddb2$var$Zf(d) ? (a = !0, $c32e4b0ba829ddb2$var$cg(b)) : a = !1, $c32e4b0ba829ddb2$var$Tg(b, c), $c32e4b0ba829ddb2$var$ph(b, d, e), $c32e4b0ba829ddb2$var$rh(b, d, e, c), $c32e4b0ba829ddb2$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c32e4b0ba829ddb2$var$yj(a, b, c);
        case 22:
            return $c32e4b0ba829ddb2$var$ej(a, b, c);
    }
    throw Error($c32e4b0ba829ddb2$var$p(156, b.tag));
};
function $c32e4b0ba829ddb2$var$Gk(a, b) {
    return $c32e4b0ba829ddb2$var$ac(a, b);
}
function $c32e4b0ba829ddb2$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c32e4b0ba829ddb2$var$Bg(a, b, c, d) {
    return new $c32e4b0ba829ddb2$var$al(a, b, c, d);
}
function $c32e4b0ba829ddb2$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c32e4b0ba829ddb2$var$$k(a) {
    if ("function" === typeof a) return $c32e4b0ba829ddb2$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c32e4b0ba829ddb2$var$Da) return 11;
        if (a === $c32e4b0ba829ddb2$var$Ga) return 14;
    }
    return 2;
}
function $c32e4b0ba829ddb2$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c32e4b0ba829ddb2$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c32e4b0ba829ddb2$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c32e4b0ba829ddb2$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c32e4b0ba829ddb2$var$ya:
            return $c32e4b0ba829ddb2$var$Ah(c.children, e, f, b);
        case $c32e4b0ba829ddb2$var$za:
            g = 8;
            e |= 8;
            break;
        case $c32e4b0ba829ddb2$var$Aa:
            return a = $c32e4b0ba829ddb2$var$Bg(12, c, b, e | 2), a.elementType = $c32e4b0ba829ddb2$var$Aa, a.lanes = f, a;
        case $c32e4b0ba829ddb2$var$Ea:
            return a = $c32e4b0ba829ddb2$var$Bg(13, c, b, e), a.elementType = $c32e4b0ba829ddb2$var$Ea, a.lanes = f, a;
        case $c32e4b0ba829ddb2$var$Fa:
            return a = $c32e4b0ba829ddb2$var$Bg(19, c, b, e), a.elementType = $c32e4b0ba829ddb2$var$Fa, a.lanes = f, a;
        case $c32e4b0ba829ddb2$var$Ia:
            return $c32e4b0ba829ddb2$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c32e4b0ba829ddb2$var$Ba:
                    g = 10;
                    break a;
                case $c32e4b0ba829ddb2$var$Ca:
                    g = 9;
                    break a;
                case $c32e4b0ba829ddb2$var$Da:
                    g = 11;
                    break a;
                case $c32e4b0ba829ddb2$var$Ga:
                    g = 14;
                    break a;
                case $c32e4b0ba829ddb2$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c32e4b0ba829ddb2$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a), ""));
    }
    b = $c32e4b0ba829ddb2$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c32e4b0ba829ddb2$var$Ah(a, b, c, d) {
    a = $c32e4b0ba829ddb2$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c32e4b0ba829ddb2$var$qj(a, b, c, d) {
    a = $c32e4b0ba829ddb2$var$Bg(22, a, d, b);
    a.elementType = $c32e4b0ba829ddb2$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c32e4b0ba829ddb2$var$xh(a, b, c) {
    a = $c32e4b0ba829ddb2$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c32e4b0ba829ddb2$var$zh(a, b, c) {
    b = $c32e4b0ba829ddb2$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c32e4b0ba829ddb2$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c32e4b0ba829ddb2$var$zc(0);
    this.expirationTimes = $c32e4b0ba829ddb2$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c32e4b0ba829ddb2$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c32e4b0ba829ddb2$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c32e4b0ba829ddb2$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c32e4b0ba829ddb2$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c32e4b0ba829ddb2$var$ah(f);
    return a;
}
function $c32e4b0ba829ddb2$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c32e4b0ba829ddb2$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c32e4b0ba829ddb2$var$el(a) {
    if (!a) return $c32e4b0ba829ddb2$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c32e4b0ba829ddb2$var$Vb(a) !== a || 1 !== a.tag) throw Error($c32e4b0ba829ddb2$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c32e4b0ba829ddb2$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c32e4b0ba829ddb2$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c32e4b0ba829ddb2$var$Zf(c)) return $c32e4b0ba829ddb2$var$bg(a, c, b);
    }
    return b;
}
function $c32e4b0ba829ddb2$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c32e4b0ba829ddb2$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c32e4b0ba829ddb2$var$el(null);
    c = a.current;
    d = $c32e4b0ba829ddb2$var$L();
    e = $c32e4b0ba829ddb2$var$lh(c);
    f = $c32e4b0ba829ddb2$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c32e4b0ba829ddb2$var$dh(c, f, e);
    a.current.lanes = e;
    $c32e4b0ba829ddb2$var$Ac(a, e, d);
    $c32e4b0ba829ddb2$var$Ek(a, d);
    return a;
}
function $c32e4b0ba829ddb2$var$gl(a, b, c, d) {
    var e = b.current, f = $c32e4b0ba829ddb2$var$L(), g = $c32e4b0ba829ddb2$var$lh(e);
    c = $c32e4b0ba829ddb2$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c32e4b0ba829ddb2$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c32e4b0ba829ddb2$var$dh(e, b, g);
    null !== a && ($c32e4b0ba829ddb2$var$mh(a, e, g, f), $c32e4b0ba829ddb2$var$eh(a, e, g));
    return g;
}
function $c32e4b0ba829ddb2$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c32e4b0ba829ddb2$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c32e4b0ba829ddb2$var$jl(a, b) {
    $c32e4b0ba829ddb2$var$il(a, b);
    (a = a.alternate) && $c32e4b0ba829ddb2$var$il(a, b);
}
function $c32e4b0ba829ddb2$var$kl() {
    return null;
}
var $c32e4b0ba829ddb2$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $c32e4b0ba829ddb2$var$ml(a) {
    this._internalRoot = a;
}
$c32e4b0ba829ddb2$var$nl.prototype.render = $c32e4b0ba829ddb2$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c32e4b0ba829ddb2$var$p(409));
    $c32e4b0ba829ddb2$var$gl(a, b, null, null);
};
$c32e4b0ba829ddb2$var$nl.prototype.unmount = $c32e4b0ba829ddb2$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c32e4b0ba829ddb2$var$Sk(function() {
            $c32e4b0ba829ddb2$var$gl(null, a, null, null);
        });
        b[$c32e4b0ba829ddb2$var$uf] = null;
    }
};
function $c32e4b0ba829ddb2$var$nl(a) {
    this._internalRoot = a;
}
$c32e4b0ba829ddb2$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c32e4b0ba829ddb2$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c32e4b0ba829ddb2$var$Qc.length && 0 !== b && b < $c32e4b0ba829ddb2$var$Qc[c].priority; c++);
        $c32e4b0ba829ddb2$var$Qc.splice(c, 0, a);
        0 === c && $c32e4b0ba829ddb2$var$Vc(a);
    }
};
function $c32e4b0ba829ddb2$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c32e4b0ba829ddb2$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c32e4b0ba829ddb2$var$ql() {}
function $c32e4b0ba829ddb2$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $c32e4b0ba829ddb2$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $c32e4b0ba829ddb2$var$fl(b, d, a, 0, null, !1, !1, "", $c32e4b0ba829ddb2$var$ql);
        a._reactRootContainer = g;
        a[$c32e4b0ba829ddb2$var$uf] = g.current;
        $c32e4b0ba829ddb2$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c32e4b0ba829ddb2$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $c32e4b0ba829ddb2$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $c32e4b0ba829ddb2$var$cl(a, 0, !1, null, null, !1, !1, "", $c32e4b0ba829ddb2$var$ql);
    a._reactRootContainer = k;
    a[$c32e4b0ba829ddb2$var$uf] = k.current;
    $c32e4b0ba829ddb2$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c32e4b0ba829ddb2$var$Sk(function() {
        $c32e4b0ba829ddb2$var$gl(b, k, c, d);
    });
    return k;
}
function $c32e4b0ba829ddb2$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $c32e4b0ba829ddb2$var$hl(g);
                h.call(_$a);
            };
        }
        $c32e4b0ba829ddb2$var$gl(b, g, a, e);
    } else g = $c32e4b0ba829ddb2$var$rl(c, b, a, e, d);
    return $c32e4b0ba829ddb2$var$hl(g);
}
$c32e4b0ba829ddb2$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c32e4b0ba829ddb2$var$tc(b.pendingLanes);
                0 !== c && ($c32e4b0ba829ddb2$var$Cc(b, c | 1), $c32e4b0ba829ddb2$var$Ek(b, $c32e4b0ba829ddb2$var$B()), 0 === ($c32e4b0ba829ddb2$var$K & 6) && ($c32e4b0ba829ddb2$var$Hj = $c32e4b0ba829ddb2$var$B() + 500, $c32e4b0ba829ddb2$var$jg()));
            }
            break;
        case 13:
            $c32e4b0ba829ddb2$var$Sk(function() {
                var b = $c32e4b0ba829ddb2$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c32e4b0ba829ddb2$var$L();
                    $c32e4b0ba829ddb2$var$mh(b, a, 1, c);
                }
            }), $c32e4b0ba829ddb2$var$jl(a, 1);
    }
};
$c32e4b0ba829ddb2$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $c32e4b0ba829ddb2$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c32e4b0ba829ddb2$var$L();
            $c32e4b0ba829ddb2$var$mh(b, a, 134217728, c);
        }
        $c32e4b0ba829ddb2$var$jl(a, 134217728);
    }
};
$c32e4b0ba829ddb2$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $c32e4b0ba829ddb2$var$lh(a), c = $c32e4b0ba829ddb2$var$Zg(a, b);
        if (null !== c) {
            var d = $c32e4b0ba829ddb2$var$L();
            $c32e4b0ba829ddb2$var$mh(c, a, b, d);
        }
        $c32e4b0ba829ddb2$var$jl(a, b);
    }
};
$c32e4b0ba829ddb2$var$Hc = function Hc() {
    return $c32e4b0ba829ddb2$var$C;
};
$c32e4b0ba829ddb2$var$Ic = function Ic(a, b) {
    var c = $c32e4b0ba829ddb2$var$C;
    try {
        return $c32e4b0ba829ddb2$var$C = a, b();
    } finally{
        $c32e4b0ba829ddb2$var$C = c;
    }
};
$c32e4b0ba829ddb2$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $c32e4b0ba829ddb2$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c32e4b0ba829ddb2$var$Db(d);
                        if (!e) throw Error($c32e4b0ba829ddb2$var$p(90));
                        $c32e4b0ba829ddb2$var$Wa(d);
                        $c32e4b0ba829ddb2$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c32e4b0ba829ddb2$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c32e4b0ba829ddb2$var$fb(a, !!c.multiple, b, !1);
    }
};
$c32e4b0ba829ddb2$var$Gb = $c32e4b0ba829ddb2$var$Rk;
$c32e4b0ba829ddb2$var$Hb = $c32e4b0ba829ddb2$var$Sk;
var $c32e4b0ba829ddb2$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c32e4b0ba829ddb2$var$Cb,
        $c32e4b0ba829ddb2$var$ue,
        $c32e4b0ba829ddb2$var$Db,
        $c32e4b0ba829ddb2$var$Eb,
        $c32e4b0ba829ddb2$var$Fb,
        $c32e4b0ba829ddb2$var$Rk
    ]
}, $c32e4b0ba829ddb2$var$ul = {
    findFiberByHostInstance: $c32e4b0ba829ddb2$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c32e4b0ba829ddb2$var$vl = {
    bundleType: $c32e4b0ba829ddb2$var$ul.bundleType,
    version: $c32e4b0ba829ddb2$var$ul.version,
    rendererPackageName: $c32e4b0ba829ddb2$var$ul.rendererPackageName,
    rendererConfig: $c32e4b0ba829ddb2$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c32e4b0ba829ddb2$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $c32e4b0ba829ddb2$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c32e4b0ba829ddb2$var$ul.findFiberByHostInstance || $c32e4b0ba829ddb2$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c32e4b0ba829ddb2$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c32e4b0ba829ddb2$var$wl.isDisabled && $c32e4b0ba829ddb2$var$wl.supportsFiber) try {
        $c32e4b0ba829ddb2$var$kc = $c32e4b0ba829ddb2$var$wl.inject($c32e4b0ba829ddb2$var$vl), $c32e4b0ba829ddb2$var$lc = $c32e4b0ba829ddb2$var$wl;
    } catch (a) {}
}
$c32e4b0ba829ddb2$export$ae55be85d98224ed = $c32e4b0ba829ddb2$var$tl;
$c32e4b0ba829ddb2$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c32e4b0ba829ddb2$var$ol(b)) throw Error($c32e4b0ba829ddb2$var$p(200));
    return $c32e4b0ba829ddb2$var$dl(a, b, null, c);
};
$c32e4b0ba829ddb2$export$882461b6382ed46c = function(a, b) {
    if (!$c32e4b0ba829ddb2$var$ol(a)) throw Error($c32e4b0ba829ddb2$var$p(299));
    var c = !1, d = "", e = $c32e4b0ba829ddb2$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c32e4b0ba829ddb2$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c32e4b0ba829ddb2$var$uf] = b.current;
    $c32e4b0ba829ddb2$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c32e4b0ba829ddb2$var$ml(b);
};
$c32e4b0ba829ddb2$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c32e4b0ba829ddb2$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c32e4b0ba829ddb2$var$p(268, a));
    }
    a = $c32e4b0ba829ddb2$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c32e4b0ba829ddb2$export$cd75ccfd720a3cd4 = function(a) {
    return $c32e4b0ba829ddb2$var$Sk(a);
};
$c32e4b0ba829ddb2$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c32e4b0ba829ddb2$var$pl(b)) throw Error($c32e4b0ba829ddb2$var$p(200));
    return $c32e4b0ba829ddb2$var$sl(null, a, b, !0, c);
};
$c32e4b0ba829ddb2$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c32e4b0ba829ddb2$var$ol(a)) throw Error($c32e4b0ba829ddb2$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c32e4b0ba829ddb2$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c32e4b0ba829ddb2$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c32e4b0ba829ddb2$var$uf] = b.current;
    $c32e4b0ba829ddb2$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c32e4b0ba829ddb2$var$nl(b);
};
$c32e4b0ba829ddb2$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c32e4b0ba829ddb2$var$pl(b)) throw Error($c32e4b0ba829ddb2$var$p(200));
    return $c32e4b0ba829ddb2$var$sl(null, a, b, !1, c);
};
$c32e4b0ba829ddb2$export$502457920280e6be = function(a) {
    if (!$c32e4b0ba829ddb2$var$pl(a)) throw Error($c32e4b0ba829ddb2$var$p(40));
    return a._reactRootContainer ? ($c32e4b0ba829ddb2$var$Sk(function() {
        $c32e4b0ba829ddb2$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c32e4b0ba829ddb2$var$uf] = null;
        });
    }), !0) : !1;
};
$c32e4b0ba829ddb2$export$c78a37762a8d58e1 = $c32e4b0ba829ddb2$var$Rk;
$c32e4b0ba829ddb2$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c32e4b0ba829ddb2$var$pl(c)) throw Error($c32e4b0ba829ddb2$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c32e4b0ba829ddb2$var$p(38));
    return $c32e4b0ba829ddb2$var$sl(a, b, c, !1, d);
};
$c32e4b0ba829ddb2$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("2bfPH", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $1968e3edfc5cfc11$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $1968e3edfc5cfc11$export$5f0017c582d45a2d; });
function $1968e3edfc5cfc11$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("eHaBZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("luEM2"));

});
parcelRegister("luEM2", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $fa5c07254b0b0f21$export$dca3b0875bd9a954; }, function (v) { return $fa5c07254b0b0f21$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $fa5c07254b0b0f21$export$16fa2f45be04daa8; }, function (v) { return $fa5c07254b0b0f21$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fa5c07254b0b0f21$export$ffb0004e005737fa; }, function (v) { return $fa5c07254b0b0f21$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $fa5c07254b0b0f21$export$e2c29f18771995cb; }, function (v) { return $fa5c07254b0b0f21$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $fa5c07254b0b0f21$export$221d75b3f55bb0bd; }, function (v) { return $fa5c07254b0b0f21$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fa5c07254b0b0f21$export$5f8d39834fd61797; }, function (v) { return $fa5c07254b0b0f21$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fa5c07254b0b0f21$export$74bf444e3cd11ea5; }, function (v) { return $fa5c07254b0b0f21$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fa5c07254b0b0f21$export$ae55be85d98224ed; }, function (v) { return $fa5c07254b0b0f21$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $fa5c07254b0b0f21$export$e530037191fcd5d7; }, function (v) { return $fa5c07254b0b0f21$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $fa5c07254b0b0f21$export$fd42f52fd3ae1109; }, function (v) { return $fa5c07254b0b0f21$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $fa5c07254b0b0f21$export$c8a8987d4410bf2d; }, function (v) { return $fa5c07254b0b0f21$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $fa5c07254b0b0f21$export$d38cd72104c1f0e9; }, function (v) { return $fa5c07254b0b0f21$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $fa5c07254b0b0f21$export$7d1e3a5e95ceca43; }, function (v) { return $fa5c07254b0b0f21$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $fa5c07254b0b0f21$export$257a8862b851cb5b; }, function (v) { return $fa5c07254b0b0f21$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $fa5c07254b0b0f21$export$a8257692ac88316c; }, function (v) { return $fa5c07254b0b0f21$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $fa5c07254b0b0f21$export$488013bae63b21da; }, function (v) { return $fa5c07254b0b0f21$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $fa5c07254b0b0f21$export$7c73462e0d25e514; }, function (v) { return $fa5c07254b0b0f21$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $fa5c07254b0b0f21$export$7568632d0d33d16d; }, function (v) { return $fa5c07254b0b0f21$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $fa5c07254b0b0f21$export$88948ce120ea2619; }, function (v) { return $fa5c07254b0b0f21$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $fa5c07254b0b0f21$export$35808ee640e87ca7; }, function (v) { return $fa5c07254b0b0f21$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $fa5c07254b0b0f21$export$fae74005e78b1a27; }, function (v) { return $fa5c07254b0b0f21$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $fa5c07254b0b0f21$export$dc8fbce3eb94dc1e; }, function (v) { return $fa5c07254b0b0f21$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $fa5c07254b0b0f21$export$6a7bc4e911dc01cf; }, function (v) { return $fa5c07254b0b0f21$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $fa5c07254b0b0f21$export$6d9c69b0de29b591; }, function (v) { return $fa5c07254b0b0f21$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $fa5c07254b0b0f21$export$f680877a34711e37; }, function (v) { return $fa5c07254b0b0f21$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $fa5c07254b0b0f21$export$d5a552a76deda3c2; }, function (v) { return $fa5c07254b0b0f21$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $fa5c07254b0b0f21$export$aaabe4eda9ed9969; }, function (v) { return $fa5c07254b0b0f21$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $fa5c07254b0b0f21$export$e5c5a5f917a5871c; }, function (v) { return $fa5c07254b0b0f21$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $fa5c07254b0b0f21$export$1538c33de8887b59; }, function (v) { return $fa5c07254b0b0f21$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $fa5c07254b0b0f21$export$13e3392192263954; }, function (v) { return $fa5c07254b0b0f21$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $fa5c07254b0b0f21$export$b8f5890fc79d6aca; }, function (v) { return $fa5c07254b0b0f21$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $fa5c07254b0b0f21$export$60241385465d0a34; }, function (v) { return $fa5c07254b0b0f21$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $fa5c07254b0b0f21$export$306c0aa65ff9ec16; }, function (v) { return $fa5c07254b0b0f21$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $fa5c07254b0b0f21$export$7b286972b8d8ccbf; }, function (v) { return $fa5c07254b0b0f21$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $fa5c07254b0b0f21$export$83d89fbfd8236492; }, function (v) { return $fa5c07254b0b0f21$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2bfPH = parcelRequire("2bfPH");
var $fa5c07254b0b0f21$export$dca3b0875bd9a954;
var $fa5c07254b0b0f21$export$16fa2f45be04daa8;
var $fa5c07254b0b0f21$export$ffb0004e005737fa;
var $fa5c07254b0b0f21$export$e2c29f18771995cb;
var $fa5c07254b0b0f21$export$221d75b3f55bb0bd;
var $fa5c07254b0b0f21$export$5f8d39834fd61797;
var $fa5c07254b0b0f21$export$74bf444e3cd11ea5;
var $fa5c07254b0b0f21$export$ae55be85d98224ed;
var $fa5c07254b0b0f21$export$e530037191fcd5d7;
var $fa5c07254b0b0f21$export$fd42f52fd3ae1109;
var $fa5c07254b0b0f21$export$c8a8987d4410bf2d;
var $fa5c07254b0b0f21$export$d38cd72104c1f0e9;
var $fa5c07254b0b0f21$export$7d1e3a5e95ceca43;
var $fa5c07254b0b0f21$export$257a8862b851cb5b;
var $fa5c07254b0b0f21$export$a8257692ac88316c;
var $fa5c07254b0b0f21$export$488013bae63b21da;
var $fa5c07254b0b0f21$export$7c73462e0d25e514;
var $fa5c07254b0b0f21$export$7568632d0d33d16d;
var $fa5c07254b0b0f21$export$88948ce120ea2619;
var $fa5c07254b0b0f21$export$35808ee640e87ca7;
var $fa5c07254b0b0f21$export$fae74005e78b1a27;
var $fa5c07254b0b0f21$export$dc8fbce3eb94dc1e;
var $fa5c07254b0b0f21$export$6a7bc4e911dc01cf;
var $fa5c07254b0b0f21$export$6d9c69b0de29b591;
var $fa5c07254b0b0f21$export$f680877a34711e37;
var $fa5c07254b0b0f21$export$d5a552a76deda3c2;
var $fa5c07254b0b0f21$export$aaabe4eda9ed9969;
var $fa5c07254b0b0f21$export$e5c5a5f917a5871c;
var $fa5c07254b0b0f21$export$1538c33de8887b59;
var $fa5c07254b0b0f21$export$13e3392192263954;
var $fa5c07254b0b0f21$export$b8f5890fc79d6aca;
var $fa5c07254b0b0f21$export$60241385465d0a34;
var $fa5c07254b0b0f21$export$306c0aa65ff9ec16;
var $fa5c07254b0b0f21$export$7b286972b8d8ccbf;
var $fa5c07254b0b0f21$export$83d89fbfd8236492;
"use strict";
var $fa5c07254b0b0f21$var$l = Symbol.for("react.element"), $fa5c07254b0b0f21$var$n = Symbol.for("react.portal"), $fa5c07254b0b0f21$var$p = Symbol.for("react.fragment"), $fa5c07254b0b0f21$var$q = Symbol.for("react.strict_mode"), $fa5c07254b0b0f21$var$r = Symbol.for("react.profiler"), $fa5c07254b0b0f21$var$t = Symbol.for("react.provider"), $fa5c07254b0b0f21$var$u = Symbol.for("react.context"), $fa5c07254b0b0f21$var$v = Symbol.for("react.forward_ref"), $fa5c07254b0b0f21$var$w = Symbol.for("react.suspense"), $fa5c07254b0b0f21$var$x = Symbol.for("react.memo"), $fa5c07254b0b0f21$var$y = Symbol.for("react.lazy"), $fa5c07254b0b0f21$var$z = Symbol.iterator;
function $fa5c07254b0b0f21$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fa5c07254b0b0f21$var$z && a[$fa5c07254b0b0f21$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fa5c07254b0b0f21$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $fa5c07254b0b0f21$var$C = Object.assign, $fa5c07254b0b0f21$var$D = {};
function $fa5c07254b0b0f21$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $fa5c07254b0b0f21$var$D;
    this.updater = e || $fa5c07254b0b0f21$var$B;
}
$fa5c07254b0b0f21$var$E.prototype.isReactComponent = {};
$fa5c07254b0b0f21$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$fa5c07254b0b0f21$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $fa5c07254b0b0f21$var$F() {}
$fa5c07254b0b0f21$var$F.prototype = $fa5c07254b0b0f21$var$E.prototype;
function $fa5c07254b0b0f21$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $fa5c07254b0b0f21$var$D;
    this.updater = e || $fa5c07254b0b0f21$var$B;
}
var $fa5c07254b0b0f21$var$H = $fa5c07254b0b0f21$var$G.prototype = new $fa5c07254b0b0f21$var$F;
$fa5c07254b0b0f21$var$H.constructor = $fa5c07254b0b0f21$var$G;
$fa5c07254b0b0f21$var$C($fa5c07254b0b0f21$var$H, $fa5c07254b0b0f21$var$E.prototype);
$fa5c07254b0b0f21$var$H.isPureReactComponent = !0;
var $fa5c07254b0b0f21$var$I = Array.isArray, $fa5c07254b0b0f21$var$J = Object.prototype.hasOwnProperty, $fa5c07254b0b0f21$var$K = {
    current: null
}, $fa5c07254b0b0f21$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $fa5c07254b0b0f21$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$fa5c07254b0b0f21$var$J.call(b, d) && !$fa5c07254b0b0f21$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $fa5c07254b0b0f21$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $fa5c07254b0b0f21$var$K.current
    };
}
function $fa5c07254b0b0f21$var$N(a, b) {
    return {
        $$typeof: $fa5c07254b0b0f21$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $fa5c07254b0b0f21$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fa5c07254b0b0f21$var$l;
}
function $fa5c07254b0b0f21$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $fa5c07254b0b0f21$var$P = /\/+/g;
function $fa5c07254b0b0f21$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $fa5c07254b0b0f21$var$escape("" + a.key) : b.toString(36);
}
function $fa5c07254b0b0f21$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $fa5c07254b0b0f21$var$l:
                case $fa5c07254b0b0f21$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $fa5c07254b0b0f21$var$Q(h, 0) : d, $fa5c07254b0b0f21$var$I(c) ? (e = "", null != a && (e = a.replace($fa5c07254b0b0f21$var$P, "$&/") + "/"), $fa5c07254b0b0f21$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($fa5c07254b0b0f21$var$O(c) && (c = $fa5c07254b0b0f21$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($fa5c07254b0b0f21$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($fa5c07254b0b0f21$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $fa5c07254b0b0f21$var$Q(k, g);
        h += $fa5c07254b0b0f21$var$R(k, b, e, f, c);
    }
    else if (f = $fa5c07254b0b0f21$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $fa5c07254b0b0f21$var$Q(k, g++), h += $fa5c07254b0b0f21$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $fa5c07254b0b0f21$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $fa5c07254b0b0f21$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $fa5c07254b0b0f21$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $fa5c07254b0b0f21$var$U = {
    current: null
}, $fa5c07254b0b0f21$var$V = {
    transition: null
}, $fa5c07254b0b0f21$var$W = {
    ReactCurrentDispatcher: $fa5c07254b0b0f21$var$U,
    ReactCurrentBatchConfig: $fa5c07254b0b0f21$var$V,
    ReactCurrentOwner: $fa5c07254b0b0f21$var$K
};
$fa5c07254b0b0f21$export$dca3b0875bd9a954 = {
    map: $fa5c07254b0b0f21$var$S,
    forEach: function forEach(a, b, e) {
        $fa5c07254b0b0f21$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $fa5c07254b0b0f21$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $fa5c07254b0b0f21$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$fa5c07254b0b0f21$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$fa5c07254b0b0f21$export$16fa2f45be04daa8 = $fa5c07254b0b0f21$var$E;
$fa5c07254b0b0f21$export$ffb0004e005737fa = $fa5c07254b0b0f21$var$p;
$fa5c07254b0b0f21$export$e2c29f18771995cb = $fa5c07254b0b0f21$var$r;
$fa5c07254b0b0f21$export$221d75b3f55bb0bd = $fa5c07254b0b0f21$var$G;
$fa5c07254b0b0f21$export$5f8d39834fd61797 = $fa5c07254b0b0f21$var$q;
$fa5c07254b0b0f21$export$74bf444e3cd11ea5 = $fa5c07254b0b0f21$var$w;
$fa5c07254b0b0f21$export$ae55be85d98224ed = $fa5c07254b0b0f21$var$W;
$fa5c07254b0b0f21$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $fa5c07254b0b0f21$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $fa5c07254b0b0f21$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$fa5c07254b0b0f21$var$J.call(b, f) && !$fa5c07254b0b0f21$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $fa5c07254b0b0f21$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$fa5c07254b0b0f21$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $fa5c07254b0b0f21$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $fa5c07254b0b0f21$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$fa5c07254b0b0f21$export$c8a8987d4410bf2d = $fa5c07254b0b0f21$var$M;
$fa5c07254b0b0f21$export$d38cd72104c1f0e9 = function(a) {
    var b = $fa5c07254b0b0f21$var$M.bind(null, a);
    b.type = a;
    return b;
};
$fa5c07254b0b0f21$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$fa5c07254b0b0f21$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $fa5c07254b0b0f21$var$v,
        render: a
    };
};
$fa5c07254b0b0f21$export$a8257692ac88316c = $fa5c07254b0b0f21$var$O;
$fa5c07254b0b0f21$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $fa5c07254b0b0f21$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $fa5c07254b0b0f21$var$T
    };
};
$fa5c07254b0b0f21$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $fa5c07254b0b0f21$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$fa5c07254b0b0f21$export$7568632d0d33d16d = function(a) {
    var b = $fa5c07254b0b0f21$var$V.transition;
    $fa5c07254b0b0f21$var$V.transition = {};
    try {
        a();
    } finally{
        $fa5c07254b0b0f21$var$V.transition = b;
    }
};
$fa5c07254b0b0f21$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$fa5c07254b0b0f21$export$35808ee640e87ca7 = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useCallback(a, b);
};
$fa5c07254b0b0f21$export$fae74005e78b1a27 = function(a) {
    return $fa5c07254b0b0f21$var$U.current.useContext(a);
};
$fa5c07254b0b0f21$export$dc8fbce3eb94dc1e = function() {};
$fa5c07254b0b0f21$export$6a7bc4e911dc01cf = function(a) {
    return $fa5c07254b0b0f21$var$U.current.useDeferredValue(a);
};
$fa5c07254b0b0f21$export$6d9c69b0de29b591 = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useEffect(a, b);
};
$fa5c07254b0b0f21$export$f680877a34711e37 = function() {
    return $fa5c07254b0b0f21$var$U.current.useId();
};
$fa5c07254b0b0f21$export$d5a552a76deda3c2 = function(a, b, e) {
    return $fa5c07254b0b0f21$var$U.current.useImperativeHandle(a, b, e);
};
$fa5c07254b0b0f21$export$aaabe4eda9ed9969 = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useInsertionEffect(a, b);
};
$fa5c07254b0b0f21$export$e5c5a5f917a5871c = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useLayoutEffect(a, b);
};
$fa5c07254b0b0f21$export$1538c33de8887b59 = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useMemo(a, b);
};
$fa5c07254b0b0f21$export$13e3392192263954 = function(a, b, e) {
    return $fa5c07254b0b0f21$var$U.current.useReducer(a, b, e);
};
$fa5c07254b0b0f21$export$b8f5890fc79d6aca = function(a) {
    return $fa5c07254b0b0f21$var$U.current.useRef(a);
};
$fa5c07254b0b0f21$export$60241385465d0a34 = function(a) {
    return $fa5c07254b0b0f21$var$U.current.useState(a);
};
$fa5c07254b0b0f21$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $fa5c07254b0b0f21$var$U.current.useSyncExternalStore(a, b, e);
};
$fa5c07254b0b0f21$export$7b286972b8d8ccbf = function() {
    return $fa5c07254b0b0f21$var$U.current.useTransition();
};
$fa5c07254b0b0f21$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("5t8wa", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3but8"));

});
parcelRegister("3but8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $251a08a6d9ef527f$export$c4744153514ff05d; }, function (v) { return $251a08a6d9ef527f$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $251a08a6d9ef527f$export$3e506c1ccc9cc1a7; }, function (v) { return $251a08a6d9ef527f$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $251a08a6d9ef527f$export$e26fe2ed2fa76875; }, function (v) { return $251a08a6d9ef527f$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $251a08a6d9ef527f$export$502329bbf4b505b1; }, function (v) { return $251a08a6d9ef527f$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $251a08a6d9ef527f$export$6e3807111c4874c4; }, function (v) { return $251a08a6d9ef527f$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $251a08a6d9ef527f$export$c27134553091fb3a; }, function (v) { return $251a08a6d9ef527f$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $251a08a6d9ef527f$export$33ee1acdc04fd2a2; }, function (v) { return $251a08a6d9ef527f$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $251a08a6d9ef527f$export$b00a404bbd5edef2; }, function (v) { return $251a08a6d9ef527f$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $251a08a6d9ef527f$export$8352ce38b91d0c62; }, function (v) { return $251a08a6d9ef527f$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $251a08a6d9ef527f$export$d66a1c1c77bd778b; }, function (v) { return $251a08a6d9ef527f$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $251a08a6d9ef527f$export$d3dfb8e4810cb555; }, function (v) { return $251a08a6d9ef527f$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $251a08a6d9ef527f$export$839f9183b0465a69; }, function (v) { return $251a08a6d9ef527f$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $251a08a6d9ef527f$export$72fdf0e06517287b; }, function (v) { return $251a08a6d9ef527f$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $251a08a6d9ef527f$export$4b844e58a3e414b4; }, function (v) { return $251a08a6d9ef527f$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $251a08a6d9ef527f$export$816d2913ae6b83b1; }, function (v) { return $251a08a6d9ef527f$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $251a08a6d9ef527f$export$61bcfe829111a1d0; }, function (v) { return $251a08a6d9ef527f$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $251a08a6d9ef527f$export$7ee8c9beb337bc3f; }, function (v) { return $251a08a6d9ef527f$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $251a08a6d9ef527f$export$b5836b71941fa3ed; }, function (v) { return $251a08a6d9ef527f$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $251a08a6d9ef527f$export$cf845f2c119da08a; }, function (v) { return $251a08a6d9ef527f$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $251a08a6d9ef527f$export$c4744153514ff05d;
var $251a08a6d9ef527f$export$3e506c1ccc9cc1a7;
var $251a08a6d9ef527f$export$e26fe2ed2fa76875;
var $251a08a6d9ef527f$export$502329bbf4b505b1;
var $251a08a6d9ef527f$export$6e3807111c4874c4;
var $251a08a6d9ef527f$export$c27134553091fb3a;
var $251a08a6d9ef527f$export$33ee1acdc04fd2a2;
var $251a08a6d9ef527f$export$b00a404bbd5edef2;
var $251a08a6d9ef527f$export$8352ce38b91d0c62;
var $251a08a6d9ef527f$export$d66a1c1c77bd778b;
var $251a08a6d9ef527f$export$d3dfb8e4810cb555;
var $251a08a6d9ef527f$export$839f9183b0465a69;
var $251a08a6d9ef527f$export$72fdf0e06517287b;
var $251a08a6d9ef527f$export$4b844e58a3e414b4;
var $251a08a6d9ef527f$export$816d2913ae6b83b1;
var $251a08a6d9ef527f$export$61bcfe829111a1d0;
var $251a08a6d9ef527f$export$7ee8c9beb337bc3f;
var $251a08a6d9ef527f$export$b5836b71941fa3ed;
var $251a08a6d9ef527f$export$cf845f2c119da08a;
"use strict";
function $251a08a6d9ef527f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $251a08a6d9ef527f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $251a08a6d9ef527f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $251a08a6d9ef527f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $251a08a6d9ef527f$var$g(C, c)) n < e && 0 > $251a08a6d9ef527f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $251a08a6d9ef527f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $251a08a6d9ef527f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $251a08a6d9ef527f$var$l = performance;
    $251a08a6d9ef527f$export$c4744153514ff05d = function() {
        return $251a08a6d9ef527f$var$l.now();
    };
} else {
    var $251a08a6d9ef527f$var$p = Date, $251a08a6d9ef527f$var$q = $251a08a6d9ef527f$var$p.now();
    $251a08a6d9ef527f$export$c4744153514ff05d = function() {
        return $251a08a6d9ef527f$var$p.now() - $251a08a6d9ef527f$var$q;
    };
}
var $251a08a6d9ef527f$var$r = [], $251a08a6d9ef527f$var$t = [], $251a08a6d9ef527f$var$u = 1, $251a08a6d9ef527f$var$v = null, $251a08a6d9ef527f$var$y = 3, $251a08a6d9ef527f$var$z = !1, $251a08a6d9ef527f$var$A = !1, $251a08a6d9ef527f$var$B = !1, $251a08a6d9ef527f$var$D = "function" === typeof setTimeout ? setTimeout : null, $251a08a6d9ef527f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $251a08a6d9ef527f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $251a08a6d9ef527f$var$G(a) {
    for(var b = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t); null !== b;){
        if (null === b.callback) $251a08a6d9ef527f$var$k($251a08a6d9ef527f$var$t);
        else if (b.startTime <= a) $251a08a6d9ef527f$var$k($251a08a6d9ef527f$var$t), b.sortIndex = b.expirationTime, $251a08a6d9ef527f$var$f($251a08a6d9ef527f$var$r, b);
        else break;
        b = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t);
    }
}
function $251a08a6d9ef527f$var$H(a) {
    $251a08a6d9ef527f$var$B = !1;
    $251a08a6d9ef527f$var$G(a);
    if (!$251a08a6d9ef527f$var$A) {
        if (null !== $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r)) $251a08a6d9ef527f$var$A = !0, $251a08a6d9ef527f$var$I($251a08a6d9ef527f$var$J);
        else {
            var b = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t);
            null !== b && $251a08a6d9ef527f$var$K($251a08a6d9ef527f$var$H, b.startTime - a);
        }
    }
}
function $251a08a6d9ef527f$var$J(a, b) {
    $251a08a6d9ef527f$var$A = !1;
    $251a08a6d9ef527f$var$B && ($251a08a6d9ef527f$var$B = !1, $251a08a6d9ef527f$var$E($251a08a6d9ef527f$var$L), $251a08a6d9ef527f$var$L = -1);
    $251a08a6d9ef527f$var$z = !0;
    var c = $251a08a6d9ef527f$var$y;
    try {
        $251a08a6d9ef527f$var$G(b);
        for($251a08a6d9ef527f$var$v = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r); null !== $251a08a6d9ef527f$var$v && (!($251a08a6d9ef527f$var$v.expirationTime > b) || a && !$251a08a6d9ef527f$var$M());){
            var d = $251a08a6d9ef527f$var$v.callback;
            if ("function" === typeof d) {
                $251a08a6d9ef527f$var$v.callback = null;
                $251a08a6d9ef527f$var$y = $251a08a6d9ef527f$var$v.priorityLevel;
                var e = d($251a08a6d9ef527f$var$v.expirationTime <= b);
                b = $251a08a6d9ef527f$export$c4744153514ff05d();
                "function" === typeof e ? $251a08a6d9ef527f$var$v.callback = e : $251a08a6d9ef527f$var$v === $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r) && $251a08a6d9ef527f$var$k($251a08a6d9ef527f$var$r);
                $251a08a6d9ef527f$var$G(b);
            } else $251a08a6d9ef527f$var$k($251a08a6d9ef527f$var$r);
            $251a08a6d9ef527f$var$v = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r);
        }
        if (null !== $251a08a6d9ef527f$var$v) var w = !0;
        else {
            var m = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t);
            null !== m && $251a08a6d9ef527f$var$K($251a08a6d9ef527f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $251a08a6d9ef527f$var$v = null, $251a08a6d9ef527f$var$y = c, $251a08a6d9ef527f$var$z = !1;
    }
}
var $251a08a6d9ef527f$var$N = !1, $251a08a6d9ef527f$var$O = null, $251a08a6d9ef527f$var$L = -1, $251a08a6d9ef527f$var$P = 5, $251a08a6d9ef527f$var$Q = -1;
function $251a08a6d9ef527f$var$M() {
    return $251a08a6d9ef527f$export$c4744153514ff05d() - $251a08a6d9ef527f$var$Q < $251a08a6d9ef527f$var$P ? !1 : !0;
}
function $251a08a6d9ef527f$var$R() {
    if (null !== $251a08a6d9ef527f$var$O) {
        var a = $251a08a6d9ef527f$export$c4744153514ff05d();
        $251a08a6d9ef527f$var$Q = a;
        var b = !0;
        try {
            b = $251a08a6d9ef527f$var$O(!0, a);
        } finally{
            b ? $251a08a6d9ef527f$var$S() : ($251a08a6d9ef527f$var$N = !1, $251a08a6d9ef527f$var$O = null);
        }
    } else $251a08a6d9ef527f$var$N = !1;
}
var $251a08a6d9ef527f$var$S;
if ("function" === typeof $251a08a6d9ef527f$var$F) $251a08a6d9ef527f$var$S = function S() {
    $251a08a6d9ef527f$var$F($251a08a6d9ef527f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $251a08a6d9ef527f$var$T = new MessageChannel, $251a08a6d9ef527f$var$U = $251a08a6d9ef527f$var$T.port2;
    $251a08a6d9ef527f$var$T.port1.onmessage = $251a08a6d9ef527f$var$R;
    $251a08a6d9ef527f$var$S = function S() {
        $251a08a6d9ef527f$var$U.postMessage(null);
    };
} else $251a08a6d9ef527f$var$S = function S() {
    $251a08a6d9ef527f$var$D($251a08a6d9ef527f$var$R, 0);
};
function $251a08a6d9ef527f$var$I(a) {
    $251a08a6d9ef527f$var$O = a;
    $251a08a6d9ef527f$var$N || ($251a08a6d9ef527f$var$N = !0, $251a08a6d9ef527f$var$S());
}
function $251a08a6d9ef527f$var$K(a, b) {
    $251a08a6d9ef527f$var$L = $251a08a6d9ef527f$var$D(function() {
        a($251a08a6d9ef527f$export$c4744153514ff05d());
    }, b);
}
$251a08a6d9ef527f$export$3e506c1ccc9cc1a7 = 5;
$251a08a6d9ef527f$export$e26fe2ed2fa76875 = 1;
$251a08a6d9ef527f$export$502329bbf4b505b1 = 4;
$251a08a6d9ef527f$export$6e3807111c4874c4 = 3;
$251a08a6d9ef527f$export$c27134553091fb3a = null;
$251a08a6d9ef527f$export$33ee1acdc04fd2a2 = 2;
$251a08a6d9ef527f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$251a08a6d9ef527f$export$8352ce38b91d0c62 = function() {
    $251a08a6d9ef527f$var$A || $251a08a6d9ef527f$var$z || ($251a08a6d9ef527f$var$A = !0, $251a08a6d9ef527f$var$I($251a08a6d9ef527f$var$J));
};
$251a08a6d9ef527f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $251a08a6d9ef527f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$251a08a6d9ef527f$export$d3dfb8e4810cb555 = function() {
    return $251a08a6d9ef527f$var$y;
};
$251a08a6d9ef527f$export$839f9183b0465a69 = function() {
    return $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r);
};
$251a08a6d9ef527f$export$72fdf0e06517287b = function(a) {
    switch($251a08a6d9ef527f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $251a08a6d9ef527f$var$y;
    }
    var c = $251a08a6d9ef527f$var$y;
    $251a08a6d9ef527f$var$y = b;
    try {
        return a();
    } finally{
        $251a08a6d9ef527f$var$y = c;
    }
};
$251a08a6d9ef527f$export$4b844e58a3e414b4 = function() {};
$251a08a6d9ef527f$export$816d2913ae6b83b1 = function() {};
$251a08a6d9ef527f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $251a08a6d9ef527f$var$y;
    $251a08a6d9ef527f$var$y = a;
    try {
        return b();
    } finally{
        $251a08a6d9ef527f$var$y = c;
    }
};
$251a08a6d9ef527f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $251a08a6d9ef527f$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $251a08a6d9ef527f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $251a08a6d9ef527f$var$f($251a08a6d9ef527f$var$t, a), null === $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r) && a === $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t) && ($251a08a6d9ef527f$var$B ? ($251a08a6d9ef527f$var$E($251a08a6d9ef527f$var$L), $251a08a6d9ef527f$var$L = -1) : $251a08a6d9ef527f$var$B = !0, $251a08a6d9ef527f$var$K($251a08a6d9ef527f$var$H, c - d))) : (a.sortIndex = e, $251a08a6d9ef527f$var$f($251a08a6d9ef527f$var$r, a), $251a08a6d9ef527f$var$A || $251a08a6d9ef527f$var$z || ($251a08a6d9ef527f$var$A = !0, $251a08a6d9ef527f$var$I($251a08a6d9ef527f$var$J)));
    return a;
};
$251a08a6d9ef527f$export$b5836b71941fa3ed = $251a08a6d9ef527f$var$M;
$251a08a6d9ef527f$export$cf845f2c119da08a = function(a) {
    var b = $251a08a6d9ef527f$var$y;
    return function() {
        var c = $251a08a6d9ef527f$var$y;
        $251a08a6d9ef527f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $251a08a6d9ef527f$var$y = c;
        }
    };
};

});



parcelRegister("azwTY", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $7b26b1dce1949a02$export$ffb0004e005737fa; }, function (v) { return $7b26b1dce1949a02$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $7b26b1dce1949a02$export$34b9dba7ce09269b; }, function (v) { return $7b26b1dce1949a02$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $7b26b1dce1949a02$export$25062201e9e25d76; }, function (v) { return $7b26b1dce1949a02$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7b26b1dce1949a02$export$ffb0004e005737fa;
var $7b26b1dce1949a02$export$34b9dba7ce09269b;
var $7b26b1dce1949a02$export$25062201e9e25d76;
"use strict";

var $eHaBZ = parcelRequire("eHaBZ");
var $7b26b1dce1949a02$var$k = Symbol.for("react.element"), $7b26b1dce1949a02$var$l = Symbol.for("react.fragment"), $7b26b1dce1949a02$var$m = Object.prototype.hasOwnProperty, $7b26b1dce1949a02$var$n = $eHaBZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7b26b1dce1949a02$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7b26b1dce1949a02$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7b26b1dce1949a02$var$m.call(a, b) && !$7b26b1dce1949a02$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7b26b1dce1949a02$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7b26b1dce1949a02$var$n.current
    };
}
$7b26b1dce1949a02$export$ffb0004e005737fa = $7b26b1dce1949a02$var$l;
$7b26b1dce1949a02$export$34b9dba7ce09269b = $7b26b1dce1949a02$var$q;
$7b26b1dce1949a02$export$25062201e9e25d76 = $7b26b1dce1949a02$var$q;

});

parcelRegister("fOJyi", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $eDsRw = parcelRequire("eDsRw");
function $b83edc36be0efe6f$var$emptyFunction() {}
function $b83edc36be0efe6f$var$emptyFunctionWithReset() {}
$b83edc36be0efe6f$var$emptyFunctionWithReset.resetWarningCache = $b83edc36be0efe6f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $eDsRw) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $b83edc36be0efe6f$var$emptyFunctionWithReset,
        resetWarningCache: $b83edc36be0efe6f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("eDsRw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $aa7b18ab7f899a3f$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $aa7b18ab7f899a3f$var$ReactPropTypesSecret;

});


parcelRegister("9MAz8", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $71f4f5ea6e688fd1$export$2b8d127b894957b9; }, function (v) { return $71f4f5ea6e688fd1$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $71f4f5ea6e688fd1$export$cea3a54a6425200c; }, function (v) { return $71f4f5ea6e688fd1$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $71f4f5ea6e688fd1$export$a7c73072b1a182ae; }, function (v) { return $71f4f5ea6e688fd1$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $71f4f5ea6e688fd1$export$9f27bc3417b4524d; }, function (v) { return $71f4f5ea6e688fd1$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $71f4f5ea6e688fd1$export$db77ccec0bb4ccac; }, function (v) { return $71f4f5ea6e688fd1$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $71f4f5ea6e688fd1$export$8392c0c9d3dcbd35; }, function (v) { return $71f4f5ea6e688fd1$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $71f4f5ea6e688fd1$export$ffb0004e005737fa; }, function (v) { return $71f4f5ea6e688fd1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $71f4f5ea6e688fd1$export$b624eff549462981; }, function (v) { return $71f4f5ea6e688fd1$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $71f4f5ea6e688fd1$export$7897aa7841a5380c; }, function (v) { return $71f4f5ea6e688fd1$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $71f4f5ea6e688fd1$export$602eac185826482c; }, function (v) { return $71f4f5ea6e688fd1$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $71f4f5ea6e688fd1$export$e2c29f18771995cb; }, function (v) { return $71f4f5ea6e688fd1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $71f4f5ea6e688fd1$export$5f8d39834fd61797; }, function (v) { return $71f4f5ea6e688fd1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $71f4f5ea6e688fd1$export$74bf444e3cd11ea5; }, function (v) { return $71f4f5ea6e688fd1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $71f4f5ea6e688fd1$export$92387174baf9b227; }, function (v) { return $71f4f5ea6e688fd1$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $71f4f5ea6e688fd1$export$ec112efeb987d9c6; }, function (v) { return $71f4f5ea6e688fd1$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $71f4f5ea6e688fd1$export$b706b080d889d2c9; }, function (v) { return $71f4f5ea6e688fd1$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $71f4f5ea6e688fd1$export$5be5a87408f70ddc; }, function (v) { return $71f4f5ea6e688fd1$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $71f4f5ea6e688fd1$export$45a5e7f76e0caa8d; }, function (v) { return $71f4f5ea6e688fd1$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $71f4f5ea6e688fd1$export$455c2e768291efa6; }, function (v) { return $71f4f5ea6e688fd1$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $71f4f5ea6e688fd1$export$9522e17588c12572; }, function (v) { return $71f4f5ea6e688fd1$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $71f4f5ea6e688fd1$export$2110ac352bb060b9; }, function (v) { return $71f4f5ea6e688fd1$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $71f4f5ea6e688fd1$export$56885ab8b9c456ab; }, function (v) { return $71f4f5ea6e688fd1$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $71f4f5ea6e688fd1$export$d927fcb6adf8f9de; }, function (v) { return $71f4f5ea6e688fd1$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $71f4f5ea6e688fd1$export$b82d16f27459e05a; }, function (v) { return $71f4f5ea6e688fd1$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $71f4f5ea6e688fd1$export$522c17b4f5e123e8; }, function (v) { return $71f4f5ea6e688fd1$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $71f4f5ea6e688fd1$export$1aabd8a0274ecfd6; }, function (v) { return $71f4f5ea6e688fd1$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $71f4f5ea6e688fd1$export$9b621391a187a31a; }, function (v) { return $71f4f5ea6e688fd1$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $71f4f5ea6e688fd1$export$f5bbd400c2f4426f; }, function (v) { return $71f4f5ea6e688fd1$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $71f4f5ea6e688fd1$export$2b8d127b894957b9;
var $71f4f5ea6e688fd1$export$cea3a54a6425200c;
var $71f4f5ea6e688fd1$export$a7c73072b1a182ae;
var $71f4f5ea6e688fd1$export$9f27bc3417b4524d;
var $71f4f5ea6e688fd1$export$db77ccec0bb4ccac;
var $71f4f5ea6e688fd1$export$8392c0c9d3dcbd35;
var $71f4f5ea6e688fd1$export$ffb0004e005737fa;
var $71f4f5ea6e688fd1$export$b624eff549462981;
var $71f4f5ea6e688fd1$export$7897aa7841a5380c;
var $71f4f5ea6e688fd1$export$602eac185826482c;
var $71f4f5ea6e688fd1$export$e2c29f18771995cb;
var $71f4f5ea6e688fd1$export$5f8d39834fd61797;
var $71f4f5ea6e688fd1$export$74bf444e3cd11ea5;
var $71f4f5ea6e688fd1$export$92387174baf9b227;
var $71f4f5ea6e688fd1$export$ec112efeb987d9c6;
var $71f4f5ea6e688fd1$export$b706b080d889d2c9;
var $71f4f5ea6e688fd1$export$5be5a87408f70ddc;
var $71f4f5ea6e688fd1$export$45a5e7f76e0caa8d;
var $71f4f5ea6e688fd1$export$455c2e768291efa6;
var $71f4f5ea6e688fd1$export$9522e17588c12572;
var $71f4f5ea6e688fd1$export$2110ac352bb060b9;
var $71f4f5ea6e688fd1$export$56885ab8b9c456ab;
var $71f4f5ea6e688fd1$export$d927fcb6adf8f9de;
var $71f4f5ea6e688fd1$export$b82d16f27459e05a;
var $71f4f5ea6e688fd1$export$522c17b4f5e123e8;
var $71f4f5ea6e688fd1$export$1aabd8a0274ecfd6;
var $71f4f5ea6e688fd1$export$9b621391a187a31a;
var $71f4f5ea6e688fd1$export$f5bbd400c2f4426f;
"use strict";
var $71f4f5ea6e688fd1$var$b = "function" === typeof Symbol && Symbol.for, $71f4f5ea6e688fd1$var$c = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.element") : 60103, $71f4f5ea6e688fd1$var$d = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.portal") : 60106, $71f4f5ea6e688fd1$var$e = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.fragment") : 60107, $71f4f5ea6e688fd1$var$f = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.strict_mode") : 60108, $71f4f5ea6e688fd1$var$g = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.profiler") : 60114, $71f4f5ea6e688fd1$var$h = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.provider") : 60109, $71f4f5ea6e688fd1$var$k = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.context") : 60110, $71f4f5ea6e688fd1$var$l = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.async_mode") : 60111, $71f4f5ea6e688fd1$var$m = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.concurrent_mode") : 60111, $71f4f5ea6e688fd1$var$n = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.forward_ref") : 60112, $71f4f5ea6e688fd1$var$p = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.suspense") : 60113, $71f4f5ea6e688fd1$var$q = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.suspense_list") : 60120, $71f4f5ea6e688fd1$var$r = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.memo") : 60115, $71f4f5ea6e688fd1$var$t = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.lazy") : 60116, $71f4f5ea6e688fd1$var$v = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.block") : 60121, $71f4f5ea6e688fd1$var$w = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.fundamental") : 60117, $71f4f5ea6e688fd1$var$x = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.responder") : 60118, $71f4f5ea6e688fd1$var$y = $71f4f5ea6e688fd1$var$b ? Symbol.for("react.scope") : 60119;
function $71f4f5ea6e688fd1$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $71f4f5ea6e688fd1$var$c:
                switch(a = a.type, a){
                    case $71f4f5ea6e688fd1$var$l:
                    case $71f4f5ea6e688fd1$var$m:
                    case $71f4f5ea6e688fd1$var$e:
                    case $71f4f5ea6e688fd1$var$g:
                    case $71f4f5ea6e688fd1$var$f:
                    case $71f4f5ea6e688fd1$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $71f4f5ea6e688fd1$var$k:
                            case $71f4f5ea6e688fd1$var$n:
                            case $71f4f5ea6e688fd1$var$t:
                            case $71f4f5ea6e688fd1$var$r:
                            case $71f4f5ea6e688fd1$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $71f4f5ea6e688fd1$var$d:
                return u;
        }
    }
}
function $71f4f5ea6e688fd1$var$A(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$m;
}
$71f4f5ea6e688fd1$export$2b8d127b894957b9 = $71f4f5ea6e688fd1$var$l;
$71f4f5ea6e688fd1$export$cea3a54a6425200c = $71f4f5ea6e688fd1$var$m;
$71f4f5ea6e688fd1$export$a7c73072b1a182ae = $71f4f5ea6e688fd1$var$k;
$71f4f5ea6e688fd1$export$9f27bc3417b4524d = $71f4f5ea6e688fd1$var$h;
$71f4f5ea6e688fd1$export$db77ccec0bb4ccac = $71f4f5ea6e688fd1$var$c;
$71f4f5ea6e688fd1$export$8392c0c9d3dcbd35 = $71f4f5ea6e688fd1$var$n;
$71f4f5ea6e688fd1$export$ffb0004e005737fa = $71f4f5ea6e688fd1$var$e;
$71f4f5ea6e688fd1$export$b624eff549462981 = $71f4f5ea6e688fd1$var$t;
$71f4f5ea6e688fd1$export$7897aa7841a5380c = $71f4f5ea6e688fd1$var$r;
$71f4f5ea6e688fd1$export$602eac185826482c = $71f4f5ea6e688fd1$var$d;
$71f4f5ea6e688fd1$export$e2c29f18771995cb = $71f4f5ea6e688fd1$var$g;
$71f4f5ea6e688fd1$export$5f8d39834fd61797 = $71f4f5ea6e688fd1$var$f;
$71f4f5ea6e688fd1$export$74bf444e3cd11ea5 = $71f4f5ea6e688fd1$var$p;
$71f4f5ea6e688fd1$export$92387174baf9b227 = function(a) {
    return $71f4f5ea6e688fd1$var$A(a) || $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$l;
};
$71f4f5ea6e688fd1$export$ec112efeb987d9c6 = $71f4f5ea6e688fd1$var$A;
$71f4f5ea6e688fd1$export$b706b080d889d2c9 = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$k;
};
$71f4f5ea6e688fd1$export$5be5a87408f70ddc = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$h;
};
$71f4f5ea6e688fd1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $71f4f5ea6e688fd1$var$c;
};
$71f4f5ea6e688fd1$export$455c2e768291efa6 = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$n;
};
$71f4f5ea6e688fd1$export$9522e17588c12572 = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$e;
};
$71f4f5ea6e688fd1$export$2110ac352bb060b9 = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$t;
};
$71f4f5ea6e688fd1$export$56885ab8b9c456ab = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$r;
};
$71f4f5ea6e688fd1$export$d927fcb6adf8f9de = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$d;
};
$71f4f5ea6e688fd1$export$b82d16f27459e05a = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$g;
};
$71f4f5ea6e688fd1$export$522c17b4f5e123e8 = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$f;
};
$71f4f5ea6e688fd1$export$1aabd8a0274ecfd6 = function(a) {
    return $71f4f5ea6e688fd1$var$z(a) === $71f4f5ea6e688fd1$var$p;
};
$71f4f5ea6e688fd1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $71f4f5ea6e688fd1$var$e || a === $71f4f5ea6e688fd1$var$m || a === $71f4f5ea6e688fd1$var$g || a === $71f4f5ea6e688fd1$var$f || a === $71f4f5ea6e688fd1$var$p || a === $71f4f5ea6e688fd1$var$q || "object" === typeof a && null !== a && (a.$$typeof === $71f4f5ea6e688fd1$var$t || a.$$typeof === $71f4f5ea6e688fd1$var$r || a.$$typeof === $71f4f5ea6e688fd1$var$h || a.$$typeof === $71f4f5ea6e688fd1$var$k || a.$$typeof === $71f4f5ea6e688fd1$var$n || a.$$typeof === $71f4f5ea6e688fd1$var$w || a.$$typeof === $71f4f5ea6e688fd1$var$x || a.$$typeof === $71f4f5ea6e688fd1$var$y || a.$$typeof === $71f4f5ea6e688fd1$var$v);
};
$71f4f5ea6e688fd1$export$f5bbd400c2f4426f = $71f4f5ea6e688fd1$var$z;

});

parcelRegister("lELzA", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $fc423c6bbd4d8d14$export$306c0aa65ff9ec16; }, function (v) { return $fc423c6bbd4d8d14$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fc423c6bbd4d8d14$export$306c0aa65ff9ec16;
"use strict";

var $eHaBZ = parcelRequire("eHaBZ");
function $fc423c6bbd4d8d14$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fc423c6bbd4d8d14$var$k = "function" === typeof Object.is ? Object.is : $fc423c6bbd4d8d14$var$h, $fc423c6bbd4d8d14$var$l = $eHaBZ.useState, $fc423c6bbd4d8d14$var$m = $eHaBZ.useEffect, $fc423c6bbd4d8d14$var$n = $eHaBZ.useLayoutEffect, $fc423c6bbd4d8d14$var$p = $eHaBZ.useDebugValue;
function $fc423c6bbd4d8d14$var$q(a, b) {
    var d = b(), f = $fc423c6bbd4d8d14$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $fc423c6bbd4d8d14$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $fc423c6bbd4d8d14$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $fc423c6bbd4d8d14$var$m(function() {
        $fc423c6bbd4d8d14$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $fc423c6bbd4d8d14$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $fc423c6bbd4d8d14$var$p(d);
    return d;
}
function $fc423c6bbd4d8d14$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$fc423c6bbd4d8d14$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $fc423c6bbd4d8d14$var$t(a, b) {
    return b();
}
var $fc423c6bbd4d8d14$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $fc423c6bbd4d8d14$var$t : $fc423c6bbd4d8d14$var$q;
$fc423c6bbd4d8d14$export$306c0aa65ff9ec16 = void 0 !== $eHaBZ.useSyncExternalStore ? $eHaBZ.useSyncExternalStore : $fc423c6bbd4d8d14$var$u;

});

var $61e8f293f375c170$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $61e8f293f375c170$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $61e8f293f375c170$exports));
try {
    regeneratorRuntime = $61e8f293f375c170$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $61e8f293f375c170$var$runtime;
    else Function("r", "regeneratorRuntime = r")($61e8f293f375c170$var$runtime);
}


function $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $14c571840e589f0e$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $2bfPH = parcelRequire("2bfPH");
var $4fa1715f971c561b$var$extendStatics = function extendStatics1(d, b) {
    $4fa1715f971c561b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4fa1715f971c561b$var$extendStatics(d, b);
};
function $4fa1715f971c561b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4fa1715f971c561b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4fa1715f971c561b$export$18ce0697a983be9b = function __assign1() {
    $4fa1715f971c561b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fa1715f971c561b$export$18ce0697a983be9b.apply(this, arguments);
};
function $4fa1715f971c561b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4fa1715f971c561b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4fa1715f971c561b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4fa1715f971c561b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4fa1715f971c561b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4fa1715f971c561b$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x)) === "symbol" ? x : "".concat(x);
}
function $4fa1715f971c561b$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $2bfPH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4fa1715f971c561b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4fa1715f971c561b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4fa1715f971c561b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4fa1715f971c561b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4fa1715f971c561b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4fa1715f971c561b$export$45d3717a4c69092e(o, m, p);
}
function $4fa1715f971c561b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4fa1715f971c561b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4fa1715f971c561b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4fa1715f971c561b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4fa1715f971c561b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4fa1715f971c561b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4fa1715f971c561b$export$10c90e4f7922046c(v) {
    return this instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? (this.v = v, this) : new $4fa1715f971c561b$export$10c90e4f7922046c(v);
}
function $4fa1715f971c561b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4fa1715f971c561b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4fa1715f971c561b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4fa1715f971c561b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4fa1715f971c561b$export$19a8beecd37a4c45 === "function" ? $4fa1715f971c561b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4fa1715f971c561b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4fa1715f971c561b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4fa1715f971c561b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4fa1715f971c561b$export$45d3717a4c69092e(result, mod, k);
    }
    $4fa1715f971c561b$var$__setModuleDefault(result, mod);
    return result;
}
function $4fa1715f971c561b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4fa1715f971c561b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4fa1715f971c561b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4fa1715f971c561b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4fa1715f971c561b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4fa1715f971c561b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4fa1715f971c561b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4fa1715f971c561b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $4fa1715f971c561b$export$2e2bcd8739ae039 = {
    __extends: $4fa1715f971c561b$export$a8ba968b8961cb8a,
    __assign: $4fa1715f971c561b$export$18ce0697a983be9b,
    __rest: $4fa1715f971c561b$export$3c9a16f847548506,
    __decorate: $4fa1715f971c561b$export$29e00dfd3077644b,
    __param: $4fa1715f971c561b$export$d5ad3fd78186038f,
    __metadata: $4fa1715f971c561b$export$f1db080c865becb9,
    __awaiter: $4fa1715f971c561b$export$1050f835b63b671e,
    __generator: $4fa1715f971c561b$export$67ebef60e6f28a6,
    __createBinding: $4fa1715f971c561b$export$45d3717a4c69092e,
    __exportStar: $4fa1715f971c561b$export$f33643c0debef087,
    __values: $4fa1715f971c561b$export$19a8beecd37a4c45,
    __read: $4fa1715f971c561b$export$8d051b38c9118094,
    __spread: $4fa1715f971c561b$export$afc72e2116322959,
    __spreadArrays: $4fa1715f971c561b$export$6388937ca91ccae8,
    __spreadArray: $4fa1715f971c561b$export$1216008129fb82ed,
    __await: $4fa1715f971c561b$export$10c90e4f7922046c,
    __asyncGenerator: $4fa1715f971c561b$export$e427f37a30a4de9b,
    __asyncDelegator: $4fa1715f971c561b$export$bbd80228419bb833,
    __asyncValues: $4fa1715f971c561b$export$e3b29a3d6162315f,
    __makeTemplateObject: $4fa1715f971c561b$export$4fb47efe1390b86f,
    __importStar: $4fa1715f971c561b$export$c21735bcef00d192,
    __importDefault: $4fa1715f971c561b$export$da59b14a69baef04,
    __classPrivateFieldGet: $4fa1715f971c561b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4fa1715f971c561b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4fa1715f971c561b$export$81fdc39f203e4e04,
    __addDisposableResource: $4fa1715f971c561b$export$88ac25d8e944e405,
    __disposeResources: $4fa1715f971c561b$export$8f076105dc360e92
};


var $59e7dcc9c52865c1$export$882461b6382ed46c;
var $59e7dcc9c52865c1$export$757ceba2d55c277e;
"use strict";
var $8afcda7f6e55ccf7$exports = {};
"use strict";
function $8afcda7f6e55ccf7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8afcda7f6e55ccf7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8afcda7f6e55ccf7$var$checkDCE();

$8afcda7f6e55ccf7$exports = (parcelRequire("gKWsR"));


var $59e7dcc9c52865c1$var$i;
$59e7dcc9c52865c1$export$882461b6382ed46c = $8afcda7f6e55ccf7$exports.createRoot;
$59e7dcc9c52865c1$export$757ceba2d55c277e = $8afcda7f6e55ccf7$exports.hydrateRoot;


function $bcce38db0d2b4516$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $6b55e905aa672e6c$export$c2c98ac76e997b63(o, p) {
    $6b55e905aa672e6c$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6b55e905aa672e6c$export$c2c98ac76e997b63(o, p);
}


function $0951870dac564cbc$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $6b55e905aa672e6c$export$c2c98ac76e997b63)(subClass, superClass);
}


function $e0202b2b0021476d$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $d2535f9282d6afd9$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $e0202b2b0021476d$export$685354647fba1516)()) $d2535f9282d6afd9$export$2d841144c5f8c4ab = Reflect.construct;
    else $d2535f9282d6afd9$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $6b55e905aa672e6c$export$c2c98ac76e997b63)(instance, Class.prototype);
        return instance;
    };
    return $d2535f9282d6afd9$export$2d841144c5f8c4ab.apply(null, arguments);
}


function $5982ea1ba8b4c6e7$export$f09211a7d3c496a1(o) {
    $5982ea1ba8b4c6e7$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5982ea1ba8b4c6e7$export$f09211a7d3c496a1(o);
}


function $070a8cede0f67609$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $9f87b386401b733e$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $9f87b386401b733e$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $070a8cede0f67609$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $d2535f9282d6afd9$export$2d841144c5f8c4ab)(Class, arguments, (0, $5982ea1ba8b4c6e7$export$f09211a7d3c496a1)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $6b55e905aa672e6c$export$c2c98ac76e997b63)(Wrapper, Class);
    };
    return $9f87b386401b733e$export$2466d533fda16e33(Class);
}




function $ee29917471fa094f$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $2bfPH = parcelRequire("2bfPH");
function $95d08371c2c4ef4e$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $2bfPH._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(self);
}


function $59441bceea5b2713$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $e0202b2b0021476d$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $5982ea1ba8b4c6e7$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5982ea1ba8b4c6e7$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $95d08371c2c4ef4e$export$ef97c660ca164e52)(this, result);
    };
}






var $0d06257c362dc1a1$export$1871035840b7f83a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(OfflineStorageNotAvailableError, Error1);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(OfflineStorageNotAvailableError);
    function OfflineStorageNotAvailableError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Offline storage is not available";
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, OfflineStorageNotAvailableError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "OfflineStorageNotAvailableError";
        return _this;
    }
    return OfflineStorageNotAvailableError;
}((0, $9f87b386401b733e$export$2466d533fda16e33)(Error));
var $0d06257c362dc1a1$export$66d311bf29d5c89c = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(TimeoutError, Error1);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(TimeoutError);
    function TimeoutError(message) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, TimeoutError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "TimeoutError";
        return _this;
    }
    return TimeoutError;
}((0, $9f87b386401b733e$export$2466d533fda16e33)(Error));
var $0d06257c362dc1a1$export$65bd6083489bd8bb = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(HttpError, Error1);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(HttpError);
    function HttpError(message) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, HttpError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "HttpError";
        return _this;
    }
    return HttpError;
}((0, $9f87b386401b733e$export$2466d533fda16e33)(Error));
var $0d06257c362dc1a1$export$5e64a9683d127ef6 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(LoginError, Error1);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(LoginError);
    function LoginError(message) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, LoginError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "LoginError";
        return _this;
    }
    return LoginError;
}((0, $9f87b386401b733e$export$2466d533fda16e33)(Error));
var $0d06257c362dc1a1$export$4511c7da58e2d9c2 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(UnexpectedStateError, Error1);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(UnexpectedStateError);
    function UnexpectedStateError(message) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, UnexpectedStateError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "UnexpectedStateError";
        return _this;
    }
    return UnexpectedStateError;
}((0, $9f87b386401b733e$export$2466d533fda16e33)(Error));


var $32ae13b741542474$exports = {};

$parcel$export($32ae13b741542474$exports, "rejectUnless", function () { return $32ae13b741542474$export$8d90b058a02656d9; });
$parcel$export($32ae13b741542474$exports, "rejectIfNotOkay", function () { return $32ae13b741542474$export$3a2f576a374b4dda; });
$parcel$export($32ae13b741542474$exports, "options", function () { return $32ae13b741542474$export$41c562ebe57d11e2; });
$parcel$export($32ae13b741542474$exports, "option", function () { return $32ae13b741542474$export$a75d1723e6bda2ec; });
$parcel$export($32ae13b741542474$exports, "headers", function () { return $32ae13b741542474$export$838e2a576d4d6ff6; });
$parcel$export($32ae13b741542474$exports, "header", function () { return $32ae13b741542474$export$38e42c68cf43b5d4; });
$parcel$export($32ae13b741542474$exports, "liftToPromiseField", function () { return $32ae13b741542474$export$e39d76e25ce37988; });
$parcel$export($32ae13b741542474$exports, "makeAbortableFetch", function () { return $32ae13b741542474$export$9c77439751b4390b; });
$parcel$export($32ae13b741542474$exports, "makeFetchWithTimeout", function () { return $32ae13b741542474$export$e9a8372937ef7f1; });
$parcel$export($32ae13b741542474$exports, "makeFetchFailOnHttpErrors", function () { return $32ae13b741542474$export$fe633c745f42b5cd; });
$parcel$export($32ae13b741542474$exports, "makeFetchSupportGetBody", function () { return $32ae13b741542474$export$f4ba43f659d5549c; });
$parcel$export($32ae13b741542474$exports, "fetch", function () { return $32ae13b741542474$export$e7aa7bc5c1b3cfb3; });
$parcel$export($32ae13b741542474$exports, "get", function () { return $32ae13b741542474$export$3988ae62b71be9a3; });
$parcel$export($32ae13b741542474$exports, "post", function () { return $32ae13b741542474$export$299ba2dee77727e9; });
$parcel$export($32ae13b741542474$exports, "delete_", function () { return $32ae13b741542474$export$38dab5a9fea42f39; });
$parcel$export($32ae13b741542474$exports, "makeSearchParams", function () { return $32ae13b741542474$export$92871f7982deaf9f; });
function $ec426015f75d7738$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $fa9769297b8a68c8$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $c19975616f0f5e3a$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $7e86f5813bbb0f77$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $c19975616f0f5e3a$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


function $94d3f045916e0583$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $b0c62864eda90b51$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $2b2eb8ca3633154b$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $7b161889ca248e24$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d6f91c356a8197fd$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7b161889ca248e24$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7b161889ca248e24$export$79e617b1955a2616)(o, minLen);
}


function $bd823d1c24941985$export$e62c166da838fa3(arr) {
    return (0, $94d3f045916e0583$export$e6256bf45c68d561)(arr) || (0, $b0c62864eda90b51$export$1eb58a6e75231000)(arr) || (0, $d6f91c356a8197fd$export$a5be06335b3a083c)(arr) || (0, $2b2eb8ca3633154b$export$60dbc22abd7da546)();
}



function $f8a29d58f287cd3d$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $7b161889ca248e24$export$79e617b1955a2616)(arr);
}



function $cf17359bdd687909$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $4c858c0d999a5b9b$export$1b5e630bc3aea29f(arr) {
    return (0, $f8a29d58f287cd3d$export$7e0947b5ad3404e2)(arr) || (0, $b0c62864eda90b51$export$1eb58a6e75231000)(arr) || (0, $d6f91c356a8197fd$export$a5be06335b3a083c)(arr) || (0, $cf17359bdd687909$export$e6f3c4780d19eb2b)();
}


var $16bf04b797257b4a$exports = {};

var $2bfPH = parcelRequire("2bfPH");
$16bf04b797257b4a$exports = function(data) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var sorted = opts.sorted, ignorenull = opts.ignorenull, ignoreEmptyArray = opts.ignoreEmptyArray, useDot = opts.useDot, skipIndex = opts.skipIndex, skipBracket = opts.skipBracket, _opts_whitespace = opts.whitespace, whitespace = _opts_whitespace === void 0 ? "+" : _opts_whitespace;
    var encode = function(value) {
        return String(value).replace(RegExp("[^ !'()~*]", "gu"), encodeURIComponent).replace(/ /g, whitespace).replace(/[!'()~*]/g, function(ch) {
            return "%".concat(ch.charCodeAt().toString(16).slice(-2).toUpperCase());
        });
    };
    var keys = function(obj) {
        var keyarr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Object.keys(obj);
        return sorted ? keyarr.sort() : keyarr;
    };
    var filterjoin = function(arr) {
        return arr.filter(function(e) {
            return e;
        }).join("&");
    };
    var objnest = function(name, obj) {
        return filterjoin(keys(obj).map(function(key) {
            return useDot ? nest("".concat(name, ".").concat(key), obj[key]) : nest("".concat(name, "[").concat(key, "]"), obj[key]);
        }));
    };
    var arrnest = function(name, arr) {
        var brackets = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : skipBracket ? "" : "[]";
        return arr.length ? filterjoin(arr.map(function(elem, index) {
            return skipIndex ? nest(name + brackets, elem) : nest(name + "[" + index + "]", elem);
        })) : ignoreEmptyArray ? null : encode(name + brackets);
    };
    var setnest = function(name, set) {
        return filterjoin(Array.from(set).map(function(elem) {
            return nest(name, elem);
        }));
    };
    var nest = function(name, value) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value), f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        if (value === f) f = ignorenull ? f : encode(name) + "=" + f;
        else if (/string|number|boolean/.test(type)) f = encode(name) + "=" + encode(value);
        else if (Array.isArray(value)) f = arrnest(name, value);
        else if (value instanceof Set) f = setnest(name, value);
        else if (type === "object") f = objnest(name, value);
        return f;
    };
    return data && filterjoin(keys(data).map(function(key) {
        return nest(key, data[key]);
    }));
};


var $c41432d844932dcf$exports = {};
var $16cdbc498258dabf$exports = {};
var $7e9ffa7fa815703c$exports = {};
var $f6709ecef4b253a2$exports = {};
function $f6709ecef4b253a2$var$_isPlaceholder(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}
$f6709ecef4b253a2$exports = $f6709ecef4b253a2$var$_isPlaceholder;


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $7e9ffa7fa815703c$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $f6709ecef4b253a2$exports(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
$7e9ffa7fa815703c$exports = $7e9ffa7fa815703c$var$_curry1;



/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $16cdbc498258dabf$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $f6709ecef4b253a2$exports(a) ? f2 : $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? f2 : $f6709ecef4b253a2$exports(a) ? $7e9ffa7fa815703c$exports(function(_a) {
                    return fn(_a, b);
                }) : $f6709ecef4b253a2$exports(b) ? $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
$16cdbc498258dabf$exports = $16cdbc498258dabf$var$_curry2;


var $c1dff8cdd11e90ef$exports = {};
var $80cb0262fd5157fd$exports = {};



/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $80cb0262fd5157fd$var$_curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return $f6709ecef4b253a2$exports(a) ? f3 : $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? f3 : $f6709ecef4b253a2$exports(a) ? $16cdbc498258dabf$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $f6709ecef4b253a2$exports(b) ? $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $7e9ffa7fa815703c$exports(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) && $f6709ecef4b253a2$exports(c) ? f3 : $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? $16cdbc498258dabf$exports(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(c) ? $16cdbc498258dabf$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $f6709ecef4b253a2$exports(b) && $f6709ecef4b253a2$exports(c) ? $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $f6709ecef4b253a2$exports(a) ? $7e9ffa7fa815703c$exports(function(_a) {
                    return fn(_a, b, c);
                }) : $f6709ecef4b253a2$exports(b) ? $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b, c);
                }) : $f6709ecef4b253a2$exports(c) ? $7e9ffa7fa815703c$exports(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}
$80cb0262fd5157fd$exports = $80cb0262fd5157fd$var$_curry3;


var $db378aa7becbce1c$exports = {};
function $db378aa7becbce1c$var$_isObject(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}
$db378aa7becbce1c$exports = $db378aa7becbce1c$var$_isObject;


var $5b93c9afa1b3d914$exports = {};

var $8659c368bdbba7be$exports = {};
function $8659c368bdbba7be$var$_has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
$8659c368bdbba7be$exports = $8659c368bdbba7be$var$_has;


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $5b93c9afa1b3d914$var$mergeWithKey = /*#__PURE__*/ $80cb0262fd5157fd$exports(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    l = l || {};
    r = r || {};
    for(k in l)if ($8659c368bdbba7be$exports(k, l)) result[k] = $8659c368bdbba7be$exports(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ($8659c368bdbba7be$exports(k, r) && !$8659c368bdbba7be$exports(k, result)) result[k] = r[k];
    return result;
});
$5b93c9afa1b3d914$exports = $5b93c9afa1b3d914$var$mergeWithKey;


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $c1dff8cdd11e90ef$var$mergeDeepWithKey = /*#__PURE__*/ $80cb0262fd5157fd$exports(function mergeDeepWithKey(fn, lObj, rObj) {
    return $5b93c9afa1b3d914$exports(function(k, lVal, rVal) {
        if ($db378aa7becbce1c$exports(lVal) && $db378aa7becbce1c$exports(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
$c1dff8cdd11e90ef$exports = $c1dff8cdd11e90ef$var$mergeDeepWithKey;


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $c41432d844932dcf$var$mergeDeepLeft = /*#__PURE__*/ $16cdbc498258dabf$exports(function mergeDeepLeft(lObj, rObj) {
    return $c1dff8cdd11e90ef$exports(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
$c41432d844932dcf$exports = $c41432d844932dcf$var$mergeDeepLeft;


var $d260ff7ca3ce6993$exports = {};
var $7629ad89266bbe6b$exports = {};
function $7629ad89266bbe6b$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}
$7629ad89266bbe6b$exports = $7629ad89266bbe6b$var$_arity;


var $b5790e78e290f7f4$exports = {};
function $b5790e78e290f7f4$var$_pipe(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}
$b5790e78e290f7f4$exports = $b5790e78e290f7f4$var$_pipe;


var $c4fccbe08b9f0fad$exports = {};

var $bdafe3f0d791dda7$exports = {};
var $f02a59ea5dc135be$exports = {};
var $67c81c8b457540e6$exports = {};

var $73fb5ea04d9dead1$exports = {};
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ $73fb5ea04d9dead1$exports = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};


var $04e2efa5ca25c0f3$exports = {};
function $04e2efa5ca25c0f3$var$_isString(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}
$04e2efa5ca25c0f3$exports = $04e2efa5ca25c0f3$var$_isString;


/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $67c81c8b457540e6$var$_isArrayLike = /*#__PURE__*/ $7e9ffa7fa815703c$exports(function isArrayLike(x) {
    if ($73fb5ea04d9dead1$exports(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ($04e2efa5ca25c0f3$exports(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
$67c81c8b457540e6$exports = $67c81c8b457540e6$var$_isArrayLike;


var $f02a59ea5dc135be$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $f02a59ea5dc135be$var$_createReduce(arrayReduce, methodReduce, iterableReduce) {
    return function _reduce(xf, acc, list) {
        if ($67c81c8b457540e6$exports(list)) return arrayReduce(xf, acc, list);
        if (list == null) return acc;
        if (typeof list["fantasy-land/reduce"] === "function") return methodReduce(xf, acc, list, "fantasy-land/reduce");
        if (list[$f02a59ea5dc135be$var$symIterator] != null) return iterableReduce(xf, acc, list[$f02a59ea5dc135be$var$symIterator]());
        if (typeof list.next === "function") return iterableReduce(xf, acc, list);
        if (typeof list.reduce === "function") return methodReduce(xf, acc, list, "reduce");
        throw new TypeError("reduce: list must be array or iterable");
    };
}
$f02a59ea5dc135be$exports = $f02a59ea5dc135be$var$_createReduce;


var $4b2ec1de5112b3cd$exports = {};
function $4b2ec1de5112b3cd$var$_xArrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
$4b2ec1de5112b3cd$exports = $4b2ec1de5112b3cd$var$_xArrayReduce;


var $367e3100760e4974$exports = {};


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $367e3100760e4974$var$bind = /*#__PURE__*/ $16cdbc498258dabf$exports(function bind(fn, thisObj) {
    return $7629ad89266bbe6b$exports(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
$367e3100760e4974$exports = $367e3100760e4974$var$bind;


function $bdafe3f0d791dda7$var$_xIterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $bdafe3f0d791dda7$var$_xMethodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]($367e3100760e4974$exports(xf["@@transducer/step"], xf), acc));
}
var $bdafe3f0d791dda7$var$_xReduce = /*#__PURE__*/ $f02a59ea5dc135be$exports($4b2ec1de5112b3cd$exports, $bdafe3f0d791dda7$var$_xMethodReduce, $bdafe3f0d791dda7$var$_xIterableReduce);
$bdafe3f0d791dda7$exports = $bdafe3f0d791dda7$var$_xReduce;


var $fcc04a1cf53b4b80$exports = {};
var $fcc04a1cf53b4b80$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $fcc04a1cf53b4b80$var$_xwrap(fn) {
    return new $fcc04a1cf53b4b80$var$XWrap(fn);
}
$fcc04a1cf53b4b80$exports = $fcc04a1cf53b4b80$var$_xwrap;


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $c4fccbe08b9f0fad$var$reduce = /*#__PURE__*/ $80cb0262fd5157fd$exports(function(xf, acc, list) {
    return $bdafe3f0d791dda7$exports(typeof xf === "function" ? $fcc04a1cf53b4b80$exports(xf) : xf, acc, list);
});
$c4fccbe08b9f0fad$exports = $c4fccbe08b9f0fad$var$reduce;


var $9b7ae0ca44597272$exports = {};
var $9c866f84cc2fbcff$exports = {};

/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implementation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */ function $9c866f84cc2fbcff$var$_checkForMethod(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return $73fb5ea04d9dead1$exports(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}
$9c866f84cc2fbcff$exports = $9c866f84cc2fbcff$var$_checkForMethod;



var $b62da072c6a6f6e5$exports = {};


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $b62da072c6a6f6e5$var$slice = /*#__PURE__*/ $80cb0262fd5157fd$exports(/*#__PURE__*/ $9c866f84cc2fbcff$exports("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
$b62da072c6a6f6e5$exports = $b62da072c6a6f6e5$var$slice;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $9b7ae0ca44597272$var$tail = /*#__PURE__*/ $7e9ffa7fa815703c$exports(/*#__PURE__*/ $9c866f84cc2fbcff$exports("tail", /*#__PURE__*/ $b62da072c6a6f6e5$exports(1, Infinity)));
$9b7ae0ca44597272$exports = $9b7ae0ca44597272$var$tail;


/**
 * Performs left-to-right function composition. The first argument may have
 * any arity; the remaining arguments must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      const f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
 */ function $d260ff7ca3ce6993$var$pipe() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return $7629ad89266bbe6b$exports(arguments[0].length, $c4fccbe08b9f0fad$exports($b5790e78e290f7f4$exports, arguments[0], $9b7ae0ca44597272$exports(arguments)));
}
$d260ff7ca3ce6993$exports = $d260ff7ca3ce6993$var$pipe;



var $32ae13b741542474$var$_this = undefined;
var $32ae13b741542474$export$8d90b058a02656d9 = function(pred) {
    return function(response) {
        if (pred(response)) return response;
        else {
            var err = new (0, $0d06257c362dc1a1$export$65bd6083489bd8bb)(response.statusText);
            err.response = response;
            throw err;
        }
    };
};
var $32ae13b741542474$export$3a2f576a374b4dda = function(response) {
    return $32ae13b741542474$export$8d90b058a02656d9(function(response) {
        return response.ok;
    })(response);
};
var $32ae13b741542474$export$41c562ebe57d11e2 = function(newOpts) {
    return function(fetch) {
        return function(url) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return fetch(url, (0, (/*@__PURE__*/$parcel$interopDefault($c41432d844932dcf$exports)))(opts, newOpts));
        };
    };
};
var $32ae13b741542474$export$a75d1723e6bda2ec = function(name, value) {
    return $32ae13b741542474$export$41c562ebe57d11e2((0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, name, value));
};
var $32ae13b741542474$export$838e2a576d4d6ff6 = function(value) {
    return $32ae13b741542474$export$a75d1723e6bda2ec("headers", value);
};
var $32ae13b741542474$export$38e42c68cf43b5d4 = function(name, value) {
    return $32ae13b741542474$export$838e2a576d4d6ff6((0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, name, value));
};
var $32ae13b741542474$export$e39d76e25ce37988 = function(wrapper) {
    return function(f) {
        return function() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                params[_key] = arguments[_key];
            }
            var rest;
            var promise = wrapper(function() {
                for(var _len = arguments.length, innerParams = new Array(_len), _key = 0; _key < _len; _key++){
                    innerParams[_key] = arguments[_key];
                }
                var _f = f.apply(void 0, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(innerParams)), promise = _f.promise, innerRest = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_f, [
                    "promise"
                ]);
                rest = innerRest;
                return promise;
            }).apply($32ae13b741542474$var$_this, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(params));
            return (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
                promise: promise
            }, rest);
        };
    };
};
var $32ae13b741542474$export$9c77439751b4390b = function(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var controller = opts.abortController || new AbortController();
        var promise = fetch(url, (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
            signal: controller.signal
        }, opts));
        return {
            controller: controller,
            promise: promise
        };
    };
};
var $32ae13b741542474$export$e9a8372937ef7f1 = function(abortableFetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // offline db consistency requires ajax calls to fail reliably,
        // so we enforce a default timeout on ajax calls
        var _opts_timeout = opts.timeout, timeout = _opts_timeout === void 0 ? 60000 : _opts_timeout, rest = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(opts, [
            "timeout"
        ]);
        var _abortableFetch = abortableFetch(url, rest), controller = _abortableFetch.controller, promise = _abortableFetch.promise;
        if (timeout !== 0) {
            var newPromise = promise.catch(function(error) {
                // Change error name in case of time out so that we can
                // distinguish it from explicit abort.
                if (error.name === "AbortError" && promise.timedOut) error = new (0, $0d06257c362dc1a1$export$66d311bf29d5c89c)("Request timed out after ".concat(timeout / 1000, " seconds"));
                throw error;
            });
            setTimeout(function() {
                promise.timedOut = true;
                controller.abort();
            }, timeout);
            return {
                controller: controller,
                promise: newPromise
            };
        }
        return {
            controller: controller,
            promise: promise
        };
    };
};
var $32ae13b741542474$export$fe633c745f42b5cd = function(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _opts_failOnHttpErrors = opts.failOnHttpErrors, failOnHttpErrors = _opts_failOnHttpErrors === void 0 ? true : _opts_failOnHttpErrors, rest = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(opts, [
            "failOnHttpErrors"
        ]);
        var promise = fetch(url, rest);
        if (failOnHttpErrors) return promise.then($32ae13b741542474$export$3a2f576a374b4dda);
        return promise;
    };
};
var $32ae13b741542474$export$f4ba43f659d5549c = function(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var body = opts.body, method = opts.method, rest = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(opts, [
            "body",
            "method"
        ]);
        var newUrl = url;
        var newOpts = opts;
        if (Object.keys(opts).includes("method") && Object.keys(opts).includes("body") && method.toUpperCase() === "GET" && body instanceof URLSearchParams) {
            var _newUrl_split = (0, $bd823d1c24941985$export$e62c166da838fa3)(newUrl.split("#")), main = _newUrl_split[0], fragments = _newUrl_split.slice(1);
            var separator = main.includes("?") ? "&" : "?";
            // append the body to the query string
            newUrl = "".concat(main).concat(separator).concat(body.toString(), "#").concat(fragments.join("#"));
            // remove the body since it has been moved to URL
            newOpts = {
                method: method,
                rest: rest
            };
        }
        return fetch(newUrl, newOpts);
    };
};
var $32ae13b741542474$export$e7aa7bc5c1b3cfb3 = (0, (/*@__PURE__*/$parcel$interopDefault($d260ff7ca3ce6993$exports)))(// Same as jQuery.ajax
$32ae13b741542474$export$a75d1723e6bda2ec("credentials", "same-origin"), $32ae13b741542474$export$38e42c68cf43b5d4("X-Requested-With", "XMLHttpRequest"), $32ae13b741542474$export$fe633c745f42b5cd, $32ae13b741542474$export$f4ba43f659d5549c, $32ae13b741542474$export$9c77439751b4390b, $32ae13b741542474$export$e9a8372937ef7f1)(window.fetch);
var $32ae13b741542474$export$3988ae62b71be9a3 = $32ae13b741542474$export$e39d76e25ce37988($32ae13b741542474$export$a75d1723e6bda2ec("method", "GET"))($32ae13b741542474$export$e7aa7bc5c1b3cfb3);
var $32ae13b741542474$export$299ba2dee77727e9 = $32ae13b741542474$export$e39d76e25ce37988($32ae13b741542474$export$a75d1723e6bda2ec("method", "POST"))($32ae13b741542474$export$e7aa7bc5c1b3cfb3);
var $32ae13b741542474$export$38dab5a9fea42f39 = $32ae13b741542474$export$e39d76e25ce37988($32ae13b741542474$export$a75d1723e6bda2ec("method", "DELETE"))($32ae13b741542474$export$e7aa7bc5c1b3cfb3);
var $32ae13b741542474$export$92871f7982deaf9f = function(data) {
    return new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($16bf04b797257b4a$exports)))(data, {
        ignorenull: true
    }));
};


var $5be8e377f991f791$export$1a748576aa07f99b = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(PasswordHashingError, Error1);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(PasswordHashingError);
    function PasswordHashingError(message) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, PasswordHashingError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "PasswordHashingError";
        return _this;
    }
    return PasswordHashingError;
}((0, $9f87b386401b733e$export$2466d533fda16e33)(Error));
function $5be8e377f991f791$export$1d2e6bc0307ffd89() {
    return $32ae13b741542474$export$3988ae62b71be9a3("api/about", {
        // we want fresh configuration each time
        cache: "no-store"
    }).promise.then(function(response) {
        return response.json();
    });
}
function $5be8e377f991f791$export$596d806903d1f59e(credentials) {
    return $32ae13b741542474$export$299ba2dee77727e9("login", {
        body: new URLSearchParams(credentials)
    }).promise.then(function(response) {
        return response.json();
    }).then(function(data) {
        if (data.success) return Promise.resolve();
        else return Promise.reject(new (0, $0d06257c362dc1a1$export$5e64a9683d127ef6)(data.error));
    });
}
function $5be8e377f991f791$export$708be5cd94908894(password) {
    return $32ae13b741542474$export$299ba2dee77727e9("api/private/hash-password", {
        body: new URLSearchParams({
            password: password
        })
    }).promise.then(function(response) {
        return response.json();
    }).then(function(data) {
        if (data.success) return Promise.resolve(data.hash);
        else return Promise.reject(new $5be8e377f991f791$export$1a748576aa07f99b(data.error));
    });
}
function $5be8e377f991f791$export$b3b4cde15a96b715(file) {
    var data = new FormData();
    data.append("opml", file);
    return $32ae13b741542474$export$299ba2dee77727e9("opml", {
        body: data,
        failOnHttpErrors: false
    }).promise.then($32ae13b741542474$export$8d90b058a02656d9(function(response) {
        return response.status === 200 || response.status === 202 || response.status === 400;
    })).then(function(response) {
        return response.json().then(function(data) {
            return {
                response: response,
                data: data
            };
        });
    });
}
function $5be8e377f991f791$export$a0973bcfe11b05c9() {
    return $32ae13b741542474$export$38dab5a9fea42f39("api/session/current").promise;
}



function $bcc58ea15e13e580$export$c36f611d5eb39a7() {
    return $32ae13b741542474$export$3988ae62b71be9a3("tags").promise.then(function(response) {
        return response.json();
    });
}
function $bcc58ea15e13e580$export$6f3c7c74c4b252bb(tag, color) {
    return $32ae13b741542474$export$299ba2dee77727e9("tags/color", {
        body: $32ae13b741542474$export$92871f7982deaf9f({
            tag: tag,
            color: color
        })
    }).promise;
}




function $53f3ce6e74f6aaad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53f3ce6e74f6aaad$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}





var $e721f0b5888adce1$export$5521c47db270880f = /*#__PURE__*/ function(Event1) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(ValueChangeEvent, Event1);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(ValueChangeEvent);
    function ValueChangeEvent(value) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, ValueChangeEvent);
        var _this;
        _this = _super.call(this, "change");
        _this.value = value;
        return _this;
    }
    return ValueChangeEvent;
}((0, $9f87b386401b733e$export$2466d533fda16e33)(Event));
var $e721f0b5888adce1$export$8fa6ce44b7b131e9 = /*#__PURE__*/ function(EventTarget1) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(ValueListenable, EventTarget1);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(ValueListenable);
    function ValueListenable(value) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, ValueListenable);
        var _this;
        _this = _super.call(this);
        _this.value = value;
        return _this;
    }
    (0, $53f3ce6e74f6aaad$export$d60067ff2358eee8)(ValueListenable, [
        {
            key: "update",
            value: function update(value) {
                if (this.value !== value) {
                    this.value = value;
                    var event = new $e721f0b5888adce1$export$5521c47db270880f(value);
                    this.dispatchEvent(event);
                }
            }
        }
    ]);
    return ValueListenable;
}((0, $9f87b386401b733e$export$2466d533fda16e33)(EventTarget));



/**
 * Object describing what state a request is in.
 * @enum {string}
 */ var $d2d3ee75176c5e4c$export$62aa48085237e36f = {
    INITIAL: "initial",
    LOADING: "loading",
    SUCCESS: "success",
    FAILURE: "failure"
};







function $715bf31211e65705$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $715bf31211e65705$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $715bf31211e65705$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



function $a19fa517098223d7$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}




function $1788e2ed61915b1e$export$fdf2a89c76341bbf(arr, i) {
    return (0, $94d3f045916e0583$export$e6256bf45c68d561)(arr) || (0, $a19fa517098223d7$export$2fd15edff6687200)(arr, i) || (0, $d6f91c356a8197fd$export$a5be06335b3a083c)(arr, i) || (0, $2b2eb8ca3633154b$export$60dbc22abd7da546)();
}



var $f171543c027e46e7$exports = {};
"use strict";

$f171543c027e46e7$exports = (parcelRequire("azwTY"));



var $eHaBZ = parcelRequire("eHaBZ");
var $35e9123a2e6f4e90$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $35e9123a2e6f4e90$var$ReactIs, $35e9123a2e6f4e90$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$35e9123a2e6f4e90$exports = (parcelRequire("fOJyi"))();


var $cff7e9a474db95c7$exports = {};

function $cff7e9a474db95c7$var$nullable(subRequirement) {
    var check = function(required, props, key) {
        for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
            rest[_key - 3] = arguments[_key];
        }
        if (props[key] === null) return null;
        var sub = required ? subRequirement.isRequired : subRequirement;
        return sub.apply(void 0, [
            props,
            key
        ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(rest)));
    };
    var fn = check.bind(null, false);
    fn.isRequired = check.bind(null, true);
    return fn;
}
Object.defineProperty($cff7e9a474db95c7$exports, "__esModule", {
    value: true
});
$cff7e9a474db95c7$exports.default = $cff7e9a474db95c7$var$nullable;
$cff7e9a474db95c7$exports = Object.assign($cff7e9a474db95c7$exports.default, $cff7e9a474db95c7$exports);
$cff7e9a474db95c7$exports.default.default = $cff7e9a474db95c7$exports;


function $9ffc3760517c29a0$export$2e2bcd8739ae039(o, p) {
    $9ffc3760517c29a0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9ffc3760517c29a0$export$2e2bcd8739ae039(o, p);
}


function $a4348b481db67826$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $9ffc3760517c29a0$export$2e2bcd8739ae039)(subClass, superClass);
}



var $eHaBZ = parcelRequire("eHaBZ");

function $eb6622af1e6fe02f$export$2e2bcd8739ae039() {
    $eb6622af1e6fe02f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eb6622af1e6fe02f$export$2e2bcd8739ae039.apply(this, arguments);
}


function $e53130ac90e98044$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $e53130ac90e98044$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $e53130ac90e98044$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $e53130ac90e98044$var$isAbsolute(to);
    var isFromAbs = from && $e53130ac90e98044$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $e53130ac90e98044$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $e53130ac90e98044$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $e53130ac90e98044$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $e53130ac90e98044$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$e53130ac90e98044$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $e53130ac90e98044$export$2e2bcd8739ae039 = $e53130ac90e98044$var$resolvePathname;


function $a9de1abd3dd7cd13$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $a9de1abd3dd7cd13$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $a9de1abd3dd7cd13$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $a9de1abd3dd7cd13$var$valueOf(a);
        var bValue = $a9de1abd3dd7cd13$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $a9de1abd3dd7cd13$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $a9de1abd3dd7cd13$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $a9de1abd3dd7cd13$export$2e2bcd8739ae039 = $a9de1abd3dd7cd13$var$valueEqual;



var $671fec4f4a0ea416$var$isProduction = true;
var $671fec4f4a0ea416$var$prefix = "Invariant failed";
function $671fec4f4a0ea416$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($671fec4f4a0ea416$var$isProduction) throw new Error($671fec4f4a0ea416$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($671fec4f4a0ea416$var$prefix, ": ").concat(provided) : $671fec4f4a0ea416$var$prefix;
    throw new Error(value);
}


function $53841ea263796361$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $53841ea263796361$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $53841ea263796361$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $53841ea263796361$var$stripBasename(path, prefix) {
    return $53841ea263796361$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $53841ea263796361$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $53841ea263796361$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $53841ea263796361$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $53841ea263796361$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $53841ea263796361$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $e53130ac90e98044$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $53841ea263796361$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $a9de1abd3dd7cd13$export$2e2bcd8739ae039)(a.state, b.state);
}
function $53841ea263796361$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $53841ea263796361$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $53841ea263796361$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $53841ea263796361$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $53841ea263796361$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $53841ea263796361$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $53841ea263796361$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $53841ea263796361$var$PopStateEvent = "popstate";
var $53841ea263796361$var$HashChangeEvent = "hashchange";
function $53841ea263796361$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $53841ea263796361$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$53841ea263796361$var$canUseDOM && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $53841ea263796361$var$supportsHistory();
    var needsHashChangeListener = !$53841ea263796361$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $53841ea263796361$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $53841ea263796361$var$stripTrailingSlash($53841ea263796361$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $53841ea263796361$var$stripBasename(path, basename);
        return $53841ea263796361$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $53841ea263796361$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($53841ea263796361$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($53841ea263796361$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($53841ea263796361$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $53841ea263796361$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $53841ea263796361$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $53841ea263796361$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($53841ea263796361$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($53841ea263796361$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($53841ea263796361$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($53841ea263796361$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $53841ea263796361$var$HashChangeEvent$1 = "hashchange";
var $53841ea263796361$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $53841ea263796361$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $53841ea263796361$var$stripLeadingSlash,
        decodePath: $53841ea263796361$var$addLeadingSlash
    },
    slash: {
        encodePath: $53841ea263796361$var$addLeadingSlash,
        decodePath: $53841ea263796361$var$addLeadingSlash
    }
};
function $53841ea263796361$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $53841ea263796361$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $53841ea263796361$var$pushHashPath(path) {
    window.location.hash = path;
}
function $53841ea263796361$var$replaceHashPath(path) {
    window.location.replace($53841ea263796361$var$stripHash(window.location.href) + "#" + path);
}
function $53841ea263796361$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$53841ea263796361$var$canUseDOM && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $53841ea263796361$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $53841ea263796361$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $53841ea263796361$var$stripTrailingSlash($53841ea263796361$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $53841ea263796361$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($53841ea263796361$var$getHashPath());
        if (basename) path = $53841ea263796361$var$stripBasename(path, basename);
        return $53841ea263796361$export$90c043f1c57770b8(path);
    }
    var transitionManager = $53841ea263796361$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $53841ea263796361$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $53841ea263796361$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $53841ea263796361$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($53841ea263796361$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($53841ea263796361$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $53841ea263796361$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $53841ea263796361$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $53841ea263796361$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $53841ea263796361$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $53841ea263796361$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $53841ea263796361$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = $53841ea263796361$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = $53841ea263796361$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                $53841ea263796361$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($53841ea263796361$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(_$path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $53841ea263796361$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = $53841ea263796361$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = $53841ea263796361$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                $53841ea263796361$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($53841ea263796361$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = _$path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($53841ea263796361$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($53841ea263796361$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $53841ea263796361$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $53841ea263796361$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $53841ea263796361$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $53841ea263796361$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $53841ea263796361$export$90c043f1c57770b8(entry, undefined, createKey()) : $53841ea263796361$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $53841ea263796361$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $53841ea263796361$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $53841ea263796361$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $53841ea263796361$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $e43e94788a0895ce$exports = {};
var $2c094df4173650ca$exports = {};
$2c094df4173650ca$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $e43e94788a0895ce$exports = $e43e94788a0895ce$var$pathToRegexp;
$e43e94788a0895ce$exports.parse = $e43e94788a0895ce$var$parse;
$e43e94788a0895ce$exports.compile = $e43e94788a0895ce$var$compile;
$e43e94788a0895ce$exports.tokensToFunction = $e43e94788a0895ce$var$tokensToFunction;
$e43e94788a0895ce$exports.tokensToRegExp = $e43e94788a0895ce$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $e43e94788a0895ce$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $e43e94788a0895ce$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $e43e94788a0895ce$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $e43e94788a0895ce$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $e43e94788a0895ce$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $e43e94788a0895ce$var$compile(str, options) {
    return $e43e94788a0895ce$var$tokensToFunction($e43e94788a0895ce$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $e43e94788a0895ce$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $e43e94788a0895ce$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $e43e94788a0895ce$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $e43e94788a0895ce$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var _$options = opts || {};
        var encode = _$options.pretty ? $e43e94788a0895ce$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($2c094df4173650ca$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $e43e94788a0895ce$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $e43e94788a0895ce$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $e43e94788a0895ce$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $e43e94788a0895ce$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $e43e94788a0895ce$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $e43e94788a0895ce$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $e43e94788a0895ce$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $e43e94788a0895ce$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($e43e94788a0895ce$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $e43e94788a0895ce$var$flags(options));
    return $e43e94788a0895ce$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $e43e94788a0895ce$var$stringToRegexp(path, keys, options) {
    return $e43e94788a0895ce$var$tokensToRegExp($e43e94788a0895ce$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $e43e94788a0895ce$var$tokensToRegExp(tokens, keys, options) {
    if (!$2c094df4173650ca$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $e43e94788a0895ce$var$escapeString(token);
        else {
            var prefix = $e43e94788a0895ce$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $e43e94788a0895ce$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $e43e94788a0895ce$var$attachKeys(new RegExp("^" + route, $e43e94788a0895ce$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $e43e94788a0895ce$var$pathToRegexp(path, keys, options) {
    if (!$2c094df4173650ca$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $e43e94788a0895ce$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($2c094df4173650ca$exports(path)) return $e43e94788a0895ce$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $e43e94788a0895ce$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $ac8d2e8301c434c8$exports = {};
"use strict";

$ac8d2e8301c434c8$exports = (parcelRequire("9MAz8"));


function $6d20ebfed8c0a7ce$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $3bd4071a6f61164d$exports = {};
"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3bd4071a6f61164d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3bd4071a6f61164d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3bd4071a6f61164d$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3bd4071a6f61164d$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3bd4071a6f61164d$var$TYPE_STATICS = {};
$3bd4071a6f61164d$var$TYPE_STATICS[$ac8d2e8301c434c8$exports.ForwardRef] = $3bd4071a6f61164d$var$FORWARD_REF_STATICS;
$3bd4071a6f61164d$var$TYPE_STATICS[$ac8d2e8301c434c8$exports.Memo] = $3bd4071a6f61164d$var$MEMO_STATICS;
function $3bd4071a6f61164d$var$getStatics(component) {
    // React v16.11 and below
    if ($ac8d2e8301c434c8$exports.isMemo(component)) return $3bd4071a6f61164d$var$MEMO_STATICS;
     // React v16.12 and above
    return $3bd4071a6f61164d$var$TYPE_STATICS[component["$$typeof"]] || $3bd4071a6f61164d$var$REACT_STATICS;
}
var $3bd4071a6f61164d$var$defineProperty = Object.defineProperty;
var $3bd4071a6f61164d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3bd4071a6f61164d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3bd4071a6f61164d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3bd4071a6f61164d$var$getPrototypeOf = Object.getPrototypeOf;
var $3bd4071a6f61164d$var$objectPrototype = Object.prototype;
function $3bd4071a6f61164d$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3bd4071a6f61164d$var$objectPrototype) {
            var inheritedComponent = $3bd4071a6f61164d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3bd4071a6f61164d$var$objectPrototype) $3bd4071a6f61164d$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3bd4071a6f61164d$var$getOwnPropertyNames(sourceComponent);
        if ($3bd4071a6f61164d$var$getOwnPropertySymbols) keys = keys.concat($3bd4071a6f61164d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3bd4071a6f61164d$var$getStatics(targetComponent);
        var sourceStatics = $3bd4071a6f61164d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3bd4071a6f61164d$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3bd4071a6f61164d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3bd4071a6f61164d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$3bd4071a6f61164d$exports = $3bd4071a6f61164d$var$hoistNonReactStatics;


var $c1feef6a502006a1$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $c1feef6a502006a1$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $c1feef6a502006a1$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $c1feef6a502006a1$var$commonjsGlobal[key] = ($c1feef6a502006a1$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $c1feef6a502006a1$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $c1feef6a502006a1$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $c1feef6a502006a1$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $c1feef6a502006a1$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $c1feef6a502006a1$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $a4348b481db67826$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $c1feef6a502006a1$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($c1feef6a502006a1$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $c1feef6a502006a1$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $a4348b481db67826$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $c1feef6a502006a1$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $c1feef6a502006a1$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $c1feef6a502006a1$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $c1feef6a502006a1$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createContext || $c1feef6a502006a1$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $c1feef6a502006a1$var$createNamedContext = function createNamedContext(name) {
    var context = $c1feef6a502006a1$var$createContext();
    context.displayName = name;
    return context;
};
var $c1feef6a502006a1$export$c213558b66925821 = /*#__PURE__*/ $c1feef6a502006a1$var$createNamedContext("Router-History");
var $c1feef6a502006a1$export$63baa8ccbe60bb07 = /*#__PURE__*/ $c1feef6a502006a1$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $c1feef6a502006a1$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $a4348b481db67826$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $c1feef6a502006a1$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $a4348b481db67826$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $53841ea263796361$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
var $c1feef6a502006a1$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $a4348b481db67826$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $c1feef6a502006a1$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $c1feef6a502006a1$var$messageType;
var $c1feef6a502006a1$var$cache = {};
var $c1feef6a502006a1$var$cacheLimit = 10000;
var $c1feef6a502006a1$var$cacheCount = 0;
function $c1feef6a502006a1$var$compilePath(path) {
    if ($c1feef6a502006a1$var$cache[path]) return $c1feef6a502006a1$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($e43e94788a0895ce$exports))).compile(path);
    if ($c1feef6a502006a1$var$cacheCount < $c1feef6a502006a1$var$cacheLimit) {
        $c1feef6a502006a1$var$cache[path] = generator;
        $c1feef6a502006a1$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $c1feef6a502006a1$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $c1feef6a502006a1$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $c1feef6a502006a1$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $53841ea263796361$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $c1feef6a502006a1$export$82476f982757e71e(to, computedMatch.params) : (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, to, {
            pathname: $c1feef6a502006a1$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $53841ea263796361$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $53841ea263796361$export$c3e8bb440bd55b18)(prevLocation, (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $c1feef6a502006a1$var$cache$1 = {};
var $c1feef6a502006a1$var$cacheLimit$1 = 10000;
var $c1feef6a502006a1$var$cacheCount$1 = 0;
function $c1feef6a502006a1$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $c1feef6a502006a1$var$cache$1[cacheKey] || ($c1feef6a502006a1$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($e43e94788a0895ce$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($c1feef6a502006a1$var$cacheCount$1 < $c1feef6a502006a1$var$cacheLimit$1) {
        pathCache[path] = result;
        $c1feef6a502006a1$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $c1feef6a502006a1$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $c1feef6a502006a1$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $c1feef6a502006a1$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Children.count(children) === 0;
}
function $c1feef6a502006a1$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $c1feef6a502006a1$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $a4348b481db67826$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $c1feef6a502006a1$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $c1feef6a502006a1$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
function $c1feef6a502006a1$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $c1feef6a502006a1$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, location, {
        pathname: $c1feef6a502006a1$var$addLeadingSlash(basename) + location.pathname
    });
}
function $c1feef6a502006a1$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $c1feef6a502006a1$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $c1feef6a502006a1$var$createURL(location) {
    return typeof location === "string" ? location : (0, $53841ea263796361$export$fe53371bee54353d)(location);
}
function $c1feef6a502006a1$var$staticHandler(methodName) {
    return function() {
        (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
    };
}
function $c1feef6a502006a1$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $c1feef6a502006a1$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $a4348b481db67826$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $c1feef6a502006a1$var$noop;
        };
        _this.handleBlock = function() {
            return $c1feef6a502006a1$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $c1feef6a502006a1$var$addBasename(basename, (0, $53841ea263796361$export$90c043f1c57770b8)(location));
        context.url = $c1feef6a502006a1$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $6d20ebfed8c0a7ce$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $c1feef6a502006a1$var$addLeadingSlash(basename + $c1feef6a502006a1$var$createURL(path));
            },
            action: "POP",
            location: $c1feef6a502006a1$var$stripBasename(basename, (0, $53841ea263796361$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $c1feef6a502006a1$var$staticHandler("go"),
            goBack: $c1feef6a502006a1$var$staticHandler("goBack"),
            goForward: $c1feef6a502006a1$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$55185c17a0fcbe46, (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $c1feef6a502006a1$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $a4348b481db67826$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $c1feef6a502006a1$export$81336c211d5ff295(location.pathname, (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $c1feef6a502006a1$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $6d20ebfed8c0a7ce$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($c1feef6a502006a1$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement(Component, (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3bd4071a6f61164d$exports)))(C, Component);
}
var $c1feef6a502006a1$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).useContext;
function $c1feef6a502006a1$export$3420e1dc2c4a518c() {
    return $c1feef6a502006a1$var$useContext($c1feef6a502006a1$export$c213558b66925821);
}
function $c1feef6a502006a1$export$45d76561a5302f2b() {
    return $c1feef6a502006a1$var$useContext($c1feef6a502006a1$export$63baa8ccbe60bb07).location;
}
function $c1feef6a502006a1$export$99eaa27ddbbb95ef() {
    var match = $c1feef6a502006a1$var$useContext($c1feef6a502006a1$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $c1feef6a502006a1$export$632be4bb944c1bc7(path) {
    var location = $c1feef6a502006a1$export$45d76561a5302f2b();
    var match = $c1feef6a502006a1$var$useContext($c1feef6a502006a1$export$63baa8ccbe60bb07).match;
    return path ? $c1feef6a502006a1$export$81336c211d5ff295(location.pathname, path) : match;
}
var $c1feef6a502006a1$var$global$1, $c1feef6a502006a1$var$key, $c1feef6a502006a1$var$buildNames, $c1feef6a502006a1$var$initialBuildName, $c1feef6a502006a1$var$secondaryBuildName;




var $eHaBZ = parcelRequire("eHaBZ");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $23454774ad668d69$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $a4348b481db67826$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $53841ea263796361$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement((0, $c1feef6a502006a1$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $23454774ad668d69$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $a4348b481db67826$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $53841ea263796361$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement((0, $c1feef6a502006a1$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
var $23454774ad668d69$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $23454774ad668d69$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $53841ea263796361$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $23454774ad668d69$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $23454774ad668d69$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).forwardRef;
if (typeof $23454774ad668d69$var$forwardRef === "undefined") $23454774ad668d69$var$forwardRef = $23454774ad668d69$var$forwardRefShim;
function $23454774ad668d69$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $23454774ad668d69$var$LinkAnchor = $23454774ad668d69$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $6d20ebfed8c0a7ce$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$23454774ad668d69$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($23454774ad668d69$var$forwardRefShim !== $23454774ad668d69$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $23454774ad668d69$export$a6c7ac8248d6e38a = $23454774ad668d69$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $23454774ad668d69$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $6d20ebfed8c0a7ce$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement((0, $c1feef6a502006a1$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $23454774ad668d69$var$normalizeToLocation($23454774ad668d69$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $23454774ad668d69$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $53841ea263796361$export$fe53371bee54353d)(context.location) === (0, $53841ea263796361$export$fe53371bee54353d)($23454774ad668d69$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($23454774ad668d69$var$forwardRefShim !== $23454774ad668d69$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement(component, props);
    });
});
var $23454774ad668d69$var$toType, $23454774ad668d69$var$refType;
var $23454774ad668d69$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $23454774ad668d69$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).forwardRef;
if (typeof $23454774ad668d69$var$forwardRef$1 === "undefined") $23454774ad668d69$var$forwardRef$1 = $23454774ad668d69$var$forwardRefShim$1;
function $23454774ad668d69$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $23454774ad668d69$export$b0d92dbee9b5b60d = $23454774ad668d69$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $6d20ebfed8c0a7ce$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement((0, $c1feef6a502006a1$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $671fec4f4a0ea416$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $23454774ad668d69$var$normalizeToLocation($23454774ad668d69$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $c1feef6a502006a1$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $23454774ad668d69$var$joinClassnames(className, activeClassName);
            style = (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $eb6622af1e6fe02f$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($23454774ad668d69$var$forwardRefShim$1 !== $23454774ad668d69$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement($23454774ad668d69$export$a6c7ac8248d6e38a, props);
    });
});
var $23454774ad668d69$var$ariaCurrentType;


function $39c5346b7e5f0f6d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $39c5346b7e5f0f6d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $39c5346b7e5f0f6d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $39c5346b7e5f0f6d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $39c5346b7e5f0f6d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $39c5346b7e5f0f6d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $39c5346b7e5f0f6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $39c5346b7e5f0f6d$var$_typeof(obj);
}
function $39c5346b7e5f0f6d$var$_wrapRegExp() {
    $39c5346b7e5f0f6d$var$_wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $39c5346b7e5f0f6d$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $39c5346b7e5f0f6d$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $39c5346b7e5f0f6d$var$_wrapRegExp.apply(this, arguments);
}
function $39c5346b7e5f0f6d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $39c5346b7e5f0f6d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $39c5346b7e5f0f6d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $39c5346b7e5f0f6d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $39c5346b7e5f0f6d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $39c5346b7e5f0f6d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $39c5346b7e5f0f6d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $39c5346b7e5f0f6d$var$_setPrototypeOf(subClass, superClass);
}
function $39c5346b7e5f0f6d$var$_setPrototypeOf(o, p) {
    $39c5346b7e5f0f6d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $39c5346b7e5f0f6d$var$_setPrototypeOf(o, p);
}
function $39c5346b7e5f0f6d$var$_slicedToArray(arr, i) {
    return $39c5346b7e5f0f6d$var$_arrayWithHoles(arr) || $39c5346b7e5f0f6d$var$_iterableToArrayLimit(arr, i) || $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(arr, i) || $39c5346b7e5f0f6d$var$_nonIterableRest();
}
function $39c5346b7e5f0f6d$var$_toConsumableArray(arr) {
    return $39c5346b7e5f0f6d$var$_arrayWithoutHoles(arr) || $39c5346b7e5f0f6d$var$_iterableToArray(arr) || $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(arr) || $39c5346b7e5f0f6d$var$_nonIterableSpread();
}
function $39c5346b7e5f0f6d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $39c5346b7e5f0f6d$var$_arrayLikeToArray(arr);
}
function $39c5346b7e5f0f6d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $39c5346b7e5f0f6d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $39c5346b7e5f0f6d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $39c5346b7e5f0f6d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $39c5346b7e5f0f6d$var$_arrayLikeToArray(o, minLen);
}
function $39c5346b7e5f0f6d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $39c5346b7e5f0f6d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $39c5346b7e5f0f6d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $39c5346b7e5f0f6d$var$noop = function noop() {};
var $39c5346b7e5f0f6d$var$_WINDOW = {};
var $39c5346b7e5f0f6d$var$_DOCUMENT = {};
var $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER = null;
var $39c5346b7e5f0f6d$var$_PERFORMANCE = {
    mark: $39c5346b7e5f0f6d$var$noop,
    measure: $39c5346b7e5f0f6d$var$noop
};
try {
    if (typeof window !== "undefined") $39c5346b7e5f0f6d$var$_WINDOW = window;
    if (typeof document !== "undefined") $39c5346b7e5f0f6d$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $39c5346b7e5f0f6d$var$_PERFORMANCE = performance;
} catch (e) {}
var $39c5346b7e5f0f6d$var$_ref = $39c5346b7e5f0f6d$var$_WINDOW.navigator || {}, $39c5346b7e5f0f6d$var$_ref$userAgent = $39c5346b7e5f0f6d$var$_ref.userAgent, $39c5346b7e5f0f6d$var$userAgent = $39c5346b7e5f0f6d$var$_ref$userAgent === void 0 ? "" : $39c5346b7e5f0f6d$var$_ref$userAgent;
var $39c5346b7e5f0f6d$var$WINDOW = $39c5346b7e5f0f6d$var$_WINDOW;
var $39c5346b7e5f0f6d$var$DOCUMENT = $39c5346b7e5f0f6d$var$_DOCUMENT;
var $39c5346b7e5f0f6d$var$MUTATION_OBSERVER = $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER;
var $39c5346b7e5f0f6d$var$PERFORMANCE = $39c5346b7e5f0f6d$var$_PERFORMANCE;
var $39c5346b7e5f0f6d$var$IS_BROWSER = !!$39c5346b7e5f0f6d$var$WINDOW.document;
var $39c5346b7e5f0f6d$var$IS_DOM = !!$39c5346b7e5f0f6d$var$DOCUMENT.documentElement && !!$39c5346b7e5f0f6d$var$DOCUMENT.head && typeof $39c5346b7e5f0f6d$var$DOCUMENT.addEventListener === "function" && typeof $39c5346b7e5f0f6d$var$DOCUMENT.createElement === "function";
var $39c5346b7e5f0f6d$var$IS_IE = ~$39c5346b7e5f0f6d$var$userAgent.indexOf("MSIE") || ~$39c5346b7e5f0f6d$var$userAgent.indexOf("Trident/");
var $39c5346b7e5f0f6d$var$_familyProxy, $39c5346b7e5f0f6d$var$_familyProxy2, $39c5346b7e5f0f6d$var$_familyProxy3, $39c5346b7e5f0f6d$var$_familyProxy4, $39c5346b7e5f0f6d$var$_familyProxy5;
var $39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $39c5346b7e5f0f6d$var$UNITS_IN_GRID = 16;
var $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX = "fa";
var $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $39c5346b7e5f0f6d$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $39c5346b7e5f0f6d$var$DATA_PREFIX = "data-prefix";
var $39c5346b7e5f0f6d$var$DATA_ICON = "data-icon";
var $39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $39c5346b7e5f0f6d$var$MUTATION_APPROACH_ASYNC = "async";
var $39c5346b7e5f0f6d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $39c5346b7e5f0f6d$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $39c5346b7e5f0f6d$var$FAMILY_CLASSIC = "classic";
var $39c5346b7e5f0f6d$var$FAMILY_SHARP = "sharp";
var $39c5346b7e5f0f6d$var$FAMILIES = [
    $39c5346b7e5f0f6d$var$FAMILY_CLASSIC,
    $39c5346b7e5f0f6d$var$FAMILY_SHARP
];
function $39c5346b7e5f0f6d$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC];
        }
    });
}
var $39c5346b7e5f0f6d$var$PREFIX_TO_STYLE = $39c5346b7e5f0f6d$var$familyProxy(($39c5346b7e5f0f6d$var$_familyProxy = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fakd": "kit",
    "fa-kit": "kit",
    "fa-kit-duotone": "kit"
}), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy, $39c5346b7e5f0f6d$var$FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid",
    "fasr": "regular",
    "fa-regular": "regular",
    "fasl": "light",
    "fa-light": "light",
    "fast": "thin",
    "fa-thin": "thin"
}), $39c5346b7e5f0f6d$var$_familyProxy));
var $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy(($39c5346b7e5f0f6d$var$_familyProxy2 = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy2, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab",
    kit: "fak"
}), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy2, $39c5346b7e5f0f6d$var$FAMILY_SHARP, {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
}), $39c5346b7e5f0f6d$var$_familyProxy2));
var $39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE = $39c5346b7e5f0f6d$var$familyProxy(($39c5346b7e5f0f6d$var$_familyProxy3 = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy3, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, {
    fab: "fa-brands",
    fad: "fa-duotone",
    fak: "fa-kit",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
}), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy3, $39c5346b7e5f0f6d$var$FAMILY_SHARP, {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
}), $39c5346b7e5f0f6d$var$_familyProxy3));
var $39c5346b7e5f0f6d$var$LONG_STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy(($39c5346b7e5f0f6d$var$_familyProxy4 = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy4, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy4, $39c5346b7e5f0f6d$var$FAMILY_SHARP, {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
}), $39c5346b7e5f0f6d$var$_familyProxy4));
var $39c5346b7e5f0f6d$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $39c5346b7e5f0f6d$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var $39c5346b7e5f0f6d$var$FONT_WEIGHT_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy(($39c5346b7e5f0f6d$var$_familyProxy5 = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy5, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
}), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_familyProxy5, $39c5346b7e5f0f6d$var$FAMILY_SHARP, {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
}), $39c5346b7e5f0f6d$var$_familyProxy5));
var $39c5346b7e5f0f6d$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $39c5346b7e5f0f6d$var$oneToTwenty = $39c5346b7e5f0f6d$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $39c5346b7e5f0f6d$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $39c5346b7e5f0f6d$var$DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $39c5346b7e5f0f6d$var$prefixes = new Set();
Object.keys($39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC]).map($39c5346b7e5f0f6d$var$prefixes.add.bind($39c5346b7e5f0f6d$var$prefixes));
Object.keys($39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$FAMILY_SHARP]).map($39c5346b7e5f0f6d$var$prefixes.add.bind($39c5346b7e5f0f6d$var$prefixes));
var $39c5346b7e5f0f6d$var$RESERVED_CLASSES = [].concat($39c5346b7e5f0f6d$var$FAMILIES, $39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $39c5346b7e5f0f6d$var$DUOTONE_CLASSES.GROUP,
    $39c5346b7e5f0f6d$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $39c5346b7e5f0f6d$var$DUOTONE_CLASSES.PRIMARY,
    $39c5346b7e5f0f6d$var$DUOTONE_CLASSES.SECONDARY
]).concat($39c5346b7e5f0f6d$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($39c5346b7e5f0f6d$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $39c5346b7e5f0f6d$var$initial = $39c5346b7e5f0f6d$var$WINDOW.FontAwesomeConfig || {};
function $39c5346b7e5f0f6d$var$getAttrConfig(attr) {
    var element = $39c5346b7e5f0f6d$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $39c5346b7e5f0f6d$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($39c5346b7e5f0f6d$var$DOCUMENT && typeof $39c5346b7e5f0f6d$var$DOCUMENT.querySelector === "function") {
    var $39c5346b7e5f0f6d$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $39c5346b7e5f0f6d$var$attrs.forEach(function(_ref) {
        var _ref2 = $39c5346b7e5f0f6d$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $39c5346b7e5f0f6d$var$coerce($39c5346b7e5f0f6d$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $39c5346b7e5f0f6d$var$initial[key] = val;
    });
}
var $39c5346b7e5f0f6d$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX,
    replacementClass: $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($39c5346b7e5f0f6d$var$initial.familyPrefix) $39c5346b7e5f0f6d$var$initial.cssPrefix = $39c5346b7e5f0f6d$var$initial.familyPrefix;
var $39c5346b7e5f0f6d$var$_config = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$_default), $39c5346b7e5f0f6d$var$initial);
if (!$39c5346b7e5f0f6d$var$_config.autoReplaceSvg) $39c5346b7e5f0f6d$var$_config.observeMutations = false;
var $39c5346b7e5f0f6d$var$config = {};
Object.keys($39c5346b7e5f0f6d$var$_default).forEach(function(key) {
    Object.defineProperty($39c5346b7e5f0f6d$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $39c5346b7e5f0f6d$var$_config[key] = val;
            $39c5346b7e5f0f6d$var$_onChangeCb.forEach(function(cb) {
                return cb($39c5346b7e5f0f6d$var$config);
            });
        },
        get: function get() {
            return $39c5346b7e5f0f6d$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($39c5346b7e5f0f6d$var$config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        $39c5346b7e5f0f6d$var$_config.cssPrefix = val;
        $39c5346b7e5f0f6d$var$_onChangeCb.forEach(function(cb) {
            return cb($39c5346b7e5f0f6d$var$config);
        });
    },
    get: function get() {
        return $39c5346b7e5f0f6d$var$_config.cssPrefix;
    }
});
$39c5346b7e5f0f6d$var$WINDOW.FontAwesomeConfig = $39c5346b7e5f0f6d$var$config;
var $39c5346b7e5f0f6d$var$_onChangeCb = [];
function $39c5346b7e5f0f6d$var$onChange(cb) {
    $39c5346b7e5f0f6d$var$_onChangeCb.push(cb);
    return function() {
        $39c5346b7e5f0f6d$var$_onChangeCb.splice($39c5346b7e5f0f6d$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $39c5346b7e5f0f6d$var$d = $39c5346b7e5f0f6d$var$UNITS_IN_GRID;
var $39c5346b7e5f0f6d$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $39c5346b7e5f0f6d$var$insertCss(css) {
    if (!css || !$39c5346b7e5f0f6d$var$IS_DOM) return;
    var style = $39c5346b7e5f0f6d$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $39c5346b7e5f0f6d$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $39c5346b7e5f0f6d$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $39c5346b7e5f0f6d$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $39c5346b7e5f0f6d$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $39c5346b7e5f0f6d$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $39c5346b7e5f0f6d$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $39c5346b7e5f0f6d$var$classArray(node) {
    if (node.classList) return $39c5346b7e5f0f6d$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $39c5346b7e5f0f6d$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $39c5346b7e5f0f6d$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($39c5346b7e5f0f6d$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $39c5346b7e5f0f6d$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $39c5346b7e5f0f6d$var$transformIsMeaningful(transform) {
    return transform.size !== $39c5346b7e5f0f6d$var$meaninglessTransform.size || transform.x !== $39c5346b7e5f0f6d$var$meaninglessTransform.x || transform.y !== $39c5346b7e5f0f6d$var$meaninglessTransform.y || transform.rotate !== $39c5346b7e5f0f6d$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $39c5346b7e5f0f6d$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $39c5346b7e5f0f6d$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $39c5346b7e5f0f6d$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $39c5346b7e5f0f6d$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $39c5346b7e5f0f6d$var$IS_IE) val += "translate(".concat(transform.x / $39c5346b7e5f0f6d$var$d - width / 2, "em, ").concat(transform.y / $39c5346b7e5f0f6d$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $39c5346b7e5f0f6d$var$d, "em), calc(-50% + ").concat(transform.y / $39c5346b7e5f0f6d$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $39c5346b7e5f0f6d$var$d, "em, ").concat(transform.y / $39c5346b7e5f0f6d$var$d, "em) ");
    val += "scale(".concat(transform.size / $39c5346b7e5f0f6d$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $39c5346b7e5f0f6d$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $39c5346b7e5f0f6d$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $39c5346b7e5f0f6d$var$css() {
    var dcp = $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX;
    var drc = $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $39c5346b7e5f0f6d$var$config.cssPrefix;
    var rc = $39c5346b7e5f0f6d$var$config.replacementClass;
    var s = $39c5346b7e5f0f6d$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $39c5346b7e5f0f6d$var$_cssInserted = false;
function $39c5346b7e5f0f6d$var$ensureCss() {
    if ($39c5346b7e5f0f6d$var$config.autoAddCss && !$39c5346b7e5f0f6d$var$_cssInserted) {
        $39c5346b7e5f0f6d$var$insertCss($39c5346b7e5f0f6d$var$css());
        $39c5346b7e5f0f6d$var$_cssInserted = true;
    }
}
var $39c5346b7e5f0f6d$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $39c5346b7e5f0f6d$var$css,
                insertCss: $39c5346b7e5f0f6d$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $39c5346b7e5f0f6d$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $39c5346b7e5f0f6d$var$ensureCss();
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$w = $39c5346b7e5f0f6d$var$WINDOW || {};
if (!$39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER]) $39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER] = {};
if (!$39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].styles) $39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].hooks) $39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].shims) $39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].shims = [];
var $39c5346b7e5f0f6d$var$namespace = $39c5346b7e5f0f6d$var$w[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER];
var $39c5346b7e5f0f6d$var$functions = [];
var $39c5346b7e5f0f6d$var$listener = function listener() {
    $39c5346b7e5f0f6d$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $39c5346b7e5f0f6d$var$loaded = 1;
    $39c5346b7e5f0f6d$var$functions.map(function(fn) {
        return fn();
    });
};
var $39c5346b7e5f0f6d$var$loaded = false;
if ($39c5346b7e5f0f6d$var$IS_DOM) {
    $39c5346b7e5f0f6d$var$loaded = ($39c5346b7e5f0f6d$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($39c5346b7e5f0f6d$var$DOCUMENT.readyState);
    if (!$39c5346b7e5f0f6d$var$loaded) $39c5346b7e5f0f6d$var$DOCUMENT.addEventListener("DOMContentLoaded", $39c5346b7e5f0f6d$var$listener);
}
function $39c5346b7e5f0f6d$var$domready(fn) {
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    $39c5346b7e5f0f6d$var$loaded ? setTimeout(fn, 0) : $39c5346b7e5f0f6d$var$functions.push(fn);
}
function $39c5346b7e5f0f6d$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $39c5346b7e5f0f6d$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($39c5346b7e5f0f6d$var$joinAttributes(attributes), ">").concat(children.map($39c5346b7e5f0f6d$var$toHtml).join(""), "</").concat(tag, ">");
}
function $39c5346b7e5f0f6d$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $39c5346b7e5f0f6d$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $39c5346b7e5f0f6d$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $39c5346b7e5f0f6d$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $39c5346b7e5f0f6d$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $39c5346b7e5f0f6d$var$toHex(unicode) {
    var decoded = $39c5346b7e5f0f6d$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $39c5346b7e5f0f6d$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $39c5346b7e5f0f6d$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $39c5346b7e5f0f6d$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $39c5346b7e5f0f6d$var$normalizeIcons(icons);
    if (typeof $39c5346b7e5f0f6d$var$namespace.hooks.addPack === "function" && !skipHooks) $39c5346b7e5f0f6d$var$namespace.hooks.addPack(prefix, $39c5346b7e5f0f6d$var$normalizeIcons(icons));
    else $39c5346b7e5f0f6d$var$namespace.styles[prefix] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $39c5346b7e5f0f6d$var$defineIcons("fa", icons);
}
var $39c5346b7e5f0f6d$var$duotonePathRe = [
    /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $39c5346b7e5f0f6d$var$_LONG_STYLE, $39c5346b7e5f0f6d$var$_PREFIXES, $39c5346b7e5f0f6d$var$_PREFIXES_FOR_FAMILY;
var $39c5346b7e5f0f6d$var$styles = $39c5346b7e5f0f6d$var$namespace.styles, $39c5346b7e5f0f6d$var$shims = $39c5346b7e5f0f6d$var$namespace.shims;
var $39c5346b7e5f0f6d$var$LONG_STYLE = ($39c5346b7e5f0f6d$var$_LONG_STYLE = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_LONG_STYLE, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, Object.values($39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC])), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_LONG_STYLE, $39c5346b7e5f0f6d$var$FAMILY_SHARP, Object.values($39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$FAMILY_SHARP])), $39c5346b7e5f0f6d$var$_LONG_STYLE);
var $39c5346b7e5f0f6d$var$_defaultUsablePrefix = null;
var $39c5346b7e5f0f6d$var$_byUnicode = {};
var $39c5346b7e5f0f6d$var$_byLigature = {};
var $39c5346b7e5f0f6d$var$_byOldName = {};
var $39c5346b7e5f0f6d$var$_byOldUnicode = {};
var $39c5346b7e5f0f6d$var$_byAlias = {};
var $39c5346b7e5f0f6d$var$PREFIXES = ($39c5346b7e5f0f6d$var$_PREFIXES = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_PREFIXES, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_STYLE[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC])), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_PREFIXES, $39c5346b7e5f0f6d$var$FAMILY_SHARP, Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_STYLE[$39c5346b7e5f0f6d$var$FAMILY_SHARP])), $39c5346b7e5f0f6d$var$_PREFIXES);
function $39c5346b7e5f0f6d$var$isReserved(name) {
    return ~$39c5346b7e5f0f6d$var$RESERVED_CLASSES.indexOf(name);
}
function $39c5346b7e5f0f6d$var$getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$39c5346b7e5f0f6d$var$isReserved(iconName)) return iconName;
    else return null;
}
var $39c5346b7e5f0f6d$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $39c5346b7e5f0f6d$var$reduce($39c5346b7e5f0f6d$var$styles, function(o, style, prefix) {
            o[prefix] = $39c5346b7e5f0f6d$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $39c5346b7e5f0f6d$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $39c5346b7e5f0f6d$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $39c5346b7e5f0f6d$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = "far" in $39c5346b7e5f0f6d$var$styles || $39c5346b7e5f0f6d$var$config.autoFetchSvg;
    var shimLookups = $39c5346b7e5f0f6d$var$reduce($39c5346b7e5f0f6d$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $39c5346b7e5f0f6d$var$_byOldName = shimLookups.names;
    $39c5346b7e5f0f6d$var$_byOldUnicode = shimLookups.unicodes;
    $39c5346b7e5f0f6d$var$_defaultUsablePrefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix($39c5346b7e5f0f6d$var$config.styleDefault, {
        family: $39c5346b7e5f0f6d$var$config.familyDefault
    });
};
$39c5346b7e5f0f6d$var$onChange(function(c) {
    $39c5346b7e5f0f6d$var$_defaultUsablePrefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix(c.styleDefault, {
        family: $39c5346b7e5f0f6d$var$config.familyDefault
    });
});
$39c5346b7e5f0f6d$var$build();
function $39c5346b7e5f0f6d$var$byUnicode(prefix, unicode) {
    return ($39c5346b7e5f0f6d$var$_byUnicode[prefix] || {})[unicode];
}
function $39c5346b7e5f0f6d$var$byLigature(prefix, ligature) {
    return ($39c5346b7e5f0f6d$var$_byLigature[prefix] || {})[ligature];
}
function $39c5346b7e5f0f6d$var$byAlias(prefix, alias) {
    return ($39c5346b7e5f0f6d$var$_byAlias[prefix] || {})[alias];
}
function $39c5346b7e5f0f6d$var$byOldName(name) {
    return $39c5346b7e5f0f6d$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $39c5346b7e5f0f6d$var$byOldUnicode(unicode) {
    var oldUnicode = $39c5346b7e5f0f6d$var$_byOldUnicode[unicode];
    var newUnicode = $39c5346b7e5f0f6d$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $39c5346b7e5f0f6d$var$getDefaultUsablePrefix() {
    return $39c5346b7e5f0f6d$var$_defaultUsablePrefix;
}
var $39c5346b7e5f0f6d$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $39c5346b7e5f0f6d$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $39c5346b7e5f0f6d$var$FAMILY_CLASSIC : _params$family;
    var style = $39c5346b7e5f0f6d$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $39c5346b7e5f0f6d$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $39c5346b7e5f0f6d$var$PREFIXES_FOR_FAMILY = ($39c5346b7e5f0f6d$var$_PREFIXES_FOR_FAMILY = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_PREFIXES_FOR_FAMILY, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC])), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_PREFIXES_FOR_FAMILY, $39c5346b7e5f0f6d$var$FAMILY_SHARP, Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$FAMILY_SHARP])), $39c5346b7e5f0f6d$var$_PREFIXES_FOR_FAMILY);
function $39c5346b7e5f0f6d$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $39c5346b7e5f0f6d$var$_defineProperty(_famProps, $39c5346b7e5f0f6d$var$FAMILY_CLASSIC, "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$FAMILY_CLASSIC)), $39c5346b7e5f0f6d$var$_defineProperty(_famProps, $39c5346b7e5f0f6d$var$FAMILY_SHARP, "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $39c5346b7e5f0f6d$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $39c5346b7e5f0f6d$var$PREFIXES_FOR_FAMILY[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC].includes(v);
    })) family = $39c5346b7e5f0f6d$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$39c5346b7e5f0f6d$var$FAMILY_SHARP]) || values.some(function(v) {
        return $39c5346b7e5f0f6d$var$PREFIXES_FOR_FAMILY[$39c5346b7e5f0f6d$var$FAMILY_SHARP].includes(v);
    })) family = $39c5346b7e5f0f6d$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $39c5346b7e5f0f6d$var$getIconName($39c5346b7e5f0f6d$var$config.cssPrefix, cls);
        if ($39c5346b7e5f0f6d$var$styles[cls]) {
            cls = $39c5346b7e5f0f6d$var$LONG_STYLE[family].includes(cls) ? $39c5346b7e5f0f6d$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($39c5346b7e5f0f6d$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $39c5346b7e5f0f6d$var$config.replacementClass && cls !== famProps[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC] && cls !== famProps[$39c5346b7e5f0f6d$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? $39c5346b7e5f0f6d$var$byOldName(acc.iconName) : {};
            var aliasIconName = $39c5346b7e5f0f6d$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$39c5346b7e5f0f6d$var$styles["far"] && $39c5346b7e5f0f6d$var$styles["fas"] && !$39c5346b7e5f0f6d$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $39c5346b7e5f0f6d$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $39c5346b7e5f0f6d$var$FAMILY_SHARP && ($39c5346b7e5f0f6d$var$styles["fass"] || $39c5346b7e5f0f6d$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $39c5346b7e5f0f6d$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
var $39c5346b7e5f0f6d$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $39c5346b7e5f0f6d$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $39c5346b7e5f0f6d$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $39c5346b7e5f0f6d$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $39c5346b7e5f0f6d$var$defineIcons(longPrefix, additions[key]);
                    $39c5346b7e5f0f6d$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === "string") additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $39c5346b7e5f0f6d$var$_plugins = [];
var $39c5346b7e5f0f6d$var$_hooks = {};
var $39c5346b7e5f0f6d$var$providers = {};
var $39c5346b7e5f0f6d$var$defaultProviderKeys = Object.keys($39c5346b7e5f0f6d$var$providers);
function $39c5346b7e5f0f6d$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $39c5346b7e5f0f6d$var$_plugins = nextPlugins;
    $39c5346b7e5f0f6d$var$_hooks = {};
    Object.keys($39c5346b7e5f0f6d$var$providers).forEach(function(k) {
        if ($39c5346b7e5f0f6d$var$defaultProviderKeys.indexOf(k) === -1) delete $39c5346b7e5f0f6d$var$providers[k];
    });
    $39c5346b7e5f0f6d$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if ($39c5346b7e5f0f6d$var$_typeof(mixout[tk]) === "object") Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$39c5346b7e5f0f6d$var$_hooks[hook]) $39c5346b7e5f0f6d$var$_hooks[hook] = [];
                $39c5346b7e5f0f6d$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($39c5346b7e5f0f6d$var$providers);
    });
    return obj;
}
function $39c5346b7e5f0f6d$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $39c5346b7e5f0f6d$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $39c5346b7e5f0f6d$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $39c5346b7e5f0f6d$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $39c5346b7e5f0f6d$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $39c5346b7e5f0f6d$var$providers[hook] ? $39c5346b7e5f0f6d$var$providers[hook].apply(null, args) : undefined;
}
function $39c5346b7e5f0f6d$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $39c5346b7e5f0f6d$var$byAlias(prefix, iconName) || iconName;
    return $39c5346b7e5f0f6d$var$iconFromMapping($39c5346b7e5f0f6d$var$library.definitions, prefix, iconName) || $39c5346b7e5f0f6d$var$iconFromMapping($39c5346b7e5f0f6d$var$namespace.styles, prefix, iconName);
}
var $39c5346b7e5f0f6d$var$library = new $39c5346b7e5f0f6d$var$Library();
var $39c5346b7e5f0f6d$var$noAuto = function noAuto() {
    $39c5346b7e5f0f6d$var$config.autoReplaceSvg = false;
    $39c5346b7e5f0f6d$var$config.observeMutations = false;
    $39c5346b7e5f0f6d$var$callHooks("noAuto");
};
var $39c5346b7e5f0f6d$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($39c5346b7e5f0f6d$var$IS_DOM) {
            $39c5346b7e5f0f6d$var$callHooks("beforeI2svg", params);
            $39c5346b7e5f0f6d$var$callProvided("pseudoElements2svg", params);
            return $39c5346b7e5f0f6d$var$callProvided("i2svg", params);
        } else return Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($39c5346b7e5f0f6d$var$config.autoReplaceSvg === false) $39c5346b7e5f0f6d$var$config.autoReplaceSvg = true;
        $39c5346b7e5f0f6d$var$config.observeMutations = true;
        $39c5346b7e5f0f6d$var$domready(function() {
            $39c5346b7e5f0f6d$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $39c5346b7e5f0f6d$var$callHooks("watch", params);
        });
    }
};
var $39c5346b7e5f0f6d$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($39c5346b7e5f0f6d$var$_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $39c5346b7e5f0f6d$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $39c5346b7e5f0f6d$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-")) > -1 || _icon.match($39c5346b7e5f0f6d$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $39c5346b7e5f0f6d$var$getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $39c5346b7e5f0f6d$var$getDefaultUsablePrefix(),
                iconName: $39c5346b7e5f0f6d$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $39c5346b7e5f0f6d$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $39c5346b7e5f0f6d$export$644d8ea042df96a6 = {
    noAuto: $39c5346b7e5f0f6d$var$noAuto,
    config: $39c5346b7e5f0f6d$var$config,
    dom: $39c5346b7e5f0f6d$var$dom,
    parse: $39c5346b7e5f0f6d$var$parse,
    library: $39c5346b7e5f0f6d$var$library,
    findIconDefinition: $39c5346b7e5f0f6d$var$findIconDefinition,
    toHtml: $39c5346b7e5f0f6d$var$toHtml
};
var $39c5346b7e5f0f6d$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($39c5346b7e5f0f6d$var$namespace.styles).length > 0 || $39c5346b7e5f0f6d$var$config.autoFetchSvg) && $39c5346b7e5f0f6d$var$IS_DOM && $39c5346b7e5f0f6d$var$config.autoReplaceSvg) $39c5346b7e5f0f6d$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $39c5346b7e5f0f6d$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $39c5346b7e5f0f6d$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
            var container = $39c5346b7e5f0f6d$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $39c5346b7e5f0f6d$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $39c5346b7e5f0f6d$var$joinStyles($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, styles), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $39c5346b7e5f0f6d$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $39c5346b7e5f0f6d$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        $39c5346b7e5f0f6d$var$config.replacementClass,
        iconName ? "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$39c5346b7e5f0f6d$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $39c5346b7e5f0f6d$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $39c5346b7e5f0f6d$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $39c5346b7e5f0f6d$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $39c5346b7e5f0f6d$var$asSymbol(args);
    else return $39c5346b7e5f0f6d$var$asIcon(args);
}
function $39c5346b7e5f0f6d$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$39c5346b7e5f0f6d$var$DATA_FA_I2SVG] = "";
    var styles = $39c5346b7e5f0f6d$var$_objectSpread2({}, extra.styles);
    if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform)) {
        styles["transform"] = $39c5346b7e5f0f6d$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $39c5346b7e5f0f6d$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $39c5346b7e5f0f6d$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $39c5346b7e5f0f6d$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $39c5346b7e5f0f6d$var$styles$1 = $39c5346b7e5f0f6d$var$namespace.styles;
function $39c5346b7e5f0f6d$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $39c5346b7e5f0f6d$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $39c5346b7e5f0f6d$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $39c5346b7e5f0f6d$var$maybeNotifyMissing(iconName, prefix) {
    if (!$39c5346b7e5f0f6d$var$PRODUCTION && !$39c5346b7e5f0f6d$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $39c5346b7e5f0f6d$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && $39c5346b7e5f0f6d$var$config.styleDefault !== null) prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $39c5346b7e5f0f6d$var$callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = $39c5346b7e5f0f6d$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $39c5346b7e5f0f6d$var$styles$1[prefix] && $39c5346b7e5f0f6d$var$styles$1[prefix][iconName]) {
            var icon = $39c5346b7e5f0f6d$var$styles$1[prefix][iconName];
            return resolve($39c5346b7e5f0f6d$var$asFoundIcon(icon));
        }
        $39c5346b7e5f0f6d$var$maybeNotifyMissing(iconName, prefix);
        resolve($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$missingIconResolutionMixin), {}, {
            icon: $39c5346b7e5f0f6d$var$config.showMissingIcons && iconName ? $39c5346b7e5f0f6d$var$callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var $39c5346b7e5f0f6d$var$noop$1 = function noop() {};
var $39c5346b7e5f0f6d$var$p = $39c5346b7e5f0f6d$var$config.measurePerformance && $39c5346b7e5f0f6d$var$PERFORMANCE && $39c5346b7e5f0f6d$var$PERFORMANCE.mark && $39c5346b7e5f0f6d$var$PERFORMANCE.measure ? $39c5346b7e5f0f6d$var$PERFORMANCE : {
    mark: $39c5346b7e5f0f6d$var$noop$1,
    measure: $39c5346b7e5f0f6d$var$noop$1
};
var $39c5346b7e5f0f6d$var$preamble = 'FA "6.5.1"';
var $39c5346b7e5f0f6d$var$begin = function begin(name) {
    $39c5346b7e5f0f6d$var$p.mark("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $39c5346b7e5f0f6d$var$end(name);
    };
};
var $39c5346b7e5f0f6d$var$end = function end(name) {
    $39c5346b7e5f0f6d$var$p.mark("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " ends"));
    $39c5346b7e5f0f6d$var$p.measure("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name), "".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " begins"), "".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " ends"));
};
var $39c5346b7e5f0f6d$var$perf = {
    begin: $39c5346b7e5f0f6d$var$begin,
    end: $39c5346b7e5f0f6d$var$end
};
var $39c5346b7e5f0f6d$var$noop$2 = function noop() {};
function $39c5346b7e5f0f6d$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $39c5346b7e5f0f6d$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_ICON) : null;
    return prefix && icon;
}
function $39c5346b7e5f0f6d$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($39c5346b7e5f0f6d$var$config.replacementClass);
}
function $39c5346b7e5f0f6d$var$getMutator() {
    if ($39c5346b7e5f0f6d$var$config.autoReplaceSvg === true) return $39c5346b7e5f0f6d$var$mutators.replace;
    var mutator = $39c5346b7e5f0f6d$var$mutators[$39c5346b7e5f0f6d$var$config.autoReplaceSvg];
    return mutator || $39c5346b7e5f0f6d$var$mutators.replace;
}
function $39c5346b7e5f0f6d$var$createElementNS(tag) {
    return $39c5346b7e5f0f6d$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $39c5346b7e5f0f6d$var$createElement(tag) {
    return $39c5346b7e5f0f6d$var$DOCUMENT.createElement(tag);
}
function $39c5346b7e5f0f6d$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? $39c5346b7e5f0f6d$var$createElementNS : $39c5346b7e5f0f6d$var$createElement : _params$ceFn;
    if (typeof abstractObj === "string") return $39c5346b7e5f0f6d$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($39c5346b7e5f0f6d$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $39c5346b7e5f0f6d$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $39c5346b7e5f0f6d$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(_abstract) {
                node.parentNode.insertBefore($39c5346b7e5f0f6d$var$convertSVG(_abstract), node);
            });
            if (node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG) === null && $39c5346b7e5f0f6d$var$config.keepOriginalSource) {
                var comment = $39c5346b7e5f0f6d$var$DOCUMENT.createComment($39c5346b7e5f0f6d$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$39c5346b7e5f0f6d$var$classArray(node).indexOf($39c5346b7e5f0f6d$var$config.replacementClass)) return $39c5346b7e5f0f6d$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-.*"));
        delete _abstract2[0].attributes.id;
        if (_abstract2[0].attributes.class) {
            var splitClasses = _abstract2[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === $39c5346b7e5f0f6d$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract2[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        var newInnerHTML = _abstract2.map(function(a) {
            return $39c5346b7e5f0f6d$var$toHtml(a);
        }).join("\n");
        node.setAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $39c5346b7e5f0f6d$var$performOperationSync(op) {
    op();
}
function $39c5346b7e5f0f6d$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $39c5346b7e5f0f6d$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $39c5346b7e5f0f6d$var$performOperationSync;
        if ($39c5346b7e5f0f6d$var$config.mutateApproach === $39c5346b7e5f0f6d$var$MUTATION_APPROACH_ASYNC) frame = $39c5346b7e5f0f6d$var$WINDOW.requestAnimationFrame || $39c5346b7e5f0f6d$var$performOperationSync;
        frame(function() {
            var mutator = $39c5346b7e5f0f6d$var$getMutator();
            var mark = $39c5346b7e5f0f6d$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $39c5346b7e5f0f6d$var$disabled = false;
function $39c5346b7e5f0f6d$var$disableObservation() {
    $39c5346b7e5f0f6d$var$disabled = true;
}
function $39c5346b7e5f0f6d$var$enableObservation() {
    $39c5346b7e5f0f6d$var$disabled = false;
}
var $39c5346b7e5f0f6d$var$mo = null;
function $39c5346b7e5f0f6d$var$observe(options) {
    if (!$39c5346b7e5f0f6d$var$MUTATION_OBSERVER) return;
    if (!$39c5346b7e5f0f6d$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _options$observeMutat;
    $39c5346b7e5f0f6d$var$mo = new $39c5346b7e5f0f6d$var$MUTATION_OBSERVER(function(objects) {
        if ($39c5346b7e5f0f6d$var$disabled) return;
        var defaultPrefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
        $39c5346b7e5f0f6d$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$39c5346b7e5f0f6d$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($39c5346b7e5f0f6d$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $39c5346b7e5f0f6d$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $39c5346b7e5f0f6d$var$isWatched(mutationRecord.target) && ~$39c5346b7e5f0f6d$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $39c5346b7e5f0f6d$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $39c5346b7e5f0f6d$var$getCanonicalIcon($39c5346b7e5f0f6d$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($39c5346b7e5f0f6d$var$DATA_ICON, iconName);
                } else if ($39c5346b7e5f0f6d$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    $39c5346b7e5f0f6d$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $39c5346b7e5f0f6d$var$disconnect() {
    if (!$39c5346b7e5f0f6d$var$mo) return;
    $39c5346b7e5f0f6d$var$mo.disconnect();
}
function $39c5346b7e5f0f6d$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $39c5346b7e5f0f6d$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $39c5346b7e5f0f6d$var$getCanonicalIcon($39c5346b7e5f0f6d$var$classArray(node));
    if (!val.prefix) val.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $39c5346b7e5f0f6d$var$byLigature(val.prefix, node.innerText) || $39c5346b7e5f0f6d$var$byUnicode(val.prefix, $39c5346b7e5f0f6d$var$toHex(node.innerText));
    if (!val.iconName && $39c5346b7e5f0f6d$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $39c5346b7e5f0f6d$var$attributesParser(node) {
    var extraAttributes = $39c5346b7e5f0f6d$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($39c5346b7e5f0f6d$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($39c5346b7e5f0f6d$var$config.replacementClass, "-title-").concat(titleId || $39c5346b7e5f0f6d$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $39c5346b7e5f0f6d$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $39c5346b7e5f0f6d$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $39c5346b7e5f0f6d$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $39c5346b7e5f0f6d$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $39c5346b7e5f0f6d$var$attributesParser(node);
    var pluginMeta = $39c5346b7e5f0f6d$var$chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? $39c5346b7e5f0f6d$var$styleParser(node) : [];
    return $39c5346b7e5f0f6d$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $39c5346b7e5f0f6d$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $39c5346b7e5f0f6d$var$styles$2 = $39c5346b7e5f0f6d$var$namespace.styles;
function $39c5346b7e5f0f6d$var$generateMutation(node) {
    var nodeMeta = $39c5346b7e5f0f6d$var$config.autoReplaceSvg === "nest" ? $39c5346b7e5f0f6d$var$parseMeta(node, {
        styleParser: false
    }) : $39c5346b7e5f0f6d$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME)) return $39c5346b7e5f0f6d$var$callProvided("generateLayersText", node, nodeMeta);
    else return $39c5346b7e5f0f6d$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
var $39c5346b7e5f0f6d$var$knownPrefixes = new Set();
$39c5346b7e5f0f6d$var$FAMILIES.map(function(family) {
    $39c5346b7e5f0f6d$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_STYLE[$39c5346b7e5f0f6d$var$FAMILY_CLASSIC]).map($39c5346b7e5f0f6d$var$knownPrefixes.add.bind($39c5346b7e5f0f6d$var$knownPrefixes));
Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_STYLE[$39c5346b7e5f0f6d$var$FAMILY_SHARP]).map($39c5346b7e5f0f6d$var$knownPrefixes.add.bind($39c5346b7e5f0f6d$var$knownPrefixes));
$39c5346b7e5f0f6d$var$knownPrefixes = $39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$knownPrefixes);
function $39c5346b7e5f0f6d$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $39c5346b7e5f0f6d$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $39c5346b7e5f0f6d$var$config.autoFetchSvg ? $39c5346b7e5f0f6d$var$knownPrefixes : $39c5346b7e5f0f6d$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($39c5346b7e5f0f6d$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    var prefixesDomQuery = [
        ".".concat($39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $39c5346b7e5f0f6d$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    var mark = $39c5346b7e5f0f6d$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $39c5346b7e5f0f6d$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$39c5346b7e5f0f6d$var$PRODUCTION) {
                if (e.name === "MissingIcon") console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $39c5346b7e5f0f6d$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $39c5346b7e5f0f6d$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $39c5346b7e5f0f6d$var$generateMutation(node).then(function(mutation) {
        if (mutation) $39c5346b7e5f0f6d$var$perform([
            mutation
        ], callback);
    });
}
function $39c5346b7e5f0f6d$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $39c5346b7e5f0f6d$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $39c5346b7e5f0f6d$var$findIconDefinition(mask || {});
        return next(iconDefinition, $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $39c5346b7e5f0f6d$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $39c5346b7e5f0f6d$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $39c5346b7e5f0f6d$var$domVariants($39c5346b7e5f0f6d$var$_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        $39c5346b7e5f0f6d$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($39c5346b7e5f0f6d$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($39c5346b7e5f0f6d$var$config.replacementClass, "-title-").concat(titleId || $39c5346b7e5f0f6d$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $39c5346b7e5f0f6d$var$makeInlineSvgAbstract({
            icons: {
                main: $39c5346b7e5f0f6d$var$asFoundIcon(icon),
                mask: mask ? $39c5346b7e5f0f6d$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $39c5346b7e5f0f6d$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $39c5346b7e5f0f6d$var$resolveIcons($39c5346b7e5f0f6d$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $39c5346b7e5f0f6d$var$onTree;
                accumulator.nodeCallback = $39c5346b7e5f0f6d$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function callback() {} : _params$callback;
            return $39c5346b7e5f0f6d$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $39c5346b7e5f0f6d$var$findIcon(iconName, prefix),
                    mask.iconName ? $39c5346b7e5f0f6d$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $39c5346b7e5f0f6d$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $39c5346b7e5f0f6d$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $39c5346b7e5f0f6d$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            var nextChild;
            if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform)) nextChild = $39c5346b7e5f0f6d$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: "layer"
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers")
                                ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $39c5346b7e5f0f6d$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers-counter")
                            ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $39c5346b7e5f0f6d$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: "text",
                    content: content
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $39c5346b7e5f0f6d$var$makeLayersTextAbstract({
                        content: content,
                        transform: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers-text")
                            ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($39c5346b7e5f0f6d$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($39c5346b7e5f0f6d$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $39c5346b7e5f0f6d$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $39c5346b7e5f0f6d$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $39c5346b7e5f0f6d$var$hexValueFromContent(content) {
    var cleaned = content.replace($39c5346b7e5f0f6d$var$CLEAN_CONTENT_PATTERN, "");
    var codePoint = $39c5346b7e5f0f6d$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $39c5346b7e5f0f6d$var$toHex(cleaned[0]) : $39c5346b7e5f0f6d$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $39c5346b7e5f0f6d$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $39c5346b7e5f0f6d$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $39c5346b7e5f0f6d$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($39c5346b7e5f0f6d$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? $39c5346b7e5f0f6d$var$FAMILY_SHARP : $39c5346b7e5f0f6d$var$FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $39c5346b7e5f0f6d$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $39c5346b7e5f0f6d$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = $39c5346b7e5f0f6d$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $39c5346b7e5f0f6d$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($39c5346b7e5f0f6d$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $39c5346b7e5f0f6d$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $39c5346b7e5f0f6d$var$findIcon(iconName, prefix).then(function(main) {
                    var _abstract = $39c5346b7e5f0f6d$var$makeInlineSvgAbstract($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $39c5346b7e5f0f6d$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $39c5346b7e5f0f6d$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return $39c5346b7e5f0f6d$var$toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $39c5346b7e5f0f6d$var$replace(node) {
    return Promise.all([
        $39c5346b7e5f0f6d$var$replaceForPosition(node, "::before"),
        $39c5346b7e5f0f6d$var$replaceForPosition(node, "::after")
    ]);
}
function $39c5346b7e5f0f6d$var$processable(node) {
    return node.parentNode !== document.head && !~$39c5346b7e5f0f6d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $39c5346b7e5f0f6d$var$searchPseudoElements(root) {
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $39c5346b7e5f0f6d$var$toArray(root.querySelectorAll("*")).filter($39c5346b7e5f0f6d$var$processable).map($39c5346b7e5f0f6d$var$replace);
        var end = $39c5346b7e5f0f6d$var$perf.begin("searchPseudoElements");
        $39c5346b7e5f0f6d$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $39c5346b7e5f0f6d$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $39c5346b7e5f0f6d$var$enableObservation();
            reject();
        });
    });
}
var $39c5346b7e5f0f6d$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $39c5346b7e5f0f6d$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$node;
            if ($39c5346b7e5f0f6d$var$config.searchPseudoElements) $39c5346b7e5f0f6d$var$searchPseudoElements(node);
        };
    }
};
var $39c5346b7e5f0f6d$var$_unwatched = false;
var $39c5346b7e5f0f6d$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $39c5346b7e5f0f6d$var$disableObservation();
                    $39c5346b7e5f0f6d$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $39c5346b7e5f0f6d$var$observe($39c5346b7e5f0f6d$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto() {
                $39c5346b7e5f0f6d$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($39c5346b7e5f0f6d$var$_unwatched) $39c5346b7e5f0f6d$var$enableObservation();
                else $39c5346b7e5f0f6d$var$observe($39c5346b7e5f0f6d$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $39c5346b7e5f0f6d$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $39c5346b7e5f0f6d$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $39c5346b7e5f0f6d$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $39c5346b7e5f0f6d$var$fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = "black";
    return _abstract;
}
function $39c5346b7e5f0f6d$var$deGroup(_abstract2) {
    if (_abstract2.tag === "g") return _abstract2.children;
    else return [
        _abstract2
    ];
}
var $39c5346b7e5f0f6d$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? $39c5346b7e5f0f6d$var$emptyCanonicalIcon() : $39c5346b7e5f0f6d$var$getCanonicalIcon(maskData.split(" ").map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $39c5346b7e5f0f6d$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($39c5346b7e5f0f6d$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, trans.inner),
                children: [
                    $39c5346b7e5f0f6d$var$fillBlack($39c5346b7e5f0f6d$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $39c5346b7e5f0f6d$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $39c5346b7e5f0f6d$var$nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $39c5346b7e5f0f6d$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $39c5346b7e5f0f6d$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($39c5346b7e5f0f6d$var$WINDOW.matchMedia) reduceMotion = $39c5346b7e5f0f6d$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: "1;0;1;1;0;1;"
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$plugins = [
    $39c5346b7e5f0f6d$var$InjectCSS,
    $39c5346b7e5f0f6d$var$ReplaceElements,
    $39c5346b7e5f0f6d$var$Layers,
    $39c5346b7e5f0f6d$var$LayersCounter,
    $39c5346b7e5f0f6d$var$LayersText,
    $39c5346b7e5f0f6d$var$PseudoElements,
    $39c5346b7e5f0f6d$var$MutationObserver$1,
    $39c5346b7e5f0f6d$var$PowerTransforms,
    $39c5346b7e5f0f6d$var$Masks,
    $39c5346b7e5f0f6d$var$MissingIconIndicator,
    $39c5346b7e5f0f6d$var$SvgSymbols
];
$39c5346b7e5f0f6d$var$registerPlugins($39c5346b7e5f0f6d$var$plugins, {
    mixoutsTo: $39c5346b7e5f0f6d$export$644d8ea042df96a6
});
var $39c5346b7e5f0f6d$export$4f8e844b2782642c = $39c5346b7e5f0f6d$export$644d8ea042df96a6.noAuto;
var $39c5346b7e5f0f6d$export$e506a1d27d1eaa20 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.config;
var $39c5346b7e5f0f6d$export$b839f963c7dc0e34 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.library;
var $39c5346b7e5f0f6d$export$df3a06d6289f983e = $39c5346b7e5f0f6d$export$644d8ea042df96a6.dom;
var $39c5346b7e5f0f6d$export$98e6a39c04603d36 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.parse;
var $39c5346b7e5f0f6d$export$221fed4a47f597a5 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.findIconDefinition;
var $39c5346b7e5f0f6d$export$a10125c086a4df16 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.toHtml;
var $39c5346b7e5f0f6d$export$1ca1ec8b29a4ce27 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.icon;
var $39c5346b7e5f0f6d$export$50a222d9023da98b = $39c5346b7e5f0f6d$export$644d8ea042df96a6.layer;
var $39c5346b7e5f0f6d$export$6f093cfa640b7166 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.text;
var $39c5346b7e5f0f6d$export$e575061ef2a070eb = $39c5346b7e5f0f6d$export$644d8ea042df96a6.counter;




var $eHaBZ = parcelRequire("eHaBZ");
function $2ca1a35d7f3a323d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2ca1a35d7f3a323d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2ca1a35d7f3a323d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2ca1a35d7f3a323d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2ca1a35d7f3a323d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2ca1a35d7f3a323d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2ca1a35d7f3a323d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2ca1a35d7f3a323d$var$_typeof(obj);
}
function $2ca1a35d7f3a323d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2ca1a35d7f3a323d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2ca1a35d7f3a323d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2ca1a35d7f3a323d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2ca1a35d7f3a323d$var$_toConsumableArray(arr) {
    return $2ca1a35d7f3a323d$var$_arrayWithoutHoles(arr) || $2ca1a35d7f3a323d$var$_iterableToArray(arr) || $2ca1a35d7f3a323d$var$_unsupportedIterableToArray(arr) || $2ca1a35d7f3a323d$var$_nonIterableSpread();
}
function $2ca1a35d7f3a323d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2ca1a35d7f3a323d$var$_arrayLikeToArray(arr);
}
function $2ca1a35d7f3a323d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2ca1a35d7f3a323d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2ca1a35d7f3a323d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2ca1a35d7f3a323d$var$_arrayLikeToArray(o, minLen);
}
function $2ca1a35d7f3a323d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2ca1a35d7f3a323d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $2ca1a35d7f3a323d$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $2ca1a35d7f3a323d$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $2ca1a35d7f3a323d$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $2ca1a35d7f3a323d$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $2ca1a35d7f3a323d$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $2ca1a35d7f3a323d$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $2ca1a35d7f3a323d$var$camelize(string) {
    if ($2ca1a35d7f3a323d$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $2ca1a35d7f3a323d$var$_excluded = [
    "style"
];
function $2ca1a35d7f3a323d$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $2ca1a35d7f3a323d$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $2ca1a35d7f3a323d$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$2ca1a35d7f3a323d$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $2ca1a35d7f3a323d$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $2ca1a35d7f3a323d$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $2ca1a35d7f3a323d$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$2ca1a35d7f3a323d$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $2ca1a35d7f3a323d$var$_objectWithoutProperties(extraProps, $2ca1a35d7f3a323d$var$_excluded);
    mixins.attrs["style"] = $2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($2ca1a35d7f3a323d$var$_toConsumableArray(children)));
}
var $2ca1a35d7f3a323d$var$PRODUCTION = false;
try {
    $2ca1a35d7f3a323d$var$PRODUCTION = true;
} catch (e) {}
function $2ca1a35d7f3a323d$var$log() {
    if (!$2ca1a35d7f3a323d$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $2ca1a35d7f3a323d$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $2ca1a35d7f3a323d$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).icon) return (0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $2ca1a35d7f3a323d$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $2ca1a35d7f3a323d$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $2ca1a35d7f3a323d$var$_defineProperty({}, key, value) : {};
}
var $2ca1a35d7f3a323d$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $2ca1a35d7f3a323d$var$normalizeIconArgs(iconArgs);
    var classes = $2ca1a35d7f3a323d$var$objectWithKey("classes", [].concat($2ca1a35d7f3a323d$var$_toConsumableArray($2ca1a35d7f3a323d$var$classList(props)), $2ca1a35d7f3a323d$var$_toConsumableArray(className.split(" "))));
    var transform = $2ca1a35d7f3a323d$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $2ca1a35d7f3a323d$var$objectWithKey("mask", $2ca1a35d7f3a323d$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $39c5346b7e5f0f6d$export$1ca1ec8b29a4ce27)(iconLookup, $2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $2ca1a35d7f3a323d$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$2ca1a35d7f3a323d$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $2ca1a35d7f3a323d$var$convertCurry(abstract[0], extraProps);
});
$2ca1a35d7f3a323d$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$2ca1a35d7f3a323d$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool
};
$2ca1a35d7f3a323d$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $2ca1a35d7f3a323d$var$convertCurry = $2ca1a35d7f3a323d$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement);


var $b90992e7bfaebf0a$exports = {};

var $2bfPH = parcelRequire("2bfPH");

!function(e, t) {
    $b90992e7bfaebf0a$exports = t((parcelRequire("eHaBZ")));
}(undefined, function(e) {
    "use strict";
    function t(e) {
        return e && "object" == typeof e && "default" in e ? e.default : e;
    }
    var n = t(e);
    function r(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function i(e) {
        for(var _$t = 1; _$t < arguments.length; _$t++){
            var n = null != arguments[_$t] ? arguments[_$t] : {};
            _$t % 2 ? r(Object(n), !0).forEach(function(t) {
                o(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    function o(e, t, n) {
        return (t = function(e) {
            var _$t = function(e, t) {
                if ("object" != typeof e || null === e) return e;
                var _$n = e[Symbol.toPrimitive];
                if (void 0 !== _$n) {
                    var r = _$n.call(e, t || "default");
                    if ("object" != typeof r) return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
            }(e, "string");
            return "symbol" == (typeof _$t === "undefined" ? "undefined" : (0, $2bfPH._)(_$t)) ? _$t : String(_$t);
        }(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e;
    }
    function l() {
        return (l = Object.assign ? Object.assign.bind() : function l(e) {
            for(var _$t = 1; _$t < arguments.length; _$t++){
                var n = arguments[_$t];
                for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
        }).apply(this, arguments);
    }
    function a(e, t) {
        if (null == e) return {};
        var n, r, i = function(e, t) {
            if (null == e) return {};
            var n, r, i = {}, o = Object.keys(e);
            for(r = 0; r < o.length; r++)n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for(r = 0; r < o.length; r++)n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
    }
    function c(e, t) {
        return function(e) {
            if (Array.isArray(e)) return e;
        }(e) || function(e, t) {
            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != n) {
                var r, i, o, l, a = [], c = !0, u = !1;
                try {
                    if (o = (n = n.call(e)).next, 0 === t) {
                        if (Object(n) !== n) return;
                        c = !1;
                    } else for(; !(c = (r = o.call(n)).done) && (a.push(r.value), a.length !== t); c = !0);
                } catch (e) {
                    u = !0, i = e;
                } finally{
                    try {
                        if (!c && null != n.return && (l = n.return(), Object(l) !== l)) return;
                    } finally{
                        if (u) throw i;
                    }
                }
                return a;
            }
        }(e, t) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return u(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return u(e, t);
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function u(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
        return r;
    }
    var s = [
        "children",
        "transition",
        "style",
        "render",
        "elementType",
        "isOpen",
        "collapseHeight",
        "onInit",
        "onChange",
        "className",
        "addState",
        "noAnim",
        "overflowOnExpanded"
    ];
    function f(e) {
        requestAnimationFrame(function() {
            requestAnimationFrame(e);
        });
    }
    return function(t) {
        var r = t.children, o = t.transition, u = t.style, p = t.render, y = t.elementType, d = void 0 === y ? "div" : y, b = t.isOpen, v = t.collapseHeight, g = void 0 === v ? "0px" : v, h = t.onInit, m = t.onChange, O = t.className, j = void 0 === O ? "collapse-css-transition" : O, w = t.addState, x = t.noAnim, S = t.overflowOnExpanded, P = a(t, s), A = function A() {
            return "0px" === g ? "hidden" : "";
        }, E = c(e.useReducer(function(e) {
            return e + 1;
        }, 0), 2);
        E[0];
        var T = E[1], D = e.useRef(), I = c(e.useState(0), 2), C = I[0], N = I[1], k = e.useRef({
            collapse: b ? "expanded" : "collapsed",
            style: {
                height: b ? "" : g,
                visibility: b ? "" : A()
            }
        }).current;
        e.useEffect(function() {
            C && R(m);
        }, [
            C
        ]);
        var R = function R(e) {
            var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            e && (e.name, e(i({
                state: k.collapse,
                style: k.style
            }, _$t)));
        };
        function q() {
            D.current && (k.collapse = "collapsed", k.style = {
                height: g,
                visibility: A()
            }, T(), setTimeout(function() {
                return N(Date.now);
            }, 0));
        }
        function H() {
            D.current && (k.collapse = "expanded", k.style = {
                height: "",
                visibility: ""
            }, T(), setTimeout(function() {
                return N(Date.now);
            }, 0));
        }
        function F() {
            return "".concat(D.current.scrollHeight, "px");
        }
        var M = "expanded" === k.collapse || "expanding" === k.collapse;
        !M && b && function() {
            if (D.current) {
                if (x) return H();
                k.collapse = "expanding", f(function() {
                    D.current && "expanding" === k.collapse && (k.style = {
                        height: F(),
                        visibility: ""
                    }, N(Date.now));
                });
            }
        }(), M && !b && function() {
            if (D.current) {
                if (x) return q();
                k.collapse = "collapsing", k.style = {
                    height: F(),
                    visibility: ""
                }, T(), f(function() {
                    D.current && "collapsing" === k.collapse && (k.style = {
                        height: g,
                        visibility: ""
                    }, N(Date.now));
                });
            }
        }();
        var U = i(i({
            overflow: "expanded" === k.collapse && S ? "" : "hidden",
            transition: o
        }, u), k.style), $ = d, z = e.useCallback(function(e) {
            e && (D.current = e, R(h, {
                node: e
            }));
        }, [
            d
        ]), B = w ? "".concat(j, " --c-").concat(k.collapse) : j;
        return n.createElement($, l({
            ref: z,
            style: U,
            onTransitionEnd: function onTransitionEnd(e) {
                var _$t = e.target, n = e.propertyName;
                if (_$t === D.current && "height" === n) {
                    var r = _$t.style.height;
                    switch(k.collapse, k.collapse){
                        case "expanding":
                            "" === r || r === g || H();
                            break;
                        case "collapsing":
                            "" === r || r !== g || q();
                    }
                }
            },
            className: B
        }, P), "function" == typeof r ? r(k.collapse) : "function" == typeof p ? p(k.collapse) : r);
    };
});


var $c31009cc66f4e9b8$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $c31009cc66f4e9b8$exports) {
        classNames.default = classNames;
        $c31009cc66f4e9b8$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();







var $eHaBZ = parcelRequire("eHaBZ");



var $eHaBZ = parcelRequire("eHaBZ");
var $026aafd64bf1663f$var$defaultOptions = {};
/**
 *
 * useInput Hook
 *
 * Handles an input's value and onChange props internally to
 * make text input creation process easier
 *
 * @param {unknown} [initialValue] Initial value of the input
 * @param {Options} [options] Options object
 * @returns {InputHandler} Input handler with value and onChange
 * @see https://rooks.vercel.app/docs/useInput
 */ function $026aafd64bf1663f$export$1e36b9f257eee5fa() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $026aafd64bf1663f$var$defaultOptions;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(initialValue), 2), value = _useState[0], setValue = _useState[1];
    var onChange = (0, $eHaBZ.useCallback)(function(event) {
        var newValue = event.target.value;
        var shouldUpdate = true;
        if (typeof options.validate === "function") shouldUpdate = options.validate(newValue, value);
        if (shouldUpdate) setValue(newValue);
    }, [
        options,
        value
    ]);
    // sync with default value
    (0, $eHaBZ.useEffect)(function() {
        setValue(initialValue);
    }, [
        initialValue
    ]);
    var handler = {
        onChange: onChange,
        value: value
    };
    return handler;
}





function $ecbfc97fac1903d9$export$2e2bcd8739ae039(param) {
    var setTitle = param.setTitle;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL), 2), state = _useState[0], setState = _useState[1];
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(""), 2), hashedPassword = _useState1[0], setHashedPassword = _useState1[1];
    var _useState2 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), error = _useState2[0], setError = _useState2[1];
    var passwordEntry = (0, $026aafd64bf1663f$export$1e36b9f257eee5fa)("");
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    var submit = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
        (0, $5be8e377f991f791$export$708be5cd94908894)(passwordEntry.value.trim()).then(function(hashedPassword) {
            setHashedPassword(hashedPassword);
            setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
        }).catch(function(error) {
            if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                history.push("/sign/in", {
                    error: "Generating a new password hash requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                    returnLocation: "/password"
                });
                return;
            }
            setError(error);
            setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).ERROR);
        });
    }, [
        history,
        passwordEntry.value
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setTitle("selfoss password hash generator");
        return function() {
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    var message = state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
        className: "error",
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("label", {
            children: [
                "Generated Password (insert this into config.ini):",
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                    type: "text",
                    value: hashedPassword,
                    readOnly: true
                })
            ]
        })
    }) : state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).ERROR ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
        className: "error",
        children: [
            "Unexpected happened.",
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("details", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("pre", {
                    children: [
                        "$",
                        JSON.stringify(error)
                    ]
                })
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        action: "",
        method: "post",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            id: "login",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h1", {
                        children: "hash generator"
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "password",
                            children: "Password:"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
                            type: "password",
                            name: "password",
                            autoComplete: "new-password",
                            accessKey: "p"
                        }, passwordEntry))
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: message
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            className: "button",
                            type: "submit",
                            value: state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING ? "Hashing password\u2026" : "Compute hash",
                            accessKey: "g",
                            disabled: state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING
                        })
                    ]
                })
            ]
        })
    });
}
$ecbfc97fac1903d9$export$2e2bcd8739ae039.propTypes = {
    setTitle: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};





var $eHaBZ = parcelRequire("eHaBZ");

var $2065ab085cb8cea8$exports = {};
"use strict";

$2065ab085cb8cea8$exports = (parcelRequire("lELzA"));


var $148c4e751dd82504$export$8793edee2d425525 = function() {};


/**
 *
 * @returns {boolean} Is navigator online
 */ function $cf4db7b376694e94$var$getSnapshot() {
    if (typeof window === "undefined") return null;
    return navigator.onLine;
}
function $cf4db7b376694e94$var$subscribe(onStoreChange) {
    if (typeof window !== "undefined") {
        window.addEventListener("online", onStoreChange);
        window.addEventListener("offline", onStoreChange);
        return function() {
            window.removeEventListener("online", onStoreChange);
            window.removeEventListener("offline", onStoreChange);
        };
    } else {
        console.warn("useOnline: window is undefined.");
        return 0, $148c4e751dd82504$export$8793edee2d425525;
    }
}
/**
 * useOnline hook
 *
 * Returns true if navigator is online, false if not.
 *
 * @returns {boolean} The value of navigator.onLine
 * @see https://rooks.vercel.app/docs/useOnline
 */ function $cf4db7b376694e94$export$6feb6ada280bcdab() {
    var isOnline = (0, $2065ab085cb8cea8$exports.useSyncExternalStore)($cf4db7b376694e94$var$subscribe, $cf4db7b376694e94$var$getSnapshot);
    return isOnline;
}






function $f343fb504b01a581$export$2e2bcd8739ae039(param) {
    var setTitle = param.setTitle;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL), 2), state = _useState[0], setState = _useState[1];
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), message = _useState1[0], setMessage = _useState1[1];
    var fileEntry = (0, $eHaBZ.useRef)();
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    var submit = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
        var file = fileEntry.current.files[0];
        (0, $5be8e377f991f791$export$b3b4cde15a96b715)(file).then(function(param) {
            var response = param.response, data = param.data;
            var messages = data.messages;
            if (response.status === 200) {
                setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
                setMessage(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                    className: "msg success",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                            children: messages.map(function(msg, i) {
                                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: msg
                                }, i);
                            })
                        }),
                        "You might want to ",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                            href: "update",
                            children: "update now"
                        }),
                        " or ",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                            to: "/",
                            children: "view your feeds"
                        }),
                        "."
                    ]
                }));
            } else if (response.status === 202) {
                setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).ERROR);
                setMessage(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                    className: "msg error",
                    children: [
                        "The following feeds could not be imported:",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                            children: messages.map(function(msg, i) {
                                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: msg
                                }, i);
                            })
                        })
                    ]
                }));
            } else if (response.status === 400) {
                setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).ERROR);
                setMessage(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                    className: "msg error",
                    children: [
                        "There was a problem importing your OPML file:",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                            children: messages.map(function(msg, i) {
                                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: msg
                                }, i);
                            })
                        })
                    ]
                }));
            } else throw new (0, $0d06257c362dc1a1$export$4511c7da58e2d9c2)("OPML import handler received status ".concat(response.status, ". This should not happen."));
        }).catch(function(error) {
            if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                history.push("/sign/in", {
                    error: "Importing OPML file requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                    returnLocation: "/opml"
                });
                return;
            } else {
                setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).ERROR);
                setMessage(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                    className: "msg error",
                    children: [
                        "Unexpected error occurred.",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("details", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("pre", {
                                children: error.message
                            })
                        })
                    ]
                }));
            }
        });
    }, [
        history
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setTitle("selfoss OPML importer");
        return function() {
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    var isOnline = (0, $cf4db7b376694e94$export$6feb6ada280bcdab)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        action: "",
        method: "post",
        encType: "multipart/form-data",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            id: "opml",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h1", {
                        children: "Upload an OPML File"
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        children: "Coming from a different RSS Reader? Export your subscriptions to an OPML file and upload it here. OPML export is usually located somewhere in settings, consult the reader\u2019s manual."
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: [
                        !isOnline && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            className: "msg error",
                            children: "OPML import requires an internet connection. Please reconnect before proceeding."
                        }),
                        message
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "opml",
                            children: "Opml.xml:"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            type: "file",
                            accessKey: "f",
                            ref: fileEntry,
                            id: "opml",
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "button",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            type: "submit",
                            value: state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING ? "Importing\u2026" : "Deliver my OPML!",
                            accessKey: "d",
                            disabled: !isOnline || state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING
                        })
                    ]
                })
            ]
        })
    });
}
$f343fb504b01a581$export$2e2bcd8739ae039.propTypes = {
    setTitle: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};





var $eHaBZ = parcelRequire("eHaBZ");




var $eHaBZ = parcelRequire("eHaBZ");


var $8216ee54ed5c099f$exports = {};
"use strict";
Object.defineProperty($8216ee54ed5c099f$exports, "__esModule", {
    value: true
});
var $8216ee54ed5c099f$var$prefix = "fab";
var $8216ee54ed5c099f$var$iconName = "diaspora";
var $8216ee54ed5c099f$var$width = 512;
var $8216ee54ed5c099f$var$height = 512;
var $8216ee54ed5c099f$var$aliases = [];
var $8216ee54ed5c099f$var$unicode = "f791";
var $8216ee54ed5c099f$var$svgPathData = "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z";
$8216ee54ed5c099f$exports.definition = {
    prefix: $8216ee54ed5c099f$var$prefix,
    iconName: $8216ee54ed5c099f$var$iconName,
    icon: [
        $8216ee54ed5c099f$var$width,
        $8216ee54ed5c099f$var$height,
        $8216ee54ed5c099f$var$aliases,
        $8216ee54ed5c099f$var$unicode,
        $8216ee54ed5c099f$var$svgPathData
    ]
};
$8216ee54ed5c099f$exports.faDiaspora = $8216ee54ed5c099f$exports.definition;
$8216ee54ed5c099f$exports.prefix = $8216ee54ed5c099f$var$prefix;
$8216ee54ed5c099f$exports.iconName = $8216ee54ed5c099f$var$iconName;
$8216ee54ed5c099f$exports.width = $8216ee54ed5c099f$var$width;
$8216ee54ed5c099f$exports.height = $8216ee54ed5c099f$var$height;
$8216ee54ed5c099f$exports.ligatures = $8216ee54ed5c099f$var$aliases;
$8216ee54ed5c099f$exports.unicode = $8216ee54ed5c099f$var$unicode;
$8216ee54ed5c099f$exports.svgPathData = $8216ee54ed5c099f$var$svgPathData;
$8216ee54ed5c099f$exports.aliases = $8216ee54ed5c099f$var$aliases;


var $a5565bc5d7aa9135$exports = {};
"use strict";
Object.defineProperty($a5565bc5d7aa9135$exports, "__esModule", {
    value: true
});
var $79ac955092d93bd6$exports = {};
"use strict";
Object.defineProperty($79ac955092d93bd6$exports, "__esModule", {
    value: true
});
var $79ac955092d93bd6$var$prefix = "fab";
var $79ac955092d93bd6$var$iconName = "square-facebook";
var $79ac955092d93bd6$var$width = 448;
var $79ac955092d93bd6$var$height = 512;
var $79ac955092d93bd6$var$aliases = [
    "facebook-square"
];
var $79ac955092d93bd6$var$unicode = "f082";
var $79ac955092d93bd6$var$svgPathData = "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z";
$79ac955092d93bd6$exports.definition = {
    prefix: $79ac955092d93bd6$var$prefix,
    iconName: $79ac955092d93bd6$var$iconName,
    icon: [
        $79ac955092d93bd6$var$width,
        $79ac955092d93bd6$var$height,
        $79ac955092d93bd6$var$aliases,
        $79ac955092d93bd6$var$unicode,
        $79ac955092d93bd6$var$svgPathData
    ]
};
$79ac955092d93bd6$exports.faSquareFacebook = $79ac955092d93bd6$exports.definition;
$79ac955092d93bd6$exports.prefix = $79ac955092d93bd6$var$prefix;
$79ac955092d93bd6$exports.iconName = $79ac955092d93bd6$var$iconName;
$79ac955092d93bd6$exports.width = $79ac955092d93bd6$var$width;
$79ac955092d93bd6$exports.height = $79ac955092d93bd6$var$height;
$79ac955092d93bd6$exports.ligatures = $79ac955092d93bd6$var$aliases;
$79ac955092d93bd6$exports.unicode = $79ac955092d93bd6$var$unicode;
$79ac955092d93bd6$exports.svgPathData = $79ac955092d93bd6$var$svgPathData;
$79ac955092d93bd6$exports.aliases = $79ac955092d93bd6$var$aliases;


$a5565bc5d7aa9135$exports.definition = {
    prefix: $79ac955092d93bd6$exports.prefix,
    iconName: $79ac955092d93bd6$exports.iconName,
    icon: [
        $79ac955092d93bd6$exports.width,
        $79ac955092d93bd6$exports.height,
        $79ac955092d93bd6$exports.aliases,
        $79ac955092d93bd6$exports.unicode,
        $79ac955092d93bd6$exports.svgPathData
    ]
};
$a5565bc5d7aa9135$exports.faFacebookSquare = $a5565bc5d7aa9135$exports.definition;
$a5565bc5d7aa9135$exports.prefix = $79ac955092d93bd6$exports.prefix;
$a5565bc5d7aa9135$exports.iconName = $79ac955092d93bd6$exports.iconName;
$a5565bc5d7aa9135$exports.width = $79ac955092d93bd6$exports.width;
$a5565bc5d7aa9135$exports.height = $79ac955092d93bd6$exports.height;
$a5565bc5d7aa9135$exports.ligatures = $79ac955092d93bd6$exports.aliases;
$a5565bc5d7aa9135$exports.unicode = $79ac955092d93bd6$exports.unicode;
$a5565bc5d7aa9135$exports.svgPathData = $79ac955092d93bd6$exports.svgPathData;
$a5565bc5d7aa9135$exports.aliases = $79ac955092d93bd6$exports.aliases;


var $acd52ab24d9744ba$exports = {};
"use strict";
Object.defineProperty($acd52ab24d9744ba$exports, "__esModule", {
    value: true
});
var $acd52ab24d9744ba$var$prefix = "fab";
var $acd52ab24d9744ba$var$iconName = "get-pocket";
var $acd52ab24d9744ba$var$width = 448;
var $acd52ab24d9744ba$var$height = 512;
var $acd52ab24d9744ba$var$aliases = [];
var $acd52ab24d9744ba$var$unicode = "f265";
var $acd52ab24d9744ba$var$svgPathData = "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z";
$acd52ab24d9744ba$exports.definition = {
    prefix: $acd52ab24d9744ba$var$prefix,
    iconName: $acd52ab24d9744ba$var$iconName,
    icon: [
        $acd52ab24d9744ba$var$width,
        $acd52ab24d9744ba$var$height,
        $acd52ab24d9744ba$var$aliases,
        $acd52ab24d9744ba$var$unicode,
        $acd52ab24d9744ba$var$svgPathData
    ]
};
$acd52ab24d9744ba$exports.faGetPocket = $acd52ab24d9744ba$exports.definition;
$acd52ab24d9744ba$exports.prefix = $acd52ab24d9744ba$var$prefix;
$acd52ab24d9744ba$exports.iconName = $acd52ab24d9744ba$var$iconName;
$acd52ab24d9744ba$exports.width = $acd52ab24d9744ba$var$width;
$acd52ab24d9744ba$exports.height = $acd52ab24d9744ba$var$height;
$acd52ab24d9744ba$exports.ligatures = $acd52ab24d9744ba$var$aliases;
$acd52ab24d9744ba$exports.unicode = $acd52ab24d9744ba$var$unicode;
$acd52ab24d9744ba$exports.svgPathData = $acd52ab24d9744ba$var$svgPathData;
$acd52ab24d9744ba$exports.aliases = $acd52ab24d9744ba$var$aliases;


var $11826e5bf54ad532$exports = {};
"use strict";
Object.defineProperty($11826e5bf54ad532$exports, "__esModule", {
    value: true
});
var $11826e5bf54ad532$var$prefix = "fab";
var $11826e5bf54ad532$var$iconName = "twitter";
var $11826e5bf54ad532$var$width = 512;
var $11826e5bf54ad532$var$height = 512;
var $11826e5bf54ad532$var$aliases = [];
var $11826e5bf54ad532$var$unicode = "f099";
var $11826e5bf54ad532$var$svgPathData = "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z";
$11826e5bf54ad532$exports.definition = {
    prefix: $11826e5bf54ad532$var$prefix,
    iconName: $11826e5bf54ad532$var$iconName,
    icon: [
        $11826e5bf54ad532$var$width,
        $11826e5bf54ad532$var$height,
        $11826e5bf54ad532$var$aliases,
        $11826e5bf54ad532$var$unicode,
        $11826e5bf54ad532$var$svgPathData
    ]
};
$11826e5bf54ad532$exports.faTwitter = $11826e5bf54ad532$exports.definition;
$11826e5bf54ad532$exports.prefix = $11826e5bf54ad532$var$prefix;
$11826e5bf54ad532$exports.iconName = $11826e5bf54ad532$var$iconName;
$11826e5bf54ad532$exports.width = $11826e5bf54ad532$var$width;
$11826e5bf54ad532$exports.height = $11826e5bf54ad532$var$height;
$11826e5bf54ad532$exports.ligatures = $11826e5bf54ad532$var$aliases;
$11826e5bf54ad532$exports.unicode = $11826e5bf54ad532$var$unicode;
$11826e5bf54ad532$exports.svgPathData = $11826e5bf54ad532$var$svgPathData;
$11826e5bf54ad532$exports.aliases = $11826e5bf54ad532$var$aliases;


var $8ebe08a4e3d0a860$exports = {};
"use strict";
Object.defineProperty($8ebe08a4e3d0a860$exports, "__esModule", {
    value: true
});
var $8ebe08a4e3d0a860$var$prefix = "fab";
var $8ebe08a4e3d0a860$var$iconName = "wordpress-simple";
var $8ebe08a4e3d0a860$var$width = 512;
var $8ebe08a4e3d0a860$var$height = 512;
var $8ebe08a4e3d0a860$var$aliases = [];
var $8ebe08a4e3d0a860$var$unicode = "f411";
var $8ebe08a4e3d0a860$var$svgPathData = "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z";
$8ebe08a4e3d0a860$exports.definition = {
    prefix: $8ebe08a4e3d0a860$var$prefix,
    iconName: $8ebe08a4e3d0a860$var$iconName,
    icon: [
        $8ebe08a4e3d0a860$var$width,
        $8ebe08a4e3d0a860$var$height,
        $8ebe08a4e3d0a860$var$aliases,
        $8ebe08a4e3d0a860$var$unicode,
        $8ebe08a4e3d0a860$var$svgPathData
    ]
};
$8ebe08a4e3d0a860$exports.faWordpressSimple = $8ebe08a4e3d0a860$exports.definition;
$8ebe08a4e3d0a860$exports.prefix = $8ebe08a4e3d0a860$var$prefix;
$8ebe08a4e3d0a860$exports.iconName = $8ebe08a4e3d0a860$var$iconName;
$8ebe08a4e3d0a860$exports.width = $8ebe08a4e3d0a860$var$width;
$8ebe08a4e3d0a860$exports.height = $8ebe08a4e3d0a860$var$height;
$8ebe08a4e3d0a860$exports.ligatures = $8ebe08a4e3d0a860$var$aliases;
$8ebe08a4e3d0a860$exports.unicode = $8ebe08a4e3d0a860$var$unicode;
$8ebe08a4e3d0a860$exports.svgPathData = $8ebe08a4e3d0a860$var$svgPathData;
$8ebe08a4e3d0a860$exports.aliases = $8ebe08a4e3d0a860$var$aliases;


var $b92068b2b2ac161b$exports = {};
"use strict";
Object.defineProperty($b92068b2b2ac161b$exports, "__esModule", {
    value: true
});
var $b92068b2b2ac161b$var$prefix = "fab";
var $b92068b2b2ac161b$var$iconName = "mastodon";
var $b92068b2b2ac161b$var$width = 448;
var $b92068b2b2ac161b$var$height = 512;
var $b92068b2b2ac161b$var$aliases = [];
var $b92068b2b2ac161b$var$unicode = "f4f6";
var $b92068b2b2ac161b$var$svgPathData = "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z";
$b92068b2b2ac161b$exports.definition = {
    prefix: $b92068b2b2ac161b$var$prefix,
    iconName: $b92068b2b2ac161b$var$iconName,
    icon: [
        $b92068b2b2ac161b$var$width,
        $b92068b2b2ac161b$var$height,
        $b92068b2b2ac161b$var$aliases,
        $b92068b2b2ac161b$var$unicode,
        $b92068b2b2ac161b$var$svgPathData
    ]
};
$b92068b2b2ac161b$exports.faMastodon = $b92068b2b2ac161b$exports.definition;
$b92068b2b2ac161b$exports.prefix = $b92068b2b2ac161b$var$prefix;
$b92068b2b2ac161b$exports.iconName = $b92068b2b2ac161b$var$iconName;
$b92068b2b2ac161b$exports.width = $b92068b2b2ac161b$var$width;
$b92068b2b2ac161b$exports.height = $b92068b2b2ac161b$var$height;
$b92068b2b2ac161b$exports.ligatures = $b92068b2b2ac161b$var$aliases;
$b92068b2b2ac161b$exports.unicode = $b92068b2b2ac161b$var$unicode;
$b92068b2b2ac161b$exports.svgPathData = $b92068b2b2ac161b$var$svgPathData;
$b92068b2b2ac161b$exports.aliases = $b92068b2b2ac161b$var$aliases;


var $60c3775e24ebf896$exports = {};
"use strict";
Object.defineProperty($60c3775e24ebf896$exports, "__esModule", {
    value: true
});
var $7e27b77be2aec1a1$exports = {};
"use strict";
Object.defineProperty($7e27b77be2aec1a1$exports, "__esModule", {
    value: true
});
var $7e27b77be2aec1a1$var$prefix = "far";
var $7e27b77be2aec1a1$var$iconName = "circle-check";
var $7e27b77be2aec1a1$var$width = 512;
var $7e27b77be2aec1a1$var$height = 512;
var $7e27b77be2aec1a1$var$aliases = [
    61533,
    "check-circle"
];
var $7e27b77be2aec1a1$var$unicode = "f058";
var $7e27b77be2aec1a1$var$svgPathData = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z";
$7e27b77be2aec1a1$exports.definition = {
    prefix: $7e27b77be2aec1a1$var$prefix,
    iconName: $7e27b77be2aec1a1$var$iconName,
    icon: [
        $7e27b77be2aec1a1$var$width,
        $7e27b77be2aec1a1$var$height,
        $7e27b77be2aec1a1$var$aliases,
        $7e27b77be2aec1a1$var$unicode,
        $7e27b77be2aec1a1$var$svgPathData
    ]
};
$7e27b77be2aec1a1$exports.faCircleCheck = $7e27b77be2aec1a1$exports.definition;
$7e27b77be2aec1a1$exports.prefix = $7e27b77be2aec1a1$var$prefix;
$7e27b77be2aec1a1$exports.iconName = $7e27b77be2aec1a1$var$iconName;
$7e27b77be2aec1a1$exports.width = $7e27b77be2aec1a1$var$width;
$7e27b77be2aec1a1$exports.height = $7e27b77be2aec1a1$var$height;
$7e27b77be2aec1a1$exports.ligatures = $7e27b77be2aec1a1$var$aliases;
$7e27b77be2aec1a1$exports.unicode = $7e27b77be2aec1a1$var$unicode;
$7e27b77be2aec1a1$exports.svgPathData = $7e27b77be2aec1a1$var$svgPathData;
$7e27b77be2aec1a1$exports.aliases = $7e27b77be2aec1a1$var$aliases;


$60c3775e24ebf896$exports.definition = {
    prefix: $7e27b77be2aec1a1$exports.prefix,
    iconName: $7e27b77be2aec1a1$exports.iconName,
    icon: [
        $7e27b77be2aec1a1$exports.width,
        $7e27b77be2aec1a1$exports.height,
        $7e27b77be2aec1a1$exports.aliases,
        $7e27b77be2aec1a1$exports.unicode,
        $7e27b77be2aec1a1$exports.svgPathData
    ]
};
$60c3775e24ebf896$exports.faCheckCircle = $60c3775e24ebf896$exports.definition;
$60c3775e24ebf896$exports.prefix = $7e27b77be2aec1a1$exports.prefix;
$60c3775e24ebf896$exports.iconName = $7e27b77be2aec1a1$exports.iconName;
$60c3775e24ebf896$exports.width = $7e27b77be2aec1a1$exports.width;
$60c3775e24ebf896$exports.height = $7e27b77be2aec1a1$exports.height;
$60c3775e24ebf896$exports.ligatures = $7e27b77be2aec1a1$exports.aliases;
$60c3775e24ebf896$exports.unicode = $7e27b77be2aec1a1$exports.unicode;
$60c3775e24ebf896$exports.svgPathData = $7e27b77be2aec1a1$exports.svgPathData;
$60c3775e24ebf896$exports.aliases = $7e27b77be2aec1a1$exports.aliases;


var $de3818063bbfedbe$exports = {};
"use strict";
Object.defineProperty($de3818063bbfedbe$exports, "__esModule", {
    value: true
});
var $de3818063bbfedbe$var$prefix = "far";
var $de3818063bbfedbe$var$iconName = "star";
var $de3818063bbfedbe$var$width = 576;
var $de3818063bbfedbe$var$height = 512;
var $de3818063bbfedbe$var$aliases = [
    11088,
    61446
];
var $de3818063bbfedbe$var$unicode = "f005";
var $de3818063bbfedbe$var$svgPathData = "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z";
$de3818063bbfedbe$exports.definition = {
    prefix: $de3818063bbfedbe$var$prefix,
    iconName: $de3818063bbfedbe$var$iconName,
    icon: [
        $de3818063bbfedbe$var$width,
        $de3818063bbfedbe$var$height,
        $de3818063bbfedbe$var$aliases,
        $de3818063bbfedbe$var$unicode,
        $de3818063bbfedbe$var$svgPathData
    ]
};
$de3818063bbfedbe$exports.faStar = $de3818063bbfedbe$exports.definition;
$de3818063bbfedbe$exports.prefix = $de3818063bbfedbe$var$prefix;
$de3818063bbfedbe$exports.iconName = $de3818063bbfedbe$var$iconName;
$de3818063bbfedbe$exports.width = $de3818063bbfedbe$var$width;
$de3818063bbfedbe$exports.height = $de3818063bbfedbe$var$height;
$de3818063bbfedbe$exports.ligatures = $de3818063bbfedbe$var$aliases;
$de3818063bbfedbe$exports.unicode = $de3818063bbfedbe$var$unicode;
$de3818063bbfedbe$exports.svgPathData = $de3818063bbfedbe$var$svgPathData;
$de3818063bbfedbe$exports.aliases = $de3818063bbfedbe$var$aliases;


var $ea95ad8a568dd277$exports = {};
"use strict";
Object.defineProperty($ea95ad8a568dd277$exports, "__esModule", {
    value: true
});
var $404c2ac019d45a68$exports = {};
"use strict";
Object.defineProperty($404c2ac019d45a68$exports, "__esModule", {
    value: true
});
var $404c2ac019d45a68$var$prefix = "far";
var $404c2ac019d45a68$var$iconName = "circle-xmark";
var $404c2ac019d45a68$var$width = 512;
var $404c2ac019d45a68$var$height = 512;
var $404c2ac019d45a68$var$aliases = [
    61532,
    "times-circle",
    "xmark-circle"
];
var $404c2ac019d45a68$var$unicode = "f057";
var $404c2ac019d45a68$var$svgPathData = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
$404c2ac019d45a68$exports.definition = {
    prefix: $404c2ac019d45a68$var$prefix,
    iconName: $404c2ac019d45a68$var$iconName,
    icon: [
        $404c2ac019d45a68$var$width,
        $404c2ac019d45a68$var$height,
        $404c2ac019d45a68$var$aliases,
        $404c2ac019d45a68$var$unicode,
        $404c2ac019d45a68$var$svgPathData
    ]
};
$404c2ac019d45a68$exports.faCircleXmark = $404c2ac019d45a68$exports.definition;
$404c2ac019d45a68$exports.prefix = $404c2ac019d45a68$var$prefix;
$404c2ac019d45a68$exports.iconName = $404c2ac019d45a68$var$iconName;
$404c2ac019d45a68$exports.width = $404c2ac019d45a68$var$width;
$404c2ac019d45a68$exports.height = $404c2ac019d45a68$var$height;
$404c2ac019d45a68$exports.ligatures = $404c2ac019d45a68$var$aliases;
$404c2ac019d45a68$exports.unicode = $404c2ac019d45a68$var$unicode;
$404c2ac019d45a68$exports.svgPathData = $404c2ac019d45a68$var$svgPathData;
$404c2ac019d45a68$exports.aliases = $404c2ac019d45a68$var$aliases;


$ea95ad8a568dd277$exports.definition = {
    prefix: $404c2ac019d45a68$exports.prefix,
    iconName: $404c2ac019d45a68$exports.iconName,
    icon: [
        $404c2ac019d45a68$exports.width,
        $404c2ac019d45a68$exports.height,
        $404c2ac019d45a68$exports.aliases,
        $404c2ac019d45a68$exports.unicode,
        $404c2ac019d45a68$exports.svgPathData
    ]
};
$ea95ad8a568dd277$exports.faTimesCircle = $ea95ad8a568dd277$exports.definition;
$ea95ad8a568dd277$exports.prefix = $404c2ac019d45a68$exports.prefix;
$ea95ad8a568dd277$exports.iconName = $404c2ac019d45a68$exports.iconName;
$ea95ad8a568dd277$exports.width = $404c2ac019d45a68$exports.width;
$ea95ad8a568dd277$exports.height = $404c2ac019d45a68$exports.height;
$ea95ad8a568dd277$exports.ligatures = $404c2ac019d45a68$exports.aliases;
$ea95ad8a568dd277$exports.unicode = $404c2ac019d45a68$exports.unicode;
$ea95ad8a568dd277$exports.svgPathData = $404c2ac019d45a68$exports.svgPathData;
$ea95ad8a568dd277$exports.aliases = $404c2ac019d45a68$exports.aliases;


var $7417e626c64fb3c5$exports = {};
"use strict";
Object.defineProperty($7417e626c64fb3c5$exports, "__esModule", {
    value: true
});
var $76a0fa091acb188e$exports = {};
"use strict";
Object.defineProperty($76a0fa091acb188e$exports, "__esModule", {
    value: true
});
var $76a0fa091acb188e$var$prefix = "fas";
var $76a0fa091acb188e$var$iconName = "circle-down";
var $76a0fa091acb188e$var$width = 512;
var $76a0fa091acb188e$var$height = 512;
var $76a0fa091acb188e$var$aliases = [
    61466,
    "arrow-alt-circle-down"
];
var $76a0fa091acb188e$var$unicode = "f358";
var $76a0fa091acb188e$var$svgPathData = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z";
$76a0fa091acb188e$exports.definition = {
    prefix: $76a0fa091acb188e$var$prefix,
    iconName: $76a0fa091acb188e$var$iconName,
    icon: [
        $76a0fa091acb188e$var$width,
        $76a0fa091acb188e$var$height,
        $76a0fa091acb188e$var$aliases,
        $76a0fa091acb188e$var$unicode,
        $76a0fa091acb188e$var$svgPathData
    ]
};
$76a0fa091acb188e$exports.faCircleDown = $76a0fa091acb188e$exports.definition;
$76a0fa091acb188e$exports.prefix = $76a0fa091acb188e$var$prefix;
$76a0fa091acb188e$exports.iconName = $76a0fa091acb188e$var$iconName;
$76a0fa091acb188e$exports.width = $76a0fa091acb188e$var$width;
$76a0fa091acb188e$exports.height = $76a0fa091acb188e$var$height;
$76a0fa091acb188e$exports.ligatures = $76a0fa091acb188e$var$aliases;
$76a0fa091acb188e$exports.unicode = $76a0fa091acb188e$var$unicode;
$76a0fa091acb188e$exports.svgPathData = $76a0fa091acb188e$var$svgPathData;
$76a0fa091acb188e$exports.aliases = $76a0fa091acb188e$var$aliases;


$7417e626c64fb3c5$exports.definition = {
    prefix: $76a0fa091acb188e$exports.prefix,
    iconName: $76a0fa091acb188e$exports.iconName,
    icon: [
        $76a0fa091acb188e$exports.width,
        $76a0fa091acb188e$exports.height,
        $76a0fa091acb188e$exports.aliases,
        $76a0fa091acb188e$exports.unicode,
        $76a0fa091acb188e$exports.svgPathData
    ]
};
$7417e626c64fb3c5$exports.faArrowAltCircleDown = $7417e626c64fb3c5$exports.definition;
$7417e626c64fb3c5$exports.prefix = $76a0fa091acb188e$exports.prefix;
$7417e626c64fb3c5$exports.iconName = $76a0fa091acb188e$exports.iconName;
$7417e626c64fb3c5$exports.width = $76a0fa091acb188e$exports.width;
$7417e626c64fb3c5$exports.height = $76a0fa091acb188e$exports.height;
$7417e626c64fb3c5$exports.ligatures = $76a0fa091acb188e$exports.aliases;
$7417e626c64fb3c5$exports.unicode = $76a0fa091acb188e$exports.unicode;
$7417e626c64fb3c5$exports.svgPathData = $76a0fa091acb188e$exports.svgPathData;
$7417e626c64fb3c5$exports.aliases = $76a0fa091acb188e$exports.aliases;


var $67e9658d0f6c3ae3$exports = {};
"use strict";
Object.defineProperty($67e9658d0f6c3ae3$exports, "__esModule", {
    value: true
});
var $67e9658d0f6c3ae3$var$prefix = "fas";
var $67e9658d0f6c3ae3$var$iconName = "arrow-right";
var $67e9658d0f6c3ae3$var$width = 448;
var $67e9658d0f6c3ae3$var$height = 512;
var $67e9658d0f6c3ae3$var$aliases = [
    8594
];
var $67e9658d0f6c3ae3$var$unicode = "f061";
var $67e9658d0f6c3ae3$var$svgPathData = "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z";
$67e9658d0f6c3ae3$exports.definition = {
    prefix: $67e9658d0f6c3ae3$var$prefix,
    iconName: $67e9658d0f6c3ae3$var$iconName,
    icon: [
        $67e9658d0f6c3ae3$var$width,
        $67e9658d0f6c3ae3$var$height,
        $67e9658d0f6c3ae3$var$aliases,
        $67e9658d0f6c3ae3$var$unicode,
        $67e9658d0f6c3ae3$var$svgPathData
    ]
};
$67e9658d0f6c3ae3$exports.faArrowRight = $67e9658d0f6c3ae3$exports.definition;
$67e9658d0f6c3ae3$exports.prefix = $67e9658d0f6c3ae3$var$prefix;
$67e9658d0f6c3ae3$exports.iconName = $67e9658d0f6c3ae3$var$iconName;
$67e9658d0f6c3ae3$exports.width = $67e9658d0f6c3ae3$var$width;
$67e9658d0f6c3ae3$exports.height = $67e9658d0f6c3ae3$var$height;
$67e9658d0f6c3ae3$exports.ligatures = $67e9658d0f6c3ae3$var$aliases;
$67e9658d0f6c3ae3$exports.unicode = $67e9658d0f6c3ae3$var$unicode;
$67e9658d0f6c3ae3$exports.svgPathData = $67e9658d0f6c3ae3$var$svgPathData;
$67e9658d0f6c3ae3$exports.aliases = $67e9658d0f6c3ae3$var$aliases;


var $0c96aa001209cff1$exports = {};
"use strict";
Object.defineProperty($0c96aa001209cff1$exports, "__esModule", {
    value: true
});
var $0c96aa001209cff1$var$prefix = "fas";
var $0c96aa001209cff1$var$iconName = "check";
var $0c96aa001209cff1$var$width = 448;
var $0c96aa001209cff1$var$height = 512;
var $0c96aa001209cff1$var$aliases = [
    10003,
    10004
];
var $0c96aa001209cff1$var$unicode = "f00c";
var $0c96aa001209cff1$var$svgPathData = "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z";
$0c96aa001209cff1$exports.definition = {
    prefix: $0c96aa001209cff1$var$prefix,
    iconName: $0c96aa001209cff1$var$iconName,
    icon: [
        $0c96aa001209cff1$var$width,
        $0c96aa001209cff1$var$height,
        $0c96aa001209cff1$var$aliases,
        $0c96aa001209cff1$var$unicode,
        $0c96aa001209cff1$var$svgPathData
    ]
};
$0c96aa001209cff1$exports.faCheck = $0c96aa001209cff1$exports.definition;
$0c96aa001209cff1$exports.prefix = $0c96aa001209cff1$var$prefix;
$0c96aa001209cff1$exports.iconName = $0c96aa001209cff1$var$iconName;
$0c96aa001209cff1$exports.width = $0c96aa001209cff1$var$width;
$0c96aa001209cff1$exports.height = $0c96aa001209cff1$var$height;
$0c96aa001209cff1$exports.ligatures = $0c96aa001209cff1$var$aliases;
$0c96aa001209cff1$exports.unicode = $0c96aa001209cff1$var$unicode;
$0c96aa001209cff1$exports.svgPathData = $0c96aa001209cff1$var$svgPathData;
$0c96aa001209cff1$exports.aliases = $0c96aa001209cff1$var$aliases;


var $7214b407105f2291$exports = {};
"use strict";
Object.defineProperty($7214b407105f2291$exports, "__esModule", {
    value: true
});
var $02c0b80d7cc7c21e$exports = {};
"use strict";
Object.defineProperty($02c0b80d7cc7c21e$exports, "__esModule", {
    value: true
});
var $02c0b80d7cc7c21e$var$prefix = "fas";
var $02c0b80d7cc7c21e$var$iconName = "circle-check";
var $02c0b80d7cc7c21e$var$width = 512;
var $02c0b80d7cc7c21e$var$height = 512;
var $02c0b80d7cc7c21e$var$aliases = [
    61533,
    "check-circle"
];
var $02c0b80d7cc7c21e$var$unicode = "f058";
var $02c0b80d7cc7c21e$var$svgPathData = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
$02c0b80d7cc7c21e$exports.definition = {
    prefix: $02c0b80d7cc7c21e$var$prefix,
    iconName: $02c0b80d7cc7c21e$var$iconName,
    icon: [
        $02c0b80d7cc7c21e$var$width,
        $02c0b80d7cc7c21e$var$height,
        $02c0b80d7cc7c21e$var$aliases,
        $02c0b80d7cc7c21e$var$unicode,
        $02c0b80d7cc7c21e$var$svgPathData
    ]
};
$02c0b80d7cc7c21e$exports.faCircleCheck = $02c0b80d7cc7c21e$exports.definition;
$02c0b80d7cc7c21e$exports.prefix = $02c0b80d7cc7c21e$var$prefix;
$02c0b80d7cc7c21e$exports.iconName = $02c0b80d7cc7c21e$var$iconName;
$02c0b80d7cc7c21e$exports.width = $02c0b80d7cc7c21e$var$width;
$02c0b80d7cc7c21e$exports.height = $02c0b80d7cc7c21e$var$height;
$02c0b80d7cc7c21e$exports.ligatures = $02c0b80d7cc7c21e$var$aliases;
$02c0b80d7cc7c21e$exports.unicode = $02c0b80d7cc7c21e$var$unicode;
$02c0b80d7cc7c21e$exports.svgPathData = $02c0b80d7cc7c21e$var$svgPathData;
$02c0b80d7cc7c21e$exports.aliases = $02c0b80d7cc7c21e$var$aliases;


$7214b407105f2291$exports.definition = {
    prefix: $02c0b80d7cc7c21e$exports.prefix,
    iconName: $02c0b80d7cc7c21e$exports.iconName,
    icon: [
        $02c0b80d7cc7c21e$exports.width,
        $02c0b80d7cc7c21e$exports.height,
        $02c0b80d7cc7c21e$exports.aliases,
        $02c0b80d7cc7c21e$exports.unicode,
        $02c0b80d7cc7c21e$exports.svgPathData
    ]
};
$7214b407105f2291$exports.faCheckCircle = $7214b407105f2291$exports.definition;
$7214b407105f2291$exports.prefix = $02c0b80d7cc7c21e$exports.prefix;
$7214b407105f2291$exports.iconName = $02c0b80d7cc7c21e$exports.iconName;
$7214b407105f2291$exports.width = $02c0b80d7cc7c21e$exports.width;
$7214b407105f2291$exports.height = $02c0b80d7cc7c21e$exports.height;
$7214b407105f2291$exports.ligatures = $02c0b80d7cc7c21e$exports.aliases;
$7214b407105f2291$exports.unicode = $02c0b80d7cc7c21e$exports.unicode;
$7214b407105f2291$exports.svgPathData = $02c0b80d7cc7c21e$exports.svgPathData;
$7214b407105f2291$exports.aliases = $02c0b80d7cc7c21e$exports.aliases;


var $843ec70749747e2a$exports = {};
"use strict";
Object.defineProperty($843ec70749747e2a$exports, "__esModule", {
    value: true
});
var $843ec70749747e2a$var$prefix = "fas";
var $843ec70749747e2a$var$iconName = "caret-down";
var $843ec70749747e2a$var$width = 320;
var $843ec70749747e2a$var$height = 512;
var $843ec70749747e2a$var$aliases = [];
var $843ec70749747e2a$var$unicode = "f0d7";
var $843ec70749747e2a$var$svgPathData = "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z";
$843ec70749747e2a$exports.definition = {
    prefix: $843ec70749747e2a$var$prefix,
    iconName: $843ec70749747e2a$var$iconName,
    icon: [
        $843ec70749747e2a$var$width,
        $843ec70749747e2a$var$height,
        $843ec70749747e2a$var$aliases,
        $843ec70749747e2a$var$unicode,
        $843ec70749747e2a$var$svgPathData
    ]
};
$843ec70749747e2a$exports.faCaretDown = $843ec70749747e2a$exports.definition;
$843ec70749747e2a$exports.prefix = $843ec70749747e2a$var$prefix;
$843ec70749747e2a$exports.iconName = $843ec70749747e2a$var$iconName;
$843ec70749747e2a$exports.width = $843ec70749747e2a$var$width;
$843ec70749747e2a$exports.height = $843ec70749747e2a$var$height;
$843ec70749747e2a$exports.ligatures = $843ec70749747e2a$var$aliases;
$843ec70749747e2a$exports.unicode = $843ec70749747e2a$var$unicode;
$843ec70749747e2a$exports.svgPathData = $843ec70749747e2a$var$svgPathData;
$843ec70749747e2a$exports.aliases = $843ec70749747e2a$var$aliases;


var $809575f3b9653d01$exports = {};
"use strict";
Object.defineProperty($809575f3b9653d01$exports, "__esModule", {
    value: true
});
var $809575f3b9653d01$var$prefix = "fas";
var $809575f3b9653d01$var$iconName = "caret-right";
var $809575f3b9653d01$var$width = 256;
var $809575f3b9653d01$var$height = 512;
var $809575f3b9653d01$var$aliases = [];
var $809575f3b9653d01$var$unicode = "f0da";
var $809575f3b9653d01$var$svgPathData = "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z";
$809575f3b9653d01$exports.definition = {
    prefix: $809575f3b9653d01$var$prefix,
    iconName: $809575f3b9653d01$var$iconName,
    icon: [
        $809575f3b9653d01$var$width,
        $809575f3b9653d01$var$height,
        $809575f3b9653d01$var$aliases,
        $809575f3b9653d01$var$unicode,
        $809575f3b9653d01$var$svgPathData
    ]
};
$809575f3b9653d01$exports.faCaretRight = $809575f3b9653d01$exports.definition;
$809575f3b9653d01$exports.prefix = $809575f3b9653d01$var$prefix;
$809575f3b9653d01$exports.iconName = $809575f3b9653d01$var$iconName;
$809575f3b9653d01$exports.width = $809575f3b9653d01$var$width;
$809575f3b9653d01$exports.height = $809575f3b9653d01$var$height;
$809575f3b9653d01$exports.ligatures = $809575f3b9653d01$var$aliases;
$809575f3b9653d01$exports.unicode = $809575f3b9653d01$var$unicode;
$809575f3b9653d01$exports.svgPathData = $809575f3b9653d01$var$svgPathData;
$809575f3b9653d01$exports.aliases = $809575f3b9653d01$var$aliases;


var $78546ca20d789f8c$exports = {};
"use strict";
Object.defineProperty($78546ca20d789f8c$exports, "__esModule", {
    value: true
});
var $b125f469bd48e450$exports = {};
"use strict";
Object.defineProperty($b125f469bd48e450$exports, "__esModule", {
    value: true
});
var $b125f469bd48e450$var$prefix = "fas";
var $b125f469bd48e450$var$iconName = "cloud-arrow-up";
var $b125f469bd48e450$var$width = 640;
var $b125f469bd48e450$var$height = 512;
var $b125f469bd48e450$var$aliases = [
    62338,
    "cloud-upload",
    "cloud-upload-alt"
];
var $b125f469bd48e450$var$unicode = "f0ee";
var $b125f469bd48e450$var$svgPathData = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z";
$b125f469bd48e450$exports.definition = {
    prefix: $b125f469bd48e450$var$prefix,
    iconName: $b125f469bd48e450$var$iconName,
    icon: [
        $b125f469bd48e450$var$width,
        $b125f469bd48e450$var$height,
        $b125f469bd48e450$var$aliases,
        $b125f469bd48e450$var$unicode,
        $b125f469bd48e450$var$svgPathData
    ]
};
$b125f469bd48e450$exports.faCloudArrowUp = $b125f469bd48e450$exports.definition;
$b125f469bd48e450$exports.prefix = $b125f469bd48e450$var$prefix;
$b125f469bd48e450$exports.iconName = $b125f469bd48e450$var$iconName;
$b125f469bd48e450$exports.width = $b125f469bd48e450$var$width;
$b125f469bd48e450$exports.height = $b125f469bd48e450$var$height;
$b125f469bd48e450$exports.ligatures = $b125f469bd48e450$var$aliases;
$b125f469bd48e450$exports.unicode = $b125f469bd48e450$var$unicode;
$b125f469bd48e450$exports.svgPathData = $b125f469bd48e450$var$svgPathData;
$b125f469bd48e450$exports.aliases = $b125f469bd48e450$var$aliases;


$78546ca20d789f8c$exports.definition = {
    prefix: $b125f469bd48e450$exports.prefix,
    iconName: $b125f469bd48e450$exports.iconName,
    icon: [
        $b125f469bd48e450$exports.width,
        $b125f469bd48e450$exports.height,
        $b125f469bd48e450$exports.aliases,
        $b125f469bd48e450$exports.unicode,
        $b125f469bd48e450$exports.svgPathData
    ]
};
$78546ca20d789f8c$exports.faCloudUploadAlt = $78546ca20d789f8c$exports.definition;
$78546ca20d789f8c$exports.prefix = $b125f469bd48e450$exports.prefix;
$78546ca20d789f8c$exports.iconName = $b125f469bd48e450$exports.iconName;
$78546ca20d789f8c$exports.width = $b125f469bd48e450$exports.width;
$78546ca20d789f8c$exports.height = $b125f469bd48e450$exports.height;
$78546ca20d789f8c$exports.ligatures = $b125f469bd48e450$exports.aliases;
$78546ca20d789f8c$exports.unicode = $b125f469bd48e450$exports.unicode;
$78546ca20d789f8c$exports.svgPathData = $b125f469bd48e450$exports.svgPathData;
$78546ca20d789f8c$exports.aliases = $b125f469bd48e450$exports.aliases;


var $18f640b80ac26745$exports = {};
"use strict";
Object.defineProperty($18f640b80ac26745$exports, "__esModule", {
    value: true
});
var $2a47a982851253e1$exports = {};
"use strict";
Object.defineProperty($2a47a982851253e1$exports, "__esModule", {
    value: true
});
var $2a47a982851253e1$var$prefix = "fas";
var $2a47a982851253e1$var$iconName = "gear";
var $2a47a982851253e1$var$width = 512;
var $2a47a982851253e1$var$height = 512;
var $2a47a982851253e1$var$aliases = [
    9881,
    "cog"
];
var $2a47a982851253e1$var$unicode = "f013";
var $2a47a982851253e1$var$svgPathData = "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z";
$2a47a982851253e1$exports.definition = {
    prefix: $2a47a982851253e1$var$prefix,
    iconName: $2a47a982851253e1$var$iconName,
    icon: [
        $2a47a982851253e1$var$width,
        $2a47a982851253e1$var$height,
        $2a47a982851253e1$var$aliases,
        $2a47a982851253e1$var$unicode,
        $2a47a982851253e1$var$svgPathData
    ]
};
$2a47a982851253e1$exports.faGear = $2a47a982851253e1$exports.definition;
$2a47a982851253e1$exports.prefix = $2a47a982851253e1$var$prefix;
$2a47a982851253e1$exports.iconName = $2a47a982851253e1$var$iconName;
$2a47a982851253e1$exports.width = $2a47a982851253e1$var$width;
$2a47a982851253e1$exports.height = $2a47a982851253e1$var$height;
$2a47a982851253e1$exports.ligatures = $2a47a982851253e1$var$aliases;
$2a47a982851253e1$exports.unicode = $2a47a982851253e1$var$unicode;
$2a47a982851253e1$exports.svgPathData = $2a47a982851253e1$var$svgPathData;
$2a47a982851253e1$exports.aliases = $2a47a982851253e1$var$aliases;


$18f640b80ac26745$exports.definition = {
    prefix: $2a47a982851253e1$exports.prefix,
    iconName: $2a47a982851253e1$exports.iconName,
    icon: [
        $2a47a982851253e1$exports.width,
        $2a47a982851253e1$exports.height,
        $2a47a982851253e1$exports.aliases,
        $2a47a982851253e1$exports.unicode,
        $2a47a982851253e1$exports.svgPathData
    ]
};
$18f640b80ac26745$exports.faCog = $18f640b80ac26745$exports.definition;
$18f640b80ac26745$exports.prefix = $2a47a982851253e1$exports.prefix;
$18f640b80ac26745$exports.iconName = $2a47a982851253e1$exports.iconName;
$18f640b80ac26745$exports.width = $2a47a982851253e1$exports.width;
$18f640b80ac26745$exports.height = $2a47a982851253e1$exports.height;
$18f640b80ac26745$exports.ligatures = $2a47a982851253e1$exports.aliases;
$18f640b80ac26745$exports.unicode = $2a47a982851253e1$exports.unicode;
$18f640b80ac26745$exports.svgPathData = $2a47a982851253e1$exports.svgPathData;
$18f640b80ac26745$exports.aliases = $2a47a982851253e1$exports.aliases;


var $7f79cc0a934ae117$exports = {};
"use strict";
Object.defineProperty($7f79cc0a934ae117$exports, "__esModule", {
    value: true
});
var $7f79cc0a934ae117$var$prefix = "fas";
var $7f79cc0a934ae117$var$iconName = "copy";
var $7f79cc0a934ae117$var$width = 448;
var $7f79cc0a934ae117$var$height = 512;
var $7f79cc0a934ae117$var$aliases = [];
var $7f79cc0a934ae117$var$unicode = "f0c5";
var $7f79cc0a934ae117$var$svgPathData = "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z";
$7f79cc0a934ae117$exports.definition = {
    prefix: $7f79cc0a934ae117$var$prefix,
    iconName: $7f79cc0a934ae117$var$iconName,
    icon: [
        $7f79cc0a934ae117$var$width,
        $7f79cc0a934ae117$var$height,
        $7f79cc0a934ae117$var$aliases,
        $7f79cc0a934ae117$var$unicode,
        $7f79cc0a934ae117$var$svgPathData
    ]
};
$7f79cc0a934ae117$exports.faCopy = $7f79cc0a934ae117$exports.definition;
$7f79cc0a934ae117$exports.prefix = $7f79cc0a934ae117$var$prefix;
$7f79cc0a934ae117$exports.iconName = $7f79cc0a934ae117$var$iconName;
$7f79cc0a934ae117$exports.width = $7f79cc0a934ae117$var$width;
$7f79cc0a934ae117$exports.height = $7f79cc0a934ae117$var$height;
$7f79cc0a934ae117$exports.ligatures = $7f79cc0a934ae117$var$aliases;
$7f79cc0a934ae117$exports.unicode = $7f79cc0a934ae117$var$unicode;
$7f79cc0a934ae117$exports.svgPathData = $7f79cc0a934ae117$var$svgPathData;
$7f79cc0a934ae117$exports.aliases = $7f79cc0a934ae117$var$aliases;


var $5aa79799bc179db8$exports = {};
"use strict";
Object.defineProperty($5aa79799bc179db8$exports, "__esModule", {
    value: true
});
var $5aa79799bc179db8$var$prefix = "fas";
var $5aa79799bc179db8$var$iconName = "envelope";
var $5aa79799bc179db8$var$width = 512;
var $5aa79799bc179db8$var$height = 512;
var $5aa79799bc179db8$var$aliases = [
    128386,
    9993,
    61443
];
var $5aa79799bc179db8$var$unicode = "f0e0";
var $5aa79799bc179db8$var$svgPathData = "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z";
$5aa79799bc179db8$exports.definition = {
    prefix: $5aa79799bc179db8$var$prefix,
    iconName: $5aa79799bc179db8$var$iconName,
    icon: [
        $5aa79799bc179db8$var$width,
        $5aa79799bc179db8$var$height,
        $5aa79799bc179db8$var$aliases,
        $5aa79799bc179db8$var$unicode,
        $5aa79799bc179db8$var$svgPathData
    ]
};
$5aa79799bc179db8$exports.faEnvelope = $5aa79799bc179db8$exports.definition;
$5aa79799bc179db8$exports.prefix = $5aa79799bc179db8$var$prefix;
$5aa79799bc179db8$exports.iconName = $5aa79799bc179db8$var$iconName;
$5aa79799bc179db8$exports.width = $5aa79799bc179db8$var$width;
$5aa79799bc179db8$exports.height = $5aa79799bc179db8$var$height;
$5aa79799bc179db8$exports.ligatures = $5aa79799bc179db8$var$aliases;
$5aa79799bc179db8$exports.unicode = $5aa79799bc179db8$var$unicode;
$5aa79799bc179db8$exports.svgPathData = $5aa79799bc179db8$var$svgPathData;
$5aa79799bc179db8$exports.aliases = $5aa79799bc179db8$var$aliases;


var $38e96a2b42b175e8$exports = {};
"use strict";
Object.defineProperty($38e96a2b42b175e8$exports, "__esModule", {
    value: true
});
var $8c651f8f2944f6f7$exports = {};
"use strict";
Object.defineProperty($8c651f8f2944f6f7$exports, "__esModule", {
    value: true
});
var $8c651f8f2944f6f7$var$prefix = "fas";
var $8c651f8f2944f6f7$var$iconName = "up-right-from-square";
var $8c651f8f2944f6f7$var$width = 512;
var $8c651f8f2944f6f7$var$height = 512;
var $8c651f8f2944f6f7$var$aliases = [
    "external-link-alt"
];
var $8c651f8f2944f6f7$var$unicode = "f35d";
var $8c651f8f2944f6f7$var$svgPathData = "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z";
$8c651f8f2944f6f7$exports.definition = {
    prefix: $8c651f8f2944f6f7$var$prefix,
    iconName: $8c651f8f2944f6f7$var$iconName,
    icon: [
        $8c651f8f2944f6f7$var$width,
        $8c651f8f2944f6f7$var$height,
        $8c651f8f2944f6f7$var$aliases,
        $8c651f8f2944f6f7$var$unicode,
        $8c651f8f2944f6f7$var$svgPathData
    ]
};
$8c651f8f2944f6f7$exports.faUpRightFromSquare = $8c651f8f2944f6f7$exports.definition;
$8c651f8f2944f6f7$exports.prefix = $8c651f8f2944f6f7$var$prefix;
$8c651f8f2944f6f7$exports.iconName = $8c651f8f2944f6f7$var$iconName;
$8c651f8f2944f6f7$exports.width = $8c651f8f2944f6f7$var$width;
$8c651f8f2944f6f7$exports.height = $8c651f8f2944f6f7$var$height;
$8c651f8f2944f6f7$exports.ligatures = $8c651f8f2944f6f7$var$aliases;
$8c651f8f2944f6f7$exports.unicode = $8c651f8f2944f6f7$var$unicode;
$8c651f8f2944f6f7$exports.svgPathData = $8c651f8f2944f6f7$var$svgPathData;
$8c651f8f2944f6f7$exports.aliases = $8c651f8f2944f6f7$var$aliases;


$38e96a2b42b175e8$exports.definition = {
    prefix: $8c651f8f2944f6f7$exports.prefix,
    iconName: $8c651f8f2944f6f7$exports.iconName,
    icon: [
        $8c651f8f2944f6f7$exports.width,
        $8c651f8f2944f6f7$exports.height,
        $8c651f8f2944f6f7$exports.aliases,
        $8c651f8f2944f6f7$exports.unicode,
        $8c651f8f2944f6f7$exports.svgPathData
    ]
};
$38e96a2b42b175e8$exports.faExternalLinkAlt = $38e96a2b42b175e8$exports.definition;
$38e96a2b42b175e8$exports.prefix = $8c651f8f2944f6f7$exports.prefix;
$38e96a2b42b175e8$exports.iconName = $8c651f8f2944f6f7$exports.iconName;
$38e96a2b42b175e8$exports.width = $8c651f8f2944f6f7$exports.width;
$38e96a2b42b175e8$exports.height = $8c651f8f2944f6f7$exports.height;
$38e96a2b42b175e8$exports.ligatures = $8c651f8f2944f6f7$exports.aliases;
$38e96a2b42b175e8$exports.unicode = $8c651f8f2944f6f7$exports.unicode;
$38e96a2b42b175e8$exports.svgPathData = $8c651f8f2944f6f7$exports.svgPathData;
$38e96a2b42b175e8$exports.aliases = $8c651f8f2944f6f7$exports.aliases;


var $5a270b3b7e6b7fa8$exports = {};
"use strict";
Object.defineProperty($5a270b3b7e6b7fa8$exports, "__esModule", {
    value: true
});
var $5a270b3b7e6b7fa8$var$prefix = "fas";
var $5a270b3b7e6b7fa8$var$iconName = "key";
var $5a270b3b7e6b7fa8$var$width = 512;
var $5a270b3b7e6b7fa8$var$height = 512;
var $5a270b3b7e6b7fa8$var$aliases = [
    128273
];
var $5a270b3b7e6b7fa8$var$unicode = "f084";
var $5a270b3b7e6b7fa8$var$svgPathData = "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z";
$5a270b3b7e6b7fa8$exports.definition = {
    prefix: $5a270b3b7e6b7fa8$var$prefix,
    iconName: $5a270b3b7e6b7fa8$var$iconName,
    icon: [
        $5a270b3b7e6b7fa8$var$width,
        $5a270b3b7e6b7fa8$var$height,
        $5a270b3b7e6b7fa8$var$aliases,
        $5a270b3b7e6b7fa8$var$unicode,
        $5a270b3b7e6b7fa8$var$svgPathData
    ]
};
$5a270b3b7e6b7fa8$exports.faKey = $5a270b3b7e6b7fa8$exports.definition;
$5a270b3b7e6b7fa8$exports.prefix = $5a270b3b7e6b7fa8$var$prefix;
$5a270b3b7e6b7fa8$exports.iconName = $5a270b3b7e6b7fa8$var$iconName;
$5a270b3b7e6b7fa8$exports.width = $5a270b3b7e6b7fa8$var$width;
$5a270b3b7e6b7fa8$exports.height = $5a270b3b7e6b7fa8$var$height;
$5a270b3b7e6b7fa8$exports.ligatures = $5a270b3b7e6b7fa8$var$aliases;
$5a270b3b7e6b7fa8$exports.unicode = $5a270b3b7e6b7fa8$var$unicode;
$5a270b3b7e6b7fa8$exports.svgPathData = $5a270b3b7e6b7fa8$var$svgPathData;
$5a270b3b7e6b7fa8$exports.aliases = $5a270b3b7e6b7fa8$var$aliases;


var $3d54bd244f4653d3$exports = {};
"use strict";
Object.defineProperty($3d54bd244f4653d3$exports, "__esModule", {
    value: true
});
var $ca60dd235af7334a$exports = {};
"use strict";
Object.defineProperty($ca60dd235af7334a$exports, "__esModule", {
    value: true
});
var $ca60dd235af7334a$var$prefix = "fas";
var $ca60dd235af7334a$var$iconName = "magnifying-glass";
var $ca60dd235af7334a$var$width = 512;
var $ca60dd235af7334a$var$height = 512;
var $ca60dd235af7334a$var$aliases = [
    128269,
    "search"
];
var $ca60dd235af7334a$var$unicode = "f002";
var $ca60dd235af7334a$var$svgPathData = "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z";
$ca60dd235af7334a$exports.definition = {
    prefix: $ca60dd235af7334a$var$prefix,
    iconName: $ca60dd235af7334a$var$iconName,
    icon: [
        $ca60dd235af7334a$var$width,
        $ca60dd235af7334a$var$height,
        $ca60dd235af7334a$var$aliases,
        $ca60dd235af7334a$var$unicode,
        $ca60dd235af7334a$var$svgPathData
    ]
};
$ca60dd235af7334a$exports.faMagnifyingGlass = $ca60dd235af7334a$exports.definition;
$ca60dd235af7334a$exports.prefix = $ca60dd235af7334a$var$prefix;
$ca60dd235af7334a$exports.iconName = $ca60dd235af7334a$var$iconName;
$ca60dd235af7334a$exports.width = $ca60dd235af7334a$var$width;
$ca60dd235af7334a$exports.height = $ca60dd235af7334a$var$height;
$ca60dd235af7334a$exports.ligatures = $ca60dd235af7334a$var$aliases;
$ca60dd235af7334a$exports.unicode = $ca60dd235af7334a$var$unicode;
$ca60dd235af7334a$exports.svgPathData = $ca60dd235af7334a$var$svgPathData;
$ca60dd235af7334a$exports.aliases = $ca60dd235af7334a$var$aliases;


$3d54bd244f4653d3$exports.definition = {
    prefix: $ca60dd235af7334a$exports.prefix,
    iconName: $ca60dd235af7334a$exports.iconName,
    icon: [
        $ca60dd235af7334a$exports.width,
        $ca60dd235af7334a$exports.height,
        $ca60dd235af7334a$exports.aliases,
        $ca60dd235af7334a$exports.unicode,
        $ca60dd235af7334a$exports.svgPathData
    ]
};
$3d54bd244f4653d3$exports.faSearch = $3d54bd244f4653d3$exports.definition;
$3d54bd244f4653d3$exports.prefix = $ca60dd235af7334a$exports.prefix;
$3d54bd244f4653d3$exports.iconName = $ca60dd235af7334a$exports.iconName;
$3d54bd244f4653d3$exports.width = $ca60dd235af7334a$exports.width;
$3d54bd244f4653d3$exports.height = $ca60dd235af7334a$exports.height;
$3d54bd244f4653d3$exports.ligatures = $ca60dd235af7334a$exports.aliases;
$3d54bd244f4653d3$exports.unicode = $ca60dd235af7334a$exports.unicode;
$3d54bd244f4653d3$exports.svgPathData = $ca60dd235af7334a$exports.svgPathData;
$3d54bd244f4653d3$exports.aliases = $ca60dd235af7334a$exports.aliases;


var $5f3a6b596119c825$exports = {};
"use strict";
Object.defineProperty($5f3a6b596119c825$exports, "__esModule", {
    value: true
});
var $19ec3707a0f446bb$exports = {};
"use strict";
Object.defineProperty($19ec3707a0f446bb$exports, "__esModule", {
    value: true
});
var $19ec3707a0f446bb$var$prefix = "fas";
var $19ec3707a0f446bb$var$iconName = "share-nodes";
var $19ec3707a0f446bb$var$width = 448;
var $19ec3707a0f446bb$var$height = 512;
var $19ec3707a0f446bb$var$aliases = [
    "share-alt"
];
var $19ec3707a0f446bb$var$unicode = "f1e0";
var $19ec3707a0f446bb$var$svgPathData = "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z";
$19ec3707a0f446bb$exports.definition = {
    prefix: $19ec3707a0f446bb$var$prefix,
    iconName: $19ec3707a0f446bb$var$iconName,
    icon: [
        $19ec3707a0f446bb$var$width,
        $19ec3707a0f446bb$var$height,
        $19ec3707a0f446bb$var$aliases,
        $19ec3707a0f446bb$var$unicode,
        $19ec3707a0f446bb$var$svgPathData
    ]
};
$19ec3707a0f446bb$exports.faShareNodes = $19ec3707a0f446bb$exports.definition;
$19ec3707a0f446bb$exports.prefix = $19ec3707a0f446bb$var$prefix;
$19ec3707a0f446bb$exports.iconName = $19ec3707a0f446bb$var$iconName;
$19ec3707a0f446bb$exports.width = $19ec3707a0f446bb$var$width;
$19ec3707a0f446bb$exports.height = $19ec3707a0f446bb$var$height;
$19ec3707a0f446bb$exports.ligatures = $19ec3707a0f446bb$var$aliases;
$19ec3707a0f446bb$exports.unicode = $19ec3707a0f446bb$var$unicode;
$19ec3707a0f446bb$exports.svgPathData = $19ec3707a0f446bb$var$svgPathData;
$19ec3707a0f446bb$exports.aliases = $19ec3707a0f446bb$var$aliases;


$5f3a6b596119c825$exports.definition = {
    prefix: $19ec3707a0f446bb$exports.prefix,
    iconName: $19ec3707a0f446bb$exports.iconName,
    icon: [
        $19ec3707a0f446bb$exports.width,
        $19ec3707a0f446bb$exports.height,
        $19ec3707a0f446bb$exports.aliases,
        $19ec3707a0f446bb$exports.unicode,
        $19ec3707a0f446bb$exports.svgPathData
    ]
};
$5f3a6b596119c825$exports.faShareAlt = $5f3a6b596119c825$exports.definition;
$5f3a6b596119c825$exports.prefix = $19ec3707a0f446bb$exports.prefix;
$5f3a6b596119c825$exports.iconName = $19ec3707a0f446bb$exports.iconName;
$5f3a6b596119c825$exports.width = $19ec3707a0f446bb$exports.width;
$5f3a6b596119c825$exports.height = $19ec3707a0f446bb$exports.height;
$5f3a6b596119c825$exports.ligatures = $19ec3707a0f446bb$exports.aliases;
$5f3a6b596119c825$exports.unicode = $19ec3707a0f446bb$exports.unicode;
$5f3a6b596119c825$exports.svgPathData = $19ec3707a0f446bb$exports.svgPathData;
$5f3a6b596119c825$exports.aliases = $19ec3707a0f446bb$exports.aliases;


var $17ddfe677f5b40f7$exports = {};
"use strict";
Object.defineProperty($17ddfe677f5b40f7$exports, "__esModule", {
    value: true
});
var $35b4a6ca5cd59a8e$exports = {};
"use strict";
Object.defineProperty($35b4a6ca5cd59a8e$exports, "__esModule", {
    value: true
});
var $35b4a6ca5cd59a8e$var$prefix = "fas";
var $35b4a6ca5cd59a8e$var$iconName = "right-from-bracket";
var $35b4a6ca5cd59a8e$var$width = 512;
var $35b4a6ca5cd59a8e$var$height = 512;
var $35b4a6ca5cd59a8e$var$aliases = [
    "sign-out-alt"
];
var $35b4a6ca5cd59a8e$var$unicode = "f2f5";
var $35b4a6ca5cd59a8e$var$svgPathData = "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z";
$35b4a6ca5cd59a8e$exports.definition = {
    prefix: $35b4a6ca5cd59a8e$var$prefix,
    iconName: $35b4a6ca5cd59a8e$var$iconName,
    icon: [
        $35b4a6ca5cd59a8e$var$width,
        $35b4a6ca5cd59a8e$var$height,
        $35b4a6ca5cd59a8e$var$aliases,
        $35b4a6ca5cd59a8e$var$unicode,
        $35b4a6ca5cd59a8e$var$svgPathData
    ]
};
$35b4a6ca5cd59a8e$exports.faRightFromBracket = $35b4a6ca5cd59a8e$exports.definition;
$35b4a6ca5cd59a8e$exports.prefix = $35b4a6ca5cd59a8e$var$prefix;
$35b4a6ca5cd59a8e$exports.iconName = $35b4a6ca5cd59a8e$var$iconName;
$35b4a6ca5cd59a8e$exports.width = $35b4a6ca5cd59a8e$var$width;
$35b4a6ca5cd59a8e$exports.height = $35b4a6ca5cd59a8e$var$height;
$35b4a6ca5cd59a8e$exports.ligatures = $35b4a6ca5cd59a8e$var$aliases;
$35b4a6ca5cd59a8e$exports.unicode = $35b4a6ca5cd59a8e$var$unicode;
$35b4a6ca5cd59a8e$exports.svgPathData = $35b4a6ca5cd59a8e$var$svgPathData;
$35b4a6ca5cd59a8e$exports.aliases = $35b4a6ca5cd59a8e$var$aliases;


$17ddfe677f5b40f7$exports.definition = {
    prefix: $35b4a6ca5cd59a8e$exports.prefix,
    iconName: $35b4a6ca5cd59a8e$exports.iconName,
    icon: [
        $35b4a6ca5cd59a8e$exports.width,
        $35b4a6ca5cd59a8e$exports.height,
        $35b4a6ca5cd59a8e$exports.aliases,
        $35b4a6ca5cd59a8e$exports.unicode,
        $35b4a6ca5cd59a8e$exports.svgPathData
    ]
};
$17ddfe677f5b40f7$exports.faSignOutAlt = $17ddfe677f5b40f7$exports.definition;
$17ddfe677f5b40f7$exports.prefix = $35b4a6ca5cd59a8e$exports.prefix;
$17ddfe677f5b40f7$exports.iconName = $35b4a6ca5cd59a8e$exports.iconName;
$17ddfe677f5b40f7$exports.width = $35b4a6ca5cd59a8e$exports.width;
$17ddfe677f5b40f7$exports.height = $35b4a6ca5cd59a8e$exports.height;
$17ddfe677f5b40f7$exports.ligatures = $35b4a6ca5cd59a8e$exports.aliases;
$17ddfe677f5b40f7$exports.unicode = $35b4a6ca5cd59a8e$exports.unicode;
$17ddfe677f5b40f7$exports.svgPathData = $35b4a6ca5cd59a8e$exports.svgPathData;
$17ddfe677f5b40f7$exports.aliases = $35b4a6ca5cd59a8e$exports.aliases;


var $c0ffe79f8008445d$exports = {};
"use strict";
Object.defineProperty($c0ffe79f8008445d$exports, "__esModule", {
    value: true
});
var $c0ffe79f8008445d$var$prefix = "fas";
var $c0ffe79f8008445d$var$iconName = "slash";
var $c0ffe79f8008445d$var$width = 640;
var $c0ffe79f8008445d$var$height = 512;
var $c0ffe79f8008445d$var$aliases = [];
var $c0ffe79f8008445d$var$unicode = "f715";
var $c0ffe79f8008445d$var$svgPathData = "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z";
$c0ffe79f8008445d$exports.definition = {
    prefix: $c0ffe79f8008445d$var$prefix,
    iconName: $c0ffe79f8008445d$var$iconName,
    icon: [
        $c0ffe79f8008445d$var$width,
        $c0ffe79f8008445d$var$height,
        $c0ffe79f8008445d$var$aliases,
        $c0ffe79f8008445d$var$unicode,
        $c0ffe79f8008445d$var$svgPathData
    ]
};
$c0ffe79f8008445d$exports.faSlash = $c0ffe79f8008445d$exports.definition;
$c0ffe79f8008445d$exports.prefix = $c0ffe79f8008445d$var$prefix;
$c0ffe79f8008445d$exports.iconName = $c0ffe79f8008445d$var$iconName;
$c0ffe79f8008445d$exports.width = $c0ffe79f8008445d$var$width;
$c0ffe79f8008445d$exports.height = $c0ffe79f8008445d$var$height;
$c0ffe79f8008445d$exports.ligatures = $c0ffe79f8008445d$var$aliases;
$c0ffe79f8008445d$exports.unicode = $c0ffe79f8008445d$var$unicode;
$c0ffe79f8008445d$exports.svgPathData = $c0ffe79f8008445d$var$svgPathData;
$c0ffe79f8008445d$exports.aliases = $c0ffe79f8008445d$var$aliases;


var $d85e0c7e91e2ddfe$exports = {};
"use strict";
Object.defineProperty($d85e0c7e91e2ddfe$exports, "__esModule", {
    value: true
});
var $d85e0c7e91e2ddfe$var$prefix = "fas";
var $d85e0c7e91e2ddfe$var$iconName = "spinner";
var $d85e0c7e91e2ddfe$var$width = 512;
var $d85e0c7e91e2ddfe$var$height = 512;
var $d85e0c7e91e2ddfe$var$aliases = [];
var $d85e0c7e91e2ddfe$var$unicode = "f110";
var $d85e0c7e91e2ddfe$var$svgPathData = "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z";
$d85e0c7e91e2ddfe$exports.definition = {
    prefix: $d85e0c7e91e2ddfe$var$prefix,
    iconName: $d85e0c7e91e2ddfe$var$iconName,
    icon: [
        $d85e0c7e91e2ddfe$var$width,
        $d85e0c7e91e2ddfe$var$height,
        $d85e0c7e91e2ddfe$var$aliases,
        $d85e0c7e91e2ddfe$var$unicode,
        $d85e0c7e91e2ddfe$var$svgPathData
    ]
};
$d85e0c7e91e2ddfe$exports.faSpinner = $d85e0c7e91e2ddfe$exports.definition;
$d85e0c7e91e2ddfe$exports.prefix = $d85e0c7e91e2ddfe$var$prefix;
$d85e0c7e91e2ddfe$exports.iconName = $d85e0c7e91e2ddfe$var$iconName;
$d85e0c7e91e2ddfe$exports.width = $d85e0c7e91e2ddfe$var$width;
$d85e0c7e91e2ddfe$exports.height = $d85e0c7e91e2ddfe$var$height;
$d85e0c7e91e2ddfe$exports.ligatures = $d85e0c7e91e2ddfe$var$aliases;
$d85e0c7e91e2ddfe$exports.unicode = $d85e0c7e91e2ddfe$var$unicode;
$d85e0c7e91e2ddfe$exports.svgPathData = $d85e0c7e91e2ddfe$var$svgPathData;
$d85e0c7e91e2ddfe$exports.aliases = $d85e0c7e91e2ddfe$var$aliases;


var $4e5ab4d00c078f68$exports = {};
"use strict";
Object.defineProperty($4e5ab4d00c078f68$exports, "__esModule", {
    value: true
});
var $4e5ab4d00c078f68$var$prefix = "fas";
var $4e5ab4d00c078f68$var$iconName = "star";
var $4e5ab4d00c078f68$var$width = 576;
var $4e5ab4d00c078f68$var$height = 512;
var $4e5ab4d00c078f68$var$aliases = [
    11088,
    61446
];
var $4e5ab4d00c078f68$var$unicode = "f005";
var $4e5ab4d00c078f68$var$svgPathData = "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z";
$4e5ab4d00c078f68$exports.definition = {
    prefix: $4e5ab4d00c078f68$var$prefix,
    iconName: $4e5ab4d00c078f68$var$iconName,
    icon: [
        $4e5ab4d00c078f68$var$width,
        $4e5ab4d00c078f68$var$height,
        $4e5ab4d00c078f68$var$aliases,
        $4e5ab4d00c078f68$var$unicode,
        $4e5ab4d00c078f68$var$svgPathData
    ]
};
$4e5ab4d00c078f68$exports.faStar = $4e5ab4d00c078f68$exports.definition;
$4e5ab4d00c078f68$exports.prefix = $4e5ab4d00c078f68$var$prefix;
$4e5ab4d00c078f68$exports.iconName = $4e5ab4d00c078f68$var$iconName;
$4e5ab4d00c078f68$exports.width = $4e5ab4d00c078f68$var$width;
$4e5ab4d00c078f68$exports.height = $4e5ab4d00c078f68$var$height;
$4e5ab4d00c078f68$exports.ligatures = $4e5ab4d00c078f68$var$aliases;
$4e5ab4d00c078f68$exports.unicode = $4e5ab4d00c078f68$var$unicode;
$4e5ab4d00c078f68$exports.svgPathData = $4e5ab4d00c078f68$var$svgPathData;
$4e5ab4d00c078f68$exports.aliases = $4e5ab4d00c078f68$var$aliases;


var $468e6f5287149412$exports = {};
"use strict";
Object.defineProperty($468e6f5287149412$exports, "__esModule", {
    value: true
});
var $6f224e40d9413106$exports = {};
"use strict";
Object.defineProperty($6f224e40d9413106$exports, "__esModule", {
    value: true
});
var $6f224e40d9413106$var$prefix = "fas";
var $6f224e40d9413106$var$iconName = "rotate";
var $6f224e40d9413106$var$width = 512;
var $6f224e40d9413106$var$height = 512;
var $6f224e40d9413106$var$aliases = [
    128260,
    "sync-alt"
];
var $6f224e40d9413106$var$unicode = "f2f1";
var $6f224e40d9413106$var$svgPathData = "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z";
$6f224e40d9413106$exports.definition = {
    prefix: $6f224e40d9413106$var$prefix,
    iconName: $6f224e40d9413106$var$iconName,
    icon: [
        $6f224e40d9413106$var$width,
        $6f224e40d9413106$var$height,
        $6f224e40d9413106$var$aliases,
        $6f224e40d9413106$var$unicode,
        $6f224e40d9413106$var$svgPathData
    ]
};
$6f224e40d9413106$exports.faRotate = $6f224e40d9413106$exports.definition;
$6f224e40d9413106$exports.prefix = $6f224e40d9413106$var$prefix;
$6f224e40d9413106$exports.iconName = $6f224e40d9413106$var$iconName;
$6f224e40d9413106$exports.width = $6f224e40d9413106$var$width;
$6f224e40d9413106$exports.height = $6f224e40d9413106$var$height;
$6f224e40d9413106$exports.ligatures = $6f224e40d9413106$var$aliases;
$6f224e40d9413106$exports.unicode = $6f224e40d9413106$var$unicode;
$6f224e40d9413106$exports.svgPathData = $6f224e40d9413106$var$svgPathData;
$6f224e40d9413106$exports.aliases = $6f224e40d9413106$var$aliases;


$468e6f5287149412$exports.definition = {
    prefix: $6f224e40d9413106$exports.prefix,
    iconName: $6f224e40d9413106$exports.iconName,
    icon: [
        $6f224e40d9413106$exports.width,
        $6f224e40d9413106$exports.height,
        $6f224e40d9413106$exports.aliases,
        $6f224e40d9413106$exports.unicode,
        $6f224e40d9413106$exports.svgPathData
    ]
};
$468e6f5287149412$exports.faSyncAlt = $468e6f5287149412$exports.definition;
$468e6f5287149412$exports.prefix = $6f224e40d9413106$exports.prefix;
$468e6f5287149412$exports.iconName = $6f224e40d9413106$exports.iconName;
$468e6f5287149412$exports.width = $6f224e40d9413106$exports.width;
$468e6f5287149412$exports.height = $6f224e40d9413106$exports.height;
$468e6f5287149412$exports.ligatures = $6f224e40d9413106$exports.aliases;
$468e6f5287149412$exports.unicode = $6f224e40d9413106$exports.unicode;
$468e6f5287149412$exports.svgPathData = $6f224e40d9413106$exports.svgPathData;
$468e6f5287149412$exports.aliases = $6f224e40d9413106$exports.aliases;


var $6c06a95c587730ec$exports = {};
"use strict";
Object.defineProperty($6c06a95c587730ec$exports, "__esModule", {
    value: true
});
var $9e310623eda7f0ec$exports = {};
"use strict";
Object.defineProperty($9e310623eda7f0ec$exports, "__esModule", {
    value: true
});
var $9e310623eda7f0ec$var$prefix = "fas";
var $9e310623eda7f0ec$var$iconName = "xmark";
var $9e310623eda7f0ec$var$width = 384;
var $9e310623eda7f0ec$var$height = 512;
var $9e310623eda7f0ec$var$aliases = [
    128473,
    10005,
    10006,
    10060,
    215,
    "close",
    "multiply",
    "remove",
    "times"
];
var $9e310623eda7f0ec$var$unicode = "f00d";
var $9e310623eda7f0ec$var$svgPathData = "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z";
$9e310623eda7f0ec$exports.definition = {
    prefix: $9e310623eda7f0ec$var$prefix,
    iconName: $9e310623eda7f0ec$var$iconName,
    icon: [
        $9e310623eda7f0ec$var$width,
        $9e310623eda7f0ec$var$height,
        $9e310623eda7f0ec$var$aliases,
        $9e310623eda7f0ec$var$unicode,
        $9e310623eda7f0ec$var$svgPathData
    ]
};
$9e310623eda7f0ec$exports.faXmark = $9e310623eda7f0ec$exports.definition;
$9e310623eda7f0ec$exports.prefix = $9e310623eda7f0ec$var$prefix;
$9e310623eda7f0ec$exports.iconName = $9e310623eda7f0ec$var$iconName;
$9e310623eda7f0ec$exports.width = $9e310623eda7f0ec$var$width;
$9e310623eda7f0ec$exports.height = $9e310623eda7f0ec$var$height;
$9e310623eda7f0ec$exports.ligatures = $9e310623eda7f0ec$var$aliases;
$9e310623eda7f0ec$exports.unicode = $9e310623eda7f0ec$var$unicode;
$9e310623eda7f0ec$exports.svgPathData = $9e310623eda7f0ec$var$svgPathData;
$9e310623eda7f0ec$exports.aliases = $9e310623eda7f0ec$var$aliases;


$6c06a95c587730ec$exports.definition = {
    prefix: $9e310623eda7f0ec$exports.prefix,
    iconName: $9e310623eda7f0ec$exports.iconName,
    icon: [
        $9e310623eda7f0ec$exports.width,
        $9e310623eda7f0ec$exports.height,
        $9e310623eda7f0ec$exports.aliases,
        $9e310623eda7f0ec$exports.unicode,
        $9e310623eda7f0ec$exports.svgPathData
    ]
};
$6c06a95c587730ec$exports.faTimes = $6c06a95c587730ec$exports.definition;
$6c06a95c587730ec$exports.prefix = $9e310623eda7f0ec$exports.prefix;
$6c06a95c587730ec$exports.iconName = $9e310623eda7f0ec$exports.iconName;
$6c06a95c587730ec$exports.width = $9e310623eda7f0ec$exports.width;
$6c06a95c587730ec$exports.height = $9e310623eda7f0ec$exports.height;
$6c06a95c587730ec$exports.ligatures = $9e310623eda7f0ec$exports.aliases;
$6c06a95c587730ec$exports.unicode = $9e310623eda7f0ec$exports.unicode;
$6c06a95c587730ec$exports.svgPathData = $9e310623eda7f0ec$exports.svgPathData;
$6c06a95c587730ec$exports.aliases = $9e310623eda7f0ec$exports.aliases;


var $37a500ad1dcc914a$exports = {};
"use strict";
Object.defineProperty($37a500ad1dcc914a$exports, "__esModule", {
    value: true
});
var $37a500ad1dcc914a$var$prefix = "fas";
var $37a500ad1dcc914a$var$iconName = "wifi";
var $37a500ad1dcc914a$var$width = 640;
var $37a500ad1dcc914a$var$height = 512;
var $37a500ad1dcc914a$var$aliases = [
    "wifi-3",
    "wifi-strong"
];
var $37a500ad1dcc914a$var$unicode = "f1eb";
var $37a500ad1dcc914a$var$svgPathData = "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z";
$37a500ad1dcc914a$exports.definition = {
    prefix: $37a500ad1dcc914a$var$prefix,
    iconName: $37a500ad1dcc914a$var$iconName,
    icon: [
        $37a500ad1dcc914a$var$width,
        $37a500ad1dcc914a$var$height,
        $37a500ad1dcc914a$var$aliases,
        $37a500ad1dcc914a$var$unicode,
        $37a500ad1dcc914a$var$svgPathData
    ]
};
$37a500ad1dcc914a$exports.faWifi = $37a500ad1dcc914a$exports.definition;
$37a500ad1dcc914a$exports.prefix = $37a500ad1dcc914a$var$prefix;
$37a500ad1dcc914a$exports.iconName = $37a500ad1dcc914a$var$iconName;
$37a500ad1dcc914a$exports.width = $37a500ad1dcc914a$var$width;
$37a500ad1dcc914a$exports.height = $37a500ad1dcc914a$var$height;
$37a500ad1dcc914a$exports.ligatures = $37a500ad1dcc914a$var$aliases;
$37a500ad1dcc914a$exports.unicode = $37a500ad1dcc914a$var$unicode;
$37a500ad1dcc914a$exports.svgPathData = $37a500ad1dcc914a$var$svgPathData;
$37a500ad1dcc914a$exports.aliases = $37a500ad1dcc914a$var$aliases;


var $d38ff8171a2466a8$export$2e2bcd8739ae039 = [
    124.155,
    133.529,
    [],
    null,
    // wallabag.svg: Free Art License 1.3 https://github.com/wallabag/logo
    "M108.69.004c-.241-.026-.512.083-.777.299-.572.465-5.551 1.614-8.504 3.917-4.768 3.72-7.707 10.796-9.04 14.708-.024.06-.205.603-.265.79-.62 1.499-1.857 1.495-1.857 1.495v.002c-.6-.065-1.202-.102-1.809-.102-.54 0-1.078.03-1.615.082-.012.002-.02 0-.031 0-1.581.233-2.451-1.696-2.633-2.156C80.312 13.735 75.342 3.277 64.174.463c0 0-2.028-1.554-1.41 1.074.588 2.51 1.805 5.048 1.535 8.74-.124 1.704-1.18 10.442 6.85 14.99.763.432 1.44.796 2.05 1.102-4.041 3.235-7.715 7.739-10.858 12.852 1.597-.981 10.206-5.557 24.097.177 14.29 5.897 23.155.777 24.254.08-3.454-5.678-7.561-10.62-12.103-13.943.303-.083.612-.168.939-.264 6.023-1.742 7.553-6.84 7.875-11.209.364-4.954.615-5.029 1.691-9.486.774-3.21.32-4.495-.404-4.572zM86.774 50.228a4.677 4.677 0 00-1.652.256 6.555 6.555 0 00-1.332.615 3.879 3.879 0 00-1.094.985c-.322.432-.486.901-.486 1.396v16.307c0 2.158-.362 3.75-1.078 4.73-.688.94-1.85 1.397-3.55 1.397-1.704 0-2.876-.46-3.583-1.402-.734-.98-1.108-2.57-1.108-4.725V53.73c0-.908-.383-1.727-1.144-2.437-.751-.702-1.75-1.059-2.973-1.059-1.258 0-2.297.352-3.086 1.045-.81.71-1.22 1.536-1.22 2.451v15.807c0 1.988.193 3.869.574 5.588.393 1.758 1.077 3.3 2.035 4.586.968 1.299 2.282 2.322 3.906 3.049 1.607.716 3.617 1.08 5.975 1.08 2.457 0 4.515-.457 6.115-1.356a10.678 10.678 0 003.371-2.95 10.256 10.256 0 003.295 2.95c1.58.9 3.669 1.354 6.21 1.354 2.358 0 4.358-.363 5.946-1.08 1.601-.726 2.903-1.752 3.873-3.05.96-1.29 1.644-2.832 2.033-4.585.381-1.72.577-3.6.577-5.588V53.73c0-.91-.398-1.733-1.184-2.445-.767-.697-1.82-1.05-3.121-1.05-1.181 0-2.161.356-2.912 1.058-.76.71-1.145 1.53-1.145 2.437v16.057c0 2.154-.381 3.742-1.134 4.72-.728.947-1.891 1.407-3.555 1.407-1.703 0-2.863-.458-3.549-1.397-.716-.979-1.078-2.57-1.078-4.73v-16.12c0-1.097-.501-1.997-1.45-2.597-.805-.507-1.607-.81-2.476-.842zM51.796 82.363a31.2 31.2 0 001.865 5.742c.666 3.745 1.561 12.563-2.674 20.282-3.731 6.8-22.15 16.069-49.484 10.748 0 0-1.096-.765-1.428-.135-.491.932 1.516 1.684 3.582 2.228 19.03 5.04 47.756 2.989 56.777-4.443 4.116-3.388 5.705-7.953 6.108-12.865l.002.008s.11-1.288 1.718-.32c.461.276 2.126 1.36 2.391 2.585.232 1.743.248 3.884-.652 5.383-1.287 2.144-1.302 2.45.392 3.66 1.04.742 5.289 3.865 11.2 7.416.015.01.022.02.037.028 1.25.753 2.988 2.595 2.988 2.595 2.662 3.08 8.45 9.277 10.97 8.11 1.19-.551-.05-3.033-.05-3.033s1.98 2.572 3.043 1.695c.809-.668-.473-3.23-.473-3.23s1.73 1.5 2.758.945c1.258-.68-.188-4.614-10.08-10.627-9.896-6.018-12.579-6.941-12.815-9.627 0 0-.004-.134.004-.365.077-.593.416-1.848 1.854-1.713 2.14.346 4.347.53 6.607.53 2.587 0 5.106-.236 7.535-.689l.002.002.164-.029c.284-.036.838-.019.84.67-.09.873-.331 1.752-.845 2.52-1.447 2.168-.971 2.466.54 3.859.934.859 5.212 4.622 11.07 8.264.013.009.016.016.03.023 1.25.752 3.41 2.814 3.41 2.814 2.428 2.466 6.895 6.595 9.328 6.346 1.646-.168.305-3.002.305-3.002s2.079 2.006 3.1 1.416c1.142-.659-.475-2.754-.475-2.754s1.338.708 2.283.473c.948-.236 1.187-2.643-8.654-8.736-9.842-6.098-13.154-8.244-12.947-10.577 0 0 .003-.379.1-.957.238-1.236.994-3.346 3.406-4.55.079-.04.147-.084.209-.13 7.668-4.45 13.27-11.614 15.246-20.56-1.99 4.941-16.737 8.78-34.647 8.78-17.903 0-32.65-3.839-34.64-8.78z"
];


"use strict";
var $8cad2150f94e1c78$export$a67558cb68d63c7e = {
    prefix: "fac",
    iconName: "wallabag",
    icon: (0, $d38ff8171a2466a8$export$2e2bcd8739ae039)
};


function $4e51d095a6eb2eac$export$7f7cbe89f1eacd2(param) {
    var label = param.label, size = param.size;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                icon: $d85e0c7e91e2ddfe$exports.faSpinner,
                size: size,
                spin: true,
                "aria-hidden": "true",
                title: label
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "visually-hidden",
                role: "alert",
                children: label
            })
        ]
    });
}
$4e51d095a6eb2eac$export$7f7cbe89f1eacd2.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string
};
function $4e51d095a6eb2eac$export$84dbad74efe95918(param) {
    var label = param.label;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
        className: "spinner-big",
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($4e51d095a6eb2eac$export$7f7cbe89f1eacd2, {
            size: "10x",
            label: label
        })
    });
}
$4e51d095a6eb2eac$export$84dbad74efe95918.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired
};





var $eHaBZ = parcelRequire("eHaBZ");
var $94046e75c3010f4f$export$326f6d1b69f1c06e = /*#__PURE__*/ (0, $eHaBZ.createContext)();



var $eHaBZ = parcelRequire("eHaBZ");
function $7e577f35f270614e$export$e51161e9fbfde80e(translated, params) {
    var formatted = "";
    var curChar = undefined;
    var buffer = "";
    var state = "out";
    var placeholder = undefined;
    var plural = undefined;
    var pluralKeyword = undefined;
    var pluralValue = undefined;
    for(var i = 0, len = translated.length; i < len; i++){
        curChar = translated.charAt(i);
        switch(curChar){
            case "{":
                if (placeholder) {
                    if (state == "plural") {
                        pluralKeyword = buffer.trim();
                        if ([
                            "zero",
                            "one",
                            "other"
                        ].includes(pluralKeyword)) buffer = "";
                        else pluralKeyword = undefined;
                    }
                } else {
                    formatted = formatted + buffer;
                    buffer = "";
                    placeholder = {};
                    state = "index";
                }
                break;
            case "}":
            case ",":
                if (placeholder) {
                    if (state == "index") {
                        var index = buffer.trim();
                        var intIndex = parseInt(index);
                        placeholder.index = Number.isNaN(intIndex) ? index : intIndex;
                        placeholder.value = params[placeholder.index];
                        buffer = "";
                    } else if (state == "type") {
                        placeholder.type = buffer.trim();
                        buffer = "";
                        if (placeholder.type == "plural") {
                            plural = {};
                            state = "plural";
                        }
                    }
                    if (curChar == "}") {
                        if (state == "plural" && pluralKeyword) {
                            plural[pluralKeyword] = buffer;
                            buffer = "";
                            pluralKeyword = undefined;
                        } else if (plural) {
                            if ("zero" in plural && placeholder.value === 0) pluralValue = plural.zero;
                            else if ("one" in plural && placeholder.value == 1) pluralValue = plural.one;
                            else pluralValue = plural.other;
                            formatted = formatted + pluralValue.replace("#", placeholder.value);
                            plural = undefined;
                            placeholder = undefined;
                            state = "out";
                        } else {
                            formatted = formatted + placeholder.value;
                            placeholder = undefined;
                            state = "out";
                        }
                    } else if (curChar == "," && state == "index") state = "type";
                }
                break;
            default:
                buffer = buffer + curChar;
                break;
        }
    }
    if (state != "out") return "Error formatting '" + translated + "', bug report?";
    formatted = formatted + buffer;
    return formatted;
}
var $7e577f35f270614e$export$51216bcc3983e55d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createContext();


function $374b9547e2738d1e$var$handleLogIn(param) {
    var event = param.event, configuration = param.configuration, history = param.history, setLoading = param.setLoading, username = param.username, password = param.password, enableOffline = param.enableOffline, returnLocation = param.returnLocation;
    event.preventDefault();
    setLoading(true);
    selfoss.login({
        configuration: configuration,
        username: username,
        password: password,
        enableOffline: enableOffline
    }).then(function() {
        history.push(returnLocation);
    }).catch(function(err) {
        var message = err instanceof (0, $0d06257c362dc1a1$export$5e64a9683d127ef6) ? selfoss.app._("login_invalid_credentials") : selfoss.app._("login_error_generic", {
            errorMessage: err instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) ? "HTTP ".concat(err.response.status, " ").concat(err.message) : err.message
        });
        history.replace("/sign/in", {
            error: message
        });
    }).finally(function() {
        setLoading(false);
    });
}
function $374b9547e2738d1e$export$2e2bcd8739ae039(param) {
    var offlineEnabled = param.offlineEnabled;
    var _location_state, _location_state1;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(""), 2), username = _useState[0], setUsername = _useState[1];
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(""), 2), password = _useState1[0], setPassword = _useState1[1];
    var _useState2 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(false), 2), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(offlineEnabled), 2), enableOffline = _useState3[0], setEnableOffline = _useState3[1];
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var error = location === null || location === void 0 ? void 0 : (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.error;
    var _location_state_returnLocation;
    var returnLocation = (_location_state_returnLocation = location === null || location === void 0 ? void 0 : (_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1.returnLocation) !== null && _location_state_returnLocation !== void 0 ? _location_state_returnLocation : "/";
    var formOnSubmit = (0, $eHaBZ.useCallback)(function(event) {
        return $374b9547e2738d1e$var$handleLogIn({
            event: event,
            configuration: configuration,
            history: history,
            setLoading: setLoading,
            username: username,
            password: password,
            enableOffline: enableOffline,
            returnLocation: returnLocation
        });
    }, [
        configuration,
        history,
        username,
        password,
        enableOffline,
        returnLocation
    ]);
    var usernameOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setUsername(event.target.value);
    }, []);
    var passwordOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setPassword(event.target.value);
    }, []);
    var offlineOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setEnableOffline(event.target.checked);
    }, [
        setEnableOffline
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
        children: [
            loading ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$84dbad74efe95918), {
                label: _("login_in_progress")
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
                action: "",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    loading: loading
                }),
                method: "post",
                onSubmit: formOnSubmit,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "login",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("h1", {
                                children: [
                                    configuration.htmlTitle,
                                    " login"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "username",
                                    children: _("login_username")
                                }),
                                " ",
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "text",
                                    name: "username",
                                    id: "username",
                                    accessKey: "u",
                                    autoComplete: "username",
                                    onChange: usernameOnChange,
                                    value: username,
                                    autoFocus: true,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "password",
                                    children: _("login_password")
                                }),
                                " ",
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "password",
                                    name: "password",
                                    id: "password",
                                    accessKey: "p",
                                    autoComplete: "current-password",
                                    onChange: passwordOnChange,
                                    value: password
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "enableoffline",
                                    children: _("login_offline")
                                }),
                                " ",
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                            type: "checkbox",
                                            name: "enableoffline",
                                            id: "enableoffline",
                                            accessKey: "o",
                                            onChange: offlineOnChange,
                                            checked: enableOffline
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                            className: "badge-experimental",
                                            children: _("experimental")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            className: "error",
                            "aria-live": "assertive",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            className: "button",
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "submit",
                                    accessKey: "l",
                                    value: _("login")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
$374b9547e2738d1e$export$2e2bcd8739ae039.propTypes = {
    offlineEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired
};







var $eHaBZ = parcelRequire("eHaBZ");









var $eHaBZ = parcelRequire("eHaBZ");





var $eHaBZ = parcelRequire("eHaBZ");





var $eHaBZ = parcelRequire("eHaBZ");







var $eHaBZ = parcelRequire("eHaBZ");




var $eHaBZ = parcelRequire("eHaBZ");



var $e352c376e0aff571$export$30c2dce1a652e248 = function(state) {
    return !!state && state[0] === "o";
};
var $e352c376e0aff571$export$3e3e6d241f8feb60 = (0, $8afcda7f6e55ccf7$exports.unstable_batchedUpdates) || function(callback) {
    return callback();
};
var $e352c376e0aff571$export$68c286be0e7e55b7 = Object.values || function(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
};
var $e352c376e0aff571$export$de749ee021c3ab62 = function(a, b) {
    var diff = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.0001;
    return Math.abs(a - b) < diff;
};
var $e352c376e0aff571$export$d5639c01d489b0c = function(transition, name) {
    return transition === true || !!(transition && transition[name]);
};
var $e352c376e0aff571$export$175e60bb96229ece = function(fn, arg) {
    return typeof fn === "function" ? fn(arg) : fn;
};
var $e352c376e0aff571$var$internalKey = "_szhsinMenu";
var $e352c376e0aff571$export$7d9f7e9c1c02b41e = function(component) {
    return component[$e352c376e0aff571$var$internalKey];
};
var $e352c376e0aff571$export$4c4bf90f1b4d3105 = function(name, component) {
    return Object.defineProperty(component, $e352c376e0aff571$var$internalKey, {
        value: name
    });
};
var $e352c376e0aff571$export$9d1611c77c2fe928 = function(target, source) {
    source && Object.keys(source).forEach(function(key) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if (typeof sourceProp === "function" && targetProp) target[key] = function() {
            for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
                arg[_key] = arguments[_key];
            }
            sourceProp.apply(void 0, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(arg));
            targetProp.apply(void 0, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(arg));
        };
        else target[key] = sourceProp;
    });
    return target;
};
var $e352c376e0aff571$export$4bc3c325941e6f67 = function(paddingStr) {
    if (typeof paddingStr !== "string") return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    var padding = paddingStr.trim().split(/\s+/, 4).map(parseFloat);
    var top = !isNaN(padding[0]) ? padding[0] : 0;
    var right = !isNaN(padding[1]) ? padding[1] : top;
    return {
        top: top,
        right: right,
        bottom: !isNaN(padding[2]) ? padding[2] : top,
        left: !isNaN(padding[3]) ? padding[3] : right
    };
};
var $e352c376e0aff571$export$7414735161c19437 = function(node) {
    while(node){
        node = node.parentNode;
        if (!node || node === document.body || !node.parentNode) return;
        var _getComputedStyle = getComputedStyle(node), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) return node;
    }
};
function $e352c376e0aff571$export$ffb2d5922287e12(isDisabled, isHovering) {
    return {
        "aria-disabled": isDisabled || undefined,
        tabIndex: isHovering ? 0 : -1
    };
}
function $e352c376e0aff571$export$a12bd5aaf0b59fa0(nodeList, node) {
    for(var i = 0; i < nodeList.length; i++){
        if (nodeList[i] === node) return i;
    }
    return -1;
}



var $eHaBZ = parcelRequire("eHaBZ");
var $370568074483fa2d$export$7ae630fe844fbd1f = function(param) {
    var block = param.block, element = param.element, modifiers = param.modifiers, className = param.className;
    return (0, $eHaBZ.useMemo)(function() {
        var blockElement = element ? "".concat(block, "__").concat(element) : block;
        var classString = blockElement;
        modifiers && Object.keys(modifiers).forEach(function(name) {
            var value = modifiers[name];
            if (value) classString += " ".concat(blockElement, "--").concat(value === true ? name : "".concat(name, "-").concat(value));
        });
        var expandedClassName = typeof className === "function" ? className(modifiers) : className;
        if (typeof expandedClassName === "string") {
            expandedClassName = expandedClassName.trim();
            if (expandedClassName) classString += " ".concat(expandedClassName);
        }
        return classString;
    }, [
        block,
        element,
        modifiers,
        className
    ]);
};



var $eHaBZ = parcelRequire("eHaBZ");
var $8582129499aad1e8$export$ccf052fa53df1929 = "szh-menu-container";
var $8582129499aad1e8$export$832250593589325a = "szh-menu";
var $8582129499aad1e8$export$b3d82f113f746a0 = "szh-menu-button";
var $8582129499aad1e8$export$3b35f0f35c840df9 = "arrow";
var $8582129499aad1e8$export$b5a3c9a9995a8c24 = "item";
var $8582129499aad1e8$export$10b42530e0558a83 = "divider";
var $8582129499aad1e8$export$29e3fcfc61abbafd = "header";
var $8582129499aad1e8$export$e4f8e9b9e6d790ae = "group";
var $8582129499aad1e8$export$3b437b9ab85faa03 = "submenu";
var $8582129499aad1e8$export$d6766e4ef63d0cb0 = "radio-group";
var $8582129499aad1e8$export$15c1690330cd94e = /*#__PURE__*/ (0, $eHaBZ.createContext)();
var $8582129499aad1e8$export$7cb023214e4bda1e = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $8582129499aad1e8$export$1c2bdfb4407fdacf = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $8582129499aad1e8$export$ee9f2ec6c8119c2a = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $8582129499aad1e8$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $8582129499aad1e8$export$8fa45c82eddfe270 = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $8582129499aad1e8$export$4b0075e5ea5e1f26 = /*#__PURE__*/ Object.freeze({
    ENTER: "Enter",
    ESC: "Escape",
    SPACE: " ",
    HOME: "Home",
    END: "End",
    LEFT: "ArrowLeft",
    RIGHT: "ArrowRight",
    UP: "ArrowUp",
    DOWN: "ArrowDown"
});
var $8582129499aad1e8$export$6db955af9e6f8fcd = /*#__PURE__*/ Object.freeze({
    RESET: 0,
    SET: 1,
    UNSET: 2,
    INCREASE: 3,
    DECREASE: 4,
    FIRST: 5,
    LAST: 6,
    SET_INDEX: 7
});
var $8582129499aad1e8$export$8fd8df51a9b835e6 = /*#__PURE__*/ Object.freeze({
    CLICK: "click",
    CANCEL: "cancel",
    BLUR: "blur",
    SCROLL: "scroll"
});
var $8582129499aad1e8$export$8c6ccba1b6ce32e9 = /*#__PURE__*/ Object.freeze({
    FIRST: "first",
    LAST: "last"
});
var $8582129499aad1e8$export$be1d8b0328ba66b6 = /*#__PURE__*/ Object.freeze({
    entering: "opening",
    entered: "open",
    exiting: "closing",
    exited: "closed"
});
var $8582129499aad1e8$export$f8d144aafbd3a470 = "absolute";
var $8582129499aad1e8$export$a5a9d7469a9cc520 = "presentation";
var $8582129499aad1e8$export$3e982710469daaf = "menuitem";
var $8582129499aad1e8$export$988a172bcdaead26 = {
    "aria-hidden": true,
    role: $8582129499aad1e8$export$3e982710469daaf
};


var $78abf5b0212be3bf$export$b286f91cddfedb5a = function(param) {
    var className = param.className, containerRef = param.containerRef, containerProps = param.containerProps, children = param.children, isOpen = param.isOpen, theming = param.theming, transition = param.transition, onClose = param.onClose;
    var itemTransition = (0, $e352c376e0aff571$export$d5639c01d489b0c)(transition, "item");
    var onKeyDown = function(param) {
        var key = param.key;
        switch(key){
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).ESC:
                (0, $e352c376e0aff571$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $8582129499aad1e8$export$8fd8df51a9b835e6).CANCEL
                });
                break;
        }
    };
    var onBlur = function(e) {
        if (isOpen && !e.currentTarget.contains(e.relatedTarget)) (0, $e352c376e0aff571$export$175e60bb96229ece)(onClose, {
            reason: (0, $8582129499aad1e8$export$8fd8df51a9b835e6).BLUR
        });
    };
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, (0, $e352c376e0aff571$export$9d1611c77c2fe928)({
        onKeyDown: onKeyDown,
        onBlur: onBlur
    }, containerProps)), {
        className: (0, $370568074483fa2d$export$7ae630fe844fbd1f)({
            block: (0, $8582129499aad1e8$export$ccf052fa53df1929),
            modifiers: (0, $eHaBZ.useMemo)(function() {
                return {
                    theme: theming,
                    itemTransition: itemTransition
                };
            }, [
                theming,
                itemTransition
            ]),
            className: className
        }),
        style: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
            position: "absolute"
        }, containerProps == null ? void 0 : containerProps.style),
        ref: containerRef,
        children: children
    }));
};



var $25eb87944aca3f1e$export$fd76cd1ffdc0d698 = function() {
    var timer, count = 0;
    return {
        toggle: function(isOpen) {
            isOpen ? count++ : count--;
            count = Math.max(count, 0);
        },
        on: function(closeDelay, pending, settled) {
            if (count) {
                if (!timer) timer = setTimeout(function() {
                    timer = 0;
                    pending();
                }, closeDelay);
            } else settled == null || settled();
        },
        off: function() {
            if (timer) {
                clearTimeout(timer);
                timer = 0;
            }
        }
    };
};





var $eHaBZ = parcelRequire("eHaBZ");


var $f2aef6f7a6d79b0a$export$7bfdd97581ca93c = function(menuRef, focusRef) {
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(), 2), hoverItem = _useState[0], setHoverItem = _useState[1];
    var stateRef = (0, $eHaBZ.useRef)({
        items: [],
        hoverIndex: -1,
        sorted: false
    });
    var mutableState = stateRef.current;
    var updateItems = (0, $eHaBZ.useCallback)(function(item, isMounted) {
        var items = mutableState.items;
        if (!item) mutableState.items = [];
        else if (isMounted) items.push(item);
        else {
            var index = items.indexOf(item);
            if (index > -1) {
                items.splice(index, 1);
                if (item.contains(document.activeElement)) {
                    focusRef.current.focus();
                    setHoverItem();
                }
            }
        }
        mutableState.hoverIndex = -1;
        mutableState.sorted = false;
    }, [
        mutableState,
        focusRef
    ]);
    var dispatch = (0, $eHaBZ.useCallback)(function(actionType, item, nextIndex) {
        var items = mutableState.items, hoverIndex = mutableState.hoverIndex;
        var sortItems = function() {
            if (mutableState.sorted) return;
            var orderedNodes = menuRef.current.querySelectorAll(".szh-menu__item");
            items.sort(function(a, b) {
                return (0, $e352c376e0aff571$export$a12bd5aaf0b59fa0)(orderedNodes, a) - (0, $e352c376e0aff571$export$a12bd5aaf0b59fa0)(orderedNodes, b);
            });
            mutableState.sorted = true;
        };
        var index = -1, newItem = undefined;
        switch(actionType){
            case (0, $8582129499aad1e8$export$6db955af9e6f8fcd).RESET:
                break;
            case (0, $8582129499aad1e8$export$6db955af9e6f8fcd).SET:
                newItem = item;
                break;
            case (0, $8582129499aad1e8$export$6db955af9e6f8fcd).UNSET:
                newItem = function(prevItem) {
                    return prevItem === item ? undefined : prevItem;
                };
                break;
            case (0, $8582129499aad1e8$export$6db955af9e6f8fcd).FIRST:
                sortItems();
                index = 0;
                newItem = items[index];
                break;
            case (0, $8582129499aad1e8$export$6db955af9e6f8fcd).LAST:
                sortItems();
                index = items.length - 1;
                newItem = items[index];
                break;
            case (0, $8582129499aad1e8$export$6db955af9e6f8fcd).SET_INDEX:
                sortItems();
                index = nextIndex;
                newItem = items[index];
                break;
            case (0, $8582129499aad1e8$export$6db955af9e6f8fcd).INCREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index++;
                if (index >= items.length) index = 0;
                newItem = items[index];
                break;
            case (0, $8582129499aad1e8$export$6db955af9e6f8fcd).DECREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index--;
                if (index < 0) index = items.length - 1;
                newItem = items[index];
                break;
            default:
        }
        if (!newItem) index = -1;
        setHoverItem(newItem);
        mutableState.hoverIndex = index;
    }, [
        menuRef,
        mutableState
    ]);
    return {
        hoverItem: hoverItem,
        dispatch: dispatch,
        updateItems: updateItems
    };
};




var $de396a1ce69702c3$export$62e2806a96b09d4 = function(containerRef, menuRef, menuScroll, boundingBoxPadding) {
    var menuRect = menuRef.current.getBoundingClientRect();
    var containerRect = containerRef.current.getBoundingClientRect();
    var boundingRect = menuScroll === window ? {
        left: 0,
        top: 0,
        right: document.documentElement.clientWidth,
        bottom: window.innerHeight
    } : menuScroll.getBoundingClientRect();
    var padding = (0, $e352c376e0aff571$export$4bc3c325941e6f67)(boundingBoxPadding);
    var getLeftOverflow = function(x) {
        return x + containerRect.left - boundingRect.left - padding.left;
    };
    var getRightOverflow = function(x) {
        return x + containerRect.left + menuRect.width - boundingRect.right + padding.right;
    };
    var getTopOverflow = function(y) {
        return y + containerRect.top - boundingRect.top - padding.top;
    };
    var getBottomOverflow = function(y) {
        return y + containerRect.top + menuRect.height - boundingRect.bottom + padding.bottom;
    };
    var confineHorizontally = function(x) {
        var leftOverflow = getLeftOverflow(x);
        if (leftOverflow < 0) x -= leftOverflow;
        else {
            var rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                x -= rightOverflow;
                leftOverflow = getLeftOverflow(x);
                if (leftOverflow < 0) x -= leftOverflow;
            }
        }
        return x;
    };
    var confineVertically = function(y) {
        var topOverflow = getTopOverflow(y);
        if (topOverflow < 0) y -= topOverflow;
        else {
            var bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                y -= bottomOverflow;
                topOverflow = getTopOverflow(y);
                if (topOverflow < 0) y -= topOverflow;
            }
        }
        return y;
    };
    return {
        menuRect: menuRect,
        containerRect: containerRect,
        getLeftOverflow: getLeftOverflow,
        getRightOverflow: getRightOverflow,
        getTopOverflow: getTopOverflow,
        getBottomOverflow: getBottomOverflow,
        confineHorizontally: confineHorizontally,
        confineVertically: confineVertically
    };
};




var $96179909425069ab$export$95257ec7631d2e00 = function(param) {
    var arrowRef = param.arrowRef, menuY = param.menuY, anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect;
    var y = anchorRect.top - containerRect.top - menuY + anchorRect.height / 2;
    var offset = arrowRef.current.offsetHeight * 1.25;
    y = Math.max(offset, y);
    y = Math.min(y, menuRect.height - offset);
    return y;
};


var $f067b03c6bc52e18$export$f768fc0fa8f5878e = function(param) {
    var anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect, placeLeftorRightY = param.placeLeftorRightY, placeLeftX = param.placeLeftX, placeRightX = param.placeRightX, getLeftOverflow = param.getLeftOverflow, getRightOverflow = param.getRightOverflow, confineHorizontally = param.confineHorizontally, confineVertically = param.confineVertically, arrowRef = param.arrowRef, arrow = param.arrow, direction = param.direction, position = param.position;
    var computedDirection = direction;
    var y = placeLeftorRightY;
    if (position !== "initial") {
        y = confineVertically(y);
        if (position === "anchor") {
            y = Math.min(y, anchorRect.bottom - containerRect.top);
            y = Math.max(y, anchorRect.top - containerRect.top - menuRect.height);
        }
    }
    var x, leftOverflow, rightOverflow;
    if (computedDirection === "left") {
        x = placeLeftX;
        if (position !== "initial") {
            leftOverflow = getLeftOverflow(x);
            if (leftOverflow < 0) {
                rightOverflow = getRightOverflow(placeRightX);
                if (rightOverflow <= 0 || -leftOverflow > rightOverflow) {
                    x = placeRightX;
                    computedDirection = "right";
                }
            }
        }
    } else {
        x = placeRightX;
        if (position !== "initial") {
            rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                leftOverflow = getLeftOverflow(placeLeftX);
                if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
                    x = placeLeftX;
                    computedDirection = "left";
                }
            }
        }
    }
    if (position === "auto") x = confineHorizontally(x);
    var arrowY = arrow ? (0, $96179909425069ab$export$95257ec7631d2e00)({
        menuY: y,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowY: arrowY,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


var $ae04babf0fb29f98$export$4c9b3bcc0c46b8d3 = function(param) {
    var arrowRef = param.arrowRef, menuX = param.menuX, anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect;
    var x = anchorRect.left - containerRect.left - menuX + anchorRect.width / 2;
    var offset = arrowRef.current.offsetWidth * 1.25;
    x = Math.max(offset, x);
    x = Math.min(x, menuRect.width - offset);
    return x;
};


var $8701c5f0e0ade6fa$export$65848579d307fa3f = function(param) {
    var anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect, placeToporBottomX = param.placeToporBottomX, placeTopY = param.placeTopY, placeBottomY = param.placeBottomY, getTopOverflow = param.getTopOverflow, getBottomOverflow = param.getBottomOverflow, confineHorizontally = param.confineHorizontally, confineVertically = param.confineVertically, arrowRef = param.arrowRef, arrow = param.arrow, direction = param.direction, position = param.position;
    var computedDirection = direction === "top" ? "top" : "bottom";
    var x = placeToporBottomX;
    if (position !== "initial") {
        x = confineHorizontally(x);
        if (position === "anchor") {
            x = Math.min(x, anchorRect.right - containerRect.left);
            x = Math.max(x, anchorRect.left - containerRect.left - menuRect.width);
        }
    }
    var y, topOverflow, bottomOverflow;
    if (computedDirection === "top") {
        y = placeTopY;
        if (position !== "initial") {
            topOverflow = getTopOverflow(y);
            if (topOverflow < 0) {
                bottomOverflow = getBottomOverflow(placeBottomY);
                if (bottomOverflow <= 0 || -topOverflow > bottomOverflow) {
                    y = placeBottomY;
                    computedDirection = "bottom";
                }
            }
        }
    } else {
        y = placeBottomY;
        if (position !== "initial") {
            bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                topOverflow = getTopOverflow(placeTopY);
                if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
                    y = placeTopY;
                    computedDirection = "top";
                }
            }
        }
    }
    if (position === "auto") y = confineVertically(y);
    var arrowX = arrow ? (0, $ae04babf0fb29f98$export$4c9b3bcc0c46b8d3)({
        menuX: x,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowX: arrowX,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


var $ee66ebf559d4953b$export$5a6e2d3543ff3d7e = function(param) {
    var arrow = param.arrow, align = param.align, direction = param.direction, gap = param.gap, shift = param.shift, position = param.position, anchorRect = param.anchorRect, arrowRef = param.arrowRef, positionHelpers = param.positionHelpers;
    var menuRect = positionHelpers.menuRect, containerRect = positionHelpers.containerRect;
    var isHorizontal = direction === "left" || direction === "right";
    var horizontalOffset = isHorizontal ? gap : shift;
    var verticalOffset = isHorizontal ? shift : gap;
    if (arrow) {
        var arrowElt = arrowRef.current;
        if (isHorizontal) horizontalOffset += arrowElt.offsetWidth;
        else verticalOffset += arrowElt.offsetHeight;
    }
    var placeLeftX = anchorRect.left - containerRect.left - menuRect.width - horizontalOffset;
    var placeRightX = anchorRect.right - containerRect.left + horizontalOffset;
    var placeTopY = anchorRect.top - containerRect.top - menuRect.height - verticalOffset;
    var placeBottomY = anchorRect.bottom - containerRect.top + verticalOffset;
    var placeToporBottomX, placeLeftorRightY;
    if (align === "end") {
        placeToporBottomX = anchorRect.right - containerRect.left - menuRect.width;
        placeLeftorRightY = anchorRect.bottom - containerRect.top - menuRect.height;
    } else if (align === "center") {
        placeToporBottomX = anchorRect.left - containerRect.left - (menuRect.width - anchorRect.width) / 2;
        placeLeftorRightY = anchorRect.top - containerRect.top - (menuRect.height - anchorRect.height) / 2;
    } else {
        placeToporBottomX = anchorRect.left - containerRect.left;
        placeLeftorRightY = anchorRect.top - containerRect.top;
    }
    placeToporBottomX += horizontalOffset;
    placeLeftorRightY += verticalOffset;
    var options = (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, positionHelpers), {
        anchorRect: anchorRect,
        placeLeftX: placeLeftX,
        placeRightX: placeRightX,
        placeLeftorRightY: placeLeftorRightY,
        placeTopY: placeTopY,
        placeBottomY: placeBottomY,
        placeToporBottomX: placeToporBottomX,
        arrowRef: arrowRef,
        arrow: arrow,
        direction: direction,
        position: position
    });
    switch(direction){
        case "left":
        case "right":
            return (0, $f067b03c6bc52e18$export$f768fc0fa8f5878e)(options);
        case "top":
        case "bottom":
        default:
            return (0, $8701c5f0e0ade6fa$export$65848579d307fa3f)(options);
    }
};



var $eHaBZ = parcelRequire("eHaBZ");
var $a8b919922d1a2d78$export$e5c5a5f917a5871c = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $eHaBZ.useLayoutEffect) : (0, $eHaBZ.useEffect);




var $eHaBZ = parcelRequire("eHaBZ");
function $c38ebdac3c379752$var$setRef(ref, instance) {
    typeof ref === "function" ? ref(instance) : ref.current = instance;
}
var $c38ebdac3c379752$export$2d8be4568b07be94 = function(refA, refB) {
    return (0, $eHaBZ.useMemo)(function() {
        if (!refA) return refB;
        if (!refB) return refA;
        return function(instance) {
            $c38ebdac3c379752$var$setRef(refA, instance);
            $c38ebdac3c379752$var$setRef(refB, instance);
        };
    }, [
        refA,
        refB
    ]);
};


var $8e34748411cc095a$var$offScreen = -9999;
var $8e34748411cc095a$export$d4c4e98c5044dc8 = function(_param) {
    var ariaLabel = _param.ariaLabel, menuClassName = _param.menuClassName, menuStyle = _param.menuStyle, arrow = _param.arrow, _param_arrowProps = _param.arrowProps, arrowProps = _param_arrowProps === void 0 ? {} : _param_arrowProps, anchorPoint = _param.anchorPoint, anchorRef = _param.anchorRef, containerRef = _param.containerRef, containerProps = _param.containerProps, focusProps = _param.focusProps, externalRef = _param.externalRef, parentScrollingRef = _param.parentScrollingRef, _param_align = _param.align, align = _param_align === void 0 ? "start" : _param_align, _param_direction = _param.direction, direction = _param_direction === void 0 ? "bottom" : _param_direction, _param_position = _param.position, position = _param_position === void 0 ? "auto" : _param_position, _param_overflow = _param.overflow, overflow = _param_overflow === void 0 ? "visible" : _param_overflow, setDownOverflow = _param.setDownOverflow, repositionFlag = _param.repositionFlag, _param_captureFocus = _param.captureFocus, captureFocus = _param_captureFocus === void 0 ? true : _param_captureFocus, state = _param.state, endTransition = _param.endTransition, isDisabled = _param.isDisabled, menuItemFocus = _param.menuItemFocus, _param_gap = _param.gap, gap = _param_gap === void 0 ? 0 : _param_gap, _param_shift = _param.shift, shift = _param_shift === void 0 ? 0 : _param_shift, children = _param.children, onClose = _param.onClose, restProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "ariaLabel",
        "menuClassName",
        "menuStyle",
        "arrow",
        "arrowProps",
        "anchorPoint",
        "anchorRef",
        "containerRef",
        "containerProps",
        "focusProps",
        "externalRef",
        "parentScrollingRef",
        "align",
        "direction",
        "position",
        "overflow",
        "setDownOverflow",
        "repositionFlag",
        "captureFocus",
        "state",
        "endTransition",
        "isDisabled",
        "menuItemFocus",
        "gap",
        "shift",
        "children",
        "onClose"
    ]);
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)({
        x: $8e34748411cc095a$var$offScreen,
        y: $8e34748411cc095a$var$offScreen
    }), 2), menuPosition = _useState[0], setMenuPosition = _useState[1];
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)({}), 2), arrowPosition = _useState1[0], setArrowPosition = _useState1[1];
    var _useState2 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(), 2), overflowData = _useState2[0], setOverflowData = _useState2[1];
    var _useState3 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(direction), 2), expandedDirection = _useState3[0], setExpandedDirection = _useState3[1];
    var _useState4 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)((0, $25eb87944aca3f1e$export$fd76cd1ffdc0d698)), 1), submenuCtx = _useState4[0];
    var _useReducer = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useReducer)(function(c) {
        return c + 1;
    }, 1), 2), reposSubmenu = _useReducer[0], forceReposSubmenu = _useReducer[1];
    var _useContext = (0, $eHaBZ.useContext)((0, $8582129499aad1e8$export$8fa45c82eddfe270)), transition = _useContext.transition, boundingBoxRef = _useContext.boundingBoxRef, boundingBoxPadding = _useContext.boundingBoxPadding, rootMenuRef = _useContext.rootMenuRef, rootAnchorRef = _useContext.rootAnchorRef, scrollNodesRef = _useContext.scrollNodesRef, reposition = _useContext.reposition, viewScroll = _useContext.viewScroll, submenuCloseDelay = _useContext.submenuCloseDelay;
    var _useContext1 = (0, $eHaBZ.useContext)((0, $8582129499aad1e8$export$1c2bdfb4407fdacf)), parentSubmenuCtx = _useContext1.submenuCtx, tmp = _useContext1.reposSubmenu, reposFlag = tmp === void 0 ? repositionFlag : tmp;
    var menuRef = (0, $eHaBZ.useRef)(null);
    var focusRef = (0, $eHaBZ.useRef)();
    var arrowRef = (0, $eHaBZ.useRef)();
    var prevOpen = (0, $eHaBZ.useRef)(false);
    var latestMenuSize = (0, $eHaBZ.useRef)({
        width: 0,
        height: 0
    });
    var latestHandlePosition = (0, $eHaBZ.useRef)(function() {});
    var _useItems = (0, $f2aef6f7a6d79b0a$export$7bfdd97581ca93c)(menuRef, focusRef), hoverItem = _useItems.hoverItem, dispatch = _useItems.dispatch, updateItems = _useItems.updateItems;
    var isOpen = (0, $e352c376e0aff571$export$30c2dce1a652e248)(state);
    var openTransition = (0, $e352c376e0aff571$export$d5639c01d489b0c)(transition, "open");
    var closeTransition = (0, $e352c376e0aff571$export$d5639c01d489b0c)(transition, "close");
    var scrollNodes = scrollNodesRef.current;
    var onKeyDown = function(e) {
        switch(e.key){
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).HOME:
                dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).FIRST);
                break;
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).END:
                dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).LAST);
                break;
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).UP:
                dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).DECREASE, hoverItem);
                break;
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).DOWN:
                dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).INCREASE, hoverItem);
                break;
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).SPACE:
                if (e.target && e.target.className.indexOf((0, $8582129499aad1e8$export$832250593589325a)) !== -1) e.preventDefault();
                return;
            default:
                return;
        }
        e.preventDefault();
        e.stopPropagation();
    };
    var onAnimationEnd = function() {
        if (state === "closing") setOverflowData();
        (0, $e352c376e0aff571$export$175e60bb96229ece)(endTransition);
    };
    var onPointerMove = function(e) {
        e.stopPropagation();
        submenuCtx.on(submenuCloseDelay, function() {
            dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).RESET);
            focusRef.current.focus();
        });
    };
    var onPointerLeave = function(e) {
        if (e.target === e.currentTarget) submenuCtx.off();
    };
    var handlePosition = (0, $eHaBZ.useCallback)(function(noOverflowCheck) {
        var _anchorRef$current;
        var anchorRect = anchorRef ? (_anchorRef$current = anchorRef.current) == null ? void 0 : _anchorRef$current.getBoundingClientRect() : anchorPoint ? {
            left: anchorPoint.x,
            right: anchorPoint.x,
            top: anchorPoint.y,
            bottom: anchorPoint.y,
            width: 0,
            height: 0
        } : null;
        if (!anchorRect) return;
        if (!scrollNodes.menu) scrollNodes.menu = (boundingBoxRef ? boundingBoxRef.current : (0, $e352c376e0aff571$export$7414735161c19437)(rootMenuRef.current)) || window;
        var positionHelpers = (0, $de396a1ce69702c3$export$62e2806a96b09d4)(containerRef, menuRef, scrollNodes.menu, boundingBoxPadding);
        var _positionMenu = (0, $ee66ebf559d4953b$export$5a6e2d3543ff3d7e)({
            arrow: arrow,
            align: align,
            direction: direction,
            gap: gap,
            shift: shift,
            position: position,
            anchorRect: anchorRect,
            arrowRef: arrowRef,
            positionHelpers: positionHelpers
        }), arrowX = _positionMenu.arrowX, arrowY = _positionMenu.arrowY, x = _positionMenu.x, y = _positionMenu.y, computedDirection = _positionMenu.computedDirection;
        var menuRect = positionHelpers.menuRect;
        var menuHeight = menuRect.height;
        if (!noOverflowCheck && overflow !== "visible") {
            var getTopOverflow = positionHelpers.getTopOverflow, getBottomOverflow = positionHelpers.getBottomOverflow;
            var height, overflowAmt;
            var prevHeight = latestMenuSize.current.height;
            var bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0 || (0, $e352c376e0aff571$export$de749ee021c3ab62)(bottomOverflow, 0) && (0, $e352c376e0aff571$export$de749ee021c3ab62)(menuHeight, prevHeight)) {
                height = menuHeight - bottomOverflow;
                overflowAmt = bottomOverflow;
            } else {
                var topOverflow = getTopOverflow(y);
                if (topOverflow < 0 || (0, $e352c376e0aff571$export$de749ee021c3ab62)(topOverflow, 0) && (0, $e352c376e0aff571$export$de749ee021c3ab62)(menuHeight, prevHeight)) {
                    height = menuHeight + topOverflow;
                    overflowAmt = 0 - topOverflow;
                    if (height >= 0) y -= topOverflow;
                }
            }
            if (height >= 0) {
                menuHeight = height;
                setOverflowData({
                    height: height,
                    overflowAmt: overflowAmt
                });
            } else setOverflowData();
        }
        if (arrow) setArrowPosition({
            x: arrowX,
            y: arrowY
        });
        setMenuPosition({
            x: x,
            y: y
        });
        setExpandedDirection(computedDirection);
        latestMenuSize.current = {
            width: menuRect.width,
            height: menuHeight
        };
    }, [
        arrow,
        align,
        boundingBoxPadding,
        direction,
        gap,
        shift,
        position,
        overflow,
        anchorPoint,
        anchorRef,
        containerRef,
        boundingBoxRef,
        rootMenuRef,
        scrollNodes
    ]);
    (0, $a8b919922d1a2d78$export$e5c5a5f917a5871c)(function() {
        if (isOpen) {
            handlePosition();
            if (prevOpen.current) forceReposSubmenu();
        }
        prevOpen.current = isOpen;
        latestHandlePosition.current = handlePosition;
    }, [
        isOpen,
        handlePosition,
        reposFlag
    ]);
    (0, $a8b919922d1a2d78$export$e5c5a5f917a5871c)(function() {
        if (overflowData && !setDownOverflow) menuRef.current.scrollTop = 0;
    }, [
        overflowData,
        setDownOverflow
    ]);
    (0, $a8b919922d1a2d78$export$e5c5a5f917a5871c)(function() {
        return updateItems;
    }, [
        updateItems
    ]);
    (0, $eHaBZ.useEffect)(function() {
        var menuScroll = scrollNodes.menu;
        if (!isOpen || !menuScroll) return;
        menuScroll = menuScroll.addEventListener ? menuScroll : window;
        if (!scrollNodes.anchors) {
            scrollNodes.anchors = [];
            var anchorScroll = (0, $e352c376e0aff571$export$7414735161c19437)(rootAnchorRef && rootAnchorRef.current);
            while(anchorScroll && anchorScroll !== menuScroll){
                scrollNodes.anchors.push(anchorScroll);
                anchorScroll = (0, $e352c376e0aff571$export$7414735161c19437)(anchorScroll);
            }
        }
        var scroll = viewScroll;
        if (scrollNodes.anchors.length && scroll === "initial") scroll = "auto";
        if (scroll === "initial") return;
        var handleScroll = function() {
            if (scroll === "auto") (0, $e352c376e0aff571$export$3e3e6d241f8feb60)(function() {
                return handlePosition(true);
            });
            else (0, $e352c376e0aff571$export$175e60bb96229ece)(onClose, {
                reason: (0, $8582129499aad1e8$export$8fd8df51a9b835e6).SCROLL
            });
        };
        var scrollObservers = scrollNodes.anchors.concat(viewScroll !== "initial" ? menuScroll : []);
        scrollObservers.forEach(function(o) {
            return o.addEventListener("scroll", handleScroll);
        });
        return function() {
            return scrollObservers.forEach(function(o) {
                return o.removeEventListener("scroll", handleScroll);
            });
        };
    }, [
        rootAnchorRef,
        scrollNodes,
        isOpen,
        onClose,
        viewScroll,
        handlePosition
    ]);
    var hasOverflow = !!overflowData && overflowData.overflowAmt > 0;
    (0, $eHaBZ.useEffect)(function() {
        if (hasOverflow || !isOpen || !parentScrollingRef) return;
        var handleScroll = function() {
            return (0, $e352c376e0aff571$export$3e3e6d241f8feb60)(handlePosition);
        };
        var parentScroll = parentScrollingRef.current;
        parentScroll.addEventListener("scroll", handleScroll);
        return function() {
            return parentScroll.removeEventListener("scroll", handleScroll);
        };
    }, [
        isOpen,
        hasOverflow,
        parentScrollingRef,
        handlePosition
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof ResizeObserver !== "function" || reposition === "initial") return;
        var resizeObserver = new ResizeObserver(function(param) {
            var _$_param = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(param, 1), entry = _$_param[0];
            var borderBoxSize = entry.borderBoxSize, target = entry.target;
            var width, height;
            if (borderBoxSize) {
                var _ref = borderBoxSize[0] || borderBoxSize, inlineSize = _ref.inlineSize, blockSize = _ref.blockSize;
                width = inlineSize;
                height = blockSize;
            } else {
                var borderRect = target.getBoundingClientRect();
                width = borderRect.width;
                height = borderRect.height;
            }
            if (width === 0 || height === 0) return;
            if ((0, $e352c376e0aff571$export$de749ee021c3ab62)(width, latestMenuSize.current.width, 1) && (0, $e352c376e0aff571$export$de749ee021c3ab62)(height, latestMenuSize.current.height, 1)) return;
            (0, $8afcda7f6e55ccf7$exports.flushSync)(function() {
                latestHandlePosition.current();
                forceReposSubmenu();
            });
        });
        var observeTarget = menuRef.current;
        resizeObserver.observe(observeTarget, {
            box: "border-box"
        });
        return function() {
            return resizeObserver.unobserve(observeTarget);
        };
    }, [
        reposition
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isOpen) {
            dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).RESET);
            if (!closeTransition) setOverflowData();
            return;
        }
        var _ref = menuItemFocus || {}, position = _ref.position, alwaysUpdate = _ref.alwaysUpdate;
        var setItemFocus = function() {
            if (position === (0, $8582129499aad1e8$export$8c6ccba1b6ce32e9).FIRST) dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).FIRST);
            else if (position === (0, $8582129499aad1e8$export$8c6ccba1b6ce32e9).LAST) dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).LAST);
            else if (position >= -1) dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).SET_INDEX, undefined, position);
        };
        if (alwaysUpdate) setItemFocus();
        else if (captureFocus) {
            var id = setTimeout(function() {
                var menuElt = menuRef.current;
                if (menuElt && !menuElt.contains(document.activeElement)) {
                    focusRef.current.focus();
                    setItemFocus();
                }
            }, openTransition ? 170 : 100);
            return function() {
                return clearTimeout(id);
            };
        }
    }, [
        isOpen,
        openTransition,
        closeTransition,
        captureFocus,
        menuItemFocus,
        dispatch
    ]);
    var itemContext = (0, $eHaBZ.useMemo)(function() {
        return {
            isParentOpen: isOpen,
            submenuCtx: submenuCtx,
            dispatch: dispatch,
            updateItems: updateItems
        };
    }, [
        isOpen,
        submenuCtx,
        dispatch,
        updateItems
    ]);
    var maxHeight, overflowAmt;
    if (overflowData) setDownOverflow ? overflowAmt = overflowData.overflowAmt : maxHeight = overflowData.height;
    var listContext = (0, $eHaBZ.useMemo)(function() {
        return {
            reposSubmenu: reposSubmenu,
            submenuCtx: submenuCtx,
            overflow: overflow,
            overflowAmt: overflowAmt,
            parentMenuRef: menuRef,
            parentDir: expandedDirection
        };
    }, [
        reposSubmenu,
        submenuCtx,
        overflow,
        overflowAmt,
        expandedDirection
    ]);
    var overflowStyle = maxHeight >= 0 ? {
        maxHeight: maxHeight,
        overflow: overflow
    } : undefined;
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            state: state,
            dir: expandedDirection
        };
    }, [
        state,
        expandedDirection
    ]);
    var arrowModifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            dir: expandedDirection
        };
    }, [
        expandedDirection
    ]);
    var _arrowClassName = (0, $370568074483fa2d$export$7ae630fe844fbd1f)({
        block: (0, $8582129499aad1e8$export$832250593589325a),
        element: (0, $8582129499aad1e8$export$3b35f0f35c840df9),
        modifiers: arrowModifiers,
        className: arrowProps.className
    });
    var menu = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        role: "menu",
        "aria-label": ariaLabel
    }, (0, $e352c376e0aff571$export$ffb2d5922287e12)(isDisabled), (0, $e352c376e0aff571$export$9d1611c77c2fe928)({
        onPointerEnter: parentSubmenuCtx == null ? void 0 : parentSubmenuCtx.off,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerLeave,
        onKeyDown: onKeyDown,
        onAnimationEnd: onAnimationEnd
    }, restProps)), {
        ref: (0, $c38ebdac3c379752$export$2d8be4568b07be94)(externalRef, menuRef),
        className: (0, $370568074483fa2d$export$7ae630fe844fbd1f)({
            block: (0, $8582129499aad1e8$export$832250593589325a),
            modifiers: modifiers,
            className: menuClassName
        }),
        style: (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, menuStyle, overflowStyle), {
            margin: 0,
            display: state === "closed" ? "none" : undefined,
            position: (0, $8582129499aad1e8$export$f8d144aafbd3a470),
            left: menuPosition.x,
            top: menuPosition.y
        }),
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
                tabIndex: -1,
                style: {
                    position: (0, $8582129499aad1e8$export$f8d144aafbd3a470),
                    left: 0,
                    top: 0,
                    display: "block",
                    outline: "none"
                },
                ref: focusRef
            }, (0, $8582129499aad1e8$export$988a172bcdaead26), focusProps)),
            arrow && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, (0, $8582129499aad1e8$export$988a172bcdaead26), arrowProps), {
                className: _arrowClassName,
                style: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
                    display: "block",
                    position: (0, $8582129499aad1e8$export$f8d144aafbd3a470),
                    left: arrowPosition.x,
                    top: arrowPosition.y
                }, arrowProps.style),
                ref: arrowRef
            })),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8582129499aad1e8$export$1c2bdfb4407fdacf).Provider, {
                value: listContext,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8582129499aad1e8$export$7cb023214e4bda1e).Provider, {
                    value: itemContext,
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8582129499aad1e8$export$15c1690330cd94e).Provider, {
                        value: hoverItem,
                        children: (0, $e352c376e0aff571$export$175e60bb96229ece)(children, modifiers)
                    })
                })
            })
        ]
    }));
    return containerProps ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $78abf5b0212be3bf$export$b286f91cddfedb5a), (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, containerProps), {
        isOpen: isOpen,
        children: menu
    })) : menu;
};






var $4f2f557029cf5aa9$export$a5a70f2f059d02ee = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function ControlledMenu(_param, externalRef) {
    var ariaLabel = _param["aria-label"], className = _param.className, containerProps = _param.containerProps, initialMounted = _param.initialMounted, unmountOnClose = _param.unmountOnClose, transition = _param.transition, transitionTimeout = _param.transitionTimeout, boundingBoxRef = _param.boundingBoxRef, boundingBoxPadding = _param.boundingBoxPadding, _param_reposition = _param.reposition, reposition = _param_reposition === void 0 ? "auto" : _param_reposition, _param_submenuOpenDelay = _param.submenuOpenDelay, submenuOpenDelay = _param_submenuOpenDelay === void 0 ? 300 : _param_submenuOpenDelay, _param_submenuCloseDelay = _param.submenuCloseDelay, submenuCloseDelay = _param_submenuCloseDelay === void 0 ? 150 : _param_submenuCloseDelay, _param_viewScroll = _param.viewScroll, viewScroll = _param_viewScroll === void 0 ? "initial" : _param_viewScroll, portal = _param.portal, theming = _param.theming, onItemClick = _param.onItemClick, restProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "aria-label",
        "className",
        "containerProps",
        "initialMounted",
        "unmountOnClose",
        "transition",
        "transitionTimeout",
        "boundingBoxRef",
        "boundingBoxPadding",
        "reposition",
        "submenuOpenDelay",
        "submenuCloseDelay",
        "viewScroll",
        "portal",
        "theming",
        "onItemClick"
    ]);
    var containerRef = (0, $eHaBZ.useRef)(null);
    var scrollNodesRef = (0, $eHaBZ.useRef)({});
    var anchorRef = restProps.anchorRef, state = restProps.state, onClose = restProps.onClose;
    var settings = (0, $eHaBZ.useMemo)(function() {
        return {
            initialMounted: initialMounted,
            unmountOnClose: unmountOnClose,
            transition: transition,
            transitionTimeout: transitionTimeout,
            boundingBoxRef: boundingBoxRef,
            boundingBoxPadding: boundingBoxPadding,
            rootMenuRef: containerRef,
            rootAnchorRef: anchorRef,
            scrollNodesRef: scrollNodesRef,
            reposition: reposition,
            viewScroll: viewScroll,
            submenuOpenDelay: submenuOpenDelay,
            submenuCloseDelay: submenuCloseDelay
        };
    }, [
        initialMounted,
        unmountOnClose,
        transition,
        transitionTimeout,
        anchorRef,
        boundingBoxRef,
        boundingBoxPadding,
        reposition,
        viewScroll,
        submenuOpenDelay,
        submenuCloseDelay
    ]);
    var eventHandlers = (0, $eHaBZ.useMemo)(function() {
        return {
            handleClick: function(event, isCheckorRadio) {
                if (!event.stopPropagation) (0, $e352c376e0aff571$export$175e60bb96229ece)(onItemClick, event);
                var keepOpen = event.keepOpen;
                if (keepOpen === undefined) keepOpen = isCheckorRadio && event.key === (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).SPACE;
                if (!keepOpen) (0, $e352c376e0aff571$export$175e60bb96229ece)(onClose, {
                    value: event.value,
                    key: event.key,
                    reason: (0, $8582129499aad1e8$export$8fd8df51a9b835e6).CLICK
                });
            },
            handleClose: function(key) {
                (0, $e352c376e0aff571$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $8582129499aad1e8$export$8fd8df51a9b835e6).CLICK
                });
            }
        };
    }, [
        onItemClick,
        onClose
    ]);
    if (!state) return null;
    var menuList = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8582129499aad1e8$export$8fa45c82eddfe270).Provider, {
        value: settings,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8582129499aad1e8$export$ee9f2ec6c8119c2a).Provider, {
            value: eventHandlers,
            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8e34748411cc095a$export$d4c4e98c5044dc8), (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, restProps), {
                ariaLabel: ariaLabel || "Menu",
                externalRef: externalRef,
                containerRef: containerRef,
                containerProps: {
                    className: className,
                    containerRef: containerRef,
                    containerProps: containerProps,
                    theming: theming,
                    transition: transition,
                    onClose: onClose
                }
            }))
        })
    });
    if (portal === true && typeof document !== "undefined") return /*#__PURE__*/ (0, $8afcda7f6e55ccf7$exports.createPortal)(menuList, document.body);
    else if (portal) return portal.target ? /*#__PURE__*/ (0, $8afcda7f6e55ccf7$exports.createPortal)(menuList, portal.target) : portal.stablePosition ? null : menuList;
    return menuList;
});






var $eHaBZ = parcelRequire("eHaBZ");



var $eHaBZ = parcelRequire("eHaBZ");
var $d0e1680f42e557c3$export$3a9d054b510f1baf = 0;
var $d0e1680f42e557c3$export$df38205c966be359 = 1;
var $d0e1680f42e557c3$export$78e9e6e3e014d60a = 2;
var $d0e1680f42e557c3$export$6f37f73bf74e3970 = 3;
var $d0e1680f42e557c3$export$4aacc83d4d59139f = 4;
var $d0e1680f42e557c3$export$84cbff306f539230 = 5;
var $d0e1680f42e557c3$export$bb38bb9a1161268 = 6;
var $d0e1680f42e557c3$export$e50006273435e7d4 = [
    "preEnter",
    "entering",
    "entered",
    "preExit",
    "exiting",
    "exited",
    "unmounted"
];
var $d0e1680f42e557c3$export$50fdfeece43146fd = function(status) {
    return {
        _s: status,
        status: $d0e1680f42e557c3$export$e50006273435e7d4[status],
        isEnter: status < $d0e1680f42e557c3$export$6f37f73bf74e3970,
        isMounted: status !== $d0e1680f42e557c3$export$bb38bb9a1161268,
        isResolved: status === $d0e1680f42e557c3$export$78e9e6e3e014d60a || status > $d0e1680f42e557c3$export$4aacc83d4d59139f
    };
};
var $d0e1680f42e557c3$export$eb0971344425f03e = function(unmounted) {
    return unmounted ? $d0e1680f42e557c3$export$bb38bb9a1161268 : $d0e1680f42e557c3$export$84cbff306f539230;
};
var $d0e1680f42e557c3$export$c9efa50dd559122e = function(status, unmountOnExit) {
    switch(status){
        case $d0e1680f42e557c3$export$df38205c966be359:
        case $d0e1680f42e557c3$export$3a9d054b510f1baf:
            return $d0e1680f42e557c3$export$78e9e6e3e014d60a;
        case $d0e1680f42e557c3$export$4aacc83d4d59139f:
        case $d0e1680f42e557c3$export$6f37f73bf74e3970:
            return $d0e1680f42e557c3$export$eb0971344425f03e(unmountOnExit);
    }
};
var $d0e1680f42e557c3$export$d2e3f47e67110e3a = function(timeout) {
    return typeof timeout === "object" ? [
        timeout.enter,
        timeout.exit
    ] : [
        timeout,
        timeout
    ];
};
var $d0e1680f42e557c3$export$bdd553fddd433dcb = function(transitState, status) {
    return setTimeout(function() {
        // Reading document.body.offsetTop can force browser to repaint before transition to the next state
        isNaN(document.body.offsetTop) || transitState(status + 1);
    }, 0);
};


var $0e34f56b5fc11d1e$var$updateState = function(status, setState, latestState, timeoutId, onChange) {
    clearTimeout(timeoutId.current);
    var state = (0, $d0e1680f42e557c3$export$50fdfeece43146fd)(status);
    setState(state);
    latestState.current = state;
    onChange && onChange({
        current: state
    });
};
var $0e34f56b5fc11d1e$export$7b286972b8d8ccbf = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_enter = _ref.enter, enter = _ref_enter === void 0 ? true : _ref_enter, _ref_exit = _ref.exit, exit = _ref_exit === void 0 ? true : _ref_exit, preEnter = _ref.preEnter, preExit = _ref.preExit, timeout = _ref.timeout, initialEntered = _ref.initialEntered, mountOnEnter = _ref.mountOnEnter, unmountOnExit = _ref.unmountOnExit, onChange = _ref.onStateChange;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(function() {
        return (0, $d0e1680f42e557c3$export$50fdfeece43146fd)(initialEntered ? (0, $d0e1680f42e557c3$export$78e9e6e3e014d60a) : (0, $d0e1680f42e557c3$export$eb0971344425f03e)(mountOnEnter));
    }), 2), state = _useState[0], setState = _useState[1];
    var latestState = (0, $eHaBZ.useRef)(state);
    var timeoutId = (0, $eHaBZ.useRef)();
    var _getTimeout = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $d0e1680f42e557c3$export$d2e3f47e67110e3a)(timeout), 2), enterTimeout = _getTimeout[0], exitTimeout = _getTimeout[1];
    var endTransition = (0, $eHaBZ.useCallback)(function() {
        var status = (0, $d0e1680f42e557c3$export$c9efa50dd559122e)(latestState.current._s, unmountOnExit);
        status && $0e34f56b5fc11d1e$var$updateState(status, setState, latestState, timeoutId, onChange);
    }, [
        onChange,
        unmountOnExit
    ]);
    var toggle = (0, $eHaBZ.useCallback)(function(toEnter) {
        var transitState = function(status) {
            $0e34f56b5fc11d1e$var$updateState(status, setState, latestState, timeoutId, onChange);
            switch(status){
                case 0, $d0e1680f42e557c3$export$df38205c966be359:
                    if (enterTimeout >= 0) timeoutId.current = setTimeout(endTransition, enterTimeout);
                    break;
                case 0, $d0e1680f42e557c3$export$4aacc83d4d59139f:
                    if (exitTimeout >= 0) timeoutId.current = setTimeout(endTransition, exitTimeout);
                    break;
                case 0, $d0e1680f42e557c3$export$3a9d054b510f1baf:
                case 0, $d0e1680f42e557c3$export$6f37f73bf74e3970:
                    timeoutId.current = (0, $d0e1680f42e557c3$export$bdd553fddd433dcb)(transitState, status);
                    break;
            }
        };
        var enterStage = latestState.current.isEnter;
        if (typeof toEnter !== "boolean") toEnter = !enterStage;
        if (toEnter) !enterStage && transitState(enter ? preEnter ? (0, $d0e1680f42e557c3$export$3a9d054b510f1baf) : (0, $d0e1680f42e557c3$export$df38205c966be359) : (0, $d0e1680f42e557c3$export$78e9e6e3e014d60a));
        else enterStage && transitState(exit ? preExit ? (0, $d0e1680f42e557c3$export$6f37f73bf74e3970) : (0, $d0e1680f42e557c3$export$4aacc83d4d59139f) : (0, $d0e1680f42e557c3$export$eb0971344425f03e)(unmountOnExit));
    }, [
        endTransition,
        onChange,
        enter,
        exit,
        preEnter,
        preExit,
        enterTimeout,
        exitTimeout,
        unmountOnExit
    ]);
    (0, $eHaBZ.useEffect)(function() {
        return function() {
            return clearTimeout(timeoutId.current);
        };
    }, []);
    return [
        state,
        toggle,
        endTransition
    ];
};




var $0951921dfe1e8262$export$8091e3849c182a6 = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, initialOpen = _ref.initialOpen, initialMounted = _ref.initialMounted, unmountOnClose = _ref.unmountOnClose, transition = _ref.transition, _ref_transitionTimeout = _ref.transitionTimeout, transitionTimeout = _ref_transitionTimeout === void 0 ? 500 : _ref_transitionTimeout;
    var _useTransition = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $0e34f56b5fc11d1e$export$7b286972b8d8ccbf)({
        initialEntered: initialOpen,
        mountOnEnter: !initialMounted,
        unmountOnExit: unmountOnClose,
        timeout: transitionTimeout,
        enter: (0, $e352c376e0aff571$export$d5639c01d489b0c)(transition, "open"),
        exit: (0, $e352c376e0aff571$export$d5639c01d489b0c)(transition, "close")
    }), 3), status = _useTransition[0].status, toggleMenu = _useTransition[1], endTransition = _useTransition[2];
    return [
        {
            state: (0, $8582129499aad1e8$export$be1d8b0328ba66b6)[status],
            endTransition: endTransition
        },
        toggleMenu
    ];
};


var $ae26e7d217817bdf$export$1668883ac2d8e856 = function(options) {
    var _useMenuState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $0951921dfe1e8262$export$8091e3849c182a6)(options), 2), menuProps = _useMenuState[0], toggleMenu = _useMenuState[1];
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(), 2), menuItemFocus = _useState[0], setMenuItemFocus = _useState[1];
    var openMenu = function(position, alwaysUpdate) {
        setMenuItemFocus({
            position: position,
            alwaysUpdate: alwaysUpdate
        });
        toggleMenu(true);
    };
    return [
        (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
            menuItemFocus: menuItemFocus
        }, menuProps),
        toggleMenu,
        openMenu
    ];
};




var $eHaBZ = parcelRequire("eHaBZ");
var $9c4ef94082e6b0ed$export$98524f11226063fc = function(state, onToggle) {
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)({}), 1), skipOpen = _useState[0];
    return {
        onMouseDown: function() {
            skipOpen.v = state && state !== "closed";
        },
        onClick: function(e) {
            return skipOpen.v ? skipOpen.v = false : onToggle(true, e);
        }
    };
};





var $eHaBZ = parcelRequire("eHaBZ");

var $f6157dc84680d262$export$8410607abb05084e = function(onMenuChange, isOpen) {
    var prevOpen = (0, $eHaBZ.useRef)(isOpen);
    (0, $eHaBZ.useEffect)(function() {
        if (prevOpen.current !== isOpen) (0, $e352c376e0aff571$export$175e60bb96229ece)(onMenuChange, {
            open: isOpen
        });
        prevOpen.current = isOpen;
    }, [
        onMenuChange,
        isOpen
    ]);
};




var $7520d8d0d9cb8a67$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function Menu(_param, externalRef) {
    var ariaLabel = _param["aria-label"], _ = _param.captureFocus, _1 = _param.initialOpen, menuButton = _param.menuButton, instanceRef = _param.instanceRef, onMenuChange = _param.onMenuChange, restProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "aria-label",
        "captureFocus",
        "initialOpen",
        "menuButton",
        "instanceRef",
        "onMenuChange"
    ]);
    var _useMenuStateAndFocus = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $ae26e7d217817bdf$export$1668883ac2d8e856)(restProps), 3), stateProps = _useMenuStateAndFocus[0], toggleMenu = _useMenuStateAndFocus[1], openMenu = _useMenuStateAndFocus[2];
    var state = stateProps.state;
    var isOpen = (0, $e352c376e0aff571$export$30c2dce1a652e248)(state);
    var buttonRef = (0, $eHaBZ.useRef)(null);
    var anchorProps = (0, $9c4ef94082e6b0ed$export$98524f11226063fc)(state, function(_, e) {
        return openMenu(!e.detail ? (0, $8582129499aad1e8$export$8c6ccba1b6ce32e9).FIRST : undefined);
    });
    var handleClose = (0, $eHaBZ.useCallback)(function(e) {
        toggleMenu(false);
        if (e.key) buttonRef.current.focus();
    }, [
        toggleMenu
    ]);
    var onKeyDown = function(e) {
        switch(e.key){
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).UP:
                openMenu((0, $8582129499aad1e8$export$8c6ccba1b6ce32e9).LAST);
                break;
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).DOWN:
                openMenu((0, $8582129499aad1e8$export$8c6ccba1b6ce32e9).FIRST);
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    var button = (0, $e352c376e0aff571$export$175e60bb96229ece)(menuButton, {
        open: isOpen
    });
    if (!button || !button.type) throw new Error("Menu requires a menuButton prop.");
    var buttonProps = (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        ref: (0, $c38ebdac3c379752$export$2d8be4568b07be94)(button.ref, buttonRef)
    }, (0, $e352c376e0aff571$export$9d1611c77c2fe928)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        onKeyDown: onKeyDown
    }, anchorProps), button.props));
    if ((0, $e352c376e0aff571$export$7d9f7e9c1c02b41e)(button.type) === "MenuButton") buttonProps.isOpen = isOpen;
    var renderButton = /*#__PURE__*/ (0, $eHaBZ.cloneElement)(button, buttonProps);
    (0, $f6157dc84680d262$export$8410607abb05084e)(onMenuChange, isOpen);
    (0, $eHaBZ.useImperativeHandle)(instanceRef, function() {
        return {
            openMenu: openMenu,
            closeMenu: function() {
                return toggleMenu(false);
            }
        };
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $eHaBZ.Fragment), {
        children: [
            renderButton,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4f2f557029cf5aa9$export$a5a70f2f059d02ee), (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, restProps, stateProps), {
                "aria-label": ariaLabel || (typeof button.props.children === "string" ? button.props.children : "Menu"),
                anchorRef: buttonRef,
                ref: externalRef,
                onClose: handleClose
            }))
        ]
    });
});





var $eHaBZ = parcelRequire("eHaBZ");






var $8cca9a381f9e7f19$export$266a769812832828 = /*#__PURE__*/ (0, $e352c376e0aff571$export$4c4bf90f1b4d3105)("MenuButton", /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function MenuButton(_param, ref) {
    var className = _param.className, isOpen = _param.isOpen, disabled = _param.disabled, children = _param.children, restProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "className",
        "isOpen",
        "disabled",
        "children"
    ]);
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            open: isOpen
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        "aria-haspopup": true,
        "aria-expanded": isOpen,
        "aria-disabled": disabled || undefined,
        type: "button",
        disabled: disabled
    }, restProps), {
        ref: ref,
        className: (0, $370568074483fa2d$export$7ae630fe844fbd1f)({
            block: (0, $8582129499aad1e8$export$b3d82f113f746a0),
            modifiers: modifiers,
            className: className
        }),
        children: children
    }));
}));





var $eHaBZ = parcelRequire("eHaBZ");



var $eHaBZ = parcelRequire("eHaBZ");

var $8f58e57783b8e7d5$export$68b1d6ee802c4a06 = function(isDisabled, itemRef, updateItems) {
    (0, $a8b919922d1a2d78$export$e5c5a5f917a5871c)(function() {
        if (isDisabled) return;
        var item = itemRef.current;
        updateItems(item, true);
        return function() {
            updateItems(item);
        };
    }, [
        isDisabled,
        itemRef,
        updateItems
    ]);
};



var $71fb58b0987b4684$export$c75b31607cdc621e = function(itemRef, focusRef, isHovering, isDisabled) {
    var submenuCloseDelay = (0, $eHaBZ.useContext)((0, $8582129499aad1e8$export$8fa45c82eddfe270)).submenuCloseDelay;
    var _useContext = (0, $eHaBZ.useContext)((0, $8582129499aad1e8$export$7cb023214e4bda1e)), isParentOpen = _useContext.isParentOpen, submenuCtx = _useContext.submenuCtx, dispatch = _useContext.dispatch, updateItems = _useContext.updateItems;
    var setHover = function() {
        !isHovering && !isDisabled && dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).SET, itemRef.current);
    };
    var unsetHover = function() {
        !isDisabled && dispatch((0, $8582129499aad1e8$export$6db955af9e6f8fcd).UNSET, itemRef.current);
    };
    var onBlur = function(e) {
        if (isHovering && !e.currentTarget.contains(e.relatedTarget)) unsetHover();
    };
    var onPointerMove = function(e) {
        if (!isDisabled) {
            e.stopPropagation();
            submenuCtx.on(submenuCloseDelay, setHover, setHover);
        }
    };
    var onPointerLeave = function(_, keepHover) {
        submenuCtx.off();
        !keepHover && unsetHover();
    };
    (0, $8f58e57783b8e7d5$export$68b1d6ee802c4a06)(isDisabled, itemRef, updateItems);
    (0, $eHaBZ.useEffect)(function() {
        if (isHovering && isParentOpen) focusRef.current && focusRef.current.focus();
    }, [
        focusRef,
        isHovering,
        isParentOpen
    ]);
    return {
        setHover: setHover,
        onBlur: onBlur,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerLeave
    };
};








var $eHaBZ = parcelRequire("eHaBZ");


var $76ee2a1f5db3d280$export$9f154fa70a6daa25 = function(name, WrappedComponent) {
    var Component = /*#__PURE__*/ (0, $eHaBZ.memo)(WrappedComponent);
    var WithHovering = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function(props, ref) {
        var itemRef = (0, $eHaBZ.useRef)(null);
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)(Component, (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, props), {
            itemRef: itemRef,
            externalRef: ref,
            isHovering: (0, $eHaBZ.useContext)((0, $8582129499aad1e8$export$15c1690330cd94e)) === itemRef.current
        }));
    });
    WithHovering.displayName = "WithHovering(".concat(name, ")");
    return WithHovering;
};




var $d2607b40d2c54b42$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $76ee2a1f5db3d280$export$9f154fa70a6daa25)("MenuItem", function MenuItem(_param) {
    var className = _param.className, value = _param.value, href = _param.href, type = _param.type, checked = _param.checked, disabled = _param.disabled, children = _param.children, onClick = _param.onClick, isHovering = _param.isHovering, itemRef = _param.itemRef, externalRef = _param.externalRef, restProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "className",
        "value",
        "href",
        "type",
        "checked",
        "disabled",
        "children",
        "onClick",
        "isHovering",
        "itemRef",
        "externalRef"
    ]);
    var isDisabled = !!disabled;
    var _useItemState = (0, $71fb58b0987b4684$export$c75b31607cdc621e)(itemRef, itemRef, isHovering, isDisabled), setHover = _useItemState.setHover, restStateProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_useItemState, [
        "setHover"
    ]);
    var eventHandlers = (0, $eHaBZ.useContext)((0, $8582129499aad1e8$export$ee9f2ec6c8119c2a));
    var radioGroup = (0, $eHaBZ.useContext)((0, $8582129499aad1e8$export$a79eda4ff50e30b6));
    var isRadio = type === "radio";
    var isCheckBox = type === "checkbox";
    var isAnchor = !!href && !isDisabled && !isRadio && !isCheckBox;
    var isChecked = isRadio ? radioGroup.value === value : isCheckBox ? !!checked : false;
    var handleClick = function(e) {
        if (isDisabled) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        var event = {
            value: value,
            syntheticEvent: e
        };
        if (e.key !== undefined) event.key = e.key;
        if (isCheckBox) event.checked = !isChecked;
        if (isRadio) event.name = radioGroup.name;
        (0, $e352c376e0aff571$export$175e60bb96229ece)(onClick, event);
        if (isRadio) (0, $e352c376e0aff571$export$175e60bb96229ece)(radioGroup.onRadioChange, event);
        eventHandlers.handleClick(event, isCheckBox || isRadio);
    };
    var handleKeyDown = function(e) {
        if (!isHovering) return;
        switch(e.key){
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).ENTER:
                e.preventDefault();
            case (0, $8582129499aad1e8$export$4b0075e5ea5e1f26).SPACE:
                isAnchor ? itemRef.current.click() : handleClick(e);
        }
    };
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            type: type,
            disabled: isDisabled,
            hover: isHovering,
            checked: isChecked,
            anchor: isAnchor
        };
    }, [
        type,
        isDisabled,
        isHovering,
        isChecked,
        isAnchor
    ]);
    var mergedProps = (0, $e352c376e0aff571$export$9d1611c77c2fe928)((0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, restStateProps), {
        onPointerDown: setHover,
        onKeyDown: handleKeyDown,
        onClick: handleClick
    }), restProps);
    var menuItemProps = (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        role: isRadio ? "menuitemradio" : isCheckBox ? "menuitemcheckbox" : (0, $8582129499aad1e8$export$3e982710469daaf),
        "aria-checked": isRadio || isCheckBox ? isChecked : undefined
    }, (0, $e352c376e0aff571$export$ffb2d5922287e12)(isDisabled, isHovering), mergedProps), {
        ref: (0, $c38ebdac3c379752$export$2d8be4568b07be94)(externalRef, itemRef),
        className: (0, $370568074483fa2d$export$7ae630fe844fbd1f)({
            block: (0, $8582129499aad1e8$export$832250593589325a),
            element: (0, $8582129499aad1e8$export$b5a3c9a9995a8c24),
            modifiers: modifiers,
            className: className
        }),
        children: (0, $eHaBZ.useMemo)(function() {
            return (0, $e352c376e0aff571$export$175e60bb96229ece)(children, modifiers);
        }, [
            children,
            modifiers
        ])
    });
    return isAnchor ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        role: (0, $8582129499aad1e8$export$a5a9d7469a9cc520),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
            href: href
        }, menuItemProps))
    }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, menuItemProps));
});



/**
 * @callback completeCallback
 */ /**
 * @typedef {Object} Options
 * @property {number} [duration]
 * @property {string} [easing]
 * @property {completeCallback} [complete]
 */ /**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $7ef98d8c594793a5$var$fadeComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty("transition");
    if (properties.opacity) element.style.opacity = properties.opacity;
    else element.style.removeProperty("opacity");
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$82e6205b15e6c637(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 0;
    element.style.removeProperty("display");
    element.style.transition = "opacity ".concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        element.style.opacity = 1;
    });
    setTimeout(function() {
        $7ef98d8c594793a5$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$c091916f1530334c(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 1;
    element.style.transition = "opacity ".concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        element.style.opacity = 0;
    });
    setTimeout(function() {
        element.style.display = "none";
        $7ef98d8c594793a5$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$75d3d2c72ecccf9b(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var display = element.style.display || undefined;
    if (display == "none") $7ef98d8c594793a5$export$82e6205b15e6c637(element, options);
    else $7ef98d8c594793a5$export$c091916f1530334c(element, options);
}
/**
 * @param {Options} options
 * @return {Options}
 */ function $7ef98d8c594793a5$var$getOptions(options) {
    return {
        duration: options.duration || 400,
        easing: options.easing || "ease-out",
        complete: options.complete || undefined
    };
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$fe8985bb6374093c(element) {
    element.style.display = "none";
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$57bf213be019eeb0(element) {
    element.style.removeProperty("display");
}
/**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $7ef98d8c594793a5$var$slideComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty("transition");
    if (properties.overflowY) element.style.overflowY = properties.overflowY;
    else element.style.removeProperty("overflow-y");
    if (properties.marginTop) element.style.marginTop = properties.marginTop;
    else element.style.removeProperty("margin-top");
    if (properties.marginBottom) element.style.marginBottom = properties.marginBottom;
    else element.style.removeProperty("margin-bottom");
    if (properties.paddingTop) element.style.paddingTop = properties.paddingTop;
    else element.style.removeProperty("padding-top");
    if (properties.paddingBottom) element.style.paddingBottom = properties.paddingBottom;
    else element.style.removeProperty("padding-bottom");
    if (properties.height) element.style.height = properties.height;
    else element.style.removeProperty("height");
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$abdd11a06a163232(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    var cs = window.getComputedStyle(element);
    var marginTop = cs.getPropertyValue("margin-top");
    var marginBottom = cs.getPropertyValue("margin-bottom");
    var paddingTop = cs.getPropertyValue("padding-top");
    var paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    if (!element.style.height) element.style.height = "0px";
    element.style.marginTop = "0px";
    element.style.marginBottom = "0px";
    element.style.paddingTop = "0px";
    element.style.paddingBottom = "0px";
    element.style.overflowY = "hidden";
    element.style.removeProperty("display");
    element.style.transition = "height ".concat(o.duration / 1000, "s ").concat(o.easing, ", margin ").concat(o.duration / 1000, "s ").concat(o.easing, ", padding ").concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        var height = element.scrollHeight;
        if (cs.getPropertyValue("box-sizing") == "border-box") height += parseFloat(paddingTop) + parseFloat(paddingBottom);
        element.style.height = "".concat(height, "px");
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
    });
    setTimeout(function() {
        $7ef98d8c594793a5$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$715de50cedc228a8(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var display = element.style.display || undefined;
    if (display == "none") $7ef98d8c594793a5$export$abdd11a06a163232(element, options);
    else $7ef98d8c594793a5$export$deed561b1a0ff1ea(element, options);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$deed561b1a0ff1ea(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    var cs = window.getComputedStyle(element);
    var marginTop = cs.getPropertyValue("margin-top");
    var marginBottom = cs.getPropertyValue("margin-bottom");
    var paddingTop = cs.getPropertyValue("padding-top");
    var paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    requestAnimationFrame(function() {
        if (!element.style.height) {
            var height = element.scrollHeight;
            if (cs.getPropertyValue("box-sizing") == "content-box") height -= parseFloat(paddingTop) + parseFloat(paddingBottom);
            element.style.height = "".concat(height, "px");
        }
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
        element.style.overflowY = "hidden";
        element.style.transition = "height ".concat(o.duration / 1000, "s ").concat(o.easing, ", margin ").concat(o.duration / 1000, "s ").concat(o.easing, ", padding ").concat(o.duration / 1000, "s ").concat(o.easing);
        requestAnimationFrame(function() {
            element.style.height = "0px";
            element.style.marginTop = "0px";
            element.style.marginBottom = "0px";
            element.style.paddingTop = "0px";
            element.style.paddingBottom = "0px";
        });
    });
    setTimeout(function() {
        element.style.display = "none";
        $7ef98d8c594793a5$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$e03c1c3201ee8bb7(element) {
    var display = element.style.display || undefined;
    if (display == "none") $7ef98d8c594793a5$export$57bf213be019eeb0(element);
    else $7ef98d8c594793a5$export$fe8985bb6374093c(element);
}






/**
 * Object describing how feed items are filtered in the view.
 * @enum {string}
 */ var $c311f30f92964d8a$export$c67e46de1ec7dfa6 = {
    NEWEST: "newest",
    UNREAD: "unread",
    STARRED: "starred"
};


function $0be080af3052783c$export$46e843a62e9cebcc(type) {
    if (type == "newest") return (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST;
    else if (type == "unread") return (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD;
    else if (type == "starred") return (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED;
    else throw new Error("Invalid filter type: \u201C".concat(type, "\u201D"));
}
function $0be080af3052783c$export$63b3966ca4cc85d9(type) {
    if (type == (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST) return "newest";
    else if (type == (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD) return "unread";
    else if (type == (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED) return "starred";
}
var $0be080af3052783c$export$f1004941042944df = "/:filter(newest|unread|starred)/:category(all|tag-[^/]+|source-[0-9]+)/:id?";
function $0be080af3052783c$export$d0bb2ab5375d1521(location, param) {
    var filter = param.filter, category = param.category, id = param.id, search = param.search;
    var queryString = new URLSearchParams(location.search);
    var path;
    if (location.pathname.match(/^\/(newest|unread|starred)\//) !== null) {
        var _location_pathname_split = (0, $bd823d1c24941985$export$e62c166da838fa3)(location.pathname.split("/")), segments = _location_pathname_split.slice(1);
        path = (0, $c1feef6a502006a1$export$82476f982757e71e)($0be080af3052783c$export$f1004941042944df, {
            filter: filter !== null && filter !== void 0 ? filter : segments[0],
            category: category !== null && category !== void 0 ? category : segments[1],
            id: typeof id !== "undefined" ? id : segments[2]
        });
    } else path = (0, $c1feef6a502006a1$export$82476f982757e71e)($0be080af3052783c$export$f1004941042944df, {
        // TODO: change default from config
        filter: filter !== null && filter !== void 0 ? filter : "unread",
        category: category !== null && category !== void 0 ? category : "all",
        id: id
    });
    if (typeof search !== "undefined") {
        if (search) queryString.set("search", search);
        else queryString.delete("search");
    }
    return {
        pathname: path,
        search: queryString.toString()
    };
}
function $0be080af3052783c$export$7f0beea2aa79e4fa(location, params) {
    var _makeEntriesLinkLocation = $0be080af3052783c$export$d0bb2ab5375d1521(location, params), pathname = _makeEntriesLinkLocation.pathname, search = _makeEntriesLinkLocation.search;
    return pathname + (search !== "" ? "?".concat(search) : "");
}
function $0be080af3052783c$export$e64cf1b9b4b3aa56(location) {
    var _location_state;
    var state = (_location_state = location.state) !== null && _location_state !== void 0 ? _location_state : {};
    var _state_forceReload;
    return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, state), {
        forceReload: ((_state_forceReload = state.forceReload) !== null && _state_forceReload !== void 0 ? _state_forceReload : 0) + 1
    });
}




/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $4c0cf5d996e33977$var$replace = "".replace;
// escape
var $4c0cf5d996e33977$var$es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
var $4c0cf5d996e33977$var$ca = /[&<>'"]/g;
var $4c0cf5d996e33977$var$esca = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "'": "&#39;",
    '"': "&quot;"
};
var $4c0cf5d996e33977$var$pe = function(m) {
    return $4c0cf5d996e33977$var$esca[m];
};
var $4c0cf5d996e33977$export$4e7f196112fea3c5 = function(es) {
    return $4c0cf5d996e33977$var$replace.call(es, $4c0cf5d996e33977$var$ca, $4c0cf5d996e33977$var$pe);
};
// unescape
var $4c0cf5d996e33977$var$unes = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"'
};
var $4c0cf5d996e33977$var$cape = function(m) {
    return $4c0cf5d996e33977$var$unes[m];
};
var $4c0cf5d996e33977$export$e8bacd2802a88316 = function(un) {
    return $4c0cf5d996e33977$var$replace.call(un, $4c0cf5d996e33977$var$es, $4c0cf5d996e33977$var$cape);
};



var $bb84a3e4bd55e38f$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ 
var $2bfPH = parcelRequire("2bfPH");
var $bb84a3e4bd55e38f$var$INFINITY = 1 / 0, $bb84a3e4bd55e38f$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $bb84a3e4bd55e38f$var$argsTag = "[object Arguments]", $bb84a3e4bd55e38f$var$funcTag = "[object Function]", $bb84a3e4bd55e38f$var$genTag = "[object GeneratorFunction]", $bb84a3e4bd55e38f$var$symbolTag = "[object Symbol]";
/** Detect free variable `global` from Node.js. */ var $bb84a3e4bd55e38f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $bb84a3e4bd55e38f$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $bb84a3e4bd55e38f$var$root = $bb84a3e4bd55e38f$var$freeGlobal || $bb84a3e4bd55e38f$var$freeSelf || Function("return this")();
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $bb84a3e4bd55e38f$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $bb84a3e4bd55e38f$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $bb84a3e4bd55e38f$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/** Used for built-in method references. */ var $bb84a3e4bd55e38f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb84a3e4bd55e38f$var$hasOwnProperty = $bb84a3e4bd55e38f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bb84a3e4bd55e38f$var$objectToString = $bb84a3e4bd55e38f$var$objectProto.toString;
/** Built-in value references. */ var $bb84a3e4bd55e38f$var$Symbol = $bb84a3e4bd55e38f$var$root.Symbol, $bb84a3e4bd55e38f$var$propertyIsEnumerable = $bb84a3e4bd55e38f$var$objectProto.propertyIsEnumerable, $bb84a3e4bd55e38f$var$spreadableSymbol = $bb84a3e4bd55e38f$var$Symbol ? $bb84a3e4bd55e38f$var$Symbol.isConcatSpreadable : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bb84a3e4bd55e38f$var$nativeMax = Math.max;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $bb84a3e4bd55e38f$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $bb84a3e4bd55e38f$var$isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $bb84a3e4bd55e38f$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $bb84a3e4bd55e38f$var$arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */ function $bb84a3e4bd55e38f$var$basePick(object, props) {
    object = Object(object);
    return $bb84a3e4bd55e38f$var$basePickBy(object, props, function(value, key) {
        return key in object;
    });
}
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $bb84a3e4bd55e38f$var$basePickBy(object, props, predicate) {
    var index = -1, length = props.length, result = {};
    while(++index < length){
        var key = props[index], value = object[key];
        if (predicate(value, key)) result[key] = value;
    }
    return result;
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $bb84a3e4bd55e38f$var$baseRest(func, start) {
    start = $bb84a3e4bd55e38f$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $bb84a3e4bd55e38f$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return $bb84a3e4bd55e38f$var$apply(func, this, otherArgs);
    };
}
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $bb84a3e4bd55e38f$var$isFlattenable(value) {
    return $bb84a3e4bd55e38f$var$isArray(value) || $bb84a3e4bd55e38f$var$isArguments(value) || !!($bb84a3e4bd55e38f$var$spreadableSymbol && value && value[$bb84a3e4bd55e38f$var$spreadableSymbol]);
}
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $bb84a3e4bd55e38f$var$toKey(value) {
    if (typeof value == "string" || $bb84a3e4bd55e38f$var$isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$bb84a3e4bd55e38f$var$INFINITY ? "-0" : result;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $bb84a3e4bd55e38f$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $bb84a3e4bd55e38f$var$isArrayLikeObject(value) && $bb84a3e4bd55e38f$var$hasOwnProperty.call(value, "callee") && (!$bb84a3e4bd55e38f$var$propertyIsEnumerable.call(value, "callee") || $bb84a3e4bd55e38f$var$objectToString.call(value) == $bb84a3e4bd55e38f$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $bb84a3e4bd55e38f$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $bb84a3e4bd55e38f$var$isArrayLike(value) {
    return value != null && $bb84a3e4bd55e38f$var$isLength(value.length) && !$bb84a3e4bd55e38f$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $bb84a3e4bd55e38f$var$isArrayLikeObject(value) {
    return $bb84a3e4bd55e38f$var$isObjectLike(value) && $bb84a3e4bd55e38f$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $bb84a3e4bd55e38f$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $bb84a3e4bd55e38f$var$isObject(value) ? $bb84a3e4bd55e38f$var$objectToString.call(value) : "";
    return tag == $bb84a3e4bd55e38f$var$funcTag || tag == $bb84a3e4bd55e38f$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $bb84a3e4bd55e38f$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $bb84a3e4bd55e38f$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bb84a3e4bd55e38f$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $bb84a3e4bd55e38f$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $bb84a3e4bd55e38f$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == "symbol" || $bb84a3e4bd55e38f$var$isObjectLike(value) && $bb84a3e4bd55e38f$var$objectToString.call(value) == $bb84a3e4bd55e38f$var$symbolTag;
}
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $bb84a3e4bd55e38f$var$pick = $bb84a3e4bd55e38f$var$baseRest(function(object, props) {
    return object == null ? {} : $bb84a3e4bd55e38f$var$basePick(object, $bb84a3e4bd55e38f$var$arrayMap($bb84a3e4bd55e38f$var$baseFlatten(props, 1), $bb84a3e4bd55e38f$var$toKey));
});
$bb84a3e4bd55e38f$exports = $bb84a3e4bd55e38f$var$pick;









var $eHaBZ = parcelRequire("eHaBZ");


function $5101856265f93aa2$export$2e2bcd8739ae039(param) {
    var spoutParamName = param.spoutParamName, spoutParam = param.spoutParam, _param_params = param.params, params = _param_params === void 0 ? {} : _param_params, sourceErrors = param.sourceErrors, sourceId = param.sourceId, setEditedSource = param.setEditedSource, setDirty = param.setDirty;
    var updateSourceParam = (0, $eHaBZ.useCallback)(function(event) {
        setDirty(true);
        setEditedSource(function(_param) {
            var params = _param.params, restSource = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
                "params"
            ]);
            return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, restSource), {
                params: (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, params), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, spoutParamName, event.target.value))
            });
        });
    }, [
        setEditedSource,
        setDirty,
        spoutParamName
    ]);
    var updateSourceParamBool = (0, $eHaBZ.useCallback)(function(event) {
        return updateSourceParam({
            target: {
                value: event.target.checked ? "1" : undefined
            }
        });
    }, [
        updateSourceParam
    ]);
    var value = spoutParamName in params ? params[spoutParamName] : spoutParam.default;
    var control = null;
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    if ([
        "text",
        "checkbox",
        "url"
    ].includes(spoutParam.type)) {
        var checked = undefined;
        if (spoutParam.type === "checkbox") {
            checked = value == "1";
            // Value always has to be 1 since HTML sends [name]=[value] when a checkbox is checked
            // and omits the field altogether from HTTP request when not checked.
            value = "1";
        }
        control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
            id: "".concat(spoutParamName, "-").concat(sourceId),
            type: spoutParam.type,
            name: spoutParamName,
            value: value,
            checked: checked,
            onChange: spoutParam.type !== "checkbox" ? updateSourceParam : updateSourceParamBool
        });
    } else if (spoutParam.type === "password") control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
        id: "".concat(spoutParamName, "-").concat(sourceId),
        type: spoutParam.type,
        name: spoutParamName,
        placeholder: _("source_pwd_placeholder"),
        onChange: updateSourceParam
    });
    else if (spoutParam.type === "select") control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("select", {
        id: "".concat(spoutParamName, "-").concat(sourceId),
        name: spoutParamName,
        size: "1",
        value: value,
        onChange: updateSourceParam,
        children: Object.entries(spoutParam.values).map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(param, 2), optionName = _param[0], optionTitle = _param[1];
            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                value: optionName,
                children: optionTitle
            }, optionName);
        })
    });
    else return null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                htmlFor: "".concat(spoutParamName, "-").concat(sourceId),
                children: spoutParam.title
            }),
            control,
            sourceErrors[spoutParamName] ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "error",
                children: sourceErrors[spoutParamName]
            }) : null
        ]
    });
}
$5101856265f93aa2$export$2e2bcd8739ae039.propTypes = {
    spoutParamName: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired,
    spoutParam: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    sourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string).isRequired,
    sourceId: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    setEditedSource: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setDirty: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};




function $b0e03640e062f6f9$export$722fbec263ad908a(id, values) {
    return $32ae13b741542474$export$299ba2dee77727e9("source/".concat(id), {
        headers: {
            "content-type": "application/json; charset=utf-8"
        },
        body: JSON.stringify(values),
        failOnHttpErrors: false
    }).promise.then($32ae13b741542474$export$8d90b058a02656d9(function(response) {
        return response.ok || response.status === 400;
    })).then(function(response) {
        return response.json();
    });
}
function $b0e03640e062f6f9$export$c1f8f7c408fa54a(id) {
    return $32ae13b741542474$export$299ba2dee77727e9("source/" + id + "/update", {
        timeout: 0
    }).promise;
}
function $b0e03640e062f6f9$export$c5eb18431f66026b() {
    return $32ae13b741542474$export$3988ae62b71be9a3("update", {
        headers: {
            "Accept": "text/event-stream"
        },
        timeout: 0
    }).promise.then(function(response) {
        return response.text();
    });
}
function $b0e03640e062f6f9$export$cd7f480d6b8286c3(id) {
    return $32ae13b741542474$export$38dab5a9fea42f39("source/".concat(id)).promise;
}
function $b0e03640e062f6f9$export$316f19f1ddc6b34e(abortController) {
    return $32ae13b741542474$export$3988ae62b71be9a3("sources", {
        abortController: abortController
    }).promise.then(function(response) {
        return response.json();
    });
}
function $b0e03640e062f6f9$export$ba43f46f09336c84() {
    return $32ae13b741542474$export$3988ae62b71be9a3("source").promise.then(function(response) {
        return response.json();
    });
}
function $b0e03640e062f6f9$export$d72d2378a998c10c(spoutClass) {
    return $32ae13b741542474$export$3988ae62b71be9a3("source/params", {
        body: $32ae13b741542474$export$92871f7982deaf9f({
            spout: spoutClass
        })
    }).promise.then(function(res) {
        return res.json();
    });
}
function $b0e03640e062f6f9$export$432f698644f45d1() {
    return $32ae13b741542474$export$3988ae62b71be9a3("sources/stats").promise.then(function(response) {
        return response.json();
    });
}




var $559aa794d8d2d8fd$var$FAST_DURATION_MS = 200;
// cancel source editing
function $559aa794d8d2d8fd$var$handleCancel(param) {
    var source = param.source, sourceElem = param.sourceElem, setSources = param.setSources, setEditedSource = param.setEditedSource;
    var id = source.id;
    if (id.toString().startsWith("new-")) (0, $7ef98d8c594793a5$export$c091916f1530334c)(sourceElem.current, {
        duration: $559aa794d8d2d8fd$var$FAST_DURATION_MS,
        complete: function() {
            // Remove the source from this page’s model.
            setSources(function(sources) {
                return sources.filter(function(source) {
                    return source.id !== id;
                });
            });
        }
    });
    else // Hide the input form.
    setEditedSource(null);
}
// save source
function $559aa794d8d2d8fd$var$handleSave(param) {
    var event = param.event, setSources = param.setSources, source = param.source, setEditedSource = param.setEditedSource, setSourceActionLoading = param.setSourceActionLoading, setJustSavedTimeout = param.setJustSavedTimeout, setSourceErrors = param.setSourceErrors;
    event.preventDefault();
    // remove old errors
    setSourceErrors({});
    setSourceActionLoading(true);
    var newSource = source;
    var id = source.id, tags = source.tags, filter = source.filter, params = source.params, restSource = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(source, [
        "id",
        "tags",
        "filter",
        "params"
    ]);
    // Make tags into a list.
    var tagsList = tags ? tags.split(",").map(function(tag) {
        return tag.trim();
    }).filter(function(tag) {
        return tag !== "";
    }) : [];
    var values = (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, restSource, params), {
        tags: tagsList,
        filter: filter || null
    });
    $b0e03640e062f6f9$export$722fbec263ad908a(id, values).then(function(response) {
        if (!response.success) setSourceErrors(response);
        else {
            // Set justSavedTimeout state variable to a timeout.
            // The view will show “saved” text while the timeout runs.
            setJustSavedTimeout(function(oldTimeout) {
                // Only keep the most recent timeout.
                if (oldTimeout !== null) clearTimeout(oldTimeout);
                return window.setTimeout(function() {
                    setJustSavedTimeout(null);
                }, 10000);
            });
            // Hide the input form.
            setEditedSource(null);
            // Update tags and sources for navigation.
            selfoss.app.setTags(response.tags);
            selfoss.app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            selfoss.app.setSources(response.sources);
            selfoss.app.setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            // Update sources in this page’s model.
            setSources(function(sources) {
                return sources.map(function(source) {
                    if (source.id === id) return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, newSource), {
                        id: response.id,
                        tags: tagsList,
                        // Use fetched title.
                        title: response.title
                    });
                    else return source;
                });
            });
        }
    }).catch(function(error) {
        selfoss.app.showError(selfoss.app._("error_edit_source") + " " + error.message);
    }).finally(function() {
        setSourceActionLoading(false);
    });
}
// delete source
function $559aa794d8d2d8fd$var$handleDelete(param) {
    var source = param.source, sourceElem = param.sourceElem, setSources = param.setSources, setSourceBeingDeleted = param.setSourceBeingDeleted, setDirty = param.setDirty;
    var answer = confirm(selfoss.app._("source_warn"));
    if (answer == false) return;
    // get id
    var id = source.id;
    setDirty(false);
    // show loading
    setSourceBeingDeleted(true);
    // delete on server
    $b0e03640e062f6f9$export$cd7f480d6b8286c3(id).then(function() {
        (0, $7ef98d8c594793a5$export$c091916f1530334c)(sourceElem.current, {
            duration: $559aa794d8d2d8fd$var$FAST_DURATION_MS,
            complete: function() {
                // Remove the source from this page’s model.
                setSources(function(sources) {
                    return sources.filter(function(source) {
                        return source.id !== id;
                    });
                });
            }
        });
        // Reload tags and remove source from navigation.
        selfoss.reloadTags();
        selfoss.app.setSources(function(sources) {
            return sources.filter(function(source) {
                return source.id !== id;
            });
        });
    }).catch(function(error) {
        setSourceBeingDeleted(false);
        selfoss.app.showError(selfoss.app._("error_delete_source") + " " + error.message);
    });
}
// start editing
function $559aa794d8d2d8fd$var$handleEdit(param) {
    var event = param.event, source = param.source, setEditedSource = param.setEditedSource;
    event.preventDefault();
    var id = source.id, title = source.title, tags = source.tags, filter = source.filter, spout = source.spout, params = source.params;
    setEditedSource({
        id: id,
        title: title ? (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(title) : "",
        tags: tags ? tags.map((0, $4c0cf5d996e33977$export$e8bacd2802a88316)).join(",") : "",
        filter: filter,
        spout: spout,
        params: params
    });
}
// select new source spout type
function $559aa794d8d2d8fd$var$handleSpoutChange(param) {
    var event = param.event, setSpouts = param.setSpouts, updateEditedSource = param.updateEditedSource, setSourceParamsLoading = param.setSourceParamsLoading, setSourceParamsError = param.setSourceParamsError;
    var spoutClass = event.target.value;
    updateEditedSource({
        spout: spoutClass
    });
    if (spoutClass.trim().length === 0) return;
    setSourceParamsLoading(true);
    $b0e03640e062f6f9$export$d72d2378a998c10c(spoutClass).then(function(param) {
        var spout = param.spout;
        setSourceParamsLoading(false);
        setSpouts(function(spouts) {
            return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, spouts), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, spoutClass, spout));
        });
        var defaults = Object.fromEntries(Object.entries(spout.params).map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(param, 2), _$param = _param[0], props = _param[1];
            var _props_default;
            return [
                _$param,
                (_props_default = props["default"]) !== null && _props_default !== void 0 ? _props_default : ""
            ];
        }));
        updateEditedSource(function(source) {
            var oldCompatibleParams = (0, (/*@__PURE__*/$parcel$interopDefault($bb84a3e4bd55e38f$exports)))(source.params, Object.keys(spout.params));
            return {
                params: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaults, oldCompatibleParams)
            };
        });
    }).catch(function(error) {
        setSourceParamsLoading(false);
        setSourceParamsError(error.message);
    });
}
// Taken from https://stackoverflow.com/a/15289883/160386
var $559aa794d8d2d8fd$var$MS_PER_DAY = 86400000;
function $559aa794d8d2d8fd$var$daysAgo(date) {
    // Get number of days between now and when the last entry was seen
    // Note: The time of the two dates is set to midnight
    // to get the difference of the two dates in calendar days
    // instead of a day equaling any 24 hour period which makes it
    // impossible to distinguish today and yesterday.
    var now = new Date();
    var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var old = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return Math.floor((today - old) / $559aa794d8d2d8fd$var$MS_PER_DAY);
}
function $559aa794d8d2d8fd$var$SourceEditForm(param) {
    var source = param.source, sourceElem = param.sourceElem, sourceError = param.sourceError, setSources = param.setSources, spouts = param.spouts, setSpouts = param.setSpouts, setEditedSource = param.setEditedSource, sourceActionLoading = param.sourceActionLoading, setSourceActionLoading = param.setSourceActionLoading, sourceParamsLoading = param.sourceParamsLoading, setSourceParamsLoading = param.setSourceParamsLoading, sourceParamsError = param.sourceParamsError, setSourceParamsError = param.setSourceParamsError, setJustSavedTimeout = param.setJustSavedTimeout, sourceErrors = param.sourceErrors, setSourceErrors = param.setSourceErrors, dirty = param.dirty, setDirty = param.setDirty;
    var sourceId = source.id;
    var updateEditedSource = (0, $eHaBZ.useCallback)(function(changes) {
        setDirty(true);
        if (typeof changes === "function") setEditedSource(function(source) {
            return (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, source, changes(source));
        });
        else setEditedSource(function(source) {
            return (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, source, changes);
        });
    }, [
        setEditedSource,
        setDirty
    ]);
    var titleOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            title: event.target.value
        });
    }, [
        updateEditedSource
    ]);
    var tagsOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            tags: event.target.value
        });
    }, [
        updateEditedSource
    ]);
    var filterOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            filter: event.target.value
        });
    }, [
        updateEditedSource
    ]);
    var spoutOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return $559aa794d8d2d8fd$var$handleSpoutChange({
            event: event,
            setSpouts: setSpouts,
            updateEditedSource: updateEditedSource,
            setSourceParamsLoading: setSourceParamsLoading,
            setSourceParamsError: setSourceParamsError
        });
    }, [
        setSpouts,
        updateEditedSource,
        setSourceParamsLoading,
        setSourceParamsError
    ]);
    var saveOnClick = (0, $eHaBZ.useCallback)(function(event) {
        setDirty(false);
        $559aa794d8d2d8fd$var$handleSave({
            event: event,
            setSources: setSources,
            source: source,
            setEditedSource: setEditedSource,
            setSourceActionLoading: setSourceActionLoading,
            setJustSavedTimeout: setJustSavedTimeout,
            setSourceErrors: setSourceErrors
        });
    }, [
        setSources,
        source,
        setEditedSource,
        setSourceActionLoading,
        setJustSavedTimeout,
        setSourceErrors,
        setDirty
    ]);
    var cancelOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        if (dirty) {
            var answer = confirm(selfoss.app._("source_warn_cancel_dirty"));
            if (answer === false) return;
        }
        setDirty(false);
        $559aa794d8d2d8fd$var$handleCancel({
            event: event,
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setEditedSource: setEditedSource
        });
    }, [
        source,
        sourceElem,
        setSources,
        setEditedSource,
        dirty,
        setDirty
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var sourceParamsContent = sourceParamsLoading ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$7f7cbe89f1eacd2), {
        size: "3x",
        label: _("source_params_loading")
    }) : sourceParamsError !== null && sourceParamsError !== void 0 ? sourceParamsError : Object.keys(spouts).includes(source.spout) && Object.keys(spouts[source.spout].params).length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
        children: Object.entries(spouts[source.spout].params).map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(param, 2), spoutParamName = _param[0], spoutParam = _param[1];
            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5101856265f93aa2$export$2e2bcd8739ae039), {
                params: source.params,
                spoutParamName: spoutParamName,
                spoutParam: spoutParam,
                sourceErrors: sourceErrors,
                sourceId: sourceId,
                setEditedSource: setEditedSource,
                setDirty: setDirty
            }, spoutParamName);
        })
    }) : null;
    var _source_title, _source_tags, _source_filter;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            className: "source-edit-form",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "title-".concat(sourceId),
                            children: _("source_title")
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "title-".concat(sourceId),
                            type: "text",
                            name: "title",
                            accessKey: "t",
                            value: (_source_title = source.title) !== null && _source_title !== void 0 ? _source_title : "",
                            placeholder: _("source_autotitle_hint"),
                            onChange: titleOnChange,
                            autoFocus: true
                        }),
                        sourceErrors["title"] ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors["title"]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "tags-".concat(sourceId),
                            children: _("source_tags")
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "tags-".concat(sourceId),
                            type: "text",
                            name: "tags",
                            accessKey: "g",
                            value: (_source_tags = source.tags) !== null && _source_tags !== void 0 ? _source_tags : "",
                            onChange: tagsOnChange
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                            className: "source-edit-form-help",
                            children: [
                                " ",
                                _("source_comma")
                            ]
                        }),
                        sourceErrors["tags"] ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors["tags"]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "filter-".concat(sourceId),
                            children: _("source_filter")
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "filter-".concat(sourceId),
                            type: "text",
                            name: "filter",
                            accessKey: "f",
                            value: (_source_filter = source.filter) !== null && _source_filter !== void 0 ? _source_filter : "",
                            onChange: filterOnChange
                        }),
                        sourceErrors["filter"] ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors["filter"]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "type-".concat(sourceId),
                            children: _("source_type")
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("select", {
                            id: "type-".concat(sourceId),
                            className: "source-spout",
                            name: "spout",
                            accessKey: "y",
                            onChange: spoutOnChange,
                            value: source.spout,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                                    value: "",
                                    children: _("source_select")
                                }),
                                Object.entries(spouts).map(function(param) {
                                    var _param = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(param, 2), spouttype = _param[0], spout = _param[1];
                                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                                        title: spout.description,
                                        value: spouttype,
                                        children: spout.name
                                    }, spouttype);
                                })
                            ]
                        }),
                        sourceErrors["spout"] ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors["spout"]
                        }) : null
                    ]
                }),
                sourceParamsContent ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "source-params",
                    children: sourceParamsContent
                }) : null,
                sourceError ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "source-error",
                    "aria-live": "assertive",
                    children: sourceError
                }) : null,
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "source-action",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            type: "submit",
                            className: "source-save",
                            accessKey: "s",
                            onClick: saveOnClick,
                            children: [
                                _("source_save"),
                                sourceActionLoading && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$7f7cbe89f1eacd2), {
                                            label: _("source_saving")
                                        })
                                    ]
                                })
                            ]
                        }),
                        " \u2022 ",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                            type: "submit",
                            className: "source-cancel",
                            accessKey: "c",
                            onClick: cancelOnClick,
                            children: _("source_cancel")
                        })
                    ]
                })
            ]
        })
    });
}
$559aa794d8d2d8fd$var$SourceEditForm.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    sourceElem: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    sourceError: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    spouts: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setSpouts: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setEditedSource: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourceActionLoading: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setSourceActionLoading: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourceParamsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setSourceParamsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourceParamsError: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string).isRequired,
    setSourceParamsError: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setJustSavedTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string).isRequired,
    setSourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    dirty: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setDirty: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};
function $559aa794d8d2d8fd$export$2e2bcd8739ae039(param) {
    var source = param.source, setSources = param.setSources, spouts = param.spouts, setSpouts = param.setSpouts, dirty = param.dirty, setDirtySources = param.setDirtySources;
    var isNew = !source.title;
    var classes = {
        source: true,
        "source-new": isNew,
        error: source.error && source.error.length > 0
    };
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(isNew ? (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, source) : null), 2), editedSource = _useState[0], setEditedSource = _useState[1];
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(false), 2), sourceActionLoading = _useState1[0], setSourceActionLoading = _useState1[1];
    var _useState2 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(false), 2), sourceBeingDeleted = _useState2[0], setSourceBeingDeleted = _useState2[1];
    var _useState3 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(false), 2), sourceParamsLoading = _useState3[0], setSourceParamsLoading = _useState3[1];
    var _useState4 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), justSavedTimeout = _useState4[0], setJustSavedTimeout = _useState4[1];
    var _useState5 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), sourceParamsError = _useState5[0], setSourceParamsError = _useState5[1];
    var _useState6 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)({}), 2), sourceErrors = _useState6[0], setSourceErrors = _useState6[1];
    (0, $eHaBZ.useEffect)(function() {
        // Prevent timeout from trying to update state after unmount.
        var oldTimeout = justSavedTimeout;
        return function() {
            if (oldTimeout !== null) clearTimeout(oldTimeout);
        };
    }, [
        justSavedTimeout
    ]);
    var editOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $559aa794d8d2d8fd$var$handleEdit({
            event: event,
            source: source,
            setEditedSource: setEditedSource
        });
    }, [
        source
    ]);
    var setDirty = (0, $eHaBZ.useCallback)(function(dirty) {
        setDirtySources(function(dirtySources) {
            return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, dirtySources), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, source.id, dirty));
        });
    }, [
        source.id,
        setDirtySources
    ]);
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var sourceElem = (0, $eHaBZ.useRef)(null);
    var extraMenuOnSelection = (0, $eHaBZ.useCallback)(function(param) {
        var value = param.value;
        if (value === "delete") $559aa794d8d2d8fd$var$handleDelete({
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setSourceBeingDeleted: setSourceBeingDeleted,
            setDirty: setDirty
        });
        else if (value === "browse") history.push((0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(source.id)
        }));
    }, [
        source,
        sourceElem,
        setSources,
        setDirty,
        location,
        history
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))(classes),
        "data-id": source.id,
        id: "source-".concat(source.id),
        ref: sourceElem,
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "source-icon",
                children: source.icon && source.icon != "0" ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                    src: "favicons/".concat(source.icon),
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                className: "source-title",
                children: source.title ? (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(source.title) : _("source_new")
            }),
            " ",
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: "source-edit-delete",
                children: [
                    !editedSource && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                                type: "button",
                                accessKey: "e",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    "source-showparams": true,
                                    saved: justSavedTimeout !== null
                                }),
                                onClick: editOnClick,
                                "aria-expanded": !!editedSource,
                                children: _(justSavedTimeout !== null ? "source_saved" : "source_edit")
                            }),
                            " \u2022 "
                        ]
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $7520d8d0d9cb8a67$export$d9b273488cd8ce6f), {
                        onItemClick: extraMenuOnSelection,
                        menuButton: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $8cca9a381f9e7f19$export$266a769812832828), {
                            className: "source-menu-button",
                            children: [
                                _("source_menu"),
                                sourceBeingDeleted && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$7f7cbe89f1eacd2), {
                                            label: _("source_deleting")
                                        })
                                    ]
                                })
                            ]
                        }),
                        menuClassName: "popup-menu",
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d2607b40d2c54b42$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-browse",
                                value: "browse",
                                children: _("source_browse")
                            }),
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d2607b40d2c54b42$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-delete",
                                value: "delete",
                                children: _("source_delete")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "source-days",
                children: source.lastentry ? " \u2022 ".concat(_("source_last_post"), " ").concat(_("days", [
                    $559aa794d8d2d8fd$var$daysAgo(new Date(source.lastentry * 1000))
                ])) : null
            }),
            editedSource ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($559aa794d8d2d8fd$var$SourceEditForm, {
                setSources: setSources,
                spouts: spouts,
                setSpouts: setSpouts,
                setEditedSource: setEditedSource,
                sourceActionLoading: sourceActionLoading,
                setSourceActionLoading: setSourceActionLoading,
                sourceParamsLoading: sourceParamsLoading,
                setSourceParamsLoading: setSourceParamsLoading,
                sourceParamsError: sourceParamsError,
                setSourceParamsError: setSourceParamsError,
                setJustSavedTimeout: setJustSavedTimeout,
                sourceErrors: sourceErrors,
                setSourceErrors: setSourceErrors,
                dirty: dirty,
                setDirty: setDirty,
                sourceElem: sourceElem,
                sourceError: source.error,
                source: editedSource
            }) : null
        ]
    });
}
$559aa794d8d2d8fd$export$2e2bcd8739ae039.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    spouts: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setSpouts: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    dirty: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setDirtySources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};







var $eHaBZ = parcelRequire("eHaBZ");



var $eHaBZ = parcelRequire("eHaBZ");
/**
 * useMediaMatch
 *
 * A react hook that signals whether or not a media query is matched.
 *
 * @param query The media query to signal on. Example, `"print"` will signal
 * `true` when previewing in print mode, and `false` otherwise.
 * @returns Whether or not the media query is currently matched.
 * @see https://rooks.vercel.app/docs/useMediaMatch
 */ function $91ca5a7b31687b1c$export$b1eecdc553bff745(query) {
    var matchMedia = (0, $eHaBZ.useMemo)(function() {
        return window.matchMedia(query);
    }, [
        query
    ]);
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(function() {
        return matchMedia.matches;
    }), 2), matches = _useState[0], setMatches = _useState[1];
    (0, $eHaBZ.useEffect)(function() {
        setMatches(matchMedia.matches);
        var listener = function(event) {
            return setMatches(event.matches);
        };
        if (matchMedia.addEventListener) {
            matchMedia.addEventListener("change", listener);
            return function() {
                return matchMedia.removeEventListener("change", listener);
            };
        } else {
            matchMedia.addListener(listener);
            return function() {
                return matchMedia.removeListener(listener);
            };
        }
    }, [
        matchMedia
    ]);
    if (typeof window === "undefined") {
        console.warn("useMediaMatch cannot function as window is undefined.");
        return false;
    }
    return matches;
}


function $c8aedc92b88eb948$export$7bcdf1c247ef07b1() {
    var _location_state;
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var forceReload = location === null || location === void 0 ? void 0 : (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.forceReload;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(forceReload), 2), oldForceReload = _useState[0], setOldForceReload = _useState[1];
    if (oldForceReload !== forceReload) setOldForceReload(forceReload);
    // The location state is not persisted during navigation
    // so forceReload would change to undefined on successive navigation,
    // triggering an unwanter reload.
    // We use a separate counter to prevent that.
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(0), 2), reloadCounter = _useState1[0], setReloadCounter = _useState1[1];
    if (forceReload !== undefined && forceReload !== oldForceReload) {
        var newReloadCounter = reloadCounter + 1;
        setReloadCounter(newReloadCounter);
        return newReloadCounter;
    }
    return reloadCounter;
}
function $c8aedc92b88eb948$export$443718c44347a6b3() {
    return (0, $91ca5a7b31687b1c$export$b1eecdc553bff745)("(max-width: 641px)");
}
function $c8aedc92b88eb948$export$96b5b894afc1d2e3(valueListenable) {
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(valueListenable.value), 2), value = _useState[0], setValue = _useState[1];
    (0, $eHaBZ.useEffect)(function() {
        var listener = function(event) {
            setValue(event.value);
        };
        // It might happen that values change between creating the component and setting up the event handlers.
        listener({
            value: valueListenable.value
        });
        valueListenable.addEventListener("change", listener);
        return function() {
            valueListenable.removeEventListener("change", listener);
        };
    }, [
        valueListenable
    ]);
    return value;
}




function $160db82a87133f5d$var$rand() {
    // https://www.php.net/manual/en/function.mt-getrandmax.php#117620
    return Math.floor(Math.random() * 2147483647);
}
function $160db82a87133f5d$var$handleAddSource(param) {
    var _param_event = param.event, event = _param_event === void 0 ? null : _param_event, setSources = param.setSources, setSpouts = param.setSpouts, _param_extraInitialData = param.extraInitialData, extraInitialData = _param_extraInitialData === void 0 ? {} : _param_extraInitialData;
    if (event) event.preventDefault();
    // Add new empty source.
    setSources(function(sources) {
        return [
            (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
                id: "new-" + $160db82a87133f5d$var$rand()
            }, extraInitialData)
        ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(sources));
    });
    // Refresh the spout datea
    $b0e03640e062f6f9$export$ba43f46f09336c84().then(function(param) {
        var spouts = param.spouts;
        // Update spout data.
        setSpouts(spouts);
    }).catch(function() {
        console.error("Unable to update spouts, falling back to previously fetched list.");
    });
}
// load sources
function $160db82a87133f5d$var$loadSources(param) {
    var abortController = param.abortController, location = param.location, setSpouts = param.setSpouts, setSources = param.setSources, setLoadingState = param.setLoadingState;
    if (abortController.signal.aborted) return Promise.resolve();
    setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
    return (0, $b0e03640e062f6f9$export$316f19f1ddc6b34e)(abortController).then(function(param) {
        var sources = param.sources, spouts = param.spouts;
        if (abortController.signal.aborted) return;
        setSpouts(spouts);
        setSources(sources);
        setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
        if (location.hash.startsWith("#source-")) {
            var source = document.querySelector('.source[data-id="'.concat(location.hash.replace(/^#source-/, ""), '"]'));
            if (!source) return;
            // needs to be delayed for some reason
            requestAnimationFrame(function() {
                source.scrollIntoView();
            });
        }
    }).catch(function(error) {
        if (error.name === "AbortError" || abortController.signal.aborted) return;
        selfoss.handleAjaxError(error, false).catch(function(error) {
            if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                selfoss.history.push("/sign/in", {
                    error: selfoss.app._("error_session_expired")
                });
                return;
            }
            selfoss.app.showError(selfoss.app._("error_loading") + " " + error.message);
        });
        setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
    });
}
function $160db82a87133f5d$export$2e2bcd8739ae039() {
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)([]), 2), spouts = _useState[0], setSpouts = _useState[1];
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)([]), 2), sources = _useState1[0], setSources = _useState1[1];
    var _useState2 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL), 2), loadingState = _useState2[0], setLoadingState = _useState2[1];
    var forceReload = (0, $c8aedc92b88eb948$export$7bcdf1c247ef07b1)();
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var isAdding = (0, $c1feef6a502006a1$export$632be4bb944c1bc7)("/manage/sources/add");
    (0, $eHaBZ.useEffect)(function() {
        var abortController = new AbortController();
        $160db82a87133f5d$var$loadSources({
            abortController: abortController,
            location: location,
            setSpouts: setSpouts,
            setSources: setSources,
            setLoadingState: setLoadingState
        }).then(function() {
            if (isAdding) {
                var params = new URLSearchParams(location.search);
                var _params_get;
                $160db82a87133f5d$var$handleAddSource({
                    setSources: setSources,
                    setSpouts: setSpouts,
                    extraInitialData: {
                        spout: "spouts\\rss\\feed",
                        params: {
                            url: (_params_get = params.get("url")) !== null && _params_get !== void 0 ? _params_get : ""
                        }
                    }
                });
                // Clear the value from the state so it does not bug us forever.
                history.replace("/manage/sources");
            }
        });
        return function() {
            abortController.abort();
        };
    }, [
        forceReload
    ]);
    var addOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $160db82a87133f5d$var$handleAddSource({
            event: event,
            setSources: setSources,
            setSpouts: setSpouts
        });
    }, []);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var _useState3 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)({}), 2), dirtySources = _useState3[0], setDirtySources = _useState3[1];
    var isDirty = (0, $eHaBZ.useMemo)(function() {
        return Object.values(dirtySources).includes(true);
    }, [
        dirtySources
    ]);
    if (loadingState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$84dbad74efe95918), {
        label: _("sources_loading")
    });
    if (loadingState !== (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS) return null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$83716a4aa1642908), {
                when: isDirty,
                message: _("sources_leaving_unsaved_prompt")
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                className: "source-add",
                onClick: addOnClick,
                children: _("source_add")
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                className: "source-export",
                href: "opmlexport",
                children: _("source_export")
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                className: "source-opml",
                to: "/opml",
                children: _("source_opml")
            }),
            sources ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                children: sources.map(function(source) /*#__PURE__*/ {
                    var _dirtySources_source_id;
                    return (0, $f171543c027e46e7$exports.jsx)((0, $559aa794d8d2d8fd$export$2e2bcd8739ae039), {
                        dirty: (_dirtySources_source_id = dirtySources[source.id]) !== null && _dirtySources_source_id !== void 0 ? _dirtySources_source_id : false,
                        source: source,
                        setSources: setSources,
                        spouts: spouts,
                        setSpouts: setSpouts,
                        setDirtySources: setDirtySources
                    }, source.id);
                })
            }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                children: _("no_sources")
            })
        ]
    });
}














var $eHaBZ = parcelRequire("eHaBZ");



var $52218fae2790199f$exports = {};
"use strict";
Object.defineProperty($52218fae2790199f$exports, "__esModule", {
    value: true
});
$52218fae2790199f$exports.useStateWithDeps = $52218fae2790199f$var$useStateWithDeps;

var $eHaBZ = parcelRequire("eHaBZ");
var $fa3cfc9f742f9e64$exports = {};
"use strict";
Object.defineProperty($fa3cfc9f742f9e64$exports, "__esModule", {
    value: true
});
$fa3cfc9f742f9e64$exports.useForceUpdate = $fa3cfc9f742f9e64$var$useForceUpdate;

var $eHaBZ = parcelRequire("eHaBZ");
function $fa3cfc9f742f9e64$var$_slicedToArray(arr, i) {
    return $fa3cfc9f742f9e64$var$_arrayWithHoles(arr) || $fa3cfc9f742f9e64$var$_iterableToArrayLimit(arr, i) || $fa3cfc9f742f9e64$var$_unsupportedIterableToArray(arr, i) || $fa3cfc9f742f9e64$var$_nonIterableRest();
}
function $fa3cfc9f742f9e64$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fa3cfc9f742f9e64$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fa3cfc9f742f9e64$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fa3cfc9f742f9e64$var$_arrayLikeToArray(o, minLen);
}
function $fa3cfc9f742f9e64$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fa3cfc9f742f9e64$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fa3cfc9f742f9e64$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fa3cfc9f742f9e64$var$useForceUpdate() {
    var _useReducer = (0, $eHaBZ.useReducer)(function(x) {
        return !x;
    }, false), _useReducer2 = $fa3cfc9f742f9e64$var$_slicedToArray(_useReducer, 2), forceUpdate = _useReducer2[1];
    return function() {
        return forceUpdate();
    };
}


var $686edff819e0378d$exports = {};
"use strict";
Object.defineProperty($686edff819e0378d$exports, "__esModule", {
    value: true
});
$686edff819e0378d$exports.depsAreEqual = $686edff819e0378d$var$depsAreEqual;
function $686edff819e0378d$var$depsAreEqual(prevDeps, deps) {
    return prevDeps.length === deps.length && deps.every(function(dep, index) {
        return Object.is(dep, prevDeps[index]);
    });
}


var $77b0cc4e4744fb64$exports = {};
"use strict";
Object.defineProperty($77b0cc4e4744fb64$exports, "__esModule", {
    value: true
});
$77b0cc4e4744fb64$exports.isFunction = $77b0cc4e4744fb64$var$isFunction;
// eslint-disable-next-line @typescript-eslint/ban-types
function $77b0cc4e4744fb64$var$isFunction(input) {
    return typeof input === "function";
}


/**
 * `useState` hook with an additional dependency array that resets
 * the state to the `initialState` param when the dependencies passed
 * in the `deps` array change.
 *
 * @param initialState
 * The state that will be set when the component mounts or the
 * dependencies change.
 *
 * It can also be a function which resolves to the state. If the state
 * is reset due to a change of dependencies, this function will be called with the previous
 * state (`undefined` for the first call upon mount).
 * @param deps Dependencies for this hook that resets the state to `initialState`
 */ function $52218fae2790199f$var$useStateWithDeps(initialState, deps) {
    var isMounted = (0, $eHaBZ.useRef)(false); // Determine initial state
    var usableInitialState = null;
    if (!isMounted.current) {
        isMounted.current = true;
        if ((0, $77b0cc4e4744fb64$exports.isFunction)(initialState)) usableInitialState = initialState();
        else usableInitialState = initialState;
    } // It would be possible to use useState instead of
    // useRef to store the state, however this would
    // trigger re-renders whenever the state is reset due
    // to a change in dependencies. In order to avoid these
    // re-renders, the state is stored in a ref and an
    // update is triggered via forceUpdate below when necessary
    var state = (0, $eHaBZ.useRef)(usableInitialState); // Check if dependencies have changed
    var prevDeps = (0, $eHaBZ.useRef)(deps);
    if (!(0, $686edff819e0378d$exports.depsAreEqual)(prevDeps.current, deps)) {
        // Update state and deps
        var nextState;
        if ((0, $77b0cc4e4744fb64$exports.isFunction)(initialState)) nextState = initialState(state.current);
        else nextState = initialState;
        state.current = nextState;
        prevDeps.current = deps;
    }
    var forceUpdate = (0, $fa3cfc9f742f9e64$exports.useForceUpdate)();
    var updateState = (0, $eHaBZ.useCallback)(function updateState(newState) {
        var nextState;
        if ((0, $77b0cc4e4744fb64$exports.isFunction)(newState)) nextState = newState(state.current);
        else nextState = newState;
        if (!Object.is(state.current, nextState)) {
            state.current = nextState;
            forceUpdate();
        }
    }, []);
    return [
        state.current,
        updateState
    ];
}








var $eHaBZ = parcelRequire("eHaBZ");



var $eHaBZ = parcelRequire("eHaBZ");
/**
 * usePreviousImmediate hook for React
 *
 * @param currentValue The value whose previous value is to be tracked
 * @returns The previous value
 * @see https://rooks.vercel.app/docs/usePreviousImmediate
 */ function $45d08aa99719a2d0$export$f6f3f74729fdd0b7(currentValue) {
    var previousRef = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        previousRef.current = currentValue;
    });
    return previousRef.current;
}




/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $2bfPH = parcelRequire("2bfPH");
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $863eb30dd7d7e7a9$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $863eb30dd7d7e7a9$var$candidateSelector = /* #__PURE__ */ $863eb30dd7d7e7a9$var$candidateSelectors.join(",");
var $863eb30dd7d7e7a9$var$NoElement = typeof Element === "undefined";
var $863eb30dd7d7e7a9$var$matches = $863eb30dd7d7e7a9$var$NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $863eb30dd7d7e7a9$var$getRootNode = !$863eb30dd7d7e7a9$var$NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $863eb30dd7d7e7a9$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $863eb30dd7d7e7a9$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $863eb30dd7d7e7a9$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($863eb30dd7d7e7a9$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($863eb30dd7d7e7a9$var$candidateSelector));
    if (includeContainer && $863eb30dd7d7e7a9$var$matches.call(el, $863eb30dd7d7e7a9$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $863eb30dd7d7e7a9$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($863eb30dd7d7e7a9$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $863eb30dd7d7e7a9$var$matches.call(element, $863eb30dd7d7e7a9$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$863eb30dd7d7e7a9$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $863eb30dd7d7e7a9$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $863eb30dd7d7e7a9$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $863eb30dd7d7e7a9$var$isContentEditable(node)) && !$863eb30dd7d7e7a9$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $863eb30dd7d7e7a9$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $863eb30dd7d7e7a9$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$863eb30dd7d7e7a9$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $863eb30dd7d7e7a9$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $863eb30dd7d7e7a9$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $863eb30dd7d7e7a9$var$isHiddenInput = function isHiddenInput(node) {
    return $863eb30dd7d7e7a9$var$isInput(node) && node.type === "hidden";
};
var $863eb30dd7d7e7a9$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $863eb30dd7d7e7a9$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $863eb30dd7d7e7a9$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $863eb30dd7d7e7a9$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $863eb30dd7d7e7a9$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $863eb30dd7d7e7a9$var$isRadio = function isRadio(node) {
    return $863eb30dd7d7e7a9$var$isInput(node) && node.type === "radio";
};
var $863eb30dd7d7e7a9$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $863eb30dd7d7e7a9$var$isRadio(node) && !$863eb30dd7d7e7a9$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $863eb30dd7d7e7a9$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $863eb30dd7d7e7a9$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $863eb30dd7d7e7a9$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $863eb30dd7d7e7a9$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $863eb30dd7d7e7a9$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $863eb30dd7d7e7a9$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($863eb30dd7d7e7a9$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $863eb30dd7d7e7a9$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $863eb30dd7d7e7a9$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($863eb30dd7d7e7a9$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $863eb30dd7d7e7a9$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $863eb30dd7d7e7a9$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $863eb30dd7d7e7a9$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $863eb30dd7d7e7a9$var$isInert(node) || $863eb30dd7d7e7a9$var$isHiddenInput(node) || $863eb30dd7d7e7a9$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $863eb30dd7d7e7a9$var$isDetailsWithSummary(node) || $863eb30dd7d7e7a9$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($863eb30dd7d7e7a9$var$isNonTabbableRadio(node) || $863eb30dd7d7e7a9$export$a4672efddb4181b8(node) < 0 || !$863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $863eb30dd7d7e7a9$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $863eb30dd7d7e7a9$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $863eb30dd7d7e7a9$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($863eb30dd7d7e7a9$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $863eb30dd7d7e7a9$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $863eb30dd7d7e7a9$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $863eb30dd7d7e7a9$var$isValidShadowRootTabbable
    });
    else candidates = $863eb30dd7d7e7a9$var$getCandidates(container, options.includeContainer, $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $863eb30dd7d7e7a9$var$sortByOrder(candidates);
};
var $863eb30dd7d7e7a9$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $863eb30dd7d7e7a9$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $863eb30dd7d7e7a9$var$getCandidates(container, options.includeContainer, $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $863eb30dd7d7e7a9$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($863eb30dd7d7e7a9$var$matches.call(node, $863eb30dd7d7e7a9$var$candidateSelector) === false) return false;
    return $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable(options, node);
};
var $863eb30dd7d7e7a9$var$focusableCandidateSelector = /* #__PURE__ */ $863eb30dd7d7e7a9$var$candidateSelectors.concat("iframe").join(",");
var $863eb30dd7d7e7a9$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($863eb30dd7d7e7a9$var$matches.call(node, $863eb30dd7d7e7a9$var$focusableCandidateSelector) === false) return false;
    return $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable(options, node);
};


function $197853feae65c1a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $197853feae65c1a7$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $197853feae65c1a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $197853feae65c1a7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $197853feae65c1a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $197853feae65c1a7$var$_defineProperty(obj, key, value) {
    key = $197853feae65c1a7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $197853feae65c1a7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $197853feae65c1a7$var$_toPropertyKey(arg) {
    var key = $197853feae65c1a7$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $2bfPH._)(key)) === "symbol" ? key : String(key);
}
var $197853feae65c1a7$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var $197853feae65c1a7$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var $197853feae65c1a7$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $197853feae65c1a7$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $197853feae65c1a7$var$isKeyForward = function isKeyForward(e) {
    return $197853feae65c1a7$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $197853feae65c1a7$var$isKeyBackward = function isKeyBackward(e) {
    return $197853feae65c1a7$var$isTabEvent(e) && e.shiftKey;
};
var $197853feae65c1a7$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var $197853feae65c1a7$var$findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $197853feae65c1a7$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var $197853feae65c1a7$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $197853feae65c1a7$var$internalTrapStack = [];
var $197853feae65c1a7$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $197853feae65c1a7$var$internalTrapStack;
    var config = $197853feae65c1a7$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $197853feae65c1a7$var$isKeyForward,
        isKeyBackward: $197853feae65c1a7$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus");
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || !(0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $863eb30dd7d7e7a9$export$17100aea90429aa7)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $863eb30dd7d7e7a9$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === getActiveElement(document)) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($197853feae65c1a7$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref2) {
        var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
        target = target || $197853feae65c1a7$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = $197853feae65c1a7$var$findIndex(state.tabbableGroups, function(_ref3) {
                    var firstTabbableNode = _ref3.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$197853feae65c1a7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = $197853feae65c1a7$var$findIndex(state.tabbableGroups, function(_ref4) {
                    var lastTabbableNode = _ref4.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$197853feae65c1a7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $197853feae65c1a7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($197853feae65c1a7$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($197853feae65c1a7$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $197853feae65c1a7$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) tryFocus(nextNode);
            else tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($197853feae65c1a7$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(event) {
        if ($197853feae65c1a7$var$isEscapeEvent(event) && $197853feae65c1a7$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
            return;
        }
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkClick = function checkClick(e) {
        var target = $197853feae65c1a7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($197853feae65c1a7$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($197853feae65c1a7$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $197853feae65c1a7$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $197853feae65c1a7$var$delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $197853feae65c1a7$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $197853feae65c1a7$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $197853feae65c1a7$var$delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (state.paused || !state.active) return this;
            var onPause = getOption(pauseOptions, "onPause");
            var onPostPause = getOption(pauseOptions, "onPostPause");
            state.paused = true;
            onPause === null || onPause === void 0 || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === void 0 || onPostPause();
            return this;
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.paused || !state.active) return this;
            var onUnpause = getOption(unpauseOptions, "onUnpause");
            var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
            state.paused = false;
            onUnpause === null || onUnpause === void 0 || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};




var $eHaBZ = parcelRequire("eHaBZ");
function $bd320d0e16baa5f3$export$3b062b02b4537682() {
    return (0, $c8aedc92b88eb948$export$96b5b894afc1d2e3)(selfoss.loggedin);
}
function $bd320d0e16baa5f3$export$f5bdb3b3cec7f803() {
    var loggedIn = $bd320d0e16baa5f3$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return selfoss.isAllowedToRead();
    }, [
        loggedIn
    ]);
}
function $bd320d0e16baa5f3$export$683005ba76038aff() {
    var loggedIn = $bd320d0e16baa5f3$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return selfoss.isAllowedToUpdate();
    }, [
        loggedIn
    ]);
}
function $bd320d0e16baa5f3$export$b416b77cd328c02f() {
    var loggedIn = $bd320d0e16baa5f3$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return selfoss.isAllowedToWrite();
    }, [
        loggedIn
    ]);
}






var $b625dc2dd2df76bd$export$cacd6541cfeeb6c1 = {
    PREV: "prev",
    NEXT: "next"
};
function $b625dc2dd2df76bd$export$d976747ecb966cea(target) {
    var viewportHeight = document.body.clientHeight;
    var viewportScrollTop = window.scrollY;
    var targetBb = target.getBoundingClientRect();
    var targetTop = window.scrollY + targetBb.top;
    var targetHeight = targetBb.height;
    // scroll down
    if (viewportScrollTop + viewportHeight < targetTop + targetHeight + 80) {
        if (targetHeight > viewportHeight) window.scrollTo({
            top: targetTop
        });
        else {
            var marginTop = (viewportHeight - targetHeight) / 2;
            var scrollTop = targetTop - marginTop;
            window.scrollTo({
                top: scrollTop
            });
        }
    }
    // scroll up
    if (targetTop <= viewportScrollTop) window.scrollTo({
        top: targetTop
    });
}






var $eHaBZ = parcelRequire("eHaBZ");

var $419292d15b74e6e0$exports = {};
var $ef4a30588310d5d7$exports = {};
function $ef4a30588310d5d7$var$_arrayReduce(reducer, acc, list) {
    var index = 0;
    var length = list.length;
    while(index < length){
        acc = reducer(acc, list[index]);
        index += 1;
    }
    return acc;
}
$ef4a30588310d5d7$exports = $ef4a30588310d5d7$var$_arrayReduce;



var $f4091c18d79168b1$exports = {};

var $b1373d49cfb8ba69$exports = {};
function $b1373d49cfb8ba69$var$_isTransformer(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}
$b1373d49cfb8ba69$exports = $b1373d49cfb8ba69$var$_isTransformer;


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */ function $f4091c18d79168b1$var$_dispatchable(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!$73fb5ea04d9dead1$exports(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ($b1373d49cfb8ba69$exports(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}
$f4091c18d79168b1$exports = $f4091c18d79168b1$var$_dispatchable;


var $8b790a9e48f0992d$exports = {};
function $8b790a9e48f0992d$var$_map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}
$8b790a9e48f0992d$exports = $8b790a9e48f0992d$var$_map;


var $2f7cea74d4afd9d8$exports = {};
var $8ad75158a6dee908$exports = {};
$8ad75158a6dee908$exports = {
    init: function init() {
        return this.xf["@@transducer/init"]();
    },
    result: function result(_result) {
        return this.xf["@@transducer/result"](_result);
    }
};


var $2f7cea74d4afd9d8$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = $8ad75158a6dee908$exports.init;
    XMap.prototype["@@transducer/result"] = $8ad75158a6dee908$exports.result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var $2f7cea74d4afd9d8$var$_xmap = function _xmap(f) {
    return function(xf) {
        return new $2f7cea74d4afd9d8$var$XMap(f, xf);
    };
};
$2f7cea74d4afd9d8$exports = $2f7cea74d4afd9d8$var$_xmap;


var $76af6f4bdc955f60$exports = {};



var $d7d932f9cbe80b4e$exports = {};


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $d7d932f9cbe80b4e$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        var hasPlaceholder = false;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$f6709ecef4b253a2$exports(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$f6709ecef4b253a2$exports(result)) left -= 1;
            else hasPlaceholder = true;
            combinedIdx += 1;
        }
        return !hasPlaceholder && left <= 0 ? fn.apply(this, combined) : $7629ad89266bbe6b$exports(Math.max(0, left), $d7d932f9cbe80b4e$var$_curryN(length, combined, fn));
    };
}
$d7d932f9cbe80b4e$exports = $d7d932f9cbe80b4e$var$_curryN;


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $76af6f4bdc955f60$var$curryN = /*#__PURE__*/ $16cdbc498258dabf$exports(function curryN(length, fn) {
    if (length === 1) return $7e9ffa7fa815703c$exports(fn);
    return $7629ad89266bbe6b$exports(length, $d7d932f9cbe80b4e$exports(length, [], fn));
});
$76af6f4bdc955f60$exports = $76af6f4bdc955f60$var$curryN;


var $a97e5ea9fcd3c823$exports = {};


var $69a5e3c09611504c$exports = {};

var $69a5e3c09611504c$var$toString = Object.prototype.toString;
var $69a5e3c09611504c$var$_isArguments = /*#__PURE__*/ function() {
    return $69a5e3c09611504c$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $69a5e3c09611504c$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return $8659c368bdbba7be$exports("callee", x);
    };
}();
$69a5e3c09611504c$exports = $69a5e3c09611504c$var$_isArguments;


var $a97e5ea9fcd3c823$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $a97e5ea9fcd3c823$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
]; // Safari bug
var $a97e5ea9fcd3c823$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $a97e5ea9fcd3c823$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $a97e5ea9fcd3c823$var$keys = typeof Object.keys === "function" && !$a97e5ea9fcd3c823$var$hasArgsEnumBug ? /*#__PURE__*/ $7e9ffa7fa815703c$exports(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ $7e9ffa7fa815703c$exports(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $a97e5ea9fcd3c823$var$hasArgsEnumBug && $69a5e3c09611504c$exports(obj);
    for(prop in obj)if ($8659c368bdbba7be$exports(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($a97e5ea9fcd3c823$var$hasEnumBug) {
        nIdx = $a97e5ea9fcd3c823$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $a97e5ea9fcd3c823$var$nonEnumerableProps[nIdx];
            if ($8659c368bdbba7be$exports(prop, obj) && !$a97e5ea9fcd3c823$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
$a97e5ea9fcd3c823$exports = $a97e5ea9fcd3c823$var$keys;


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $419292d15b74e6e0$var$map = /*#__PURE__*/ $16cdbc498258dabf$exports(/*#__PURE__*/ $f4091c18d79168b1$exports([
    "fantasy-land/map",
    "map"
], $2f7cea74d4afd9d8$exports, function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return $76af6f4bdc955f60$exports(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return $ef4a30588310d5d7$exports(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, $a97e5ea9fcd3c823$exports(functor));
        default:
            return $8b790a9e48f0992d$exports(fn, functor);
    }
}));
$419292d15b74e6e0$exports = $419292d15b74e6e0$var$map;




function $8ee8a2a1e50ded87$var$materializeSharerIcon(sharer) {
    var icon = sharer.icon;
    return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, sharer), {
        icon: typeof icon === "string" && icon.includes("<") ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: icon
            }
        }) : icon
    });
}
function $8ee8a2a1e50ded87$export$aebedbd51beb48eb(param) {
    var configuration = param.configuration, _ = param._;
    return (0, $eHaBZ.useMemo)(function() {
        var _selfoss_customSharers;
        var availableSharers = (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
            "a": {
                label: _("share_native_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $5f3a6b596119c825$exports.faShareAlt
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    navigator.share({
                        title: title,
                        url: url
                    }).catch(function(e) {
                        if (e.name === "AbortError") (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError(_("error_share_native_abort"));
                        else (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError(_("error_share_native"));
                    });
                },
                available: "share" in navigator
            },
            "d": {
                label: _("share_diaspora_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $8216ee54ed5c099f$exports.faDiaspora
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open("https://share.diasporafoundation.org/?url=" + encodeURIComponent(url) + "&title=" + encodeURIComponent(title), undefined, "noreferrer");
                }
            },
            "t": {
                label: _("share_twitter_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $11826e5bf54ad532$exports.faTwitter
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open("https://twitter.com/intent/tweet?source=webclient&text=" + encodeURIComponent(title) + " " + encodeURIComponent(url), undefined, "noreferrer");
                }
            },
            "f": {
                label: _("share_facebook_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $a5565bc5d7aa9135$exports.faFacebookSquare
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url) + "&t=" + encodeURIComponent(title), undefined, "noreferrer");
                }
            },
            "m": {
                label: _("share_mastodon_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $b92068b2b2ac161b$exports.faMastodon
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open(configuration.mastodon + "/share?text=" + encodeURIComponent('"' + title + '"\n' + url), undefined, "noreferrer");
                },
                available: configuration.mastodon !== null
            },
            "p": {
                label: _("share_pocket_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $acd52ab24d9744ba$exports.faGetPocket
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open("https://getpocket.com/save?url=" + encodeURIComponent(url) + "&title=" + encodeURIComponent(title), undefined, "noreferrer");
                }
            },
            "w": {
                label: _("share_wallabag_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $8cad2150f94e1c78$export$a67558cb68d63c7e
                }),
                action: function(param) {
                    var url = param.url;
                    if (configuration.wallabag.version === 2) window.open(configuration.wallabag.url + "/bookmarklet?url=" + encodeURIComponent(url), undefined, "noreferrer");
                    else window.open(configuration.wallabag.url + "/?action=add&url=" + btoa(url), undefined, "noreferrer");
                },
                available: configuration.wallabag !== null
            },
            "s": {
                label: _("share_wordpress_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $8ebe08a4e3d0a860$exports.faWordpressSimple
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open(configuration.wordpress + "/wp-admin/press-this.php?u=" + encodeURIComponent(url) + "&t=" + encodeURIComponent(title), undefined, "noreferrer");
                },
                available: configuration.wordpress !== null
            },
            "e": {
                label: _("share_mail_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $5aa79799bc179db8$exports.faEnvelope
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    document.location.href = "mailto:?body=" + encodeURIComponent(url) + "&subject=" + encodeURIComponent(title);
                }
            },
            "c": {
                label: _("share_copy_label"),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $7f79cc0a934ae117$exports.faCopy
                }),
                action: function(param) {
                    var url = param.url;
                    navigator.clipboard.writeText(url).then(function() {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showMessage(_("info_url_copied"));
                    });
                }
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($419292d15b74e6e0$exports)))($8ee8a2a1e50ded87$var$materializeSharerIcon, (_selfoss_customSharers = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).customSharers) !== null && _selfoss_customSharers !== void 0 ? _selfoss_customSharers : {}));
        var enabledSharers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = configuration.share[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var letter = _step.value;
                var sharer = availableSharers[letter];
                var _sharer_available;
                if (sharer !== undefined && ((_sharer_available = sharer.available) !== null && _sharer_available !== void 0 ? _sharer_available : true)) {
                    var label = sharer.label, icon = sharer.icon, action = sharer.action;
                    enabledSharers.push({
                        key: letter,
                        label: label,
                        icon: icon,
                        action: action
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return enabledSharers;
    }, [
        configuration,
        _
    ]);
}









var $eHaBZ = parcelRequire("eHaBZ");
var $b17a7fd270a24b50$export$83fe3bee12eb51bb = "carousel";
var $b17a7fd270a24b50$export$b861c6f4d58b4c2f = "controller";
var $b17a7fd270a24b50$export$607ce719f0ec9b98 = "navigation";
var $b17a7fd270a24b50$export$52cbc29cf5406ba8 = "no-scroll";
var $b17a7fd270a24b50$export$9d2e4856063e1a22 = "portal";
var $b17a7fd270a24b50$export$62f3c66ae8dab8a3 = "root";
var $b17a7fd270a24b50$export$5414719b40b8294f = "toolbar";
var $b17a7fd270a24b50$export$a23b14c1465897d = "captions";
var $b17a7fd270a24b50$export$8ae0dbe553798d04 = "counter";
var $b17a7fd270a24b50$export$ace9d67c0f2290af = "download";
var $b17a7fd270a24b50$export$4792108761b262a9 = "fullscreen";
var $b17a7fd270a24b50$export$c21ea5a712f18fb6 = "inline";
var $b17a7fd270a24b50$export$6bbdc870e6ef9c88 = "share";
var $b17a7fd270a24b50$export$be7dc72e63e6ef2e = "slideshow";
var $b17a7fd270a24b50$export$6bf9d56640f46f01 = "thumbnails";
var $b17a7fd270a24b50$export$929980e2a2c57ecf = "zoom";
var $b17a7fd270a24b50$export$554a1415841c52a8 = "loading";
var $b17a7fd270a24b50$export$38ce62e512432ebb = "playing";
var $b17a7fd270a24b50$export$2ed3c80dbc178d91 = "error";
var $b17a7fd270a24b50$export$a195e517d37aaa33 = "complete";
var $b17a7fd270a24b50$export$e51f1c6d74b54a13 = "placeholder";
var $b17a7fd270a24b50$export$6751782e799f6445 = function(status) {
    return "active-slide-".concat(status);
};
var $b17a7fd270a24b50$export$7ab73e7383503259 = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$554a1415841c52a8);
var $b17a7fd270a24b50$export$ccb5eb0b2db52ae8 = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$38ce62e512432ebb);
var $b17a7fd270a24b50$export$817be438d1d0e4cf = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$2ed3c80dbc178d91);
var $b17a7fd270a24b50$export$2ec1d32caeb97dfe = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$a195e517d37aaa33);
var $b17a7fd270a24b50$export$37b171d829eeeaa2 = "fullsize";
var $b17a7fd270a24b50$export$974a68ef150451f5 = "flex_center";
var $b17a7fd270a24b50$export$b6426a00c33a0175 = "no_scroll";
var $b17a7fd270a24b50$export$651541414233b476 = "no_scroll_padding";
var $b17a7fd270a24b50$export$ac396c284080b10c = "slide_wrapper";
var $b17a7fd270a24b50$export$a007161537026955 = "prev";
var $b17a7fd270a24b50$export$f1d7a854db833ed4 = "next";
var $b17a7fd270a24b50$export$c43bd1a4101c4078 = "swipe";
var $b17a7fd270a24b50$export$493a596486210a21 = "close";
var $b17a7fd270a24b50$export$e15fc153f45a963d = "onPointerDown";
var $b17a7fd270a24b50$export$1f8863949fbdd7e5 = "onPointerMove";
var $b17a7fd270a24b50$export$2d868b67a5791b8a = "onPointerUp";
var $b17a7fd270a24b50$export$526cafa85592f1a5 = "onPointerLeave";
var $b17a7fd270a24b50$export$22151cee048c4be9 = "onPointerCancel";
var $b17a7fd270a24b50$export$1aba4f3521686ca9 = "onKeyDown";
var $b17a7fd270a24b50$export$bdb9f99d61a6879b = "onKeyUp";
var $b17a7fd270a24b50$export$5635dc9d647242c7 = "onWheel";
var $b17a7fd270a24b50$export$e8d60d9b5ceff7c0 = "Escape";
var $b17a7fd270a24b50$export$17dec1da9b0e2eb3 = "ArrowLeft";
var $b17a7fd270a24b50$export$91898c0e7e48903 = "ArrowRight";
var $b17a7fd270a24b50$export$d62fb7722b07f2f3 = "button";
var $b17a7fd270a24b50$export$c5f5ca1963fed141 = "icon";
var $b17a7fd270a24b50$export$eff7fe5eefd707ad = "contain";
var $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f = "cover";
var $b17a7fd270a24b50$export$b149fc25cb186fec = "Unknown action type";



"use client";
var $2e545d666ef3112d$export$4f5d2d50c9deca37 = function() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(classes).filter(function(cls) {
        return Boolean(cls);
    }).join(" ");
};
var $2e545d666ef3112d$var$cssPrefix$3 = "yarl__";
var $2e545d666ef3112d$export$1283875077dc8f0a = function(name) {
    return "".concat($2e545d666ef3112d$var$cssPrefix$3).concat(name);
};
var $2e545d666ef3112d$export$8b4981022bd80a4e = function(name) {
    return "--".concat($2e545d666ef3112d$var$cssPrefix$3).concat(name);
};
var $2e545d666ef3112d$export$195c4126907dde97 = function(base, prefix) {
    return "".concat(base).concat(prefix ? "_".concat(prefix) : "");
};
var $2e545d666ef3112d$export$3e7cd27eed1727c = function(base) {
    return function(prefix) {
        return $2e545d666ef3112d$export$195c4126907dde97(base, prefix);
    };
};
var $2e545d666ef3112d$export$1237798dc640739a = function(labels, lbl) {
    return labels && labels[lbl] ? labels[lbl] : lbl;
};
var $2e545d666ef3112d$export$de863c629cb9919d = function() {
    for(var _len = arguments.length, cleaners = new Array(_len), _key = 0; _key < _len; _key++){
        cleaners[_key] = arguments[_key];
    }
    return function() {
        cleaners.forEach(function(cleaner) {
            cleaner();
        });
    };
};
var $2e545d666ef3112d$export$aac3e49c3c8b5cb0 = function(name, contextName, context) {
    return function() {
        var ctx = $eHaBZ.useContext(context);
        if (!ctx) throw new Error("".concat(name, " must be used within a ").concat(contextName, ".Provider"));
        return ctx;
    };
};
var $2e545d666ef3112d$export$fef62134eea24008 = function() {
    return typeof window !== "undefined";
};
function $2e545d666ef3112d$export$2077e0241d6afd3c(value) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var factor = Math.pow(10, decimals);
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
var $2e545d666ef3112d$export$55ec18c411514c07 = function(slide) {
    return slide.type === undefined || slide.type === "image";
};
var $2e545d666ef3112d$export$f5ba2f5b3fd12e6e = function(image, imageFit) {
    return image.imageFit === (0, $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f) || image.imageFit !== (0, $b17a7fd270a24b50$export$eff7fe5eefd707ad) && imageFit === (0, $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f);
};
function $2e545d666ef3112d$export$5f87784a266e50a4(value) {
    return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function $2e545d666ef3112d$export$7871fb532d320d99(input) {
    if (typeof input === "number") return {
        pixel: input
    };
    if (typeof input === "string") {
        var value = $2e545d666ef3112d$export$5f87784a266e50a4(input);
        return input.endsWith("%") ? {
            percent: value
        } : {
            pixel: value
        };
    }
    return {
        pixel: 0
    };
}
function $2e545d666ef3112d$export$7ff571008bce9900(containerRect, padding) {
    var paddingValue = $2e545d666ef3112d$export$7871fb532d320d99(padding);
    var paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0)
    };
}
var $2e545d666ef3112d$export$508f096bfcdaac40 = function() {
    return ($2e545d666ef3112d$export$fef62134eea24008() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
};
var $2e545d666ef3112d$export$501611100333094a = function(index, slidesCount) {
    return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
};
var $2e545d666ef3112d$export$883ece934910f98d = function(slides) {
    return slides.length > 0;
};
var $2e545d666ef3112d$export$cdfb855c5eb3bc84 = function(slides, index) {
    return slides[$2e545d666ef3112d$export$501611100333094a(index, slides.length)];
};
var $2e545d666ef3112d$export$9f2f3fed4fdffdfc = function(slides, index) {
    return $2e545d666ef3112d$export$883ece934910f98d(slides) ? $2e545d666ef3112d$export$cdfb855c5eb3bc84(slides, index) : undefined;
};
function $2e545d666ef3112d$export$34ce6a408311d810(toolbar, key, button) {
    if (!button) return toolbar;
    var buttons = toolbar.buttons, restToolbar = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(toolbar, [
        "buttons"
    ]);
    var index = buttons.findIndex(function(item) {
        return item === key;
    });
    var buttonWithKey = $eHaBZ.isValidElement(button) ? $eHaBZ.cloneElement(button, {
        key: key
    }, null) : button;
    if (index >= 0) {
        var result = (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(buttons);
        result.splice(index, 1, buttonWithKey);
        return (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
            buttons: result
        }, restToolbar);
    }
    return (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        buttons: [
            buttonWithKey
        ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(buttons))
    }, restToolbar);
}
function $2e545d666ef3112d$export$e88693bab67822d1() {
    var stopPropagation = function(event) {
        event.stopPropagation();
    };
    return {
        onPointerDown: stopPropagation,
        onKeyDown: stopPropagation,
        onWheel: stopPropagation
    };
}
function $2e545d666ef3112d$export$aab7f3145c728301(carousel, slides) {
    var minimum = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
var $2e545d666ef3112d$export$d626463445cef3e9 = {
    open: false,
    close: function() {},
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: {
        buttons: [
            (0, $b17a7fd270a24b50$export$493a596486210a21)
        ]
    },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out"
        }
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: (0, $b17a7fd270a24b50$export$eff7fe5eefd707ad),
        imageProps: {}
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullDown: false,
        closeOnBackdropClick: false
    },
    portal: {},
    noScroll: {
        disabled: false
    },
    on: {},
    styles: {},
    className: ""
};
function $2e545d666ef3112d$export$c5ba3739ffba980d(name, component) {
    return {
        name: name,
        component: component
    };
}
function $2e545d666ef3112d$export$270e7ba5936d3c48(module, children) {
    return {
        module: module,
        children: children
    };
}
function $2e545d666ef3112d$var$traverseNode(node, target, apply) {
    if (node.module.name === target) return apply(node);
    if (node.children) return [
        $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, node.children.flatMap(function(n) {
            var _a;
            return (_a = $2e545d666ef3112d$var$traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
        }))
    ];
    return [
        node
    ];
}
function $2e545d666ef3112d$var$traverse(nodes, target, apply) {
    return nodes.flatMap(function(node) {
        var _a;
        return (_a = $2e545d666ef3112d$var$traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
    });
}
function $2e545d666ef3112d$export$bc996c07eb970c78(root) {
    var plugins = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], augmentations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var config = root;
    var contains = function(target) {
        var nodes = (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(config);
        while(nodes.length > 0){
            var _nodes;
            var node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
            if (node === null || node === void 0 ? void 0 : node.children) (_nodes = nodes).push.apply(_nodes, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(node.children));
        }
        return false;
    };
    var addParent = function(target, module) {
        if (target === "") {
            config = [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, config)
            ];
            return;
        }
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, [
                    node
                ])
            ];
        });
    };
    var append = function(target, module) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module, node.children)
                ])
            ];
        });
    };
    var addChild = function(target, module, precede) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            var _a;
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(precede ? [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module)
                ] : []).concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)((_a = node.children) !== null && _a !== void 0 ? _a : []), (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(!precede ? [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module)
                ] : [])))
            ];
        });
    };
    var addSibling = function(target, module, precede) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(precede ? [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module)
            ] : []).concat([
                node
            ], (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(!precede ? [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module)
            ] : []));
        });
    };
    var addModule = function(module) {
        append((0, $b17a7fd270a24b50$export$b861c6f4d58b4c2f), module);
    };
    var replace = function(target, module) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, node.children)
            ];
        });
    };
    var remove = function(target) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return node.children;
        });
    };
    var augment = function(augmentation) {
        augmentations.push(augmentation);
    };
    plugins.forEach(function(plugin) {
        plugin({
            contains: contains,
            addParent: addParent,
            append: append,
            addChild: addChild,
            addSibling: addSibling,
            addModule: addModule,
            replace: replace,
            remove: remove,
            augment: augment
        });
    });
    return {
        config: config,
        augmentation: function(props) {
            return augmentations.reduce(function(acc, augmentation) {
                return augmentation(acc);
            }, props);
        }
    };
}
var $2e545d666ef3112d$export$f4208dae105d4d3 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$91a992459f6e0f07 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useEvents", "EventsContext", $2e545d666ef3112d$export$f4208dae105d4d3);
function $2e545d666ef3112d$export$686accdd53ac150f(param) {
    var children = param.children;
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState({}), 1), subscriptions = _React_useState[0];
    $eHaBZ.useEffect(function() {
        return function() {
            Object.keys(subscriptions).forEach(function(topic) {
                return delete subscriptions[topic];
            });
        };
    }, [
        subscriptions
    ]);
    var context = $eHaBZ.useMemo(function() {
        var unsubscribe = function(topic, callback) {
            var _a;
            var _a1;
            (_a1 = subscriptions[topic]) === null || _a1 === void 0 || (_a = _a1).splice.apply(_a, [
                0,
                subscriptions[topic].length
            ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(subscriptions[topic].filter(function(cb) {
                return cb !== callback;
            }))));
        };
        var subscribe = function(topic, callback) {
            if (!subscriptions[topic]) subscriptions[topic] = [];
            subscriptions[topic].push(callback);
            return function() {
                return unsubscribe(topic, callback);
            };
        };
        var publish = function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(_tmp, 2), topic = _tmp1[0], event = _tmp1[1];
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.forEach(function(callback) {
                return callback(event);
            });
        };
        return {
            publish: publish,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }, [
        subscriptions
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$f4208dae105d4d3.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$9f6b9cbf1d54cc28 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$d930f3536e1c64f6 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxProps", "LightboxPropsContext", $2e545d666ef3112d$export$9f6b9cbf1d54cc28);
function $2e545d666ef3112d$export$7141a340a3dea601(_param) {
    var children = _param.children, props = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "children"
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$9f6b9cbf1d54cc28.Provider, {
        value: props
    }, children);
}
var $2e545d666ef3112d$export$c24db94cf7704d3a = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$566121e2bbc52eec = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxState", "LightboxStateContext", $2e545d666ef3112d$export$c24db94cf7704d3a);
var $2e545d666ef3112d$export$42eb31c6c0f01c10 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$9463bb14d6ba055e = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxDispatch", "LightboxDispatchContext", $2e545d666ef3112d$export$42eb31c6c0f01c10);
function $2e545d666ef3112d$var$reducer(state, action) {
    switch(action.type){
        case "swipe":
            {
                var slides = state.slides;
                var increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
                var globalIndex = state.globalIndex + increment;
                var currentIndex = $2e545d666ef3112d$export$501611100333094a(globalIndex, slides.length);
                var currentSlide = $2e545d666ef3112d$export$9f2f3fed4fdffdfc(slides, currentIndex);
                var animation = increment || action.duration ? {
                    increment: increment,
                    duration: action.duration,
                    easing: action.easing
                } : undefined;
                return {
                    slides: slides,
                    currentIndex: currentIndex,
                    globalIndex: globalIndex,
                    currentSlide: currentSlide,
                    animation: animation
                };
            }
        case "update":
            if (action.slides !== state.slides || action.index !== state.currentIndex) return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: $2e545d666ef3112d$export$9f2f3fed4fdffdfc(action.slides, action.index)
            };
            return state;
        default:
            throw new Error((0, $b17a7fd270a24b50$export$b149fc25cb186fec));
    }
}
function $2e545d666ef3112d$export$62d2e1d2e7609988(param) {
    var slides = param.slides, index = param.index, children = param.children;
    var _React_useReducer = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useReducer($2e545d666ef3112d$var$reducer, {
        slides: slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: $2e545d666ef3112d$export$9f2f3fed4fdffdfc(slides, index)
    }), 2), state = _React_useReducer[0], dispatch = _React_useReducer[1];
    $eHaBZ.useEffect(function() {
        dispatch({
            type: "update",
            slides: slides,
            index: index
        });
    }, [
        slides,
        index
    ]);
    var context = $eHaBZ.useMemo(function() {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, state), {
            state: state,
            dispatch: dispatch
        });
    }, [
        state,
        dispatch
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$42eb31c6c0f01c10.Provider, {
        value: dispatch
    }, $eHaBZ.createElement($2e545d666ef3112d$export$c24db94cf7704d3a.Provider, {
        value: context
    }, children));
}
var $2e545d666ef3112d$export$e338b1178a56544e = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$1bc7162631c81b3f = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useTimeouts", "TimeoutsContext", $2e545d666ef3112d$export$e338b1178a56544e);
function $2e545d666ef3112d$export$9d9954f5885fa393(param) {
    var children = param.children;
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState([]), 1), timeouts = _React_useState[0];
    $eHaBZ.useEffect(function() {
        return function() {
            timeouts.forEach(function(tid) {
                return window.clearTimeout(tid);
            });
            timeouts.splice(0, timeouts.length);
        };
    }, [
        timeouts
    ]);
    var context = $eHaBZ.useMemo(function() {
        var removeTimeout = function(id) {
            var _timeouts;
            (_timeouts = timeouts).splice.apply(_timeouts, [
                0,
                timeouts.length
            ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(timeouts.filter(function(tid) {
                return tid !== id;
            }))));
        };
        var setTimeout = function(fn, delay) {
            var id = window.setTimeout(function() {
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        var clearTimeout = function(id) {
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
    }, [
        timeouts
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$e338b1178a56544e.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$c25acd513dcc8062 = $eHaBZ.forwardRef(function IconButton(_param, ref) {
    var label$1 = _param.label, className = _param.className, Icon = _param.icon, renderIcon = _param.renderIcon, onClick = _param.onClick, style = _param.style, rest = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "label",
        "className",
        "icon",
        "renderIcon",
        "onClick",
        "style"
    ]);
    var _useLightboxProps = $2e545d666ef3112d$export$d930f3536e1c64f6(), styles = _useLightboxProps.styles, labels = _useLightboxProps.labels;
    return $eHaBZ.createElement("button", (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        ref: ref,
        type: "button",
        "aria-label": $2e545d666ef3112d$export$1237798dc640739a(labels, label$1),
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$d62fb7722b07f2f3)), className),
        onClick: onClick,
        style: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, style, styles.button)
    }, rest), renderIcon ? renderIcon() : $eHaBZ.createElement(Icon, {
        className: $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)),
        style: styles.icon
    }));
});
function $2e545d666ef3112d$var$svgIcon(name, children) {
    var icon = function(props) {
        return $eHaBZ.createElement("svg", (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            "aria-hidden": "true",
            focusable: "false"
        }, props), children);
    };
    icon.displayName = name;
    return icon;
}
function $2e545d666ef3112d$export$274edc73af1ae9c8(name, glyph) {
    return $2e545d666ef3112d$var$svgIcon(name, $eHaBZ.createElement("g", {
        fill: "currentColor"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph));
}
function $2e545d666ef3112d$export$6b1fd58c1dc933ec(name, glyph) {
    return $2e545d666ef3112d$var$svgIcon(name, $eHaBZ.createElement($eHaBZ.Fragment, null, $eHaBZ.createElement("defs", null, $eHaBZ.createElement("mask", {
        id: "strike"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "white"
    }), $eHaBZ.createElement("path", {
        d: "M0 0L24 24",
        stroke: "black",
        strokeWidth: 4
    }))), $eHaBZ.createElement("path", {
        d: "M0.70707 2.121320L21.878680 23.292883",
        stroke: "currentColor",
        strokeWidth: 2
    }), $eHaBZ.createElement("g", {
        fill: "currentColor",
        mask: "url(#strike)"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph)));
}
var $2e545d666ef3112d$export$cae179f078f4b4a4 = $2e545d666ef3112d$export$274edc73af1ae9c8("Close", $eHaBZ.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
var $2e545d666ef3112d$export$d05925e1c7f3f136 = $2e545d666ef3112d$export$274edc73af1ae9c8("Previous", $eHaBZ.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
var $2e545d666ef3112d$export$3da0e0ec94bd4ce1 = $2e545d666ef3112d$export$274edc73af1ae9c8("Next", $eHaBZ.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
var $2e545d666ef3112d$export$b936c55164dcf1db = $2e545d666ef3112d$export$274edc73af1ae9c8("Loading", $eHaBZ.createElement($eHaBZ.Fragment, null, Array.from({
    length: 8
}).map(function(_, index, array) {
    return $eHaBZ.createElement("line", {
        key: index,
        x1: "12",
        y1: "6.5",
        x2: "12",
        y2: "1.8",
        strokeLinecap: "round",
        strokeWidth: "2.6",
        stroke: "currentColor",
        strokeOpacity: 1 / array.length * (index + 1),
        transform: "rotate(".concat(360 / array.length * index, ", 12, 12)")
    });
})));
var $2e545d666ef3112d$export$19bc16ee58e19b3d = $2e545d666ef3112d$export$274edc73af1ae9c8("Error", $eHaBZ.createElement("path", {
    d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
var $2e545d666ef3112d$export$e5c5a5f917a5871c = $2e545d666ef3112d$export$fef62134eea24008() ? $eHaBZ.useLayoutEffect : $eHaBZ.useEffect;
function $2e545d666ef3112d$export$f3e625e1b2b31d60() {
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState(false), 2), reduceMotion = _React_useState[0], setReduceMotion = _React_useState[1];
    $eHaBZ.useEffect(function() {
        var _a, _b;
        var mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        var listener = function(event) {
            return setReduceMotion(event.matches);
        };
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 || _b.call(mediaQuery, "change", listener);
        return function() {
            var _a;
            return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
        };
    }, []);
    return reduceMotion;
}
function $2e545d666ef3112d$var$currentTransformation(node) {
    var x = 0;
    var y = 0;
    var z = 0;
    var matrix = window.getComputedStyle(node).transform;
    var matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        var values = matcher[1].split(",").map($2e545d666ef3112d$export$5f87784a266e50a4);
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        } else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return {
        x: x,
        y: y,
        z: z
    };
}
function $2e545d666ef3112d$export$9e2608686d4ad846(nodeRef, computeAnimation) {
    var snapshot = $eHaBZ.useRef();
    var animation = $eHaBZ.useRef();
    var reduceMotion = $2e545d666ef3112d$export$f3e625e1b2b31d60();
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            var _ref = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), $2e545d666ef3112d$var$currentTransformation(nodeRef.current)) || {}, keyframes = _ref.keyframes, duration = _ref.duration, easing = _ref.easing, onfinish = _ref.onfinish;
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 || _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
                        duration: duration,
                        easing: easing
                    });
                } catch (err) {
                    console.error(err);
                }
                if (animation.current) animation.current.onfinish = function() {
                    animation.current = undefined;
                    onfinish === null || onfinish === void 0 || onfinish();
                };
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: function(currentSnapshot) {
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: function() {
            var _a;
            return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
        }
    };
}
function $2e545d666ef3112d$export$b1d85de58d38d09d() {
    var containerRef = $eHaBZ.useRef(null);
    var observerRef = $eHaBZ.useRef();
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState(), 2), containerRect = _React_useState[0], setContainerRect = _React_useState[1];
    var setContainerRef = $eHaBZ.useCallback(function(node) {
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        var updateContainerRect = function() {
            if (node) {
                var styles = window.getComputedStyle(node);
                var parse = function(value) {
                    return parseFloat(value) || 0;
                };
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
                });
            } else setContainerRect(undefined);
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return {
        setContainerRef: setContainerRef,
        containerRef: containerRef,
        containerRect: containerRect
    };
}
function $2e545d666ef3112d$export$69f38700ea0cb3b9() {
    var timeoutId = $eHaBZ.useRef();
    var _useTimeouts = $2e545d666ef3112d$export$1bc7162631c81b3f(), setTimeout = _useTimeouts.setTimeout, clearTimeout = _useTimeouts.clearTimeout;
    return $eHaBZ.useCallback(function(callback, delay) {
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [
        setTimeout,
        clearTimeout
    ]);
}
function $2e545d666ef3112d$export$ee5b5d04074a389e(fn) {
    var ref = $eHaBZ.useRef(fn);
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        ref.current = fn;
    });
    return $eHaBZ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _a;
        var _a1;
        return (_a1 = ref.current) === null || _a1 === void 0 ? void 0 : (_a = _a1).call.apply(_a, [
            ref
        ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(args)));
    }, []);
}
function $2e545d666ef3112d$export$4bb192c7cacf928f(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $2e545d666ef3112d$export$ebc1e1560c2dffa5(refA, refB) {
    return $eHaBZ.useMemo(function() {
        return refA == null && refB == null ? null : function(refValue) {
            $2e545d666ef3112d$export$4bb192c7cacf928f(refA, refValue);
            $2e545d666ef3112d$export$4bb192c7cacf928f(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $2e545d666ef3112d$export$2bd1c19440b9235c(focus) {
    var disabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var focused = $eHaBZ.useRef();
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [
        disabled,
        focus
    ]);
    var onFocus = $eHaBZ.useCallback(function() {
        focused.current = true;
    }, []);
    var onBlur = $eHaBZ.useCallback(function() {
        focused.current = false;
    }, []);
    return {
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $2e545d666ef3112d$export$81f015b3ec5d61cf() {
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState(false), 2), isRTL = _React_useState[0], setIsRTL = _React_useState[1];
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
    }, []);
    return isRTL;
}
function $2e545d666ef3112d$export$19012f58216d597f() {
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState({}), 1), subscribers = _React_useState[0];
    var notifySubscribers = $eHaBZ.useCallback(function(type, event) {
        var _a;
        (_a = subscribers[type]) === null || _a === void 0 || _a.forEach(function(listener) {
            if (!event.isPropagationStopped()) listener(event);
        });
    }, [
        subscribers
    ]);
    var registerSensors = $eHaBZ.useMemo(function() {
        return {
            onPointerDown: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$e15fc153f45a963d), event);
            },
            onPointerMove: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$1f8863949fbdd7e5), event);
            },
            onPointerUp: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$2d868b67a5791b8a), event);
            },
            onPointerLeave: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$526cafa85592f1a5), event);
            },
            onPointerCancel: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$22151cee048c4be9), event);
            },
            onKeyDown: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$1aba4f3521686ca9), event);
            },
            onKeyUp: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$bdb9f99d61a6879b), event);
            },
            onWheel: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$5635dc9d647242c7), event);
            }
        };
    }, [
        notifySubscribers
    ]);
    var subscribeSensors = $eHaBZ.useCallback(function(type, callback) {
        if (!subscribers[type]) subscribers[type] = [];
        subscribers[type].unshift(callback);
        return function() {
            var _listeners;
            var listeners = subscribers[type];
            if (listeners) (_listeners = listeners).splice.apply(_listeners, [
                0,
                listeners.length
            ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(listeners.filter(function(el) {
                return el !== callback;
            }))));
        };
    }, [
        subscribers
    ]);
    return {
        registerSensors: registerSensors,
        subscribeSensors: subscribeSensors
    };
}
function $2e545d666ef3112d$export$8b7b9481d6186f21(callback, delay) {
    var lastCallbackTime = $eHaBZ.useRef(0);
    var delayCallback = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var executeCallback = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        lastCallbackTime.current = Date.now();
        callback(args);
    });
    return $eHaBZ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        delayCallback(function() {
            executeCallback(args);
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [
        delay,
        executeCallback,
        delayCallback
    ]);
}
var $2e545d666ef3112d$var$slidePrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("slide");
var $2e545d666ef3112d$var$slideImagePrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("slide_image");
function $2e545d666ef3112d$export$ef86b1d52c77b27b(param) {
    var image = param.slide, offset = param.offset, render = param.render, rect = param.rect, imageFit = param.imageFit, imageProps = param.imageProps, onClick = param.onClick, onLoad = param.onLoad, style = param.style;
    var _Math, _Math1;
    var _a, _b, _c, _d, _e, _f, _g;
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState((0, $b17a7fd270a24b50$export$554a1415841c52a8)), 2), status = _React_useState[0], setStatus = _React_useState[1];
    var publish = $2e545d666ef3112d$export$91a992459f6e0f07().publish;
    var setTimeout = $2e545d666ef3112d$export$1bc7162631c81b3f().setTimeout;
    var imageRef = $eHaBZ.useRef(null);
    $eHaBZ.useEffect(function() {
        if (offset === 0) publish((0, $b17a7fd270a24b50$export$6751782e799f6445)(status));
    }, [
        offset,
        status,
        publish
    ]);
    var handleLoading = $2e545d666ef3112d$export$ee5b5d04074a389e(function(img) {
        ("decode" in img ? img.decode() : Promise.resolve()).catch(function() {}).then(function() {
            if (!img.parentNode) return;
            setStatus((0, $b17a7fd270a24b50$export$a195e517d37aaa33));
            setTimeout(function() {
                onLoad === null || onLoad === void 0 || onLoad(img);
            }, 0);
        });
    });
    var setImageRef = $eHaBZ.useCallback(function(img) {
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) handleLoading(img);
    }, [
        handleLoading
    ]);
    var handleOnLoad = $eHaBZ.useCallback(function(event) {
        handleLoading(event.currentTarget);
    }, [
        handleLoading
    ]);
    var onError = $eHaBZ.useCallback(function() {
        setStatus((0, $b17a7fd270a24b50$export$2ed3c80dbc178d91));
    }, []);
    var cover = $2e545d666ef3112d$export$f5ba2f5b3fd12e6e(image, imageFit);
    var nonInfinite = function(value, fallback) {
        return Number.isFinite(value) ? value : fallback;
    };
    var maxWidth = nonInfinite((_Math = Math).max.apply(_Math, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map(function(x) {
        return x.width;
    })) !== null && _b !== void 0 ? _b : []).concat(image.width ? [
        image.width
    ] : []).filter(Boolean))), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    var maxHeight = nonInfinite((_Math1 = Math).max.apply(_Math1, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map(function(x) {
        return x.height;
    })) !== null && _e !== void 0 ? _e : []).concat(image.height ? [
        image.height
    ] : []).filter(Boolean))), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    var defaultStyle = maxWidth && maxHeight ? {
        maxWidth: "min(".concat(maxWidth, "px, 100%)"),
        maxHeight: "min(".concat(maxHeight, "px, 100%)")
    } : {
        maxWidth: "100%",
        maxHeight: "100%"
    };
    var srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort(function(a, b) {
        return a.width - b.width;
    }).map(function(item) {
        return "".concat(item.src, " ").concat(item.width, "w");
    }).join(", ");
    var estimateActualWidth = function() {
        return rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
    };
    var sizes = srcSet && rect && $2e545d666ef3112d$export$fef62134eea24008() ? "".concat(Math.round(Math.min(estimateActualWidth(), rect.width)), "px") : undefined;
    var _ref = imageProps || {}, imagePropsStyle = _ref.style, imagePropsClassName = _ref.className, restImageProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_ref, [
        "style",
        "className"
    ]);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, $eHaBZ.createElement("img", (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        ref: setImageRef,
        onLoad: handleOnLoad,
        onError: onError,
        onClick: onClick,
        draggable: false,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix()), cover && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix("cover")), status !== (0, $b17a7fd270a24b50$export$a195e517d37aaa33) && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix("loading")), imagePropsClassName),
        style: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaultStyle, style, imagePropsStyle)
    }, restImageProps), {
        alt: image.alt,
        sizes: sizes,
        srcSet: srcSet,
        src: image.src
    })), status !== (0, $b17a7fd270a24b50$export$a195e517d37aaa33) && $eHaBZ.createElement("div", {
        className: $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$e51f1c6d74b54a13)))
    }, status === (0, $b17a7fd270a24b50$export$554a1415841c52a8) && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : $eHaBZ.createElement($2e545d666ef3112d$export$b936c55164dcf1db, {
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)), $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$554a1415841c52a8))))
    })), status === (0, $b17a7fd270a24b50$export$2ed3c80dbc178d91) && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : $eHaBZ.createElement($2e545d666ef3112d$export$19bc16ee58e19b3d, {
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)), $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$2ed3c80dbc178d91))))
    }))));
}
var $2e545d666ef3112d$export$59f0048f451fc458;
(function(SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL_DOWN"] = 2] = "PULL_DOWN";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})($2e545d666ef3112d$export$59f0048f451fc458 || ($2e545d666ef3112d$export$59f0048f451fc458 = {}));
function $2e545d666ef3112d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    $eHaBZ.useEffect(function() {
        return !disabled ? $2e545d666ef3112d$export$de863c629cb9919d(subscribeSensors((0, $b17a7fd270a24b50$export$e15fc153f45a963d), onPointerDown), subscribeSensors((0, $b17a7fd270a24b50$export$1f8863949fbdd7e5), onPointerMove), subscribeSensors((0, $b17a7fd270a24b50$export$2d868b67a5791b8a), onPointerUp), subscribeSensors((0, $b17a7fd270a24b50$export$526cafa85592f1a5), onPointerUp), subscribeSensors((0, $b17a7fd270a24b50$export$22151cee048c4be9), onPointerUp)) : function() {};
    }, [
        subscribeSensors,
        onPointerDown,
        onPointerMove,
        onPointerUp,
        disabled
    ]);
}
var $2e545d666ef3112d$var$Gesture;
(function(Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL_DOWN"] = 2] = "PULL_DOWN";
})($2e545d666ef3112d$var$Gesture || ($2e545d666ef3112d$var$Gesture = {}));
var $2e545d666ef3112d$var$SWIPE_THRESHOLD = 30;
function $2e545d666ef3112d$export$abaee32ee49963c1(subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullDownEnabled, onPullDownStart, onPullDownProgress, onPullDownFinish, onPullDownCancel) {
    var offset = $eHaBZ.useRef(0);
    var pointers = $eHaBZ.useRef([]);
    var activePointer = $eHaBZ.useRef();
    var startTime = $eHaBZ.useRef(0);
    var gesture = $eHaBZ.useRef($2e545d666ef3112d$var$Gesture.NONE);
    var clearPointer = $eHaBZ.useCallback(function(event) {
        var _currentPointers;
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = $2e545d666ef3112d$var$Gesture.NONE;
        }
        var currentPointers = pointers.current;
        (_currentPointers = currentPointers).splice.apply(_currentPointers, [
            0,
            currentPointers.length
        ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(currentPointers.filter(function(p) {
            return p.pointerId !== event.pointerId;
        }))));
    }, []);
    var addPointer = $eHaBZ.useCallback(function(event) {
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [
        clearPointer
    ]);
    var onPointerDown = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        addPointer(event);
    });
    var onPointerUp = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        if (pointers.current.find(function(x) {
            return x.pointerId === event.pointerId;
        }) && activePointer.current === event.pointerId) {
            var duration = Date.now() - startTime.current;
            var currentOffset = offset.current;
            if (gesture.current === $2e545d666ef3112d$var$Gesture.SWIPE) {
                if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) onSwipeFinish(currentOffset, duration);
                else onSwipeCancel(currentOffset);
            } else if (gesture.current === $2e545d666ef3112d$var$Gesture.PULL_DOWN) {
                if (currentOffset > 2 * $2e545d666ef3112d$var$SWIPE_THRESHOLD) onPullDownFinish(currentOffset, duration);
                else onPullDownCancel(currentOffset);
            }
            offset.current = 0;
            gesture.current = $2e545d666ef3112d$var$Gesture.NONE;
        }
        clearPointer(event);
    });
    var onPointerMove = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        var pointer = pointers.current.find(function(p) {
            return p.pointerId === event.pointerId;
        });
        if (pointer) {
            var isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) onPointerUp(event);
                else clearPointer(pointer);
                return;
            }
            var deltaX = event.clientX - pointer.clientX;
            var deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                var startGesture = function(newGesture) {
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > $2e545d666ef3112d$var$SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    startGesture($2e545d666ef3112d$var$Gesture.SWIPE);
                    onSwipeStart();
                } else if (pullDownEnabled && Math.abs(deltaY) > Math.abs(deltaX) && deltaY > $2e545d666ef3112d$var$SWIPE_THRESHOLD) {
                    startGesture($2e545d666ef3112d$var$Gesture.PULL_DOWN);
                    onPullDownStart();
                }
            } else if (isCurrentPointer) {
                if (gesture.current === $2e545d666ef3112d$var$Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                } else if (gesture.current === $2e545d666ef3112d$var$Gesture.PULL_DOWN) {
                    offset.current = deltaY;
                    onPullDownProgress(deltaY);
                }
            }
        }
    });
    $2e545d666ef3112d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
var $2e545d666ef3112d$var$WHEEL = "wheel";
function $2e545d666ef3112d$var$preventDefault(event) {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.ctrlKey) event.preventDefault();
}
function $2e545d666ef3112d$export$7c9183023e7620cd() {
    var ref = $eHaBZ.useRef(null);
    return $eHaBZ.useCallback(function(node) {
        var _a;
        if (node) node.addEventListener($2e545d666ef3112d$var$WHEEL, $2e545d666ef3112d$var$preventDefault, {
            passive: false
        });
        else (_a = ref.current) === null || _a === void 0 || _a.removeEventListener($2e545d666ef3112d$var$WHEEL, $2e545d666ef3112d$var$preventDefault);
        ref.current = node;
    }, []);
}
function $2e545d666ef3112d$export$10506de8b6841445(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    var offset = $eHaBZ.useRef(0);
    var intent = $eHaBZ.useRef(0);
    var intentCleanup = $eHaBZ.useRef();
    var resetCleanup = $eHaBZ.useRef();
    var wheelResidualMomentum = $eHaBZ.useRef(0);
    var startTime = $eHaBZ.useRef(0);
    var _useTimeouts = $2e545d666ef3112d$export$1bc7162631c81b3f(), setTimeout = _useTimeouts.setTimeout, clearTimeout = _useTimeouts.clearTimeout;
    var cancelSwipeIntentCleanup = $eHaBZ.useCallback(function() {
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    var cancelSwipeResetCleanup = $eHaBZ.useCallback(function() {
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    var handleCleanup = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        if (swipeState !== $2e545d666ef3112d$export$59f0048f451fc458.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    $eHaBZ.useEffect(handleCleanup, [
        swipeState,
        handleCleanup
    ]);
    var handleCancelSwipe = $2e545d666ef3112d$export$ee5b5d04074a389e(function(currentSwipeOffset) {
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) onSwipeCancel(offset.current);
    });
    var onWheel = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
        if (swipeState === $2e545d666ef3112d$export$59f0048f451fc458.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelResidualMomentum.current)) {
                wheelResidualMomentum.current = event.deltaX;
                return;
            }
            if (!isSwipeValid(-event.deltaX)) return;
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                wheelResidualMomentum.current = 0;
                startTime.current = Date.now();
                onSwipeStart();
            } else {
                var currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(function() {
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) intent.current = 0;
                }, swipeAnimationDuration);
            }
        } else if (swipeState === $2e545d666ef3112d$export$59f0048f451fc458.SWIPE) {
            var newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                wheelResidualMomentum.current = event.deltaX;
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(function() {
                return handleCancelSwipe(newSwipeOffset);
            }, 2 * swipeAnimationDuration);
        } else wheelResidualMomentum.current = event.deltaX;
    });
    $eHaBZ.useEffect(function() {
        return subscribeSensors((0, $b17a7fd270a24b50$export$5635dc9d647242c7), onWheel);
    }, [
        subscribeSensors,
        onWheel
    ]);
}
var $2e545d666ef3112d$var$cssContainerPrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("container");
var $2e545d666ef3112d$export$e92ff191b0c59550 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$e8c786024a2b0a79 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useController", "ControllerContext", $2e545d666ef3112d$export$e92ff191b0c59550);
function $2e545d666ef3112d$export$bd0bf19f25da8474(_param) {
    var children = _param.children, props = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "children"
    ]);
    var _a;
    var carousel = props.carousel, animation = props.animation, controller = props.controller, on = props.on, styles = props.styles, render = props.render;
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState(), 2), toolbarWidth = _React_useState[0], setToolbarWidth = _React_useState[1];
    var state = $2e545d666ef3112d$export$566121e2bbc52eec();
    var dispatch = $2e545d666ef3112d$export$9463bb14d6ba055e();
    var _React_useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState($2e545d666ef3112d$export$59f0048f451fc458.NONE), 2), swipeState = _React_useState1[0], setSwipeState = _React_useState1[1];
    var swipeOffset = $eHaBZ.useRef(0);
    var pullDownOffset = $eHaBZ.useRef(0);
    var pullDownOpacity = $eHaBZ.useRef(1);
    var _useSensors = $2e545d666ef3112d$export$19012f58216d597f(), registerSensors = _useSensors.registerSensors, subscribeSensors = _useSensors.subscribeSensors;
    var _useEvents = $2e545d666ef3112d$export$91a992459f6e0f07(), subscribe = _useEvents.subscribe, publish = _useEvents.publish;
    var cleanupAnimationIncrement = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var cleanupSwipeOffset = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var cleanupPullDownOffset = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var _useContainerRect = $2e545d666ef3112d$export$b1d85de58d38d09d(), containerRef = _useContainerRect.containerRef, setContainerRef = _useContainerRect.setContainerRef, containerRect = _useContainerRect.containerRect;
    var handleContainerRef = $2e545d666ef3112d$export$ebc1e1560c2dffa5($2e545d666ef3112d$export$7c9183023e7620cd(), setContainerRef);
    var carouselRef = $eHaBZ.useRef(null);
    var setCarouselRef = $2e545d666ef3112d$export$ebc1e1560c2dffa5(carouselRef, undefined);
    var isRTL = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    var rtl = function(value) {
        return (isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    };
    var focus = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    var getLightboxProps = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        return props;
    });
    var getLightboxState = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        return state;
    });
    var prev = $eHaBZ.useCallback(function(params) {
        return publish((0, $b17a7fd270a24b50$export$a007161537026955), params);
    }, [
        publish
    ]);
    var next = $eHaBZ.useCallback(function(params) {
        return publish((0, $b17a7fd270a24b50$export$f1d7a854db833ed4), params);
    }, [
        publish
    ]);
    var close = $eHaBZ.useCallback(function() {
        return publish((0, $b17a7fd270a24b50$export$493a596486210a21));
    }, [
        publish
    ]);
    var isSwipeValid = function(offset) {
        return !(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
    };
    var setSwipeOffset = function(offset) {
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("swipe_offset"), "".concat(Math.round(offset), "px"));
    };
    var closeOnPullDown = controller.closeOnPullDown;
    var setPullDownOffset = function(offset) {
        var _a, _b;
        pullDownOffset.current = offset;
        pullDownOpacity.current = function() {
            var threshold = 60;
            var minOpacity = 0.5;
            return Math.min(Math.max($2e545d666ef3112d$export$2077e0241d6afd3c(1 - offset / threshold * (1 - minOpacity), 2), minOpacity), 1);
        }();
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("pull_down_offset"), "".concat(Math.round(offset), "px"));
        (_b = containerRef.current) === null || _b === void 0 || _b.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("pull_down_opacity"), "".concat(pullDownOpacity.current));
    };
    var _useAnimation = $2e545d666ef3112d$export$9e2608686d4ad846(carouselRef, function(snapshot, rect, translate) {
        if (carouselRef.current && containerRect) return {
            keyframes: [
                {
                    transform: "translate(0, ".concat(snapshot.rect.y - rect.y + translate.y, "px)"),
                    opacity: snapshot.opacity
                },
                {
                    transform: "translate(0, 0)",
                    opacity: 1
                }
            ],
            duration: snapshot.duration,
            easing: animation.easing.fade
        };
        return undefined;
    }), preparePullDownAnimation = _useAnimation.prepareAnimation;
    var pullDown = function(offset, cancel) {
        if (closeOnPullDown) {
            setPullDownOffset(offset);
            var duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullDownAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullDownOpacity.current,
                    duration: duration
                });
            }
            cleanupPullDownOffset(function() {
                setPullDownOffset(0);
                setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.NONE);
            }, duration);
            setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.ANIMATION);
            if (!cancel) close();
        }
    };
    var _useAnimation1 = $2e545d666ef3112d$export$9e2608686d4ad846(carouselRef, function(snapshot, rect, translate) {
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            var parsedSpacing = $2e545d666ef3112d$export$7871fb532d320d99(carousel.spacing);
            var spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: "translate(".concat(rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x, "px, 0)")
                    },
                    {
                        transform: "translate(0, 0)"
                    }
                ],
                duration: state.animation.duration,
                easing: state.animation.easing
            };
        }
        return undefined;
    }), prepareAnimation = _useAnimation1.prepareAnimation, isAnimationPlaying = _useAnimation1.isAnimationPlaying;
    var swipe = $2e545d666ef3112d$export$ee5b5d04074a389e(function(action) {
        var _a, _b;
        var currentSwipeOffset = action.offset || 0;
        var swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        var swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        var direction = action.direction;
        var count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        var newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.ANIMATION;
        var newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            var containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            var elapsedTime = action.duration || 0;
            var expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
                else if (containerWidth) newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
                direction = rtl(currentSwipeOffset) > 0 ? (0, $b17a7fd270a24b50$export$a007161537026955) : (0, $b17a7fd270a24b50$export$f1d7a854db833ed4);
            } else newSwipeAnimationDuration = swipeDuration / 2;
        }
        var increment = 0;
        if (direction === (0, $b17a7fd270a24b50$export$a007161537026955)) {
            if (isSwipeValid(rtl(1))) increment = -count;
            else {
                newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        } else if (direction === (0, $b17a7fd270a24b50$export$f1d7a854db833ed4)) {
            if (isSwipeValid(rtl(-1))) increment = count;
            else {
                newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(function() {
            setSwipeOffset(0);
            setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) prepareAnimation({
            rect: carouselRef.current.getBoundingClientRect(),
            index: state.globalIndex
        });
        setSwipeState(newSwipeState);
        publish((0, $b17a7fd270a24b50$export$c43bd1a4101c4078), {
            type: "swipe",
            increment: increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing
        });
    });
    $eHaBZ.useEffect(function() {
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) cleanupAnimationIncrement(function() {
            return dispatch({
                type: "swipe",
                increment: 0
            });
        }, state.animation.duration);
    }, [
        state.animation,
        dispatch,
        cleanupAnimationIncrement
    ]);
    var swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        function() {
            return setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.SWIPE);
        },
        function(offset) {
            return setSwipeOffset(offset);
        },
        function(offset, duration) {
            return swipe({
                offset: offset,
                duration: duration,
                count: 1
            });
        },
        function(offset) {
            return swipe({
                offset: offset,
                count: 0
            });
        }
    ];
    var pullDownParams = [
        function() {
            if (closeOnPullDown) setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.PULL_DOWN);
        },
        function(offset) {
            return setPullDownOffset(offset);
        },
        function(offset) {
            return pullDown(offset);
        },
        function(offset) {
            return pullDown(offset, true);
        }
    ];
    $2e545d666ef3112d$export$abaee32ee49963c1.apply(void 0, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(swipeParams).concat([
        closeOnPullDown
    ], (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(pullDownParams)));
    $2e545d666ef3112d$export$10506de8b6841445.apply(void 0, [
        swipeState
    ].concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(swipeParams)));
    var focusOnMount = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        if (controller.focus) {
            if (document.querySelector(".".concat($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$9d2e4856063e1a22)), " .").concat($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssContainerPrefix())))) focus();
        }
    });
    $eHaBZ.useEffect(focusOnMount, [
        focusOnMount
    ]);
    var onViewCallback = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        (_a = on.view) === null || _a === void 0 || _a.call(on, {
            index: state.currentIndex
        });
    });
    $eHaBZ.useEffect(onViewCallback, [
        state.globalIndex,
        onViewCallback
    ]);
    $eHaBZ.useEffect(function() {
        return $2e545d666ef3112d$export$de863c629cb9919d(subscribe((0, $b17a7fd270a24b50$export$a007161537026955), function(action) {
            return swipe((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
                direction: (0, $b17a7fd270a24b50$export$a007161537026955)
            }, action));
        }), subscribe((0, $b17a7fd270a24b50$export$f1d7a854db833ed4), function(action) {
            return swipe((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
                direction: (0, $b17a7fd270a24b50$export$f1d7a854db833ed4)
            }, action));
        }), subscribe((0, $b17a7fd270a24b50$export$c43bd1a4101c4078), function(action) {
            return dispatch(action);
        }));
    }, [
        subscribe,
        swipe,
        dispatch
    ]);
    var context = $eHaBZ.useMemo(function() {
        return {
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            slideRect: containerRect ? $2e545d666ef3112d$export$7ff571008bce9900(containerRect, carousel.padding) : {
                width: 0,
                height: 0
            },
            containerRect: containerRect || {
                width: 0,
                height: 0
            },
            subscribeSensors: subscribeSensors,
            containerRef: containerRef,
            setCarouselRef: setCarouselRef,
            toolbarWidth: toolbarWidth,
            setToolbarWidth: setToolbarWidth
        };
    }, [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding
    ]);
    $eHaBZ.useImperativeHandle(controller.ref, function() {
        return {
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            getLightboxProps: getLightboxProps,
            getLightboxState: getLightboxState
        };
    }, [
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState
    ]);
    var _obj;
    return $eHaBZ.createElement("div", (0, $fa9769297b8a68c8$export$581ff339ea0ba762)((0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        ref: handleContainerRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssContainerPrefix()), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$974a68ef150451f5))),
        style: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, swipeState === $2e545d666ef3112d$export$59f0048f451fc458.SWIPE ? (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("swipe_offset"), "".concat(Math.round(swipeOffset.current), "px")) : null, swipeState === $2e545d666ef3112d$export$59f0048f451fc458.PULL_DOWN ? (_obj = {}, (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)(_obj, $2e545d666ef3112d$export$8b4981022bd80a4e("pull_down_offset"), "".concat(Math.round(pullDownOffset.current), "px")), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)(_obj, $2e545d666ef3112d$export$8b4981022bd80a4e("pull_down_opacity"), "".concat(pullDownOpacity.current)), _obj) : null, controller.touchAction !== "none" ? (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("controller_touch_action"), controller.touchAction) : null, styles.container)
    }, controller.aria ? {
        role: "presentation",
        "aria-live": "polite"
    } : null), {
        tabIndex: -1
    }), registerSensors), containerRect && $eHaBZ.createElement($2e545d666ef3112d$export$e92ff191b0c59550.Provider, {
        value: context
    }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render)));
}
var $2e545d666ef3112d$export$be59d34228c8ec8a = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$b861c6f4d58b4c2f), $2e545d666ef3112d$export$bd0bf19f25da8474);
function $2e545d666ef3112d$var$cssPrefix$2(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$83fe3bee12eb51bb), value);
}
function $2e545d666ef3112d$var$cssSlidePrefix(value) {
    return $2e545d666ef3112d$export$195c4126907dde97("slide", value);
}
function $2e545d666ef3112d$var$CarouselSlide(param) {
    var slide = param.slide, offset = param.offset;
    var containerRef = $eHaBZ.useRef(null);
    var currentIndex = $2e545d666ef3112d$export$566121e2bbc52eec().currentIndex;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), slideRect = _useController.slideRect, close = _useController.close;
    var _useLightboxProps = $2e545d666ef3112d$export$d930f3536e1c64f6(), render = _useLightboxProps.render, _useLightboxProps_carousel = _useLightboxProps.carousel, imageFit = _useLightboxProps_carousel.imageFit, imageProps = _useLightboxProps_carousel.imageProps, _useLightboxProps_on = _useLightboxProps.on, onClick = _useLightboxProps_on.click, closeOnBackdropClick = _useLightboxProps.controller.closeOnBackdropClick, _useLightboxProps_styles = _useLightboxProps.styles, style = _useLightboxProps_styles.slide;
    var renderSlide = function() {
        var _a, _b, _c, _d;
        var rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
            slide: slide,
            offset: offset,
            rect: slideRect
        });
        if (!rendered && $2e545d666ef3112d$export$55ec18c411514c07(slide)) rendered = $eHaBZ.createElement($2e545d666ef3112d$export$ef86b1d52c77b27b, {
            slide: slide,
            offset: offset,
            render: render,
            rect: slideRect,
            imageFit: imageFit,
            imageProps: imageProps,
            onClick: offset === 0 ? function() {
                return onClick === null || onClick === void 0 ? void 0 : onClick({
                    index: currentIndex
                });
            } : undefined
        });
        return rendered ? $eHaBZ.createElement($eHaBZ.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
            slide: slide
        }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : function(param) {
            var children = param.children;
            return children;
        })({
            slide: slide,
            children: rendered
        }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
            slide: slide
        })) : null;
    };
    var handleBackdropClick = function(event) {
        var container = containerRef.current;
        var target = event.target instanceof HTMLElement ? event.target : undefined;
        if (closeOnBackdropClick && target && container && (target === container || Array.from(container.children).find(function(x) {
            return x === target;
        }) && target.classList.contains($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$ac396c284080b10c))))) close();
    };
    return $eHaBZ.createElement("div", {
        ref: containerRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssSlidePrefix()), offset === 0 && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssSlidePrefix("current")), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$974a68ef150451f5))),
        onClick: handleBackdropClick,
        style: style
    }, renderSlide());
}
function $2e545d666ef3112d$var$Placeholder() {
    var style = $2e545d666ef3112d$export$d930f3536e1c64f6().styles.slide;
    return $eHaBZ.createElement("div", {
        className: $2e545d666ef3112d$export$1283875077dc8f0a("slide"),
        style: style
    });
}
function $2e545d666ef3112d$export$144901db2ea8e967(param) {
    var carousel = param.carousel;
    var _useLightboxState = $2e545d666ef3112d$export$566121e2bbc52eec(), slides = _useLightboxState.slides, currentIndex = _useLightboxState.currentIndex, globalIndex = _useLightboxState.globalIndex;
    var setCarouselRef = $2e545d666ef3112d$export$e8c786024a2b0a79().setCarouselRef;
    var spacingValue = $2e545d666ef3112d$export$7871fb532d320d99(carousel.spacing);
    var paddingValue = $2e545d666ef3112d$export$7871fb532d320d99(carousel.padding);
    var items = [];
    var preload = $2e545d666ef3112d$export$aab7f3145c728301(carousel, slides, 1);
    if ($2e545d666ef3112d$export$883ece934910f98d(slides)) {
        for(var i = currentIndex - preload; i < currentIndex; i += 1){
            var key = globalIndex + i - currentIndex;
            items.push(!carousel.finite || i >= 0 ? $eHaBZ.createElement($2e545d666ef3112d$var$CarouselSlide, {
                key: key,
                slide: slides[(i + preload * slides.length) % slides.length],
                offset: i - currentIndex
            }) : $eHaBZ.createElement($2e545d666ef3112d$var$Placeholder, {
                key: key
            }));
        }
        items.push($eHaBZ.createElement($2e545d666ef3112d$var$CarouselSlide, {
            key: globalIndex,
            slide: slides[currentIndex],
            offset: 0
        }));
        for(var i1 = currentIndex + 1; i1 <= currentIndex + preload; i1 += 1){
            var key1 = globalIndex + i1 - currentIndex;
            items.push(!carousel.finite || i1 <= slides.length - 1 ? $eHaBZ.createElement($2e545d666ef3112d$var$CarouselSlide, {
                key: key1,
                slide: slides[i1 % slides.length],
                offset: i1 - currentIndex
            }) : $eHaBZ.createElement($2e545d666ef3112d$var$Placeholder, {
                key: key1
            }));
        }
    }
    var _obj;
    return $eHaBZ.createElement("div", {
        ref: setCarouselRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$2()), items.length > 0 && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$2("with_slides"))),
        style: (_obj = {}, (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("slides_count"))), items.length), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("spacing_px"))), spacingValue.pixel || 0), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("spacing_percent"))), spacingValue.percent || 0), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("padding_px"))), paddingValue.pixel || 0), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("padding_percent"))), paddingValue.percent || 0), _obj)
    }, items);
}
var $2e545d666ef3112d$export$9c087759a323a56c = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$83fe3bee12eb51bb), $2e545d666ef3112d$export$144901db2ea8e967);
function $2e545d666ef3112d$export$e482f4662aebc4a0() {
    var carousel = $2e545d666ef3112d$export$d930f3536e1c64f6().carousel;
    var _useLightboxState = $2e545d666ef3112d$export$566121e2bbc52eec(), slides = _useLightboxState.slides, currentIndex = _useLightboxState.currentIndex;
    var prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
    var nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
    return {
        prevDisabled: prevDisabled,
        nextDisabled: nextDisabled
    };
}
function $2e545d666ef3112d$export$4da28cf324280418(subscribeSensors) {
    var _a;
    var isRTL = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    var publish = $2e545d666ef3112d$export$91a992459f6e0f07().publish;
    var animation = $2e545d666ef3112d$export$d930f3536e1c64f6().animation;
    var _useNavigationState = $2e545d666ef3112d$export$e482f4662aebc4a0(), prevDisabled = _useNavigationState.prevDisabled, nextDisabled = _useNavigationState.nextDisabled;
    var throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    var prev = $2e545d666ef3112d$export$8b7b9481d6186f21(function() {
        return publish((0, $b17a7fd270a24b50$export$a007161537026955));
    }, throttle);
    var next = $2e545d666ef3112d$export$8b7b9481d6186f21(function() {
        return publish((0, $b17a7fd270a24b50$export$f1d7a854db833ed4));
    }, throttle);
    var handleKeyDown = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        switch(event.key){
            case 0, $b17a7fd270a24b50$export$e8d60d9b5ceff7c0:
                publish((0, $b17a7fd270a24b50$export$493a596486210a21));
                break;
            case 0, $b17a7fd270a24b50$export$17dec1da9b0e2eb3:
                if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
                break;
            case 0, $b17a7fd270a24b50$export$91898c0e7e48903:
                if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
                break;
            default:
        }
    });
    $eHaBZ.useEffect(function() {
        return subscribeSensors((0, $b17a7fd270a24b50$export$1aba4f3521686ca9), handleKeyDown);
    }, [
        subscribeSensors,
        handleKeyDown
    ]);
}
function $2e545d666ef3112d$export$e2d1bd910e689283(param) {
    var label = param.label, icon = param.icon, renderIcon = param.renderIcon, action = param.action, onClick = param.onClick, disabled = param.disabled, style = param.style;
    return $eHaBZ.createElement($2e545d666ef3112d$export$c25acd513dcc8062, (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        label: label,
        icon: icon,
        renderIcon: renderIcon,
        className: $2e545d666ef3112d$export$1283875077dc8f0a("navigation_".concat(action)),
        disabled: disabled,
        onClick: onClick,
        style: style
    }, $2e545d666ef3112d$export$2bd1c19440b9235c($2e545d666ef3112d$export$e8c786024a2b0a79().focus, disabled)));
}
function $2e545d666ef3112d$export$b8a61e5c71402559(param) {
    var _param_render = param.render, buttonPrev = _param_render.buttonPrev, buttonNext = _param_render.buttonNext, iconPrev = _param_render.iconPrev, iconNext = _param_render.iconNext, styles = param.styles;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), prev = _useController.prev, next = _useController.next, subscribeSensors = _useController.subscribeSensors;
    var _useNavigationState = $2e545d666ef3112d$export$e482f4662aebc4a0(), prevDisabled = _useNavigationState.prevDisabled, nextDisabled = _useNavigationState.nextDisabled;
    $2e545d666ef3112d$export$4da28cf324280418(subscribeSensors);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, buttonPrev ? buttonPrev() : $eHaBZ.createElement($2e545d666ef3112d$export$e2d1bd910e689283, {
        label: "Previous",
        action: (0, $b17a7fd270a24b50$export$a007161537026955),
        icon: $2e545d666ef3112d$export$d05925e1c7f3f136,
        renderIcon: iconPrev,
        style: styles.navigationPrev,
        disabled: prevDisabled,
        onClick: prev
    }), buttonNext ? buttonNext() : $eHaBZ.createElement($2e545d666ef3112d$export$e2d1bd910e689283, {
        label: "Next",
        action: (0, $b17a7fd270a24b50$export$f1d7a854db833ed4),
        icon: $2e545d666ef3112d$export$3da0e0ec94bd4ce1,
        renderIcon: iconNext,
        style: styles.navigationNext,
        disabled: nextDisabled,
        onClick: next
    }));
}
var $2e545d666ef3112d$export$6c16e1ac15089858 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$607ce719f0ec9b98), $2e545d666ef3112d$export$b8a61e5c71402559);
var $2e545d666ef3112d$var$noScroll = $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$b6426a00c33a0175));
var $2e545d666ef3112d$var$noScrollPadding = $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$651541414233b476));
function $2e545d666ef3112d$var$isHTMLElement(element) {
    return "style" in element;
}
function $2e545d666ef3112d$var$padScrollbar(element, padding, rtl) {
    var styles = window.getComputedStyle(element);
    var property = rtl ? "padding-left" : "padding-right";
    var computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    var originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, "".concat(($2e545d666ef3112d$export$5f87784a266e50a4(computedValue) || 0) + padding, "px"));
    return function() {
        if (originalValue) element.style.setProperty(property, originalValue);
        else element.style.removeProperty(property);
    };
}
function $2e545d666ef3112d$export$bbae9e931237726f(param) {
    var disabled = param.noScroll.disabled, children = param.children;
    var rtl = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        if (disabled) return function() {};
        var cleanup = [];
        var body = document.body, documentElement = document.documentElement;
        var scrollbar = Math.round(window.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push($2e545d666ef3112d$var$padScrollbar(body, scrollbar, rtl));
            var elements = body.getElementsByTagName("*");
            for(var i = 0; i < elements.length; i += 1){
                var element = elements[i];
                if ($2e545d666ef3112d$var$isHTMLElement(element) && window.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains($2e545d666ef3112d$var$noScrollPadding)) cleanup.push($2e545d666ef3112d$var$padScrollbar(element, scrollbar, rtl));
            }
        }
        body.classList.add($2e545d666ef3112d$var$noScroll);
        return function() {
            body.classList.remove($2e545d666ef3112d$var$noScroll);
            cleanup.forEach(function(clean) {
                return clean();
            });
        };
    }, [
        rtl,
        disabled
    ]);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, children);
}
var $2e545d666ef3112d$export$7ded5f1cd4840ad = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$52cbc29cf5406ba8), $2e545d666ef3112d$export$bbae9e931237726f);
function $2e545d666ef3112d$var$cssPrefix$1(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$9d2e4856063e1a22), value);
}
function $2e545d666ef3112d$var$setAttribute(element, attribute, value) {
    var previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return function() {
        if (previousValue) element.setAttribute(attribute, previousValue);
        else element.removeAttribute(attribute);
    };
}
function $2e545d666ef3112d$export$602eac185826482c(param) {
    var children = param.children, animation = param.animation, styles = param.styles, className = param.className, on = param.on, portal = param.portal, close = param.close;
    var _React_useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState(false), 2), mounted = _React_useState[0], setMounted = _React_useState[1];
    var _React_useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)($eHaBZ.useState(false), 2), visible = _React_useState1[0], setVisible = _React_useState1[1];
    var cleanup = $eHaBZ.useRef([]);
    var restoreFocus = $eHaBZ.useRef(null);
    var setTimeout = $2e545d666ef3112d$export$1bc7162631c81b3f().setTimeout;
    var subscribe = $2e545d666ef3112d$export$91a992459f6e0f07().subscribe;
    var reduceMotion = $2e545d666ef3112d$export$f3e625e1b2b31d60();
    var animationDuration = !reduceMotion ? animation.fade : 0;
    $eHaBZ.useEffect(function() {
        setMounted(true);
        return function() {
            setMounted(false);
            setVisible(false);
        };
    }, []);
    var handleCleanup = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        cleanup.current.forEach(function(clean) {
            return clean();
        });
        cleanup.current = [];
    });
    var handleClose = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        setVisible(false);
        handleCleanup();
        (_a = on.exiting) === null || _a === void 0 || _a.call(on);
        setTimeout(function() {
            var _a;
            (_a = on.exited) === null || _a === void 0 || _a.call(on);
            close();
        }, animationDuration);
    });
    $eHaBZ.useEffect(function() {
        return subscribe((0, $b17a7fd270a24b50$export$493a596486210a21), handleClose);
    }, [
        subscribe,
        handleClose
    ]);
    var handleEnter = $2e545d666ef3112d$export$ee5b5d04074a389e(function(node) {
        var _a, _b, _c;
        node.scrollTop;
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 || _a.call(on);
        var elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for(var i = 0; i < elements.length; i += 1){
            var element = elements[i];
            if ([
                "TEMPLATE",
                "SCRIPT",
                "STYLE"
            ].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push($2e545d666ef3112d$var$setAttribute(element, "inert", "true"));
                cleanup.current.push($2e545d666ef3112d$var$setAttribute(element, "aria-hidden", "true"));
            }
        }
        cleanup.current.push(function() {
            var _a, _b;
            (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
        });
        setTimeout(function() {
            var _a;
            (_a = on.entered) === null || _a === void 0 || _a.call(on);
        }, animationDuration);
    });
    var handleRef = $eHaBZ.useCallback(function(node) {
        if (node) handleEnter(node);
        else handleCleanup();
    }, [
        handleEnter,
        handleCleanup
    ]);
    return mounted ? (0, $8afcda7f6e55ccf7$exports.createPortal)($eHaBZ.createElement("div", {
        ref: handleRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37(className, $2e545d666ef3112d$export$1283875077dc8f0a("root"), $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$1()), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$651541414233b476)), visible && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$1("open"))),
        role: "presentation",
        "aria-live": "polite",
        style: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, animation.fade !== $2e545d666ef3112d$export$d626463445cef3e9.animation.fade ? (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("fade_animation_duration"), "".concat(animationDuration, "ms")) : null, animation.easing.fade !== $2e545d666ef3112d$export$d626463445cef3e9.animation.easing.fade ? (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("fade_animation_timing_function"), animation.easing.fade) : null, styles.root),
        onFocus: function(event) {
            if (!restoreFocus.current) restoreFocus.current = event.relatedTarget;
        }
    }, children), portal.root || document.body) : null;
}
var $2e545d666ef3112d$export$f2a0761442face5c = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$9d2e4856063e1a22), $2e545d666ef3112d$export$602eac185826482c);
function $2e545d666ef3112d$export$be92b6f5f03c0fe9(param) {
    var children = param.children;
    return $eHaBZ.createElement($eHaBZ.Fragment, null, children);
}
var $2e545d666ef3112d$export$fa1081225b99a9f2 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$62f3c66ae8dab8a3), $2e545d666ef3112d$export$be92b6f5f03c0fe9);
function $2e545d666ef3112d$var$cssPrefix(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$5414719b40b8294f), value);
}
function $2e545d666ef3112d$export$4c260019440d418f(param) {
    var buttons = param.toolbar.buttons, _param_render = param.render, buttonClose = _param_render.buttonClose, iconClose = _param_render.iconClose, styles = param.styles;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), close = _useController.close, setToolbarWidth = _useController.setToolbarWidth;
    var _useContainerRect = $2e545d666ef3112d$export$b1d85de58d38d09d(), setContainerRef = _useContainerRect.setContainerRef, containerRect = _useContainerRect.containerRect;
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [
        setToolbarWidth,
        containerRect === null || containerRect === void 0 ? void 0 : containerRect.width
    ]);
    var renderCloseButton = function() {
        if (buttonClose) return buttonClose();
        return $eHaBZ.createElement($2e545d666ef3112d$export$c25acd513dcc8062, {
            key: (0, $b17a7fd270a24b50$export$493a596486210a21),
            label: "Close",
            icon: $2e545d666ef3112d$export$cae179f078f4b4a4,
            renderIcon: iconClose,
            onClick: close
        });
    };
    return $eHaBZ.createElement("div", {
        ref: setContainerRef,
        style: styles.toolbar,
        className: $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix())
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function(button) {
        return button === (0, $b17a7fd270a24b50$export$493a596486210a21) ? renderCloseButton() : button;
    }));
}
var $2e545d666ef3112d$export$d0a9743c06e42ce8 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$5414719b40b8294f), $2e545d666ef3112d$export$4c260019440d418f);
function $2e545d666ef3112d$var$renderNode(node, props) {
    var _a;
    return $eHaBZ.createElement(node.module.component, (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        key: node.module.name
    }, props), (_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function(child) {
        return $2e545d666ef3112d$var$renderNode(child, props);
    }));
}
function $2e545d666ef3112d$var$mergeAnimation(defaultAnimation) {
    var animation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var defaultAnimationEasing = defaultAnimation.easing, restDefaultAnimation = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(defaultAnimation, [
        "easing"
    ]);
    var easing = animation.easing, restAnimation = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(animation, [
        "easing"
    ]);
    return (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        easing: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaultAnimationEasing, easing)
    }, restDefaultAnimation, restAnimation);
}
function $2e545d666ef3112d$export$7d2670a66155874b(_param) {
    var carousel = _param.carousel, animation = _param.animation, render = _param.render, toolbar = _param.toolbar, controller = _param.controller, noScroll = _param.noScroll, on = _param.on, plugins = _param.plugins, slides = _param.slides, index = _param.index, restProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)(_param, [
        "carousel",
        "animation",
        "render",
        "toolbar",
        "controller",
        "noScroll",
        "on",
        "plugins",
        "slides",
        "index"
    ]);
    var defaultAnimation = $2e545d666ef3112d$export$d626463445cef3e9.animation, defaultCarousel = $2e545d666ef3112d$export$d626463445cef3e9.carousel, defaultRender = $2e545d666ef3112d$export$d626463445cef3e9.render, defaultToolbar = $2e545d666ef3112d$export$d626463445cef3e9.toolbar, defaultController = $2e545d666ef3112d$export$d626463445cef3e9.controller, defaultNoScroll = $2e545d666ef3112d$export$d626463445cef3e9.noScroll, defaultOn = $2e545d666ef3112d$export$d626463445cef3e9.on, defaultSlides = $2e545d666ef3112d$export$d626463445cef3e9.slides, defaultIndex = $2e545d666ef3112d$export$d626463445cef3e9.index, defaultPlugins = $2e545d666ef3112d$export$d626463445cef3e9.plugins, restDefaultProps = (0, $7e86f5813bbb0f77$export$69fdd232f62cde60)($2e545d666ef3112d$export$d626463445cef3e9, [
        "animation",
        "carousel",
        "render",
        "toolbar",
        "controller",
        "noScroll",
        "on",
        "slides",
        "index",
        "plugins"
    ]);
    var _withPlugins = $2e545d666ef3112d$export$bc996c07eb970c78([
        $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$f2a0761442face5c, [
            $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$7ded5f1cd4840ad, [
                $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$be59d34228c8ec8a, [
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$9c087759a323a56c),
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$d0a9743c06e42ce8),
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$6c16e1ac15089858)
                ])
            ])
        ])
    ], plugins || defaultPlugins), config = _withPlugins.config, augmentation = _withPlugins.augmentation;
    var props = augmentation((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({
        animation: $2e545d666ef3112d$var$mergeAnimation(defaultAnimation, animation),
        carousel: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaultCarousel, carousel),
        render: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaultRender, render),
        toolbar: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaultToolbar, toolbar),
        controller: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaultController, controller),
        noScroll: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaultNoScroll, noScroll),
        on: (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, defaultOn, on)
    }, restDefaultProps, restProps));
    if (!props.open) return null;
    return $eHaBZ.createElement($2e545d666ef3112d$export$7141a340a3dea601, (0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, props), $eHaBZ.createElement($2e545d666ef3112d$export$62d2e1d2e7609988, {
        slides: slides || defaultSlides,
        index: $2e545d666ef3112d$export$5f87784a266e50a4(index || defaultIndex)
    }, $eHaBZ.createElement($2e545d666ef3112d$export$9d9954f5885fa393, null, $eHaBZ.createElement($2e545d666ef3112d$export$686accdd53ac150f, null, $2e545d666ef3112d$var$renderNode($2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$fa1081225b99a9f2, config), props)))));
}


// TODO: do the search highlights client-side
function $bfe6f4dc29c37278$var$reHighlight(text) {
    return text.split(/<span class="found">(.+?)<\/span>/).map(function(n, i) {
        return i % 2 == 0 ? n : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
            className: "found",
            children: n
        }, i);
    });
}
function $bfe6f4dc29c37278$var$setupLightbox(param) {
    var element = param.element, setSlides = param.setSlides, setSelectedPhotoIndex = param.setSelectedPhotoIndex;
    var images = element.querySelectorAll('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".jpg:large"], a[href$=".jpeg:large"], a[href$=".png:large"], a[href$=".gif:large"]');
    setSlides(Array.from(images).map(function(link, index) {
        link.addEventListener("click", function(event) {
            event.preventDefault();
            setSelectedPhotoIndex(index);
        });
        return {
            src: link.getAttribute("href")
        };
    }));
}
function $bfe6f4dc29c37278$var$stopPropagation(event) {
    event.stopPropagation();
}
function $bfe6f4dc29c37278$var$lazyLoadImages(content) {
    content.querySelectorAll("img").forEach(function(img) {
        img.setAttribute("src", img.getAttribute("data-selfoss-src"));
    });
}
// React will prevent the default action when it bubbles to our callbacks.
// Let’s stop bubbling for links.
// https://medium.com/peloton-engineering/onclick-wat-51331718ba9
function $bfe6f4dc29c37278$var$fixLinkBubbling(content) {
    content.querySelectorAll("a").forEach(function(a) {
        a.addEventListener("click", function(event) {
            event.stopPropagation();
        });
    });
}
// Prevent passing referrer info when opening a link.
function $bfe6f4dc29c37278$var$sanitizeContent(content) {
    content.querySelectorAll("a").forEach(function(a) {
        var oldRel = a.getAttribute("rel");
        a.setAttribute("rel", "noreferrer" + (oldRel ? " " + oldRel : ""));
        // Ensure links inside item content are opened in new tab/window.
        a.setAttribute("target", "_blank");
    });
}
function $bfe6f4dc29c37278$var$handleKeyUp(event) {
    // emulate clicking when using keyboard
    if (event.keyCode === 13) {
        event.target.click();
        event.preventDefault();
        event.stopPropagation();
    }
}
function $bfe6f4dc29c37278$var$preventDefaultOnSmartphone(event) {
    // We want to use the whole title as action for opening/closing items
    // and smartphones have separate buttons for opening the article anyway.
    if (selfoss.isSmartphone()) event.preventDefault();
}
// Handle closing fullscreen on mobile
function $bfe6f4dc29c37278$var$closeFullScreen(param) {
    var event = param.event, history = param.history, location = param.location, entryId = param.entryId;
    event.preventDefault();
    event.stopPropagation();
    selfoss.entriesPage.setEntryExpanded(entryId, false);
    history.replace((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
        id: null
    }));
}
// show/hide entry
function $bfe6f4dc29c37278$var$handleClick(param) {
    var event = param.event, history = param.history, location = param.location, expanded = param.expanded, id = param.id, target = param.target;
    var expected = selfoss.isMobile() ? ".entry" : ".entry-title";
    if (target !== expected) return;
    event.preventDefault();
    event.stopPropagation();
    if (expanded) {
        selfoss.entriesPage.setSelectedEntry(id);
        selfoss.entriesPage.deactivateEntry(id);
        history.replace((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
            id: null
        }));
    } else {
        selfoss.entriesPage.activateEntry(id);
        history.replace((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
            id: id
        }));
    }
}
// load images
function $bfe6f4dc29c37278$var$loadImages(param) {
    var event = param.event, setImagesLoaded = param.setImagesLoaded, contentBlock = param.contentBlock;
    event.preventDefault();
    event.stopPropagation();
    $bfe6f4dc29c37278$var$lazyLoadImages(contentBlock.current);
    setImagesLoaded(true);
}
// next item on tablet and smartphone
function $bfe6f4dc29c37278$var$openNext(event) {
    event.preventDefault();
    event.stopPropagation();
    // TODO: Figure out why it does not work when run immediately.
    requestAnimationFrame(function() {
        var _selfoss_entriesPage;
        (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT, true);
    });
}
function $bfe6f4dc29c37278$var$ShareButton(param) {
    var label = param.label, icon = param.icon, item = param.item, action = param.action, _param_showLabel = param.showLabel, showLabel = _param_showLabel === void 0 ? true : _param_showLabel;
    var shareOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        action({
            id: item.id,
            url: item.link,
            // TODO: remove HTML
            title: item.title
        });
    }, [
        item,
        action
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
        type: "button",
        className: "entry-share",
        title: label,
        "aria-label": label,
        onClick: shareOnClick,
        children: [
            icon,
            " ",
            showLabel ? label : null
        ]
    });
}
$bfe6f4dc29c37278$var$ShareButton.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).element
    ]).isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    action: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    showLabel: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool
};
function $bfe6f4dc29c37278$var$ItemTag(param) {
    var tag = param.tag, color = param.color;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            color: color.foreColor,
            backgroundColor: color.backColor
        };
    }, [
        color
    ]);
    var link = (0, $eHaBZ.useCallback)(function(location) {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, location, (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: "tag-".concat(tag),
            id: null
        })), {
            state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(location)
        });
    }, [
        tag
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
        className: "entry-tags-tag",
        style: style,
        to: link,
        onClick: $bfe6f4dc29c37278$var$preventDefaultOnSmartphone,
        children: tag
    });
}
$bfe6f4dc29c37278$var$ItemTag.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired
};
/**
 * Converts Date to a relative string.
 * When the date is too old, null is returned instead.
 * @param {Date} currentTime
 * @param {Date} datetime
 * @return {?String} relative time reference
 */ function $bfe6f4dc29c37278$var$datetimeRelative(currentTime, datetime) {
    var ageInseconds = (currentTime - datetime) / 1000;
    var ageInMinutes = ageInseconds / 60;
    var ageInHours = ageInMinutes / 60;
    var ageInDays = ageInHours / 24;
    if (ageInHours < 1) return selfoss.app._("minutes", [
        Math.round(ageInMinutes)
    ]);
    else if (ageInDays < 1) return selfoss.app._("hours", [
        Math.round(ageInHours)
    ]);
    else return null;
}
function $bfe6f4dc29c37278$export$2e2bcd8739ae039(param) {
    var currentTime = param.currentTime, item = param.item, selected = param.selected, expanded = param.expanded, setNavExpanded = param.setNavExpanded;
    var title = item.title, author = item.author, sourcetitle = item.sourcetitle;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), fullScreenTrap = _useState[0], setFullScreenTrap = _useState[1];
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(false), 2), imagesLoaded = _useState1[0], setImagesLoaded = _useState1[1];
    var contentBlock = (0, $eHaBZ.useRef)(null);
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    var relDate = (0, $eHaBZ.useMemo)(function() {
        return $bfe6f4dc29c37278$var$datetimeRelative(currentTime, item.datetime);
    }, [
        currentTime,
        item.datetime
    ]);
    var previouslyExpanded = (0, $45d08aa99719a2d0$export$f6f3f74729fdd0b7)(expanded);
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    var _useState2 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)([]), 2), slides = _useState2[0], setSlides = _useState2[1];
    var _useState3 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), selectedPhotoIndex = _useState3[0], setSelectedPhotoIndex = _useState3[1];
    (0, $eHaBZ.useEffect)(function() {
        // Handle entry becoming/ceasing to be expanded.
        var parent = document.querySelector('.entry[data-entry-id="'.concat(item.id, '"]'));
        if (expanded) {
            var firstExpansion = contentBlock.current.childElementCount === 0;
            if (firstExpansion) {
                contentBlock.current.innerHTML = item.content;
                $bfe6f4dc29c37278$var$sanitizeContent(contentBlock.current);
                selfoss.extensionPoints.processItemContents(contentBlock.current);
                // load images not on mobile devices
                if (selfoss.isMobile() == false || configuration.loadImagesOnMobile) {
                    setImagesLoaded(true);
                    $bfe6f4dc29c37278$var$lazyLoadImages(contentBlock.current);
                }
            }
            if (selfoss.isSmartphone()) {
                // save scroll position
                var scrollTop = window.scrollY;
                setNavExpanded(function(expanded) {
                    // hide nav
                    if (expanded) {
                        scrollTop = scrollTop - document.querySelector("#nav").getBoundingClientRect().height;
                        scrollTop = scrollTop < 0 ? 0 : scrollTop;
                        window.scrollTo({
                            top: scrollTop
                        });
                        return false;
                    }
                    return expanded;
                });
                // show fullscreen
                document.body.classList.add("fullscreen-mode");
                var trap = (0, $197853feae65c1a7$export$360440dfcba94c00)(parent);
                setFullScreenTrap(trap);
                trap.activate();
                if (firstExpansion) $bfe6f4dc29c37278$var$fixLinkBubbling(contentBlock.current);
            } else {
                if (firstExpansion) // setup fancyBox image viewer
                $bfe6f4dc29c37278$var$setupLightbox({
                    element: contentBlock.current,
                    setSlides: setSlides,
                    setSelectedPhotoIndex: setSelectedPhotoIndex
                });
                // scroll to article header
                if (configuration.scrollToArticleHeader) parent.scrollIntoView();
                if (firstExpansion) // turn of column view if entry is too long
                requestAnimationFrame(function() {
                    // Delayed into next frame so that the entry is expanded when the height is being determined.
                    if (contentBlock.current.getBoundingClientRect().height > document.body.clientHeight) contentBlock.current.parentNode.classList.add("entry-content-nocolumns");
                });
            }
        } else {
            // No longer expanded.
            setFullScreenTrap(function(trap) {
                if (trap !== null) trap.deactivate();
                return null;
            });
            document.body.classList.remove("fullscreen-mode");
        }
    }, [
        configuration,
        expanded,
        item.content,
        item.id,
        setNavExpanded
    ]);
    (0, $eHaBZ.useEffect)(function() {
        // Handle autoHideReadOnMobile setting.
        if (selfoss.isSmartphone() && !expanded && previouslyExpanded) {
            var autoHideReadOnMobile = configuration.autoHideReadOnMobile && item.unread == 1;
            if (autoHideReadOnMobile && item.unread != 1) selfoss.entriesPage.setEntries(function(entries) {
                return entries.filter(function(param) {
                    var id = param.id;
                    return id !== item.id;
                });
            });
        }
    }, [
        configuration,
        expanded,
        item.id,
        item.unread,
        previouslyExpanded
    ]);
    var entryOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $bfe6f4dc29c37278$var$handleClick({
            event: event,
            history: history,
            location: location,
            expanded: expanded,
            id: item.id,
            target: ".entry"
        });
    }, [
        history,
        location,
        expanded,
        item.id
    ]);
    var titleOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $bfe6f4dc29c37278$var$handleClick({
            event: event,
            history: history,
            location: location,
            expanded: expanded,
            id: item.id,
            target: ".entry-title"
        });
    }, [
        history,
        location,
        expanded,
        item.id
    ]);
    var starOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        selfoss.entriesPage.markEntryStarred(item.id, item.starred != 1);
    }, [
        item
    ]);
    var markReadOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        selfoss.entriesPage.markEntryRead(item.id, item.unread == 1);
    }, [
        item
    ]);
    var loadImagesOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $bfe6f4dc29c37278$var$loadImages({
            event: event,
            setImagesLoaded: setImagesLoaded,
            contentBlock: contentBlock
        });
    }, []);
    var closeOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $bfe6f4dc29c37278$var$closeFullScreen({
            event: event,
            history: history,
            location: location,
            entryId: item.id
        });
    }, [
        history,
        location,
        item.id
    ]);
    var titleHtml = (0, $eHaBZ.useMemo)(function() {
        return {
            __html: title ? title : selfoss.app._("no_title")
        };
    }, [
        title
    ]);
    var sourceLink = (0, $eHaBZ.useCallback)(function(location) {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, location, (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(item.source),
            id: null
        })), {
            state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(location)
        });
    }, [
        item.source
    ]);
    var canWrite = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var sharers = (0, $8ee8a2a1e50ded87$export$aebedbd51beb48eb)({
        configuration: configuration,
        _: _
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        "data-entry-id": item.id,
        "data-entry-source": item.source,
        "data-entry-url": item.link,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            entry: true,
            unread: item.unread == 1,
            expanded: expanded,
            selected: selected
        }),
        role: "article",
        "aria-modal": fullScreenTrap !== null,
        onClick: entryOnClick,
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                href: item.link,
                className: "entry-icon",
                tabIndex: "-1",
                rel: "noreferrer",
                "aria-hidden": "true",
                onClick: $bfe6f4dc29c37278$var$preventDefaultOnSmartphone,
                children: item.icon !== null && item.icon.trim().length > 0 && item.icon != "0" ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                    src: "favicons/".concat(item.icon),
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h3", {
                className: "entry-title",
                onClick: titleOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "entry-title-link",
                    "aria-expanded": expanded,
                    "aria-current": selected,
                    role: "link",
                    tabIndex: "0",
                    onKeyUp: $bfe6f4dc29c37278$var$handleKeyUp,
                    dangerouslySetInnerHTML: titleHtml
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "entry-tags",
                children: Object.entries(item.tags).map(function(param) {
                    var _param = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(param, 2), tag = _param[0], color = _param[1];
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($bfe6f4dc29c37278$var$ItemTag, {
                        tag: tag,
                        color: color
                    }, tag);
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                className: "entry-source",
                to: sourceLink,
                onClick: $bfe6f4dc29c37278$var$preventDefaultOnSmartphone,
                children: $bfe6f4dc29c37278$var$reHighlight(sourcetitle)
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "entry-separator",
                children: "\u2022"
            }),
            author !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-author",
                        children: author
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                href: item.link,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    "entry-datetime": true,
                    timestamped: relDate === null
                }),
                target: "_blank",
                rel: "noreferrer",
                onClick: $bfe6f4dc29c37278$var$preventDefaultOnSmartphone,
                children: relDate !== null ? relDate : item.datetime.toLocaleString()
            }),
            configuration.readingSpeed !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-readtime",
                        children: _("article_reading_time", [
                            Math.round(item.wordCount / configuration.readingSpeed)
                        ])
                    })
                ]
            }) : null,
            item.thumbnail && item.thumbnail.trim().length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    "entry-thumbnail": true,
                    "entry-thumbnail-always-visible": configuration.showThumbnails
                }),
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                    href: item.link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                        src: "thumbnails/".concat(item.thumbnail),
                        alt: item.strippedTitle
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    "entry-content": true,
                    "entry-content-nocolumns": item.lengthWithoutTags < 500
                }),
                children: [
                    slides.length !== 0 && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2e545d666ef3112d$export$7d2670a66155874b), {
                        open: selectedPhotoIndex !== null,
                        index: selectedPhotoIndex,
                        close: function() {
                            return setSelectedPhotoIndex(null);
                        },
                        carousel: {
                            finite: true
                        },
                        controller: {
                            closeOnBackdropClick: true
                        },
                        on: {
                            entered: function() {
                                return selfoss.lightboxActive.update(true);
                            },
                            exited: function() {
                                return selfoss.lightboxActive.update(false);
                            }
                        },
                        slides: slides
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                        ref: contentBlock
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                        className: "entry-smartphone-share",
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                            "aria-label": _("article_actions"),
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("a", {
                                        href: item.link,
                                        className: "entry-newwindow",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        accessKey: "o",
                                        onClick: $bfe6f4dc29c37278$var$stopPropagation,
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                                icon: $38e96a2b42b175e8$exports.faExternalLinkAlt
                                            }),
                                            " ",
                                            _("open_window")
                                        ]
                                    })
                                }),
                                sharers.map(function(param) {
                                    var key = param.key, label = param.label, icon = param.icon, action = param.action;
                                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($bfe6f4dc29c37278$var$ShareButton, {
                                            label: label,
                                            icon: icon,
                                            item: item,
                                            action: action
                                        })
                                    }, key);
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                                        type: "button",
                                        accessKey: "n",
                                        className: "entry-next",
                                        onClick: $bfe6f4dc29c37278$var$openNext,
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                                icon: $67e9658d0f6c3ae3$exports.faArrowRight
                                            }),
                                            " ",
                                            _("next")
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                "aria-label": _("article_actions"),
                className: "entry-toolbar",
                children: [
                    canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "a",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                "entry-starr": true,
                                active: item.starred == 1
                            }),
                            onClick: starOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: item.starred == 1 ? $4e5ab4d00c078f68$exports.faStar : $de3818063bbfedbe$exports.faStar
                                }),
                                " ",
                                item.starred == 1 ? _("unstar") : _("star")
                            ]
                        })
                    }),
                    canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "u",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                "entry-unread": true,
                                active: item.unread == 1
                            }),
                            onClick: markReadOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: item.unread == 1 ? $7214b407105f2291$exports.faCheckCircle : $60c3775e24ebf896$exports.faCheckCircle
                                }),
                                " ",
                                item.unread == 1 ? _("mark") : _("unmark")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("a", {
                            href: item.link,
                            className: "entry-newwindow",
                            target: "_blank",
                            rel: "noreferrer",
                            accessKey: "o",
                            onClick: $bfe6f4dc29c37278$var$stopPropagation,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: $38e96a2b42b175e8$exports.faExternalLinkAlt
                                }),
                                " ",
                                _("open_window")
                            ]
                        })
                    }),
                    !imagesLoaded ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            className: "entry-loadimages",
                            onClick: loadImagesOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: $7417e626c64fb3c5$exports.faArrowAltCircleDown
                                }),
                                " ",
                                _("load_img")
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            type: "button",
                            accessKey: "n",
                            className: "entry-next",
                            onClick: $bfe6f4dc29c37278$var$openNext,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: $67e9658d0f6c3ae3$exports.faArrowRight
                                }),
                                " ",
                                _("next")
                            ]
                        })
                    }),
                    sharers.map(function(param) {
                        var key = param.key, label = param.label, icon = param.icon, action = param.action;
                        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($bfe6f4dc29c37278$var$ShareButton, {
                                label: label,
                                icon: icon,
                                item: item,
                                action: action,
                                showLabel: false
                            })
                        }, key);
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "c",
                            className: "entry-close",
                            onClick: closeOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: $ea95ad8a568dd277$exports.faTimesCircle
                                }),
                                " ",
                                _("close_entry")
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
$bfe6f4dc29c37278$export$2e2bcd8739ae039.propTypes = {
    currentTime: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).instanceOf(Date).isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};







function $8ef3cedac61156e9$var$safeDate(datetimeString) {
    var date = new Date(datetimeString);
    if (isNaN(date.valueOf())) throw new Error("Invalid date detected: \u201C".concat(datetimeString, "\u201D"));
    else return date;
}
function $8ef3cedac61156e9$export$8ce663b0c6b2535e(ids) {
    return $32ae13b741542474$export$299ba2dee77727e9("mark", {
        headers: {
            "content-type": "application/json; charset=utf-8"
        },
        body: JSON.stringify(ids)
    }).promise.then(function(response) {
        return response.json();
    });
}
function $8ef3cedac61156e9$export$d11ee7cd6d3f95d4(id, starr) {
    return $32ae13b741542474$export$299ba2dee77727e9("".concat(starr ? "starr" : "unstarr", "/").concat(id)).promise;
}
function $8ef3cedac61156e9$export$bf7f2fce5c1cf636(id, read) {
    return $32ae13b741542474$export$299ba2dee77727e9("".concat(read ? "unmark" : "mark", "/").concat(id)).promise;
}
/**
 * Converts some values like dates in an entry into a objects.
 */ function $8ef3cedac61156e9$var$enrichEntry(entry) {
    return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, entry), {
        link: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(entry.link),
        datetime: $8ef3cedac61156e9$var$safeDate(entry.datetime),
        updatetime: entry.updatetime ? $8ef3cedac61156e9$var$safeDate(entry.updatetime) : entry.updatetime
    });
}
/**
 * Converts some values like dates in response into a objects.
 */ function $8ef3cedac61156e9$var$enrichItemsResponse(data) {
    var _data_entries, _data_newItems;
    return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, data), {
        lastUpdate: data.lastUpdate ? $8ef3cedac61156e9$var$safeDate(data.lastUpdate) : data.lastUpdate,
        // in getItems
        entries: (_data_entries = data.entries) === null || _data_entries === void 0 ? void 0 : _data_entries.map($8ef3cedac61156e9$var$enrichEntry),
        // in sync
        newItems: (_data_newItems = data.newItems) === null || _data_newItems === void 0 ? void 0 : _data_newItems.map($8ef3cedac61156e9$var$enrichEntry)
    });
}
function $8ef3cedac61156e9$export$d2f92acf417bbf5d(filter, abortController) {
    return $32ae13b741542474$export$3988ae62b71be9a3("", {
        body: $32ae13b741542474$export$92871f7982deaf9f((0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, filter), {
            fromDatetime: filter.fromDatetime ? filter.fromDatetime.toISOString() : filter.fromDatetime
        })),
        abortController: abortController
    }).promise.then(function(response) {
        return response.json();
    }).then($8ef3cedac61156e9$var$enrichItemsResponse);
}
function $8ef3cedac61156e9$export$92d6409d68f0739a(updatedStatuses, syncParams) {
    var params = (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, syncParams), {
        updatedStatuses: syncParams.updatedStatuses ? syncParams.updatedStatuses.map(function(status) {
            return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, status), {
                datetime: status.datetime.toISOString()
            });
        }) : syncParams.updatedStatuses
    });
    if ("since" in params) params.since = params.since.toISOString();
    if ("itemsNotBefore" in params) params.itemsNotBefore = params.itemsNotBefore.toISOString();
    var _ajax_fetch = $32ae13b741542474$export$e7aa7bc5c1b3cfb3("items/sync", {
        method: updatedStatuses ? "POST" : "GET",
        body: $32ae13b741542474$export$92871f7982deaf9f(params)
    }), controller = _ajax_fetch.controller, promise = _ajax_fetch.promise;
    return {
        controller: controller,
        promise: promise.then(function(response) {
            return response.json();
        }).then($8ef3cedac61156e9$var$enrichItemsResponse)
    };
}













function $9b2cb125cea35be7$var$reloadList(param) {
    var fetchParams = param.fetchParams, abortController = param.abortController, _param_append = param.append, append = _param_append === void 0 ? false : _param_append, _param_waitForSync = param.waitForSync, waitForSync = _param_waitForSync === void 0 ? true : _param_waitForSync, configuration = param.configuration, _param_entryId = param.entryId, entryId = _param_entryId === void 0 ? null : _param_entryId, setLoadingState = param.setLoadingState;
    if (abortController.signal.aborted) return Promise.resolve();
    if (entryId && fetchParams.fromId === undefined) fetchParams = (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, fetchParams), {
        extraIds: (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(fetchParams.extraIds).concat([
            entryId
        ])
    });
    if (!append || fetchParams.type !== (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST) selfoss.dbOffline.olderEntriesOnline = false;
    setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
    var reload = function() {
        if (abortController.signal.aborted) return Promise.resolve();
        var reloader = selfoss.dbOffline.getEntries;
        // tag, source and search filtering not supported offline (yet?)
        if (fetchParams.tag || fetchParams.source || fetchParams.search) reloader = selfoss.dbOnline.getEntries;
        var forceLoadOnline = selfoss.dbOffline.olderEntriesOnline || selfoss.dbOffline.shouldLoadEntriesOnline;
        if (!selfoss.db.enableOffline.value || selfoss.isOnline() && forceLoadOnline) reloader = selfoss.dbOnline.getEntries;
        // Clean state when not just adding items.
        if (!append) {
            selfoss.entriesPage.setHasMore(false);
            selfoss.entriesPage.setExpandedEntries({});
            selfoss.entriesPage.setEntries([]);
            selfoss.entriesPage.setSelectedEntry(null);
        }
        setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
        return reloader(fetchParams, abortController).then(function(param) {
            var entries = param.entries, hasMore = param.hasMore;
            if (abortController.signal.aborted) return;
            setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            selfoss.entriesPage.setHasMore(hasMore);
            if (append) selfoss.entriesPage.appendEntries(entries);
            else {
                selfoss.entriesPage.setExpandedEntries({});
                selfoss.entriesPage.setEntries(entries);
                // open selected entry only if entry was requested (i.e. if not streaming
                // more)
                if (entryId && fetchParams.fromId === undefined) {
                    var entry = document.querySelector('.entry[data-entry-id="'.concat(entryId, '"]'));
                    if (!entry) return;
                    selfoss.entriesPage.activateEntry(entryId);
                    // ensure scrolling to requested entry even if scrolling to article
                    // header is disabled
                    if (!configuration.scrollToArticleHeader) // needs to be delayed for some reason
                    requestAnimationFrame(function() {
                        entry.scrollIntoView();
                    });
                } else window.scrollTo({
                    top: 0
                });
            }
        }).catch(function(error) {
            if (abortController.signal.aborted) return;
            if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                selfoss.history.push("/sign/in", {
                    error: selfoss.app._("error_session_expired")
                });
                return;
            }
            setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
            selfoss.app.showError(selfoss.app._("error_loading") + " " + error.message);
        });
    };
    if (waitForSync && selfoss.dbOnline.syncing.promise) {
        selfoss.db.userWaiting = true;
        return selfoss.dbOnline.syncing.promise.finally(reload);
    } else return reload();
}
/**
 * Try to open the selected article using the preferred method.
 * @param {number} selected
 */ function $9b2cb125cea35be7$var$openSelectedArticle(selected) {
    var link = document.querySelector('.entry[data-entry-id="'.concat(selected, '"] .entry-datetime'));
    if (selfoss.config.openInBackgroundTab) {
        // In Chromium, this will just cause the tab to open in the foreground.
        // Appears to be disallowed by the pop-under prevention:
        // https://crbug.com/431335
        // https://crbug.com/487919
        var event = new MouseEvent("click", {
            ctrlKey: true
        });
        link.dispatchEvent(event);
    } else // open item in new window
    link.click();
}
// updates a source
function $9b2cb125cea35be7$var$handleRefreshSource(param) {
    var event = param.event, source = param.source, setLoadingState = param.setLoadingState, setNavExpanded = param.setNavExpanded, reload = param.reload;
    event.preventDefault();
    // show loading
    setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
    return $b0e03640e062f6f9$export$c1f8f7c408fa54a(source).then(function() {
        // hide nav on smartphone
        setNavExpanded(false);
        // Fetch the new items and reload the list.
        // Will also clear the loading status.
        reload();
    }).catch(function(error) {
        setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
        alert(selfoss.app._("error_refreshing_source") + " " + error.message);
    });
}
function $9b2cb125cea35be7$export$66d62ccfdff1c843(param) {
    var entries = param.entries, hasMore = param.hasMore, loadingState = param.loadingState, setLoadingState = param.setLoadingState, selectedEntry = param.selectedEntry, expandedEntries = param.expandedEntries, setNavExpanded = param.setNavExpanded, navSourcesExpanded = param.navSourcesExpanded, reload = param.reload, setGlobalUnreadCount = param.setGlobalUnreadCount, unreadItemsCount = param.unreadItemsCount;
    var _params_category, _params_category1;
    var allowedToUpdate = (0, $bd320d0e16baa5f3$export$683005ba76038aff)();
    var allowedToWrite = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var forceReload = (0, $c8aedc92b88eb948$export$7bcdf1c247ef07b1)();
    var searchText = (0, $eHaBZ.useMemo)(function() {
        var queryString = new URLSearchParams(location.search);
        var _queryString_get;
        return (_queryString_get = queryString.get("search")) !== null && _queryString_get !== void 0 ? _queryString_get : "";
    }, [
        location.search
    ]);
    var params = (0, $c1feef6a502006a1$export$99eaa27ddbbb95ef)();
    var currentTag = ((_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith("tag-")) ? params.category.replace(/^tag-/, "") : null;
    var currentSource = ((_params_category1 = params.category) === null || _params_category1 === void 0 ? void 0 : _params_category1.startsWith("source-")) ? parseInt(params.category.replace(/^source-/, ""), 10) : null;
    // The offsets for pagination.
    // Clear them when URL changes, except for when only id changes since that happens when reading.
    var _useStateWithDeps = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $52218fae2790199f$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]), 2), fromDatetime = _useStateWithDeps[0], setFromDatetime = _useStateWithDeps[1];
    var _useStateWithDeps1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $52218fae2790199f$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]), 2), fromId = _useStateWithDeps1[0], setFromId = _useStateWithDeps1[1];
    // Cache the item id from initial URL so that we can fetch it
    // but do not re-fetch when the id in the URI changes later
    // since that happens when reading.
    var initialItemId = (0, $eHaBZ.useMemo)(function() {
        return parseInt(params.id, 10);
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText,
        forceReload
    ]);
    // Same for the state of navigation being expanded.
    // It is only passed to the API request as a part of optimization scheme
    // so there is no need for it to trigger refresh of the entries.
    var initialNavSourcesExpanded = (0, $eHaBZ.useMemo)(function() {
        return navSourcesExpanded;
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL), 2), moreLoadingState = _useState[0], setMoreLoadingState = _useState[1];
    // Perform the scheduled reload.
    (0, $eHaBZ.useEffect)(function() {
        var append = fromId !== undefined || fromDatetime !== undefined;
        var abortController = new AbortController();
        $9b2cb125cea35be7$var$reloadList({
            // Object with parameters for GET /items and similar API calls
            // based on the current location.
            fetchParams: {
                type: params.filter,
                tag: currentTag,
                source: currentSource,
                extraIds: [],
                sourcesNav: initialNavSourcesExpanded,
                search: searchText,
                fromDatetime: fromDatetime,
                fromId: fromId
            },
            abortController: abortController,
            append: append,
            configuration: configuration,
            // We do not want to focus the entry on successive loads.
            entryId: append ? undefined : initialItemId,
            setLoadingState: append ? setMoreLoadingState : setLoadingState
        }).then(function() {
            if (currentTag !== null && !selfoss.db.isValidTag(currentTag)) selfoss.app.showError(selfoss.app._("error_unknown_tag") + " " + currentTag);
            if (currentSource !== null && !selfoss.db.isValidSource(currentSource)) selfoss.app.showError(selfoss.app._("error_unknown_source") + " " + currentSource);
        });
        return function() {
            abortController.abort();
        };
    }, [
        configuration,
        params.filter,
        currentTag,
        currentSource,
        initialNavSourcesExpanded,
        searchText,
        fromDatetime,
        fromId,
        initialItemId,
        setLoadingState,
        forceReload
    ]);
    (0, $eHaBZ.useEffect)(function() {
        // scroll load more
        var onScroll = function() {
            var streamMoreButton = document.querySelector(".stream-more");
            if (!streamMoreButton) return;
            var streamMoreButtonTop = window.scrollY + streamMoreButton.getBoundingClientRect().top;
            // When “More” button appears on the screen, click it.
            if (streamMoreButtonTop < document.body.clientHeight + window.scrollY) streamMoreButton.click();
        };
        if (hasMore && moreLoadingState !== (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING && configuration.autoStreamMore) {
            window.addEventListener("scroll", onScroll);
            return function() {
                window.removeEventListener("scroll", onScroll);
            };
        }
    }, [
        configuration,
        hasMore,
        moreLoadingState
    ]);
    (0, $eHaBZ.useEffect)(function() {
        // setup periodic server status sync
        var interval = window.setInterval(selfoss.db.sync, 60000);
        return function() {
            window.clearInterval(interval);
        };
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        setGlobalUnreadCount(unreadItemsCount);
        return function() {
            setGlobalUnreadCount(null);
        };
    }, [
        setGlobalUnreadCount,
        unreadItemsCount
    ]);
    var isOnline = (0, $cf4db7b376694e94$export$6feb6ada280bcdab)();
    var refreshOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $9b2cb125cea35be7$var$handleRefreshSource({
            event: event,
            source: currentSource,
            setLoadingState: setLoadingState,
            setNavExpanded: setNavExpanded,
            reload: reload
        });
    }, [
        currentSource,
        setLoadingState,
        setNavExpanded,
        reload
    ]);
    var moreOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        var lastEntry = entries[entries.length - 1];
        // Calculate offset.
        setFromDatetime(lastEntry ? lastEntry.datetime : undefined);
        setFromId(lastEntry ? lastEntry.id : undefined);
    }, [
        entries,
        setFromDatetime,
        setFromId
    ]);
    // Current time for calculating relative dates in items.
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), currentTime = _useState1[0], setCurrentTime = _useState1[1];
    (0, $eHaBZ.useEffect)(function() {
        setCurrentTime(new Date());
        var tick = window.setInterval(function() {
            setCurrentTime(new Date());
        }, 60000);
        return function() {
            clearInterval(tick);
        };
    }, []);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    if (loadingState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$84dbad74efe95918), {
        label: _("entries_loading")
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
        children: [
            currentSource !== null && allowedToUpdate && isOnline ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                type: "button",
                className: "refresh-source",
                onClick: refreshOnClick,
                children: _("source_refresh")
            }) : null,
            currentSource !== null && allowedToWrite && isOnline ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                to: {
                    pathname: "/manage/sources",
                    hash: "#source-".concat(currentSource)
                },
                className: "entries-go-to-settings",
                children: _("source_go_to_settings")
            }) : null,
            entries.map(function(entry) /*#__PURE__*/ {
                var _expandedEntries_entry_id;
                return (0, $f171543c027e46e7$exports.jsx)((0, $bfe6f4dc29c37278$export$2e2bcd8739ae039), {
                    item: entry,
                    currentTime: currentTime,
                    selected: selectedEntry == entry.id,
                    expanded: (_expandedEntries_entry_id = expandedEntries[entry.id]) !== null && _expandedEntries_entry_id !== void 0 ? _expandedEntries_entry_id : false,
                    setNavExpanded: setNavExpanded
                }, entry.id);
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                id: "stream-buttons",
                children: [
                    loadingState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS && entries.length === 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        "aria-live": "assertive",
                        className: "stream-empty",
                        children: _("no_entries")
                    }) : null,
                    hasMore ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                            "stream-button": true,
                            "stream-more": true
                        }),
                        accessKey: "m",
                        "aria-label": _("more"),
                        onClick: moreLoadingState !== (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING ? moreOnClick : null,
                        children: moreLoadingState !== (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            children: _("more")
                        }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$7f7cbe89f1eacd2), {
                            size: "3x",
                            label: _("entries_loading")
                        })
                    }) : null,
                    entries.length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: "stream-button mark-these-read",
                        "aria-label": _("markread"),
                        onClick: selfoss.entriesPage.markVisibleRead,
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            children: _("markread")
                        })
                    }) : null,
                    loadingState == (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: "stream-button stream-error",
                        "aria-live": "assertive",
                        "aria-label": _("streamerror"),
                        onClick: reload,
                        children: _("streamerror")
                    }) : null
                ]
            })
        ]
    });
}
$9b2cb125cea35be7$export$66d62ccfdff1c843.propTypes = {
    entries: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).array.isRequired,
    hasMore: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    loadingState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf(Object.values((0, $d2d3ee75176c5e4c$export$62aa48085237e36f))).isRequired,
    setLoadingState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    selectedEntry: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number).isRequired,
    expandedEntries: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool).isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    reload: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setGlobalUnreadCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired
};
var $9b2cb125cea35be7$var$initialState = {
    entries: [],
    hasMore: false,
    /**
     * Currently selected entry.
     * The id in the location.hash should imply the selected entry.
     * It will also be used for keyboard navigation (for finding previous/next).
     */ selectedEntry: null,
    expandedEntries: {},
    loadingState: (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL
};
var $9b2cb125cea35be7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(StateHolder, _React_Component);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(StateHolder);
    function StateHolder(props) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, StateHolder);
        var _this;
        _this = _super.call(this, props);
        _this.state = $9b2cb125cea35be7$var$initialState;
        _this.reload = _this.reload.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setLoadingState = _this.setLoadingState.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.activateEntry = _this.activateEntry.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.deactivateEntry = _this.deactivateEntry.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.markVisibleRead = _this.markVisibleRead.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.markEntryRead = _this.markEntryRead.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.markEntryStarred = _this.markEntryStarred.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.nextPrev = _this.nextPrev.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.entryNav = _this.entryNav.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.jumpToNext = _this.jumpToNext.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.toggleSelectedStarred = _this.toggleSelectedStarred.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.toggleSelectedRead = _this.toggleSelectedRead.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.toggleSelectedExpanded = _this.toggleSelectedExpanded.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.openSelectedTarget = _this.openSelectedTarget.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.openSelectedTargetAndMarkRead = _this.openSelectedTargetAndMarkRead.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.throw = _this.throw.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        return _this;
    }
    (0, $53f3ce6e74f6aaad$export$d60067ff2358eee8)(StateHolder, [
        {
            key: "setEntries",
            value: function setEntries(entries) {
                if (typeof entries === "function") this.setState(function(state) {
                    return {
                        entries: entries(state.entries)
                    };
                });
                else this.setState({
                    entries: entries
                });
            }
        },
        {
            key: "appendEntries",
            value: function appendEntries(extraEntries) {
                this.setEntries(function(entries) {
                    return (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(entries).concat((0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(extraEntries));
                });
            }
        },
        {
            /**
     * Make the given entry currently selected one.
     * @param {number|function(number): number} id of entry to select, or a function that transforms a previous id into a new one
     */ key: "setSelectedEntry",
            value: function setSelectedEntry(selectedEntry) {
                if (typeof selectedEntry === "function") this.setState(function(state) {
                    return {
                        selectedEntry: selectedEntry(state.selectedEntry)
                    };
                });
                else this.setState({
                    selectedEntry: selectedEntry
                });
            }
        },
        {
            /**
     * Get the currently selected entry.
     * @return {number}
     */ key: "getSelectedEntry",
            value: function getSelectedEntry() {
                return this.state.selectedEntry;
            }
        },
        {
            key: "setExpandedEntries",
            value: function setExpandedEntries(expandedEntries) {
                if (typeof expandedEntries === "function") this.setState(function(state) {
                    return {
                        expandedEntries: expandedEntries(state.expandedEntries)
                    };
                });
                else this.setState({
                    expandedEntries: expandedEntries
                });
            }
        },
        {
            key: "setEntryExpanded",
            value: function setEntryExpanded(id, expand) {
                if (typeof expand === "function") this.setExpandedEntries(function(oldEntries) {
                    var _oldEntries_id;
                    return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, oldEntries), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, id, expand((_oldEntries_id = oldEntries[id]) !== null && _oldEntries_id !== void 0 ? _oldEntries_id : false)));
                });
                else this.setExpandedEntries(function(oldEntries) {
                    return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, oldEntries), (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, id, expand));
                });
            }
        },
        {
            /**
     * Collapse all expanded entries.
     */ key: "collapseAllEntries",
            value: function collapseAllEntries() {
                this.setExpandedEntries({});
            }
        },
        {
            /**
     * Is given entry expanded?
     * @param {number} id of entry to check
     * @return {bool} whether it is expanded
     */ key: "isEntryExpanded",
            value: function isEntryExpanded(entry) {
                var _this_state_expandedEntries_entry;
                return (_this_state_expandedEntries_entry = this.state.expandedEntries[entry]) !== null && _this_state_expandedEntries_entry !== void 0 ? _this_state_expandedEntries_entry : false;
            }
        },
        {
            /**
     * Toggle expanded state of given entry.
     * @param {number} id of entry to toggle
     */ key: "toggleEntryExpanded",
            value: function toggleEntryExpanded(entry) {
                if (!entry) return;
                this.setEntryExpanded(entry, function(expanded) {
                    return !(expanded !== null && expanded !== void 0 ? expanded : false);
                });
            }
        },
        {
            /**
     * Activate entry as if it were clicked.
     * This will open it, focus it and based on the settings, mark it as read.
     * @param {number} id of entry
     */ key: "activateEntry",
            value: function activateEntry(id) {
                if (this.props.configuration.autoCollapse) this.collapseAllEntries();
                this.setSelectedEntry(id);
                // show/hide (with toolbar)
                this.setEntryExpanded(id, true);
                // automark as read
                var entry = this.state.entries.find(function(entry) {
                    return id === entry.id;
                });
                var autoMarkAsRead = selfoss.isAllowedToWrite() && this.props.configuration.autoMarkAsRead && entry.unread == 1;
                if (autoMarkAsRead) this.markEntryRead(id, true);
            }
        },
        {
            /**
     * Deactivate entry, as if it were clicked.
     * This will close it and maybe something more.
     * @param {number} id of entry
     */ key: "deactivateEntry",
            value: function deactivateEntry(id) {
                this.setEntryExpanded(id, false);
            }
        },
        {
            key: "starEntryInView",
            value: function starEntryInView(id, starred) {
                this.setEntries(function(entries) {
                    return entries.map(function(entry) {
                        if (entry.id === id) return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, entry), {
                            starred: starred
                        });
                        else return entry;
                    });
                });
            }
        },
        {
            key: "markEntryInView",
            value: function markEntryInView(id, unread) {
                this.setEntries(function(entries) {
                    return entries.map(function(entry) {
                        if (entry.id === id) return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, entry), {
                            unread: unread
                        });
                        else return entry;
                    });
                });
            }
        },
        {
            key: "refreshEntryStatuses",
            value: function refreshEntryStatuses(entryStatuses) {
                var _this = this;
                this.state.entries.forEach(function(entry) {
                    var id = entry.id;
                    var newStatus = false;
                    entryStatuses.some(function(entryStatus) {
                        if (entryStatus.id == id) newStatus = entryStatus;
                        return newStatus;
                    });
                    if (newStatus) {
                        _this.starEntryInView(id, newStatus.starred);
                        _this.markEntryInView(id, newStatus.unread);
                    }
                });
            }
        },
        {
            key: "setHasMore",
            value: function setHasMore(hasMore) {
                if (typeof hasMore === "function") this.setState(function(state) {
                    return {
                        hasMore: hasMore(state.hasMore)
                    };
                });
                else this.setState({
                    hasMore: hasMore
                });
            }
        },
        {
            key: "setLoadingState",
            value: function setLoadingState(loadingState) {
                if (typeof loadingState === "function") this.setState(function(state) {
                    return {
                        loadingState: loadingState(state.loadingState)
                    };
                });
                else this.setState({
                    loadingState: loadingState
                });
            }
        },
        {
            key: "getActiveTag",
            value: function getActiveTag() {
                var _params_category;
                if (!this.props.match) return null;
                var params = this.props.match.params;
                return ((_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith("tag-")) ? params.category.replace(/^tag-/, "") : null;
            }
        },
        {
            key: "getActiveSource",
            value: function getActiveSource() {
                var _params_category;
                if (!this.props.match) return null;
                var params = this.props.match.params;
                return ((_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith("source-")) ? parseInt(params.category.replace(/^source-/, ""), 10) : null;
            }
        },
        {
            key: "getActiveFilter",
            value: function getActiveFilter() {
                if (!this.props.match) return null;
                return this.props.match.params.filter;
            }
        },
        {
            /**
     * Mark all visible items as read
     */ key: "markVisibleRead",
            value: function markVisibleRead() {
                var _this = this;
                var ids = [];
                var tagUnreadDiff = {};
                var sourceUnreadDiff = {};
                var markedEntries = this.state.entries.map(function(entry) {
                    if (!entry.unread) return entry;
                    ids.push(entry.id);
                    Object.keys(entry.tags).forEach(function(tag) {
                        if (Object.keys(tagUnreadDiff).includes(tag)) tagUnreadDiff[tag] += -1;
                        else tagUnreadDiff[tag] = -1;
                    });
                    var source = entry.source;
                    if (Object.keys(sourceUnreadDiff).includes(source.toString())) sourceUnreadDiff[source] += -1;
                    else sourceUnreadDiff[source] = -1;
                    return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, entry), {
                        unread: false
                    });
                });
                var oldEntries = this.state.entries;
                var hadMore = this.state.hasMore;
                // close opened entry and list
                this.setExpandedEntries({});
                this.props.setNavExpanded(false);
                if (ids.length !== 0 && this.props.match.params.filter === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD) markedEntries = markedEntries.filter(function(param) {
                    var id = param.id;
                    return !ids.includes(id);
                });
                this.setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
                this.setEntries(markedEntries);
                // update statistics in main menu
                var updateStats = function(markRead) {
                    // update all unread counters
                    var unreadstats = selfoss.app.state.unreadItemsCount;
                    var diff = markRead ? -1 : 1;
                    selfoss.refreshUnread(unreadstats + diff * ids.length);
                    // update unread on tags and sources
                    if (markRead) selfoss.app.refreshTagSourceUnread(tagUnreadDiff, sourceUnreadDiff);
                    else // Diffs are negative by default.
                    selfoss.app.refreshTagSourceUnread(Object.fromEntries(Object.entries(tagUnreadDiff).map(function(param) {
                        var _param = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(param, 2), tag = _param[0], diff = _param[1];
                        return [
                            tag,
                            -1 * diff
                        ];
                    })), Object.fromEntries(Object.entries(sourceUnreadDiff).map(function(param) {
                        var _param = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(param, 2), source = _param[0], diff = _param[1];
                        return [
                            source,
                            -1 * diff
                        ];
                    })));
                };
                updateStats(true);
                if (selfoss.db.enableOffline.value) selfoss.dbOffline.entriesMark(ids, false);
                $8ef3cedac61156e9$export$8ce663b0c6b2535e(ids).then(function() {
                    _this.setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
                }).catch(function(error) {
                    selfoss.handleAjaxError(error).then(function() {
                        var statuses = ids.map(function(id) {
                            return {
                                entryId: id,
                                name: "unread",
                                value: false
                            };
                        });
                        selfoss.dbOffline.enqueueStatuses(statuses);
                    }).catch(function(error) {
                        if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                            selfoss.history.push("/sign/in", {
                                error: selfoss.app._("error_session_expired")
                            });
                            return;
                        }
                        _this.setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
                        _this.setEntries(oldEntries);
                        updateStats(false);
                        _this.setHasMore(hadMore);
                        selfoss.app.showError(selfoss.app._("error_mark_items") + " " + error.message);
                    });
                });
            }
        },
        {
            /**
     * Requests for an entry to be marked read/unread in the model.
     * @param {number} id of entry to mark
     * @param {bool|'toggle'} true to mark read, false to mark unread
     */ key: "markEntryRead",
            value: function markEntryRead(id, markRead) {
                var _this = this;
                // only loggedin users
                if (!selfoss.isAllowedToWrite()) {
                    console.log("User not allowed to mark an entry (un)read.");
                    return;
                }
                var entry = this.state.entries.find(function(entry) {
                    return id === entry.id;
                });
                if (markRead === "toggle") markRead = entry.unread;
                this.markEntryInView(id, !markRead);
                // update statistics in main menue and the currently active tag
                var updateStats = function(markRead) {
                    // update all unread counters
                    var unreadstats = selfoss.app.state.unreadItemsCount;
                    var diff = markRead ? -1 : 1;
                    selfoss.refreshUnread(unreadstats + diff);
                    // update unread on tags and sources
                    // Only a single instance of each tag per entry so we can just assign.
                    var entryTags = Object.fromEntries(Object.keys(entry.tags).map(function(tag) {
                        return [
                            tag,
                            diff
                        ];
                    }));
                    selfoss.app.refreshTagSourceUnread(entryTags, (0, $ec426015f75d7738$export$1e71eb4bef00f6b0)({}, entry.source, diff));
                };
                updateStats(markRead);
                if (selfoss.db.enableOffline.value) selfoss.dbOffline.entryMark(id, !markRead);
                $8ef3cedac61156e9$export$bf7f2fce5c1cf636(id, !markRead).then(function() {
                    selfoss.db.setOnline();
                }).catch(function(error) {
                    selfoss.handleAjaxError(error).then(function() {
                        selfoss.dbOffline.enqueueStatus(id, "unread", !markRead);
                    }).catch(function(error) {
                        if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                            selfoss.history.push("/sign/in", {
                                error: selfoss.app._("error_session_expired")
                            });
                            return;
                        }
                        // rollback ui changes
                        _this.markEntryInView(id, markRead);
                        updateStats(!markRead);
                        selfoss.app.showError(selfoss.app._("error_mark_item") + " " + error.message);
                    });
                });
            }
        },
        {
            /**
     * Requests for an entry to be marked (un)starred in the model.
     * @param {number} id of entry to mark
     * @param {bool|'toggle'} true to mark starred, false to mark unstarred
     */ key: "markEntryStarred",
            value: function markEntryStarred(id, markStarred) {
                var _this = this;
                // only loggedin users
                if (!selfoss.isAllowedToWrite()) {
                    console.log("User not allowed to (un)star an entry.");
                    return;
                }
                if (markStarred === "toggle") {
                    var entry = this.state.entries.find(function(entry) {
                        return id === entry.id;
                    });
                    markStarred = !entry.starred;
                }
                this.starEntryInView(id, markStarred);
                // update statistics in main menu
                var updateStats = function(markStarred) {
                    selfoss.app.setStarredItemsCount(function(starred) {
                        return starred + (markStarred ? 1 : -1);
                    });
                };
                updateStats(markStarred);
                if (selfoss.db.enableOffline.value) selfoss.dbOffline.entryStar(id, markStarred);
                $8ef3cedac61156e9$export$d11ee7cd6d3f95d4(id, markStarred).then(function() {
                    selfoss.db.setOnline();
                }).catch(function(error) {
                    selfoss.handleAjaxError(error).then(function() {
                        selfoss.dbOffline.enqueueStatus(id, "starred", markStarred);
                    }).catch(function(error) {
                        if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                            selfoss.history.push("/sign/in", {
                                error: selfoss.app._("error_session_expired")
                            });
                            return;
                        }
                        // rollback ui changes
                        _this.starEntryInView(id, !markStarred);
                        updateStats(!markStarred);
                        selfoss.app.showError(selfoss.app._("error_star_item") + " " + error.message);
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                /**
         * HACK: A counter that is increased every time reload action (r key) is triggered.
         */ selfoss.history.replace((0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, this.props.location, (0, $0be080af3052783c$export$d0bb2ab5375d1521)(this.props.location, {
                    id: null
                })), {
                    state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(this.props.location)
                }));
            }
        },
        {
            /**
     * get next/prev item
     * @param direction
     */ key: "nextPrev",
            value: function nextPrev(direction) {
                var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (direction != (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT && direction != (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV) throw new Error("direction must be one of Direction.{PREV,NEXT}");
                // when there are no entries
                if (this.state.entries.length == 0) return;
                // select current
                var old = this.getSelectedEntry();
                var oldIndex = old !== null ? this.state.entries.findIndex(function(param) {
                    var id = param.id;
                    return id === old;
                }) : null;
                var current = null;
                // select next/prev entry and save it to "current"
                // if we would overflow, we stay on the old one
                if (direction == (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT) {
                    if (old === null) current = this.state.entries[0].id;
                    else {
                        var nextIndex = oldIndex + 1;
                        if (nextIndex >= this.state.entries.length) {
                            var // attempt to load more
                            _document_querySelector;
                            current = old;
                            (_document_querySelector = document.querySelector(".stream-more")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.click();
                        } else current = this.state.entries[nextIndex].id;
                    }
                } else {
                    if (old === null) return;
                    else if (oldIndex <= 0) current = old;
                    else current = this.state.entries[oldIndex - 1].id;
                }
                if (old !== current) {
                    // remove active
                    this.deactivateEntry(old);
                    if (open) this.activateEntry(current);
                    else this.setSelectedEntry(current);
                    var currentElement = document.querySelector('.entry[data-entry-id="'.concat(current, '"]'));
                    // scroll to element
                    (0, $b625dc2dd2df76bd$export$d976747ecb966cea)(currentElement);
                    // focus the title link for better keyboard navigation
                    currentElement.querySelector(".entry-title-link").focus();
                }
            }
        },
        {
            /**
     * entry navigation (next/prev) with keys
     * @param direction
     */ key: "entryNav",
            value: function entryNav(direction) {
                if (direction != (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT && direction != (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV) throw new Error("direction must be one of Direction.{PREV,NEXT}");
                var open = this.isEntryExpanded(this.getSelectedEntry());
                this.nextPrev(direction, open);
            }
        },
        {
            key: "jumpToNext",
            value: function jumpToNext() {
                var selected = this.getSelectedEntry();
                if (selected !== null && !this.isEntryExpanded(selected)) this.activateEntry(selected);
                else this.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT, true);
            }
        },
        {
            key: "toggleSelectedStarred",
            value: function toggleSelectedStarred() {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryStarred(selected, "toggle");
            }
        },
        {
            key: "toggleSelectedRead",
            value: function toggleSelectedRead() {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryRead(selected, "toggle");
            }
        },
        {
            key: "toggleSelectedExpanded",
            value: function toggleSelectedExpanded() {
                this.toggleEntryExpanded(this.getSelectedEntry());
            }
        },
        {
            key: "openSelectedTarget",
            value: function openSelectedTarget() {
                var selected = this.getSelectedEntry();
                if (selected !== null) $9b2cb125cea35be7$var$openSelectedArticle(selected);
            }
        },
        {
            key: "openSelectedTargetAndMarkRead",
            value: function openSelectedTargetAndMarkRead() {
                var selected = this.getSelectedEntry();
                if (selected !== null) {
                    this.markEntryRead(selected, true);
                    $9b2cb125cea35be7$var$openSelectedArticle(selected);
                }
            }
        },
        {
            key: "throw",
            value: function _throw(direction) {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryRead(selected, true);
                this.nextPrev(direction, true);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($9b2cb125cea35be7$export$66d62ccfdff1c843, {
                    entries: this.state.entries,
                    selectedEntry: this.state.selectedEntry,
                    expandedEntries: this.state.expandedEntries,
                    hasMore: this.state.hasMore,
                    loadingState: this.state.loadingState,
                    setLoadingState: this.setLoadingState,
                    setNavExpanded: this.props.setNavExpanded,
                    navSourcesExpanded: this.props.navSourcesExpanded,
                    reload: this.reload,
                    setGlobalUnreadCount: this.props.setGlobalUnreadCount,
                    unreadItemsCount: this.props.unreadItemsCount
                });
            }
        }
    ]);
    return StateHolder;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
$9b2cb125cea35be7$export$2e2bcd8739ae039.propTypes = {
    configuration: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    match: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setGlobalUnreadCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired
};




var $eHaBZ = parcelRequire("eHaBZ");









var $eHaBZ = parcelRequire("eHaBZ");









function $5040dba436a03900$export$2e2bcd8739ae039(param) {
    var setNavExpanded = param.setNavExpanded, offlineState = param.offlineState, allItemsCount = param.allItemsCount, allItemsOfflineCount = param.allItemsOfflineCount, unreadItemsCount = param.unreadItemsCount, unreadItemsOfflineCount = param.unreadItemsOfflineCount, starredItemsCount = param.starredItemsCount, starredItemsOfflineCount = param.starredItemsOfflineCount;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(true), 2), expanded = _useState[0], setExpanded = _useState[1];
    // useParams does not seem to work.
    var match = (0, $c1feef6a502006a1$export$632be4bb944c1bc7)((0, $0be080af3052783c$export$f1004941042944df));
    var params = match !== null ? match.params : {};
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return setExpanded(function(expanded) {
            return !expanded;
        });
    }, []);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var newestLink = (0, $eHaBZ.useCallback)(function(location) {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, location, (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            filter: (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST,
            id: null
        })), {
            state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(location)
        });
    }, []);
    var unreadLink = (0, $eHaBZ.useCallback)(function(location) {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, location, (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            filter: (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD,
            id: null
        })), {
            state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(location)
        });
    }, []);
    var starredLink = (0, $eHaBZ.useCallback)(function(location) {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, location, (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            filter: (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED,
            id: null
        })), {
            state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(location)
        });
    }, []);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "nav-filter-wrapper",
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-filter-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        "nav-section-toggle": true,
                        "nav-filter-collapsed": !expanded,
                        "nav-filter-expanded": expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                            icon: expanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        " ",
                        _("filter")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b90992e7bfaebf0a$exports))), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "nav-filter",
                    "aria-labelledby": "nav-filter-title",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-newest",
                                to: newestLink,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    "nav-filter-newest": true,
                                    active: params.filter === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST
                                }),
                                onClick: collapseNav,
                                children: [
                                    _("newest"),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            "offline-count": true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: allItemsCount !== allItemsOfflineCount && allItemsOfflineCount
                                        }),
                                        title: _("offline_count"),
                                        children: allItemsOfflineCount > 0 ? allItemsOfflineCount : ""
                                    }),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: "count",
                                        title: _("online_count"),
                                        children: allItemsCount > 0 ? allItemsCount : ""
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-unread",
                                to: unreadLink,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    "nav-filter-unread": true,
                                    active: params.filter === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD
                                }),
                                onClick: collapseNav,
                                children: [
                                    _("unread"),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            "unread-count": true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            unread: unreadItemsCount > 0
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                    "offline-count": true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                }),
                                                title: _("offline_count"),
                                                children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ""
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                className: "count",
                                                title: _("online_count"),
                                                children: unreadItemsCount > 0 ? unreadItemsCount : ""
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-starred",
                                to: starredLink,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    "nav-filter-starred": true,
                                    active: params.filter === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED
                                }),
                                onClick: collapseNav,
                                children: [
                                    _("starred"),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            "offline-count": true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: starredItemsCount !== starredItemsOfflineCount && starredItemsOfflineCount
                                        }),
                                        title: _("offline_count"),
                                        children: starredItemsOfflineCount > 0 ? starredItemsOfflineCount : ""
                                    }),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: "count",
                                        title: _("online_count"),
                                        children: starredItemsCount > 0 ? starredItemsCount : ""
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$5040dba436a03900$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired
};






var $eHaBZ = parcelRequire("eHaBZ");












function $a66ee1fb90186752$var$handleTitleClick(param) {
    var setExpanded = param.setExpanded, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, setSources = param.setSources;
    if (!selfoss.isOnline()) {
        console.log("Cannot toggle, not online.");
        return;
    }
    setExpanded(function(expanded) {
        if (!expanded && sourcesState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL) $b0e03640e062f6f9$export$432f698644f45d1().then(function(data) {
            setSources(data);
            setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
        }).catch(function(error) {
            setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
            selfoss.app.showError(selfoss.app._("error_loading_stats") + " " + error.message);
        });
        return !expanded;
    });
}
function $a66ee1fb90186752$var$Source(param) {
    var source = param.source, active = param.active, collapseNav = param.collapseNav;
    var link = (0, $eHaBZ.useCallback)(function(location) {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, location, (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(source.id),
            id: null
        })), {
            state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(location)
        });
    }, [
        source.id
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            read: source.unread === 0
        }),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                active: active,
                unread: source.unread > 0
            }),
            onClick: collapseNav,
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "nav-source",
                    children: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(source.title)
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "unread",
                    children: source.unread > 0 ? source.unread : ""
                })
            ]
        })
    });
}
$a66ee1fb90186752$var$Source.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    collapseNav: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};
function $a66ee1fb90186752$export$2e2bcd8739ae039(param) {
    var setNavExpanded = param.setNavExpanded, navSourcesExpanded = param.navSourcesExpanded, setNavSourcesExpanded = param.setNavSourcesExpanded, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, sources = param.sources, setSources = param.setSources;
    var _params_category;
    var reallyExpanded = navSourcesExpanded && sourcesState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS;
    // useParams does not seem to work.
    var match = (0, $c1feef6a502006a1$export$632be4bb944c1bc7)((0, $0be080af3052783c$export$f1004941042944df));
    var params = match !== null ? match.params : {};
    var currentSource = ((_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith("source-")) ? parseInt(params.category.replace(/^source-/, ""), 10) : null;
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return $a66ee1fb90186752$var$handleTitleClick({
            setExpanded: setNavSourcesExpanded,
            sourcesState: sourcesState,
            setSourcesState: setSourcesState,
            setSources: setSources
        });
    }, [
        setNavSourcesExpanded,
        sourcesState,
        setSourcesState,
        setSources
    ]);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var previousSourcesState = (0, $45d08aa99719a2d0$export$f6f3f74729fdd0b7)(sourcesState);
    (0, $eHaBZ.useEffect)(function() {
        if (previousSourcesState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL && sourcesState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS) setNavSourcesExpanded(true);
    }, [
        previousSourcesState,
        sourcesState,
        setNavSourcesExpanded
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-sources-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        "nav-section-toggle": true,
                        "nav-sources-collapsed": !reallyExpanded,
                        "nav-sources-expanded": reallyExpanded
                    }),
                    "aria-expanded": reallyExpanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                            icon: navSourcesExpanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        "  ",
                        _("sources")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b90992e7bfaebf0a$exports))), {
                isOpen: reallyExpanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                    id: "nav-sources",
                    "aria-labelledby": "nav-sources-title",
                    children: sources.map(function(source) {
                        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($a66ee1fb90186752$var$Source, {
                            source: source,
                            active: currentSource === source.id,
                            collapseNav: collapseNav
                        }, source.id);
                    })
                })
            })
        ]
    });
}
$a66ee1fb90186752$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf(Object.values((0, $d2d3ee75176c5e4c$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};





var $eHaBZ = parcelRequire("eHaBZ");







// search button shows search input or executes search
function $4c0fa68710d48580$var$handleSubmit(param) {
    var active = param.active, setActive = param.setActive, searchField = param.searchField, searchText = param.searchText, history = param.history, location = param.location, setNavExpanded = param.setNavExpanded;
    if (!selfoss.isSmartphone() && !active) {
        setActive(true);
        searchField.current.focus();
        searchField.current.select();
        return;
    }
    history.push((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
        search: searchText,
        id: null
    }));
    setActive(false);
    searchField.current.blur();
    setNavExpanded(false);
}
function $4c0fa68710d48580$var$handleFieldKeyUp(param) {
    var event = param.event, searchButton = param.searchButton, searchRemoveButton = param.searchRemoveButton;
    // keypress enter in search inputfield
    if (event.which == 13) searchButton.current.click();
    if (event.keyCode == 27) searchRemoveButton.current.click();
}
// remove button of search
function $4c0fa68710d48580$var$handleRemove(param) {
    var setActive = param.setActive, searchField = param.searchField, history = param.history, location = param.location;
    var queryString = new URLSearchParams(location.search);
    var oldTerm = queryString.get("search");
    setActive(false);
    if (oldTerm == "") {
        searchField.current.blur();
        return;
    }
    history.push((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
        search: "",
        id: null
    }));
}
function $4c0fa68710d48580$export$2e2bcd8739ae039(param) {
    var setNavExpanded = param.setNavExpanded, offlineState = param.offlineState;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(false), 2), active = _useState[0], setActive = _useState[1];
    var searchField = (0, $eHaBZ.useRef)(null);
    var searchButton = (0, $eHaBZ.useRef)(null);
    var searchRemoveButton = (0, $eHaBZ.useRef)(null);
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    var queryString = new URLSearchParams(location.search);
    var _queryString_get;
    var oldTerm = (_queryString_get = queryString.get("search")) !== null && _queryString_get !== void 0 ? _queryString_get : "";
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(""), 2), searchText = _useState1[0], setSearchText = _useState1[1];
    (0, $eHaBZ.useEffect)(function() {
        // Update the search term when the query string changes.
        setSearchText(oldTerm);
    }, [
        oldTerm
    ]);
    var termOnKeyUp = (0, $eHaBZ.useCallback)(function(event) {
        return $4c0fa68710d48580$var$handleFieldKeyUp({
            event: event,
            searchButton: searchButton,
            searchRemoveButton: searchRemoveButton
        });
    }, []);
    var termOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setSearchText(event.target.value);
    }, []);
    var removeOnClick = (0, $eHaBZ.useCallback)(function() {
        return $4c0fa68710d48580$var$handleRemove({
            setActive: setActive,
            searchField: searchField,
            history: history,
            location: location
        });
    }, [
        history,
        location
    ]);
    var searchOnClick = (0, $eHaBZ.useCallback)(function() {
        return $4c0fa68710d48580$var$handleSubmit({
            active: active,
            setActive: setActive,
            searchField: searchField,
            searchText: searchText,
            history: history,
            location: location,
            setNavExpanded: setNavExpanded
        });
    }, [
        active,
        searchText,
        history,
        location,
        setNavExpanded
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "search",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            offline: offlineState,
            online: !offlineState,
            active: active
        }),
        role: "search",
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                "aria-label": _("search_label"),
                type: "search",
                id: "search-term",
                accessKey: "s",
                ref: searchField,
                value: searchText,
                onKeyUp: termOnKeyUp,
                onChange: termOnChange
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "search-remove",
                title: _("searchremove"),
                accessKey: "h",
                "aria-label": _("searchremove"),
                onClick: removeOnClick,
                ref: searchRemoveButton,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $6c06a95c587730ec$exports.faTimes
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                id: "search-button",
                title: _("searchbutton"),
                "aria-label": _("searchbutton"),
                accessKey: "e",
                onClick: searchOnClick,
                ref: searchButton,
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                        icon: $3d54bd244f4653d3$exports.faSearch
                    }),
                    " ",
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "search-button-label",
                        children: _("searchbutton")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
        ]
    });
}
$4c0fa68710d48580$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired
};







var $eHaBZ = parcelRequire("eHaBZ");








var $eHaBZ = parcelRequire("eHaBZ");



/**
 * Get dark OR bright color depending the color contrast.
 *
 * @param string hexColor color (hex) value
 * @param string darkColor dark color value
 * @param string brightColor bright color value
 *
 * @return string dark OR bright color value
 *
 * @see https://24ways.org/2010/calculating-color-contrast/
 */ function $8cbb75ae74525933$export$97e1e2675ab19423(hexColor) {
    var darkColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "#555", brightColor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "#EEE";
    // Strip hash sign.
    var color = hexColor.substr(1);
    var r = parseInt(color.substr(0, 2), 16);
    var g = parseInt(color.substr(2, 2), 16);
    var b = parseInt(color.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? darkColor : brightColor;
}




var $e097d983d6c2a48b$var$palette = [
    "#ffccc9",
    "#ffce93",
    "#fffc9e",
    "#ffffc7",
    "#9aff99",
    "#96fffb",
    "#cdffff",
    "#cbcefb",
    "#fffe65",
    "#cfcfcf",
    "#fd6864",
    "#fe996b",
    "#fcff2f",
    "#67fd9a",
    "#38fff8",
    "#68fdff",
    "#9698ed",
    "#c0c0c0",
    "#fe0000",
    "#f8a102",
    "#ffcc67",
    "#f8ff00",
    "#34ff34",
    "#68cbd0",
    "#34cdf9",
    "#6665cd",
    "#9b9b9b",
    "#cb0000",
    "#f56b00",
    "#ffcb2f",
    "#ffc702",
    "#32cb00",
    "#00d2cb",
    "#3166ff",
    "#6434fc",
    "#656565",
    "#9a0000",
    "#ce6301",
    "#cd9934",
    "#999903",
    "#009901",
    "#329a9d",
    "#3531ff",
    "#6200c9",
    "#343434",
    "#680100",
    "#963400",
    "#986536",
    "#646809",
    "#036400",
    "#34696d",
    "#00009b",
    "#303498",
    "#000000",
    "#330001",
    "#643403",
    "#663234",
    "#343300",
    "#013300",
    "#003532",
    "#010066",
    "#340096"
];
function $e097d983d6c2a48b$var$ColorButton(param) {
    var tag = param.tag, color = param.color;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            backgroundColor: color,
            color: (0, $8cbb75ae74525933$export$97e1e2675ab19423)(color)
        };
    }, [
        color
    ]);
    var selected = color === tag.color;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d2607b40d2c54b42$export$2ce376c2cc3355c8), {
        className: "popup-menu-item",
        value: color,
        style: style,
        children: selected ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
            icon: $0c96aa001209cff1$exports.faCheck
        }) : " "
    });
}
$e097d983d6c2a48b$var$ColorButton.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired
};
var $e097d983d6c2a48b$var$preventDefault = function(event) {
    event.preventDefault();
    // Prevent closing navigation on mobile.
    event.stopPropagation();
};
function $e097d983d6c2a48b$export$2e2bcd8739ae039(param) {
    var tag = param.tag, onChange = param.onChange;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            backgroundColor: tag.color
        };
    }, [
        tag.color
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
        className: "color",
        onClick: $e097d983d6c2a48b$var$preventDefault,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $7520d8d0d9cb8a67$export$d9b273488cd8ce6f), {
            menuButton: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $8cca9a381f9e7f19$export$266a769812832828), {
                className: "color-chooser-button",
                title: _("tag_change_color_button_title"),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "color-box",
                        style: style
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: _("tag_change_color_button_title")
                    })
                ]
            }),
            menuClassName: "color-chooser popup-menu",
            onItemClick: onChange,
            viewScroll: "auto",
            portal: true,
            children: [
                $e097d983d6c2a48b$var$palette.map(function(color) {
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e097d983d6c2a48b$var$ColorButton, {
                        color: color,
                        tag: tag
                    }, color);
                }),
                !$e097d983d6c2a48b$var$palette.includes(tag.color) && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e097d983d6c2a48b$var$ColorButton, {
                    color: tag.color,
                    tag: tag
                }, "custom")
            ]
        })
    });
}
$e097d983d6c2a48b$export$2e2bcd8739ae039.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};







function $25d64656d90230de$var$Tag(param) {
    var tag = param.tag, active = param.active, collapseNav = param.collapseNav;
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var tagName = tag !== null ? tag.tag : null;
    var colorChanged = (0, $eHaBZ.useCallback)(function(param) {
        var value = param.value;
        (0, $bcc58ea15e13e580$export$6f3c7c74c4b252bb)(tagName, value).then(function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
        }).catch(function(error) {
            selfoss.app.showError(selfoss.app._("error_saving_color") + " " + error.message);
        });
    }, [
        tagName
    ]);
    var category = tag === null ? "all" : "tag-".concat(tag.tag);
    var link = (0, $eHaBZ.useCallback)(function(location) {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, location, (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: category,
            id: null
        })), {
            state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(location)
        });
    }, [
        category
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            read: tag !== null && tag.unread === 0
        }),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                "nav-tags-all": tag === null,
                active: active
            }),
            onClick: collapseNav,
            children: tag === null ? _("alltags") : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "tag",
                        children: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(tag.tag)
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "unread",
                        children: tag.unread > 0 ? tag.unread : ""
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e097d983d6c2a48b$export$2e2bcd8739ae039), {
                        tag: tag,
                        onChange: colorChanged
                    })
                ]
            })
        })
    });
}
$25d64656d90230de$var$Tag.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    collapseNav: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};
function $25d64656d90230de$export$2e2bcd8739ae039(param) {
    var setNavExpanded = param.setNavExpanded, tags = param.tags;
    var _params_category;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(true), 2), expanded = _useState[0], setExpanded = _useState[1];
    // useParams does not seem to work.
    var match = (0, $c1feef6a502006a1$export$632be4bb944c1bc7)((0, $0be080af3052783c$export$f1004941042944df));
    var params = match !== null ? match.params : {};
    var currentAllTags = params.category === "all";
    var currentTag = ((_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith("tag-")) ? params.category.replace(/^tag-/, "") : null;
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return setExpanded(function(expanded) {
            return !expanded;
        });
    }, []);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-tags-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        "nav-section-toggle": true,
                        "nav-tags-collapsed": !expanded,
                        "nav-tags-expanded": expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                            icon: expanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        "  ",
                        _("tags")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b90992e7bfaebf0a$exports))), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "nav-tags",
                    "aria-labelledby": "nav-tags-title",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($25d64656d90230de$var$Tag, {
                            tag: null,
                            active: currentAllTags,
                            collapseNav: collapseNav
                        }),
                        tags.map(function(tag) {
                            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($25d64656d90230de$var$Tag, {
                                tag: tag,
                                active: currentTag === tag.tag,
                                collapseNav: collapseNav
                            }, tag.tag);
                        })
                    ]
                })
            })
        ]
    });
}
$25d64656d90230de$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired
};







var $eHaBZ = parcelRequire("eHaBZ");








function $8a7bf68b184288ce$var$handleReloadAll(param) {
    var reloadAll = param.reloadAll, setReloading = param.setReloading, setNavExpanded = param.setNavExpanded;
    setReloading(true);
    reloadAll().finally(function() {
        setNavExpanded(false);
        setReloading(false);
    });
}
function $8a7bf68b184288ce$var$handleLogOut(param) {
    var setNavExpanded = param.setNavExpanded;
    // only loggedin users
    if (!selfoss.hasSession() || !selfoss.isOnline()) return;
    selfoss.db.clear();
    selfoss.logout();
    setNavExpanded(false);
}
function $8a7bf68b184288ce$export$2e2bcd8739ae039(param) {
    var reloadAll = param.reloadAll, setNavExpanded = param.setNavExpanded;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(false), 2), reloading = _useState[0], setReloading = _useState[1];
    var refreshOnClick = (0, $eHaBZ.useCallback)(function() {
        return $8a7bf68b184288ce$var$handleReloadAll({
            reloadAll: reloadAll,
            setReloading: setReloading,
            setNavExpanded: setNavExpanded
        });
    }, [
        reloadAll,
        setNavExpanded
    ]);
    var settingsOnClick = (0, $eHaBZ.useCallback)(function() {
        setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var settingsLink = (0, $eHaBZ.useCallback)(function(location) {
        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, location), {
            pathname: "/manage/sources",
            state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(location)
        });
    }, []);
    var logoutOnClick = (0, $eHaBZ.useCallback)(function() {
        return $8a7bf68b184288ce$var$handleLogOut({
            setNavExpanded: setNavExpanded
        });
    }, [
        setNavExpanded
    ]);
    var isLoggedIn = (0, $bd320d0e16baa5f3$export$3b062b02b4537682)();
    var canRefreshAll = (0, $bd320d0e16baa5f3$export$683005ba76038aff)();
    var canVisitSettings = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    var canLogOut = isLoggedIn;
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    var canLogIn = !isLoggedIn && configuration.authEnabled;
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        className: "nav-toolbar",
        children: [
            canRefreshAll && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "nav-refresh",
                title: _("refreshbutton"),
                "aria-label": _("refreshbutton"),
                accessKey: "r",
                onClick: refreshOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $468e6f5287149412$exports.faSyncAlt,
                    fixedWidth: true,
                    spin: reloading
                })
            }),
            canVisitSettings && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                id: "nav-settings",
                title: _("settingsbutton"),
                "aria-label": _("settingsbutton"),
                accessKey: "t",
                to: settingsLink,
                onClick: settingsOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $78546ca20d789f8c$exports.faCloudUploadAlt,
                    fixedWidth: true
                })
            }),
            canLogOut && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "nav-logout",
                title: _("logoutbutton"),
                "aria-label": _("logoutbutton"),
                accessKey: "l",
                onClick: logoutOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $17ddfe677f5b40f7$exports.faSignOutAlt,
                    fixedWidth: true
                })
            }),
            canLogIn && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                id: "nav-login",
                title: _("loginbutton"),
                "aria-label": _("loginbutton"),
                accessKey: "l",
                to: "/sign/in",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $5a270b3b7e6b7fa8$exports.faKey,
                    fixedWidth: true
                })
            })
        ]
    });
}
$8a7bf68b184288ce$export$2e2bcd8739ae039.propTypes = {
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};







function $117ab31dd2c08da6$export$2e2bcd8739ae039(param) {
    var entriesPage = param.entriesPage, setNavExpanded = param.setNavExpanded, navSourcesExpanded = param.navSourcesExpanded, setNavSourcesExpanded = param.setNavSourcesExpanded, offlineState = param.offlineState, allItemsCount = param.allItemsCount, allItemsOfflineCount = param.allItemsOfflineCount, unreadItemsCount = param.unreadItemsCount, unreadItemsOfflineCount = param.unreadItemsOfflineCount, starredItemsCount = param.starredItemsCount, starredItemsOfflineCount = param.starredItemsOfflineCount, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, sources = param.sources, setSources = param.setSources, tags = param.tags, reloadAll = param.reloadAll;
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var canWrite = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                id: "nav-logo"
            }),
            canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                accessKey: "a",
                id: "nav-mark",
                onClick: entriesPage !== null ? entriesPage.markVisibleRead : null,
                disabled: entriesPage === null,
                children: _("markread")
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5040dba436a03900$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState,
                allItemsCount: allItemsCount,
                allItemsOfflineCount: allItemsOfflineCount,
                unreadItemsCount: unreadItemsCount,
                unreadItemsOfflineCount: unreadItemsOfflineCount,
                starredItemsCount: starredItemsCount,
                starredItemsOfflineCount: starredItemsOfflineCount
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    "nav-ts-wrapper": true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $25d64656d90230de$export$2e2bcd8739ae039), {
                        tags: tags,
                        setNavExpanded: setNavExpanded
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a66ee1fb90186752$export$2e2bcd8739ae039), {
                        setNavExpanded: setNavExpanded,
                        navSourcesExpanded: navSourcesExpanded,
                        setNavSourcesExpanded: setNavSourcesExpanded,
                        sourcesState: sourcesState,
                        setSourcesState: setSourcesState,
                        sources: sources,
                        setSources: setSources
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    "nav-unavailable": true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                        className: "fa-layers fa-2x",
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                icon: $37a500ad1dcc914a$exports.faWifi
                            }),
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                icon: $c0ffe79f8008445d$exports.faSlash
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        children: _("offline_navigation_unavailable")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4c0fa68710d48580$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8a7bf68b184288ce$export$2e2bcd8739ae039), {
                reloadAll: reloadAll,
                setNavExpanded: setNavExpanded
            })
        ]
    });
}
$117ab31dd2c08da6$export$2e2bcd8739ae039.propTypes = {
    entriesPage: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).instanceOf((0, $9b2cb125cea35be7$export$2e2bcd8739ae039))).isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf(Object.values((0, $d2d3ee75176c5e4c$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};




var $eHaBZ = parcelRequire("eHaBZ");






function $3bebfa7a3ec2ab2e$var$splitTerm(term) {
    if (term == "") return [];
    else if (term.match(/^\/.+\/$/)) return [
        term
    ];
    var words = term.match(/"[^"]+"|\S+/g);
    for(var i = 0; i < words.length; i++)words[i] = words[i].replace(/"/g, "");
    return words;
}
function $3bebfa7a3ec2ab2e$var$joinTerm(words) {
    if (!words || words.length <= 0) return "";
    for(var i = 0; i < words.length; i++)if (words[i].indexOf(" ") >= 0) words[i] = '"' + words[i] + '"';
    return words.join(" ");
}
// remove search term
function $3bebfa7a3ec2ab2e$var$handleRemove(param) {
    var index = param.index, location = param.location, history = param.history, regexSearch = param.regexSearch;
    var newterm;
    if (regexSearch) newterm = "";
    else {
        var queryString = new URLSearchParams(location.search);
        var oldTerm = queryString.get("search");
        var termArray = $3bebfa7a3ec2ab2e$var$splitTerm(oldTerm);
        termArray.splice(index, 1);
        newterm = $3bebfa7a3ec2ab2e$var$joinTerm(termArray);
    }
    history.push((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
        search: newterm,
        id: null
    }));
}
function $3bebfa7a3ec2ab2e$var$SearchWord(param) {
    var regexSearch = param.regexSearch, index = param.index, item = param.item;
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    var removeOnClick = (0, $eHaBZ.useCallback)(function() {
        return $3bebfa7a3ec2ab2e$var$handleRemove({
            index: index,
            location: location,
            history: history,
            regexSearch: regexSearch
        });
    }, [
        index,
        location,
        history,
        regexSearch
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        onClick: removeOnClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            "regex-search-term": regexSearch
        }),
        children: [
            item,
            " ",
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                icon: $6c06a95c587730ec$exports.faTimes
            })
        ]
    });
}
$3bebfa7a3ec2ab2e$var$SearchWord.propTypes = {
    regexSearch: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired
};
function $3bebfa7a3ec2ab2e$export$2e2bcd8739ae039() {
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var searchText = (0, $eHaBZ.useMemo)(function() {
        var queryString = new URLSearchParams(location.search);
        var _queryString_get;
        return (_queryString_get = queryString.get("search")) !== null && _queryString_get !== void 0 ? _queryString_get : "";
    }, [
        location.search
    ]);
    var regexSearch = searchText.match(/^\/.+\/$/) !== null;
    var terms = regexSearch ? [
        searchText
    ] : $3bebfa7a3ec2ab2e$var$splitTerm(searchText);
    return terms.map(function(item, index) {
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($3bebfa7a3ec2ab2e$var$SearchWord, {
            index: index,
            item: item,
            regexSearch: regexSearch
        }, index);
    });
}


var $0efeac3f6dc93c13$var$t = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
], $0efeac3f6dc93c13$var$e = "object" == typeof navigator ? navigator.platform : "", $0efeac3f6dc93c13$var$n = /Mac|iPod|iPhone|iPad/.test($0efeac3f6dc93c13$var$e), $0efeac3f6dc93c13$var$r = $0efeac3f6dc93c13$var$n ? "Meta" : "Control", $0efeac3f6dc93c13$var$o = "Win32" === $0efeac3f6dc93c13$var$e ? [
    "Control",
    "Alt"
] : $0efeac3f6dc93c13$var$n ? [
    "Alt"
] : [];
function $0efeac3f6dc93c13$var$i(t, e) {
    return "function" == typeof t.getModifierState && (t.getModifierState(e) || $0efeac3f6dc93c13$var$o.includes(e) && t.getModifierState("AltGraph"));
}
function $0efeac3f6dc93c13$export$d0b30d424c95c5e9(t) {
    return t.trim().split(" ").map(function(t) {
        var e = t.split(/\b\+/), n = e.pop();
        return [
            e = e.map(function(t) {
                return "$mod" === t ? $0efeac3f6dc93c13$var$r : t;
            }),
            n
        ];
    });
}
function $0efeac3f6dc93c13$export$a3db0ee43d16bb47(e, n) {
    var r;
    void 0 === n && (n = {});
    var o = null != (r = n.timeout) ? r : 1e3, u = Object.keys(e).map(function(t) {
        return [
            $0efeac3f6dc93c13$export$d0b30d424c95c5e9(t),
            e[t]
        ];
    }), c = new Map, f = null;
    return function(e) {
        e instanceof KeyboardEvent && (u.forEach(function(n) {
            var r = n[0], o = n[1], a = c.get(r) || r;
            !function(e, n) {
                return !(n[1].toUpperCase() !== e.key.toUpperCase() && n[1] !== e.code || n[0].find(function(t) {
                    return !$0efeac3f6dc93c13$var$i(e, t);
                }) || $0efeac3f6dc93c13$var$t.find(function(t) {
                    return !n[0].includes(t) && n[1] !== t && $0efeac3f6dc93c13$var$i(e, t);
                }));
            }(e, a[0]) ? $0efeac3f6dc93c13$var$i(e, e.key) || c.delete(r) : a.length > 1 ? c.set(r, a.slice(1)) : (c.delete(r), o(e));
        }), f && clearTimeout(f), f = setTimeout(c.clear.bind(c), o));
    };
}
function $0efeac3f6dc93c13$export$6fc42dca60e28416(t, e, n) {
    var r;
    void 0 === n && (n = {});
    var o = null != (r = n.event) ? r : "keydown", i = $0efeac3f6dc93c13$export$a3db0ee43d16bb47(e, n);
    return t.addEventListener(o, i), function() {
        t.removeEventListener(o, i);
    };
}



/**
 * Decorates an event handler so that it only runs
 * when not interacting with an input field or lightbox.
 */ function $f81f2efad81fa28e$var$ignoreWhenInteracting(handler) {
    return function(event) {
        if (selfoss.lightboxActive.value) return;
        // Ignore shortcuts when on input elements.
        // https://github.com/jamiebuilds/tinykeys/issues/17
        var active = document.activeElement;
        var enteringText = active instanceof HTMLElement && (active.isContentEditable || active.tagName === "INPUT" || active.tagName === "TEXTAREA");
        if (!enteringText) return handler(event);
    };
}
function $f81f2efad81fa28e$export$2e2bcd8739ae039() {
    return (0, $0efeac3f6dc93c13$export$6fc42dca60e28416)(document, {
        // 'space': next article
        "Space": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.jumpToNext();
        }),
        // 'n': next article
        "n": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT, false);
        }),
        // 'right cursor': next article
        "ArrowRight": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.entryNav((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT);
        }),
        // 'j': next article
        "j": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT, true);
        }),
        // 'shift+space': previous article
        "Shift+Space": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV, true);
        }),
        // 'p': previous article
        "p": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV, false);
        }),
        // 'left': previous article
        "ArrowLeft": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.entryNav((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV);
        }),
        // 'k': previous article
        "k": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV, true);
        }),
        // 's': star/unstar
        "s": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedStarred();
        }),
        // 'm': mark/unmark
        "m": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedRead();
        }),
        // 'o': open/close entry
        "o": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedExpanded();
        }),
        // 'Shift + o': close open entries
        "Shift+o": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.collapseAllEntries();
        }),
        // 'v': open target
        "v": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.openSelectedTarget();
        }),
        // 'Shift + v': open target and mark read
        "Shift+v": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.openSelectedTargetAndMarkRead();
        }),
        // 'r': Reload the current view
        "r": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
        }),
        // 'Shift + r': Refresh sources
        "Shift+r": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector("#nav-refresh").click();
        }),
        // 'Control+m': mark all as read
        "Control+m": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector("#nav-mark").click();
        }),
        // 't': throw (mark as read & open next)
        "t": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.throw((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT);
        }),
        // throw (mark as read & open previous)
        "Shift+t": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.throw((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV);
        }),
        // 'Shift+n': switch to newest items overview / menu item
        "Shift+n": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector("#nav-filter-newest").click();
        }),
        // 'Shift+u': switch to unread items overview / menu item
        "Shift+u": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector("#nav-filter-unread").click();
        }),
        // 'Shift+s': switch to starred items overview / menu item
        "Shift+s": $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector("#nav-filter-starred").click();
        })
    });
}










// Unfortunately we need to declare everything manually for Parcel to pick those up.
var $3109e67d2d012138$exports = {};
$3109e67d2d012138$exports = JSON.parse('{"lang_markread":"Marca com llegit","lang_filter":"Filtre","lang_newest":"Nous","lang_unread":"Per llegir","lang_starred":"Preferits","lang_online_count":"Elements disponibles al servidor","lang_offline_count":"Elements disponibles localment","lang_tags":"Etiquetes","lang_alltags":"Totes les etiquetes","lang_timestamp":"{0,date} {0,time}","lang_hours":"fa {0,plural,one {1 hora},other {# hores}}","lang_minutes":"fa {0,plural,one {1 minut},other {# minuts}}","lang_seconds":"fa {0,plural,one {1 segon},other {# segons}}","lang_days":"{0,plural,zero {avui},one {ahir},other {fa # dies}}","lang_star":"Preferit","lang_unstar":"Ja no ho prefereixo","lang_mark":"Marca com llegit","lang_unmark":"Marca com no llegit","lang_load_img":"Mostra les imatges","lang_open_window":"Obre","lang_next":"Seg\xfcent","lang_searchbutton":"Cerca","lang_searchremove":"Amaga la cerca","lang_refreshbutton":"Actualitza les fonts","lang_settingsbutton":"Configuraci\xf3","lang_logoutbutton":"Finalitza la sessi\xf3","lang_loginbutton":"Inicia una sessi\xf3","lang_sources":"Fonts","lang_source_add":"Afegeix una font","lang_source_opml":"o importa des d\'un fitxer opml o des del Google Reader (fins al 15 de juliol de 2013)","lang_source_export":"Exporta les fonts","lang_source_edit":"Edita","lang_source_filter":"Filtra","lang_source_delete":"Esborra","lang_source_warn":"Segur que voleu esborrar la font?","lang_source_new":"Nova font per desar","lang_source_title":"T\xedtol","lang_source_autotitle_hint":"Deixa en blanc per a obtindre el t\xedtol","lang_source_tags":"Etiquetes","lang_source_pwd_placeholder":"No ha canviat","lang_source_comma":"Separat per comes","lang_source_select":"Seleccioneu una font","lang_source_type":"Tipus","lang_source_save":"Desa","lang_source_cancel":"Cancel\xb7la","lang_source_saved":"Desat","lang_source_last_post":"\xdaltima entrada vista","lang_source_refresh":"Actualitza aquesta font","lang_no_entries":"No es van trobar entrades","lang_more":"M\xe9s","lang_login":"Inicia una sessi\xf3","lang_login_username":"Nom d\'usuari","lang_login_password":"Contrasenya","lang_login_invalid_credentials":"Nom d\'usuari o contrasenya incorrectes","lang_login_offline":"Emmagatzematge fora de l\xednia","lang_no_title":"Sense t\xedtol","lang_error":"S\'ha produ\xeft un error","lang_streamerror":"No hi ha cap element carregat. Es recarrega?","lang_reload_list":"Recarrega la llista","lang_sources_refreshed":"S\'han actualitzat les fonts","lang_app_update":"selfoss s\'ha actualitzat, torneu a carregar","lang_app_reload":"Recarrega","lang_error_session_expired":"La sessi\xf3 ha expirat","lang_error_add_source":"No s\'ha pogut afegir la font:","lang_error_delete_source":"No s\'ha pogut esborrar la font:","lang_error_load_tags":"No s\'han pogut carregar les etiquetes:","lang_error_unknown_tag":"Etiqueta desconeguda:","lang_error_unknown_source":"Id de font desconeguda:","lang_error_mark_items":"No s\'han pogut marcar tots els elements visibles:","lang_error_mark_item":"No s\'ha pogut marcar/desmarcar element:","lang_error_star_item":"No s\'ha pogut preferir/despreferir l\'element:","lang_error_logout":"No s\'ha pogut finalitzar la sessi\xf3:","lang_error_loading":"Error de c\xe0rrega:","lang_error_loading_stats":"No s\'han pogut carregar les estad\xedstiques de navegaci\xf3:","lang_error_saving_color":"No s\'ha pogut desar el nou color:","lang_error_refreshing_source":"No s\'han pogut refrescar fonts:","lang_error_sync":"No s\'han pogut sincronitzar els \xfaltims canvis del servidor:","lang_error_offline_storage":"Error d\'emmagatzematge fora de l\xednia: {0}. Recarregar pot ajudar. Es desactiva l\'\xfas fora de l\xednia per ara.","lang_error_invalid_subsection":"Subsecci\xf3 inv\xe0lida:","lang_search_label":"Terme de cerca","lang_article_actions":"Accions","lang_error_configuration":"No es pot carregar la configuraci\xf3.","lang_info_url_copied":"S\'ha copiat l\'URL al portaretalls.","lang_share_native_label":"Comparteix","lang_share_diaspora_label":"Comparteix a Diaspora","lang_share_twitter_label":"Comparteix al Twitter","lang_share_facebook_label":"Comparteix al Facebook","lang_share_pocket_label":"Desa a Pocket","lang_share_wallabag_label":"Desa a Wallabag","lang_share_wordpress_label":"Comparteix a WordPress","lang_share_mail_label":"Comparteix per correu electr\xf2nic","lang_share_copy_label":"Copia l\'enlla\xe7 al portaretalls","lang_error_share_native_abort":"No es pot compartir l\'element\u2014o no hi ha destinacions de compartici\xf3, o ho heu cancel\xb7lat.","lang_error_share_native":"No es pot compartir l\'element.","lang_close_entry":"Tanca","lang_error_unwritable_logs":"No es poden escriure els registres.","lang_error_check_system_logs":"S\'ha produ\xeft un error. Comproveu els registres del sistema.","lang_error_check_log_file":"S\'ha produ\xeft un error. Comprova el fitxer de registre \u201C{0}\u201D.","lang_offline_navigation_unavailable":"Canviar etiquetes i fonts no \xe9s disponible en el mode fora de l\xednia.","lang_error_offline_storage_not_available":"Emmagatzematge fora de l\xednia no disponible. Assegureu-vos que el navegador {0}suporta IndexedDB API{1}. Si utilitzeu un navegador basat en Google Chrome, que no estigueu utilitzant selfoss en mode inc\xf2gnit.","lang_error_edit_source":"No es pot desar els canvis a les fonts:","lang_article_reading_time":"{0} min lectura","lang_experimental":"Experimental","lang_source_menu":"M\xe9s accions","lang_source_browse":"Navega","lang_sources_leaving_unsaved_prompt":"Voleu deixar la configuraci\xf3 amb els canvis de font no desats?","lang_source_warn_cancel_dirty":"Vols descartar els canvis no desats?","lang_tag_change_color_button_title":"Canvia el color","lang_sources_loading":"S\'estan carregant les fonts\u2026","lang_source_deleting":"S\'est\xe0 suprimint la font\u2026","lang_source_params_loading":"S\'estan carregant els par\xe0metres\u2026","lang_no_sources":"No hi ha fonts configurades.","lang_source_saving":"S\'estan desant els canvis a la font\u2026","lang_source_go_to_settings":"Obre a la configuraci\xf3","lang_entries_loading":"S\'estan carregant les entrades\u2026","lang_login_in_progress":"S\'est\xe0 intentant iniciar sessi\xf3\u2026","lang_login_error_generic":"No s\'ha pogut iniciar sessi\xf3: {errorMessage}","lang_error_unauthorized":"Si us plau, {link_begin}inicieu sessi\xf3{link_end} per a continuar."}');


var $3f89fcb2517a5831$exports = {};
$3f89fcb2517a5831$exports = JSON.parse('{"lang_markread":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","lang_filter":"Zobrazovat","lang_newest":"Nejnov\u011Bj\u0161\xed","lang_unread":"Nep\u0159e\u010Dten\xe9","lang_starred":"Ozna\u010Den\xe9","lang_tags":"\u0160t\xedtky","lang_alltags":"V\u0161echny \u0161t\xedtky","lang_timestamp":"{0,date} {0,time}","lang_hours":"p\u0159ed {0,plural,one {1 hodinou},other {# hodinami}}","lang_minutes":"p\u0159ed {0,plural,one {1 minutou},other {# minutami}}","lang_seconds":"p\u0159ed {0,plural,one {chv\xedl\xed},other {# sekundami}}","lang_days":"{0,plural,zero {dnes},one {v\u010Dera},other {p\u0159ed # dny}}","lang_star":"Ozna\u010Dit","lang_unstar":"Odzna\u010Dit","lang_mark":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","lang_unmark":"Ozna\u010Dit jako nep\u0159e\u010Dten\xe9","lang_load_img":"Zobrazit obr\xe1zky","lang_open_window":"Otev\u0159\xedt","lang_next":"Dal\u0161\xed","lang_search_label":"Vyhled\xe1van\xfd text","lang_searchbutton":"Hledat","lang_searchremove":"Skr\xfdt hled\xe1n\xed","lang_refreshbutton":"Obnovit zdroje","lang_settingsbutton":"Nastaven\xed","lang_logoutbutton":"Odhl\xe1sit se","lang_loginbutton":"P\u0159ihl\xe1sit se","lang_sources":"Zdroje","lang_sources_loading":"Na\u010D\xedt\xe1n\xed zdroj\u016F\u2026","lang_no_sources":"Nejsou nastaveny \u017E\xe1dn\xe9 zdroje.","lang_source_add":"P\u0159idat zdroj","lang_source_opml":"nebo nahr\xe1t opml soubor","lang_source_export":"Export zdroj\u016F","lang_source_edit":"Upravit","lang_source_filter":"Filtr","lang_source_menu":"V\xedce akc\xed","lang_source_browse":"Prohl\xed\u017Eet","lang_source_delete":"Smazat","lang_source_warn":"Opravdu chcete tento zdroj smazat?","lang_source_deleting":"Maz\xe1n\xed zdroje\u2026","lang_source_warn_cancel_dirty":"Opravdu chcete zahodit neulo\u017Een\xe9 zm\u011Bny?","lang_source_new":"Nov\xfd neulo\u017Een\xfd zdroj","lang_source_title":"N\xe1zev","lang_source_autotitle_hint":"Pro automatick\xe9 vypln\u011Bn\xed ponechte pr\xe1zdn\xe9","lang_source_tags":"\u0160t\xedtky","lang_source_pwd_placeholder":"Beze zm\u011Bny","lang_source_comma":"Odd\u011Blen\xe9 \u010D\xe1rkou","lang_source_select":"Vyberte pros\xedm zdroj","lang_source_params_loading":"Na\u010D\xedt\xe1n\xed parametr\u016F\u2026","lang_source_type":"Typ","lang_source_save":"Ulo\u017Eit","lang_source_cancel":"Zru\u0161it","lang_source_saving":"Ukl\xe1d\xe1n\xed zm\u011Bn zdroje\u2026","lang_source_saved":"Ulo\u017Eeno","lang_source_last_post":"Posledn\xed p\u0159\xedsp\u011Bvek spat\u0159en","lang_source_refresh":"Obnovit tento zdroj","lang_source_go_to_settings":"Otev\u0159\xedt v\xa0nastaven\xed","lang_sources_leaving_unsaved_prompt":"Na str\xe1nce jsou neulo\u017Een\xe9 zm\u011Bny. Opravdu chcete opustit nastaven\xed?","lang_tag_change_color_button_title":"Zm\u011Bnit barvu","lang_entries_loading":"Na\u010D\xedt\xe1n\xed z\xe1znam\u016F\u2026","lang_no_entries":"\u017D\xe1dn\xfd z\xe1znam","lang_more":"V\xedce","lang_login":"P\u0159ihl\xe1sit","lang_login_in_progress":"P\u0159ihla\u0161ov\xe1n\xed\u2026","lang_login_username":"Jm\xe9no","lang_login_password":"Heslo","lang_login_invalid_credentials":"\u0160patn\xe9 jm\xe9no nebo heslo","lang_login_error_generic":"Pokus o p\u0159ihl\xe1\u0161en\xed selhal: {errorMessage}","lang_no_title":"Bez titulku","lang_error":"Nastala chyba","lang_error_unauthorized":"Pro pokra\u010Dov\xe1n\xed se pros\xedm {link_begin}p\u0159ihlaste{link_end}.","lang_error_check_log_file":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0souboru \u201E{0}\u201C.","lang_error_check_system_logs":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0opera\u010Dn\xedm syst\xe9mu.","lang_error_unwritable_logs":"Nebylo mo\u017En\xe9 zaznamenat chybu.","lang_streamerror":"Nena\u010Dteny \u017E\xe1dn\xe9 polo\u017Eky, zkusit znovu?","lang_reload_list":"Znovu na\u010D\xedst seznam","lang_sources_refreshed":"Zdroje byly obnoveny","lang_error_session_expired":"Va\u0161e sezen\xed vypr\u0161elo","lang_error_add_source":"Zdroj nemohl b\xfdt p\u0159id\xe1n:","lang_error_delete_source":"Zdroj nemohl b\xfdt smaz\xe1n:","lang_error_load_tags":"\u0160t\xedtky nemohly b\xfdt na\u010Dteny:","lang_error_unknown_tag":"Nezn\xe1m\xfd \u0161t\xedtek:","lang_error_unknown_source":"Nezn\xe1m\xe9 id zdroje:","lang_error_mark_items":"Nelze ozna\u010Dit v\u0161echny viditeln\xe9 zdroje:","lang_error_mark_item":"Nelze ozna\u010Dit polo\u017Eku za (ne)p\u0159e\u010Dtenou:","lang_error_star_item":"Nelze o(d)zna\u010Dit polo\u017Eku hv\u011Bzdi\u010Dkou:","lang_error_logout":"Odhl\xe1\u0161en\xed se nezda\u0159ilo:","lang_error_loading":"Chyba na\u010D\xedt\xe1n\xed:","lang_error_loading_stats":"Na\u010D\xedt\xe1n\xed statistik se nezda\u0159ilo:","lang_error_saving_color":"Nelze zm\u011Bnit barvu:","lang_error_refreshing_source":"Nelze obnovit zdroje:","lang_error_sync":"Synchronizace zm\u011Bn ze serveru selhala:","lang_error_invalid_subsection":"Podsekce neexistuje:","lang_online_count":"Polo\u017Eky dostupn\xe9 na serveru","lang_offline_count":"Polo\u017Eky jsou dostupn\xe9 v prohl\xed\u017Ee\u010Di","lang_offline_navigation_unavailable":"Offline re\u017Eim zat\xedm neumo\u017E\u0148uje p\u0159ep\xednat mezi \u0161t\xedtky a zdroji.","lang_login_offline":"Ukl\xe1dat data v prohl\xed\u017Ee\u010Di","lang_app_update":"selfoss byl aktualizov\xe1n, pros\xedm znovu na\u010Dt\u011Bte str\xe1nku","lang_app_reload":"Znovu na\u010D\xedst","lang_error_offline_storage":"Chyba lok\xe1ln\xedho \xfalo\u017Ei\u0161t\u011B: {0}. Mo\u017En\xe1 pom\u016F\u017Ee znovuna\u010Dten\xed str\xe1nky. Prozat\xedm bude ukl\xe1d\xe1n\xed vypnuto.","lang_article_actions":"Akce","lang_error_configuration":"Nelze na\u010D\xedst konfiguraci.","lang_share_native_label":"Sd\xedlet","lang_share_diaspora_label":"Sd\xedlet na Diaspo\u0159e","lang_share_twitter_label":"Sd\xedlet na Twitteru","lang_share_facebook_label":"Sd\xedlet na Facebooku","lang_share_pocket_label":"Ulo\u017Eit do Pocketu","lang_share_wallabag_label":"Ulo\u017Eit do Wallabagu","lang_share_wordpress_label":"Sd\xedlet na WordPressu","lang_share_mail_label":"Sd\xedlet e-mailem","lang_share_copy_label":"Zkop\xedrovat odkaz do schr\xe1nky","lang_info_url_copied":"URL zkop\xedrov\xe1na do schr\xe1nky.","lang_error_share_native_abort":"Nelze sd\xedlet polo\u017Eku: bu\u010F v\xe1\u0161 prohl\xed\u017Ee\u010D nepodporuje sd\xedlen\xed odkaz\u016F, nebo jste sd\xedlen\xed zru\u0161ili.","lang_error_share_native":"Nelze sd\xedlet polo\u017Eku.","lang_close_entry":"Zav\u0159\xedt","lang_article_reading_time":"{0} min \u010Dten\xed","lang_error_offline_storage_not_available":"Offline \xfalo\u017Ei\u0161t\u011B nen\xed dostupn\xe9. Ujist\u011Bte se, \u017Ee v\xe1\u0161 prohl\xed\u017Ee\u010D {0}podporuje rozhran\xed IndexedDB{1} a, pokud pou\u017E\xedv\xe1te prohl\xed\u017Ee\u010D zalo\u017Een\xfd na Google Chrome, \u017Ee nespou\u0161t\xedte selfoss v re\u017Eimu anonymn\xedho prohl\xed\u017Een\xed.","lang_error_edit_source":"Nelze ulo\u017Eit zm\u011Bny zdroje:","lang_experimental":"Experiment"}');


var $efc21f73bdbf3d30$exports = {};
$efc21f73bdbf3d30$exports = JSON.parse('{"lang_markread":"Alles gelesen","lang_newest":"Neueste","lang_unread":"Ungelesen","lang_starred":"Favoriten","lang_tags":"Markierungen","lang_alltags":"Alle Markierungen","lang_timestamp":"{0,date} {0,time}","lang_hours":"vor {0,plural,one {1 Stunde},other {# Stunden}}","lang_minutes":"vor {0,plural,one {1 Minute},other {# Minuten}}","lang_seconds":"{0,plural,one {Jetzt gerade},other {vor # Sekunden}}","lang_days":"{0,plural,zero {heute},one {gestern},other {vor # Tagen}}","lang_star":"behalten","lang_unstar":"vergessen","lang_mark":"als gelesen markieren","lang_unmark":"als ungelesen markieren","lang_load_img":"Zeige Bilder","lang_open_window":"\xf6ffnen","lang_next":"weiter","lang_searchbutton":"suchen","lang_refreshbutton":"Quellen aktualisieren","lang_settingsbutton":"Einstellungen","lang_logoutbutton":"Abmelden","lang_loginbutton":"Anmelden","lang_sources":"Quellen","lang_source_add":"Quelle hinzuf\xfcgen","lang_source_opml":"oder OPML-Datei oder Google Reader importieren","lang_source_export":"Quellen exportieren","lang_source_edit":"bearbeiten","lang_source_filter":"Filter","lang_source_delete":"l\xf6schen","lang_source_warn":"Wirklich diesen Feed entfernen?","lang_source_new":"Neue ungespeicherte Quelle","lang_source_title":"Titel","lang_source_autotitle_hint":"Leer lassen um automatisch Titel zu setzen","lang_source_tags":"Markierungen","lang_source_pwd_placeholder":"Nicht ge\xe4ndert","lang_source_comma":"Komma getrennt","lang_source_select":"Quelle ausw\xe4hlen","lang_source_type":"Typ","lang_source_save":"speichern","lang_source_cancel":"abbrechen","lang_source_saved":"gespeichert","lang_source_last_post":"Letzter gesehener Beitrag","lang_no_entries":"keine Eintr\xe4ge gefunden","lang_more":"mehr","lang_login":"Anmelden","lang_login_username":"Benutzername","lang_login_password":"Passwort","lang_no_title":"kein Titel","lang_error":"Ein Fehler ist aufgetreten","lang_filter":"Filter","lang_online_count":"Auf dem Server verf\xfcgbare Elemente","lang_offline_count":"Lokal verf\xfcgbare Artikel","lang_searchremove":"Suche ausblenden","lang_source_refresh":"Diese Quelle aktualisieren","lang_login_invalid_credentials":"Falscher Benutzername/Passwort","lang_login_offline":"Offline-Speicherung","lang_streamerror":"Keine Artikel geladen, neu laden?","lang_reload_list":"Liste neu laden","lang_sources_refreshed":"Quellen aktualisiert","lang_app_update":"selfoss wurde aktualisiert, bitte neu laden","lang_app_reload":"Neu laden","lang_error_session_expired":"Session abgelaufen","lang_error_add_source":"Die Quelle konnte nicht hinzugef\xfcgt werden:","lang_error_delete_source":"Die Quelle konnte nicht gel\xf6scht werden:","lang_error_load_tags":"Konnte Markierungen nicht laden:","lang_error_unknown_tag":"Unbekannte Markierung:","lang_error_unknown_source":"Unbekannte Quell-ID:","lang_error_mark_items":"Es k\xf6nnen nicht alle sichtbaren Elemente markiert werden:","lang_error_mark_item":"Das Markieren/Deaktivieren von Elementen ist nicht m\xf6glich:","lang_error_star_item":"Artikel kann nicht ge-sternt oder ent-sternt werden:","lang_error_logout":"Konnte nicht ausloggen:","lang_error_loading":"Ladefehler:","lang_error_loading_stats":"Nav-Statistiken k\xf6nnen nicht geladen werden:","lang_error_saving_color":"Neue Farbe kann nicht gespeichert werden:","lang_error_refreshing_source":"Quellen k\xf6nnen nicht aktualisiert werden:","lang_error_sync":"Letzte \xc4nderungen vom Server konnten nicht synchronisiert werden:","lang_error_offline_storage":"Offline-Speicherfehler: {0}. Neu laden k\xf6nnte helfen. Deaktiviere offline vorerst.","lang_error_invalid_subsection":"Ung\xfcltiger Unterabschnitt:","lang_search_label":"Suchbegriff","lang_article_actions":"Aktionen","lang_error_configuration":"Nicht m\xf6glich die Konfiguration zu laden.","lang_info_url_copied":"URL in die Zwischenablage kopiert.","lang_share_native_label":"teilen","lang_share_diaspora_label":"auf Diaspora teilen","lang_share_twitter_label":"auf Twitter teilen","lang_share_facebook_label":"auf Facebook teilen","lang_share_mastodon_label":"auf Mastodon teilen","lang_share_pocket_label":"in Pocket speichern","lang_share_wallabag_label":"in Wallabag speichern","lang_share_wordpress_label":"teile auf WordPress","lang_share_mail_label":"per E-Mail teilen","lang_share_copy_label":"Link in die Zwischenablage kopieren","lang_error_share_native_abort":"Es ist nicht m\xf6glich das Objekt zu teilen\u202F\u2013\u202Fentweder gibt es keine Ziele zum Teilen oder die Aktion wurde abgebrochen.","lang_error_share_native":"Es ist nicht m\xf6glich das Objekt zu teilen.","lang_close_entry":"Schlie\xdfen","lang_error_offline_storage_not_available":"Offline-Speicherung ist nicht verf\xfcgbar. Stelle sicher, dass dein Browser die {0}IndexedDB-API unterst\xfctzt{1} und, falls du einen Browser auf Grundlage von Google Chrome benutzt, dass du selfoss nicht im Incognito-Modus ausf\xfchrst.","lang_error_edit_source":"Konnte die \xc4nderungen an den Quellen nicht speichern:","lang_error_unwritable_logs":"Logdateien konnten nicht geschrieben werden.","lang_error_check_system_logs":"Ein Fehler ist aufgetreten, bitte die Systemlogs pr\xfcfen.","lang_error_check_log_file":"Es ist ein Fehler aufgetreten, bitte Protokolldatei \u201E{0}\u201C pr\xfcfen.","lang_offline_navigation_unavailable":"Markierungen und Quellen zu wechseln wird derzeit im Offline-Modus nicht unterst\xfctzt."}');


var $e8fba7b0a3114fd9$exports = {};
$e8fba7b0a3114fd9$exports = JSON.parse('{"lang_markread":"Mark as read","lang_filter":"Filter","lang_newest":"Newest","lang_unread":"Unread","lang_starred":"Starred","lang_online_count":"Items available on the server","lang_offline_count":"Items available locally","lang_offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","lang_tags":"Tags","lang_alltags":"All tags","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 hour},other {# hours}} ago","lang_minutes":"{0,plural,one {1 minute},other {# minutes}} ago","lang_seconds":"{0,plural,one {1 second},other {# seconds}} ago","lang_days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","lang_star":"Star","lang_unstar":"Unstar","lang_mark":"Mark as read","lang_unmark":"Mark as unread","lang_load_img":"Show images","lang_open_window":"Open","lang_next":"Next","lang_share_native_label":"Share","lang_share_diaspora_label":"Share on Diaspora","lang_share_twitter_label":"Share on Twitter","lang_share_facebook_label":"Share on Facebook","lang_share_mastodon_label":"Share on Mastodon","lang_share_pocket_label":"Save to Pocket","lang_share_wallabag_label":"Save to Wallabag","lang_share_wordpress_label":"Share on WordPress","lang_share_mail_label":"Share using e-mail","lang_share_copy_label":"Copy link to clipboard","lang_search_label":"Search term","lang_searchbutton":"Search","lang_searchremove":"Hide search","lang_refreshbutton":"Refresh sources","lang_settingsbutton":"Settings","lang_logoutbutton":"Log out","lang_loginbutton":"Log in","lang_sources":"Sources","lang_sources_loading":"Loading sources\u2026","lang_no_sources":"No sources configured.","lang_source_add":"Add source","lang_source_opml":"or import an OPML file","lang_source_export":"Export sources","lang_source_edit":"Edit","lang_source_filter":"Filter","lang_source_menu":"More actions","lang_source_browse":"Browse","lang_source_delete":"Delete","lang_source_warn":"Really delete this source?","lang_source_deleting":"Deleting source\u2026","lang_source_warn_cancel_dirty":"Discard unsaved changes?","lang_source_new":"New unsaved source","lang_source_title":"Title","lang_source_autotitle_hint":"Leave empty to fetch title","lang_source_tags":"Tags","lang_source_pwd_placeholder":"Not changed","lang_source_comma":"Comma separated","lang_source_select":"Please select source","lang_source_params_loading":"Loading parameters\u2026","lang_source_type":"Type","lang_source_save":"Save","lang_source_cancel":"Cancel","lang_source_saving":"Saving source changes\u2026","lang_source_saved":"Saved","lang_source_last_post":"Last post seen","lang_source_refresh":"Refresh this source","lang_source_go_to_settings":"Open in settings","lang_sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","lang_tag_change_color_button_title":"Change color","lang_entries_loading":"Loading entries\u2026","lang_no_entries":"No entries found","lang_more":"More","lang_login":"Log in","lang_login_in_progress":"Trying to log in\u2026","lang_login_username":"Username","lang_login_password":"Password","lang_login_invalid_credentials":"Wrong username/password","lang_login_error_generic":"Could not log in: {errorMessage}","lang_login_offline":"Offline storage","lang_no_title":"No title","lang_experimental":"Experimental","lang_error":"An error occurred","lang_error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","lang_error_check_log_file":"An error occured, please check the log file \u201C{0}\u201D.","lang_error_check_system_logs":"An error occured, please check your system logs.","lang_error_unwritable_logs":"Unable to write logs.","lang_streamerror":"No items loaded, reload?","lang_reload_list":"Reload list","lang_sources_refreshed":"Sources refreshed","lang_app_update":"selfoss has been updated, please reload","lang_app_reload":"Reload","lang_error_session_expired":"Session expired","lang_error_add_source":"Could not add source:","lang_error_edit_source":"Could not save source changes:","lang_error_delete_source":"Could not delete source:","lang_error_load_tags":"Could not load tags:","lang_error_unknown_tag":"Unknown tag:","lang_error_unknown_source":"Unknown source ID:","lang_error_mark_items":"Cannot mark all visible items:","lang_error_mark_item":"Cannot mark/unmark item:","lang_error_star_item":"Cannot star/unstar item:","lang_error_logout":"Could not log out:","lang_error_loading":"Loading error:","lang_error_loading_stats":"Cannot load nav stats:","lang_error_saving_color":"Cannot save new color:","lang_error_refreshing_source":"Cannot refresh sources:","lang_error_sync":"Could not sync last changes from server:","lang_error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","lang_error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","lang_error_invalid_subsection":"Invalid subsection:","lang_error_configuration":"Unable to load configuration.","lang_error_share_native_abort":"Unable to share item\u2014either there are no share targets, or you cancelled it.","lang_error_share_native":"Unable to share item.","lang_info_url_copied":"URL copied to clipboard.","lang_close_entry":"Close","lang_article_actions":"Actions","lang_article_reading_time":"{0} min read"}');


var $9bb1025262b0fb39$exports = {};
$9bb1025262b0fb39$exports = JSON.parse('{"lang_error_share_native_abort":"Unable to share item\u202F\u2013\u202Feither there are no share targets, or you cancelled it.","lang_error_saving_color":"Cannot save new colour:","lang_close_entry":"Close","lang_error_share_native":"Unable to share item.","lang_share_copy_label":"Copy link to clipboard","lang_share_mail_label":"Share using e-mail","lang_share_wordpress_label":"Share on WordPress","lang_share_wallabag_label":"Save to Wallabag","lang_share_pocket_label":"Save to Pocket","lang_share_facebook_label":"Share on Facebook","lang_share_twitter_label":"Share on Twitter","lang_share_diaspora_label":"Share on Diaspora","lang_share_native_label":"Share","lang_info_url_copied":"URL copied to clipboard.","lang_error_configuration":"Unable to load configuration.","lang_article_actions":"Actions","lang_search_label":"Search term","lang_error_invalid_subsection":"Invalid subsection:","lang_error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","lang_error_sync":"Could not sync last changes from server:","lang_error_refreshing_source":"Cannot refresh sources:","lang_error_loading_stats":"Cannot load nav stats:","lang_error_loading":"Loading error:","lang_error_logout":"Could not log out:","lang_error_star_item":"Cannot star/unstar item:","lang_error_mark_item":"Cannot mark/unmark item:","lang_error_mark_items":"Cannot mark all visible items:","lang_error_unknown_source":"Unknown source ID:","lang_error_unknown_tag":"Unknown tag:","lang_error_load_tags":"Could not load tags:","lang_error_delete_source":"Could not delete source:","lang_error_add_source":"Could not add source:","lang_error_session_expired":"Session expired","lang_app_reload":"Reload","lang_app_update":"selfoss has been updated, please reload","lang_sources_refreshed":"Sources refreshed","lang_reload_list":"Reload list","lang_streamerror":"No items loaded, reload?","lang_error":"An error occurred","lang_no_title":"No title","lang_login_offline":"Offline storage","lang_login_invalid_credentials":"Wrong username/password","lang_login_password":"Password","lang_login_username":"Username","lang_login":"Log in","lang_more":"More","lang_no_entries":"No entries found","lang_source_refresh":"Refresh this source","lang_source_last_post":"Last post seen","lang_source_saved":"Saved","lang_source_cancel":"Cancel","lang_source_save":"Save","lang_source_type":"Type","lang_source_select":"Please select source","lang_source_comma":"Comma separated","lang_source_pwd_placeholder":"Not changed","lang_source_tags":"Tags","lang_source_autotitle_hint":"Leave empty to fetch title","lang_source_title":"Title","lang_source_new":"New unsaved source","lang_source_warn":"Really delete this source?","lang_source_delete":"Delete","lang_source_filter":"Filter","lang_source_edit":"Edit","lang_source_export":"Export sources","lang_source_opml":"or import an OPML file","lang_source_add":"Add source","lang_sources":"Sources","lang_loginbutton":"Log in","lang_logoutbutton":"Log out","lang_settingsbutton":"Settings","lang_refreshbutton":"Refresh sources","lang_searchremove":"Hide search","lang_searchbutton":"Search","lang_next":"Next","lang_open_window":"Open","lang_load_img":"Show images","lang_unmark":"Mark as unread","lang_mark":"Mark as read","lang_unstar":"Unstar","lang_star":"Star","lang_days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","lang_seconds":"{0,plural,one {1 second},other {# seconds}} ago","lang_minutes":"{0,plural,one {1 minute},other {# minutes}} ago","lang_hours":"{0,plural,one {1 hour},other {# hours}} ago","lang_timestamp":"{0,date} {0,time}","lang_alltags":"All tags","lang_tags":"Tags","lang_offline_count":"Items available locally","lang_online_count":"Items available on the server","lang_starred":"Starred","lang_unread":"Unread","lang_newest":"Newest","lang_filter":"Filter","lang_markread":"Mark as read","lang_error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","lang_error_edit_source":"Could not save source changes:","lang_error_unwritable_logs":"Unable to write logs.","lang_error_check_system_logs":"An error occured, please check your system logs.","lang_error_check_log_file":"An error occured, please check the log file \u2018{0}\u2019.","lang_offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","lang_experimental":"Experimental","lang_entries_loading":"Loading entries\u2026","lang_login_in_progress":"Trying to log in\u2026","lang_login_error_generic":"Could not log in: {errorMessage}","lang_error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","lang_no_sources":"No sources configured.","lang_source_menu":"More actions","lang_source_browse":"Browse","lang_source_params_loading":"Loading parameters\u2026","lang_sources_loading":"Loading sources\u2026","lang_source_deleting":"Deleting source\u2026","lang_source_saving":"Saving source changes\u2026","lang_source_go_to_settings":"Open in settings","lang_source_warn_cancel_dirty":"Discard unsaved changes?","lang_sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","lang_tag_change_color_button_title":"Change colour","lang_article_reading_time":"{0} min read","lang_share_mastodon_label":"Share on Mastodon"}');


var $8ae9bc6f67c8887e$exports = {};
$8ae9bc6f67c8887e$exports = JSON.parse('{"lang_markread":"marcar como le\xeddo","lang_filter":"filtro","lang_newest":"nuevos","lang_unread":"no le\xeddos","lang_starred":"preferidos","lang_online_count":"Elementos disponibles en el servidor","lang_offline_count":"Elementos disponibles localmente","lang_tags":"Etiquetas","lang_alltags":"todas las etiquetas","lang_timestamp":"{0,date} {0,time}","lang_hours":"hace {0,plural,one {1 hora},other {# horas}}","lang_minutes":"hace {0,plural,one {1 minuto},other {# minutos}}","lang_seconds":"hace {0,plural,one {1 segundo},other {# segundos}}","lang_days":"{0,plural,zero {hoy},one {ayer},other {hace # d\xedas}}","lang_star":"preferido","lang_unstar":"ya no lo prefiero","lang_mark":"marcar como le\xeddo","lang_unmark":"marcar como no le\xeddo","lang_load_img":"cargar Im\xe1genes","lang_open_window":"abrir","lang_next":"siguiente","lang_searchbutton":"buscar","lang_searchremove":"ocultar b\xfasqueda","lang_refreshbutton":"actualizar fuentes","lang_settingsbutton":"configuraci\xf3n","lang_logoutbutton":"cerrar sesi\xf3n","lang_loginbutton":"iniciar sesi\xf3n","lang_sources":"Fuentes","lang_source_add":"agregar fuente","lang_source_opml":"o importar desde un archivo opml o desde Google Reader (Hasta el 15 de Julio de 2013)","lang_source_export":"exportar fuentes","lang_source_edit":"editar","lang_source_filter":"Filtrar","lang_source_delete":"borrar","lang_source_warn":"realmente desea borrar esta fuente?","lang_source_new":"nueva fuente sin guardar","lang_source_title":"Titulo","lang_source_autotitle_hint":"Dejar en blanco para obtener t\xedtulo","lang_source_tags":"Etiquetas","lang_source_pwd_placeholder":"no ha cambiado","lang_source_comma":"separado por comas","lang_source_select":"por favor seleccione una fuente","lang_source_type":"Tipo","lang_source_save":"Guardar","lang_source_cancel":"cancelar","lang_source_saved":"Guardado","lang_source_last_post":"\xdaltima entrada vista","lang_source_refresh":"Actualizar esta fuente","lang_no_entries":"No se encontraron entradas","lang_more":"m\xe1s","lang_login":"iniciar sesi\xf3n","lang_login_username":"usuario","lang_login_password":"contrase\xf1a","lang_login_invalid_credentials":"usuario/contrase\xf1a incorrectos","lang_login_offline":"Almacenaje fuera de l\xednea","lang_no_title":"sin t\xedtulo","lang_error":"ha ocurrido un error","lang_streamerror":"Ning\xfan elemento cargado, \xbfrecargar?","lang_reload_list":"Recargar lista","lang_sources_refreshed":"Las fuentes han sido refrescadas","lang_app_update":"selfoss ha sido actualizado, recargue","lang_app_reload":"Recargar","lang_error_session_expired":"La sesi\xf3n ha expirado","lang_error_add_source":"Error a\xf1adiendo fuente:","lang_error_delete_source":"Error borrando fuente:","lang_error_load_tags":"Error cargando etiquetas:","lang_error_unknown_tag":"Etiqueta desconocida:","lang_error_unknown_source":"Id de fuente desconocido:","lang_error_mark_items":"No se pudo marcar todos los elementos visibles:","lang_error_mark_item":"No se pudo marcar/desmarcar elemento:","lang_error_star_item":"No se pudo preferir/despreferir elemento:","lang_error_logout":"No se pudo registrar:","lang_error_loading":"Error cargando:","lang_error_loading_stats":"No se pudo cargar estad\xedsticas de navegaci\xf3n:","lang_error_saving_color":"No se pudo cargar nuevo color:","lang_error_refreshing_source":"No se pudo refrescar fuentes:","lang_error_sync":"No se pudo sincronizar los \xfaltimos cambios del servidor:","lang_error_offline_storage":"Error de almacenaje fuera de l\xednea: {0}. Recargar puede ayudar. Desactivando uso fuera de l\xednea por ahora.","lang_error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","lang_search_label":"Buscar t\xe9rmino","lang_article_actions":"Acciones","lang_error_configuration":"Imposible cargar configuraci\xf3n.","lang_info_url_copied":"URL copiada al portapapeles.","lang_share_native_label":"Compartir","lang_share_diaspora_label":"Compartir en Diaspora","lang_share_twitter_label":"Compartir en Twitter","lang_share_facebook_label":"Compartir en Facebook","lang_share_pocket_label":"Guardar en Pocket","lang_share_wallabag_label":"Guardar en Wallabag","lang_share_wordpress_label":"Compartir en WordPress","lang_share_mail_label":"Compartir por e-mail","lang_share_copy_label":"Copiar enlace al portapapeles","lang_error_share_native_abort":"Imposible compartir \xedtem-no hay objetivos que compartir, o has cancelado.","lang_error_share_native":"Imposible compartir \xedtem.","lang_close_entry":"Cerrar","lang_error_unwritable_logs":"Imposible escribir logs.","lang_error_check_system_logs":"Un error ha ocurido, por favor comprueba tus logs de sistema.","lang_error_check_log_file":"Un error ha ocurrido, por favor comprueba el fichero de log \u201C{0}\u201D.","lang_offline_navigation_unavailable":"Cambiar etiquetas y fuentes no est\xe1 disponible en el modo fuera de l\xednea.","lang_error_offline_storage_not_available":"Almacenaje fuera de l\xednea no est\xe1 disponible. Aseg\xfarese que su navegador {0}soporta IndexedDB API{1} y, si est\xe1 utilizando un navegador basado en Google Chrome, que no est\xe1 usando selfoss en modo inc\xf3gnito.","lang_error_edit_source":"No se pudo guardar los cambios en las fuentes:","lang_experimental":"Experimental","lang_article_reading_time":"{0} min lectura","lang_sources_loading":"Cargando fuentes\u2026","lang_source_warn_cancel_dirty":"\xbfDescartar los cambios no guardados?","lang_error_unauthorized":"Por favor, {link_begin}firme{link_end} para continuar.","lang_no_sources":"No hay fuentes configuradas.","lang_source_menu":"M\xe1s acciones","lang_source_browse":"Navegar","lang_source_deleting":"Borrando fuente\u2026","lang_source_params_loading":"Cargando par\xe1metros\u2026","lang_login_in_progress":"Intentando iniciar sesi\xf3n\u2026","lang_source_saving":"Guardando cambios en la fuente\u2026","lang_source_go_to_settings":"Abrir en los ajustes","lang_tag_change_color_button_title":"Cambiar el color","lang_entries_loading":"Cargando las entradas\u2026","lang_login_error_generic":"No se ha podido iniciar la sesi\xf3n: {errorMessage}","lang_sources_leaving_unsaved_prompt":"\xbfDejar la configuraci\xf3n con los cambios sin guardar?","lang_share_mastodon_label":"Compartir en Mastodon"}');


var $d225499964bebf2a$exports = {};
$d225499964bebf2a$exports = JSON.parse('{"lang_markread":"M\xe4rgi loetuks","lang_newest":"Uued","lang_unread":"Mitteloetud","lang_starred":"T\xe4rniga","lang_tags":"Sildid","lang_alltags":"K\xf5ik sildid","lang_timestamp":"lisatud {0,date} kell {0,time}","lang_hours":"lisatud {0,plural,one {1 tund},other {# tundi}} tagasi","lang_minutes":"lisatud {0,plural,one {1 minut},other {# minutit}} tagasi","lang_seconds":"lisatud {0,plural,one {1 sekund},other {# sekundit}} tagasi","lang_star":"t\xe4rniga","lang_unstar":"t\xe4rnita","lang_mark":"m\xe4rgi loetuks","lang_unmark":"m\xe4rgi mitteloetuks","lang_load_img":"pildid","lang_open_window":"ava","lang_searchbutton":"otsi","lang_sources":"Tellimused","lang_source_add":"Lisa tellimus","lang_source_opml":"v\xf5i impordi opml-fail v\xf5i Google Reader","lang_source_export":"ekspordi tellimused","lang_source_edit":"toimeta","lang_source_delete":"kustuta","lang_source_warn":"Kas t\xf5esti kustutada tellimus?","lang_source_new":"uus salvestamata tellimus","lang_source_title":"Nimi","lang_source_tags":"Sildid","lang_source_comma":"komaga eraldatud","lang_source_select":"Tellimuse allika liik","lang_source_type":"Liik","lang_source_save":"Salvesta","lang_source_cancel":"loobu","lang_source_saved":"salvestatud","lang_no_entries":"\xdchtki s\xfcndmust ei leitud","lang_more":"rohkem","lang_login":"logi sisse","lang_login_username":"Kasutajanimi","lang_login_password":"Parool","lang_no_title":"Nimeta"}');


var $d319fa7db54d8a5e$exports = {};
$d319fa7db54d8a5e$exports = JSON.parse('{"lang_markread":"merkitse luetuiksi","lang_newest":"uusimmat","lang_unread":"lukemattomat","lang_starred":"t&auml;hdelliset","lang_tags":"Avainsanat","lang_alltags":"kaikki avainsanat","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 tunti},other {# tuntia}} sitten","lang_minutes":"{0,plural,one {1 minuutti},other {# minuuttia}} sitten","lang_seconds":"{0,plural,one {1 sekunti},other {# sekuntia}} sitten","lang_star":"t&auml;hti","lang_unstar":"t&auml;hti pois","lang_mark":"luetuksi","lang_unmark":"lukemattomaksi","lang_load_img":"lataa kuvat","lang_open_window":"avaa","lang_searchbutton":"etsi","lang_sources":"L&auml;hteet","lang_source_add":"lis&auml;&auml; l&auml;hde","lang_source_opml":"tai tuo opml-tiedosto tai google reader","lang_source_export":"vie l&auml;hteet","lang_source_edit":"muokkaa","lang_source_delete":"poista","lang_source_warn":"Haluatko varmasti poistaa t&auml;m&auml;n l&auml;hteen?","lang_source_new":"uusi tallentamaton l&auml;hde","lang_source_title":"Nimi","lang_source_tags":"Avainsanat","lang_source_comma":"avainsanat erotetaan pilkulla","lang_source_select":"valitse l&auml;hde","lang_source_type":"Tyyppi","lang_source_save":"tallenna","lang_source_cancel":"peruuta","lang_source_saved":"tallennettu","lang_no_entries":"merkint&ouml;j&auml; ei l&ouml;ydetty","lang_more":"lis&auml;&auml;","lang_login":"kirjaudu sis&auml;&auml;n","lang_login_username":"k&auml;ytt&auml;j&auml;tunnus","lang_login_password":"salasana","lang_no_title":"ei otsikkoa","lang_error_share_native_abort":"Kohteen jakaminen ep\xe4onnistui \u2013 joko jakamiskohteita ei ole tai peruutat sen.","lang_close_entry":"Sulje","lang_login_invalid_credentials":"V\xe4\xe4r\xe4 k\xe4ytt\xe4j\xe4nimi/salasana","lang_share_mail_label":"Jaa s\xe4hk\xf6postitse"}');


var $d0be492086bdc65a$exports = {};
$d0be492086bdc65a$exports = JSON.parse('{"lang_markread":"Marquer comme lu","lang_filter":"Filtrer","lang_newest":"Le plus r\xe9cent","lang_unread":"Non lu","lang_starred":"Favoris","lang_online_count":"Sur le serveur","lang_offline_count":"En local","lang_tags":"\xc9tiquettes","lang_alltags":"Toutes les \xe9tiquettes","lang_timestamp":"{0,date} {0,time}","lang_hours":"il y a {0,plural,one {1 heure},other {# heures}}","lang_minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","lang_seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","lang_days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","lang_star":"Ajouter aux favoris","lang_unstar":"Supprimer des favoris","lang_mark":"Marquer comme lu","lang_unmark":"Marquer comme non lu","lang_load_img":"Afficher les images","lang_open_window":"Ouvrir","lang_next":"Suivant","lang_searchbutton":"Rechercher","lang_searchremove":"Masquer le champ de recherche","lang_refreshbutton":"Actualiser les sources","lang_settingsbutton":"Param\xe8tres","lang_logoutbutton":"Se d\xe9connecter","lang_loginbutton":"Se connecter","lang_sources":"Sources","lang_source_add":"Ajouter une source","lang_source_opml":"ou importer un fichier OPML ou Google Reader","lang_source_export":"Exporter les sources","lang_source_edit":"Modifier","lang_source_filter":"Filtre","lang_source_delete":"Supprimer","lang_source_warn":"Voulez-vous vraiment supprimer cette source ?","lang_source_new":"Nouvelle source non sauvegard\xe9e","lang_source_title":"Titre","lang_source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","lang_source_tags":"\xc9tiquettes","lang_source_pwd_placeholder":"Mot de passe inchang\xe9","lang_source_comma":"S\xe9par\xe9s par une virgule","lang_source_select":"Veuillez s\xe9lectionner une source","lang_source_type":"Type","lang_source_save":"Enregistrer","lang_source_cancel":"Annuler","lang_source_saved":"Enregistr\xe9","lang_source_last_post":"Dernier \xe9l\xe9ment vu","lang_source_refresh":"Rafra\xeechir cette source","lang_no_entries":"Aucun article \xe0 consulter","lang_more":"Plus","lang_login":"Connexion","lang_login_username":"Identifiant","lang_login_password":"Mot de passe","lang_login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","lang_login_offline":"Stockage hors-ligne","lang_no_title":"Sans titre","lang_error":"Une erreur est survenue","lang_streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau\xa0?","lang_reload_list":"Recharger la liste","lang_sources_refreshed":"Sources actualis\xe9es","lang_app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","lang_app_reload":"Recharger","lang_error_session_expired":"Session expir\xe9e","lang_error_add_source":"Impossible d\'ajouter la source\xa0:","lang_error_delete_source":"Impossible de supprimer la source :","lang_error_load_tags":"Impossible de charger les \xe9tiquettes :","lang_error_unknown_tag":"Tag inconnu\xa0:","lang_error_unknown_source":"Identifiant de source inconnu\xa0:","lang_error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","lang_error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","lang_error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","lang_error_logout":"Impossible de se d\xe9connecter\xa0:","lang_error_loading":"Erreur de chargement\xa0:","lang_error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","lang_error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","lang_error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","lang_error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","lang_error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","lang_error_invalid_subsection":"Sous-section erron\xe9e :","lang_search_label":"Terme de recherche","lang_article_actions":"Actions","lang_error_configuration":"Impossible de charger la configuration.","lang_info_url_copied":"URL copi\xe9e dans le presse-papiers.","lang_share_native_label":"Partager","lang_share_diaspora_label":"Partager sur Diaspora","lang_share_twitter_label":"Partager sur Twitter","lang_share_facebook_label":"Partager sur Facebook","lang_share_pocket_label":"Enregistrer dans Pocket","lang_share_wallabag_label":"Enregistrer dans Wallabag","lang_share_wordpress_label":"Partager sur WordPress","lang_share_mail_label":"Partager par courriel","lang_share_copy_label":"Copier le lien dans le presse-papiers","lang_error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","lang_error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","lang_close_entry":"Fermer","lang_error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","lang_error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","lang_error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0} \xbb.","lang_offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment.","lang_error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","lang_error_edit_source":"Impossible d\'enregistrer les modifications de la source\xa0:","lang_source_browse":"Naviguer","lang_no_sources":"Aucune source configur\xe9es.","lang_source_warn_cancel_dirty":"Annuler les changements non sauvegard\xe9s ?","lang_source_deleting":"Suppression de la source\u2026","lang_source_saving":"Sauvegarde des changements de la source\u2026","lang_entries_loading":"Chargement des entr\xe9es\u2026","lang_source_menu":"Plus d\'actions","lang_tag_change_color_button_title":"Changer la couleur","lang_sources_loading":"Chargement des sources\u2026","lang_source_go_to_settings":"Ouvrir dans les param\xe8tres","lang_sources_leaving_unsaved_prompt":"Quitter les param\xe8tres avec des changements sur la source non sauvegard\xe9s ?","lang_source_params_loading":"Chargement des param\xe8tres\u2026","lang_experimental":"Exp\xe9rimentale","lang_article_reading_time":"{0} min de lecture","lang_login_in_progress":"Tentative de connexion\u2026","lang_login_error_generic":"Connexion impossible : {errorMessage}","lang_error_unauthorized":"S\'il vous pla\xeet {link_begin}connectez-vous{link_end} pour continuer."}');


var $bb896106aaedaee8$exports = {};
$bb896106aaedaee8$exports = JSON.parse('{"lang_error_add_source":"Impossible d\'ajouter la source\u202F:","lang_streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau?","lang_source_warn":"Voulez-vous vraiment supprimer cette source?","lang_sources":"Sources","lang_timestamp":"{0,date} {0,time}","lang_close_entry":"Fermer","lang_error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","lang_error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","lang_share_copy_label":"Copier le lien dans le presse-papiers","lang_share_mail_label":"Partager par courriel","lang_share_wordpress_label":"Partager sur WordPress","lang_share_wallabag_label":"Enregistrer dans Wallabag","lang_share_pocket_label":"Enregistrer dans Pocket","lang_share_facebook_label":"Partager sur Facebook","lang_share_twitter_label":"Partager sur Twitter","lang_share_diaspora_label":"Partager sur Diaspora","lang_share_native_label":"Partager","lang_info_url_copied":"URL copi\xe9e dans le presse-papiers.","lang_error_configuration":"Impossible de charger la configuration.","lang_article_actions":"Actions","lang_search_label":"Terme de recherche","lang_error_invalid_subsection":"Sous-section erron\xe9e :","lang_error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","lang_error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","lang_error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","lang_error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","lang_error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","lang_error_loading":"Erreur de chargement\xa0:","lang_error_logout":"Impossible de se d\xe9connecter\xa0:","lang_error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","lang_error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","lang_error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","lang_error_unknown_source":"Identifiant de source inconnu\xa0:","lang_error_unknown_tag":"Tag inconnu\xa0:","lang_error_load_tags":"Impossible de charger les \xe9tiquettes :","lang_error_delete_source":"Impossible de supprimer la source :","lang_error_session_expired":"Session expir\xe9e","lang_app_reload":"Recharger","lang_app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","lang_sources_refreshed":"Sources actualis\xe9es","lang_reload_list":"Recharger la liste","lang_error":"Une erreur est survenue","lang_no_title":"Sans titre","lang_login_offline":"Stockage hors-ligne","lang_login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","lang_login_password":"Mot de passe","lang_login_username":"Identifiant","lang_login":"Connexion","lang_more":"Plus","lang_no_entries":"Aucun article \xe0 consulter","lang_source_refresh":"Rafra\xeechir cette source","lang_source_last_post":"Dernier \xe9l\xe9ment vu","lang_source_saved":"Enregistr\xe9","lang_source_cancel":"Annuler","lang_source_save":"Enregistrer","lang_source_type":"Type","lang_source_select":"Veuillez s\xe9lectionner une source","lang_source_comma":"S\xe9par\xe9s par une virgule","lang_source_pwd_placeholder":"Mot de passe inchang\xe9","lang_source_tags":"\xc9tiquettes","lang_source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","lang_source_title":"Titre","lang_source_new":"Nouvelle source non sauvegard\xe9e","lang_source_delete":"Supprimer","lang_source_filter":"Filtre","lang_source_edit":"Modifier","lang_source_export":"Exporter les sources","lang_source_opml":"ou importer un fichier OPML ou Google Reader","lang_source_add":"Ajouter une source","lang_loginbutton":"Se connecter","lang_logoutbutton":"Se d\xe9connecter","lang_settingsbutton":"Param\xe8tres","lang_refreshbutton":"Actualiser les sources","lang_searchremove":"Masquer le champ de recherche","lang_searchbutton":"Rechercher","lang_next":"Suivant","lang_open_window":"Ouvrir","lang_load_img":"Afficher les images","lang_unmark":"Marquer comme non lu","lang_mark":"Marquer comme lu","lang_unstar":"Supprimer des favoris","lang_star":"Ajouter aux favoris","lang_days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","lang_seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","lang_minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","lang_hours":"il y a {0,plural,one {1 heure},other {# heures}}","lang_alltags":"Toutes les \xe9tiquettes","lang_tags":"\xc9tiquettes","lang_offline_count":"En local","lang_online_count":"Sur le serveur","lang_starred":"Favoris","lang_unread":"Non lu","lang_newest":"Le plus r\xe9cent","lang_filter":"Filtrer","lang_markread":"Marquer comme lu","lang_error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","lang_error_edit_source":"Impossible d\'enregistrer les modifications de la source :","lang_error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","lang_error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","lang_error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0}\xa0\xbb.","lang_offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment."}');


var $acbbfcabee63ed13$exports = {};
$acbbfcabee63ed13$exports = JSON.parse('{"lang_tags":"Etiquetas","lang_days":"{0,plural,zero {hoxe},one {onte},other {fai # d\xedas}}","lang_unmark":"Marcar como non lido","lang_share_pocket_label":"Gardar en Pocket","lang_no_entries":"Non se atoparon rexistros","lang_more":"M\xe1is","lang_filter":"Filtro","lang_online_count":"Elementos dispo\xf1ibles no servidor","lang_offline_count":"Elementos dispo\xf1ibles localmente","lang_timestamp":"{0,date} {0,time}","lang_hours":"fai {0,plural,one {1 hora},other {# horas}}","lang_minutes":"fai {0,plural,one {1 minuto},other {# minutos}}","lang_seconds":"fai {0,plural,one {1 segundo},other {# segundos}}","lang_share_wallabag_label":"Gardar en Wallabag","lang_share_wordpress_label":"Compartir en WordPress","lang_share_mail_label":"Compartir por email","lang_share_copy_label":"Copiar ligaz\xf3n o portapap\xe9is","lang_search_label":"Buscar termo","lang_searchbutton":"Procurar","lang_searchremove":"Agochar b\xfasqueda","lang_refreshbutton":"Actualizar as fontes","lang_settingsbutton":"Configuraci\xf3n","lang_logoutbutton":"Fechar a sesi\xf3n","lang_loginbutton":"Iniciar sesi\xf3n","lang_sources":"Fontes","lang_sources_loading":"Cargando as fontes\u2026","lang_no_sources":"Non hai fontes configuradas.","lang_source_add":"Engadir fonte","lang_source_opml":"ou importa dende un ficheiro OPML","lang_source_export":"Exportar fontes","lang_source_edit":"Editar","lang_source_filter":"Filtro","lang_source_menu":"M\xe1is acci\xf3ns","lang_source_browse":"Navegar","lang_source_delete":"Borrar","lang_source_warn":"Realmente queres borrar esta fonte?","lang_source_deleting":"Borrando a fonte\u2026","lang_source_warn_cancel_dirty":"Queres descargar os cambios non gardados?","lang_source_new":"Nova fonte sen gardar","lang_source_title":"T\xedtulo","lang_source_autotitle_hint":"Deixar en branco pra obter t\xedtulo","lang_source_type":"Tipo","lang_source_save":"Gardar","lang_source_cancel":"Cancelar","lang_source_saving":"Gardando cambios da fonte\u2026","lang_source_last_post":"\xdaltima entrada vista","lang_error_session_expired":"A sesi\xf3n expirou","lang_error_add_source":"Non se puido engadira a fonte:","lang_error_edit_source":"Non se puideron gardar os cambios as fontes:","lang_error_delete_source":"Erro borrando a fonte:","lang_error_load_tags":"Non se puideron cargar as etiquetas:","lang_error_unknown_tag":"Etiqueta desco\xf1ecida:","lang_error_unknown_source":"Id de fonte desco\xf1ecida:","lang_error_mark_items":"Non se puideron marcar todos os elementos visib\xe9is:","lang_error_mark_item":"Non se puido marcar/desmarcar elemento:","lang_error_star_item":"Non se puido marcar/desmarcar a estrela no elemento:","lang_error_logout":"Non se puido fechar a sesi\xf3n:","lang_error_loading":"Error cargando:","lang_error_loading_stats":"Non se puideron cargar as estat\xedsticas de navegaci\xf3n:","lang_error_saving_color":"Non se puido cargar a nova cor:","lang_error_refreshing_source":"Non se puideron refrescar as fontes:","lang_error_sync":"Non se puideron sincronizar os \xfaltimos cambios do servidor:","lang_error_offline_storage":"Error do almacenamento fora de li\xf1a: {0}. Recargar pode axudar. Desactivando uso fora de li\xf1a polo momento.","lang_share_twitter_label":"Compartir en Twitter","lang_error_offline_storage_not_available":"Almacenamento fora de li\xf1a non dispo\xf1\xedbel. Asegurase de que o seu navegador {0} soporta IndexedDB API{1} e, se est\xe1 utilizando un navegador baseado en Google Chrome, que non est\xe9 usando selfoss en modo inc\xf3gnito.","lang_error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","lang_error_configuration":"Non se puido cargar a configuraci\xf3n.","lang_error_share_native_abort":"Non se puido compartir o elemento, non tes onde compartilo ou cancel\xe1chelo.","lang_error_share_native":"Non se puido compartir o elemento.","lang_info_url_copied":"Copiouse a URL o portapap\xe9is.","lang_close_entry":"Fechar","lang_article_actions":"Acci\xf3ns","lang_article_reading_time":"{0} min lectura","lang_unread":"Non lidos","lang_offline_navigation_unavailable":"Cambiar etiquetas e fontes non est\xe1 dispo\xf1ible no modo fora de li\xf1a.","lang_source_go_to_settings":"Abrir a configuraci\xf3n","lang_login_in_progress":"Intentando iniciar sesi\xf3n\u2026","lang_markread":"Marcar como lido","lang_newest":"Novos","lang_alltags":"Todas as etiquetas","lang_source_saved":"Gardado","lang_source_refresh":"Actualizar esta fonte","lang_tag_change_color_button_title":"Cambiar a cor","lang_login":"Iniciar sesi\xf3n","lang_login_password":"Contrasinal","lang_sources_refreshed":"Actualizaronse as fontes","lang_star":"Marcar con estrela","lang_starred":"Con estrela","lang_unstar":"Quitar a estrela","lang_next":"Seguinte","lang_share_native_label":"Compartir","lang_share_diaspora_label":"Compartir en Diaspora","lang_share_facebook_label":"Compartir en Facebook","lang_source_comma":"Separado por comas","lang_mark":"Marcar como lido","lang_open_window":"Abrir","lang_load_img":"Cargar imaxes","lang_login_invalid_credentials":"Usuario/contrasinal incorrectos","lang_source_tags":"Etiquetas","lang_source_select":"Por favor, escolle unha fonte","lang_source_pwd_placeholder":"Non cambiou","lang_source_params_loading":"Estanse cargando os par\xe1metros\u2026","lang_sources_leaving_unsaved_prompt":"Queres deixar a configuraci\xf3n con cambios de fonte non gardados?","lang_login_username":"Usuario","lang_entries_loading":"Estanse cargando as entradas\u2026","lang_login_offline":"Almacenamento fora de li\xf1a","lang_error":"Ocurriu un erro","lang_error_check_system_logs":"Ocurriu un erro, por favor comproba os rexistros do sistema.","lang_error_unwritable_logs":"Non se puideron escribir os rexistros.","lang_no_title":"Sen t\xedtulo","lang_experimental":"Experimental","lang_error_check_log_file":"Produciuse un erro, por favor comproba o ficheiro de rexistro \\"{0}\\".","lang_streamerror":"Non hai elementos cargados, recargar?","lang_reload_list":"Recargar lista","lang_app_update":"Selfoss actualizouse, recargue","lang_app_reload":"Recargar","lang_error_unauthorized":"{link_begin}inicia sesi\xf3n{link_end} para continuar.","lang_login_error_generic":"Non se puido iniciar sesi\xf3n: {errorMessage}","lang_share_mastodon_label":"Comparte en Mastodon"}');


var $b6d92725827c8d30$exports = {};
$b6d92725827c8d30$exports = JSON.parse('{"lang_error_offline_storage_not_available":"\u05D4\u05D0\u05D7\u05E1\u05D5\u05DF \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05D0\u05D9\u05E0\u05D5 \u05D6\u05DE\u05D9\u05DF. \u05E0\u05D0 \u05DC\u05D5\u05D5\u05D3\u05D0 \u05E9\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA {0}\u05EA\u05D5\u05DE\u05DA \u05D1\u05BEAPI \u05DE\u05E1\u05D5\u05D2 IndexedDB{1} \u05D5\u05D2\u05DD, \u05D0\u05DD \u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DE\u05E9\u05DE\u05E9 \u05D0\u05D5\u05EA\u05DA \u05DE\u05D1\u05D5\u05E1\u05E1 Google Chrome, \u05E9\u05D6\u05D0\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D2\u05DC\u05D9\u05E9\u05D4 \u05D1\u05E1\u05EA\u05E8.","lang_error_invalid_subsection":"\u05EA\u05EA\u05BE\u05E1\u05E2\u05D9\u05E3 \u05E9\u05D2\u05D5\u05D9:","lang_error_offline_storage":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF: {0}. \u05D0\u05D5\u05DC\u05D9 \u05E8\u05E2\u05E0\u05D5\u05DF \u05D9\u05E2\u05D6\u05D5\u05E8. \u05D4\u05DE\u05E6\u05D1 \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05DE\u05D5\u05E9\u05D1\u05EA \u05DB\u05E8\u05D2\u05E2.","lang_error_share_native_abort":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8 - \u05D0\u05D5 \u05E9\u05D0\u05D9\u05DF \u05D9\u05E2\u05D3 \u05DC\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D0\u05D5 \u05E9\u05D1\u05D9\u05D8\u05DC\u05EA.","lang_error_configuration":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05D4\u05D2\u05D3\u05E8\u05D5\u05EA.","lang_error_share_native":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8.","lang_article_actions":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA","lang_close_entry":"\u05E1\u05D2\u05D9\u05E8\u05D4","lang_info_url_copied":"\u05D4\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D5\u05E2\u05EA\u05E7\u05D4 \u05DC\u05DC\u05D5\u05D7 \u05D4\u05D2\u05D6\u05D9\u05E8\u05D9\u05DD.","lang_error_sync":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05E0\u05DB\u05E8\u05DF \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D9\u05DD \u05DE\u05D4\u05E9\u05E8\u05EA:","lang_error_refreshing_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA:","lang_error_saving_color":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05D7\u05D3\u05E9:","lang_error_loading_stats":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05E1\u05D8\u05D8\u05D9\u05E1\u05D8\u05D9\u05E7\u05EA \u05E0\u05D9\u05D5\u05D5\u05D8:","lang_error_loading":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D8\u05E2\u05D9\u05E0\u05D4:","lang_error_logout":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E6\u05D0\u05EA:","lang_error_star_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1/\u05DC\u05D1\u05D8\u05DC \u05DB\u05D5\u05DB\u05D1 \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","lang_error_mark_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF/\u05DC\u05D1\u05D8\u05DC \u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","lang_error_mark_items":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D0\u05EA \u05DB\u05DC \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D4\u05D2\u05DC\u05D5\u05D9\u05D9\u05DD:","lang_error_unknown_source":"\u05DE\u05D6\u05D4\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E8 \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2:","lang_error_unknown_tag":"\u05EA\u05D2\u05D9\u05EA \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2\u05D4:","lang_error_load_tags":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05EA\u05D2\u05D9\u05D5\u05EA:","lang_error_delete_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DE\u05D7\u05D5\u05E7 \u05DE\u05E7\u05D5\u05E8:","lang_error_edit_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05D0\u05EA \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9 \u05D4\u05DE\u05E7\u05D5\u05E8:","lang_error_add_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DE\u05E7\u05D5\u05E8:","lang_error_session_expired":"\u05EA\u05D5\u05E7\u05E3 \u05D4\u05D4\u05E4\u05E2\u05DC\u05D4 \u05E4\u05D2","lang_app_reload":"\u05E8\u05E2\u05E0\u05D5\u05DF","lang_app_update":"selfoss \u05D4\u05EA\u05E2\u05D3\u05DB\u05DF, \u05E0\u05D0 \u05DC\u05E8\u05E2\u05E0\u05DF","lang_sources_refreshed":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D4\u05EA\u05E8\u05E2\u05E0\u05E0\u05D5","lang_reload_list":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05E8\u05E9\u05D9\u05DE\u05D4","lang_streamerror":"\u05DC\u05D0 \u05E0\u05D8\u05E2\u05E0\u05D5 \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD, \u05DC\u05E8\u05E2\u05E0\u05DF?","lang_error_unwritable_logs":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DB\u05EA\u05D5\u05D1 \u05D9\u05D5\u05DE\u05E0\u05D9\u05DD.","lang_error_check_system_logs":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05D9\u05D5\u05DE\u05E0\u05D9 \u05D4\u05DE\u05E2\u05E8\u05DB\u05EA \u05E9\u05DC\u05DA.","lang_error_check_log_file":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05E7\u05D5\u05D1\u05E5 \u05D4\u05D9\u05D5\u05DE\u05DF \u201E{0}\u201D.","lang_error":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4","lang_no_title":"\u05D0\u05D9\u05DF \u05DB\u05D5\u05EA\u05E8\u05EA","lang_login_offline":"\u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF","lang_login_invalid_credentials":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9/\u05E1\u05E1\u05DE\u05D4 \u05E9\u05D2\u05D5\u05D9\u05D9\u05DD","lang_login_password":"\u05E1\u05E1\u05DE\u05D4","lang_login_username":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9","lang_login":"\u05DB\u05E0\u05D9\u05E1\u05D4","lang_more":"\u05E2\u05D5\u05D3","lang_no_entries":"\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0\u05D5 \u05E8\u05E9\u05D5\u05DE\u05D5\u05EA","lang_source_refresh":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4","lang_source_last_post":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D4 \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4 \u05E9\u05E0\u05E8\u05D0\u05EA\u05D4","lang_source_saved":"\u05E0\u05E9\u05DE\u05E8","lang_source_cancel":"\u05D1\u05D9\u05D8\u05D5\u05DC","lang_source_save":"\u05E9\u05DE\u05D9\u05E8\u05D4","lang_source_type":"\u05E1\u05D5\u05D2","lang_source_select":"\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DE\u05E7\u05D5\u05E8","lang_source_comma":"\u05E2\u05DD \u05D4\u05E4\u05E8\u05D3\u05D4 \u05D1\u05E4\u05E1\u05D9\u05E7\u05D9\u05DD","lang_source_pwd_placeholder":"\u05DC\u05D0 \u05D4\u05E9\u05EA\u05E0\u05D4","lang_source_tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","lang_source_autotitle_hint":"\u05D9\u05E9 \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05E8\u05D9\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05E7\u05D1\u05DC \u05D0\u05EA \u05D4\u05DB\u05D5\u05EA\u05E8\u05EA","lang_source_title":"\u05DB\u05D5\u05EA\u05E8\u05EA","lang_source_new":"\u05DE\u05E7\u05D5\u05E8 \u05D7\u05D3\u05E9 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8","lang_source_warn":"\u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4?","lang_source_delete":"\u05DE\u05D7\u05D9\u05E7\u05D4","lang_source_filter":"\u05DE\u05E1\u05E0\u05DF","lang_source_edit":"\u05E2\u05E8\u05D9\u05DB\u05D4","lang_source_export":"\u05D9\u05D9\u05E6\u05D5\u05D0 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_source_opml":"\u05D0\u05D5 \u05DC\u05D9\u05D9\u05D1\u05D0 \u05E7\u05D5\u05D1\u05E5 OPML","lang_source_add":"\u05D4\u05D5\u05E1\u05E4\u05EA \u05DE\u05E7\u05D5\u05E8","lang_sources":"\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_loginbutton":"\u05DB\u05E0\u05D9\u05E1\u05D4","lang_logoutbutton":"\u05D9\u05E6\u05D9\u05D0\u05D4","lang_settingsbutton":"\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","lang_refreshbutton":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_searchremove":"\u05D4\u05E1\u05EA\u05E8\u05EA \u05D7\u05D9\u05E4\u05D5\u05E9","lang_searchbutton":"\u05D7\u05D9\u05E4\u05D5\u05E9","lang_search_label":"\u05D1\u05D9\u05D8\u05D5\u05D9 \u05DC\u05D7\u05D9\u05E4\u05D5\u05E9","lang_share_copy_label":"\u05D4\u05E2\u05EA\u05E7\u05EA \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05DC\u05D5\u05D7 \u05D2\u05D6\u05D9\u05E8\u05D9\u05DD","lang_share_mail_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D3\u05D5\u05D0\u05F4\u05DC","lang_share_wordpress_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D5\u05D5\u05E8\u05D3\u05E4\u05E8\u05E1","lang_share_wallabag_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEWallabag","lang_share_pocket_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEPocket","lang_share_facebook_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05E4\u05D9\u05D9\u05E1\u05D1\u05D5\u05E7","lang_share_twitter_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D8\u05D5\u05D5\u05D9\u05D8\u05E8","lang_share_diaspora_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEDiaspora","lang_share_native_label":"\u05E9\u05D9\u05EA\u05D5\u05E3","lang_next":"\u05D4\u05D1\u05D0","lang_open_window":"\u05E4\u05EA\u05D9\u05D7\u05D4","lang_load_img":"\u05D4\u05E6\u05D2\u05EA \u05EA\u05DE\u05D5\u05E0\u05D5\u05EA","lang_unmark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","lang_mark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","lang_unstar":"\u05D1\u05D9\u05D8\u05D5\u05DC \u05DB\u05D5\u05DB\u05D1","lang_star":"\u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","lang_days":"{0,plural,zero {\u05D4\u05D9\u05D5\u05DD},one {\u05D0\u05EA\u05DE\u05D5\u05DC},two {\u05E9\u05DC\u05E9\u05D5\u05DD},other {\u05DC\u05E4\u05E0\u05D9 # \u05D9\u05DE\u05D9\u05DD}}","lang_seconds":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E0\u05D9\u05D9\u05D4},other {# \u05E9\u05E0\u05D9\u05D5\u05EA}}","lang_minutes":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05D3\u05E7\u05D4},other {# \u05D3\u05E7\u05D5\u05EA}}","lang_hours":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E2\u05D4},two {\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD},other {# \u05E9\u05E2\u05D5\u05EA}}","lang_timestamp":"\u200E{0,date} {0,time}","lang_alltags":"\u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA","lang_tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","lang_offline_navigation_unavailable":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05EA\u05D2\u05D9\u05D5\u05EA \u05D5\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D6\u05DE\u05D9\u05E0\u05D4 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05DE\u05E6\u05D1 \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF.","lang_offline_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05DE\u05E7\u05D5\u05DE\u05D9\u05EA","lang_online_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05E9\u05E8\u05EA","lang_starred":"\u05DE\u05E1\u05D5\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","lang_unread":"\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","lang_newest":"\u05D4\u05D7\u05D3\u05E9 \u05D1\u05D9\u05D5\u05EA\u05E8","lang_filter":"\u05DE\u05E1\u05E0\u05DF","lang_markread":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","lang_article_reading_time":"{0} \u05D3\u05E7\u05D5\u05EA \u05E7\u05E8\u05D9\u05D0\u05D4","lang_experimental":"\u05E0\u05D9\u05E1\u05D9\u05D5\u05E0\u05D9","lang_source_warn_cancel_dirty":"\u05DC\u05D4\u05E9\u05DC\u05D9\u05DA \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","lang_sources_leaving_unsaved_prompt":"\u05DC\u05E6\u05D0\u05EA \u05DE\u05D4\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA \u05E2\u05DD \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D1\u05DE\u05E7\u05D5\u05E8 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","lang_source_browse":"\u05E2\u05D9\u05D5\u05DF","lang_source_menu":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05E0\u05D5\u05E1\u05E4\u05D5\u05EA","lang_tag_change_color_button_title":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05E6\u05D1\u05E2","lang_source_go_to_settings":"\u05E4\u05EA\u05D9\u05D7\u05D4 \u05D1\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","lang_sources_loading":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","lang_no_sources":"\u05DC\u05D0 \u05D4\u05D5\u05D2\u05D3\u05E8\u05D5 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA.","lang_source_deleting":"\u05D4\u05DE\u05E7\u05D5\u05E8 \u05E0\u05DE\u05D7\u05E7\u2026","lang_source_params_loading":"\u05D4\u05DE\u05E9\u05EA\u05E0\u05D9\u05DD \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","lang_source_saving":"\u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05DC\u05DE\u05E7\u05D5\u05E8 \u05E0\u05E9\u05DE\u05E8\u05D9\u05DD\u2026","lang_entries_loading":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D5\u05EA\u2026","lang_login_in_progress":"\u05DE\u05EA\u05D1\u05E6\u05E2 \u05E0\u05D9\u05E1\u05D9\u05D5\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4\u2026","lang_error_unauthorized":"\u05E0\u05D0 {link_begin}\u05DC\u05D4\u05D9\u05DB\u05E0\u05E1{link_end} \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.","lang_login_error_generic":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D9\u05DB\u05E0\u05E1: {errorMessage}","lang_share_mastodon_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEMastodon"}');


var $a93f0f568ed4bbb3$exports = {};
$a93f0f568ed4bbb3$exports = JSON.parse('{"lang_markread":"Mindet olvastam","lang_newest":"Legfrissebb","lang_unread":"Olvasatlan","lang_starred":"Megjel\xf6lt","lang_tags":"C\xedmk\xe9k","lang_alltags":"\xd6sszes c\xedmke","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \xf3r\xe1ja},other {# \xf3r\xe1ja}}","lang_minutes":"{0,plural,one {1 perce},other {# perce}}","lang_seconds":"{0,plural,one {1 m\xe1sodperce},other {# m\xe1sodperce}}","lang_star":"Megjel\xf6lt","lang_unstar":"Jel\xf6letlen","lang_mark":"Olvasott","lang_unmark":"Olvasatlan","lang_load_img":"K\xe9pbet\xf6lt\xe9s","lang_open_window":"Megnyit\xe1s","lang_searchbutton":"Keres\xe9s","lang_sources":"H\xedrforr\xe1sok","lang_source_add":"\xdaj h\xedrforr\xe1s","lang_source_opml":"OPML-f\xe1jl import\xe1l\xe1sa","lang_source_export":"H\xedrforr\xe1sok export\xe1l\xe1sa","lang_source_edit":"M\xf3dos\xedt\xe1s","lang_source_delete":"T\xf6rl\xe9s","lang_source_warn":"Biztos t\xf6r\xf6lhet\u0151 a h\xedrforr\xe1s?","lang_source_new":"\xdaj h\xedrforr\xe1s","lang_source_title":"C\xedm","lang_source_tags":"C\xedmk\xe9k","lang_source_comma":"(vessz\u0151vel tagolva)","lang_source_select":"A t\xedpus kiv\xe1laszt\xe1sa","lang_source_type":"T\xedpus","lang_source_save":"Ment\xe9s","lang_source_cancel":"M\xe9gsem","lang_source_saved":"Mentve","lang_no_entries":"Nincs megjelen\xedthet\u0151 h\xedr.","lang_more":"Tov\xe1bbiak","lang_login":"Bejelentkez\xe9s","lang_login_username":"Felhaszn\xe1l\xf3n\xe9v","lang_login_password":"Jelsz\xf3","lang_no_title":"Nincs c\xedm","lang_filter":"Sz\u0171r\u0151","lang_online_count":"A kiszolg\xe1l\xf3n l\xe9v\u0151 h\xedrek sz\xe1ma","lang_offline_count":"A helyben t\xe1rolt h\xedrek sz\xe1ma","lang_error_session_expired":"A munkamenet lej\xe1rt.","lang_app_reload":"\xdajrat\xf6lt\xe9s","lang_sources_refreshed":"Az \xfaj h\xedrek keres\xe9se k\xe9sz.","lang_reload_list":"\xdajrat\xf6lt\xe9s","lang_error_unwritable_logs":"A napl\xf3 nem \xedrhat\xf3.","lang_error":"Hiba t\xf6rt\xe9nt","lang_source_pwd_placeholder":"V\xe1ltozatlan","lang_source_filter":"Sz\u0171r\u0151","lang_loginbutton":"Bejelentkez\xe9s","lang_logoutbutton":"Kijelentkez\xe9s","lang_close_entry":"Bez\xe1r\xe1s","lang_share_native_label":"Megoszt\xe1s","lang_error_load_tags":"Nem siker\xfclt bet\xf6lteni a c\xedmk\xe9ket:","lang_searchremove":"Keres\u0151panel elrejt\xe9se","lang_next":"K\xf6vetkez\u0151","lang_app_update":"A selfoss friss\xedtve lett, \xfajra kell t\xf6lteni az oldalt.","lang_error_offline_storage":"T\xe1rol\xf3hiba kapcsolat n\xe9lk\xfcli m\xf3dban: {0}. Az \xfajrat\xf6lt\xe9s seg\xedthet. A kapcsolat n\xe9lk\xfcli m\xf3d mostant\xf3l ki van kapcsolva.","lang_error_star_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr megjel\xf6lts\xe9g\xe9t:","lang_days":"{0,plural,zero {ma},one {tegnap},other {# napja}}","lang_share_twitter_label":"Twitter-megoszt\xe1s","lang_share_mail_label":"Megoszt\xe1s e-mailben","lang_settingsbutton":"Be\xe1ll\xedt\xe1sok","lang_sources_loading":"H\xedrforr\xe1sok bet\xf6lt\xe9se\u2026","lang_tag_change_color_button_title":"Sz\xedn cser\xe9je","lang_entries_loading":"Bet\xf6lt\xe9s\u2026","lang_login_invalid_credentials":"Hib\xe1s felhaszn\xe1l\xf3n\xe9v vagy jelsz\xf3","lang_login_error_generic":"Sikertelen bejelentkez\xe9s: {errorMessage}","lang_login_offline":"Kapcsolat n\xe9lk\xfcli t\xe1rol\xf3","lang_experimental":"K\xeds\xe9rleti funkci\xf3","lang_error_saving_color":"Nem siker\xfclt menteni az \xfaj sz\xednt:","lang_error_sync":"Nem siker\xfclt szinkroniz\xe1lni a kiszolg\xe1l\xf3val:","lang_error_configuration":"Nem siker\xfclt beolvasni a be\xe1ll\xedt\xe1sokat.","lang_error_share_native_abort":"Nem siker\xfclt megosztani a h\xedrt \u2013 vagy nincsenek megoszt\xe1si c\xe9lok, vagy a m\u0171velet t\xf6r\xf6lve lett.","lang_error_refreshing_source":"Nem siker\xfclt \xfaj h\xedreket keresni:","lang_info_url_copied":"Az URL a v\xe1g\xf3lapra lett m\xe1solva.","lang_article_actions":"M\u0171veletek","lang_article_reading_time":"~{0} perc","lang_share_diaspora_label":"Diaspora-megoszt\xe1s","lang_share_facebook_label":"Facebook-megoszt\xe1s","lang_offline_navigation_unavailable":"A c\xedmk\xe9k \xe9s h\xedrforr\xe1sok m\xf3dos\xedt\xe1sa kapcsolat n\xe9lk\xfcli m\xf3dban jelenleg nem t\xe1mogatott.","lang_source_last_post":"Legut\xf3bbi h\xedr","lang_source_refresh":"\xdaj h\xedrek keres\xe9se","lang_source_go_to_settings":"Be\xe1ll\xedt\xe1sok","lang_sources_leaving_unsaved_prompt":"Nem minden v\xe1ltoz\xe1s lett elmentve. Biztos bez\xe1rhat\xf3 be\xe1ll\xedt\xf3fel\xfclet?","lang_error_share_native":"Nem siker\xfclt megosztani a h\xedrt.","lang_share_mastodon_label":"Mastodon-megoszt\xe1s","lang_share_pocket_label":"Pocket-ment\xe9s","lang_share_wallabag_label":"Wallabag-ment\xe9s","lang_share_wordpress_label":"WordPress-megoszt\xe1s","lang_share_copy_label":"Hivatkoz\xe1s m\xe1sol\xe1sa","lang_search_label":"Keres\u0151kifejez\xe9s","lang_refreshbutton":"\xdaj h\xedrek keres\xe9se","lang_no_sources":"Nincsenek megadva h\xedrforr\xe1sok.","lang_source_menu":"Tov\xe1bbi m\u0171veletek","lang_source_browse":"Megtekint\xe9s","lang_source_deleting":"A h\xedrforr\xe1s t\xf6rl\xe9se\u2026","lang_source_warn_cancel_dirty":"Bez\xe1r\xe1s ment\xe9s n\xe9lk\xfcl?","lang_source_autotitle_hint":"\xdcresen hagyva automatikus kit\xf6lt\xe9s","lang_source_params_loading":"Param\xe9terek bet\xf6lt\xe9se\u2026","lang_source_saving":"A v\xe1ltoz\xe1sok ment\xe9se\u2026","lang_login_in_progress":"Bejelentkez\xe9s\u2026","lang_error_unauthorized":"A folytat\xe1shoz {link_begin}bejelentkez\xe9s{link_end} sz\xfcks\xe9ges.","lang_error_check_log_file":"Hiba t\xf6rt\xe9nt, r\xe9szletek a napl\xf3f\xe1jlban: \u201E{0}\u201D.","lang_error_check_system_logs":"Hiba t\xf6rt\xe9nt, r\xe9szletek a rendszernapl\xf3ban.","lang_streamerror":"Nem t\xf6lt\u0151d\xf6tt le h\xedr. \xdajrat\xf6lt\xe9s?","lang_error_add_source":"Nem siker\xfclt hozz\xe1adni a h\xedrforr\xe1st:","lang_error_edit_source":"Nem siker\xfclt menteni a h\xedrforr\xe1s v\xe1ltoz\xe1sait:","lang_error_delete_source":"Nem siker\xfclt t\xf6r\xf6lni a h\xedrforr\xe1st:","lang_error_mark_items":"Nem siker\xfclt olvasottra \xe1ll\xedtani a megjelen\xedtett h\xedreket:","lang_error_unknown_tag":"Ismeretlen c\xedmke:","lang_error_unknown_source":"Ismeretlen h\xedrforr\xe1s-azonos\xedt\xf3:","lang_error_mark_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr olvasotts\xe1g\xe1t:","lang_error_logout":"Nem siker\xfclt kijelentkezni:","lang_error_loading":"Bet\xf6lt\xe9si hiba:","lang_error_loading_stats":"Nem siker\xfclt bet\xf6lteni a b\xf6ng\xe9sz\xe9si statisztik\xe1t:","lang_error_offline_storage_not_available":"Nem \xe1ll rendelkez\xe9sre t\xe1rol\xf3 a kapcsolat n\xe9lk\xfcli m\xf3dhoz. Ellen\u0151rizni kell, hogy a b\xf6ng\xe9sz\u0151 t\xe1mogatja-e az {0}IndexedDB API{1}-t, illetve Google Chrome alap\xfa b\xf6ng\xe9sz\u0151ben a selfoss nem haszn\xe1lhat\xf3 inkognit\xf3 m\xf3dban.","lang_error_invalid_subsection":"\xc9rv\xe9nytelen aloldal:"}');


var $e1a0d6c367542bd9$exports = {};
$e1a0d6c367542bd9$exports = JSON.parse('{"lang_timestamp":"{0,date} {0,time}","lang_article_reading_time":"bacaan {0} menit","lang_article_actions":"Tindakan","lang_close_entry":"Tutup","lang_info_url_copied":"Alamat URL disalin ke papanklip.","lang_error_share_native":"Tidak dapat membagikan item.","lang_error_share_native_abort":"Tidak dapat membagikan item\u2014kemungkinan disana tidak ada target untuk dibagikan, atau Anda membatalkan hal tersebut.","lang_error_configuration":"Tidak dapat memuat konfigurasi.","lang_error_invalid_subsection":"Subbagian tidak valid:","lang_error_offline_storage_not_available":"Penyimpanan offline tidak tersedia. Pastikan peramban web Anda {0} mendukung DB API yang Terindeks {1} dan, jika Anda menggunakan peramban web Goggle Chrome, pastikan Anda tidak menjalankan selfoss di dalam mode incognito (rahasia).","lang_error_offline_storage":"Kesalahan penyimpanan offline: {0}. Memuat ulang mungkin dapat membantu. Menonaktifkan offline untuk saat ini.","lang_error_sync":"Tidak dapat mengsinkronisasi perubahan terakhir dari server:","lang_error_refreshing_source":"Tidak dapat menyegarkan sumber:","lang_error_saving_color":"Tidak dapat menyimpan warna baru:","lang_error_loading_stats":"Tidak dapat memuat statistik navigasi:","lang_error_loading":"Kesalahan dalam memuat:","lang_error_logout":"Tidak dapat keluar:","lang_error_star_item":"Tidak dapat bintangi/batal bintangi item:","lang_error_mark_item":"Tidak dapat menandai/hapus tanda item:","lang_error_mark_items":"Tidak dapat menandai semua item yang terlihat:","lang_error_unknown_source":"ID sumber tidak diketahui:","lang_error_unknown_tag":"Tag yang tidak diketahui:","lang_error_load_tags":"Tidak dapat memuat tag:","lang_error_delete_source":"Tidak dapat menghapus sumber:","lang_error_edit_source":"Tidak dapat menyimpan perubahan sumber:","lang_error_add_source":"Tidak dapat menambahkan sumber:","lang_error_session_expired":"Sesi kadaluarsa","lang_app_reload":"Muat ulang","lang_app_update":"selfoss telah diperbarui, silahkan muat ulang","lang_sources_refreshed":"Sumber telah disegarkan","lang_reload_list":"Muat ulang daftar","lang_streamerror":"Tidak ada item yang dimuat, muat ulang?","lang_error_unwritable_logs":"Tidak dapat menulis log.","lang_error_check_system_logs":"Sebuah kesalahan terjadi, silahkan periksa log sistem Anda.","lang_error_check_log_file":"Sebuah kesalahan terjadi, silahkan periksa berkas log \\"{0}\\".","lang_error":"Sebuah kesalahan terjadi","lang_experimental":"Eksperimental","lang_no_title":"Tidak ada judul","lang_login_offline":"Penyimpanan offline","lang_login_invalid_credentials":"Nama pengguna/kata sandi salah","lang_login_password":"Kata sandi","lang_login_username":"Nama pengguna","lang_login":"Masuk","lang_more":"Lebih banyak","lang_no_entries":"Tidak ada entri ditemukan","lang_source_refresh":"Segarkan sumber ini","lang_source_last_post":"Postingan terakhir yang dilihat","lang_source_cancel":"Batal","lang_source_saved":"Disimpan","lang_source_save":"Simpan","lang_source_type":"Jenis","lang_source_select":"Silahkan pilih sumber","lang_source_comma":"Dipisahkan oleh koma","lang_source_pwd_placeholder":"Tidak diubah","lang_source_tags":"Tag","lang_source_autotitle_hint":"Biarkan kosong untuk mengambil judul","lang_source_title":"Judul","lang_source_new":"Sumber baru yang belum disimpan","lang_source_warn":"Yakin ingin menghapus sumber ini?","lang_source_delete":"Hapus","lang_source_filter":"Saring","lang_source_edit":"Sunting","lang_source_export":"Ekspor sumber","lang_source_opml":"atau import sebuah berkas OPML","lang_source_add":"Tambahkan sumber","lang_sources":"Sumber","lang_loginbutton":"Masuk","lang_logoutbutton":"Keluar","lang_settingsbutton":"Pengaturan","lang_refreshbutton":"Segarkan sumber","lang_searchremove":"Sembunyikan pencarian","lang_searchbutton":"Cari","lang_search_label":"Cari istilah","lang_share_copy_label":"Salin tautan ke papanklip","lang_share_mail_label":"Bagikan menggunakan email","lang_share_wordpress_label":"Bagikan di WordPress","lang_share_wallabag_label":"Simpan ke Wallabag","lang_share_pocket_label":"Simpan ke Pocket","lang_share_facebook_label":"Bagikan di Facebook","lang_share_twitter_label":"Bagikan di Twitter","lang_share_diaspora_label":"Bagikan di Diaspora","lang_share_native_label":"Bagikan","lang_load_img":"Tampilkan gambar","lang_open_window":"Buka","lang_next":"Selanjutnya","lang_unmark":"Tandai sebagai belum dibaca","lang_mark":"Tandai sebagai telah dibaca","lang_unstar":"Batal Bintangi","lang_star":"Bintangi","lang_days":"{0,plural,zero {today},satu {yesterday},lainnya {# days ago}}","lang_seconds":"{0,plural,one {1 second},lainnya {# seconds}} lalu","lang_minutes":"{0,plural,one {1 minute},lainnya {# minutes}} lalu","lang_hours":"{0,plural,one {1 hour},lainnya {# hours}} lalu","lang_alltags":"Semua tag","lang_tags":"Tag","lang_offline_navigation_unavailable":"Menukar tag dan sumber saat ini tidak tersedia dalam mode offline.","lang_offline_count":"Item tersedia secara lokal","lang_online_count":"Item tersedia di server","lang_starred":"Dilihat","lang_unread":"Belum Dibaca","lang_newest":"Terbaru","lang_filter":"Saring","lang_markread":"Tandai sebagai telah dibaca","lang_entries_loading":"Memuat entri\u2026","lang_source_deleting":"Menghapus sumber\u2026","lang_source_saving":"Menyimpan perubahan sumber\u2026","lang_sources_leaving_unsaved_prompt":"Tinggalkan setelan dengan perubahan sumber yang belum disimpan?","lang_source_go_to_settings":"Buka pengaturan","lang_source_menu":"Tindakan lainnya","lang_login_in_progress":"Mencoba masuk\u2026","lang_source_browse":"Telusuri","lang_login_error_generic":"Tidak bisa masuk: {errorMessage}","lang_source_params_loading":"Memuat parameter\u2026","lang_share_mastodon_label":"Bagikan di Mastodon","lang_sources_loading":"Memuat sumber\u2026","lang_no_sources":"Tidak ada sumber yang dikonfigurasi.","lang_error_unauthorized":"Silakan {link_begin}masuk{link_end} untuk melanjutkan.","lang_source_warn_cancel_dirty":"Buang perubahan yang belum disimpan?","lang_tag_change_color_button_title":"Ubah warna"}');


var $d48d8cf661c7528d$exports = {};
$d48d8cf661c7528d$exports = JSON.parse('{"lang_markread":"Tutte lette","lang_newest":"Recenti","lang_unread":"Non lette","lang_starred":"Contrassegnate","lang_tags":"Etichette","lang_alltags":"Tutte le etichette","lang_timestamp":"{0,date} {0,time}","lang_days":"{0,plural,one {1 ora},other {# ore}} fa","lang_minutes":"{0,plural,one {1 minuto},other {# minuti}} fa","lang_seconds":"{0,plural,one {1 secondo},other {# secondi}} fa","lang_star":"Contrassegna","lang_unstar":"Togli contrassegno","lang_mark":"Segna come letta","lang_unmark":"Segna come non letta","lang_load_img":"Caricare le immagini","lang_open_window":"Apri","lang_searchbutton":"Ricerca","lang_sources":"Fonti","lang_source_add":"Aggiungi una fonte","lang_source_opml":"o importa un file OPML / Google reader","lang_source_export":"Esporta fonti","lang_source_edit":"modifica","lang_source_delete":"cancella","lang_source_warn":"Vuoi veramente eliminare questa fonte?","lang_source_new":"Nuova fonte","lang_source_title":"Titolo","lang_source_tags":"Etichette","lang_source_comma":"separate da una virgola","lang_source_select":"seleziona il tipo di fonte","lang_source_type":"Tipo","lang_source_save":"salva","lang_source_cancel":"annulla","lang_no_entries":"Nessuna pubblicazione","lang_more":"Caricare altre pubblicazioni","lang_login":"Accedi","lang_login_username":"Nome utente","lang_login_password":"Password","lang_no_title":"Senza titolo","lang_error_star_item":"Non \xe8 possibile contrassegnare/togliere il contrassegno per l\'elemento:","lang_error_mark_item":"Impossibile segnare l\'elemento come letto/non letto:","lang_article_actions":"Azioni","lang_close_entry":"Chiudi","lang_info_url_copied":"URL copiato negli appunti.","lang_error_share_native":"Impossibile condividere l\'elemento.","lang_error_share_native_abort":"Impossibile condividere l\'articolo\u202F\u2013\u202Fnon ci sono obiettivi di condivisione o l\'hai cancellato.","lang_error_configuration":"Impossibile caricare la configurazione.","lang_error_invalid_subsection":"Sottosezione non valida:","lang_error_offline_storage":"Errore di archiviazione offline: {0}. Il ricaricamento pu\xf2 aiutare. Disabilitazione la modalit\xe0 offline per ora.","lang_error_sync":"Impossibile sincronizzare le ultime modifiche dal server:","lang_error_refreshing_source":"Impossibile aggiornare le fonti:","lang_error_saving_color":"Impossibile salvare un nuovo colore:","lang_error_loading_stats":"Impossibile caricare le statistiche di navigazione:","lang_error_loading":"Errore di caricamento:","lang_error_logout":"Impossibile uscire:","lang_error_mark_items":"Impossibile contrassegnare tutti gli elementi visibili:","lang_error_unknown_source":"Identificazione della fonte sconosciuta:","lang_error_unknown_tag":"Etichetta sconosciuta:","lang_error_load_tags":"Impossibile caricare le etichette:","lang_error_delete_source":"Impossibile eliminare l\'origine:","lang_error_add_source":"Impossibile aggiungere la fonte:","lang_error_session_expired":"Sessione scaduta","lang_app_reload":"Ricarica","lang_app_update":"selfoss \xe8 stato aggiornato, si prega di ricaricare","lang_sources_refreshed":"Fonti aggiornate","lang_reload_list":"Ricarica l\'elenco","lang_streamerror":"Nessun elemento caricato, ricaricare?","lang_error":"Si \xe8 verificato un errore","lang_source_refresh":"Aggiorna questa fonte","lang_source_last_post":"Ultimo elemento visto","lang_source_saved":"Salvato","lang_source_pwd_placeholder":"Non cambiato","lang_source_autotitle_hint":"Lascia vuoto per recuperare il titolo","lang_source_filter":"Filtro","lang_loginbutton":"Accedi","lang_logoutbutton":"Esci","lang_settingsbutton":"Impostazioni","lang_refreshbutton":"Aggiorna le fonti","lang_searchremove":"Nascondi la ricerca","lang_search_label":"Termine di ricerca","lang_share_copy_label":"Copia il collegamento negli appunti","lang_share_wordpress_label":"Condividi su WordPress","lang_share_wallabag_label":"Salva in Wallabag","lang_share_pocket_label":"Salva in Pocket","lang_share_facebook_label":"Condividi su Facebook","lang_share_twitter_label":"Condividi su Twitter","lang_share_diaspora_label":"Condividi su Diaspora","lang_share_native_label":"Condividi","lang_next":"Avanti","lang_hours":"{0,plural,one {1 ora},other {# ore}} fa","lang_offline_count":"Elementi disponibili localmente","lang_online_count":"Articoli disponibili sul server","lang_filter":"Filtra","lang_share_mail_label":"Condividi via posta elettronica","lang_login_offline":"Archiviazione offline","lang_login_invalid_credentials":"Nome utente o password errato","lang_error_offline_storage_not_available":"Non \xe8 disponibile memoria offline. Assicurati che il tuo browser web {0} supporti IdexedDB API {1} e che tu non stia utilizzando la modalit\xe0 incognito su browser basati su Google Chrome.","lang_error_edit_source":"Impossibile salvare le modifiche alla fonte:","lang_error_unwritable_logs":"Impossibile scrivere i log.","lang_error_check_system_logs":"Si \xe8 verificato un errore, controlla i tuoi log di sistema.","lang_error_check_log_file":"Si \xe8 verificato un errore, controlla il file di log \xab{0}\xbb.","lang_offline_navigation_unavailable":"Al momento non \xe8 possibile modificare etichette e fonti nella modalit\xe0 fuori linea.","lang_article_reading_time":"{0} min letti","lang_experimental":"Sperimentale","lang_source_go_to_settings":"Apri nelle impostazioni","lang_sources_loading":"Caricamento delle fonti\u2026","lang_source_deleting":"Eliminazione della fonte\u2026","lang_source_browse":"Sfoglia","lang_source_params_loading":"Caricamento dei parametri\u2026","lang_no_sources":"Nessuna fonte configurata.","lang_source_warn_cancel_dirty":"Scartare le modifiche non salvate?","lang_source_menu":"Pi\xf9 azioni","lang_sources_leaving_unsaved_prompt":"Esci dalle impostazioni con delle modifiche della fonte non salvate?","lang_tag_change_color_button_title":"Cambia il colore","lang_entries_loading":"Caricamento delle pubblicazioni\u2026","lang_source_saving":"Salvataggio delle modifiche alla fonte\u2026","lang_error_unauthorized":"Per favore {link_begin} connettiti{link_end} per continuare.","lang_login_in_progress":"Tentativo di connessione\u2026","lang_login_error_generic":"Connessione impossibile: {errorMessage}"}');


var $f0732a5d7f7054ed$exports = {};
$f0732a5d7f7054ed$exports = JSON.parse('{"lang_markread":"\u65E2\u8AAD\u306B\u3059\u308B","lang_filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","lang_newest":"\u65B0\u7740","lang_unread":"\u672A\u8AAD","lang_starred":"\u30B9\u30BF\u30FC","lang_tags":"\u30BF\u30B0","lang_alltags":"\u5168\u3066\u306E\u30BF\u30B0","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u6642\u9593},other {# \u6642\u9593}}\u524D","lang_minutes":"{0,plural,one {1 \u5206},other {# \u5206}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u65E5},one {\u6628\u65E5},other {# \u65E5\u524D}}","lang_star":"\u30B9\u30BF\u30FC\u3092\u3064\u3051\u308B","lang_unstar":"\u30B9\u30BF\u30FC\u3092\u5916\u3059","lang_mark":"\u65E2\u8AAD\u306B\u3059\u308B","lang_unmark":"\u672A\u8AAD\u306B\u3059\u308B","lang_load_img":"\u753B\u50CF\u3092\u8868\u793A","lang_open_window":"\u958B\u304F","lang_next":"\u6B21\u3078","lang_searchbutton":"\u691C\u7D22","lang_searchremove":"\u691C\u7D22\u3092\u975E\u8868\u793A","lang_refreshbutton":"\u30BD\u30FC\u30B9\u306E\u66F4\u65B0","lang_settingsbutton":"\u8A2D\u5B9A","lang_logoutbutton":"\u30ED\u30B0\u30A2\u30A6\u30C8","lang_loginbutton":"\u30ED\u30B0\u30A4\u30F3","lang_sources":"\u30BD\u30FC\u30B9","lang_source_add":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0","lang_source_opml":"\u307E\u305F\u306F OPML \u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8","lang_source_export":"\u30BD\u30FC\u30B9\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8","lang_source_edit":"\u7DE8\u96C6","lang_source_filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","lang_source_delete":"\u524A\u9664","lang_source_warn":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","lang_source_new":"\u65B0\u3057\u3044\u672A\u4FDD\u5B58\u306E\u30BD\u30FC\u30B9","lang_source_title":"\u30BF\u30A4\u30C8\u30EB","lang_source_tags":"\u30BF\u30B0","lang_source_pwd_placeholder":"\u5909\u66F4\u3055\u308C\u3066\u3044\u307E\u305B\u3093","lang_source_comma":"\u30AB\u30F3\u30DE(,)\u533A\u5207\u308A","lang_source_select":"\u30BD\u30FC\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","lang_source_type":"\u30BF\u30A4\u30D7","lang_source_save":"\u4FDD\u5B58","lang_source_cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","lang_source_saved":"\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","lang_source_last_post":"\u6700\u7D42\u53C2\u7167\u65E5","lang_source_refresh":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u66F4\u65B0","lang_no_entries":"\u8A18\u4E8B\u304C\u3042\u308A\u307E\u305B\u3093","lang_more":"\u3082\u3063\u3068\u898B\u308B","lang_login":"\u30ED\u30B0\u30A4\u30F3","lang_login_username":"\u30E6\u30FC\u30B6\u30FC\u540D","lang_login_password":"\u30D1\u30B9\u30EF\u30FC\u30C9","lang_no_title":"\u30BF\u30A4\u30C8\u30EB\u306A\u3057","lang_error":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","lang_streamerror":"\u8A18\u4E8B\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u307E\u3059\u304B\uFF1F","lang_source_autotitle_hint":"\u7A7A\u306E\u307E\u307E\u306B\u3059\u308B\u3068\u30BF\u30A4\u30C8\u30EB\u3092\u53D6\u5F97\u3057\u307E\u3059","lang_login_invalid_credentials":"\u30E6\u30FC\u30B6\u30FC\u540D/\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059","lang_reload_list":"\u4E00\u89A7\u3092\u518D\u8AAD\u307F\u8FBC\u307F","lang_sources_refreshed":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3057\u307E\u3057\u305F","lang_error_session_expired":"\u30BB\u30C3\u30B7\u30E7\u30F3\u304C\u671F\u9650\u5207\u308C\u3067\u3059","lang_error_add_source":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093:","lang_error_delete_source":"\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_load_tags":"\u30BF\u30B0\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","lang_error_unknown_tag":"\u4E0D\u660E\u306A\u30BF\u30B0:","lang_error_unknown_source":"\u4E0D\u660E\u306A\u30BD\u30FC\u30B9ID:","lang_error_mark_items":"\u3059\u3079\u3066\u306E\u8868\u793A\u9805\u76EE\u3092\u30DE\u30FC\u30AF\u3067\u304D\u307E\u305B\u3093:","lang_error_mark_item":"\u9805\u76EE\u3092\u30DE\u30FC\u30AF/\u30DE\u30FC\u30AF\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_star_item":"\u9805\u76EE\u3092\u30B9\u30BF\u30FC/\u30B9\u30BF\u30FC\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_logout":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3067\u304D\u307E\u305B\u3093:","lang_error_loading":"\u8AAD\u307F\u8FBC\u307F\u30A8\u30E9\u30FC:","lang_error_loading_stats":"NAV\u7D71\u8A08\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","lang_error_saving_color":"\u65B0\u3057\u3044\u8272\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093:","lang_error_refreshing_source":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093:","lang_error_sync":"\u30B5\u30FC\u30D0\u304B\u3089\u6700\u5F8C\u306E\u5909\u66F4\u3092\u540C\u671F\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F:","lang_error_invalid_subsection":"\u4E0D\u6B63\u306A\u30B5\u30D6\u30BB\u30AF\u30B7\u30E7\u30F3:","lang_online_count":"\u30B5\u30FC\u30D0\u30FC\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","lang_offline_count":"\u30ED\u30FC\u30AB\u30EB\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","lang_login_offline":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8","lang_app_update":"selfoss \u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304F\u3060\u3055\u3044","lang_app_reload":"\u518D\u8AAD\u307F\u8FBC\u307F","lang_error_offline_storage":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8 \u30A8\u30E9\u30FC: {0}\u3002 \u518D\u8AAD\u307F\u8FBC\u307F\u304C\u5F79\u7ACB\u3064\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u4ECA\u306E\u3068\u3053\u308D\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u3092\u7121\u52B9\u306B\u3057\u307E\u3059\u3002","lang_search_label":"\u691C\u7D22\u6761\u4EF6","lang_article_actions":"\u30A2\u30AF\u30B7\u30E7\u30F3","lang_error_configuration":"\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3002","lang_info_url_copied":"URL\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002","lang_article_reading_time":"{0} \u5206 \u8AAD\u307F\u307E\u3057\u305F","lang_source_menu":"\u305D\u306E\u4ED6\u306E\u30A2\u30AF\u30B7\u30E7\u30F3","lang_source_browse":"\u691C\u7D22","lang_source_warn_cancel_dirty":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u3092\u7834\u68C4\u3057\u307E\u3059\u304B\uFF1F","lang_sources_leaving_unsaved_prompt":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u305B\u305A\u306B\u8A2D\u5B9A\u3092\u6B8B\u3057\u307E\u3059\u304B\uFF1F","lang_experimental":"\u8A66\u9A13\u7684","lang_error_check_system_logs":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30B7\u30B9\u30C6\u30E0\u30ED\u30B0\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_error_edit_source":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A","lang_error_share_native":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002","lang_error_share_native_abort":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u2014\u5171\u6709\u5148\u304C\u306A\u3044\u304B\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F\u3002","lang_share_pocket_label":"Pocket \u306B\u4FDD\u5B58","lang_share_twitter_label":"Twitter \u3067\u30B7\u30A7\u30A2","lang_close_entry":"\u9589\u3058\u308B","lang_share_facebook_label":"Facebook \u3067\u30B7\u30A7\u30A2","lang_offline_navigation_unavailable":"\u73FE\u5728\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u30E2\u30FC\u30C9\u3067\u306F\u30BF\u30B0\u3068\u30BD\u30FC\u30B9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u307E\u305B\u3093\u3002","lang_share_diaspora_label":"Diaspora \u3067\u30B7\u30A7\u30A2","lang_share_wallabag_label":"Wallabag \u306B\u4FDD\u5B58","lang_share_copy_label":"\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC","lang_error_check_log_file":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30ED\u30B0\u30D5\u30A1\u30A4\u30EB\u300C{0}\u300D\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_error_unwritable_logs":"\u30ED\u30B0\u3092\u66F8\u304D\u8FBC\u3081\u307E\u305B\u3093\u3002","lang_share_mail_label":"\u30E1\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u5171\u6709","lang_share_native_label":"\u5171\u6709","lang_share_wordpress_label":"WordPress \u3067\u30B7\u30A7\u30A2","lang_error_offline_storage_not_available":"\u30AA\u30D5\u30E9\u30A4\u30F3\u30B9\u30C8\u30EC\u30FC\u30B8\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002 Web\u30D6\u30E9\u30A6\u30B6 {0} \u304CIndexedDBAPI {1} \u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u308B\u3053\u3068\u3001\u304A\u3088\u3073 Google Chrome \u30D9\u30FC\u30B9\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u30E2\u30FC\u30C9\u3067 selfoss \u3092\u5B9F\u884C\u3057\u3066\u3044\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_share_mastodon_label":"Mastodon \u3067\u30B7\u30A7\u30A2"}');


var $5170287447d26972$exports = {};
$5170287447d26972$exports = JSON.parse('{"lang_markread":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","lang_filter":"filtrs","lang_newest":"jaun\u0101kais","lang_unread":"neizlas\u012Bts","lang_starred":"ar zvaigzn\u012Bt\u0113m","lang_tags":"Birkas","lang_alltags":"visas birkas","lang_timestamp":"{0,date} {0,time}","lang_hours":"pirms {0,plural,one {1 stundas},other {# stund\u0101m}}","lang_minutes":"pirms {0,plural,one {1 min\u016Btes},other {# min\u016Bt\u0113m}}","lang_seconds":"pirms {0,plural,one {1 sekundes},other {# sekund\u0113m}}","lang_days":"{0,plural,zero {\u0161odien},one {vakardien},other {pirms # dien\u0101m}}","lang_star":"pievienot zvaigzn\u012Bti","lang_unstar":"no\u0146emt zvaigzn\u012Bti","lang_mark":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","lang_unmark":"atz\u012Bm\u0113t k\u0101 neizlas\u012Btu","lang_load_img":"iel\u0101d\u0113t bildes","lang_open_window":"atv\u0113rt","lang_next":"n\u0101kamais","lang_searchbutton":"mekl\u0113t","lang_searchremove":"sl\u0113pt mekl\u0113\u0161anu","lang_refreshbutton":"atsvaidzin\u0101t avotus","lang_settingsbutton":"iestat\u012Bjumi","lang_logoutbutton":"iziet","lang_loginbutton":"ieiet","lang_sources":"Avoti","lang_source_add":"pievienot avotu","lang_source_opml":"vai import\u0113t opml failu, vai google las\u012Bt\u0101ju","lang_source_export":"eksport\u0113t avotus","lang_source_edit":"labot","lang_source_filter":"Filtrs","lang_source_delete":"dz\u0113st","lang_source_warn":"Vai tie\u0161\u0101m v\u0113laties dz\u0113st \u0161o avotu?","lang_source_new":"nesaglab\u0101ts avots","lang_source_title":"Nosaukums","lang_source_tags":"Birkas","lang_source_pwd_placeholder":"nav main\u012Bjies","lang_source_comma":"atdal\u012Bt ar komatu","lang_source_select":"l\u016Bdzu izv\u0113lieties avotu","lang_source_type":"Tips","lang_source_save":"saglab\u0101t","lang_source_cancel":"atcelt","lang_source_saved":"saglab\u0101ts","lang_source_last_post":"P\u0113d\u0113j\u0101 zi\u0146a redz\u0113ta","lang_no_entries":"nav ierakstu","lang_more":"v\u0113l","lang_login":"ien\u0101kt","lang_login_username":"Lietot\u0101jv\u0101rds","lang_login_password":"Parole","lang_no_title":"nav nosaukuma","lang_error":"k\u013C\u016Bda","lang_streamerror":"Zi\u0146as nav iel\u0101d\u0113tas, p\u0101rl\u0101d\u0113t?"}');


var $7058dfe60927e7af$exports = {};
$7058dfe60927e7af$exports = JSON.parse('{"lang_markread":"Marker som lest","lang_newest":"Nyeste","lang_unread":"Ulest","lang_starred":"Stjernemerket","lang_tags":"Etiketter","lang_alltags":"Alle etiketter","lang_timestamp":"{0,date} {0,time}","lang_hours":"for {0,plural,one {\xe9n time},other {# timer}} ago","lang_minutes":"for {0,plural,one {ett minutt},other {# minutter}} ago","lang_seconds":"for {0,plural,one {ett sekund},other {# sekunder}} siden","lang_star":"Stjernemerk","lang_unstar":"Fjern stjerne","lang_mark":"Marker som lest","lang_unmark":"Marker som ulest","lang_load_img":"Vis bilder","lang_open_window":"\xc5pne","lang_searchbutton":"S\xf8k","lang_sources":"Kilder","lang_source_add":"Legg til kilde","lang_source_opml":"eller importer en OPML-fil","lang_source_export":"Eksporter kilder","lang_source_edit":"Endre","lang_source_delete":"Slett","lang_source_warn":"Vil du virkelig fjerne denne kilden?","lang_source_new":"Ny ulagret kilde","lang_source_title":"Tittel","lang_source_tags":"Etiketter","lang_source_comma":"Kommainndelt","lang_source_select":"Velg kilde","lang_source_type":"Type","lang_source_save":"Lagre","lang_source_cancel":"Avbryt","lang_source_saved":"Lagret","lang_no_entries":"Ingen data funnet","lang_more":"Mer","lang_login":"Logg inn","lang_login_username":"Brukernavn","lang_login_password":"Passord","lang_filter":"Filtrer","lang_days":"{0,plural,zero {i dag},one {i g\xe5r},other {# dager siden}}","lang_next":"Neste","lang_searchremove":"Skjul s\xf8k","lang_refreshbutton":"Gjenoppfrisk kilder","lang_settingsbutton":"Innstillinger","lang_logoutbutton":"Logg ut","lang_loginbutton":"Logg inn","lang_source_filter":"Filter","lang_source_autotitle_hint":"La st\xe5 tom for \xe5 hente tittel","lang_source_pwd_placeholder":"Ikke endret","lang_source_last_post":"Siste post sett","lang_source_refresh":"Gjenoppfrisk denne kilden","lang_login_invalid_credentials":"Feil brukernavn/passord","lang_no_title":"Ingen tittel","lang_error":"En feil inntraff","lang_streamerror":"Ingen elementer ble lastet inn, gjeninnlast?","lang_reload_list":"Gjeninnlast liste","lang_sources_refreshed":"Kilder gjeninnlastet","lang_error_session_expired":"\xd8kt utl\xf8pt","lang_error_add_source":"Kunne ikke legge til kilde:","lang_error_delete_source":"Kunne ikke slette kilde:","lang_error_load_tags":"Kunne ikke laste inn etiketter:","lang_error_unknown_tag":"Ukjent etikett:","lang_error_unknown_source":"Ukjent kilde-ID:","lang_error_mark_items":"Kan ikke merke alle synlige elementer:","lang_error_mark_item":"Kan ikke merke/oppheve merking av element:","lang_error_star_item":"Kan ikke stjernemerke/oppheve stjernemerking av element:","lang_error_logout":"Kunne ikke logge ut:","lang_error_loading":"Innlastingsfeil:","lang_error_loading_stats":"Kan ikke laste navigeringsstatistikk:","lang_error_saving_color":"Kan ikke lagre ny farge:","lang_error_refreshing_source":"Kan ikke gjenoppfriske kilder:","lang_error_sync":"Kunne ikke synkronisere siste endringer fra tjener:","lang_error_invalid_subsection":"Ugyldig underdel:","lang_online_count":"Elementer tilgjengelige p\xe5 tjeneren","lang_offline_count":"Elementer tilgjengelige lokalt","lang_login_offline":"Frakoblet lagring","lang_app_update":"selfoss har blitt oppdatert, last inn p\xe5 ny","lang_app_reload":"Gjeninnlast","lang_error_offline_storage":"Lagringsfeil for frakoblet lagring: {0}. Gjeninnlasting kan hjelpe. Skrur av frakoblet imens.","lang_search_label":"S\xf8ketekst","lang_article_actions":"Handlinger","lang_error_configuration":"Kunne ikke laste inn oppsett.","lang_info_url_copied":"Nettadresse kopiert til utklippstavle.","lang_share_native_label":"Del","lang_share_diaspora_label":"Del p\xe5 Diaspora","lang_share_twitter_label":"Del p\xe5 Twitter","lang_share_facebook_label":"Del p\xe5 Facebook","lang_share_pocket_label":"Del til Pocket","lang_share_wallabag_label":"Lagre p\xe5 Wallabag","lang_share_wordpress_label":"Lagre p\xe5 WordPress","lang_share_mail_label":"Del ved bruk av e-post","lang_share_copy_label":"Kopier lenke til utklippstavle","lang_error_share_native_abort":"Kunne ikke dele element, enten finnes det ingen delingsm\xe5l, eller du har avbrutt deling.","lang_error_share_native":"Kunne ikke dele element.","lang_close_entry":"Lukk","lang_error_unwritable_logs":"Kunne ikke loggf\xf8re.","lang_error_check_log_file":"En feil inntraff, sjekk loggfilen \u201C{0}\u201D.","lang_error_check_system_logs":"En feil inntraff, sjekk systemloggene dine.","lang_offline_navigation_unavailable":"\xc5 bytte etiketter og kilder st\xf8ttes forel\xf8pig ikke i frakoblet modus.","lang_error_offline_storage_not_available":"Frakoblet lager ikke tilgjengelig. S\xf8rg for at din nettleser {0}st\xf8tter IndexedDB-API-et{1}, samt at du ikke bruker incognito-modus i en Chrome-basert nettleser.","lang_error_edit_source":"Kunne ikke lagre kildeendringer:","lang_article_reading_time":"{0} min \xe5 lese","lang_experimental":"Eksperimentell","lang_sources_leaving_unsaved_prompt":"Forlat innstillinger med ulagrede kildeendringer?","lang_source_warn_cancel_dirty":"Forkast ulagrede endringer?"}');


var $51d8b37b1373d182$exports = {};
$51d8b37b1373d182$exports = JSON.parse('{"lang_markread":"markeer gelezen","lang_newest":"nieuwste","lang_unread":"ongelezen","lang_starred":"met ster","lang_tags":"Tags","lang_alltags":"alle tags","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 hour},other {# uren}} geleden","lang_minutes":"{0,plural,one {1 minute},other {# minuten}} geleden","lang_seconds":"{0,plural,one {1 second},other {# seconden}} geleden","lang_days":"{0,plural,zero {vandaag},one {gisteren},other {# dagen geleden}}","lang_star":"ster","lang_unstar":"ster verwijderen","lang_mark":"gelezen","lang_unmark":"ongelezen","lang_load_img":"afbeeldingen tonen","lang_open_window":"open","lang_searchbutton":"zoeken","lang_sources":"Bron","lang_source_add":"bron toevoegen","lang_source_opml":"of importeer opml bestand of google reader","lang_source_export":"exporteer bronnen","lang_source_edit":"wijzig","lang_source_delete":"verwijder","lang_source_warn":"bron echt verwijderen?","lang_source_new":"nieuwe bron","lang_source_title":"Titel","lang_source_tags":"Tags","lang_source_comma":"komma gescheiden","lang_source_select":"selecteer een bron","lang_source_type":"Soort","lang_source_save":"opslaan","lang_source_cancel":"annuleren","lang_source_saved":"opgeslagen","lang_source_last_post":"Meest recente artikel is gevonden","lang_no_entries":"geen items gevonden","lang_more":"meer","lang_login":"inloggen","lang_login_username":"gebruikersnaam","lang_login_password":"wachtwoord","lang_no_title":"geen titel"}');


var $3d25a85d30cd5367$exports = {};
$3d25a85d30cd5367$exports = JSON.parse('{"lang_markread":"oznacz jako przeczytane","lang_filter":"filtr","lang_newest":"najnowsze","lang_unread":"nieprzeczytane","lang_starred":"z gwiazdk\u0105","lang_tags":"Tagi","lang_alltags":"wszystkie","lang_timestamp":"{0,date} {0,time}","lang_hours":"przed {0,plural,one {godzin\u0105},other {# godzinami}}","lang_minutes":"przed {0,plural,one {minut\u0105},other {# minutami}}","lang_seconds":"przed {0,plural,one {chwil\u0105},other {# sekundami}}","lang_days":"{0,plural,zero {dzisiaj},one {wczoraj},other {przejrzany # dni temu}}","lang_star":"oznacz gwiazdk\u0105","lang_unstar":"usu\u0144 gwiazdk\u0119","lang_mark":"oznacz jako przeczytane","lang_unmark":"oznacz jako nieprzeczytane","lang_load_img":"pobierz obrazy","lang_open_window":"otw\xf3rz","lang_next":"nast\u0119pny","lang_searchbutton":"szukaj","lang_searchremove":"ukryj wyszukiwanie","lang_refreshbutton":"od\u015Bwie\u017C","lang_settingsbutton":"opcje","lang_logoutbutton":"wyloguj","lang_loginbutton":"zaloguj","lang_sources":"\u0179r\xf3d\u0142a","lang_source_add":"dodaj \u017Ar\xf3d\u0142o","lang_source_opml":"lub zaimportuj plik OPML z Google Reader","lang_source_export":"eksportuj \u017Ar\xf3d\u0142a","lang_source_edit":"edytuj","lang_source_filter":"Filtr","lang_source_delete":"usu\u0144","lang_source_warn":"Czy na pewno chcesz usun\u0105\u0107 to \u017Ar\xf3d\u0142o?","lang_source_new":"nowe niezapisane \u017Ar\xf3d\u0142o","lang_source_title":"Tytu\u0142","lang_source_autotitle_hint":"Pozostaw puste, aby uzupe\u0142ni\u0107 automatycznie","lang_source_tags":"Tagi","lang_source_pwd_placeholder":"bez zmian","lang_source_comma":"rozdzielone przecinkami","lang_source_select":"prosz\u0119 wybra\u0107 typ \u017Ar\xf3d\u0142a","lang_source_type":"Typ","lang_source_save":"zapisz","lang_source_cancel":"anuluj","lang_source_saved":"zapisano","lang_source_last_post":"Ostatni artyku\u0142 zosta\u0142 przejrzany ","lang_source_refresh":"Od\u015Bwie\u017C to \u017Ar\xf3d\u0142o","lang_no_entries":"brak wpis\xf3w","lang_more":"wi\u0119cej","lang_login":"zaloguj","lang_login_username":"u\u017Cytkownik","lang_login_password":"has\u0142o","lang_login_invalid_credentials":"nieprawid\u0142owy login lub has\u0142o.","lang_no_title":"bez tytu\u0142u","lang_error":"wyst\u0105pi\u0142 b\u0142\u0105d","lang_streamerror":"Nie za\u0142adowano \u017Cadnych element\xf3w, od\u015Bwie\u017Cy\u0107?","lang_error_loading":"B\u0142\u0105d podczas \u0142adowania:","lang_experimental":"Eksperymentalny","lang_article_actions":"Dzia\u0142ania","lang_share_native_label":"Udost\u0119pnij","lang_source_browse":"Przegl\u0105daj","lang_app_reload":"Za\u0142aduj ponownie","lang_error_session_expired":"Sesja wygas\u0142a","lang_close_entry":"Zamknij","lang_sources_refreshed":"Od\u015Bwie\u017Cono \u017Ar\xf3d\u0142a","lang_error_unknown_tag":"Nieznany tag:"}');


var $b01b1dfd07b9091e$exports = {};
$b01b1dfd07b9091e$exports = JSON.parse('{"lang_share_mail_label":"Compartilhar usando correio eletr\xf4nico","lang_error":"um erro ocorreu","lang_no_title":"sem t\xedtulo","lang_login_password":"palavra-passe","lang_login_username":"utilizador","lang_login":"entrar","lang_more":"mais","lang_no_entries":"nenhum registo encontrado","lang_source_saved":"gravado","lang_source_cancel":"cancelar","lang_source_save":"gravar","lang_source_type":"Tipo","lang_source_select":"por favor, selecione a fonte","lang_source_comma":"separado por v\xedrgula","lang_source_tags":"Marcadores","lang_source_title":"T\xedtulo","lang_source_new":"nova fonte (n\xe3o salva)","lang_source_warn":"realmente deletar esta fonte?","lang_source_delete":"deletar","lang_source_filter":"Filtro","lang_source_edit":"editar","lang_source_export":"exportar fontes","lang_source_opml":"ou importar ficheiro opml ou google reader","lang_source_add":"adicionar fonte","lang_sources":"Fontes","lang_loginbutton":"entrar","lang_logoutbutton":"sair","lang_settingsbutton":"configura\xe7\xf5es","lang_refreshbutton":"atualizar fontes","lang_searchbutton":"procurar","lang_next":"pr\xf3ximo","lang_open_window":"abrir","lang_load_img":"carregar Imagens","lang_unmark":"marcar como n\xe3o lido","lang_mark":"marcar como lido","lang_unstar":"remover estrela","lang_star":"marcar com estrela","lang_seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","lang_minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","lang_hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","lang_timestamp":"{0,date} {0,time}","lang_alltags":"todos os marcadores","lang_tags":"Marcadores","lang_starred":"com estrela","lang_unread":"n\xe3o lidos","lang_newest":"novos","lang_markread":"marcar como lido","lang_source_last_post":"\xdaltima postagem vista","lang_source_menu":"Mais a\xe7\xf5es","lang_offline_navigation_unavailable":"A troca de etiquetas e fontes n\xe3o est\xe1 atualmente dispon\xedvel em modo offline.","lang_offline_count":"Artigos dispon\xedveis localmente","lang_searchremove":"Ocultar busca","lang_share_diaspora_label":"Compartilhar na Di\xe1spora","lang_share_facebook_label":"Compartilhar no Facebook","lang_share_pocket_label":"Salvar no Pocket","lang_share_wallabag_label":"Salvar no Wallabag","lang_share_copy_label":"Copiar link para a \xe1rea de transfer\xeancia","lang_source_refresh":"Atualizar esta fonte","lang_share_native_label":"Compartilhar","lang_search_label":"Termo de pesquisa","lang_sources_leaving_unsaved_prompt":"Deixar configura\xe7\xf5es com altera\xe7\xf5es de fonte n\xe3o salvas?","lang_online_count":"Itens dispon\xedveis no servidor","lang_share_wordpress_label":"Compartilhar no WordPress","lang_source_autotitle_hint":"Deixe vazio para buscar t\xedtulo","lang_source_browse":"Navegar","lang_source_warn_cancel_dirty":"Descartar altera\xe7\xf5es n\xe3o salvas?","lang_filter":"Filtro","lang_share_twitter_label":"Compartilhe no Twitter","lang_tag_change_color_button_title":"Alterar a cor","lang_sources_loading":"Carregando fontes\u2026","lang_no_sources":"Nenhuma fonte configurada.","lang_source_deleting":"Excluindo fonte\u2026","lang_source_pwd_placeholder":"N\xe3o alterado","lang_source_params_loading":"Carregando par\xe2metros\u2026","lang_source_saving":"Salvar mudan\xe7as de fonte\u2026","lang_source_go_to_settings":"Abrir nas configura\xe7\xf5es","lang_entries_loading":"Carregando entradas\u2026","lang_login_in_progress":"Tentando fazer login\u2026"}');


var $f7917dde3df00ba4$exports = {};
$f7917dde3df00ba4$exports = JSON.parse('{"lang_markread":"marcar como lido","lang_newest":"novos","lang_unread":"n\xe3o lidos","lang_starred":"com estrela","lang_tags":"Marcadores","lang_alltags":"todos os marcadores","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","lang_minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","lang_seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","lang_star":"marcar com estrela","lang_unstar":"remover estrela","lang_mark":"marcar como lido","lang_unmark":"marcar como n\xe3o lido","lang_load_img":"carregar Imagens","lang_open_window":"abrir","lang_next":"pr\xf3ximo","lang_searchbutton":"procurar","lang_refreshbutton":"atualizar fontes","lang_settingsbutton":"configura\xe7\xf5es","lang_logoutbutton":"sair","lang_loginbutton":"entrar","lang_sources":"Fontes","lang_source_add":"adicionar fonte","lang_source_opml":"ou importar arquivo opml ou google reader","lang_source_export":"exportar fontes","lang_source_edit":"editar","lang_source_filter":"Filtro","lang_source_delete":"deletar","lang_source_warn":"realmente deletar esta fonte?","lang_source_new":"nova fonte (n\xe3o salva)","lang_source_title":"T\xedtulo","lang_source_tags":"Marcadores","lang_source_comma":"separado por v\xedrgula","lang_source_select":"por favor, selecione a fonte","lang_source_type":"Tipo","lang_source_save":"salvar","lang_source_cancel":"cancelar","lang_source_saved":"salvo","lang_no_entries":"nenhum registro encontrado","lang_more":"mais","lang_login":"entrar","lang_login_username":"usu\xe1rio","lang_login_password":"senha","lang_no_title":"sem t\xedtulo","lang_error":"um erro ocorreu","lang_share_mail_label":"Compartilhar usando correio eletr\xf4nico"}');


var $3e02282570dcf5ad$exports = {};
$3e02282570dcf5ad$exports = JSON.parse('{"lang_markread":"marcar sco leg\xec","lang_newest":"pli novas","lang_unread":"nunleg\xec","lang_starred":"cun staila","lang_tags":"Etichettas","lang_alltags":"tut las etichettas","lang_timestamp":"{0,date} {0,time}","lang_hours":"Avant {0,plural,one {1 ura},other {# uras}}","lang_minutes":"Avant {0,plural,one {1 minuta},other {# minutas}}","lang_seconds":"Avant {0,plural,one {1 secunda},other {# secundas}}","lang_star":"agiuntar staila","lang_unstar":"allontanar staila","lang_mark":"marcar sco leg\xec","lang_unmark":"marcar sco nunleg\xec","lang_load_img":"chargiar maletgs","lang_open_window":"avrir","lang_searchbutton":"tschertgar","lang_sources":"Funtaunas","lang_source_add":"agiuntar funtauna","lang_source_opml":"u importar ina datoteca opml u da google reader","lang_source_export":"exportar las funtaunas","lang_source_edit":"modifitgar","lang_source_delete":"stizzar","lang_source_warn":"propi stizzar questa funtauna?","lang_source_new":"nova funtauna betg memorisada","lang_source_title":"Titel","lang_source_tags":"Etichettas","lang_source_comma":"seper\xe0 entras commas","lang_source_select":"tscherna p.pl. la funtauna","lang_source_type":"Tip","lang_source_save":"memorisar","lang_source_cancel":"interrumper","lang_source_saved":"memoris\xe0","lang_no_entries":"chatt\xe0 naginas endataziuns","lang_more":"dapli","lang_login":"s\'annunziar","lang_login_username":"num d\'utilisader","lang_login_password":"pled-clav","lang_no_title":"nagin titel"}');


var $ee2b610e60c3d44b$exports = {};
$ee2b610e60c3d44b$exports = JSON.parse('{"lang_markread":"\u043F\u043E\u043C\u0435\u0442\u0438\u0442\u044C \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","lang_newest":"\u0441\u0432\u0435\u0436\u0438\u0435","lang_unread":"\u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","lang_starred":"\u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435","lang_tags":"\u041C\u0435\u0442\u043A\u0438","lang_alltags":"\u0432\u0441\u0435 \u043C\u0435\u0442\u043A\u0438","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u0447\u0430\u0441},other {# \u0447\u0430\u0441\u043E\u0432}} \u043D\u0430\u0437\u0430\u0434","lang_minutes":"{0,plural,one {1 \u043C\u0438\u043D\u0443\u0442\u0443},other {# \u043C\u0438\u043D\u0443\u0442}} \u043D\u0430\u0437\u0430\u0434","lang_seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434}} \u043D\u0430\u0437\u0430\u0434","lang_star":"\u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C","lang_unstar":"\u0441\u043D\u044F\u0442\u044C \u043E\u0442\u043C\u0435\u0442\u043A\u0443","lang_mark":"\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","lang_unmark":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","lang_load_img":"\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F","lang_open_window":"\u043E\u0442\u043A\u0440\u044B\u0442\u044C","lang_searchbutton":"\u041F\u043E\u0438\u0441\u043A","lang_sources":"\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438","lang_source_add":"\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","lang_source_opml":"\u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u0430\u0439\u043B OPML, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0438\u0437 Google Reader","lang_source_export":"\u044D\u043A\u0441\u043F\u043E\u0440\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432","lang_source_edit":"\u043F\u0440\u0430\u0432\u0438\u0442\u044C","lang_source_delete":"\u0443\u0434\u0430\u043B\u0438\u0442\u044C","lang_source_warn":"\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A?","lang_source_new":"\u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","lang_source_title":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435","lang_source_tags":"\u041C\u0435\u0442\u043A\u0438","lang_source_comma":"\u0440\u0430\u0434\u0435\u043B\u044F\u0439\u0442\u0435 \u0437\u0430\u043F\u044F\u0442\u043E\u0439","lang_source_select":"\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430","lang_source_type":"\u0422\u0438\u043F","lang_source_save":"\u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C","lang_source_cancel":"\u043E\u0442\u043C\u0435\u043D\u0430","lang_source_saved":"\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E","lang_no_entries":"\u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","lang_more":"\u0435\u0449\u0435","lang_login":"\u0432\u0445\u043E\u0434","lang_login_username":"\u0438\u043C\u044F","lang_login_password":"\u043F\u0430\u0440\u043E\u043B\u044C","lang_no_title":"\u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F","lang_searchremove":"\u0421\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0438\u0441\u043A"}');


var $430ac65b39f56697$exports = {};
$430ac65b39f56697$exports = JSON.parse('{"lang_markread":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","lang_filter":"Zobrazova\u0165","lang_newest":"najnov\u0161ie","lang_unread":"nepre\u010D\xedtan\xe9","lang_starred":"ozna\u010Den\xe9","lang_tags":"Tagy","lang_alltags":"v\u0161etky tagy","lang_timestamp":"{0,date} {0,time}","lang_hours":"pred {0,plural,one {1 hodinou},other {# hodinami}}","lang_minutes":"pred {0,plural,one {1 min\xfatou},other {# min\xfatami}}","lang_seconds":"pred {0,plural,one {chv\xed\u013Eou},other {# sekundami}}","lang_star":"ozna\u010Di\u0165","lang_unstar":"odzna\u010Di\u0165","lang_mark":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","lang_unmark":"ozna\u010Di\u0165 ako nepr\u010D\xedtan\xe9","lang_load_img":"nahra\u0165 obr\xe1zky","lang_open_window":"otvori\u0165","lang_next":"\u010Fal\u0161ie","lang_searchbutton":"vyh\u013Eada\u0165","lang_searchremove":"skry\u0165 vyh\u013Ead\xe1vanie","lang_refreshbutton":"obnovi\u0165 zdroje","lang_settingsbutton":"nastavenia","lang_logoutbutton":"odhl\xe1si\u0165 sa","lang_loginbutton":"prihl\xe1si\u0165 sa","lang_sources":"Zdroje","lang_source_add":"prida\u0165 zdroj","lang_source_opml":"alebo nahra\u0165 opml s\xfabor","lang_source_export":"export zdrojov","lang_source_edit":"upravi\u0165","lang_source_filter":"Filter","lang_source_delete":"zmaza\u0165","lang_source_warn":"Naozaj chcete tento zdroj zmaza\u0165?","lang_source_new":"nov\xfd neulo\u017Een\xfd zdroj","lang_source_title":"N\xe1zov","lang_source_tags":"Tagy","lang_source_comma":"oddelen\xe9 \u010Diarkou","lang_source_select":"vyberte pros\xedm zdroj","lang_source_type":"Typ","lang_source_save":"ulo\u017Ei\u0165","lang_source_cancel":"zru\u0161i\u0165","lang_source_saved":"ulo\u017Een\xe9","lang_no_entries":"\u017Eiadny z\xe1znam","lang_more":"v\xedac","lang_login":"prihl\xe1si\u0165","lang_login_username":"meno","lang_login_password":"heslo","lang_no_title":"Bez titulku","lang_error":"nastala chyba"}');


var $7b91bdeeaf0bdb85$exports = {};
$7b91bdeeaf0bdb85$exports = JSON.parse('{"lang_markread":"Markera som l\xe4st","lang_newest":"Nyast","lang_unread":"Ol\xe4st","lang_starred":"Stj\xe4rnm\xe4rkt","lang_tags":"Taggar","lang_alltags":"Alla taggar","lang_timestamp":"{0,date} {0,time}","lang_hours":"f\xf6r {0,plural,one {1 timme},other {# timmar}} sedan","lang_minutes":"f\xf6r {0,plural,one {1 minut},other {# minuter}} sedan","lang_seconds":"f\xf6r {0,plural,one {1 sekund},other {# sekunder}} sedan","lang_days":"{0,plural,zero {idag},one {ig\xe5r},other {f\xf6r # dagar sedan}}","lang_star":"stj\xe4rna","lang_unstar":"utan stj\xe4rna","lang_mark":"markera som l\xe4st","lang_unmark":"markera som ol\xe4st","lang_load_img":"bilder","lang_open_window":"\xf6ppna","lang_searchbutton":"s\xf6k","lang_sources":"K\xe4lla","lang_source_add":"L\xe4gg till k\xe4lla","lang_source_opml":"eller importera fr\xe5n opml-fil eller Google Reader","lang_source_edit":"redigera","lang_source_delete":"ta bort","lang_source_warn":"Vill du verkligen ta bort denna k\xe4lla?","lang_source_new":"ny k\xe4lla","lang_source_title":"Titel","lang_source_tags":"Tagg","lang_source_comma":"kommaseparerad","lang_source_select":"v\xe4lj k\xe4lla","lang_source_type":"Typ","lang_source_save":"spara","lang_source_cancel":"avbryt","lang_source_saved":"sparad","lang_no_entries":"hittade inga inl\xe4gg","lang_more":"fler","lang_login":"Logga in","lang_login_username":"Anv\xe4ndarnamn","lang_login_password":"L\xf6senord","lang_source_last_post":"Senaste artikel visad","lang_filter":"Filter","lang_online_count":"Objekt tillg\xe4ngliga p\xe5 servern","lang_offline_count":"Objekt som \xe4r tillg\xe4ngliga lokalt","lang_next":"N\xe4sta","lang_searchremove":"D\xf6lj s\xf6k","lang_refreshbutton":"Uppdatera k\xe4llor","lang_settingsbutton":"Inst\xe4llningar","lang_logoutbutton":"Logga ut","lang_loginbutton":"Logga in","lang_source_export":"Exportera k\xe4llor","lang_source_filter":"Filter","lang_source_autotitle_hint":"L\xe4mna tomt f\xf6r att h\xe4mta titel","lang_source_pwd_placeholder":"Inte f\xf6r\xe4ndrad","lang_source_refresh":"Uppdatera den h\xe4r k\xe4llan","lang_login_invalid_credentials":"Fel anv\xe4ndarnamn/l\xf6senord","lang_login_offline":"Offline-lagring","lang_no_title":"Ingen titel","lang_error":"Ett fel uppstod","lang_streamerror":"Inga objekt laddade, ladda om?","lang_reload_list":"Ladda om listan","lang_sources_refreshed":"K\xe4llor uppdaterade","lang_app_update":"selfoss har uppdaterats, ladda om igen","lang_app_reload":"Ladda om","lang_error_session_expired":"Sessionen har g\xe5tt ut","lang_error_add_source":"Kunde inte l\xe4gga till k\xe4lla:","lang_error_delete_source":"Kunde inte ta bort k\xe4llan:","lang_error_load_tags":"Kunde inte ladda taggar:","lang_error_unknown_tag":"Ok\xe4nd tagg:","lang_error_unknown_source":"Ok\xe4nt k\xe4ll-ID:","lang_error_mark_items":"Kan inte markera alla synliga objekt:","lang_error_mark_item":"Kan inte markera/avmarkera objekt:","lang_error_star_item":"Kan inte stj\xe4rna/avstj\xe4rna objekt:","lang_error_logout":"Kunde inte logga in:","lang_error_loading":"Laddningsfel:","lang_error_loading_stats":"Kan inte ladda nav-statistik:","lang_error_saving_color":"Det g\xe5r inte att spara ny f\xe4rg:","lang_error_refreshing_source":"Kan inte uppdatera k\xe4llor:","lang_error_sync":"Kunde inte synkronisera senaste \xe4ndringarna fr\xe5n servern:","lang_error_offline_storage":"Offline-lagringsfel: {0}. Omladdning kan hj\xe4lpa. Inaktiverar offline f\xf6r tillf\xe4llet.","lang_error_invalid_subsection":"Ogiltigt underavsnitt:","lang_search_label":"S\xf6kterm","lang_article_actions":"\xc5tg\xe4rder","lang_error_configuration":"Det g\xe5r inte att ladda konfiguration.","lang_info_url_copied":"URL kopierad till urklipp.","lang_share_native_label":"Dela","lang_share_diaspora_label":"Dela p\xe5 Diaspora","lang_share_twitter_label":"Dela p\xe5 Twitter","lang_share_facebook_label":"Dela p\xe5 Facebook","lang_share_pocket_label":"Spara i Pocket","lang_share_wallabag_label":"Spara i Wallabag","lang_share_wordpress_label":"Dela p\xe5 WordPress","lang_share_mail_label":"Dela med e-post","lang_share_copy_label":"Kopiera l\xe4nk till urklipp","lang_error_share_native_abort":"Det g\xe5r inte att dela objektet - antingen finns det inga delningsm\xe5l eller s\xe5 avbr\xf6t du det.","lang_error_share_native":"Det g\xe5r inte att dela objektet.","lang_close_entry":"St\xe4ng","lang_experimental":"Experimentell","lang_error_unwritable_logs":"Det gick inte att skriva loggar.","lang_error_check_system_logs":"Ett fel uppstod. Kontrollera dina systemloggar.","lang_error_check_log_file":"Ett fel uppstod. Kontrollera loggfilen \u201C{0}\u201D.","lang_source_browse":"Bl\xe4ddra","lang_tag_change_color_button_title":"\xc4ndra f\xe4rg","lang_source_warn_cancel_dirty":"Kasta bort osparade \xe4ndringar?","lang_offline_navigation_unavailable":"Att byta taggar och k\xe4llor \xe4r f\xf6r n\xe4rvarande inte tillg\xe4ngligt i offlinel\xe4ge.","lang_sources_leaving_unsaved_prompt":"L\xe4mna inst\xe4llningar med osparade k\xe4ll\xe4ndringar?","lang_error_offline_storage_not_available":"Offlinelagring \xe4r inte tillg\xe4ngligt. Se till att din webbl\xe4sare {0}st\xf6djer IndexedDB API{1} och, om du anv\xe4nder en Google Chrome baserad webbl\xe4sare, att du inte k\xf6r selfoss i incognito l\xe4ge.","lang_error_edit_source":"Kunde inte spara k\xe4ll\xe4ndringar:","lang_source_menu":"Mer \xe5tg\xe4rder","lang_no_sources":"Inga k\xe4llor konfigurerade.","lang_source_deleting":"Raderar k\xe4lla\u2026","lang_login_error_generic":"Kunde inte logga in: {errorMessage}","lang_sources_loading":"Laddar k\xe4llor\u2026","lang_source_params_loading":"Laddar parametrar\u2026","lang_source_saving":"Sparar k\xe4ll\xe4ndringar\u2026","lang_source_go_to_settings":"\xd6ppna i inst\xe4llningar","lang_entries_loading":"L\xe4ser in poster\u2026","lang_login_in_progress":"F\xf6rs\xf6ker att logga in\u2026","lang_error_unauthorized":"V\xe4nligen {link_begin}logga in{link_end} f\xf6r att forts\xe4tta.","lang_article_reading_time":"{0}min l\xe4s","lang_share_mastodon_label":"Dela p\xe5 Mastodon"}');


var $64a33f7e6e987d4f$exports = {};
$64a33f7e6e987d4f$exports = JSON.parse('{"lang_markread":"Okundu olarak i\u015Faretle","lang_newest":"En yeni","lang_unread":"Okunmayan","lang_starred":"Y\u0131ld\u0131zlanan","lang_tags":"Etiketler","lang_alltags":"T\xfcm etiketler","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0, plural,other {#}} saat \xf6nce","lang_minutes":"{0, plural,other {#}} dakika \xf6nce","lang_seconds":"{0, plural,other {#}} saniye \xf6nce","lang_star":"Y\u0131ld\u0131z ekle","lang_unstar":"Y\u0131ld\u0131z kald\u0131r","lang_mark":"Okundu olarak i\u015Faretle","lang_unmark":"Okunmad\u0131 olarak i\u015Faretle","lang_load_img":"Resimleri g\xf6ster","lang_open_window":"A\xe7","lang_searchbutton":"Ara","lang_sources":"Kaynaklar","lang_source_add":"Kaynak ekle","lang_source_opml":"veya bir OPML dosyas\u0131n\u0131 i\xe7e aktar","lang_source_export":"Kaynaklar\u0131 d\u0131\u015Fa aktar","lang_source_edit":"D\xfczenle","lang_source_delete":"Sil","lang_source_warn":"Bu kaynak ger\xe7ekten silinsin mi?","lang_source_new":"Yeni kaydedilmemi\u015F kaynak","lang_source_title":"Ba\u015Fl\u0131k","lang_source_tags":"Etiketler","lang_source_comma":"Virg\xfclle ayr\u0131lm\u0131\u015F","lang_source_select":"L\xfctfen kaynak se\xe7in","lang_source_type":"T\xfcr","lang_source_save":"Kaydet","lang_source_cancel":"\u0130ptal","lang_source_saved":"Kaydedildi","lang_no_entries":"Yay\u0131n bulunmad\u0131","lang_more":"Daha fazla","lang_login":"Oturum a\xe7","lang_login_username":"Kullan\u0131c\u0131 ad\u0131","lang_login_password":"Parola","lang_no_title":"Ba\u015Fl\u0131k yok","lang_article_actions":"Eylemler","lang_close_entry":"Kapat","lang_info_url_copied":"URL panoya kopyaland\u0131.","lang_error_share_native":"\xd6ge payla\u015F\u0131lam\u0131yor.","lang_error_share_native_abort":"\xd6ge payla\u015F\u0131lam\u0131yor \u2014 ya hi\xe7 payla\u015F\u0131m hedefi yok ya da siz iptal ettiniz.","lang_error_configuration":"Yap\u0131land\u0131rma y\xfcklenemiyor.","lang_error_invalid_subsection":"Ge\xe7ersiz alt b\xf6l\xfcm:","lang_error_offline_storage_not_available":"\xc7evrim d\u0131\u015F\u0131 depolama kullan\u0131lam\u0131yor. Web taray\u0131c\u0131n\u0131z\u0131n {0}IndexedDB API\'sini{1} destekledi\u011Finden ve Google Chrome tabanl\u0131 bir taray\u0131c\u0131 kullan\u0131yorsan\u0131z selfoss\'u gizli modda \xe7al\u0131\u015Ft\u0131rmad\u0131\u011F\u0131n\u0131zdan emin olun.","lang_error_offline_storage":"\xc7evrim d\u0131\u015F\u0131 depolama hatas\u0131: {0}. Yeniden y\xfcklemek yard\u0131mc\u0131 olabilir. \xc7evrim d\u0131\u015F\u0131 \u015Fimdilik devre d\u0131\u015F\u0131 b\u0131rak\u0131l\u0131yor.","lang_error_sync":"Sunucudan son de\u011Fi\u015Fiklikler e\u015Fzamanlanamad\u0131:","lang_error_refreshing_source":"Kaynaklar yenilenemiyor:","lang_error_saving_color":"Yeni renk kaydedilemiyor:","lang_error_loading_stats":"G\xf6z atma istatistikleri y\xfcklenemiyor:","lang_error_loading":"Y\xfckleme hatas\u0131:","lang_error_logout":"Oturum kapat\u0131lamad\u0131:","lang_error_star_item":"\xd6geye y\u0131ld\u0131z eklenemiyor/y\u0131ld\u0131z\u0131 kald\u0131r\u0131lam\u0131yor:","lang_error_mark_item":"\xd6ge i\u015Faretlenemiyor/i\u015Fareti kald\u0131r\u0131lam\u0131yor:","lang_error_mark_items":"T\xfcm g\xf6r\xfcn\xfcr \xf6geler i\u015Faretlenemiyor:","lang_error_unknown_source":"Bilinmeyen kaynak kimli\u011Fi:","lang_error_unknown_tag":"Bilinmeyen etiket:","lang_error_load_tags":"Etiketler y\xfcklenemedi:","lang_error_delete_source":"Kaynak silinemedi:","lang_error_edit_source":"Kaynak de\u011Fi\u015Fiklikleri kaydedilemedi:","lang_error_add_source":"Kaynak eklenemedi:","lang_error_session_expired":"Oturumun s\xfcresi doldu","lang_app_reload":"Yeniden y\xfckle","lang_app_update":"selfoss g\xfcncellendi, l\xfctfen yeniden y\xfckleyin","lang_sources_refreshed":"Kaynaklar yenilendi","lang_reload_list":"Listeyi yeniden y\xfckle","lang_streamerror":"Hi\xe7bir \xf6ge y\xfcklenmedi, yeniden y\xfcklensin mi?","lang_error_unwritable_logs":"G\xfcnl\xfck yaz\u0131lam\u0131yor.","lang_error_check_system_logs":"Bir hata olu\u015Ftu, l\xfctfen sistem g\xfcnl\xfcklerinize bak\u0131n.","lang_error_check_log_file":"Bir hata olu\u015Ftu, l\xfctfen g\xfcnl\xfck dosyas\u0131na bak\u0131n \u201C{0}\u201D.","lang_error":"Bir hata olu\u015Ftu","lang_login_offline":"\xc7evrim d\u0131\u015F\u0131 depolama","lang_login_invalid_credentials":"Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131/parola","lang_source_refresh":"Bu kayna\u011F\u0131 yenile","lang_source_last_post":"G\xf6r\xfclen son g\xf6nderi","lang_source_pwd_placeholder":"De\u011Fi\u015Fmedi","lang_source_autotitle_hint":"Ba\u015Fl\u0131\u011F\u0131 almak i\xe7in bo\u015F b\u0131rak\u0131n","lang_source_filter":"Filtrele","lang_loginbutton":"Oturum a\xe7","lang_logoutbutton":"Oturumu kapat","lang_settingsbutton":"Ayarlar","lang_refreshbutton":"Kaynaklar\u0131 yenile","lang_searchremove":"Aramay\u0131 gizle","lang_search_label":"Arama terimi","lang_share_copy_label":"Ba\u011Flant\u0131y\u0131 panoya kopyala","lang_share_mail_label":"E-posta ile payla\u015F","lang_share_wordpress_label":"WordPress\'te payla\u015F","lang_share_wallabag_label":"Wallabag\'e kaydet","lang_share_pocket_label":"Pocket\'a kaydet","lang_share_facebook_label":"Facebook\'ta payla\u015F","lang_share_twitter_label":"Twitter\'da payla\u015F","lang_share_diaspora_label":"Diaspora\'da payla\u015F","lang_share_native_label":"Payla\u015F","lang_next":"Sonraki","lang_days":"{0,plural,zero {bug\xfcn},one {d\xfcn},other {# g\xfcn \xf6nce}}","lang_offline_navigation_unavailable":"Etiketleri ve kaynaklar\u0131 de\u011Fi\u015Ftirmek \u015Fu anda \xe7evrim d\u0131\u015F\u0131 modda kullan\u0131lam\u0131yor.","lang_offline_count":"Yerel olarak kullan\u0131labilen \xf6geler","lang_online_count":"Sunucuda bulunan \xf6geler","lang_filter":"Filtrele","lang_article_reading_time":"{0} dakika okuma","lang_experimental":"Deneysel","lang_source_warn_cancel_dirty":"Kaydedilmemi\u015F de\u011Fi\u015Fiklikler at\u0131ls\u0131n m\u0131?","lang_sources_leaving_unsaved_prompt":"Kaydedilmemi\u015F kaynak de\u011Fi\u015Fiklikleri olmas\u0131na ra\u011Fmen ayarlardan \xe7\u0131k\u0131ls\u0131n m\u0131?","lang_source_browse":"G\xf6z at","lang_source_menu":"Daha fazla eylem","lang_tag_change_color_button_title":"Rengi de\u011Fi\u015Ftir","lang_source_go_to_settings":"Ayarlarda a\xe7","lang_sources_loading":"Kaynaklar y\xfckleniyor\u2026","lang_no_sources":"Yap\u0131land\u0131r\u0131lan kaynak yok.","lang_entries_loading":"Yay\u0131nlar y\xfckleniyor\u2026","lang_source_deleting":"Kaynak siliniyor\u2026","lang_login_in_progress":"Oturum a\xe7maya \xe7al\u0131\u015F\u0131l\u0131yor\u2026","lang_source_params_loading":"Parametreler y\xfckleniyor\u2026","lang_source_saving":"Kaynak de\u011Fi\u015Fiklikleri kaydediliyor\u2026","lang_error_unauthorized":"Devam etmek i\xe7in l\xfctfen {link_begin}oturum a\xe7\u0131n{link_end}.","lang_login_error_generic":"Oturum a\xe7\u0131lamad\u0131: {errorMessage}","lang_share_mastodon_label":"Mastodon\'da payla\u015F"}');


var $563d7fbeeac49c6b$exports = {};
$563d7fbeeac49c6b$exports = JSON.parse('{"lang_markread":"\u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456","lang_newest":"\u043D\u043E\u0432\u0456","lang_unread":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456","lang_starred":"\u0432\u0456\u0434\u0437\u043D\u0430\u0447\u0435\u043D\u0456","lang_tags":"\u0422\u0435\u0433\u0438","lang_alltags":"\u0443\u0441\u0456 \u0442\u0435\u0433\u0438","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u0433\u043E\u0434\u0438\u043D\u0443},other {# \u0433\u043E\u0434\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","lang_minutes":"{0,plural,one {1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443},other {# \u0445\u0432\u0438\u043B\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","lang_seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434\u0438}} \u0442\u043E\u043C\u0443","lang_star":"\u0432\u0456\u0434\u0437\u043D\u0430\u0447\u0438\u0442\u0438","lang_unstar":"\u0437\u043D\u044F\u0442\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0443","lang_mark":"\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0435","lang_unmark":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0435","lang_load_img":"\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F","lang_open_window":"\u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438","lang_searchbutton":"\u043F\u043E\u0448\u0443\u043A","lang_sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430","lang_source_add":"\u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_opml":"\u0430\u0431\u043E \u0456\u043C\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437 OPML \u0444\u0430\u0439\u043B\u0443","lang_source_export":"\u0435\u043A\u0441\u043F\u043E\u0440\u0442 \u0434\u0436\u0435\u0440\u0435\u043B","lang_source_edit":"\u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438","lang_source_delete":"\u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438","lang_source_warn":"\u0434\u0456\u0439\u0441\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E?","lang_source_new":"\u043D\u043E\u0432\u0435 \u043D\u0435 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_title":"\u041D\u0430\u0437\u0432\u0430","lang_source_tags":"\u0422\u0435\u0433\u0438","lang_source_comma":"\u0440\u043E\u0437\u0456\u043B\u0435\u043D\u0456 \u043A\u043E\u043C\u043E\u044E","lang_source_select":"\u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0434\u0436\u0435\u0440\u0435\u043B\u0430","lang_source_type":"\u0422\u0438\u043F","lang_source_save":"\u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438","lang_source_cancel":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","lang_source_saved":"\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E","lang_no_entries":"\u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430\u043F\u0438\u0441\u0456\u0432","lang_more":"\u0449\u0435","lang_login":"\u0432\u0445\u0456\u0434","lang_login_username":"\u0456\u043C\'\u044F","lang_login_password":"\u043F\u0430\u0440\u043E\u043B\u044C","lang_no_title":"\u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0438","lang_filter":"\u0424\u0456\u043B\u044C\u0442\u0440","lang_online_count":"\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0456","lang_offline_count":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E","lang_source_browse":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434","lang_share_facebook_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Facebook","lang_error_check_log_file":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0444\u0430\u0439\u043B \u0436\u0443\u0440\u043D\u0430\u043B\u0443 \\"{0}\\".","lang_error_check_system_logs":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0436\u0443\u0440\u043D\u0430\u043B\u0438.","lang_error_unwritable_logs":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u0438\u0441\u0430\u0442\u0438 \u043B\u043E\u0433\u0438.","lang_streamerror":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0456, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438?","lang_error_edit_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_mark_items":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0434\u0438\u043C\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438:","lang_error_star_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0430\u0431\u043E \u0437\u043D\u044F\u0442\u0438 \u0437\u0456\u0440\u043E\u0447\u043A\u0443:","lang_error_logout":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0439\u0442\u0438:","lang_error_saving_color":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u043E\u043B\u0456\u0440:","lang_error_sync":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0443\u0432\u0430\u0442\u0438 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u043C\u0456\u043D\u0438 \u0437 \u0441\u0435\u0440\u0432\u0435\u0440\u0430:","lang_error_unknown_source":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_load_tags":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0442\u0435\u0433\u0438:","lang_error_unknown_tag":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u0442\u0435\u0433:","lang_error_refreshing_source":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_mark_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438/\u0437\u043D\u044F\u0442\u0438 \u0432\u0456\u0434\u043C\u0456\u0442\u043A\u0443 \u0437 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430:","lang_error_offline_storage":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u043E\u043C\u0443 \u0441\u0445\u043E\u0432\u0438\u0449\u0456: {0}. \u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. \u041D\u0430\u0440\u0430\u0437\u0456 \u0432\u0456\u0434\u043A\u043B\u044E\u0447\u0430\u0454\u043C\u043E \u043E\u0444\u043B\u0430\u0439\u043D.","lang_days":"{0,plural,zero {\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456},one {\u0432\u0447\u043E\u0440\u0430},other {# \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443}}","lang_error_unauthorized":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, {link_begin}\u0443\u0432\u0456\u0439\u0434\u0456\u0442\u044C \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443{link_end}, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438.","lang_share_native_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F","lang_share_twitter_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0432 Twitter","lang_share_mastodon_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Mastodon","lang_source_deleting":"\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","lang_share_wordpress_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 WordPress","lang_share_copy_label":"\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443","lang_search_label":"\u041F\u043E\u0448\u0443\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442","lang_share_mail_label":"\u041F\u043E\u0434\u0456\u043B\u0456\u0442\u044C\u0441\u044F \u043D\u0430 e-mail","lang_searchremove":"\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0443\u043A","lang_logoutbutton":"\u0412\u0438\u0439\u0442\u0438","lang_settingsbutton":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","lang_loginbutton":"\u0423\u0432\u0456\u0439\u0442\u0438","lang_no_sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0456.","lang_source_filter":"\u0424\u0456\u043B\u044C\u0442\u0440","lang_error_loading_stats":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0439\u043D\u0443 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443:","lang_source_menu":"\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0434\u0456\u0457","lang_sources_leaving_unsaved_prompt":"\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u043C\u0438 \u0437\u043C\u0456\u043D\u0430\u043C\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430?","lang_login_error_generic":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0443\u0432\u0456\u0439\u0442\u0438: {errorMessage}","lang_experimental":"\u0415\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0456","lang_tag_change_color_button_title":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043A\u043E\u043B\u0456\u0440","lang_login_in_progress":"\u0421\u043F\u0440\u043E\u0431\u0430 \u0443\u0432\u0456\u0439\u0442\u0438\u2026","lang_sources_refreshed":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0456","lang_error":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430","lang_sources_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u2026","lang_login_invalid_credentials":"\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0435 \u0456\u043C\'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430/\u043F\u0430\u0440\u043E\u043B\u044C","lang_error_loading":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u0456:","lang_source_last_post":"\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u043F\u043E\u0431\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u043E\u0441\u0442","lang_refreshbutton":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430","lang_share_diaspora_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Diaspora","lang_share_wallabag_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0443 Wallabag","lang_next":"\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439","lang_source_saving":"\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","lang_entries_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0438\u0441\u0456\u0432\u2026","lang_reload_list":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A","lang_share_pocket_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0432 Pocket","lang_info_url_copied":"URL \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443.","lang_offline_navigation_unavailable":"\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u043D\u043D\u044F \u0442\u0435\u0433\u0456\u0432 \u0456 \u0434\u0436\u0435\u0440\u0435\u043B \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u0432 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u043E\u043C\u0443 \u0440\u0435\u0436\u0438\u043C\u0456.","lang_source_warn_cancel_dirty":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438?","lang_error_offline_storage_not_available":"\u0410\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u0435 \u0441\u0445\u043E\u0432\u0438\u0449\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435. \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432\u0430\u0448 \u0432\u0435\u0431-\u0431\u0440\u0430\u0443\u0437\u0435\u0440 {0} \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 API IndexedDB{1} \u0456, \u044F\u043A\u0449\u043E \u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0430 \u0431\u0430\u0437\u0456 Google Chrome, \u0442\u043E \u0432\u0438 \u043D\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0454\u0442\u0435 selfoss \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u0456\u043D\u043A\u043E\u0433\u043D\u0456\u0442\u043E.","lang_error_invalid_subsection":"\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u043F\u0456\u0434\u0440\u043E\u0437\u0434\u0456\u043B:","lang_error_configuration":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E.","lang_error_share_native_abort":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F - \u0430\u0431\u043E \u043D\u0435\u043C\u0430\u0454 \u0446\u0456\u043B\u0435\u0439, \u0430\u0431\u043E \u0432\u0438 \u0457\u0445 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u043B\u0438.","lang_error_share_native":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F.","lang_close_entry":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","lang_article_actions":"\u0414\u0456\u0457","lang_article_reading_time":"{0} \u0445\u0432 \u0447\u0438\u0442\u0430\u043D\u043D\u044F","lang_source_autotitle_hint":"\u0417\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u043D\u0430\u0437\u0432\u0443","lang_source_pwd_placeholder":"\u0411\u0435\u0437 \u0437\u043C\u0456\u043D","lang_source_params_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u043C\u043E \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438\u2026","lang_source_refresh":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_go_to_settings":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u0445","lang_login_offline":"\u0410\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u0435 \u0441\u0445\u043E\u0432\u0438\u0449\u0435","lang_app_update":"selfoss \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435","lang_app_reload":"\u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438","lang_error_session_expired":"\u0421\u0435\u0441\u0456\u044F \u0432\u0436\u0435 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u043B\u0430\u0441\u044F","lang_error_add_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:","lang_error_delete_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:"}');


var $94f63a341744b7b8$exports = {};
$94f63a341744b7b8$exports = JSON.parse('{"lang_markread":"\u5168\u90E8\u6807\u8BB0\u4E3A\u5DF2\u8BFB","lang_newest":"\u6700\u65B0\u6761\u76EE","lang_unread":"\u672A\u8BFB\u6761\u76EE","lang_starred":"\u52A0\u661F\u6807\u7684\u6761\u76EE","lang_tags":"\u6807\u7B7E","lang_alltags":"\u6240\u6709\u6807\u7B7E","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u5C0F\u65F6},other {# \u5C0F\u65F6}}\u524D","lang_minutes":"{0,plural,one {1 \u5206\u949F},other {# \u5206\u949F}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","lang_star":"\u52A0\u661F\u6807","lang_unstar":"\u53D6\u6D88\u661F\u6807","lang_mark":"\u6807\u8BB0\u4E3A\u5DF2\u8BFB","lang_unmark":"\u6807\u8BB0\u4E3A\u672A\u8BFB","lang_load_img":"\u52A0\u8F7D\u56FE\u7247","lang_open_window":"\u6253\u5F00","lang_searchbutton":"\u641C\u7D22","lang_sources":"\u6E90","lang_source_add":"\u6DFB\u52A0\u6E90","lang_source_opml":"\u6216\u5BFC\u5165 OPML \u6587\u4EF6/Google \u9605\u8BFB\u5668\u8BA2\u9605","lang_source_export":"\u5BFC\u51FA\u6E90","lang_source_edit":"\u7F16\u8F91","lang_source_delete":"\u5220\u9664","lang_source_warn":"\u786E\u8BA4\u8981\u5220\u9664\u8BE5\u6E90?","lang_source_new":"\u65B0\u7684\u6E90","lang_source_title":"\u6807\u9898","lang_source_tags":"\u6807\u7B7E","lang_source_comma":"\u4EE5\u9017\u53F7\u5206\u9694","lang_source_select":"\u8BF7\u9009\u62E9\u6E90","lang_source_type":"\u7C7B\u578B","lang_source_save":"\u4FDD\u5B58","lang_source_cancel":"\u53D6\u6D88","lang_source_saved":"\u5DF2\u4FDD\u5B58","lang_source_last_post":"\u66F4\u65B0\u4E8E","lang_no_entries":"\u6CA1\u6709\u6761\u76EE","lang_more":"\u66F4\u591A","lang_login":"\u767B\u5F55","lang_login_username":"\u7528\u6237\u540D","lang_login_password":"\u5BC6\u7801","lang_no_title":"\u65E0\u6807\u9898","lang_logoutbutton":"\u767B\u51FA","lang_loginbutton":"\u767B\u5F55","lang_error_logout":"\u4E0D\u80FD\u767B\u51FA\uFF1A","lang_settingsbutton":"\u8BBE\u7F6E","lang_app_reload":"\u518D\u542F\u52A8","lang_error_session_expired":"\u4F1A\u8BDD\u5DF2\u8FC7\u671F","lang_close_entry":"\u5173\u95ED","lang_error_sync":"\u65E0\u6CD5\u4ECE\u670D\u52A1\u5668\u540C\u6B65\u65B0\u7684\u66F4\u6539\uFF1A","lang_share_pocket_label":"\u4FDD\u5B58\u5230 Pocket","lang_searchremove":"\u9690\u85CF\u641C\u7D22","lang_error_share_native_abort":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE - \u53EF\u80FD\u662F\u7F3A\u5C11\u5206\u4EAB\u5BF9\u8C61\u6216\u60A8\u5DF2\u53D6\u6D88\u5206\u4EAB\u3002","lang_error_mark_items":"\u65E0\u6CD5\u6807\u8BB0\u6240\u6709\u53EF\u89C1\u9879\u76EE\uFF1A","lang_share_twitter_label":"\u5206\u4EAB\u5230 Twitter","lang_share_wallabag_label":"\u4FDD\u5B58\u5230 Wallabag","lang_filter":"\u7B5B\u9009","lang_online_count":"\u670D\u52A1\u5668\u53EF\u7528\u7684\u6761\u76EE","lang_offline_navigation_unavailable":"\u79BB\u7EBF\u6A21\u5F0F\u4E0B\u6682\u65F6\u4E0D\u80FD\u5207\u6362\u6807\u7B7E\u548C\u6765\u6E90\u3002","lang_source_menu":"\u66F4\u591A\u64CD\u4F5C","lang_source_browse":"\u6D4F\u89C8","lang_offline_count":"\u672C\u5730\u53EF\u7528\u7684\u6761\u76EE","lang_next":"\u4E0B\u4E00\u4E2A","lang_share_native_label":"\u5206\u4EAB","lang_refreshbutton":"\u66F4\u65B0\u6570\u636E\u6E90","lang_share_diaspora_label":"\u5206\u4EAB\u5230 Diaspora","lang_share_wordpress_label":"\u5206\u4EAB\u5230 WordPress","lang_search_label":"\u641C\u7D22\u8BCD","lang_share_mail_label":"\u901A\u8FC7\u90AE\u4EF6\u5206\u4EAB","lang_source_warn_cancel_dirty":"\u4E22\u5F03\u672A\u4FDD\u5B58\u7684\u66F4\u6539\uFF1F","lang_share_copy_label":"\u590D\u5236\u94FE\u63A5\u5230\u526A\u5207\u677F","lang_source_filter":"\u7B5B\u9009","lang_share_facebook_label":"\u5206\u4EAB\u5230 Facebook","lang_tag_change_color_button_title":"\u66F4\u6539\u989C\u8272","lang_experimental":"\u8BD5\u9A8C\u6027\u7684","lang_login_invalid_credentials":"\u9519\u8BEF\u7684\u7528\u6237\u540D\u6216\u5BC6\u7801","lang_error_check_log_file":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u65E5\u5FD7\u6587\u4EF6 \u201C{0}\u201D\u3002","lang_login_offline":"\u79BB\u7EBF\u5B58\u50A8","lang_error_unknown_source":"\u672A\u77E5\u6765\u6E90 ID\uFF1A","lang_error_mark_item":"\u65E0\u6CD5\u6807\u8BB0\u6216\u53D6\u6D88\u6807\u8BB0\uFF1A","lang_error_star_item":"\u65E0\u6CD5\u661F\u6807\u6216\u53D6\u6D88\u661F\u6807\uFF1A","lang_error_loading":"\u52A0\u8F7D\u9519\u8BEF\uFF1A","lang_article_reading_time":"{0} \u5206\u949F\u9605\u8BFB\u65F6\u957F","lang_sources_loading":"\u6570\u636E\u6E90\u52A0\u8F7D\u4E2D\u2026","lang_no_sources":"\u6570\u636E\u6E90\u672A\u914D\u7F6E\u3002","lang_source_deleting":"\u6B63\u5728\u5220\u9664\u6570\u636E\u6E90\u2026","lang_source_autotitle_hint":"\u7559\u7A7A\u4EE5\u81EA\u52A8\u586B\u5145\u6807\u9898","lang_source_pwd_placeholder":"\u6CA1\u6709\u6539\u53D8","lang_source_params_loading":"\u6B63\u5728\u52A0\u8F7D\u53C2\u6570\u2026","lang_source_saving":"\u6B63\u5728\u4FDD\u5B58\u6570\u636E\u6E90\u66F4\u6539\u2026","lang_source_refresh":"\u5237\u65B0\u6B64\u6570\u636E\u6E90","lang_source_go_to_settings":"\u5728\u8BBE\u7F6E\u4E2D\u6253\u5F00","lang_sources_leaving_unsaved_prompt":"\u4FDD\u7559\u672A\u4FDD\u5B58\u7684\u6570\u636E\u6E90\u66F4\u6539\uFF1F","lang_entries_loading":"\u52A0\u8F7D\u6761\u76EE\u4E2D\u2026","lang_login_in_progress":"\u5C1D\u8BD5\u767B\u5F55\u4E2D\u2026","lang_error":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF","lang_error_check_system_logs":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u4F60\u7684\u7CFB\u7EDF\u65E5\u5FD7\u3002","lang_error_unwritable_logs":"\u65E0\u6CD5\u5199\u5165\u65E5\u5FD7\u3002","lang_streamerror":"\u6CA1\u6709\u52A0\u8F7D\u5230\u6761\u76EE\uFF0C\u91CD\u65B0\u52A0\u8F7D\uFF1F","lang_sources_refreshed":"\u6570\u636E\u6E90\u5DF2\u5237\u65B0","lang_app_update":"selfoss \u5DF2\u88AB\u66F4\u65B0\uFF0C\u8BF7\u91CD\u65B0\u52A0\u8F7D","lang_error_add_source":"\u65E0\u6CD5\u6DFB\u52A0\u6E90\uFF1A","lang_error_edit_source":"\u65E0\u6CD5\u4FDD\u5B58\u6E90\u66F4\u6539\uFF1A","lang_error_delete_source":"\u65E0\u6CD5\u5220\u9664\u6E90\uFF1A","lang_error_load_tags":"\u65E0\u6CD5\u52A0\u8F7D\u6807\u7B7E\uFF1A","lang_error_unknown_tag":"\u672A\u77E5\u7684\u6807\u7B7E\uFF1A","lang_error_loading_stats":"\u65E0\u6CD5\u52A0\u8F7D\u7EDF\u8BA1\u4FE1\u606F\uFF1A","lang_error_saving_color":"\u65E0\u6CD5\u4FDD\u5B58\u65B0\u989C\u8272\uFF1A","lang_error_refreshing_source":"\u65E0\u6CD5\u5237\u65B0\u6570\u636E\u6E90\uFF1A","lang_error_offline_storage":"\u79BB\u7EBF\u5B58\u50A8\u51FA\u9519\uFF1A{0} \uFF0C\u8BF7\u5C1D\u8BD5\u91CD\u65B0\u52A0\u8F7D\u3002\u79BB\u7EBF\u6A21\u5F0F\u5DF2\u88AB\u4E34\u65F6\u7981\u7528\u3002","lang_error_offline_storage_not_available":"\u79BB\u7EBF\u5B58\u50A8\u4E0D\u53EF\u7528\u3002\u786E\u4FDD\u60A8\u7684\u7F51\u7EDC\u6D4F\u89C8\u5668 {0} \u652F\u6301 IndexedDB API{1}\uFF0C\u5982\u679C\u60A8\u4F7F\u7528\u7684\u662F\u57FA\u4E8E Google Chrome \u7684\u6D4F\u89C8\u5668\uFF0C\u8BF7\u786E\u4FDD\u60A8\u6CA1\u6709\u5728\u9690\u8EAB\u6A21\u5F0F\u4E0B\u8FD0\u884C selfoss\u3002","lang_error_invalid_subsection":"\u65E0\u6548\u7684\u5C0F\u8282\uFF1A","lang_error_configuration":"\u65E0\u6CD5\u52A0\u8F7D\u914D\u7F6E\u3002","lang_info_url_copied":"URL \u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F\u3002","lang_error_share_native":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE\u3002","lang_article_actions":"\u52A8\u4F5C","lang_reload_list":"\u91CD\u65B0\u52A0\u8F7D\u5217\u8868","lang_login_error_generic":"\u65E0\u6CD5\u767B\u5F55: {errorMessage}","lang_error_unauthorized":"\u8BF7 {link_begin}\u767B\u5F55{link_end} \u4EE5\u7EE7\u7EED\u3002"}');


var $d97043994cabe9e3$exports = {};
$d97043994cabe9e3$exports = JSON.parse('{"lang_markread":"\u5168\u90E8\u6A19\u8A18\u70BA\u5DF2\u8B80","lang_newest":"\u6700\u65B0\u689D\u76EE","lang_unread":"\u672A\u8B80\u689D\u76EE","lang_starred":"\u52A0\u661F\u6A19\u7684\u689D\u76EE","lang_tags":"\u6A19\u7C64","lang_alltags":"\u6240\u6709\u6A19\u7C64","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u5C0F\u6642},other {# \u5C0F\u6642}}\u524D","lang_minutes":"{0,plural,one {1 \u5206\u9418},other {# \u5206\u9418}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","lang_star":"\u52A0\u661F\u6A19","lang_unstar":"\u53D6\u6D88\u661F\u6A19","lang_mark":"\u6A19\u8A18\u70BA\u5DF2\u8B80","lang_unmark":"\u6A19\u8A18\u70BA\u672A\u8B80","lang_load_img":"\u8F09\u5165\u5716\u7247","lang_open_window":"\u6253\u958B","lang_searchbutton":"\u641C\u7D22","lang_sources":"\u6E90","lang_source_add":"\u6DFB\u52A0\u6E90","lang_source_opml":"\u6216\u532F\u5165 OPML \u6587\u4EF6/Google \u95B1\u8B80\u5668\u8A02\u95B1","lang_source_export":"\u532F\u51FA\u6E90","lang_source_edit":"\u7DE8\u8F2F","lang_source_delete":"\u522A\u9664","lang_source_warn":"\u78BA\u8A8D\u8981\u522A\u9664\u8A72\u6E90?","lang_source_new":"\u65B0\u7684\u6E90","lang_source_title":"\u6A19\u984C","lang_source_tags":"\u6A19\u7C64","lang_source_comma":"\u4EE5\u9017\u865F\u5206\u9694","lang_source_select":"\u8ACB\u9078\u64C7\u6E90","lang_source_type":"\u985E\u578B","lang_source_save":"\u5132\u5B58","lang_source_cancel":"\u53D6\u6D88","lang_source_saved":"\u5DF2\u5132\u5B58","lang_source_last_post":"\u66F4\u65B0\u65BC ","lang_no_entries":"\u6C92\u6709\u689D\u76EE","lang_more":"\u66F4\u591A","lang_login":"\u767B\u5165","lang_login_username":"\u5E33\u865F","lang_login_password":"\u5BC6\u78BC","lang_no_title":"\u7121\u6A19\u984C"}');


var $8d9b32747b35afdf$export$2e2bcd8739ae039 = {
    "ca": (0, (/*@__PURE__*/$parcel$interopDefault($3109e67d2d012138$exports))),
    "cs": (0, (/*@__PURE__*/$parcel$interopDefault($3f89fcb2517a5831$exports))),
    "de": (0, (/*@__PURE__*/$parcel$interopDefault($efc21f73bdbf3d30$exports))),
    "en": (0, (/*@__PURE__*/$parcel$interopDefault($e8fba7b0a3114fd9$exports))),
    "en-GB": (0, (/*@__PURE__*/$parcel$interopDefault($9bb1025262b0fb39$exports))),
    "es": (0, (/*@__PURE__*/$parcel$interopDefault($8ae9bc6f67c8887e$exports))),
    "et": (0, (/*@__PURE__*/$parcel$interopDefault($d225499964bebf2a$exports))),
    "fi": (0, (/*@__PURE__*/$parcel$interopDefault($d319fa7db54d8a5e$exports))),
    "fr": (0, (/*@__PURE__*/$parcel$interopDefault($d0be492086bdc65a$exports))),
    "fr-CA": (0, (/*@__PURE__*/$parcel$interopDefault($bb896106aaedaee8$exports))),
    "gl": (0, (/*@__PURE__*/$parcel$interopDefault($acbbfcabee63ed13$exports))),
    "he": (0, (/*@__PURE__*/$parcel$interopDefault($b6d92725827c8d30$exports))),
    "hu": (0, (/*@__PURE__*/$parcel$interopDefault($a93f0f568ed4bbb3$exports))),
    "id": (0, (/*@__PURE__*/$parcel$interopDefault($e1a0d6c367542bd9$exports))),
    "it": (0, (/*@__PURE__*/$parcel$interopDefault($d48d8cf661c7528d$exports))),
    "ja": (0, (/*@__PURE__*/$parcel$interopDefault($f0732a5d7f7054ed$exports))),
    "lv": (0, (/*@__PURE__*/$parcel$interopDefault($5170287447d26972$exports))),
    "nb": (0, (/*@__PURE__*/$parcel$interopDefault($7058dfe60927e7af$exports))),
    "nl": (0, (/*@__PURE__*/$parcel$interopDefault($51d8b37b1373d182$exports))),
    "pl": (0, (/*@__PURE__*/$parcel$interopDefault($3d25a85d30cd5367$exports))),
    "pt": (0, (/*@__PURE__*/$parcel$interopDefault($b01b1dfd07b9091e$exports))),
    "pt-BR": (0, (/*@__PURE__*/$parcel$interopDefault($f7917dde3df00ba4$exports))),
    "rm": (0, (/*@__PURE__*/$parcel$interopDefault($3e02282570dcf5ad$exports))),
    "ru": (0, (/*@__PURE__*/$parcel$interopDefault($ee2b610e60c3d44b$exports))),
    "sk": (0, (/*@__PURE__*/$parcel$interopDefault($430ac65b39f56697$exports))),
    "sv": (0, (/*@__PURE__*/$parcel$interopDefault($7b91bdeeaf0bdb85$exports))),
    "tr": (0, (/*@__PURE__*/$parcel$interopDefault($64a33f7e6e987d4f$exports))),
    "uk": (0, (/*@__PURE__*/$parcel$interopDefault($563d7fbeeac49c6b$exports))),
    "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($94f63a341744b7b8$exports))),
    "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($d97043994cabe9e3$exports)))
};


function $e66869f90d0f9f3a$var$handleNavToggle(param) {
    var event = param.event, setNavExpanded = param.setNavExpanded;
    event.preventDefault();
    // show hide navigation for mobile version
    setNavExpanded(function(expanded) {
        return !expanded;
    });
    window.scrollTo({
        top: 0
    });
}
function $e66869f90d0f9f3a$var$dismissMessage(event) {
    selfoss.app.setGlobalMessage(null);
    event.stopPropagation();
}
/**
 * Global message bar for showing errors/information at the top of the page.
 * It watches globalMessage and updates/shows/hides itself as necessary
 * when the value changes.
 */ function $e66869f90d0f9f3a$var$Message(param) {
    var message = param.message;
    // Whenever message changes, dismiss it after 15 seconds.
    (0, $eHaBZ.useEffect)(function() {
        if (message !== null) {
            var dismissTimeout = window.setTimeout(function() {
                selfoss.app.setGlobalMessage(null);
            }, 15000);
            return function() {
                // Destory previous timeout.
                window.clearTimeout(dismissTimeout);
            };
        }
    }, [
        message
    ]);
    return message !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "message",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            error: message.isError
        }),
        onClick: $e66869f90d0f9f3a$var$dismissMessage,
        children: [
            message.message,
            message.actions.map(function(param, index) {
                var label = param.label, callback = param.callback;
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                    type: "button",
                    onClick: callback,
                    children: label
                }, index);
            })
        ]
    }) : null;
}
$e66869f90d0f9f3a$var$Message.propTypes = {
    message: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired
};
function $e66869f90d0f9f3a$var$NotFound() {
    var location = (0, $c1feef6a502006a1$export$45d76561a5302f2b)();
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
        children: _("error_invalid_subsection") + location.pathname
    });
}
function $e66869f90d0f9f3a$var$CheckAuthorization(param) {
    var isAllowed = param.isAllowed, returnLocation = param.returnLocation, _ = param._, children = param.children;
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    if (!isAllowed) {
        var __split = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(_("error_unauthorized").split(/\{(?:link_begin|link_end)\}/), 3), preLink = __split[0], inLink = __split[1], postLink = __split[2];
        history.push("/sign/in", {
            returnLocation: returnLocation
        });
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
            children: [
                preLink,
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$a6c7ac8248d6e38a), {
                    to: "/sign/in",
                    children: inLink
                }),
                postLink
            ]
        });
    } else return children;
}
$e66869f90d0f9f3a$var$CheckAuthorization.propTypes = {
    isAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    returnLocation: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    _: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).any
};
function $e66869f90d0f9f3a$var$PureApp(param) {
    var navSourcesExpanded = param.navSourcesExpanded, setNavSourcesExpanded = param.setNavSourcesExpanded, offlineState = param.offlineState, allItemsCount = param.allItemsCount, allItemsOfflineCount = param.allItemsOfflineCount, unreadItemsCount = param.unreadItemsCount, unreadItemsOfflineCount = param.unreadItemsOfflineCount, starredItemsCount = param.starredItemsCount, starredItemsOfflineCount = param.starredItemsOfflineCount, globalMessage = param.globalMessage, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, sources = param.sources, setSources = param.setSources, tags = param.tags, reloadAll = param.reloadAll;
    var _useState = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(false), 2), navExpanded = _useState[0], setNavExpanded = _useState[1];
    var smartphone = (0, $c8aedc92b88eb948$export$443718c44347a6b3)();
    var offlineEnabled = (0, $c8aedc92b88eb948$export$96b5b894afc1d2e3)(selfoss.db.enableOffline);
    var _useState1 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), entriesPage = _useState1[0], setEntriesPage = _useState1[1];
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    (0, $eHaBZ.useEffect)(function() {
        // init shortcut handler
        var destroyShortcuts = (0, $f81f2efad81fa28e$export$2e2bcd8739ae039)();
        return function() {
            destroyShortcuts();
        };
    }, []);
    // TODO: move stuff that depends on this to the App.
    var history = (0, $c1feef6a502006a1$export$3420e1dc2c4a518c)();
    (0, $eHaBZ.useEffect)(function() {
        selfoss.history = history;
    }, [
        history
    ]);
    // Prepare path of the homepage for redirecting from /
    var homePagePath = configuration.homepage.split("/");
    if (!homePagePath[1]) homePagePath.push("all");
    var menuButtonOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $e66869f90d0f9f3a$var$handleNavToggle({
            event: event,
            setNavExpanded: setNavExpanded
        });
    }, []);
    var entriesRef = (0, $eHaBZ.useCallback)(function(entriesPage) {
        setEntriesPage(entriesPage);
        selfoss.entriesPage = entriesPage;
    }, []);
    var _useState2 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), title = _useState2[0], setTitle = _useState2[1];
    var _useState3 = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)((0, $eHaBZ.useState)(null), 2), globalUnreadCount = _useState3[0], setGlobalUnreadCount = _useState3[1];
    (0, $eHaBZ.useEffect)(function() {
        document.title = (title !== null && title !== void 0 ? title : configuration.htmlTitle) + ((globalUnreadCount !== null && globalUnreadCount !== void 0 ? globalUnreadCount : 0) > 0 ? " (".concat(globalUnreadCount, ")") : "");
    }, [
        configuration,
        title,
        globalUnreadCount
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var isAllowedToRead = (0, $bd320d0e16baa5f3$export$f5bdb3b3cec7f803)();
    var isAllowedToWrite = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).StrictMode, {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$Message, {
                message: globalMessage
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $c1feef6a502006a1$export$b5d5cf8927ab7262), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$e7b0ac011bb776c6), {
                        path: "/sign/in",
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                            id: "loginform",
                            role: "main",
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $374b9547e2738d1e$export$2e2bcd8739ae039), {
                                offlineEnabled: offlineEnabled
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$e7b0ac011bb776c6), {
                        path: "/password",
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$CheckAuthorization, {
                            isAllowed: isAllowedToWrite,
                            returnLocation: "/password",
                            _: _,
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                id: "hashpasswordbody",
                                role: "main",
                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ecbfc97fac1903d9$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$e7b0ac011bb776c6), {
                        path: "/opml",
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$CheckAuthorization, {
                            isAllowed: selfoss.isAllowedToWrite(),
                            returnLocation: "/opml",
                            _: _,
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("main", {
                                id: "opmlbody",
                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $f343fb504b01a581$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$e7b0ac011bb776c6), {
                        path: "/",
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)($e66869f90d0f9f3a$var$CheckAuthorization, {
                            isAllowed: isAllowedToRead,
                            _: _,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                                    id: "nav-mobile",
                                    role: "navigation",
                                    children: [
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                            id: "nav-mobile-logo",
                                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                                                id: "nav-mobile-count",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                    "unread-count": true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    unread: unreadItemsCount > 0
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                            "offline-count": true,
                                                            offline: offlineState,
                                                            online: !offlineState,
                                                            diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                        }),
                                                        children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ""
                                                    }),
                                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                        className: "count",
                                                        children: unreadItemsCount
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                                            id: "nav-mobile-settings",
                                            accessKey: "t",
                                            "aria-label": _("settingsbutton"),
                                            onClick: menuButtonOnClick,
                                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                                icon: $18f640b80ac26745$exports.faCog,
                                                size: "2x"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b90992e7bfaebf0a$exports))), {
                                    isOpen: !smartphone || navExpanded,
                                    className: "collapse-css-transition",
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                        id: "nav",
                                        role: "navigation",
                                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $117ab31dd2c08da6$export$2e2bcd8739ae039), {
                                            entriesPage: entriesPage,
                                            setNavExpanded: setNavExpanded,
                                            navSourcesExpanded: navSourcesExpanded,
                                            setNavSourcesExpanded: setNavSourcesExpanded,
                                            offlineState: offlineState,
                                            allItemsCount: allItemsCount,
                                            allItemsOfflineCount: allItemsOfflineCount,
                                            unreadItemsCount: unreadItemsCount,
                                            unreadItemsOfflineCount: unreadItemsOfflineCount,
                                            starredItemsCount: starredItemsCount,
                                            starredItemsOfflineCount: starredItemsOfflineCount,
                                            sourcesState: sourcesState,
                                            setSourcesState: setSourcesState,
                                            sources: sources,
                                            setSources: setSources,
                                            tags: tags,
                                            reloadAll: reloadAll
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                                    id: "search-list",
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $3bebfa7a3ec2ab2e$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                    id: "content",
                                    role: "main",
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $c1feef6a502006a1$export$b5d5cf8927ab7262), {
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$e7b0ac011bb776c6), {
                                                exact: true,
                                                path: "/",
                                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$2d8d895a0a0f636e), {
                                                    to: "/".concat(homePagePath.join("/"))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$e7b0ac011bb776c6), {
                                                path: (0, $0be080af3052783c$export$f1004941042944df),
                                                children: function(routeProps) {
                                                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $9b2cb125cea35be7$export$2e2bcd8739ae039), (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, routeProps), {
                                                        ref: entriesRef,
                                                        setNavExpanded: setNavExpanded,
                                                        configuration: configuration,
                                                        navSourcesExpanded: navSourcesExpanded,
                                                        unreadItemsCount: unreadItemsCount,
                                                        setGlobalUnreadCount: setGlobalUnreadCount
                                                    }));
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$e7b0ac011bb776c6), {
                                                path: "/manage/sources",
                                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $160db82a87133f5d$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $c1feef6a502006a1$export$e7b0ac011bb776c6), {
                                                path: "*",
                                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$NotFound, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
$e66869f90d0f9f3a$var$PureApp.propTypes = {
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    globalMessage: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf(Object.values((0, $d2d3ee75176c5e4c$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};
var $e66869f90d0f9f3a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $0951870dac564cbc$export$7e4530ad35d3bb8)(App, _React_Component);
    var _super = (0, $59441bceea5b2713$export$8dd05c13f5255580)(App);
    function App(props) {
        (0, $bcce38db0d2b4516$export$2996f80ef42b8419)(this, App);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            /**
             * tag repository
             */ tags: [],
            tagsState: (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL,
            /**
             * source repository
             */ sources: [],
            sourcesState: (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL,
            /**
             * true when sources in the sidebar are expanded
             * and we should fetch info about them in API requests.
             */ navSourcesExpanded: false,
            /**
             * whether off-line mode is enabled
             */ offlineState: false,
            /**
             * number of unread items
             */ unreadItemsCount: 0,
            /**
             * number of unread items available offline
             */ unreadItemsOfflineCount: 0,
            /**
             * number of starred items
             */ starredItemsCount: 0,
            /**
             * number of starred items available offline
             */ starredItemsOfflineCount: 0,
            /**
             * number of all items
             */ allItemsCount: 0,
            /**
             * number of all items available offline
             */ allItemsOfflineCount: 0,
            /**
             * Global message popup.
             * @var ?Object.{message: string, actions: Array.<Object.{label: string, callback: function>}, isError: bool}
             */ globalMessage: null
        };
        _this._ = _this._.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setTags = _this.setTags.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setTagsState = _this.setTagsState.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setSources = _this.setSources.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setSourcesState = _this.setSourcesState.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setOfflineState = _this.setOfflineState.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setNavSourcesExpanded = _this.setNavSourcesExpanded.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setUnreadItemsCount = _this.setUnreadItemsCount.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setUnreadItemsOfflineCount = _this.setUnreadItemsOfflineCount.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setStarredItemsCount = _this.setStarredItemsCount.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setStarredItemsOfflineCount = _this.setStarredItemsOfflineCount.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setAllItemsCount = _this.setAllItemsCount.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setAllItemsOfflineCount = _this.setAllItemsOfflineCount.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.setGlobalMessage = _this.setGlobalMessage.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        _this.reloadAll = _this.reloadAll.bind((0, $ee29917471fa094f$export$f3b8ed2e4a5d10b8)(_this));
        return _this;
    }
    (0, $53f3ce6e74f6aaad$export$d60067ff2358eee8)(App, [
        {
            key: "setTags",
            value: function setTags(tags) {
                if (typeof tags === "function") this.setState(function(state) {
                    return {
                        tags: tags(state.tags)
                    };
                });
                else this.setState({
                    tags: tags
                });
            }
        },
        {
            key: "setTagsState",
            value: function setTagsState(tagsState) {
                if (typeof tagsState === "function") this.setState(function(state) {
                    return {
                        tagsState: tagsState(state.tagsState)
                    };
                });
                else this.setState({
                    tagsState: tagsState
                });
            }
        },
        {
            key: "setSources",
            value: function setSources(sources) {
                if (typeof sources === "function") this.setState(function(state) {
                    return {
                        sources: sources(state.sources)
                    };
                });
                else this.setState({
                    sources: sources
                });
            }
        },
        {
            key: "setSourcesState",
            value: function setSourcesState(sourcesState) {
                if (typeof sourcesState === "function") this.setState(function(state) {
                    return {
                        sourcesState: sourcesState(state.sourcesState)
                    };
                });
                else this.setState({
                    sourcesState: sourcesState
                });
            }
        },
        {
            key: "setOfflineState",
            value: function setOfflineState(offlineState) {
                if (typeof offlineState === "function") this.setState(function(state) {
                    return {
                        offlineState: offlineState(state.offlineState)
                    };
                });
                else this.setState({
                    offlineState: offlineState
                });
            }
        },
        {
            key: "setNavSourcesExpanded",
            value: function setNavSourcesExpanded(navSourcesExpanded) {
                if (typeof navSourcesExpanded === "function") this.setState(function(state) {
                    return {
                        navSourcesExpanded: navSourcesExpanded(state.navSourcesExpanded)
                    };
                });
                else this.setState({
                    navSourcesExpanded: navSourcesExpanded
                });
            }
        },
        {
            key: "setUnreadItemsCount",
            value: function setUnreadItemsCount(unreadItemsCount) {
                if (typeof unreadItemsCount === "function") this.setState(function(state) {
                    return {
                        unreadItemsCount: unreadItemsCount(state.unreadItemsCount)
                    };
                });
                else this.setState({
                    unreadItemsCount: unreadItemsCount
                });
            }
        },
        {
            key: "setUnreadItemsOfflineCount",
            value: function setUnreadItemsOfflineCount(unreadItemsOfflineCount) {
                if (typeof unreadItemsOfflineCount === "function") this.setState(function(state) {
                    return {
                        unreadItemsOfflineCount: unreadItemsOfflineCount(state.unreadItemsOfflineCount)
                    };
                });
                else this.setState({
                    unreadItemsOfflineCount: unreadItemsOfflineCount
                });
            }
        },
        {
            key: "setStarredItemsCount",
            value: function setStarredItemsCount(starredItemsCount) {
                if (typeof starredItemsCount === "function") this.setState(function(state) {
                    return {
                        starredItemsCount: starredItemsCount(state.starredItemsCount)
                    };
                });
                else this.setState({
                    starredItemsCount: starredItemsCount
                });
            }
        },
        {
            key: "setStarredItemsOfflineCount",
            value: function setStarredItemsOfflineCount(starredItemsOfflineCount) {
                if (typeof starredItemsOfflineCount === "function") this.setState(function(state) {
                    return {
                        starredItemsOfflineCount: starredItemsOfflineCount(state.starredItemsOfflineCount)
                    };
                });
                else this.setState({
                    starredItemsOfflineCount: starredItemsOfflineCount
                });
            }
        },
        {
            key: "setAllItemsCount",
            value: function setAllItemsCount(allItemsCount) {
                if (typeof allItemsCount === "function") this.setState(function(state) {
                    return {
                        allItemsCount: allItemsCount(state.allItemsCount)
                    };
                });
                else this.setState({
                    allItemsCount: allItemsCount
                });
            }
        },
        {
            key: "setAllItemsOfflineCount",
            value: function setAllItemsOfflineCount(allItemsOfflineCount) {
                if (typeof allItemsOfflineCount === "function") this.setState(function(state) {
                    return {
                        allItemsOfflineCount: allItemsOfflineCount(state.allItemsOfflineCount)
                    };
                });
                else this.setState({
                    allItemsOfflineCount: allItemsOfflineCount
                });
            }
        },
        {
            key: "setGlobalMessage",
            value: function setGlobalMessage(globalMessage) {
                if (typeof globalMessage === "function") this.setState(function(state) {
                    return {
                        globalMessage: globalMessage(state.globalMessage)
                    };
                });
                else this.setState({
                    globalMessage: globalMessage
                });
            }
        },
        {
            /**
     * Triggers fetching news from all sources.
     * @return Promise<undefined>
     */ key: "reloadAll",
            value: function reloadAll() {
                var _this = this;
                if (!selfoss.isOnline()) return Promise.resolve();
                return $b0e03640e062f6f9$export$c5eb18431f66026b().then(function() {
                    // probe stats and prompt reload to the user
                    selfoss.dbOnline.sync().then(function() {
                        if (_this.state.unreadItemsCount > 0) _this.showMessage(_this._("sources_refreshed"), [
                            {
                                label: _this._("reload_list"),
                                callback: function() {
                                    document.querySelector("#nav-filter-unread").click();
                                }
                            }
                        ]);
                    });
                }).catch(function(error) {
                    _this.showError(_this._("error_refreshing_source") + " " + error.message);
                });
            }
        },
        {
            /**
    * Obtain a localized message for given key, substituting placeholders for values, when given.
    * @param string key
    * @param ?array parameters
    * @return string
    */ key: "_",
            value: function _(identifier, params) {
                var fallbackLanguage = "en";
                var langKey = "lang_".concat(identifier);
                var preferredLanguage = this.props.configuration.language;
                // locale auto-detection
                if (preferredLanguage === null) {
                    if ("languages" in navigator) preferredLanguage = navigator.languages.find(function(lang) {
                        return Object.keys((0, $8d9b32747b35afdf$export$2e2bcd8739ae039)).includes(lang);
                    });
                }
                if (!Object.keys((0, $8d9b32747b35afdf$export$2e2bcd8739ae039)).includes(preferredLanguage)) preferredLanguage = fallbackLanguage;
                var translated = (0, $8d9b32747b35afdf$export$2e2bcd8739ae039)[preferredLanguage][langKey] || (0, $8d9b32747b35afdf$export$2e2bcd8739ae039)[fallbackLanguage][langKey] || "#untranslated:".concat(identifier);
                if (params) translated = (0, $7e577f35f270614e$export$e51161e9fbfde80e)(translated, params);
                return translated;
            }
        },
        {
            /**
     * Show error message in the message bar in the UI.
     *
     * @param {string} message
     * @return void
     */ key: "showError",
            value: function showError(message) {
                this.showMessage(message, [], true);
            }
        },
        {
            /**
     * Show message in the message bar in the UI.
     *
     * @param {string} message
     * @param {Array.<Object.{label: string, callback: function>} actions
     * @param {bool} isError
     * @return void
     */ key: "showMessage",
            value: function showMessage(message) {
                var actions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.setGlobalMessage({
                    message: message,
                    actions: actions,
                    isError: isError
                });
            }
        },
        {
            key: "notifyNewVersion",
            value: function notifyNewVersion(cb) {
                if (!cb) cb = function() {
                    window.location.reload();
                };
                this.showMessage(this._("app_update"), [
                    {
                        label: this._("app_reload"),
                        callback: cb
                    }
                ]);
            }
        },
        {
            key: "refreshTagSourceUnread",
            value: function refreshTagSourceUnread(tagCounts, sourceCounts) {
                var diff = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                this.setTags(function(tags) {
                    return tags.map(function(tag) {
                        if (!(tag.tag in tagCounts)) return tag;
                        var unread;
                        if (diff) unread = tag.unread + tagCounts[tag.tag];
                        else unread = tagCounts[tag.tag];
                        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, tag), {
                            unread: unread
                        });
                    });
                });
                this.setSources(function(sources) {
                    return sources.map(function(source) {
                        if (!(source.id in sourceCounts)) return source;
                        var unread;
                        if (diff) unread = source.unread + sourceCounts[source.id];
                        else unread = sourceCounts[source.id];
                        return (0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, source), {
                            unread: unread
                        });
                    });
                });
            }
        },
        {
            key: "refreshOfflineCounts",
            value: function refreshOfflineCounts(offlineCounts) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(offlineCounts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(_step.value, 2), kind = _step_value[0], newCount = _step_value[1];
                        if (newCount === "keep") continue;
                        if (kind === "unread") this.setUnreadItemsOfflineCount(newCount);
                        else if (kind === "starred") this.setStarredItemsOfflineCount(newCount);
                        else if (kind === "newest") this.setAllItemsOfflineCount(newCount);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e).Provider, {
                    value: this.props.configuration,
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $7e577f35f270614e$export$51216bcc3983e55d).Provider, {
                        value: this._,
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$PureApp, {
                            navSourcesExpanded: this.state.navSourcesExpanded,
                            setNavSourcesExpanded: this.setNavSourcesExpanded,
                            offlineState: this.state.offlineState,
                            allItemsCount: this.state.allItemsCount,
                            allItemsOfflineCount: this.state.allItemsOfflineCount,
                            unreadItemsCount: this.state.unreadItemsCount,
                            unreadItemsOfflineCount: this.state.unreadItemsOfflineCount,
                            starredItemsCount: this.state.starredItemsCount,
                            starredItemsOfflineCount: this.state.starredItemsOfflineCount,
                            globalMessage: this.state.globalMessage,
                            sourcesState: this.state.sourcesState,
                            setSourcesState: this.setSourcesState,
                            sources: this.state.sources,
                            setSources: this.setSources,
                            tags: this.state.tags,
                            reloadAll: this.reloadAll
                        })
                    })
                });
            }
        }
    ]);
    return App;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
$e66869f90d0f9f3a$export$2e2bcd8739ae039.propTypes = {
    configuration: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired
};
function $e66869f90d0f9f3a$export$4e373c34abfa8c68(param) {
    var basePath = param.basePath, appRef = param.appRef, configuration = param.configuration;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $23454774ad668d69$export$9ba4e89fdfa1fc54), {
        basename: basePath,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$export$2e2bcd8739ae039, {
            ref: appRef,
            configuration: configuration
        })
    });
}


var $c6e809863a98343e$exports = {};

$c6e809863a98343e$exports = (parcelRequire("aBozd")).getBundleURL("gtLjG") + "selfoss-sw-offline.js";


/**
 * base javascript application
 *
 * @package    public_js
 * @copyright  Copyright (c) Tobias Zeising (http://www.aditu.de)
 * @license    GPLv3 (https://www.gnu.org/licenses/gpl-3.0.html)
 */ var $b40329ab00dcedb3$var$selfoss = {
    /**
     * The main App component.
     * @var App
     */ app: null,
    /**
     * React component for entries page.
     */ entriesPage: null,
    serviceWorkerInitialized: false,
    /**
     * Whether lightbox is open.
     */ lightboxActive: new (0, $e721f0b5888adce1$export$8fa6ce44b7b131e9)(false),
    init: /**
     * initialize application
     */ function() {
        return (0, $14c571840e589f0e$export$7c398597f8905a1)(function() {
            var storedConfig, oldConfiguration, configurationToUse, configuration;
            return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Load off-line mode enabledness.
                        $b40329ab00dcedb3$var$selfoss.db.enableOffline.update(window.localStorage.getItem("enableOffline") === "true");
                        // Ignore stored config when off-line mode is disabled, since it is likely stale.
                        storedConfig = $b40329ab00dcedb3$var$selfoss.db.enableOffline.value ? localStorage.getItem("configuration") : null;
                        oldConfiguration = null;
                        try {
                            oldConfiguration = storedConfig !== null ? JSON.parse(storedConfig) : null;
                        } catch (e) {
                        // We will try to obtain a new configuration anyway.
                        }
                        // Fall back to the last cached config on failure.
                        configurationToUse = oldConfiguration;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            7,
                            11
                        ]);
                        return [
                            4,
                            (0, $5be8e377f991f791$export$1d2e6bc0307ffd89)()
                        ];
                    case 2:
                        configuration = _state.sent().configuration;
                        configurationToUse = configuration;
                        if (!("caches" in window && "serviceWorker" in navigator)) return [
                            3,
                            6
                        ];
                        if (!(oldConfiguration === null || oldConfiguration.userCss !== configuration.userCss)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            caches.delete("userCss")
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (!(oldConfiguration === null || oldConfiguration.userJs !== configuration.userJs)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            caches.delete("userJs")
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            11
                        ];
                    case 7:
                        if (!configurationToUse) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            $b40329ab00dcedb3$var$selfoss.initMain(configurationToUse)
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            10
                        ];
                    case 9:
                        // TODO: Add a more proper error page
                        document.body.innerHTML = $b40329ab00dcedb3$var$selfoss.app._("error_configuration");
                        _state.label = 10;
                    case 10:
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    initMain: function(configuration) {
        return (0, $14c571840e589f0e$export$7c398597f8905a1)(function() {
            var feedLink, link, script;
            return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                $b40329ab00dcedb3$var$selfoss.config = configuration;
                if ($b40329ab00dcedb3$var$selfoss.db.enableOffline.value) $b40329ab00dcedb3$var$selfoss.setupServiceWorker();
                if (configuration.language !== null) document.documentElement.setAttribute("lang", configuration.language);
                document.querySelector('meta[name="application-name"]').setAttribute("content", configuration.htmlTitle);
                feedLink = document.createElement("link");
                feedLink.setAttribute("rel", "alternate");
                feedLink.setAttribute("type", "application/rss+xml");
                feedLink.setAttribute("title", "RSS Feed");
                feedLink.setAttribute("href", "feed");
                document.head.appendChild(feedLink);
                if (configuration.userCss !== null) {
                    link = document.createElement("link");
                    link.setAttribute("rel", "stylesheet");
                    link.setAttribute("href", "user.css?v=".concat(configuration.userCss));
                    document.head.appendChild(link);
                }
                if (configuration.userJs !== null) {
                    script = document.createElement("script");
                    script.setAttribute("src", "user.js?v=".concat(configuration.userJs));
                    document.body.appendChild(script);
                }
                // init offline if supported
                $b40329ab00dcedb3$var$selfoss.dbOffline.init();
                if (configuration.authEnabled) $b40329ab00dcedb3$var$selfoss.loggedin.update(window.localStorage.getItem("onlineSession") == "true");
                $b40329ab00dcedb3$var$selfoss.attachApp(configuration);
                return [
                    2
                ];
            });
        })();
    },
    /**
     * Create basic DOM structure of the page.
     */ attachApp: function(configuration) {
        var _document_getElementById;
        (_document_getElementById = document.getElementById("js-loading-message")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.remove();
        var mainUi = document.createElement("div");
        document.body.appendChild(mainUi);
        mainUi.classList.add("app-toplevel");
        // BrowserRouter expects no slash at the end.
        var basePath = new URL(document.baseURI).pathname.replace(/\/$/, "");
        var root = (0, $59e7dcc9c52865c1$export$882461b6382ed46c)(mainUi);
        root.render((0, $e66869f90d0f9f3a$export$4e373c34abfa8c68)({
            basePath: basePath,
            appRef: function(app) {
                $b40329ab00dcedb3$var$selfoss.app = app;
            },
            configuration: configuration
        }));
    },
    loggedin: new (0, $e721f0b5888adce1$export$8fa6ce44b7b131e9)(false),
    setSession: function() {
        window.localStorage.setItem("onlineSession", true);
        $b40329ab00dcedb3$var$selfoss.loggedin.update(true);
    },
    clearSession: function() {
        window.localStorage.removeItem("onlineSession");
        $b40329ab00dcedb3$var$selfoss.loggedin.update(false);
    },
    hasSession: function() {
        return $b40329ab00dcedb3$var$selfoss.loggedin.value;
    },
    /**
     * Try to log in using given credentials
     * @return Promise<undefined>
     */ login: function(param) {
        var configuration = param.configuration, username = param.username, password = param.password, enableOffline = param.enableOffline;
        $b40329ab00dcedb3$var$selfoss.db.enableOffline.update(enableOffline);
        window.localStorage.setItem("enableOffline", $b40329ab00dcedb3$var$selfoss.db.enableOffline.value);
        if (!$b40329ab00dcedb3$var$selfoss.db.enableOffline.value) $b40329ab00dcedb3$var$selfoss.db.clear();
        var credentials = {
            username: username,
            password: password
        };
        return (0, $5be8e377f991f791$export$596d806903d1f59e)(credentials).then(function() {
            $b40329ab00dcedb3$var$selfoss.setSession();
            // init offline if supported and not inited yet
            $b40329ab00dcedb3$var$selfoss.dbOffline.init();
            if ((!$b40329ab00dcedb3$var$selfoss.db.storage || $b40329ab00dcedb3$var$selfoss.db.broken) && $b40329ab00dcedb3$var$selfoss.db.enableOffline.value) {
                // Initialize database in offline mode when it has not been initialized yet or it got broken.
                $b40329ab00dcedb3$var$selfoss.dbOffline.init();
                // Store config for off-line use.
                localStorage.setItem("configuration", JSON.stringify(configuration));
                // Cache user files manually since service worker is not aware of them.
                if ("caches" in window && "serviceWorker" in navigator) {
                    caches.open("userCss").then(function(cache) {
                        return cache.add("user.css?v=".concat(configuration.userCss));
                    });
                    caches.open("userJs").then(function(cache) {
                        return cache.add("user.js?v=".concat(configuration.userJs));
                    });
                }
                $b40329ab00dcedb3$var$selfoss.setupServiceWorker();
            }
        });
    },
    setupServiceWorker: function() {
        if (!("serviceWorker" in navigator) || $b40329ab00dcedb3$var$selfoss.serviceWorkerInitialized) return;
        $b40329ab00dcedb3$var$selfoss.serviceWorkerInitialized = true;
        navigator.serviceWorker.addEventListener("controllerchange", function() {
            window.location.reload();
        });
        navigator.serviceWorker.register($c6e809863a98343e$exports).then(function(reg) {
            $b40329ab00dcedb3$var$selfoss.listenWaitingSW(reg, function(reg) {
                $b40329ab00dcedb3$var$selfoss.app.notifyNewVersion(function() {
                    if (reg.waiting) reg.waiting.postMessage("skipWaiting");
                });
            });
        });
    },
    logout: function() {
        return (0, $14c571840e589f0e$export$7c398597f8905a1)(function() {
            var error;
            return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $b40329ab00dcedb3$var$selfoss.clearSession();
                        $b40329ab00dcedb3$var$selfoss.db.clear(); // will not work after a failure, since storage is nulled
                        window.localStorage.clear();
                        if ("serviceWorker" in navigator) {
                            if ("caches" in window) caches.keys().then(function(keys) {
                                return keys.forEach(function(key) {
                                    return caches.delete(key);
                                });
                            });
                            navigator.serviceWorker.getRegistrations().then(function(registrations) {
                                registrations.forEach(function(reg) {
                                    reg.unregister();
                                });
                            });
                            $b40329ab00dcedb3$var$selfoss.serviceWorkerInitialized = false;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $5be8e377f991f791$export$a0973bcfe11b05c9)()
                        ];
                    case 2:
                        _state.sent();
                        if (!$b40329ab00dcedb3$var$selfoss.config.publicMode) $b40329ab00dcedb3$var$selfoss.history.push("/sign/in");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        $b40329ab00dcedb3$var$selfoss.app.showError($b40329ab00dcedb3$var$selfoss.app._("error_logout") + " " + error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    /**
     * Checks whether the current user is allowed to perform read operations.
     *
     * @returns {boolean}
     */ isAllowedToRead: function() {
        return $b40329ab00dcedb3$var$selfoss.hasSession() || !$b40329ab00dcedb3$var$selfoss.config.authEnabled || $b40329ab00dcedb3$var$selfoss.config.publicMode;
    },
    /**
     * Checks whether the current user is allowed to perform update-tier operations.
     *
     * @returns {boolean}
     */ isAllowedToUpdate: function() {
        return $b40329ab00dcedb3$var$selfoss.hasSession() || !$b40329ab00dcedb3$var$selfoss.config.authEnabled || $b40329ab00dcedb3$var$selfoss.config.allowPublicUpdate;
    },
    /**
     * Checks whether the current user is allowed to perform write operations.
     *
     * @returns {boolean}
     */ isAllowedToWrite: function() {
        return $b40329ab00dcedb3$var$selfoss.hasSession() || !$b40329ab00dcedb3$var$selfoss.config.authEnabled;
    },
    /**
     * Checks whether the current user is allowed to perform write operations.
     *
     * @returns {boolean}
     */ isOnline: function() {
        return $b40329ab00dcedb3$var$selfoss.db.online;
    },
    /**
     * indicates whether a mobile device is host
     *
     * @return true if device resolution smaller equals 1024
     */ isMobile: function() {
        // first check useragent
        if (/iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent)) return true;
        // otherwise check resolution
        return $b40329ab00dcedb3$var$selfoss.isTablet() || $b40329ab00dcedb3$var$selfoss.isSmartphone();
    },
    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ isTablet: function() {
        if (document.body.clientWidth <= 1024) return true;
        return false;
    },
    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ isSmartphone: function() {
        if (document.body.clientWidth <= 640) return true;
        return false;
    },
    /**
     * Override these functions to customize selfoss behaviour.
     */ extensionPoints: {
        /**
         * Called when an article is first expanded.
         * @param {HTMLElement} HTML element containing the article contents
         */ processItemContents: function() {}
    },
    /**
     * refresh stats.
     *
     * @return void
     * @param {Number} new all stats
     * @param {Number} new unread stats
     * @param {Number} new starred stats
     */ refreshStats: function(all, unread, starred) {
        $b40329ab00dcedb3$var$selfoss.app.setAllItemsCount(all);
        $b40329ab00dcedb3$var$selfoss.app.setStarredItemsCount(starred);
        $b40329ab00dcedb3$var$selfoss.refreshUnread(unread);
    },
    /**
     * refresh unread stats.
     *
     * @return void
     * @param {Number} new unread stats
     */ refreshUnread: function(unread) {
        $b40329ab00dcedb3$var$selfoss.app.setUnreadItemsCount(unread);
    },
    /**
     * refresh current tags.
     *
     * @return void
     */ reloadTags: function() {
        $b40329ab00dcedb3$var$selfoss.app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
        (0, $bcc58ea15e13e580$export$c36f611d5eb39a7)().then(function(data) {
            $b40329ab00dcedb3$var$selfoss.app.setTags(data);
            $b40329ab00dcedb3$var$selfoss.app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
        }).catch(function(error) {
            $b40329ab00dcedb3$var$selfoss.app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
            $b40329ab00dcedb3$var$selfoss.app.showError($b40329ab00dcedb3$var$selfoss.app._("error_load_tags") + " " + error.message);
        });
    },
    handleAjaxError: function(error) {
        var tryOffline = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _error_response;
        if (!(error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) || error instanceof (0, $0d06257c362dc1a1$export$66d311bf29d5c89c))) return Promise.reject(error);
        var httpCode = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) || 0;
        if (tryOffline && httpCode != 403) return $b40329ab00dcedb3$var$selfoss.db.setOffline();
        else return Promise.reject(error);
    },
    listenWaitingSW: function(reg, callback) {
        var awaitStateChange = function() {
            reg.installing.addEventListener("statechange", function(event) {
                if (event.target.state === "installed") callback(reg);
            });
        };
        if (!reg) return;
        else if (reg.waiting) return callback(reg);
        else if (reg.installing) {
            awaitStateChange();
            reg.addEventListener("updatefound", awaitStateChange);
        }
    },
    // Include helpers for user scripts.
    ajax: $32ae13b741542474$exports
};
var $b40329ab00dcedb3$export$2e2bcd8739ae039 = $b40329ab00dcedb3$var$selfoss;








(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline = {
    syncing: {
        promise: null,
        request: null,
        resolve: null,
        reject: null
    },
    statsDirty: false,
    firstSync: true,
    _syncBegin: function() {
        if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise = new Promise(function(resolve, reject) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.resolve = resolve;
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.reject = reject;
                var monitor = window.setInterval(function() {
                    var stopChecking = false;
                    if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
                        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.userWaiting) {
                            // reject if user has been waiting for more than 10s,
                            // this means that connectivity is bad: user will get
                            // local content and server request will continue in
                            // the background.
                            reject();
                            stopChecking = true;
                        }
                    } else stopChecking = true;
                    if (stopChecking) window.clearInterval(monitor);
                }, 10000);
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise.finally(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise = null;
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.userWaiting = false;
            });
        }
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise;
    },
    _syncDone: function() {
        var success = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
            if (success) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.resolve();
            else {
                var request = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.request;
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.reject();
                if (request) request.controller.abort();
            }
        }
    },
    /**
     * sync server status.
     *
     * @return Promise
     */ sync: function(updatedStatuses, chained) {
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise && !chained) {
            if (updatedStatuses) // Ensure the status queue is not cleared and gets sync'ed at
            // next sync.
            return Promise.reject();
            else return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise;
        }
        var syncing = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncBegin();
        var getStatuses = true;
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate === null || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.firstSync) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = new Date(0);
            getStatuses = undefined;
        }
        var syncParams = {
            since: (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate,
            tags: true,
            sources: (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.navSourcesExpanded || undefined,
            itemsStatuses: getStatuses
        };
        if (updatedStatuses && updatedStatuses.length > 0) syncParams.updatedStatuses = updatedStatuses;
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value) {
            syncParams.itemsSinceId = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId;
            syncParams.itemsNotBefore = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry;
            syncParams.itemsHowMany = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.itemsPerPage;
        }
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.statsDirty = false;
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.request = $8ef3cedac61156e9$export$92d6409d68f0739a(updatedStatuses, syncParams);
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.request.promise.then(function(data) {
            var _selfoss_entriesPage;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.setOnline();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastSync = Date.now();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.firstSync = false;
            var dataDate = data.lastUpdate;
            var storing = false;
            if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value) {
                if ("newItems" in data) {
                    var maxId = 0;
                    data.newItems.forEach(function(item) {
                        maxId = Math.max(item.id, maxId);
                    });
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing = "lastId" in data && data.lastId > (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId && data.lastId > maxId;
                    storing = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing;
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline = "lastId" in data && data.lastId - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId > 2 * (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.itemsPerPage;
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeEntries(data.newItems).then(function() {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncDone();
                    });
                }
                if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync) // There are still new items to fetch
                // or statuses to send
                syncing.then(function() {
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
                });
                if ("itemUpdates" in data) // refresh entry statuses in db and dequeue queued
                // statuses but do not calculate stats as they are taken
                // directly from the server as provided.
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses(data.itemUpdates, true, false).then(function() {
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                });
                if ("stats" in data) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeStats(data.stats);
            }
            if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.statsDirty && "stats" in data) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).refreshStats(data.stats.total, data.stats.unread, data.stats.starred);
            if ("tags" in data) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setTags(data.tags);
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            }
            if ("sources" in data) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setSources(data.sources);
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            }
            if ("stats" in data && data.stats.unread > 0 && (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage && ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.state.entries.length === 0 || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.state.entries.loadingState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE)) (_selfoss_entriesPage = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
            else {
                if ("itemUpdates" in data) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.refreshEntryStatuses(data.itemUpdates);
                if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage && (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.getActiveFilter() === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD) {
                    var unreadCount = "stats" in data ? data.stats.unread : (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.unreadItemsCount;
                    if (unreadCount > (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.state.entries.filter(function(param) {
                        var unread = param.unread;
                        return unread == 1;
                    }).length) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.setHasMore(true);
                }
            }
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = dataDate;
            if (!storing) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncDone();
        }).catch(function(error) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncDone(false);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).handleAjaxError(error).catch(function(error) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app._("error_sync") + " " + error.message);
            });
        }).finally(function() {
            if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.request = null;
        });
        return syncing;
    },
    /**
     * refresh current items.
     *
     * @return void
     */ getEntries: function(fetchParams, abortController) {
        return $8ef3cedac61156e9$export$d2f92acf417bbf5d((0, $715bf31211e65705$export$4fa2f4023c9cbda5)((0, $fa9769297b8a68c8$export$581ff339ea0ba762)({}, fetchParams), {
            itemsPerPage: (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.itemsPerPage
        }), abortController).then(function(data) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.setOnline();
            if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastSync = Date.now();
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = data.lastUpdate;
            }
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).refreshStats(data.all, data.unread, data.starred);
            // update tags
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setTags(data.tags);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            if (typeof data.sources !== "undefined" && (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.navSourcesExpanded) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setSources(data.sources);
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            }
            return {
                entries: data.entries,
                hasMore: data.hasMore
            };
        }).catch(function(error) {
            if (error.name === "AbortError") return;
            return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).handleAjaxError(error).then(function() {
                return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.getEntries(fetchParams);
            });
        });
    }
};






/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 3.2.4, Tue May 30 2023
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ 
var $2bfPH = parcelRequire("2bfPH");
var $bc26ee8cec700381$var$__assign = function __assign1() {
    $bc26ee8cec700381$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc26ee8cec700381$var$__assign.apply(this, arguments);
};
function $bc26ee8cec700381$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $bc26ee8cec700381$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
var $bc26ee8cec700381$var$keys = Object.keys;
var $bc26ee8cec700381$var$isArray = Array.isArray;
if (typeof Promise !== "undefined" && !$bc26ee8cec700381$var$_global.Promise) $bc26ee8cec700381$var$_global.Promise = Promise;
function $bc26ee8cec700381$var$extend(obj, extension) {
    if (typeof extension !== "object") return obj;
    $bc26ee8cec700381$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $bc26ee8cec700381$var$getProto = Object.getPrototypeOf;
var $bc26ee8cec700381$var$_hasOwn = {}.hasOwnProperty;
function $bc26ee8cec700381$var$hasOwn(obj, prop) {
    return $bc26ee8cec700381$var$_hasOwn.call(obj, prop);
}
function $bc26ee8cec700381$var$props(proto, extension) {
    if (typeof extension === "function") extension = extension($bc26ee8cec700381$var$getProto(proto));
    (typeof Reflect === "undefined" ? $bc26ee8cec700381$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $bc26ee8cec700381$var$setProp(proto, key, extension[key]);
    });
}
var $bc26ee8cec700381$var$defineProperty = Object.defineProperty;
function $bc26ee8cec700381$var$setProp(obj, prop, functionOrGetSet, options) {
    $bc26ee8cec700381$var$defineProperty(obj, prop, $bc26ee8cec700381$var$extend(functionOrGetSet && $bc26ee8cec700381$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $bc26ee8cec700381$var$derive(Child) {
    return {
        from: function from(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $bc26ee8cec700381$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $bc26ee8cec700381$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $bc26ee8cec700381$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $bc26ee8cec700381$var$getPropertyDescriptor(obj, prop) {
    var pd = $bc26ee8cec700381$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $bc26ee8cec700381$var$getProto(obj)) && $bc26ee8cec700381$var$getPropertyDescriptor(proto, prop);
}
var $bc26ee8cec700381$var$_slice = [].slice;
function $bc26ee8cec700381$var$slice(args, start, end) {
    return $bc26ee8cec700381$var$_slice.call(args, start, end);
}
function $bc26ee8cec700381$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $bc26ee8cec700381$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $bc26ee8cec700381$var$asap$1(fn) {
    if ($bc26ee8cec700381$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $bc26ee8cec700381$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $bc26ee8cec700381$var$tryCatch(fn, onerror, args) {
    try {
        fn.apply(null, args);
    } catch (ex) {
        onerror && onerror(ex);
    }
}
function $bc26ee8cec700381$var$getByKeyPath(obj, keyPath) {
    if ($bc26ee8cec700381$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== "string") {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $bc26ee8cec700381$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf(".");
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj === undefined ? undefined : $bc26ee8cec700381$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ("isFrozen" in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== "string" && "length" in keyPath) {
        $bc26ee8cec700381$var$assert(typeof value !== "string" && "length" in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$bc26ee8cec700381$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf(".");
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($bc26ee8cec700381$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$bc26ee8cec700381$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $bc26ee8cec700381$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($bc26ee8cec700381$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $bc26ee8cec700381$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string") $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, undefined);
    else if ("length" in keyPath) [].map.call(keyPath, function(kp) {
        $bc26ee8cec700381$var$setByKeyPath(obj, kp, undefined);
    });
}
function $bc26ee8cec700381$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($bc26ee8cec700381$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $bc26ee8cec700381$var$concat = [].concat;
function $bc26ee8cec700381$var$flatten(a) {
    return $bc26ee8cec700381$var$concat.apply([], a);
}
var $bc26ee8cec700381$var$intrinsicTypeNames = "Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat($bc26ee8cec700381$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $bc26ee8cec700381$var$_global[t];
});
var $bc26ee8cec700381$var$intrinsicTypes = $bc26ee8cec700381$var$intrinsicTypeNames.map(function(t) {
    return $bc26ee8cec700381$var$_global[t];
});
$bc26ee8cec700381$var$arrayToObject($bc26ee8cec700381$var$intrinsicTypeNames, function(x) {
    return [
        x,
        true
    ];
});
var $bc26ee8cec700381$var$circularRefs = null;
function $bc26ee8cec700381$var$deepClone(any) {
    $bc26ee8cec700381$var$circularRefs = typeof WeakMap !== "undefined" && new WeakMap();
    var rv = $bc26ee8cec700381$var$innerDeepClone(any);
    $bc26ee8cec700381$var$circularRefs = null;
    return rv;
}
function $bc26ee8cec700381$var$innerDeepClone(any) {
    if (!any || typeof any !== "object") return any;
    var rv = $bc26ee8cec700381$var$circularRefs && $bc26ee8cec700381$var$circularRefs.get(any);
    if (rv) return rv;
    if ($bc26ee8cec700381$var$isArray(any)) {
        rv = [];
        $bc26ee8cec700381$var$circularRefs && $bc26ee8cec700381$var$circularRefs.set(any, rv);
        for(var i = 0, l = any.length; i < l; ++i)rv.push($bc26ee8cec700381$var$innerDeepClone(any[i]));
    } else if ($bc26ee8cec700381$var$intrinsicTypes.indexOf(any.constructor) >= 0) rv = any;
    else {
        var proto = $bc26ee8cec700381$var$getProto(any);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $bc26ee8cec700381$var$circularRefs && $bc26ee8cec700381$var$circularRefs.set(any, rv);
        for(var prop in any)if ($bc26ee8cec700381$var$hasOwn(any, prop)) rv[prop] = $bc26ee8cec700381$var$innerDeepClone(any[prop]);
    }
    return rv;
}
var $bc26ee8cec700381$var$toString = {}.toString;
function $bc26ee8cec700381$var$toStringTag(o) {
    return $bc26ee8cec700381$var$toString.call(o).slice(8, -1);
}
var $bc26ee8cec700381$var$iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
var $bc26ee8cec700381$var$getIteratorOf = (typeof $bc26ee8cec700381$var$iteratorSymbol === "undefined" ? "undefined" : (0, $2bfPH._)($bc26ee8cec700381$var$iteratorSymbol)) === "symbol" ? function getIteratorOf(x) {
    var i;
    return x != null && (i = x[$bc26ee8cec700381$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
var $bc26ee8cec700381$var$NO_CHAR_ARRAY = {};
function $bc26ee8cec700381$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($bc26ee8cec700381$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $bc26ee8cec700381$var$NO_CHAR_ARRAY && typeof arrayLike === "string") return [
            arrayLike
        ];
        if (it = $bc26ee8cec700381$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === "number") {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $bc26ee8cec700381$var$isAsyncFunction = typeof Symbol !== "undefined" ? function isAsyncFunction(fn) {
    return fn[Symbol.toStringTag] === "AsyncFunction";
} : function() {
    return false;
};
var $bc26ee8cec700381$var$debug = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $bc26ee8cec700381$var$setDebug(value, filter) {
    $bc26ee8cec700381$var$debug = value;
    $bc26ee8cec700381$var$libraryFilter = filter;
}
var $bc26ee8cec700381$var$libraryFilter = function libraryFilter() {
    return true;
};
var $bc26ee8cec700381$var$NEEDS_THROW_FOR_STACK = !new Error("").stack;
function $bc26ee8cec700381$var$getErrorWithStack() {
    if ($bc26ee8cec700381$var$NEEDS_THROW_FOR_STACK) try {
        $bc26ee8cec700381$var$getErrorWithStack.arguments;
        throw new Error();
    } catch (e) {
        return e;
    }
    return new Error();
}
function $bc26ee8cec700381$var$prettyStack(exception, numIgnoredFrames) {
    var stack = exception.stack;
    if (!stack) return "";
    numIgnoredFrames = numIgnoredFrames || 0;
    if (stack.indexOf(exception.name) === 0) numIgnoredFrames += (exception.name + exception.message).split("\n").length;
    return stack.split("\n").slice(numIgnoredFrames).filter($bc26ee8cec700381$var$libraryFilter).map(function(frame) {
        return "\n" + frame;
    }).join("");
}
var $bc26ee8cec700381$var$dexieErrorNames = [
    "Modify",
    "Bulk",
    "OpenFailed",
    "VersionChange",
    "Schema",
    "Upgrade",
    "InvalidTable",
    "MissingAPI",
    "NoSuchDatabase",
    "InvalidArgument",
    "SubTransaction",
    "Unsupported",
    "Internal",
    "DatabaseClosed",
    "PrematureCommit",
    "ForeignAwait"
];
var $bc26ee8cec700381$var$idbDomErrorNames = [
    "Unknown",
    "Constraint",
    "Data",
    "TransactionInactive",
    "ReadOnly",
    "Version",
    "NotFound",
    "InvalidState",
    "InvalidAccess",
    "Abort",
    "Timeout",
    "QuotaExceeded",
    "Syntax",
    "DataClone"
];
var $bc26ee8cec700381$var$errorList = $bc26ee8cec700381$var$dexieErrorNames.concat($bc26ee8cec700381$var$idbDomErrorNames);
var $bc26ee8cec700381$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $bc26ee8cec700381$var$DexieError(name, msg) {
    this._e = $bc26ee8cec700381$var$getErrorWithStack();
    this.name = name;
    this.message = msg;
}
$bc26ee8cec700381$var$derive($bc26ee8cec700381$var$DexieError).from(Error).extend({
    stack: {
        get: function get() {
            return this._stack || (this._stack = this.name + ": " + this.message + $bc26ee8cec700381$var$prettyStack(this._e, 2));
        }
    },
    toString: function toString() {
        return this.name + ": " + this.message;
    }
});
function $bc26ee8cec700381$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join("\n");
}
function $bc26ee8cec700381$var$ModifyError(msg, failures, successCount, failedKeys) {
    this._e = $bc26ee8cec700381$var$getErrorWithStack();
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $bc26ee8cec700381$var$getMultiErrorMessage(msg, failures);
}
$bc26ee8cec700381$var$derive($bc26ee8cec700381$var$ModifyError).from($bc26ee8cec700381$var$DexieError);
function $bc26ee8cec700381$var$BulkError(msg, failures) {
    this._e = $bc26ee8cec700381$var$getErrorWithStack();
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $bc26ee8cec700381$var$getMultiErrorMessage(msg, failures);
}
$bc26ee8cec700381$var$derive($bc26ee8cec700381$var$BulkError).from($bc26ee8cec700381$var$DexieError);
var $bc26ee8cec700381$var$errnames = $bc26ee8cec700381$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $bc26ee8cec700381$var$BaseException = $bc26ee8cec700381$var$DexieError;
var $bc26ee8cec700381$var$exceptions = $bc26ee8cec700381$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this._e = $bc26ee8cec700381$var$getErrorWithStack();
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $bc26ee8cec700381$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === "string") {
            this.message = "" + msgOrInner + (!inner ? "" : "\n " + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === "object") {
            this.message = msgOrInner.name + " " + msgOrInner.message;
            this.inner = msgOrInner;
        }
    }
    $bc26ee8cec700381$var$derive(DexieError).from($bc26ee8cec700381$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$bc26ee8cec700381$var$exceptions.Syntax = SyntaxError;
$bc26ee8cec700381$var$exceptions.Type = TypeError;
$bc26ee8cec700381$var$exceptions.Range = RangeError;
var $bc26ee8cec700381$var$exceptionMap = $bc26ee8cec700381$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $bc26ee8cec700381$var$exceptions[name];
    return obj;
}, {});
function $bc26ee8cec700381$var$mapError(domError, message) {
    if (!domError || domError instanceof $bc26ee8cec700381$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$bc26ee8cec700381$var$exceptionMap[domError.name]) return domError;
    var rv = new $bc26ee8cec700381$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $bc26ee8cec700381$var$setProp(rv, "stack", {
        get: function get() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $bc26ee8cec700381$var$fullNameExceptions = $bc26ee8cec700381$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $bc26ee8cec700381$var$exceptions[name];
    return obj;
}, {});
$bc26ee8cec700381$var$fullNameExceptions.ModifyError = $bc26ee8cec700381$var$ModifyError;
$bc26ee8cec700381$var$fullNameExceptions.DexieError = $bc26ee8cec700381$var$DexieError;
$bc26ee8cec700381$var$fullNameExceptions.BulkError = $bc26ee8cec700381$var$BulkError;
function $bc26ee8cec700381$var$nop() {}
function $bc26ee8cec700381$var$mirror(val) {
    return val;
}
function $bc26ee8cec700381$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $bc26ee8cec700381$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $bc26ee8cec700381$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $bc26ee8cec700381$var$hookCreatingChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $bc26ee8cec700381$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $bc26ee8cec700381$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $bc26ee8cec700381$var$hookDeletingChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $bc26ee8cec700381$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $bc26ee8cec700381$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $bc26ee8cec700381$var$hookUpdatingChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $bc26ee8cec700381$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $bc26ee8cec700381$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $bc26ee8cec700381$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $bc26ee8cec700381$var$extend(res, res2);
    };
}
function $bc26ee8cec700381$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $bc26ee8cec700381$var$promisableChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === "function") {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $bc26ee8cec700381$var$INTERNAL = {};
var $bc26ee8cec700381$var$LONG_STACKS_CLIP_LIMIT = 100, $bc26ee8cec700381$var$MAX_LONG_STACKS = 20, $bc26ee8cec700381$var$ZONE_ECHO_LIMIT = 100, $bc26ee8cec700381$var$_a$1 = typeof Promise === "undefined" ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === "undefined" || !crypto.subtle) return [
        globalP,
        $bc26ee8cec700381$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $bc26ee8cec700381$var$getProto(nativeP),
        globalP
    ];
}(), $bc26ee8cec700381$var$resolvedNativePromise = $bc26ee8cec700381$var$_a$1[0], $bc26ee8cec700381$var$nativePromiseProto = $bc26ee8cec700381$var$_a$1[1], $bc26ee8cec700381$var$resolvedGlobalPromise = $bc26ee8cec700381$var$_a$1[2], $bc26ee8cec700381$var$nativePromiseThen = $bc26ee8cec700381$var$nativePromiseProto && $bc26ee8cec700381$var$nativePromiseProto.then;
var $bc26ee8cec700381$var$NativePromise = $bc26ee8cec700381$var$resolvedNativePromise && $bc26ee8cec700381$var$resolvedNativePromise.constructor;
var $bc26ee8cec700381$var$patchGlobalPromise = !!$bc26ee8cec700381$var$resolvedGlobalPromise;
var $bc26ee8cec700381$var$stack_being_generated = false;
var $bc26ee8cec700381$var$schedulePhysicalTick = $bc26ee8cec700381$var$resolvedGlobalPromise ? function schedulePhysicalTick() {
    $bc26ee8cec700381$var$resolvedGlobalPromise.then($bc26ee8cec700381$var$physicalTick);
} : $bc26ee8cec700381$var$_global.setImmediate ? setImmediate.bind(null, $bc26ee8cec700381$var$physicalTick) : $bc26ee8cec700381$var$_global.MutationObserver ? function() {
    var hiddenDiv = document.createElement("div");
    new MutationObserver(function() {
        $bc26ee8cec700381$var$physicalTick();
        hiddenDiv = null;
    }).observe(hiddenDiv, {
        attributes: true
    });
    hiddenDiv.setAttribute("i", "1");
} : function() {
    setTimeout($bc26ee8cec700381$var$physicalTick, 0);
};
var $bc26ee8cec700381$var$asap = function asap(callback, args) {
    $bc26ee8cec700381$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($bc26ee8cec700381$var$needsNewPhysicalTick) {
        $bc26ee8cec700381$var$schedulePhysicalTick();
        $bc26ee8cec700381$var$needsNewPhysicalTick = false;
    }
};
var $bc26ee8cec700381$var$isOutsideMicroTick = true, $bc26ee8cec700381$var$needsNewPhysicalTick = true, $bc26ee8cec700381$var$unhandledErrors = [], $bc26ee8cec700381$var$rejectingErrors = [], $bc26ee8cec700381$var$currentFulfiller = null, $bc26ee8cec700381$var$rejectionMapper = $bc26ee8cec700381$var$mirror;
var $bc26ee8cec700381$var$globalPSD = {
    id: "global",
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $bc26ee8cec700381$var$globalError,
    pgp: false,
    env: {},
    finalize: function finalize() {
        this.unhandleds.forEach(function(uh) {
            try {
                $bc26ee8cec700381$var$globalError(uh[0], uh[1]);
            } catch (e) {}
        });
    }
};
var $bc26ee8cec700381$var$PSD = $bc26ee8cec700381$var$globalPSD;
var $bc26ee8cec700381$var$microtickQueue = [];
var $bc26ee8cec700381$var$numScheduledCalls = 0;
var $bc26ee8cec700381$var$tickFinalizers = [];
function $bc26ee8cec700381$var$DexiePromise(fn) {
    if (typeof this !== "object") throw new TypeError("Promises must be constructed via new");
    this._listeners = [];
    this.onuncatched = $bc26ee8cec700381$var$nop;
    this._lib = false;
    var psd = this._PSD = $bc26ee8cec700381$var$PSD;
    if ($bc26ee8cec700381$var$debug) {
        this._stackHolder = $bc26ee8cec700381$var$getErrorWithStack();
        this._prev = null;
        this._numPrev = 0;
    }
    if (typeof fn !== "function") {
        if (fn !== $bc26ee8cec700381$var$INTERNAL) throw new TypeError("Not a function");
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $bc26ee8cec700381$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $bc26ee8cec700381$var$executePromiseTask(this, fn);
}
var $bc26ee8cec700381$var$thenProp = {
    get: function get() {
        var psd = $bc26ee8cec700381$var$PSD, microTaskId = $bc26ee8cec700381$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $bc26ee8cec700381$var$PSD || microTaskId !== $bc26ee8cec700381$var$totalEchoes);
            var cleanup = possibleAwait && !$bc26ee8cec700381$var$decrementExpectedAwaits();
            var rv = new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
                $bc26ee8cec700381$var$propagateToListener(_this, new $bc26ee8cec700381$var$Listener($bc26ee8cec700381$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $bc26ee8cec700381$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            $bc26ee8cec700381$var$debug && $bc26ee8cec700381$var$linkToPreviousPromise(rv, this);
            return rv;
        }
        then.prototype = $bc26ee8cec700381$var$INTERNAL;
        return then;
    },
    set: function set(value) {
        $bc26ee8cec700381$var$setProp(this, "then", value && value.prototype === $bc26ee8cec700381$var$INTERNAL ? $bc26ee8cec700381$var$thenProp : {
            get: function get() {
                return value;
            },
            set: $bc26ee8cec700381$var$thenProp.set
        });
    }
};
$bc26ee8cec700381$var$props($bc26ee8cec700381$var$DexiePromise.prototype, {
    then: $bc26ee8cec700381$var$thenProp,
    _then: function _then(onFulfilled, onRejected) {
        $bc26ee8cec700381$var$propagateToListener(this, new $bc26ee8cec700381$var$Listener(null, null, onFulfilled, onRejected, $bc26ee8cec700381$var$PSD));
    },
    catch: function _catch(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === "function" ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $bc26ee8cec700381$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $bc26ee8cec700381$var$PromiseReject(err);
        });
    },
    finally: function _finally(onFinally) {
        return this.then(function(value) {
            onFinally();
            return value;
        }, function(err) {
            onFinally();
            return $bc26ee8cec700381$var$PromiseReject(err);
        });
    },
    stack: {
        get: function get() {
            if (this._stack) return this._stack;
            try {
                $bc26ee8cec700381$var$stack_being_generated = true;
                var stacks = $bc26ee8cec700381$var$getStack(this, [], $bc26ee8cec700381$var$MAX_LONG_STACKS);
                var stack = stacks.join("\nFrom previous: ");
                if (this._state !== null) this._stack = stack;
                return stack;
            } finally{
                $bc26ee8cec700381$var$stack_being_generated = false;
            }
        }
    },
    timeout: function timeout(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $bc26ee8cec700381$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) $bc26ee8cec700381$var$setProp($bc26ee8cec700381$var$DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
$bc26ee8cec700381$var$globalPSD.env = $bc26ee8cec700381$var$snapShot();
function $bc26ee8cec700381$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$bc26ee8cec700381$var$props($bc26ee8cec700381$var$DexiePromise, {
    all: function all() {
        var values = $bc26ee8cec700381$var$getArrayOf.apply(null, arguments).map($bc26ee8cec700381$var$onPossibleParallellAsync);
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $bc26ee8cec700381$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function resolve(value) {
        if (value instanceof $bc26ee8cec700381$var$DexiePromise) return value;
        if (value && typeof value.then === "function") return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $bc26ee8cec700381$var$DexiePromise($bc26ee8cec700381$var$INTERNAL, true, value);
        $bc26ee8cec700381$var$linkToPreviousPromise(rv, $bc26ee8cec700381$var$currentFulfiller);
        return rv;
    },
    reject: $bc26ee8cec700381$var$PromiseReject,
    race: function race() {
        var values = $bc26ee8cec700381$var$getArrayOf.apply(null, arguments).map($bc26ee8cec700381$var$onPossibleParallellAsync);
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $bc26ee8cec700381$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function get() {
            return $bc26ee8cec700381$var$PSD;
        },
        set: function set(value) {
            return $bc26ee8cec700381$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function get() {
            return $bc26ee8cec700381$var$totalEchoes;
        }
    },
    newPSD: $bc26ee8cec700381$var$newScope,
    usePSD: $bc26ee8cec700381$var$usePSD,
    scheduler: {
        get: function get() {
            return $bc26ee8cec700381$var$asap;
        },
        set: function set(value) {
            $bc26ee8cec700381$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function get() {
            return $bc26ee8cec700381$var$rejectionMapper;
        },
        set: function set(value) {
            $bc26ee8cec700381$var$rejectionMapper = value;
        }
    },
    follow: function follow(fn, zoneProps) {
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            return $bc26ee8cec700381$var$newScope(function(resolve, reject) {
                var psd = $bc26ee8cec700381$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $bc26ee8cec700381$var$callBoth(function() {
                    var _this = this;
                    $bc26ee8cec700381$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($bc26ee8cec700381$var$NativePromise) {
    if ($bc26ee8cec700381$var$NativePromise.allSettled) $bc26ee8cec700381$var$setProp($bc26ee8cec700381$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $bc26ee8cec700381$var$getArrayOf.apply(null, arguments).map($bc26ee8cec700381$var$onPossibleParallellAsync);
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $bc26ee8cec700381$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($bc26ee8cec700381$var$NativePromise.any && typeof AggregateError !== "undefined") $bc26ee8cec700381$var$setProp($bc26ee8cec700381$var$DexiePromise, "any", function() {
        var possiblePromises = $bc26ee8cec700381$var$getArrayOf.apply(null, arguments).map($bc26ee8cec700381$var$onPossibleParallellAsync);
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $bc26ee8cec700381$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
}
function $bc26ee8cec700381$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError("A promise cannot be resolved with itself.");
            var shouldExecuteTick = promise._lib && $bc26ee8cec700381$var$beginMicroTickScope();
            if (value && typeof value.then === "function") $bc26ee8cec700381$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $bc26ee8cec700381$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $bc26ee8cec700381$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $bc26ee8cec700381$var$endMicroTickScope();
        }, $bc26ee8cec700381$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $bc26ee8cec700381$var$handleRejection(promise, ex);
    }
}
function $bc26ee8cec700381$var$handleRejection(promise, reason) {
    $bc26ee8cec700381$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $bc26ee8cec700381$var$beginMicroTickScope();
    reason = $bc26ee8cec700381$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $bc26ee8cec700381$var$debug && reason !== null && typeof reason === "object" && !reason._promise && $bc26ee8cec700381$var$tryCatch(function() {
        var origProp = $bc26ee8cec700381$var$getPropertyDescriptor(reason, "stack");
        reason._promise = promise;
        $bc26ee8cec700381$var$setProp(reason, "stack", {
            get: function get() {
                return $bc26ee8cec700381$var$stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
            }
        });
    });
    $bc26ee8cec700381$var$addPossiblyUnhandledError(promise);
    $bc26ee8cec700381$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $bc26ee8cec700381$var$endMicroTickScope();
}
function $bc26ee8cec700381$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$bc26ee8cec700381$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($bc26ee8cec700381$var$numScheduledCalls === 0) {
        ++$bc26ee8cec700381$var$numScheduledCalls;
        $bc26ee8cec700381$var$asap(function() {
            if (--$bc26ee8cec700381$var$numScheduledCalls === 0) $bc26ee8cec700381$var$finalizePhysicalTick();
        }, []);
    }
}
function $bc26ee8cec700381$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$bc26ee8cec700381$var$numScheduledCalls;
    $bc26ee8cec700381$var$asap($bc26ee8cec700381$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $bc26ee8cec700381$var$callListener(cb, promise, listener) {
    try {
        $bc26ee8cec700381$var$currentFulfiller = promise;
        var ret, value = promise._value;
        if (promise._state) ret = cb(value);
        else {
            if ($bc26ee8cec700381$var$rejectingErrors.length) $bc26ee8cec700381$var$rejectingErrors = [];
            ret = cb(value);
            if ($bc26ee8cec700381$var$rejectingErrors.indexOf(value) === -1) $bc26ee8cec700381$var$markErrorAsHandled(promise);
        }
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        $bc26ee8cec700381$var$currentFulfiller = null;
        if (--$bc26ee8cec700381$var$numScheduledCalls === 0) $bc26ee8cec700381$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $bc26ee8cec700381$var$getStack(promise, stacks, limit) {
    if (stacks.length === limit) return stacks;
    var stack = "";
    if (promise._state === false) {
        var failure = promise._value, errorName, message;
        if (failure != null) {
            errorName = failure.name || "Error";
            message = failure.message || failure;
            stack = $bc26ee8cec700381$var$prettyStack(failure, 0);
        } else {
            errorName = failure;
            message = "";
        }
        stacks.push(errorName + (message ? ": " + message : "") + stack);
    }
    if ($bc26ee8cec700381$var$debug) {
        stack = $bc26ee8cec700381$var$prettyStack(promise._stackHolder, 2);
        if (stack && stacks.indexOf(stack) === -1) stacks.push(stack);
        if (promise._prev) $bc26ee8cec700381$var$getStack(promise._prev, stacks, limit);
    }
    return stacks;
}
function $bc26ee8cec700381$var$linkToPreviousPromise(promise, prev) {
    var numPrev = prev ? prev._numPrev + 1 : 0;
    if (numPrev < $bc26ee8cec700381$var$LONG_STACKS_CLIP_LIMIT) {
        promise._prev = prev;
        promise._numPrev = numPrev;
    }
}
function $bc26ee8cec700381$var$physicalTick() {
    $bc26ee8cec700381$var$beginMicroTickScope() && $bc26ee8cec700381$var$endMicroTickScope();
}
function $bc26ee8cec700381$var$beginMicroTickScope() {
    var wasRootExec = $bc26ee8cec700381$var$isOutsideMicroTick;
    $bc26ee8cec700381$var$isOutsideMicroTick = false;
    $bc26ee8cec700381$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $bc26ee8cec700381$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($bc26ee8cec700381$var$microtickQueue.length > 0){
        callbacks = $bc26ee8cec700381$var$microtickQueue;
        $bc26ee8cec700381$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($bc26ee8cec700381$var$microtickQueue.length > 0);
    $bc26ee8cec700381$var$isOutsideMicroTick = true;
    $bc26ee8cec700381$var$needsNewPhysicalTick = true;
}
function $bc26ee8cec700381$var$finalizePhysicalTick() {
    var unhandledErrs = $bc26ee8cec700381$var$unhandledErrors;
    $bc26ee8cec700381$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $bc26ee8cec700381$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $bc26ee8cec700381$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $bc26ee8cec700381$var$tickFinalizers.splice($bc26ee8cec700381$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $bc26ee8cec700381$var$tickFinalizers.push(finalizer);
    ++$bc26ee8cec700381$var$numScheduledCalls;
    $bc26ee8cec700381$var$asap(function() {
        if (--$bc26ee8cec700381$var$numScheduledCalls === 0) $bc26ee8cec700381$var$finalizePhysicalTick();
    }, []);
}
function $bc26ee8cec700381$var$addPossiblyUnhandledError(promise) {
    if (!$bc26ee8cec700381$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $bc26ee8cec700381$var$unhandledErrors.push(promise);
}
function $bc26ee8cec700381$var$markErrorAsHandled(promise) {
    var i = $bc26ee8cec700381$var$unhandledErrors.length;
    while(i)if ($bc26ee8cec700381$var$unhandledErrors[--i]._value === promise._value) {
        $bc26ee8cec700381$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $bc26ee8cec700381$var$PromiseReject(reason) {
    return new $bc26ee8cec700381$var$DexiePromise($bc26ee8cec700381$var$INTERNAL, false, reason);
}
function $bc26ee8cec700381$var$wrap(fn, errorCatcher) {
    var psd = $bc26ee8cec700381$var$PSD;
    return function() {
        var wasRootExec = $bc26ee8cec700381$var$beginMicroTickScope(), outerScope = $bc26ee8cec700381$var$PSD;
        try {
            $bc26ee8cec700381$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $bc26ee8cec700381$var$switchToZone(outerScope, false);
            if (wasRootExec) $bc26ee8cec700381$var$endMicroTickScope();
        }
    };
}
var $bc26ee8cec700381$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $bc26ee8cec700381$var$taskCounter = 0;
var $bc26ee8cec700381$var$zoneStack = [];
var $bc26ee8cec700381$var$zoneEchoes = 0;
var $bc26ee8cec700381$var$totalEchoes = 0;
var $bc26ee8cec700381$var$zone_id_counter = 0;
function $bc26ee8cec700381$var$newScope(fn, props, a1, a2) {
    var parent = $bc26ee8cec700381$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$bc26ee8cec700381$var$zone_id_counter;
    var globalEnv = $bc26ee8cec700381$var$globalPSD.env;
    psd.env = $bc26ee8cec700381$var$patchGlobalPromise ? {
        Promise: $bc26ee8cec700381$var$DexiePromise,
        PromiseProp: {
            value: $bc26ee8cec700381$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $bc26ee8cec700381$var$DexiePromise.all,
        race: $bc26ee8cec700381$var$DexiePromise.race,
        allSettled: $bc26ee8cec700381$var$DexiePromise.allSettled,
        any: $bc26ee8cec700381$var$DexiePromise.any,
        resolve: $bc26ee8cec700381$var$DexiePromise.resolve,
        reject: $bc26ee8cec700381$var$DexiePromise.reject,
        nthen: $bc26ee8cec700381$var$getPatchedPromiseThen(globalEnv.nthen, psd),
        gthen: $bc26ee8cec700381$var$getPatchedPromiseThen(globalEnv.gthen, psd)
    } : {};
    if (props) $bc26ee8cec700381$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $bc26ee8cec700381$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $bc26ee8cec700381$var$incrementExpectedAwaits() {
    if (!$bc26ee8cec700381$var$task.id) $bc26ee8cec700381$var$task.id = ++$bc26ee8cec700381$var$taskCounter;
    ++$bc26ee8cec700381$var$task.awaits;
    $bc26ee8cec700381$var$task.echoes += $bc26ee8cec700381$var$ZONE_ECHO_LIMIT;
    return $bc26ee8cec700381$var$task.id;
}
function $bc26ee8cec700381$var$decrementExpectedAwaits() {
    if (!$bc26ee8cec700381$var$task.awaits) return false;
    if (--$bc26ee8cec700381$var$task.awaits === 0) $bc26ee8cec700381$var$task.id = 0;
    $bc26ee8cec700381$var$task.echoes = $bc26ee8cec700381$var$task.awaits * $bc26ee8cec700381$var$ZONE_ECHO_LIMIT;
    return true;
}
if (("" + $bc26ee8cec700381$var$nativePromiseThen).indexOf("[native code]") === -1) $bc26ee8cec700381$var$incrementExpectedAwaits = $bc26ee8cec700381$var$decrementExpectedAwaits = $bc26ee8cec700381$var$nop;
function $bc26ee8cec700381$var$onPossibleParallellAsync(possiblePromise) {
    if ($bc26ee8cec700381$var$task.echoes && possiblePromise && possiblePromise.constructor === $bc26ee8cec700381$var$NativePromise) {
        $bc26ee8cec700381$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $bc26ee8cec700381$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $bc26ee8cec700381$var$decrementExpectedAwaits();
            return $bc26ee8cec700381$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $bc26ee8cec700381$var$zoneEnterEcho(targetZone) {
    ++$bc26ee8cec700381$var$totalEchoes;
    if (!$bc26ee8cec700381$var$task.echoes || --$bc26ee8cec700381$var$task.echoes === 0) $bc26ee8cec700381$var$task.echoes = $bc26ee8cec700381$var$task.id = 0;
    $bc26ee8cec700381$var$zoneStack.push($bc26ee8cec700381$var$PSD);
    $bc26ee8cec700381$var$switchToZone(targetZone, true);
}
function $bc26ee8cec700381$var$zoneLeaveEcho() {
    var zone = $bc26ee8cec700381$var$zoneStack[$bc26ee8cec700381$var$zoneStack.length - 1];
    $bc26ee8cec700381$var$zoneStack.pop();
    $bc26ee8cec700381$var$switchToZone(zone, false);
}
function $bc26ee8cec700381$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $bc26ee8cec700381$var$PSD;
    if (bEnteringZone ? $bc26ee8cec700381$var$task.echoes && (!$bc26ee8cec700381$var$zoneEchoes++ || targetZone !== $bc26ee8cec700381$var$PSD) : $bc26ee8cec700381$var$zoneEchoes && (!--$bc26ee8cec700381$var$zoneEchoes || targetZone !== $bc26ee8cec700381$var$PSD)) $bc26ee8cec700381$var$enqueueNativeMicroTask(bEnteringZone ? $bc26ee8cec700381$var$zoneEnterEcho.bind(null, targetZone) : $bc26ee8cec700381$var$zoneLeaveEcho);
    if (targetZone === $bc26ee8cec700381$var$PSD) return;
    $bc26ee8cec700381$var$PSD = targetZone;
    if (currentZone === $bc26ee8cec700381$var$globalPSD) $bc26ee8cec700381$var$globalPSD.env = $bc26ee8cec700381$var$snapShot();
    if ($bc26ee8cec700381$var$patchGlobalPromise) {
        var GlobalPromise_1 = $bc26ee8cec700381$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        $bc26ee8cec700381$var$nativePromiseProto.then = targetEnv.nthen;
        GlobalPromise_1.prototype.then = targetEnv.gthen;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($bc26ee8cec700381$var$_global, "Promise", targetEnv.PromiseProp);
            GlobalPromise_1.all = targetEnv.all;
            GlobalPromise_1.race = targetEnv.race;
            GlobalPromise_1.resolve = targetEnv.resolve;
            GlobalPromise_1.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise_1.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise_1.any = targetEnv.any;
        }
    }
}
function $bc26ee8cec700381$var$snapShot() {
    var GlobalPromise = $bc26ee8cec700381$var$_global.Promise;
    return $bc26ee8cec700381$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($bc26ee8cec700381$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject,
        nthen: $bc26ee8cec700381$var$nativePromiseProto.then,
        gthen: GlobalPromise.prototype.then
    } : {};
}
function $bc26ee8cec700381$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $bc26ee8cec700381$var$PSD;
    try {
        $bc26ee8cec700381$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $bc26ee8cec700381$var$switchToZone(outerScope, false);
    }
}
function $bc26ee8cec700381$var$enqueueNativeMicroTask(job) {
    $bc26ee8cec700381$var$nativePromiseThen.call($bc26ee8cec700381$var$resolvedNativePromise, job);
}
function $bc26ee8cec700381$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== "function" ? fn : function() {
        var outerZone = $bc26ee8cec700381$var$PSD;
        if (possibleAwait) $bc26ee8cec700381$var$incrementExpectedAwaits();
        $bc26ee8cec700381$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $bc26ee8cec700381$var$switchToZone(outerZone, false);
            if (cleanup) $bc26ee8cec700381$var$enqueueNativeMicroTask($bc26ee8cec700381$var$decrementExpectedAwaits);
        }
    };
}
function $bc26ee8cec700381$var$getPatchedPromiseThen(origThen, zone) {
    return function(onResolved, onRejected) {
        return origThen.call(this, $bc26ee8cec700381$var$nativeAwaitCompatibleWrap(onResolved, zone), $bc26ee8cec700381$var$nativeAwaitCompatibleWrap(onRejected, zone));
    };
}
var $bc26ee8cec700381$var$UNHANDLEDREJECTION = "unhandledrejection";
function $bc26ee8cec700381$var$globalError(err, promise) {
    var rv;
    try {
        rv = promise.onuncatched(err);
    } catch (e) {}
    if (rv !== false) try {
        var event, eventData = {
            promise: promise,
            reason: err
        };
        if ($bc26ee8cec700381$var$_global.document && document.createEvent) {
            event = document.createEvent("Event");
            event.initEvent($bc26ee8cec700381$var$UNHANDLEDREJECTION, true, true);
            $bc26ee8cec700381$var$extend(event, eventData);
        } else if ($bc26ee8cec700381$var$_global.CustomEvent) {
            event = new CustomEvent($bc26ee8cec700381$var$UNHANDLEDREJECTION, {
                detail: eventData
            });
            $bc26ee8cec700381$var$extend(event, eventData);
        }
        if (event && $bc26ee8cec700381$var$_global.dispatchEvent) {
            dispatchEvent(event);
            if (!$bc26ee8cec700381$var$_global.PromiseRejectionEvent && $bc26ee8cec700381$var$_global.onunhandledrejection) try {
                $bc26ee8cec700381$var$_global.onunhandledrejection(event);
            } catch (_) {}
        }
        if ($bc26ee8cec700381$var$debug && event && !event.defaultPrevented) console.warn("Unhandled rejection: " + (err.stack || err));
    } catch (e) {}
}
var $bc26ee8cec700381$var$rejection = $bc26ee8cec700381$var$DexiePromise.reject;
function $bc26ee8cec700381$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$bc26ee8cec700381$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._options.autoOpen) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.DatabaseClosed());
            db.open().catch($bc26ee8cec700381$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $bc26ee8cec700381$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $bc26ee8cec700381$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $bc26ee8cec700381$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $bc26ee8cec700381$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $bc26ee8cec700381$var$newScope(function() {
                $bc26ee8cec700381$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            return trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $bc26ee8cec700381$var$DEXIE_VERSION = "3.2.4";
var $bc26ee8cec700381$var$maxString = String.fromCharCode(65535);
var $bc26ee8cec700381$var$minKey = -Infinity;
var $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $bc26ee8cec700381$var$STRING_EXPECTED = "String expected.";
var $bc26ee8cec700381$var$connections = [];
var $bc26ee8cec700381$var$isIEOrEdge = typeof navigator !== "undefined" && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var $bc26ee8cec700381$var$hasIEDeleteObjectStoreBug = $bc26ee8cec700381$var$isIEOrEdge;
var $bc26ee8cec700381$var$hangsOnDeleteLargeKeyRange = $bc26ee8cec700381$var$isIEOrEdge;
var $bc26ee8cec700381$var$dexieStackFrameFilter = function dexieStackFrameFilter(frame) {
    return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var $bc26ee8cec700381$var$DBNAMES_DB = "__dbnames";
var $bc26ee8cec700381$var$READONLY = "readonly";
var $bc26ee8cec700381$var$READWRITE = "readwrite";
function $bc26ee8cec700381$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $bc26ee8cec700381$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $bc26ee8cec700381$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
var $bc26ee8cec700381$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $bc26ee8cec700381$var$PSD.trans;
        var tableName = this.name;
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $bc26ee8cec700381$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $bc26ee8cec700381$var$beginMicroTickScope();
        try {
            return trans && trans.db === this.db ? trans === $bc26ee8cec700381$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $bc26ee8cec700381$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $bc26ee8cec700381$var$PSD.transless || $bc26ee8cec700381$var$PSD
            }) : $bc26ee8cec700381$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
        } finally{
            if (wasRootExec) $bc26ee8cec700381$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        return this._trans("readonly", function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === "string") return new this.db.WhereClause(this, indexOrCrit);
        if ($bc26ee8cec700381$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[" + indexOrCrit.join("+") + "]");
        var keyPaths = $bc26ee8cec700381$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            return ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            }) && ix.keyPath.every(function(keyPath) {
                return keyPaths.indexOf(keyPath) >= 0;
            });
        })[0];
        if (compoundIndex && this.db._maxKey !== $bc26ee8cec700381$var$maxString) return this.where(compoundIndex.name).equals(compoundIndex.keyPath.map(function(kp) {
            return indexOrCrit[kp];
        }));
        if (!compoundIndex && $bc26ee8cec700381$var$debug) console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join("+") + "]"));
        var idxByName = this.schema.idxByName;
        var idb = this.db._deps.indexedDB;
        function equals(a, b) {
            try {
                return idb.cmp(a, b) === 0;
            } catch (e) {
                return false;
            }
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $bc26ee8cec700381$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $bc26ee8cec700381$var$getByKeyPath(x, keyPath);
                    return $bc26ee8cec700381$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $bc26ee8cec700381$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $bc26ee8cec700381$var$isArray(index) ? "[" + index.join("+") + "]" : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        this.schema.mappedClass = constructor;
        var readHook = function readHook(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if ($bc26ee8cec700381$var$hasOwn(obj, m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $bc26ee8cec700381$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === "object" && !$bc26ee8cec700381$var$isArray(keyOrObject)) {
            var key = $bc26ee8cec700381$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            try {
                if (typeof modifications !== "function") $bc26ee8cec700381$var$keys(modifications).forEach(function(keyPath) {
                    $bc26ee8cec700381$var$setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                });
                else modifications(keyOrObject, {
                    value: keyOrObject,
                    primKey: key
                });
            } catch (_a) {}
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "put",
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "deleteRange",
                range: $bc26ee8cec700381$var$AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans("readonly", function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $bc26ee8cec700381$var$BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "put",
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $bc26ee8cec700381$var$BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $bc26ee8cec700381$var$BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
        });
    };
    return Table;
}();
function $bc26ee8cec700381$var$Events(ctx) {
    var evs = {};
    var rv = function rv(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === "string") return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === "object") return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $bc26ee8cec700381$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $bc26ee8cec700381$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function subscribe(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function unsubscribe(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $bc26ee8cec700381$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($bc26ee8cec700381$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === "asap") var context = add(eventName, $bc26ee8cec700381$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $bc26ee8cec700381$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $bc26ee8cec700381$var$makeClassConstructor(prototype, constructor) {
    $bc26ee8cec700381$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $bc26ee8cec700381$var$createTableConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $bc26ee8cec700381$var$Events(null, {
            "creating": [
                $bc26ee8cec700381$var$hookCreatingChain,
                $bc26ee8cec700381$var$nop
            ],
            "reading": [
                $bc26ee8cec700381$var$pureFunctionChain,
                $bc26ee8cec700381$var$mirror
            ],
            "updating": [
                $bc26ee8cec700381$var$hookUpdatingChain,
                $bc26ee8cec700381$var$nop
            ],
            "deleting": [
                $bc26ee8cec700381$var$hookDeletingChain,
                $bc26ee8cec700381$var$nop
            ]
        });
    });
}
function $bc26ee8cec700381$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $bc26ee8cec700381$var$addFilter(ctx, fn) {
    ctx.filter = $bc26ee8cec700381$var$combine(ctx.filter, fn);
}
function $bc26ee8cec700381$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $bc26ee8cec700381$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $bc26ee8cec700381$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $bc26ee8cec700381$var$combine(ctx.isMatch, fn);
}
function $bc26ee8cec700381$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $bc26ee8cec700381$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $bc26ee8cec700381$var$openCursor(ctx, coreTable, trans) {
    var index = $bc26ee8cec700381$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === "prev",
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $bc26ee8cec700381$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $bc26ee8cec700381$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $bc26ee8cec700381$var$iterate($bc26ee8cec700381$var$openCursor(ctx, coreTable, coreTrans), $bc26ee8cec700381$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function union(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = "" + primaryKey;
                if (key === "[object ArrayBuffer]") key = "" + new Uint8Array(primaryKey);
                if (!$bc26ee8cec700381$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $bc26ee8cec700381$var$iterate($bc26ee8cec700381$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $bc26ee8cec700381$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function mappedFn(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $bc26ee8cec700381$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function c() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $bc26ee8cec700381$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $bc26ee8cec700381$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
function $bc26ee8cec700381$var$cmp(a, b) {
    try {
        var ta = $bc26ee8cec700381$var$type(a);
        var tb = $bc26ee8cec700381$var$type(b);
        if (ta !== tb) {
            if (ta === "Array") return 1;
            if (tb === "Array") return -1;
            if (ta === "binary") return 1;
            if (tb === "binary") return -1;
            if (ta === "string") return 1;
            if (tb === "string") return -1;
            if (ta === "Date") return 1;
            if (tb !== "Date") return NaN;
            return -1;
        }
        switch(ta){
            case "number":
            case "Date":
            case "string":
                return a > b ? 1 : a < b ? -1 : 0;
            case "binary":
                return $bc26ee8cec700381$var$compareUint8Arrays($bc26ee8cec700381$var$getUint8Array(a), $bc26ee8cec700381$var$getUint8Array(b));
            case "Array":
                return $bc26ee8cec700381$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $bc26ee8cec700381$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $bc26ee8cec700381$var$cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $bc26ee8cec700381$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $bc26ee8cec700381$var$type(x) {
    var t = typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x);
    if (t !== "object") return t;
    if (ArrayBuffer.isView(x)) return "binary";
    var tsTag = $bc26ee8cec700381$var$toStringTag(x);
    return tsTag === "ArrayBuffer" ? "binary" : tsTag;
}
function $bc26ee8cec700381$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var $bc26ee8cec700381$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $bc26ee8cec700381$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $bc26ee8cec700381$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $bc26ee8cec700381$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $bc26ee8cec700381$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $bc26ee8cec700381$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $bc26ee8cec700381$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($bc26ee8cec700381$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $bc26ee8cec700381$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $bc26ee8cec700381$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split(".").reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return aVal < bVal ? -order : aVal > bVal ? order : 0;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === "next" && $bc26ee8cec700381$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $bc26ee8cec700381$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $bc26ee8cec700381$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($bc26ee8cec700381$var$isPlainKeyRange(ctx)) $bc26ee8cec700381$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $bc26ee8cec700381$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $bc26ee8cec700381$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $bc26ee8cec700381$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $bc26ee8cec700381$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $bc26ee8cec700381$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === "next" && $bc26ee8cec700381$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $bc26ee8cec700381$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $bc26ee8cec700381$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $bc26ee8cec700381$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === "function") modifyer = changes;
            else {
                var keyPaths = $bc26ee8cec700381$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function modifyer(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i], val = changes[keyPath];
                        if ($bc26ee8cec700381$var$getByKeyPath(item, keyPath) !== val) {
                            $bc26ee8cec700381$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = _this.db._options.modifyChunkSize || 200;
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function applyMutateResult(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $bc26ee8cec700381$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var nextChunk = function nextChunk1(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $bc26ee8cec700381$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $bc26ee8cec700381$var$cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        var criteria = $bc26ee8cec700381$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || changes === $bc26ee8cec700381$var$deleteCallback) && {
                            index: ctx.index,
                            range: ctx.range
                        };
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: "add",
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                                trans: trans,
                                type: "put",
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== "function" && changes
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === $bc26ee8cec700381$var$deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: "delete",
                                keys: deleteKeys,
                                criteria: criteria
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $bc26ee8cec700381$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($bc26ee8cec700381$var$isPlainKeyRange(ctx) && (ctx.isPrimKey && !$bc26ee8cec700381$var$hangsOnDeleteLargeKeyRange || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: "deleteRange",
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new $bc26ee8cec700381$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($bc26ee8cec700381$var$deleteCallback);
    };
    return Collection;
}();
var $bc26ee8cec700381$var$deleteCallback = function deleteCallback(value, ctx) {
    return ctx.value = null;
};
function $bc26ee8cec700381$var$createCollectionConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $bc26ee8cec700381$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $bc26ee8cec700381$var$mirror ? readingHook : null
        };
    });
}
function $bc26ee8cec700381$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $bc26ee8cec700381$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $bc26ee8cec700381$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $bc26ee8cec700381$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $bc26ee8cec700381$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $bc26ee8cec700381$var$rangeEqual("");
    }).limit(0);
}
function $bc26ee8cec700381$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $bc26ee8cec700381$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $bc26ee8cec700381$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === "string";
    })) return $bc26ee8cec700381$var$fail(whereClause, $bc26ee8cec700381$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $bc26ee8cec700381$var$upperFactory(dir);
        lower = $bc26ee8cec700381$var$lowerFactory(dir);
        compare = dir === "next" ? $bc26ee8cec700381$var$simpleCompare : $bc26ee8cec700381$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $bc26ee8cec700381$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== "string") return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $bc26ee8cec700381$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $bc26ee8cec700381$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $bc26ee8cec700381$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $bc26ee8cec700381$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function get() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $bc26ee8cec700381$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $bc26ee8cec700381$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== "string") return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$STRING_EXPECTED);
        return this.between(str, str + $bc26ee8cec700381$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $bc26ee8cec700381$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        return $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        return $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $bc26ee8cec700381$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $bc26ee8cec700381$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $bc26ee8cec700381$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var _$cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $bc26ee8cec700381$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $bc26ee8cec700381$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (_$cmp(newRange[0], range[1]) < 0 && _$cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function keyIsBeyondCurrentEntry(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function keyIsBeforeCurrentEntry(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === "string";
        })) return $bc26ee8cec700381$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $bc26ee8cec700381$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $bc26ee8cec700381$var$createWhereClauseConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        var indexedDB1 = db._deps.indexedDB;
        if (!indexedDB1) throw new $bc26ee8cec700381$var$exceptions.MissingAPI();
        this._cmp = this._ascending = indexedDB1.cmp.bind(indexedDB1);
        this._descending = function(a, b) {
            return indexedDB1.cmp(b, a);
        };
        this._max = function(a, b) {
            return indexedDB1.cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return indexedDB1.cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
    });
}
function $bc26ee8cec700381$var$eventRejectHandler(reject) {
    return $bc26ee8cec700381$var$wrap(function(event) {
        $bc26ee8cec700381$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $bc26ee8cec700381$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
var $bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
var $bc26ee8cec700381$var$globalEvents = $bc26ee8cec700381$var$Events(null, $bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $bc26ee8cec700381$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $bc26ee8cec700381$var$assert(!$bc26ee8cec700381$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$bc26ee8cec700381$var$PSD.global) $bc26ee8cec700381$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $bc26ee8cec700381$var$assert(!$bc26ee8cec700381$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$bc26ee8cec700381$var$PSD.global) $bc26ee8cec700381$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $bc26ee8cec700381$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $bc26ee8cec700381$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $bc26ee8cec700381$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $bc26ee8cec700381$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $bc26ee8cec700381$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $bc26ee8cec700381$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $bc26ee8cec700381$var$exceptions.TransactionInactive();
        $bc26ee8cec700381$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $bc26ee8cec700381$var$wrap(function(ev) {
            $bc26ee8cec700381$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $bc26ee8cec700381$var$wrap(function(ev) {
            $bc26ee8cec700381$var$preventDefault(ev);
            _this.active && _this._reject(new $bc26ee8cec700381$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $bc26ee8cec700381$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ("mutatedParts" in idbtrans) $bc26ee8cec700381$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === "readwrite" && this.mode !== "readwrite") return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.TransactionInactive());
        if (this._locked()) return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $bc26ee8cec700381$var$PSD
            ]);
        });
        else if (bWriteLock) return $bc26ee8cec700381$var$newScope(function() {
            var p = new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $bc26ee8cec700381$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($bc26ee8cec700381$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($bc26ee8cec700381$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $bc26ee8cec700381$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($bc26ee8cec700381$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $bc26ee8cec700381$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $bc26ee8cec700381$var$createTransactionConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $bc26ee8cec700381$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $bc26ee8cec700381$var$rejection(e);
        });
    });
}
function $bc26ee8cec700381$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto ? "++" : "") + $bc26ee8cec700381$var$nameFromKeyPath(keyPath)
    };
}
function $bc26ee8cec700381$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
}
function $bc26ee8cec700381$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $bc26ee8cec700381$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $bc26ee8cec700381$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $bc26ee8cec700381$var$getMaxKey = function getMaxKey1(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $bc26ee8cec700381$var$getMaxKey = function getMaxKey() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $bc26ee8cec700381$var$getMaxKey = function getMaxKey() {
            return $bc26ee8cec700381$var$maxString;
        };
        return $bc26ee8cec700381$var$maxString;
    }
};
function $bc26ee8cec700381$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === "string") return $bc26ee8cec700381$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $bc26ee8cec700381$var$getByKeyPath(obj, keyPath);
    };
}
function $bc26ee8cec700381$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split(".");
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $bc26ee8cec700381$var$getByKeyPath(obj, keyPath);
    };
}
function $bc26ee8cec700381$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $bc26ee8cec700381$var$_id_counter = 0;
function $bc26ee8cec700381$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[" + keyPath.join("+") + "]";
}
function $bc26ee8cec700381$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $bc26ee8cec700381$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $bc26ee8cec700381$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $bc26ee8cec700381$var$getKeyExtractor(keyPath)
                        },
                        indexes: $bc26ee8cec700381$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $bc26ee8cec700381$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $bc26ee8cec700381$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$bc26ee8cec700381$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function getIndexByKeyPath(keyPath) {
                            return indexByKeyPath[$bc26ee8cec700381$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$bc26ee8cec700381$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && "getAll" in trans.objectStore(tables[0]) && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $bc26ee8cec700381$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== "delete" && type !== "deleteRange") throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function errorHandler(event) {
                    ++numFailures;
                    $bc26ee8cec700381$var$preventDefault(event);
                };
                if (type === "deleteRange") {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _$_a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _$_a[0], args2 = _$_a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function done(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, _$query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $bc26ee8cec700381$var$wrap(resolve);
                var index = _$query.index, range = _$query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !("openKeyCursor" in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                req.onsuccess = $bc26ee8cec700381$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$bc26ee8cec700381$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function doThrowCursorIsNotStarted() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function doThrowCursorIsStopped() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $bc26ee8cec700381$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $bc26ee8cec700381$var$wrap(resolveIteration);
                            req.onerror = $bc26ee8cec700381$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function guardedCallback() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $bc26ee8cec700381$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $bc26ee8cec700381$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, _$query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = _$query.index, range = _$query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !("openKeyCursor" in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function getMany(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $bc26ee8cec700381$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function successHandler(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $bc26ee8cec700381$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function get(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $bc26ee8cec700381$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function count(_a) {
                var _$query = _a.query, trans = _a.trans;
                var index = _$query.index, range = _$query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $bc26ee8cec700381$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function table(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '" + name + "' not found");
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $bc26ee8cec700381$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $bc26ee8cec700381$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $bc26ee8cec700381$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $bc26ee8cec700381$var$createMiddlewareStack($bc26ee8cec700381$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $bc26ee8cec700381$var$generateMiddlewareStacks(_a, tmpTrans) {
    var db = _a._novip;
    var idbdb = tmpTrans.db;
    var stacks = $bc26ee8cec700381$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $bc26ee8cec700381$var$setApiOnPlace(_a, objs, tableNames, dbschema) {
    var db = _a._novip;
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $bc26ee8cec700381$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $bc26ee8cec700381$var$setProp(obj, tableName, {
                    get: function get() {
                        return this.table(tableName);
                    },
                    set: function set(value) {
                        $bc26ee8cec700381$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $bc26ee8cec700381$var$removeTablesApi(_a, objs) {
    var db = _a._novip;
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $bc26ee8cec700381$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $bc26ee8cec700381$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $bc26ee8cec700381$var$PSD.transless || $bc26ee8cec700381$var$PSD;
    $bc26ee8cec700381$var$newScope(function() {
        $bc26ee8cec700381$var$PSD.trans = trans;
        $bc26ee8cec700381$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $bc26ee8cec700381$var$keys(globalSchema).forEach(function(tableName) {
                $bc26ee8cec700381$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $bc26ee8cec700381$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $bc26ee8cec700381$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else $bc26ee8cec700381$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
    });
}
function $bc26ee8cec700381$var$updateTablesAndIndexes(_a, oldVersion, trans, idbUpgradeTrans) {
    var db = _a._novip;
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $bc26ee8cec700381$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var anyContentUpgraderHasRun = false;
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $bc26ee8cec700381$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $bc26ee8cec700381$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $bc26ee8cec700381$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $bc26ee8cec700381$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $bc26ee8cec700381$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $bc26ee8cec700381$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $bc26ee8cec700381$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $bc26ee8cec700381$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                anyContentUpgraderHasRun = true;
                var upgradeSchema_1 = $bc26ee8cec700381$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $bc26ee8cec700381$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $bc26ee8cec700381$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $bc26ee8cec700381$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $bc26ee8cec700381$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $bc26ee8cec700381$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $bc26ee8cec700381$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $bc26ee8cec700381$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === "function" ? $bc26ee8cec700381$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            if (!anyContentUpgraderHasRun || !$bc26ee8cec700381$var$hasIEDeleteObjectStoreBug) {
                var newSchema = version._cfg.dbschema;
                $bc26ee8cec700381$var$deleteRemovedTables(newSchema, idbtrans);
            }
            $bc26ee8cec700381$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $bc26ee8cec700381$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
    });
    function runQueue() {
        return queue.length ? $bc26ee8cec700381$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $bc26ee8cec700381$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $bc26ee8cec700381$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $bc26ee8cec700381$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto && !$bc26ee8cec700381$var$isIEOrEdge) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $bc26ee8cec700381$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $bc26ee8cec700381$var$addIndex(store, idx);
    });
    return store;
}
function $bc26ee8cec700381$var$createMissingTables(newSchema, idbtrans) {
    $bc26ee8cec700381$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) $bc26ee8cec700381$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    });
}
function $bc26ee8cec700381$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $bc26ee8cec700381$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $bc26ee8cec700381$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $bc26ee8cec700381$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $bc26ee8cec700381$var$createIndexSpec($bc26ee8cec700381$var$nameFromKeyPath(keyPath), keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $bc26ee8cec700381$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $bc26ee8cec700381$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $bc26ee8cec700381$var$readGlobalSchema(_a, idbdb, tmpTrans) {
    var db = _a._novip;
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $bc26ee8cec700381$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $bc26ee8cec700381$var$slice(idbdb.objectStoreNames, 0);
    $bc26ee8cec700381$var$setApiOnPlace(db, [
        db._allTables
    ], $bc26ee8cec700381$var$keys(globalSchema), globalSchema);
}
function $bc26ee8cec700381$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $bc26ee8cec700381$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $bc26ee8cec700381$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $bc26ee8cec700381$var$adjustToExistingIndexNames(_a, schema, idbtrans) {
    var db = _a._novip;
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = "getAll" in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === "string" ? keyPath : "[" + $bc26ee8cec700381$var$slice(keyPath).join("+") + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $bc26ee8cec700381$var$_global.WorkerGlobalScope && $bc26ee8cec700381$var$_global instanceof $bc26ee8cec700381$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $bc26ee8cec700381$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(",").map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split("+") : name;
        return $bc26ee8cec700381$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $bc26ee8cec700381$var$isArray(keyPath), indexNum === 0);
    });
}
var $bc26ee8cec700381$var$Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        $bc26ee8cec700381$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = $bc26ee8cec700381$var$parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (primKey.multi) throw new $bc26ee8cec700381$var$exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $bc26ee8cec700381$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new $bc26ee8cec700381$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = $bc26ee8cec700381$var$createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $bc26ee8cec700381$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $bc26ee8cec700381$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $bc26ee8cec700381$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $bc26ee8cec700381$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $bc26ee8cec700381$var$keys(dbschema), dbschema);
        db._storeNames = $bc26ee8cec700381$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $bc26ee8cec700381$var$promisableChain(this._cfg.contentUpgrade || $bc26ee8cec700381$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $bc26ee8cec700381$var$createVersionConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $bc26ee8cec700381$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $bc26ee8cec700381$export$4ece27d405df7279($bc26ee8cec700381$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $bc26ee8cec700381$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $bc26ee8cec700381$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $bc26ee8cec700381$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $bc26ee8cec700381$var$DBNAMES_DB;
        });
    }) : $bc26ee8cec700381$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $bc26ee8cec700381$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$bc26ee8cec700381$var$hasDatabasesNative(indexedDB1) && name !== $bc26ee8cec700381$var$DBNAMES_DB && $bc26ee8cec700381$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($bc26ee8cec700381$var$nop);
}
function $bc26ee8cec700381$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$bc26ee8cec700381$var$hasDatabasesNative(indexedDB1) && name !== $bc26ee8cec700381$var$DBNAMES_DB && $bc26ee8cec700381$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($bc26ee8cec700381$var$nop);
}
function $bc26ee8cec700381$var$vip(fn) {
    return $bc26ee8cec700381$var$newScope(function() {
        $bc26ee8cec700381$var$PSD.letThrough = true;
        return fn();
    });
}
function $bc26ee8cec700381$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function tryIdb() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
function $bc26ee8cec700381$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $bc26ee8cec700381$var$rejection(state.dbOpenError) : db;
    });
    $bc26ee8cec700381$var$debug && (state.openCanceller._stackHolder = $bc26ee8cec700381$var$getErrorWithStack());
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $bc26ee8cec700381$var$exceptions.DatabaseClosed("db.open() was cancelled");
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    return $bc26ee8cec700381$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === "undefined" ? $bc26ee8cec700381$var$DexiePromise.resolve() : $bc26ee8cec700381$var$idbReady()).then(function() {
            return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
                throwIfCancelled();
                if (!indexedDB1) throw new $bc26ee8cec700381$var$exceptions.MissingAPI();
                var dbName = db.name;
                var req = state.autoSchema ? indexedDB1.open(dbName) : indexedDB1.open(dbName, Math.round(db.verno * 10));
                if (!req) throw new $bc26ee8cec700381$var$exceptions.MissingAPI();
                req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                req.onblocked = $bc26ee8cec700381$var$wrap(db._fireOnBlocked);
                req.onupgradeneeded = $bc26ee8cec700381$var$wrap(function(e) {
                    upgradeTransaction = req.transaction;
                    if (state.autoSchema && !db._options.allowEmptyDB) {
                        req.onerror = $bc26ee8cec700381$var$preventDefault;
                        upgradeTransaction.abort();
                        req.result.close();
                        var delreq = indexedDB1.deleteDatabase(dbName);
                        delreq.onsuccess = delreq.onerror = $bc26ee8cec700381$var$wrap(function() {
                            reject(new $bc26ee8cec700381$var$exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                        });
                    } else {
                        upgradeTransaction.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                        var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                        wasCreated = oldVer < 1;
                        db._novip.idbdb = req.result;
                        $bc26ee8cec700381$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                    }
                }, reject);
                req.onsuccess = $bc26ee8cec700381$var$wrap(function() {
                    upgradeTransaction = null;
                    var idbdb = db._novip.idbdb = req.result;
                    var objectStoreNames = $bc26ee8cec700381$var$slice(idbdb.objectStoreNames);
                    if (objectStoreNames.length > 0) try {
                        var tmpTrans = idbdb.transaction($bc26ee8cec700381$var$safariMultiStoreFix(objectStoreNames), "readonly");
                        if (state.autoSchema) $bc26ee8cec700381$var$readGlobalSchema(db, idbdb, tmpTrans);
                        else {
                            $bc26ee8cec700381$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                            if (!$bc26ee8cec700381$var$verifyInstalledSchema(db, tmpTrans)) console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
                        }
                        $bc26ee8cec700381$var$generateMiddlewareStacks(db, tmpTrans);
                    } catch (e) {}
                    $bc26ee8cec700381$var$connections.push(db);
                    idbdb.onversionchange = $bc26ee8cec700381$var$wrap(function(ev) {
                        state.vcFired = true;
                        db.on("versionchange").fire(ev);
                    });
                    idbdb.onclose = $bc26ee8cec700381$var$wrap(function(ev) {
                        db.on("close").fire(ev);
                    });
                    if (wasCreated) $bc26ee8cec700381$var$_onDatabaseCreated(db._deps, dbName);
                    resolve();
                }, reject);
            });
        })
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $bc26ee8cec700381$var$DexiePromise.resolve($bc26ee8cec700381$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($bc26ee8cec700381$var$promisableChain, $bc26ee8cec700381$var$nop);
                state.onReadyBeingFired = [];
                return $bc26ee8cec700381$var$DexiePromise.resolve($bc26ee8cec700381$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        state.onReadyBeingFired = null;
        state.isBeingOpened = false;
    }).then(function() {
        return db;
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $bc26ee8cec700381$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    });
}
function $bc26ee8cec700381$var$awaitIterator(iterator) {
    var callNext = function callNext(result) {
        return iterator.next(result);
    }, doThrow = function doThrow(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== "function" ? $bc26ee8cec700381$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $bc26ee8cec700381$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $bc26ee8cec700381$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $bc26ee8cec700381$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $bc26ee8cec700381$var$DexiePromise.resolve().then(function() {
        var transless = $bc26ee8cec700381$var$PSD.transless || $bc26ee8cec700381$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $bc26ee8cec700381$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $bc26ee8cec700381$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $bc26ee8cec700381$var$rejection(ex);
        }
        var scopeFuncIsAsync = $bc26ee8cec700381$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $bc26ee8cec700381$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $bc26ee8cec700381$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $bc26ee8cec700381$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === "function" && typeof returnValue.throw === "function") returnValue = $bc26ee8cec700381$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === "function" ? $bc26ee8cec700381$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $bc26ee8cec700381$var$rejection(e);
        });
    });
}
function $bc26ee8cec700381$var$pad(a, value, count) {
    var result = $bc26ee8cec700381$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $bc26ee8cec700381$var$createVirtualIndexMiddleware(down) {
    return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, down), {
        table: function table(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $bc26ee8cec700381$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, lowLevelIndex), {
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $bc26ee8cec700381$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$bc26ee8cec700381$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $bc26ee8cec700381$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $bc26ee8cec700381$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, req), {
                    query: {
                        index: index,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, table), {
                schema: $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function count(req) {
                    return table.count(translateRequest(req));
                },
                query: function query(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function openCursor(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($bc26ee8cec700381$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function value(key, primaryKey) {
                                    cursor.continuePrimaryKey($bc26ee8cec700381$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function get() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function get() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function get() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $bc26ee8cec700381$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $bc26ee8cec700381$var$createVirtualIndexMiddleware
};
function $bc26ee8cec700381$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || "";
    $bc26ee8cec700381$var$keys(a).forEach(function(prop) {
        if (!$bc26ee8cec700381$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
                var apTypeName = $bc26ee8cec700381$var$toStringTag(ap);
                var bpTypeName = $bc26ee8cec700381$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === "Object") $bc26ee8cec700381$var$getObjectDiff(ap, bp, rv, prfx + prop + ".");
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $bc26ee8cec700381$var$keys(b).forEach(function(prop) {
        if (!$bc26ee8cec700381$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $bc26ee8cec700381$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === "delete") return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $bc26ee8cec700381$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function create(downCore) {
        return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, downCore), {
            table: function table(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, downTable), {
                    mutate: function mutate(req) {
                        var dxTrans = $bc26ee8cec700381$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case "add":
                                if (creating.fire === $bc26ee8cec700381$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "put":
                                if (creating.fire === $bc26ee8cec700381$var$nop && updating.fire === $bc26ee8cec700381$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "delete":
                                if (deleting.fire === $bc26ee8cec700381$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "deleteRange":
                                if (deleting.fire === $bc26ee8cec700381$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $bc26ee8cec700381$var$PSD.trans;
                            var keys = req.keys || $bc26ee8cec700381$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === "add" || req.type === "put" ? $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, req), {
                                keys: keys
                            }) : $bc26ee8cec700381$var$__assign({}, req);
                            if (req.type !== "delete") req.values = $bc26ee8cec700381$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $bc26ee8cec700381$var$__spreadArray([], req.keys, true);
                            return $bc26ee8cec700381$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === "delete") deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === "add" || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $bc26ee8cec700381$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $bc26ee8cec700381$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($bc26ee8cec700381$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $bc26ee8cec700381$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === "put" && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: "delete",
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $bc26ee8cec700381$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $bc26ee8cec700381$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($bc26ee8cec700381$var$cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $bc26ee8cec700381$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $bc26ee8cec700381$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function create(core) {
        return {
            table: function table(tableName) {
                var table = core.table(tableName);
                return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, table), {
                    getMany: function getMany(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $bc26ee8cec700381$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $bc26ee8cec700381$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $bc26ee8cec700381$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function mutate(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
var $bc26ee8cec700381$var$_a;
function $bc26ee8cec700381$var$isEmptyRange(node) {
    return !("from" in node);
}
var $bc26ee8cec700381$export$34cb5241245008dd = function RangeSet1(fromOrTree, to) {
    if (this) $bc26ee8cec700381$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $bc26ee8cec700381$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $bc26ee8cec700381$var$extend(rv, fromOrTree);
        return rv;
    }
};
$bc26ee8cec700381$var$props($bc26ee8cec700381$export$34cb5241245008dd.prototype, ($bc26ee8cec700381$var$_a = {
    add: function add(rangeSet) {
        $bc26ee8cec700381$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function addKey(key) {
        $bc26ee8cec700381$var$addRange(this, key, key);
        return this;
    },
    addKeys: function addKeys(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $bc26ee8cec700381$var$addRange(_this, key, key);
        });
        return this;
    }
}, $bc26ee8cec700381$var$_a[$bc26ee8cec700381$var$iteratorSymbol] = function() {
    return $bc26ee8cec700381$var$getRangeSetIterator(this);
}, $bc26ee8cec700381$var$_a));
function $bc26ee8cec700381$var$addRange(target, from, to) {
    var diff = $bc26ee8cec700381$var$cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($bc26ee8cec700381$var$isEmptyRange(target)) return $bc26ee8cec700381$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($bc26ee8cec700381$var$cmp(to, target.from) < 0) {
        left ? $bc26ee8cec700381$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $bc26ee8cec700381$var$rebalance(target);
    }
    if ($bc26ee8cec700381$var$cmp(from, target.to) > 0) {
        right ? $bc26ee8cec700381$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $bc26ee8cec700381$var$rebalance(target);
    }
    if ($bc26ee8cec700381$var$cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($bc26ee8cec700381$var$cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $bc26ee8cec700381$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $bc26ee8cec700381$export$4876cc3130d3f820(target, right);
}
function $bc26ee8cec700381$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $bc26ee8cec700381$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$bc26ee8cec700381$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $bc26ee8cec700381$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $bc26ee8cec700381$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $bc26ee8cec700381$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($bc26ee8cec700381$var$cmp(b.from, a.to) <= 0 && $bc26ee8cec700381$var$cmp(b.to, a.from) >= 0) return true;
        $bc26ee8cec700381$var$cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $bc26ee8cec700381$var$getRangeSetIterator(node) {
    var state = $bc26ee8cec700381$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function next(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $bc26ee8cec700381$var$cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $bc26ee8cec700381$var$cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $bc26ee8cec700381$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $bc26ee8cec700381$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $bc26ee8cec700381$var$computeDepth(rootClone);
    }
    target.d = $bc26ee8cec700381$var$computeDepth(target);
}
function $bc26ee8cec700381$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var $bc26ee8cec700381$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    create: function create(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $bc26ee8cec700381$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, core), {
            table: function table(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var tableClone = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, table), {
                    mutate: function mutate(req) {
                        var trans = req.trans;
                        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
                        var getRangeSet = function getRangeSet(indexName) {
                            var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                            return mutatedParts[part] || (mutatedParts[part] = new $bc26ee8cec700381$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _a = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            [],
                            req.values
                        ] : [], keys = _a[0], newObjs = _a[1];
                        var oldCache = req.trans["_cache"];
                        return table.mutate(req).then(function(res) {
                            if ($bc26ee8cec700381$var$isArray(keys)) {
                                if (type !== "delete") keys = res.results;
                                pkRangeSet.addKeys(keys);
                                var oldObjs = $bc26ee8cec700381$var$getFromTransactionCache(keys, oldCache);
                                if (!oldObjs && type !== "add") delsRangeSet.addKeys(keys);
                                if (oldObjs || newObjs) $bc26ee8cec700381$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                            } else if (keys) {
                                var range = {
                                    from: keys.lower,
                                    to: keys.upper
                                };
                                delsRangeSet.add(range);
                                pkRangeSet.add(range);
                            } else {
                                pkRangeSet.add(FULL_RANGE);
                                delsRangeSet.add(FULL_RANGE);
                                schema.indexes.forEach(function(idx) {
                                    return getRangeSet(idx.name).add(FULL_RANGE);
                                });
                            }
                            return res;
                        });
                    }
                });
                var getRange = function getRange(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $bc26ee8cec700381$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function get(req) {
                        return [
                            primaryKey,
                            new $bc26ee8cec700381$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function getMany(req) {
                        return [
                            primaryKey,
                            new $bc26ee8cec700381$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $bc26ee8cec700381$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $bc26ee8cec700381$var$PSD.subscr;
                        if (subscr) {
                            var getRangeSet = function getRangeSet(indexName) {
                                var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                return subscr[part] || (subscr[part] = new $bc26ee8cec700381$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function get() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function get() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function get() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $bc26ee8cec700381$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function addKeyOrKeys(key) {
            return ix.multiEntry && $bc26ee8cec700381$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($bc26ee8cec700381$var$cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
var $bc26ee8cec700381$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $bc26ee8cec700381$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $bc26ee8cec700381$var$nop,
            dbReadyPromise: null,
            cancelOpen: $bc26ee8cec700381$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3
        };
        state.dbReadyPromise = new $bc26ee8cec700381$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $bc26ee8cec700381$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $bc26ee8cec700381$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $bc26ee8cec700381$var$promisableChain,
                $bc26ee8cec700381$var$nop
            ]
        });
        this.on.ready.subscribe = $bc26ee8cec700381$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $bc26ee8cec700381$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $bc26ee8cec700381$var$createCollectionConstructor(this);
        this.Table = $bc26ee8cec700381$var$createTableConstructor(this);
        this.Transaction = $bc26ee8cec700381$var$createTransactionConstructor(this);
        this.Version = $bc26ee8cec700381$var$createVersionConstructor(this);
        this.WhereClause = $bc26ee8cec700381$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
            else console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
            _this.close();
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('" + _this.name + "') was blocked");
            else console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
        });
        this._maxKey = $bc26ee8cec700381$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $bc26ee8cec700381$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($bc26ee8cec700381$var$virtualIndexMiddleware);
        this.use($bc26ee8cec700381$var$hooksMiddleware);
        this.use($bc26ee8cec700381$var$observabilityMiddleware);
        this.use($bc26ee8cec700381$var$cacheExistingValuesMiddleware);
        this.vip = Object.create(this, {
            _vip: {
                value: true
            }
        });
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $bc26ee8cec700381$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $bc26ee8cec700381$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($bc26ee8cec700381$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $bc26ee8cec700381$var$PSD.letThrough || this._vip) ? fn() : new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $bc26ee8cec700381$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._options.autoOpen) {
                    reject(new $bc26ee8cec700381$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($bc26ee8cec700381$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        return $bc26ee8cec700381$var$dexieOpen(this);
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = $bc26ee8cec700381$var$connections.indexOf(this);
        if (idx >= 0) $bc26ee8cec700381$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this._novip.idbdb = null;
        }
        state.dbReadyPromise = new $bc26ee8cec700381$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $bc26ee8cec700381$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
    };
    Dexie.prototype.close = function() {
        this._close();
        var state = this._state;
        this._options.autoOpen = false;
        state.dbOpenError = new $bc26ee8cec700381$var$exceptions.DatabaseClosed();
        if (state.isBeingOpened) state.cancelOpen(state.dbOpenError);
    };
    Dexie.prototype.delete = function() {
        var _this = this;
        var hasArguments = arguments.length > 0;
        var state = this._state;
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            var doDelete = function doDelete() {
                _this.close();
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $bc26ee8cec700381$var$wrap(function() {
                    $bc26ee8cec700381$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasArguments) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Arguments not allowed in db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === "DatabaseClosed";
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function get() {
            var _this = this;
            return $bc26ee8cec700381$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $bc26ee8cec700381$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $bc26ee8cec700381$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf("?") !== -1;
        mode = mode.replace("!", "").replace("?", "");
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== "string") throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $bc26ee8cec700381$var$READONLY) idbMode = $bc26ee8cec700381$var$READONLY;
            else if (mode == "rw" || mode == $bc26ee8cec700381$var$READWRITE) idbMode = $bc26ee8cec700381$var$READWRITE;
            else throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $bc26ee8cec700381$var$READONLY && idbMode === $bc26ee8cec700381$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $bc26ee8cec700381$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $bc26ee8cec700381$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $bc26ee8cec700381$var$rejection(e);
        }
        var enterTransaction = $bc26ee8cec700381$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $bc26ee8cec700381$var$PSD.trans ? $bc26ee8cec700381$var$usePSD($bc26ee8cec700381$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$bc26ee8cec700381$var$hasOwn(this._allTables, tableName)) throw new $bc26ee8cec700381$var$exceptions.InvalidTable("Table " + tableName + " does not exist");
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $bc26ee8cec700381$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $bc26ee8cec700381$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$bc26ee8cec700381$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
function $bc26ee8cec700381$var$extendObservabilitySet(target, newSet) {
    $bc26ee8cec700381$var$keys(newSet).forEach(function(part) {
        var rangeSet = target[part] || (target[part] = new $bc26ee8cec700381$export$34cb5241245008dd());
        $bc26ee8cec700381$export$4876cc3130d3f820(rangeSet, newSet[part]);
    });
    return target;
}
function $bc26ee8cec700381$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue = undefined;
    var observable = new $bc26ee8cec700381$var$Observable(function(observer) {
        var scopeFuncIsAsync = $bc26ee8cec700381$var$isAsyncFunction(querier);
        function execute(subscr) {
            if (scopeFuncIsAsync) $bc26ee8cec700381$var$incrementExpectedAwaits();
            var exec = function exec() {
                return $bc26ee8cec700381$var$newScope(querier, {
                    subscr: subscr,
                    trans: null
                });
            };
            var rv = $bc26ee8cec700381$var$PSD.trans ? $bc26ee8cec700381$var$usePSD($bc26ee8cec700381$var$PSD.transless, exec) : exec();
            if (scopeFuncIsAsync) rv.then($bc26ee8cec700381$var$decrementExpectedAwaits, $bc26ee8cec700381$var$decrementExpectedAwaits);
            return rv;
        }
        var closed = false;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function unsubscribe() {
                closed = true;
                $bc26ee8cec700381$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var querying = false, startedListening = false;
        function shouldNotify() {
            return $bc26ee8cec700381$var$keys(currentObs).some(function(key) {
                return accumMuts[key] && $bc26ee8cec700381$export$8f43b23b5d8de905(accumMuts[key], currentObs[key]);
            });
        }
        var mutationListener = function mutationListener(parts) {
            $bc26ee8cec700381$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var doQuery = function doQuery1() {
            if (querying || closed) return;
            accumMuts = {};
            var subscr = {};
            var ret = execute(subscr);
            if (!startedListening) {
                $bc26ee8cec700381$var$globalEvents($bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                startedListening = true;
            }
            querying = true;
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                querying = false;
                if (closed) return;
                if (shouldNotify()) doQuery();
                else {
                    accumMuts = {};
                    currentObs = subscr;
                    observer.next && observer.next(result);
                }
            }, function(err) {
                querying = false;
                hasValue = false;
                observer.error && observer.error(err);
                subscription.unsubscribe();
            });
        };
        doQuery();
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $bc26ee8cec700381$var$domDeps;
try {
    $bc26ee8cec700381$var$domDeps = {
        indexedDB: $bc26ee8cec700381$var$_global.indexedDB || $bc26ee8cec700381$var$_global.mozIndexedDB || $bc26ee8cec700381$var$_global.webkitIndexedDB || $bc26ee8cec700381$var$_global.msIndexedDB,
        IDBKeyRange: $bc26ee8cec700381$var$_global.IDBKeyRange || $bc26ee8cec700381$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $bc26ee8cec700381$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
var $bc26ee8cec700381$var$Dexie = $bc26ee8cec700381$export$4ece27d405df7279;
$bc26ee8cec700381$var$props($bc26ee8cec700381$var$Dexie, $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, $bc26ee8cec700381$var$fullNameExceptions), {
    delete: function _delete(databaseName) {
        var db = new $bc26ee8cec700381$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function exists(name) {
        return new $bc26ee8cec700381$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch("NoSuchDatabaseError", function() {
            return false;
        });
    },
    getDatabaseNames: function getDatabaseNames1(cb) {
        try {
            return $bc26ee8cec700381$var$getDatabaseNames($bc26ee8cec700381$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.MissingAPI());
        }
    },
    defineClass: function defineClass() {
        function Class(content) {
            $bc26ee8cec700381$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function ignoreTransaction(scopeFunc) {
        return $bc26ee8cec700381$var$PSD.trans ? $bc26ee8cec700381$var$usePSD($bc26ee8cec700381$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $bc26ee8cec700381$var$vip,
    async: function async(generatorFn) {
        return function() {
            try {
                var rv = $bc26ee8cec700381$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== "function") return $bc26ee8cec700381$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $bc26ee8cec700381$var$rejection(e);
            }
        };
    },
    spawn: function spawn(generatorFn, args, thiz) {
        try {
            var rv = $bc26ee8cec700381$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== "function") return $bc26ee8cec700381$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $bc26ee8cec700381$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function get() {
            return $bc26ee8cec700381$var$PSD.trans || null;
        }
    },
    waitFor: function waitFor(promiseOrFunction, optionalTimeout) {
        var promise = $bc26ee8cec700381$var$DexiePromise.resolve(typeof promiseOrFunction === "function" ? $bc26ee8cec700381$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $bc26ee8cec700381$var$PSD.trans ? $bc26ee8cec700381$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $bc26ee8cec700381$var$DexiePromise,
    debug: {
        get: function get() {
            return $bc26ee8cec700381$var$debug;
        },
        set: function set(value) {
            $bc26ee8cec700381$var$setDebug(value, value === "dexie" ? function() {
                return true;
            } : $bc26ee8cec700381$var$dexieStackFrameFilter);
        }
    },
    derive: $bc26ee8cec700381$var$derive,
    extend: $bc26ee8cec700381$var$extend,
    props: $bc26ee8cec700381$var$props,
    override: $bc26ee8cec700381$var$override,
    Events: $bc26ee8cec700381$var$Events,
    on: $bc26ee8cec700381$var$globalEvents,
    liveQuery: $bc26ee8cec700381$export$6a9705d8f6f38796,
    extendObservabilitySet: $bc26ee8cec700381$var$extendObservabilitySet,
    getByKeyPath: $bc26ee8cec700381$var$getByKeyPath,
    setByKeyPath: $bc26ee8cec700381$var$setByKeyPath,
    delByKeyPath: $bc26ee8cec700381$var$delByKeyPath,
    shallowClone: $bc26ee8cec700381$var$shallowClone,
    deepClone: $bc26ee8cec700381$var$deepClone,
    getObjectDiff: $bc26ee8cec700381$var$getObjectDiff,
    cmp: $bc26ee8cec700381$var$cmp,
    asap: $bc26ee8cec700381$var$asap$1,
    minKey: $bc26ee8cec700381$var$minKey,
    addons: [],
    connections: $bc26ee8cec700381$var$connections,
    errnames: $bc26ee8cec700381$var$errnames,
    dependencies: $bc26ee8cec700381$var$domDeps,
    semVer: $bc26ee8cec700381$var$DEXIE_VERSION,
    version: $bc26ee8cec700381$var$DEXIE_VERSION.split(".").map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$bc26ee8cec700381$var$Dexie.maxKey = $bc26ee8cec700381$var$getMaxKey($bc26ee8cec700381$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
    $bc26ee8cec700381$var$globalEvents($bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$bc26ee8cec700381$var$propagatingLocally) {
            var event_1;
            if ($bc26ee8cec700381$var$isIEOrEdge) {
                event_1 = document.createEvent("CustomEvent");
                event_1.initCustomEvent($bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
            } else event_1 = new CustomEvent($bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $bc26ee8cec700381$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $bc26ee8cec700381$var$propagatingLocally = false;
        }
    });
    addEventListener($bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$bc26ee8cec700381$var$propagatingLocally) $bc26ee8cec700381$var$propagateLocally(detail);
    });
}
function $bc26ee8cec700381$var$propagateLocally(updateParts) {
    var wasMe = $bc26ee8cec700381$var$propagatingLocally;
    try {
        $bc26ee8cec700381$var$propagatingLocally = true;
        $bc26ee8cec700381$var$globalEvents.storagemutated.fire(updateParts);
    } finally{
        $bc26ee8cec700381$var$propagatingLocally = wasMe;
    }
}
var $bc26ee8cec700381$var$propagatingLocally = false;
if (typeof BroadcastChannel !== "undefined") {
    var $bc26ee8cec700381$var$bc_1 = new BroadcastChannel($bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME);
    if (typeof $bc26ee8cec700381$var$bc_1.unref === "function") $bc26ee8cec700381$var$bc_1.unref();
    $bc26ee8cec700381$var$globalEvents($bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$bc26ee8cec700381$var$propagatingLocally) $bc26ee8cec700381$var$bc_1.postMessage(changedParts);
    });
    $bc26ee8cec700381$var$bc_1.onmessage = function(ev) {
        if (ev.data) $bc26ee8cec700381$var$propagateLocally(ev.data);
    };
} else if (typeof self !== "undefined" && typeof navigator !== "undefined") {
    $bc26ee8cec700381$var$globalEvents($bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        try {
            if (!$bc26ee8cec700381$var$propagatingLocally) {
                if (typeof localStorage !== "undefined") localStorage.setItem($bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
                    trig: Math.random(),
                    changedParts: changedParts
                }));
                if (typeof self["clients"] === "object") $bc26ee8cec700381$var$__spreadArray([], self["clients"].matchAll({
                    includeUncontrolled: true
                }), true).forEach(function(client) {
                    return client.postMessage({
                        type: $bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME,
                        changedParts: changedParts
                    });
                });
            }
        } catch (_a) {}
    });
    if (typeof addEventListener !== "undefined") addEventListener("storage", function(ev) {
        if (ev.key === $bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME) {
            var data = JSON.parse(ev.newValue);
            if (data) $bc26ee8cec700381$var$propagateLocally(data.changedParts);
        }
    });
    var $bc26ee8cec700381$var$swContainer = self.document && navigator.serviceWorker;
    if ($bc26ee8cec700381$var$swContainer) $bc26ee8cec700381$var$swContainer.addEventListener("message", $bc26ee8cec700381$var$propagateMessageLocally);
}
function $bc26ee8cec700381$var$propagateMessageLocally(_a) {
    var data = _a.data;
    if (data && data.type === $bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME) $bc26ee8cec700381$var$propagateLocally(data.changedParts);
}
$bc26ee8cec700381$var$DexiePromise.rejectionMapper = $bc26ee8cec700381$var$mapError;
$bc26ee8cec700381$var$setDebug($bc26ee8cec700381$var$debug, $bc26ee8cec700381$var$dexieStackFrameFilter);



(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline = {
    /** @var Date the datetime of the newest garbage collected entry, i.e. deleted because not of interest. */ newestGCedEntry: null,
    offlineDays: 10,
    lastItemId: null,
    newerEntriesMissing: false,
    shouldLoadEntriesOnline: false,
    olderEntriesOnline: false,
    _tr: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _selfoss_db_storage;
        return (_selfoss_db_storage = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage).transaction.apply(_selfoss_db_storage, (0, $4c858c0d999a5b9b$export$1b5e630bc3aea29f)(args)).catch(function(error) {
            var _selfoss_entries;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app._("error_offline_storage", [
                error.message
            ]));
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.broken = true;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.update(false);
            (_selfoss_entries = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entries) === null || _selfoss_entries === void 0 ? void 0 : _selfoss_entries.reload();
            // If this is a QuotaExceededError, garbage collect more
            // entries and hope it helps.
            if (error.name === (0, $bc26ee8cec700381$export$4ece27d405df7279).errnames.QuotaExceeded) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.GCEntries(true);
            return Promise.reject(error);
        });
    },
    init: function() {
        if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage) return;
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.broken = false;
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage = new (0, $bc26ee8cec700381$export$4ece27d405df7279)("selfoss");
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.version(1).stores({
            entries: "&id,*datetime,[datetime+id]",
            statusq: "++id,*entryId",
            stamps: "&name,datetime",
            stats: "&name",
            tags: "&name",
            sources: "&id"
        });
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.on("populate", function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.add({
                name: "unread",
                value: 0
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.add({
                name: "starred",
                value: 0
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.add({
                name: "total",
                value: 0
            });
        });
        // retrieve last update stats in offline db
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("r", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries, (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps, function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._memLastItemId();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.get("lastItemsUpdate", function(stamp) {
                if (stamp) {
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = stamp.datetime;
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.firstSync = false;
                } else (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline = true;
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.get("newestGCedEntry", function(stamp) {
                if (stamp) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = stamp.datetime;
                var limit = new Date(Date.now() - 259200000);
                if (!stamp || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry < limit) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = new Date(Date.now() - 86400000);
            });
        }).then(function() {
            var offlineDays = window.localStorage.getItem("offlineDays");
            if (offlineDays !== null) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays = parseInt(offlineDays);
            // The newest garbage collected entry is either what's already
            // in the offline db or if more recent the entry older than
            // offlineDays ago.
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = new Date(Math.max((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry, Date.now() - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays * 86400000));
            window.addEventListener("online", function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.tryOnline();
            });
            window.addEventListener("offline", function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.setOffline().catch(function(error) {
                    if (error instanceof (0, $0d06257c362dc1a1$export$1871035840b7f83a)) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app._("error_offline_storage_not_available", [
                        '<a href="https://caniuse.com/#feat=indexeddb">',
                        "</a>"
                    ]));
                    else throw error;
                });
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setOfflineState(false);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.tryOnline().then(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).reloadTags();
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.reloadOnlineStats();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.refreshStats();
        }).catch(function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.broken = true;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.update(false);
        });
    },
    _memLastItemId: function() {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.orderBy("id").reverse().first(function(entry) {
            if (entry) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId = entry.id;
            else (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId = 0;
        });
    },
    storeEntries: function(entries) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries, (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps, function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.GCEntries();
            // store entries offline
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.bulkPut(entries).then(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._memLastItemId();
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.refreshStats();
            });
        });
    },
    GCEntries: function() {
        var more = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (more) {
            // We need to garbage collect more, as the browser storage limit
            // seems to be exceeded: decrease the amount of days entries are
            // kept offline.
            var keptDays = Math.floor((new Date() - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry) / 86400000);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays = Math.max(Math.min(keptDays - 1, (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays - 1), 0);
            window.localStorage.setItem("offlineDays", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays);
        }
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.transaction("rw", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries, (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps, function() {
            // cleanup and remember when
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.get("lastCleanup", function(stamp) {
                // Cleanup once a day or once after db reset
                if (!stamp || more || stamp && Date.now() - stamp.datetime > 86400000) {
                    // Cleanup items older than offlineDays days, not of
                    // interest.
                    var limit = new Date(Date.now() - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays * 86400000);
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.where("datetime").below(limit).filter(function(entry) {
                        return !entry.unread && !entry.starred;
                    }).each(function(entry) {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.delete(entry.id);
                        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry < entry.datetime) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = entry.datetime;
                    }).then(function() {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.bulkPut([
                            {
                                name: "lastCleanup",
                                datetime: new Date()
                            },
                            {
                                name: "newestGCedEntry",
                                datetime: (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry
                            }
                        ]);
                    });
                }
            });
        });
    },
    storeStats: function(stats) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats, function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(stats)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.put({
                        name: name,
                        value: value
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    },
    storeLastUpdate: function(lastUpdate) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps, function() {
            if (lastUpdate) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.put({
                name: "lastItemsUpdate",
                datetime: lastUpdate
            });
        });
    },
    getEntries: function(fetchParams) {
        var hasMore = false;
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("r", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries, function() {
            var howMany = 0;
            var ascOrder = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.unreadOrder === "asc" && fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD;
            var entries = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.orderBy("[datetime+id]");
            if (!ascOrder) entries = entries.reverse();
            var fromDatetime = fetchParams.fromDatetime;
            var fromId = fetchParams.fromId;
            var seek = fromDatetime && fromId;
            var alwaysInDb = fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED || fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD;
            return entries.filter(function(entry) {
                var keepEntry = false;
                if (fetchParams.extraIds.includes(entry.id)) return true;
                if (fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED) keepEntry = entry.starred;
                else if (fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD) keepEntry = entry.unread;
                else keepEntry = true;
                // seek pagination
                if (seek) {
                    if (ascOrder) keepEntry && (keepEntry = entry.datetime > fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id > fromId);
                    else keepEntry && (keepEntry = entry.datetime < fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id < fromId);
                }
                return keepEntry;
            }).until(function(entry) {
                howMany += 1;
                if (!ascOrder && !alwaysInDb && entry.datetime < (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry) {
                    // the offline db is missing older entries, the next
                    // seek will have to find them online.
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.olderEntriesOnline = true;
                    hasMore = true;
                    return true; // stop iteration
                }
                // stop iteration if enough entries have been shown
                // go one further to assess if has more
                if (howMany >= (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.itemsPerPage + 1) {
                    hasMore = true;
                    return true;
                }
                return false;
            });
        }).then(function(entriesCollection) {
            return entriesCollection.toArray();
        }).then(function(entries) {
            return {
                entries: entries,
                hasMore: hasMore
            };
        });
    },
    reloadOnlineStats: function() {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("r", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats, function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.toArray(function(stats) {
                var newStats = {};
                stats.forEach(function(stat) {
                    newStats[stat.name] = stat.value;
                });
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).refreshStats(newStats.total, newStats.unread, newStats.starred);
            });
        });
    },
    refreshStats: function() {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("r", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries, function() {
            var offlineCounts = {
                newest: 0,
                unread: 0,
                starred: 0
            };
            // IDBKeyRange does not support boolean indexes, so we need to
            // iterate over all the entries.
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.each(function(entry) {
                offlineCounts.newest = offlineCounts.newest + 1;
                if (entry.unread) offlineCounts.unread = offlineCounts.unread + 1;
                if (entry.starred) offlineCounts.starred = offlineCounts.starred + 1;
            }).then(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.refreshOfflineCounts(offlineCounts);
            });
        });
    },
    enqueueStatuses: function(statuses) {
        if (statuses) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync = true;
        var d = new Date();
        var newQueuedStatuses = statuses.map(function(newStatus) {
            return {
                entryId: parseInt(newStatus.entryId),
                name: newStatus.name,
                value: newStatus.value,
                datetime: d
            };
        });
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq, function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq.bulkAdd(newQueuedStatuses);
        });
    },
    enqueueStatus: function(entryId, statusName, statusValue) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.enqueueStatuses([
            {
                entryId: entryId,
                name: statusName,
                value: statusValue
            }
        ]);
    },
    sendNewStatuses: function() {
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq.toArray().then(function(statuses) {
            return statuses.map(function(s) {
                var statusUpdate = {
                    id: s.entryId,
                    datetime: s.datetime
                };
                statusUpdate[s.name] = s.value;
                return statusUpdate;
            });
        }).then(function(statuses) {
            var s = statuses.length > 0 ? statuses : undefined;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.sync(s, true).then(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync = false;
            });
        });
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncBegin();
    },
    storeEntryStatuses: function(itemStatuses) {
        var dequeue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, updateStats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr("rw", (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries, (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats, (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq, function() {
            var statsDiff = {};
            // update entries statuses
            itemStatuses.forEach(function(itemStatus) {
                var newStatus = {};
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.entryStatusNames.forEach(function(statusName) {
                    if (statusName in itemStatus) {
                        statsDiff[statusName] = 0;
                        newStatus[statusName] = itemStatus[statusName];
                        if (updateStats) {
                            if (itemStatus[statusName]) statsDiff[statusName]++;
                            else statsDiff[statusName]--;
                        }
                    }
                });
                var id = parseInt(itemStatus.id);
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.get(id).then(function() {
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.update(id, newStatus);
                }, function() {
                    // the key was not found, the status of an entry
                    // missing in db was updated, request sync.
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync = true;
                });
                if (dequeue) // status update from server, remove from status queue
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq.where("entryId").equals(id).delete();
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (updateStats) try {
                var _loop = function() {
                    var _step_value = (0, $1788e2ed61915b1e$export$fdf2a89c76341bbf)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.get(name, function(stat) {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.put({
                            name: name,
                            value: stat.value + value
                        });
                    });
                };
                for(var _iterator = Object.entries(statsDiff)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }).then((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.refreshStats);
    },
    entriesMark: function(itemIds, unread) {
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.statsDirty = true;
        var newStatuses = itemIds.map(function(itemId) {
            return {
                id: itemId,
                unread: unread
            };
        });
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses(newStatuses);
    },
    entryMark: function(itemId, unread) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.entriesMark([
            itemId
        ], unread);
    },
    entryStar: function(itemId, starred) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses([
            {
                id: itemId,
                starred: starred
            }
        ]);
    }
};


/**
 * db functions: client data repository (and offline storage)
 *
 * db is a dispatcher class and holds the logic for deciding whether selfoss
 * is running online with access to the server or offline.
 *
 * dbOnline contains AJAX calls that provide access to the server db.
 *
 * dbOffline is the entry point for the offline database held in the client.
 */ 


(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db = {
    /** When an error occurs we disable the offline mode and mark the database as broken so it can be retried. */ broken: false,
    storage: null,
    online: true,
    enableOffline: new (0, $e721f0b5888adce1$export$8fa6ce44b7b131e9)(window.localStorage.getItem("enableOffline") === "true"),
    entryStatusNames: [
        "unread",
        "starred"
    ],
    userWaiting: true,
    /**
     * last db timestamp known client side
     */ lastUpdate: null,
    setOnline: function() {
        if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.online) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.online = true;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.sync();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).reloadTags();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setOfflineState(false);
        }
    },
    tryOnline: function() {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.sync(true);
    },
    setOffline: function() {
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage && !(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.broken) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncDone(false);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.online = false;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setOfflineState(true);
            return Promise.resolve();
        } else {
            var err = new (0, $0d06257c362dc1a1$export$1871035840b7f83a)();
            return Promise.reject(err);
        }
    },
    clear: function() {
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage) {
            window.localStorage.removeItem("offlineDays");
            var clearing = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.delete();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage = null;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = null;
            return clearing;
        } else return Promise.resolve();
    },
    isValidTag: function(name) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.tags.length === 0 || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.tags.find(function(tag) {
            return tag.tag === name;
        }) !== undefined;
    },
    isValidSource: function(id) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.sources.length === 0 || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.sources.find(function(source) {
            return source.id === id;
        }) !== undefined;
    },
    lastSync: null,
    sync: function() {
        var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var lastUpdateIsOld = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate === null || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastSync === null || Date.now() - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastSync > 300000;
        var shouldSync = force || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync || lastUpdateIsOld;
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).isAllowedToRead() && (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).isOnline() && shouldSync) {
            if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value) return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
            else return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.sync();
        } else return Promise.resolve(); // ensure any chained function runs
    }
};


(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).init();
// make selfoss available in console for debugging
window.selfoss = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039);

})();
//# sourceMappingURL=index.472d7bbe.js.map
